!(function (e) {
  const t = (e.en = e.en || {});
  t.dictionary = Object.assign(t.dictionary || {}, {
    '%0 of %1': '%0 of %1',
    'Align cell text to the bottom': 'Align cell text to the bottom',
    'Align cell text to the center': 'Align cell text to the center',
    'Align cell text to the left': 'Align cell text to the left',
    'Align cell text to the middle': 'Align cell text to the middle',
    'Align cell text to the right': 'Align cell text to the right',
    'Align cell text to the top': 'Align cell text to the top',
    'Align center': 'Align center',
    'Align left': 'Align left',
    'Align right': 'Align right',
    'Align table to the left': 'Align table to the left',
    'Align table to the right': 'Align table to the right',
    Alignment: 'Alignment',
    Aquamarine: 'Aquamarine',
    Background: 'Background',
    Black: 'Black',
    'Block quote': 'Block quote',
    Blue: 'Blue',
    Bold: 'Bold',
    Border: 'Border',
    'Break text': 'Break text',
    'Bulleted List': 'Bulleted List',
    Cancel: 'Cancel',
    'Caption for image: %0': 'Caption for image: %0',
    'Caption for the image': 'Caption for the image',
    'Cell properties': 'Cell properties',
    'Center table': 'Center table',
    'Centered image': 'Centered image',
    'Change image text alternative': 'Change image text alternative',
    'Choose heading': 'Choose heading',
    Color: 'Color',
    'Color picker': 'Color picker',
    Column: 'Column',
    Dashed: 'Dashed',
    'Decrease indent': 'Decrease indent',
    'Delete column': 'Delete column',
    'Delete row': 'Delete row',
    'Dim grey': 'Dim grey',
    Dimensions: 'Dimensions',
    Dotted: 'Dotted',
    Double: 'Double',
    Downloadable: 'Downloadable',
    'Dropdown toolbar': 'Dropdown toolbar',
    'Edit block': 'Edit block',
    'Edit link': 'Edit link',
    'Editor block content toolbar': 'Editor block content toolbar',
    'Editor contextual toolbar': 'Editor contextual toolbar',
    'Editor editing area: %0': 'Editor editing area: %0',
    'Editor toolbar': 'Editor toolbar',
    'Enter image caption': 'Enter image caption',
    'Full size image': 'Full size image',
    Green: 'Green',
    Grey: 'Grey',
    Groove: 'Groove',
    'Header column': 'Header column',
    'Header row': 'Header row',
    Heading: 'Heading',
    'Heading 1': 'Heading 1',
    'Heading 2': 'Heading 2',
    'Heading 3': 'Heading 3',
    'Heading 4': 'Heading 4',
    'Heading 5': 'Heading 5',
    'Heading 6': 'Heading 6',
    Height: 'Height',
    'Horizontal text alignment toolbar': 'Horizontal text alignment toolbar',
    'Image toolbar': 'Image toolbar',
    'image widget': 'image widget',
    'In line': 'In line',
    'Increase indent': 'Increase indent',
    'Insert column left': 'Insert column left',
    'Insert column right': 'Insert column right',
    'Insert image': 'Insert image',
    'Insert media': 'Insert media',
    'Insert paragraph after block': 'Insert paragraph after block',
    'Insert paragraph before block': 'Insert paragraph before block',
    'Insert row above': 'Insert row above',
    'Insert row below': 'Insert row below',
    'Insert table': 'Insert table',
    Inset: 'Inset',
    Italic: 'Italic',
    Justify: 'Justify',
    'Justify cell text': 'Justify cell text',
    'Left aligned image': 'Left aligned image',
    'Light blue': 'Light blue',
    'Light green': 'Light green',
    'Light grey': 'Light grey',
    Link: 'Link',
    'Link URL': 'Link URL',
    'Media URL': 'Media URL',
    'media widget': 'media widget',
    'Merge cell down': 'Merge cell down',
    'Merge cell left': 'Merge cell left',
    'Merge cell right': 'Merge cell right',
    'Merge cell up': 'Merge cell up',
    'Merge cells': 'Merge cells',
    Next: 'Next',
    None: 'None',
    'Numbered List': 'Numbered List',
    'Open in a new tab': 'Open in a new tab',
    'Open link in new tab': 'Open link in new tab',
    'Open media in new tab': 'Open media in new tab',
    Orange: 'Orange',
    Outset: 'Outset',
    Padding: 'Padding',
    Paragraph: 'Paragraph',
    'Paste the media URL in the input.': 'Paste the media URL in the input.',
    Previous: 'Previous',
    Purple: 'Purple',
    Red: 'Red',
    Redo: 'Redo',
    'Remove color': 'Remove color',
    'Restore default': 'Restore default',
    'Rich Text Editor': 'Rich Text Editor',
    Ridge: 'Ridge',
    'Right aligned image': 'Right aligned image',
    Row: 'Row',
    Save: 'Save',
    'Select all': 'Select all',
    'Select column': 'Select column',
    'Select row': 'Select row',
    'Show more items': 'Show more items',
    'Side image': 'Side image',
    Solid: 'Solid',
    'Split cell horizontally': 'Split cell horizontally',
    'Split cell vertically': 'Split cell vertically',
    Style: 'Style',
    'Table alignment toolbar': 'Table alignment toolbar',
    'Table cell text alignment': 'Table cell text alignment',
    'Table properties': 'Table properties',
    'Table toolbar': 'Table toolbar',
    'Text alignment': 'Text alignment',
    'Text alignment toolbar': 'Text alignment toolbar',
    'Text alternative': 'Text alternative',
    'The color is invalid. Try "#FF0000" or "rgb(255,0,0)" or "red".': 'The color is invalid. Try "#FF0000" or "rgb(255,0,0)" or "red".',
    'The URL must not be empty.': 'The URL must not be empty.',
    'The value is invalid. Try "10px" or "2em" or simply "2".': 'The value is invalid. Try "10px" or "2em" or simply "2".',
    'This link has no URL': 'This link has no URL',
    'This media URL is not supported.': 'This media URL is not supported.',
    'Tip: Paste the URL into the content to embed faster.': 'Tip: Paste the URL into the content to embed faster.',
    'Toggle caption off': 'Toggle caption off',
    'Toggle caption on': 'Toggle caption on',
    Turquoise: 'Turquoise',
    Underline: 'Underline',
    Undo: 'Undo',
    Unlink: 'Unlink',
    'Upload failed': 'Upload failed',
    'Upload in progress': 'Upload in progress',
    'Vertical text alignment toolbar': 'Vertical text alignment toolbar',
    White: 'White',
    'Widget toolbar': 'Widget toolbar',
    Width: 'Width',
    'Wrap text': 'Wrap text',
    Yellow: 'Yellow',
  });
})(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})),
  /*!
   * @license Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md.
   */
  (function (e, t) {
    'object' == typeof exports && 'object' == typeof module
      ? (module.exports = t())
      : 'function' == typeof define && define.amd
      ? define([], t)
      : 'object' == typeof exports
      ? (exports.ClassicEditor = t())
      : (e.ClassicEditor = t());
  })(self, () =>
    (() => {
      'use strict';
      var e = {
          636: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck-content blockquote{border-left:5px solid #ccc;font-style:italic;margin-left:0;margin-right:0;overflow:hidden;padding-left:1.5em;padding-right:1.5em}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}',
              '',
              {
                version: 3,
                sources: ['webpack://./node_modules/@ckeditor/ckeditor5-block-quote/theme/blockquote.css'],
                names: [],
                mappings:
                  'AAKA,uBAWC,0BAAsC,CADtC,iBAAkB,CAFlB,aAAc,CACd,cAAe,CAPf,eAAgB,CAIhB,kBAAmB,CADnB,mBAOD,CAEA,gCACC,aAAc,CACd,2BACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content blockquote {\n\t/* See #12 */\n\toverflow: hidden;\n\n\t/* https://github.com/ckeditor/ckeditor5-block-quote/issues/15 */\n\tpadding-right: 1.5em;\n\tpadding-left: 1.5em;\n\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tfont-style: italic;\n\tborder-left: solid 5px hsl(0, 0%, 80%);\n}\n\n.ck-content[dir="rtl"] blockquote {\n\tborder-left: 0;\n\tborder-right: solid 5px hsl(0, 0%, 80%);\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          390: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position{display:inline;pointer-events:none;position:relative}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{position:absolute;width:0}.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__selection-handle,.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__type-around{display:none}:root{--ck-clipboard-drop-target-dot-width:12px;--ck-clipboard-drop-target-dot-height:8px;--ck-clipboard-drop-target-color:var(--ck-color-focus-border)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{background:var(--ck-clipboard-drop-target-color);border:1px solid var(--ck-clipboard-drop-target-color);bottom:calc(var(--ck-clipboard-drop-target-dot-height)*-.5);margin-left:-1px;top:calc(var(--ck-clipboard-drop-target-dot-height)*-.5)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span:after{border-color:var(--ck-clipboard-drop-target-color) transparent transparent transparent;border-style:solid;border-width:calc(var(--ck-clipboard-drop-target-dot-height)) calc(var(--ck-clipboard-drop-target-dot-width)*.5) 0 calc(var(--ck-clipboard-drop-target-dot-width)*.5);content:"";display:block;height:0;left:50%;position:absolute;top:calc(var(--ck-clipboard-drop-target-dot-height)*-.5);transform:translateX(-50%);width:0}.ck.ck-editor__editable .ck-widget.ck-clipboard-drop-target-range{outline:var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color)!important}.ck.ck-editor__editable .ck-widget:-webkit-drag{zoom:.6;outline:none!important}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-clipboard/theme/clipboard.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-clipboard/clipboard.css',
                ],
                names: [],
                mappings:
                  'AASC,8DACC,cAAe,CAEf,mBAAoB,CADpB,iBAOD,CAJC,mEACC,iBAAkB,CAClB,OACD,CAWA,qJACC,YACD,CCzBF,MACC,yCAA0C,CAC1C,yCAA0C,CAC1C,6DACD,CAOE,mEAIC,gDAAiD,CADjD,sDAAuD,CAFvD,2DAA8D,CAI9D,gBAAiB,CAHjB,wDAqBD,CAfC,yEAWC,sFAAuF,CAEvF,kBAAmB,CADnB,qKAA0K,CAX1K,UAAW,CAIX,aAAc,CAFd,QAAS,CAIT,QAAS,CADT,iBAAkB,CAElB,wDAA2D,CAE3D,0BAA2B,CAR3B,OAYD,CA2DF,kEACC,gGACD,CAKA,gDACC,OAAS,CACT,sBACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\tdisplay: inline;\n\t\tposition: relative;\n\t\tpointer-events: none;\n\n\t\t& span {\n\t\t\tposition: absolute;\n\t\t\twidth: 0;\n\t\t}\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\t& > .ck-widget__selection-handle {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t& > .ck-widget__type-around {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-clipboard-drop-target-dot-width: 12px;\n\t--ck-clipboard-drop-target-dot-height: 8px;\n\t--ck-clipboard-drop-target-color: var(--ck-color-focus-border)\n}\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\t& span {\n\t\t\tbottom: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\ttop: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\t\t\tbackground: var(--ck-clipboard-drop-target-color);\n\t\t\tmargin-left: -1px;\n\n\t\t\t/* The triangle above the marker */\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 50%;\n\t\t\t\ttop: calc(var(--ck-clipboard-drop-target-dot-height) * -.5);\n\n\t\t\t\ttransform: translateX(-50%);\n\t\t\t\tborder-color: var(--ck-clipboard-drop-target-color) transparent transparent transparent;\n\t\t\t\tborder-width: calc(var(--ck-clipboard-drop-target-dot-height)) calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0 calc(.5 * var(--ck-clipboard-drop-target-dot-width));\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t// Horizontal drop target (between blocks).\n\t& .ck.ck-clipboard-drop-target-position {\n\t\tdisplay: block;\n\t\tposition: relative;\n\t\twidth: 100%;\n\t\theight: 0;\n\t\tmargin: 0;\n\t\ttext-align: initial;\n\n\t\t& .ck-clipboard-drop-target__line {\n\t\t\tposition: absolute;\n\t\t\twidth: 100%;\n\t\t\theight: 0;\n\t\t\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\t\t\tmargin-top: -1px;\n\n\t\t\t&::before {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: calc(-1 * var(--ck-clipboard-drop-target-dot-size));\n\t\t\t\ttop: 0;\n\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t\tborder-color: transparent transparent transparent var(--ck-clipboard-drop-target-color);\n\t\t\t\tborder-width: var(--ck-clipboard-drop-target-dot-size) 0 var(--ck-clipboard-drop-target-dot-size) calc(2 * var(--ck-clipboard-drop-target-dot-size));\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tright: calc(-1 * var(--ck-clipboard-drop-target-dot-size));\n\t\t\t\ttop: 0;\n\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t\tborder-color: transparent var(--ck-clipboard-drop-target-color) transparent transparent;\n\t\t\t\tborder-width: var(--ck-clipboard-drop-target-dot-size) calc(2 * var(--ck-clipboard-drop-target-dot-size)) var(--ck-clipboard-drop-target-dot-size) 0;\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\t\t}\n\t}\n\t*/\n\n\t/*\n\t * Styles of the widget that it a drop target.\n\t */\n\t& .ck-widget.ck-clipboard-drop-target-range {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color) !important;\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\tzoom: 0.6;\n\t\toutline: none !important;\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          3638: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-modal)}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-bottom-width:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar{border-bottom-width:1px;border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-editor-classic/theme/classiceditor.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-editor-classic/classiceditor.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css',
                ],
                names: [],
                mappings:
                  'AAKA,cAIC,iBAMD,CAJC,2DAEC,yBACD,CCLC,gDCED,eDKC,CAPA,uICMA,qCAAsC,CDJpC,2BAA4B,CAC5B,4BAIF,CAPA,gDAMC,qBACD,CAEA,iFACC,uBAAwB,CCR1B,eDaC,CANA,yMCHA,qCAAsC,CDOpC,eAEF,CAKF,yCAEC,0CAA2C,CCpB3C,eD8BD,CAZA,yHCdE,qCAAsC,CDmBtC,wBAAyB,CACzB,yBAMF,CAHC,0DACC,wCACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor {\n\t/* All the elements within `.ck-editor` are positioned relatively to it.\n\t If any element needs to be positioned with respect to the <body>, etc.,\n\t it must land outside of the `.ck-editor` in DOM. */\n\tposition: relative;\n\n\t& .ck-editor__top .ck-sticky-panel .ck-toolbar {\n\t\t/* https://github.com/ckeditor/ckeditor5-editor-classic/issues/62 */\n\t\tz-index: var(--ck-z-modal);\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_rounded.css";\n\n.ck.ck-editor__top {\n\t& .ck-sticky-panel {\n\t\t& .ck-toolbar {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\n\t\t\tborder-bottom-width: 0;\n\t\t}\n\n\t\t& .ck-sticky-panel__content_sticky .ck-toolbar {\n\t\t\tborder-bottom-width: 1px;\n\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Note: Use ck-editor__main to make sure these styles don\'t apply to other editor types */\n.ck.ck-editor__main > .ck-editor__editable {\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/113 */\n\tbackground: var(--ck-color-base-background);\n\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&:not(.ck-focused) {\n\t\tborder-color: var(--ck-color-base-border);\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          8894: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck .ck-placeholder,.ck.ck-placeholder{position:relative}.ck .ck-placeholder:before,.ck.ck-placeholder:before{content:attr(data-placeholder);left:0;pointer-events:none;position:absolute;right:0}.ck.ck-read-only .ck-placeholder:before{display:none}.ck.ck-reset_all .ck-placeholder{position:relative}.ck .ck-placeholder:before,.ck.ck-placeholder:before{color:var(--ck-color-engine-placeholder-text);cursor:text}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-engine/theme/placeholder.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-engine/placeholder.css',
                ],
                names: [],
                mappings:
                  'AAMA,uCAEC,iBAWD,CATC,qDAIC,8BAA+B,CAF/B,MAAO,CAKP,mBAAoB,CANpB,iBAAkB,CAElB,OAKD,CAKA,wCACC,YACD,CAQD,iCACC,iBACD,CC5BC,qDAEC,6CAA8C,CAD9C,WAED',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder,\n.ck .ck-placeholder {\n\tposition: relative;\n\n\t&::before {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tcontent: attr(data-placeholder);\n\n\t\t/* See ckeditor/ckeditor5#469. */\n\t\tpointer-events: none;\n\t}\n}\n\n/* See ckeditor/ckeditor5#1987. */\n.ck.ck-read-only .ck-placeholder {\n\t&::before {\n\t\tdisplay: none;\n\t}\n}\n\n/*\n * Rules for the `ck-placeholder` are loaded before the rules for `ck-reset_all` in the base CKEditor 5 DLL build.\n * This fix overwrites the incorrectly set `position: static` from `ck-reset_all`.\n * See https://github.com/ckeditor/ckeditor5/issues/11418.\n */\n.ck.ck-reset_all .ck-placeholder {\n\tposition: relative;\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder, .ck .ck-placeholder {\n\t&::before {\n\t\tcursor: text;\n\t\tcolor: var(--ck-color-engine-placeholder-text);\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          4401: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-editor__editable span[data-ck-unsafe-element]{display:none}',
              '',
              {
                version: 3,
                sources: ['webpack://./node_modules/@ckeditor/ckeditor5-engine/theme/renderer.css'],
                names: [],
                mappings: 'AAMA,qDACC,YACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Elements marked by the Renderer as hidden should be invisible in the editor. */\n.ck.ck-editor__editable span[data-ck-unsafe-element] {\n\tdisplay: none;\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          3230: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-heading/theme/heading.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-heading/heading.css',
                ],
                names: [],
                mappings: 'AAKA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,+BACC,eACD,CCZC,2EACC,SACD,CAEA,uEACC,cACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-heading_heading1 {\n\tfont-size: 20px;\n}\n\n.ck.ck-heading_heading2 {\n\tfont-size: 17px;\n}\n\n.ck.ck-heading_heading3 {\n\tfont-size: 14px;\n}\n\n.ck[class*="ck-heading_heading"] {\n\tfont-weight: bold;\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Resize dropdown's button label. */\n.ck.ck-dropdown.ck-heading-dropdown {\n\t& .ck-dropdown__button .ck-button__label {\n\t\twidth: 8em;\n\t}\n\n\t& .ck-dropdown__panel .ck-list__item {\n\t\tmin-width: 18em;\n\t}\n}\n",
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          9048: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck-content .image{clear:both;display:table;margin:.9em auto;min-width:50px;text-align:center}.ck-content .image img{display:block;margin:0 auto;max-width:100%;min-width:100%}.ck-content .image-inline{align-items:flex-start;display:inline-flex;max-width:100%}.ck-content .image-inline picture{display:flex}.ck-content .image-inline img,.ck-content .image-inline picture{flex-grow:1;flex-shrink:1;max-width:100%}.ck.ck-editor__editable .image>figcaption.ck-placeholder:before{overflow:hidden;padding-left:inherit;padding-right:inherit;text-overflow:ellipsis;white-space:nowrap}.ck.ck-editor__editable .image-inline.ck-widget_selected,.ck.ck-editor__editable .image.ck-widget_selected{z-index:1}.ck.ck-editor__editable .image-inline.ck-widget_selected ::selection{display:none}.ck.ck-editor__editable td .image-inline img,.ck.ck-editor__editable th .image-inline img{max-width:none}',
              '',
              {
                version: 3,
                sources: ['webpack://./node_modules/@ckeditor/ckeditor5-image/theme/image.css'],
                names: [],
                mappings:
                  'AAMC,mBAEC,UAAW,CADX,aAAc,CAOd,gBAAkB,CAGlB,cAAe,CARf,iBAuBD,CAbC,uBAEC,aAAc,CAGd,aAAc,CAGd,cAAe,CAGf,cACD,CAGD,0BAYC,sBAAuB,CANvB,mBAAoB,CAGpB,cAoBD,CAdC,kCACC,YACD,CAGA,gEAGC,WAAY,CACZ,aAAc,CAGd,cACD,CAUD,gEASC,eAAgB,CARhB,oBAAqB,CACrB,qBAAsB,CAQtB,sBAAuB,CAFvB,kBAGD,CAWA,2GACC,SAUD,CAHC,qEACC,YACD,CAOA,0FACC,cACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content {\n\t& .image {\n\t\tdisplay: table;\n\t\tclear: both;\n\t\ttext-align: center;\n\n\t\t/* Make sure there is some space between the content and the image. Center image by default. */\n\t\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\t \tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\t\tmargin: 0.9em auto;\n\n\t\t/* Make sure the caption will be displayed properly (See: https://github.com/ckeditor/ckeditor5/issues/1870). */\n\t\tmin-width: 50px;\n\n\t\t& img {\n\t\t\t/* Prevent unnecessary margins caused by line-height (see #44). */\n\t\t\tdisplay: block;\n\n\t\t\t/* Center the image if its width is smaller than the content\'s width. */\n\t\t\tmargin: 0 auto;\n\n\t\t\t/* Make sure the image never exceeds the size of the parent container (ckeditor/ckeditor5-ui#67). */\n\t\t\tmax-width: 100%;\n\n\t\t\t/* Make sure the image is never smaller than the parent container (See: https://github.com/ckeditor/ckeditor5/issues/9300). */\n\t\t\tmin-width: 100%\n\t\t}\n\t}\n\n\t& .image-inline {\n\t\t/*\n\t\t * Normally, the .image-inline would have "display: inline-block" and "img { width: 100% }" (to follow the wrapper while resizing).\n\t\t * Unfortunately, together with "srcset", it gets automatically stretched up to the width of the editing root.\n\t\t * This strange behavior does not happen with inline-flex.\n\t\t */\n\t\tdisplay: inline-flex;\n\n\t\t/* While being resized, don\'t allow the image to exceed the width of the editing root. */\n\t\tmax-width: 100%;\n\n\t\t/* This is required by Safari to resize images in a sensible way. Without this, the browser breaks the ratio. */\n\t\talign-items: flex-start;\n\n\t\t/* When the picture is present it must act as a flex container to let the img resize properly */\n\t\t& picture {\n\t\t\tdisplay: flex;\n\t\t}\n\n\t\t/* When the picture is present, it must act like a resizable img. */\n\t\t& picture,\n\t\t& img {\n\t\t\t/* This is necessary for the img to span the entire .image-inline wrapper and to resize properly. */\n\t\t\tflex-grow: 1;\n\t\t\tflex-shrink: 1;\n\n\t\t\t/* Prevents overflowing the editing root boundaries when an inline image is very wide. */\n\t\t\tmax-width: 100%;\n\t\t}\n\t}\n}\n\n.ck.ck-editor__editable {\n\t/*\n\t * Inhertit the content styles padding of the <figcaption> in case the integration overrides `text-align: center`\n\t * of `.image` (e.g. to the left/right). This ensures the placeholder stays at the padding just like the native\n\t * caret does, and not at the edge of <figcaption>.\n\t */\n\t& .image > figcaption.ck-placeholder::before {\n\t\tpadding-left: inherit;\n\t\tpadding-right: inherit;\n\n\t\t/*\n\t\t * Make sure the image caption placeholder doesn\'t overflow the placeholder area.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9162.\n\t\t */\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\n\n\t/*\n\t * Make sure the selected inline image always stays on top of its siblings.\n\t * See https://github.com/ckeditor/ckeditor5/issues/9108.\n\t */\n\t& .image.ck-widget_selected {\n\t\tz-index: 1;\n\t}\n\n\t& .image-inline.ck-widget_selected {\n\t\tz-index: 1;\n\n\t\t/*\n\t\t * Make sure the native browser selection style is not displayed.\n\t\t * Inline image widgets have their own styles for the selected state and\n\t\t * leaving this up to the browser is asking for a visual collision.\n\t\t */\n\t\t& ::selection {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t/* The inline image nested in the table should have its original size if not resized.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9117. */\n\t& td,\n\t& th {\n\t\t& .image-inline img {\n\t\t\tmax-width: none;\n\t\t}\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          8662: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              ':root{--ck-color-image-caption-background:#f7f7f7;--ck-color-image-caption-text:#333;--ck-color-image-caption-highligted-background:#fd0}.ck-content .image>figcaption{background-color:var(--ck-color-image-caption-background);caption-side:bottom;color:var(--ck-color-image-caption-text);display:table-caption;font-size:.75em;outline-offset:-1px;padding:.6em;word-break:break-word}.ck.ck-editor__editable .image>figcaption.image__caption_highlighted{animation:ck-image-caption-highlight .6s ease-out}@keyframes ck-image-caption-highlight{0%{background-color:var(--ck-color-image-caption-highligted-background)}to{background-color:var(--ck-color-image-caption-background)}}',
              '',
              {
                version: 3,
                sources: ['webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imagecaption.css'],
                names: [],
                mappings:
                  'AAKA,MACC,2CAAoD,CACpD,kCAA8C,CAC9C,mDACD,CAGA,8BAKC,yDAA0D,CAH1D,mBAAoB,CAEpB,wCAAyC,CAHzC,qBAAsB,CAMtB,eAAgB,CAChB,mBAAoB,CAFpB,YAAa,CAHb,qBAMD,CAGA,qEACC,iDACD,CAEA,sCACC,GACC,oEACD,CAEA,GACC,yDACD,CACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-image-caption-background: hsl(0, 0%, 97%);\n\t--ck-color-image-caption-text: hsl(0, 0%, 20%);\n\t--ck-color-image-caption-highligted-background: hsl(52deg 100% 50%);\n}\n\n/* Content styles */\n.ck-content .image > figcaption {\n\tdisplay: table-caption;\n\tcaption-side: bottom;\n\tword-break: break-word;\n\tcolor: var(--ck-color-image-caption-text);\n\tbackground-color: var(--ck-color-image-caption-background);\n\tpadding: .6em;\n\tfont-size: .75em;\n\toutline-offset: -1px;\n}\n\n/* Editing styles */\n.ck.ck-editor__editable .image > figcaption.image__caption_highlighted {\n\tanimation: ck-image-caption-highlight .6s ease-out;\n}\n\n@keyframes ck-image-caption-highlight {\n\t0% {\n\t\tbackground-color: var(--ck-color-image-caption-highligted-background);\n\t}\n\n\t100% {\n\t\tbackground-color: var(--ck-color-image-caption-background);\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          4622: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              ':root{--ck-image-style-spacing:1.5em;--ck-inline-image-style-spacing:calc(var(--ck-image-style-spacing)/2)}.ck-content .image-style-block-align-left,.ck-content .image-style-block-align-right{max-width:calc(100% - var(--ck-image-style-spacing))}.ck-content .image-style-align-left,.ck-content .image-style-align-right{clear:none}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing);max-width:50%}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}.ck-content .image-style-block-align-right{margin-left:auto;margin-right:0}.ck-content .image-style-block-align-left{margin-left:0;margin-right:auto}.ck-content p+.image-style-align-left,.ck-content p+.image-style-align-right,.ck-content p+.image-style-side{margin-top:0}.ck-content .image-inline.image-style-align-left,.ck-content .image-inline.image-style-align-right{margin-bottom:var(--ck-inline-image-style-spacing);margin-top:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-left{margin-right:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-right{margin-left:var(--ck-inline-image-style-spacing)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-background)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after{display:none}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-hover-background)}',
              '',
              {
                version: 3,
                sources: ['webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imagestyle.css'],
                names: [],
                mappings:
                  'AAKA,MACC,8BAA+B,CAC/B,qEACD,CAMC,qFAEC,oDACD,CAIA,yEAEC,UACD,CAEA,8BACC,WAAY,CACZ,yCAA0C,CAC1C,aACD,CAEA,oCACC,UAAW,CACX,0CACD,CAEA,sCACC,gBAAiB,CACjB,iBACD,CAEA,qCACC,WAAY,CACZ,yCACD,CAEA,2CAEC,gBAAiB,CADjB,cAED,CAEA,0CACC,aAAc,CACd,iBACD,CAGA,6GAGC,YACD,CAGC,mGAGC,kDAAmD,CADnD,+CAED,CAEA,iDACC,iDACD,CAEA,kDACC,gDACD,CAUC,0lBAGC,qDAKD,CAHC,8nBACC,YACD,CAKD,oVAGC,2DACD',
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-image-style-spacing: 1.5em;\n\t--ck-inline-image-style-spacing: calc(var(--ck-image-style-spacing) / 2);\n}\n\n.ck-content {\n\t/* Provides a minimal side margin for the left and right aligned images, so that the user has a visual feedback\n\tconfirming successful application of the style if image width exceeds the editor's size.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9342 */\n\t& .image-style-block-align-left,\n\t& .image-style-block-align-right {\n\t\tmax-width: calc(100% - var(--ck-image-style-spacing));\n\t}\n\n\t/* Allows displaying multiple floating images in the same line.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9183#issuecomment-804988132 */\n\t& .image-style-align-left,\n\t& .image-style-align-right {\n\t\tclear: none;\n\t}\n\n\t& .image-style-side {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t\tmax-width: 50%;\n\t}\n\n\t& .image-style-align-left {\n\t\tfloat: left;\n\t\tmargin-right: var(--ck-image-style-spacing);\n\t}\n\n\t& .image-style-align-center {\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n\n\t& .image-style-align-right {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t}\n\n\t& .image-style-block-align-right {\n\t\tmargin-right: 0;\n\t\tmargin-left: auto;\n\t}\n\n\t& .image-style-block-align-left {\n\t\tmargin-left: 0;\n\t\tmargin-right: auto;\n\t}\n\n\t/* Simulates margin collapsing with the preceding paragraph, which does not work for the floating elements. */\n\t& p + .image-style-align-left,\n\t& p + .image-style-align-right,\n\t& p + .image-style-side {\n\t\tmargin-top: 0;\n\t}\n\n\t& .image-inline {\n\t\t&.image-style-align-left,\n\t\t&.image-style-align-right {\n\t\t\tmargin-top: var(--ck-inline-image-style-spacing);\n\t\t\tmargin-bottom: var(--ck-inline-image-style-spacing);\n\t\t}\n\n\t\t&.image-style-align-left {\n\t\t\tmargin-right: var(--ck-inline-image-style-spacing);\n\t\t}\n\n\t\t&.image-style-align-right {\n\t\t\tmargin-left: var(--ck-inline-image-style-spacing);\n\t\t}\n\t}\n}\n\n.ck.ck-splitbutton {\n\t/* The button should display as a regular drop-down if the action button\n\tis forced to fire the same action as the arrow button. */\n\t&.ck-splitbutton_flatten {\n\t\t&:hover,\n\t\t&.ck-splitbutton_open {\n\t\t\t& > .ck-splitbutton__action:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {\n\t\t\t\tbackground-color: var(--ck-color-button-on-background);\n\n\t\t\t\t&::after {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.ck-splitbutton_open:hover {\n\t\t\t& > .ck-splitbutton__action:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {\n\t\t\t\tbackground-color: var(--ck-color-button-on-hover-background);\n\t\t\t}\n\t\t}\n\t}\n}\n",
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          9899: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck-image-upload-complete-icon{border-radius:50%;display:block;position:absolute;right:min(var(--ck-spacing-medium),6%);top:min(var(--ck-spacing-medium),6%);z-index:1}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20;--ck-image-upload-icon-width:2px;--ck-image-upload-icon-is-visible:clamp(0px,100% - 50px,1px)}.ck-image-upload-complete-icon{animation-delay:0ms,3s;animation-duration:.5s,.5s;animation-fill-mode:forwards,forwards;animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;background:var(--ck-color-image-upload-icon-background);font-size:calc(1px*var(--ck-image-upload-icon-size));height:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size));opacity:0;overflow:hidden;width:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size))}.ck-image-upload-complete-icon:after{animation-delay:.5s;animation-duration:.5s;animation-fill-mode:forwards;animation-name:ck-upload-complete-icon-check;border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);box-sizing:border-box;height:0;left:25%;opacity:0;top:50%;transform:scaleX(-1) rotate(135deg);transform-origin:left top;width:0}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{height:0;opacity:1;width:0}33%{height:0;width:.3em}to{height:.45em;opacity:1;width:.3em}}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadicon.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadicon.css',
                ],
                names: [],
                mappings:
                  'AAKA,+BAUC,iBAAkB,CATlB,aAAc,CACd,iBAAkB,CAOlB,sCAAwC,CADxC,oCAAsC,CAGtC,SAMD,CAJC,qCACC,UAAW,CACX,iBACD,CChBD,MACC,iCAA8C,CAC9C,+CAA4D,CAG5D,8BAA+B,CAC/B,gCAAiC,CACjC,4DACD,CAEA,+BAWC,sBAA4B,CAN5B,0BAAgC,CADhC,qCAAuC,CADvC,wEAA0E,CAD1E,uDAAwD,CAMxD,oDAAuD,CAWvD,oFAAuF,CAlBvF,SAAU,CAgBV,eAAgB,CAChB,mFA0BD,CAtBC,qCAgBC,mBAAsB,CADtB,sBAAyB,CAEzB,4BAA6B,CAH7B,4CAA6C,CAF7C,sFAAuF,CADvF,oFAAqF,CASrF,qBAAsB,CAdtB,QAAS,CAJT,QAAS,CAGT,SAAU,CADV,OAAQ,CAKR,mCAAoC,CACpC,yBAA0B,CAH1B,OAcD,CAGD,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,yCACC,GAGC,QAAS,CAFT,SAAU,CACV,OAED,CACA,IAEC,QAAS,CADT,UAED,CACA,GAGC,YAAc,CAFd,SAAU,CACV,UAED,CACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-image-upload-complete-icon {\n\tdisplay: block;\n\tposition: absolute;\n\n\t/*\n\t * Smaller images should have the icon closer to the border.\n\t * Match the icon position with the linked image indicator brought by the link image feature.\n\t */\n\ttop: min(var(--ck-spacing-medium), 6%);\n\tright: min(var(--ck-spacing-medium), 6%);\n\tborder-radius: 50%;\n\tz-index: 1;\n\n\t&::after {\n\t\tcontent: "";\n\t\tposition: absolute;\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-image-upload-icon: hsl(0, 0%, 100%);\n\t--ck-color-image-upload-icon-background: hsl(120, 100%, 27%);\n\n\t/* Match the icon size with the linked image indicator brought by the link image feature. */\n\t--ck-image-upload-icon-size: 20;\n\t--ck-image-upload-icon-width: 2px;\n\t--ck-image-upload-icon-is-visible: clamp(0px, 100% - 50px, 1px);\n}\n\n.ck-image-upload-complete-icon {\n\topacity: 0;\n\tbackground: var(--ck-color-image-upload-icon-background);\n\tanimation-name: ck-upload-complete-icon-show, ck-upload-complete-icon-hide;\n\tanimation-fill-mode: forwards, forwards;\n\tanimation-duration: 500ms, 500ms;\n\n\t/* To make animation scalable. */\n\tfont-size: calc(1px * var(--ck-image-upload-icon-size));\n\n\t/* Hide completed upload icon after 3 seconds. */\n\tanimation-delay: 0ms, 3000ms;\n\n\t/*\n\t * Use CSS math to simulate container queries.\n\t * https://css-tricks.com/the-raven-technique-one-step-closer-to-container-queries/#what-about-showing-and-hiding-things\n\t */\n\toverflow: hidden;\n\twidth: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));\n\theight: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));\n\n\t/* This is check icon element made from border-width mixed with animations. */\n\t&::after {\n\t\t/* Because of border transformation we need to "hard code" left position. */\n\t\tleft: 25%;\n\n\t\ttop: 50%;\n\t\topacity: 0;\n\t\theight: 0;\n\t\twidth: 0;\n\n\t\ttransform: scaleX(-1) rotate(135deg);\n\t\ttransform-origin: left top;\n\t\tborder-top: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\t\tborder-right: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\n\t\tanimation-name: ck-upload-complete-icon-check;\n\t\tanimation-duration: 500ms;\n\t\tanimation-delay: 500ms;\n\t\tanimation-fill-mode: forwards;\n\n\t\t/* #1095. While reset is not providing proper box-sizing for pseudoelements, we need to handle it. */\n\t\tbox-sizing: border-box;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-show {\n\tfrom {\n\t\topacity: 0;\n\t}\n\n\tto {\n\t\topacity: 1;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-hide {\n\tfrom {\n\t\topacity: 1;\n\t}\n\n\tto {\n\t\topacity: 0;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-check {\n\t0% {\n\t\topacity: 1;\n\t\twidth: 0;\n\t\theight: 0;\n\t}\n\t33% {\n\t\twidth: 0.3em;\n\t\theight: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t\twidth: 0.3em;\n\t\theight: 0.45em;\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          9825: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck .ck-upload-placeholder-loader{align-items:center;display:flex;justify-content:center;left:0;position:absolute;top:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px;--ck-upload-placeholder-image-aspect-ratio:2.8}.ck .ck-image-upload-placeholder{margin:0;width:100%}.ck .ck-image-upload-placeholder.image-inline{width:calc(var(--ck-upload-placeholder-loader-size)*2*var(--ck-upload-placeholder-image-aspect-ratio))}.ck .ck-image-upload-placeholder img{aspect-ratio:var(--ck-upload-placeholder-image-aspect-ratio)}.ck .ck-upload-placeholder-loader{height:100%;width:100%}.ck .ck-upload-placeholder-loader:before{animation:ck-upload-placeholder-loader 1s linear infinite;border-radius:50%;border-right:2px solid transparent;border-top:3px solid var(--ck-color-upload-placeholder-loader);height:var(--ck-upload-placeholder-loader-size);width:var(--ck-upload-placeholder-loader-size)}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadloader.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadloader.css',
                ],
                names: [],
                mappings:
                  'AAKA,kCAGC,kBAAmB,CADnB,YAAa,CAEb,sBAAuB,CAEvB,MAAO,CALP,iBAAkB,CAIlB,KAOD,CAJC,yCACC,UAAW,CACX,iBACD,CCXD,MACC,4CAAqD,CACrD,wCAAyC,CACzC,8CACD,CAEA,iCAGC,QAAS,CADT,UAgBD,CAbC,8CACC,sGACD,CAEA,qCAOC,4DACD,CAGD,kCAEC,WAAY,CADZ,UAWD,CARC,yCAMC,yDAA0D,CAH1D,iBAAkB,CAElB,kCAAmC,CADnC,8DAA+D,CAF/D,+CAAgD,CADhD,8CAMD,CAGD,wCACC,GACC,uBACD,CACD',
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-upload-placeholder-loader {\n\tposition: absolute;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttop: 0;\n\tleft: 0;\n\n\t&::before {\n\t\tcontent: '';\n\t\tposition: relative;\n\t}\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-upload-placeholder-loader: hsl(0, 0%, 70%);\n\t--ck-upload-placeholder-loader-size: 32px;\n\t--ck-upload-placeholder-image-aspect-ratio: 2.8;\n}\n\n.ck .ck-image-upload-placeholder {\n\t/* We need to control the full width of the SVG gray background. */\n\twidth: 100%;\n\tmargin: 0;\n\n\t&.image-inline {\n\t\twidth: calc( 2 * var(--ck-upload-placeholder-loader-size) * var(--ck-upload-placeholder-image-aspect-ratio) );\n\t}\n\n\t& img {\n\t\t/*\n\t\t * This is an arbitrary aspect for a 1x1 px GIF to display to the user. Not too tall, not too short.\n\t\t * There's nothing special about this number except that it should make the image placeholder look like\n\t\t * a real image during this short period after the upload started and before the image was read from the\n\t\t * file system (and a rich preview was loaded).\n\t\t */\n\t\taspect-ratio: var(--ck-upload-placeholder-image-aspect-ratio);\n\t}\n}\n\n.ck .ck-upload-placeholder-loader {\n\twidth: 100%;\n\theight: 100%;\n\n\t&::before {\n\t\twidth: var(--ck-upload-placeholder-loader-size);\n\t\theight: var(--ck-upload-placeholder-loader-size);\n\t\tborder-radius: 50%;\n\t\tborder-top: 3px solid var(--ck-color-upload-placeholder-loader);\n\t\tborder-right: 2px solid transparent;\n\t\tanimation: ck-upload-placeholder-loader 1s linear infinite;\n\t}\n}\n\n@keyframes ck-upload-placeholder-loader {\n\tto {\n\t\ttransform: rotate( 360deg );\n\t}\n}\n",
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          5870: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-editor__editable .image,.ck.ck-editor__editable .image-inline{position:relative}.ck.ck-editor__editable .image .ck-progress-bar,.ck.ck-editor__editable .image-inline .ck-progress-bar{left:0;position:absolute;top:0}.ck.ck-editor__editable .image-inline.ck-appear,.ck.ck-editor__editable .image.ck-appear{animation:fadeIn .7s}.ck.ck-editor__editable .image .ck-progress-bar,.ck.ck-editor__editable .image-inline .ck-progress-bar{background:var(--ck-color-upload-bar-background);height:2px;transition:width .1s;width:0}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadprogress.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadprogress.css',
                ],
                names: [],
                mappings:
                  'AAMC,qEAEC,iBACD,CAGA,uGAIC,MAAO,CAFP,iBAAkB,CAClB,KAED,CCRC,yFACC,oBACD,CAID,uGAIC,gDAAiD,CAFjD,UAAW,CAGX,oBAAuB,CAFvB,OAGD,CAGD,kBACC,GAAO,SAAY,CACnB,GAAO,SAAY,CACpB',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t& .image,\n\t& .image-inline {\n\t\tposition: relative;\n\t}\n\n\t/* Upload progress bar. */\n\t& .image .ck-progress-bar,\n\t& .image-inline .ck-progress-bar {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t& .image,\n\t& .image-inline {\n\t\t/* Showing animation. */\n\t\t&.ck-appear {\n\t\t\tanimation: fadeIn 700ms;\n\t\t}\n\t}\n\n\t/* Upload progress bar. */\n\t& .image .ck-progress-bar,\n\t& .image-inline .ck-progress-bar {\n\t\theight: 2px;\n\t\twidth: 0;\n\t\tbackground: var(--ck-color-upload-bar-background);\n\t\ttransition: width 100ms;\n\t}\n}\n\n@keyframes fadeIn {\n\tfrom { opacity: 0; }\n\tto   { opacity: 1; }\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          6831: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-field-view{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-image/theme/textalternativeform.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css',
                ],
                names: [],
                mappings:
                  'AAOA,6BACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,oDACC,oBACD,CAEA,uCACC,YACD,CCZA,oCDCD,6BAcE,cAUF,CARE,oDACC,eACD,CAEA,wCACC,cACD,CCrBD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-text-alternative-form {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          399: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck .ck-link_selected{background:var(--ck-color-link-selected-background)}.ck .ck-link_selected span.image-inline{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background)}.ck .ck-fake-link-selection{background:var(--ck-color-link-fake-selection)}.ck .ck-fake-link-selection_collapsed{border-right:1px solid var(--ck-color-base-text);height:100%;margin-right:-1px;outline:1px solid hsla(0,0%,100%,.5)}',
              '',
              {
                version: 3,
                sources: ['webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/link.css'],
                names: [],
                mappings: 'AAMA,sBACC,mDAMD,CAHC,wCACC,yFACD,CAOD,4BACC,8CACD,CAGA,sCAEC,gDAAiD,CADjD,WAAY,CAEZ,iBAAkB,CAClB,oCACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Class added to span element surrounding currently selected link. */\n.ck .ck-link_selected {\n\tbackground: var(--ck-color-link-selected-background);\n\n\t/* Give linked inline images some outline to let the user know they are also part of the link. */\n\t& span.image-inline {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background);\n\t}\n}\n\n/*\n * Classes used by the "fake visual selection" displayed in the content when an input\n * in the link UI has focus (the browser does not render the native selection in this state).\n */\n.ck .ck-fake-link-selection {\n\tbackground: var(--ck-color-link-fake-selection);\n}\n\n/* A collapsed fake visual selection. */\n.ck .ck-fake-link-selection_collapsed {\n\theight: 100%;\n\tborder-right: 1px solid var(--ck-color-base-text);\n\tmargin-right: -1px;\n\toutline: solid 1px hsla(0, 0%, 100%, .5);\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          9465: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{color:var(--ck-color-link-default);cursor:pointer;max-width:var(--ck-input-width);min-width:3em;padding:0 var(--ck-spacing-medium);text-align:center;text-overflow:ellipsis}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{max-width:100%;min-width:0}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview),[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkactions.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkactions.css',
                ],
                names: [],
                mappings:
                  'AAOA,oBACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,8CACC,oBAKD,CAHC,gEACC,eACD,CCXD,oCDCD,oBAcE,cAUF,CARE,8CACC,eACD,CAEA,8DACC,cACD,CCrBD,CCIA,wDACC,cAAe,CACf,eAmCD,CAjCC,0EAEC,kCAAmC,CAEnC,cAAe,CAIf,+BAAgC,CAChC,aAAc,CARd,kCAAmC,CASnC,iBAAkB,CAPlB,sBAYD,CAHC,gFACC,yBACD,CAGD,mPAIC,eACD,CAEA,+DACC,eACD,CAGC,gFACC,yBACD,CAWD,qHACC,sCACD,CDtDD,oCC0DC,wDACC,8DAMD,CAJC,0EAEC,cAAe,CADf,WAED,CAGD,gJAME,aAEF,CDzED',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-link-actions__preview {\n\t\tdisplay: inline-block;\n\n\t\t& .ck-button__label {\n\t\t\toverflow: hidden;\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-link-actions__preview {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\t& .ck-button.ck-link-actions__preview {\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\n\t\t& .ck-button__label {\n\t\t\tpadding: 0 var(--ck-spacing-medium);\n\t\t\tcolor: var(--ck-color-link-default);\n\t\t\ttext-overflow: ellipsis;\n\t\t\tcursor: pointer;\n\n\t\t\t/* Match the box model of the link editor form\'s input so the balloon\n\t\t\tdoes not change width when moving between actions and the form. */\n\t\t\tmax-width: var(--ck-input-width);\n\t\t\tmin-width: 3em;\n\t\t\ttext-align: center;\n\n\t\t\t&:hover {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\n\t\t&,\n\t\t&:hover,\n\t\t&:focus,\n\t\t&:active {\n\t\t\tbackground: none;\n\t\t}\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&:focus {\n\t\t\t& .ck-button__label {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-button:not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-button:not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\t& .ck-button.ck-link-actions__preview {\n\t\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-standard) 0;\n\n\t\t\t& .ck-button__label {\n\t\t\t\tmin-width: 0;\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          4827: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-link-form{display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form_layout-vertical .ck-button.ck-button-cancel,.ck.ck-link-form_layout-vertical .ck-button.ck-button-save{margin-top:var(--ck-spacing-medium)}.ck.ck-link-form_layout-vertical{min-width:var(--ck-input-width);padding:0}.ck.ck-link-form_layout-vertical .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical>.ck-button{border-radius:0;margin:0;padding:var(--ck-spacing-standard);width:50%}.ck.ck-link-form_layout-vertical>.ck-button:not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-form_layout-vertical>.ck-button,[dir=rtl] .ck.ck-link-form_layout-vertical>.ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical>.ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin:var(--ck-spacing-standard) var(--ck-spacing-large)}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{padding:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkform.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkform.css',
                ],
                names: [],
                mappings:
                  'AAOA,iBACC,YAiBD,CAfC,2BACC,YACD,CCNA,oCDCD,iBAQE,cAUF,CARE,wCACC,eACD,CAEA,4BACC,cACD,CCfD,CDuBD,iCACC,aAYD,CALE,wHAEC,mCACD,CE/BF,iCAEC,+BAAgC,CADhC,SAgDD,CA7CC,wDACC,8EAMD,CAJC,uEACC,WAAY,CACZ,UACD,CAGD,4CAIC,eAAgB,CAFhB,QAAS,CADT,kCAAmC,CAEnC,SAkBD,CAfC,wDACC,gDACD,CARD,4GAeE,aAMF,CAJE,mEACC,kDACD,CAKF,6CACC,yDAUD,CARC,wEACC,SAAU,CACV,UAKD,CAHC,8EACC,eACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-form {\n\tdisplay: flex;\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tdisplay: block;\n\n\t/*\n\t * Whether the form is in the responsive mode or not, if there are decorator buttons\n\t * keep the top margin of action buttons medium.\n\t */\n\t& .ck-button {\n\t\t&.ck-button-save,\n\t\t&.ck-button-cancel {\n\t\t\tmargin-top: var(--ck-spacing-medium);\n\t\t}\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tpadding: 0;\n\tmin-width: var(--ck-input-width);\n\n\t& .ck-labeled-field-view {\n\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small);\n\n\t\t& .ck-input-text {\n\t\t\tmin-width: 0;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t& > .ck-button {\n\t\tpadding: var(--ck-spacing-standard);\n\t\tmargin: 0;\n\t\twidth: 50%;\n\t\tborder-radius: 0;\n\n\t\t&:not(:focus) {\n\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t}\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-left: 0;\n\n\t\t\t&:last-of-type {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Using additional `.ck` class for stronger CSS specificity than `.ck.ck-link-form > :not(:first-child)`. */\n\t& .ck.ck-list {\n\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-large);\n\n\t\t& .ck-button.ck-switchbutton {\n\t\t\tpadding: 0;\n\t\t\twidth: 100%;\n\n\t\t\t&:hover {\n\t\t\t\tbackground: none;\n\t\t\t}\n\t\t}\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          5777: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck-content .media{clear:both;display:block;margin:.9em 0;min-width:15em}',
              '',
              {
                version: 3,
                sources: ['webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaembed.css'],
                names: [],
                mappings: 'AAKA,mBAGC,UAAW,CASX,aAAc,CAJd,aAAe,CAQf,cACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .media {\n\t/* Don\'t allow floated content overlap the media.\n\thttps://github.com/ckeditor/ckeditor5-media-embed/issues/53 */\n\tclear: both;\n\n\t/* Make sure there is some space between the content and the media. */\n\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\tmargin: 0.9em 0;\n\n\t/* Make sure media is not overriden with Bootstrap default `flex` value.\n\tSee: https://github.com/ckeditor/ckeditor5/issues/1373. */\n\tdisplay: block;\n\n\t/* Give the media some minimal width in the content to prevent them\n\tfrom being "squashed" in tight spaces, e.g. in table cells (#44) */\n\tmin-width: 15em;\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          952: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck-media__wrapper .ck-media__placeholder{align-items:center;display:flex;flex-direction:column}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{display:block;overflow:hidden}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{background:var(--ck-color-base-foreground);padding:calc(var(--ck-spacing-standard)*3)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{background-position:50%;background-size:cover;height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);min-width:var(--ck-media-embed-placeholder-icon-size)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{height:100%;width:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);font-style:italic;text-align:center;text-overflow:ellipsis;white-space:nowrap}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-height:380px;max-width:300px}.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTAuMzc4IiBoZWlnaHQ9IjI1NC4xNjciIHZpZXdCb3g9IjAgMCA2Ni4yNDYgNjcuMjQ4Ij48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTcyLjUzMSAtMjE4LjQ1NSkgc2NhbGUoLjk4MDEyKSI+PHJlY3Qgcnk9IjUuMjM4IiByeD0iNS4yMzgiIHk9IjIzMS4zOTkiIHg9IjE3Ni4wMzEiIGhlaWdodD0iNjAuMDk5IiB3aWR0aD0iNjAuMDk5IiBmaWxsPSIjMzRhNjY4IiBwYWludC1vcmRlcj0ibWFya2VycyBzdHJva2UgZmlsbCIvPjxwYXRoIGQ9Im0yMDYuNDc3IDI2MC45LTI4Ljk4NyAyOC45ODdhNS4yMTggNS4yMTggMCAwIDAgMy43OCAxLjYxaDQ5LjYyMWMxLjY5NCAwIDMuMTktLjc5OCA0LjE0Ni0yLjAzN3oiIGZpbGw9IiM1Yzg4YzUiLz48cGF0aCBkPSJNMjI2Ljc0MiAyMjIuOTg4Yy05LjI2NiAwLTE2Ljc3NyA3LjE3LTE2Ljc3NyAxNi4wMTQuMDA3IDIuNzYyLjY2MyA1LjQ3NCAyLjA5MyA3Ljg3NS40My43MDMuODMgMS40MDggMS4xOSAyLjEwNy4zMzMuNTAyLjY1IDEuMDA1Ljk1IDEuNTA4LjM0My40NzcuNjczLjk1Ny45ODggMS40NCAxLjMxIDEuNzY5IDIuNSAzLjUwMiAzLjYzNyA1LjE2OC43OTMgMS4yNzUgMS42ODMgMi42NCAyLjQ2NiAzLjk5IDIuMzYzIDQuMDk0IDQuMDA3IDguMDkyIDQuNiAxMy45MTR2LjAxMmMuMTgyLjQxMi41MTYuNjY2Ljg3OS42NjcuNDAzLS4wMDEuNzY4LS4zMTQuOTMtLjc5OS42MDMtNS43NTYgMi4yMzgtOS43MjkgNC41ODUtMTMuNzk0Ljc4Mi0xLjM1IDEuNjczLTIuNzE1IDIuNDY1LTMuOTkgMS4xMzctMS42NjYgMi4zMjgtMy40IDMuNjM4LTUuMTY5LjMxNS0uNDgyLjY0NS0uOTYyLjk4OC0xLjQzOS4zLS41MDMuNjE3LTEuMDA2Ljk1LTEuNTA4LjM1OS0uNy43Ni0xLjQwNCAxLjE5LTIuMTA3IDEuNDI2LTIuNDAyIDItNS4xMTQgMi4wMDQtNy44NzUgMC04Ljg0NC03LjUxMS0xNi4wMTQtMTYuNzc2LTE2LjAxNHoiIGZpbGw9IiNkZDRiM2UiIHBhaW50LW9yZGVyPSJtYXJrZXJzIHN0cm9rZSBmaWxsIi8+PGVsbGlwc2Ugcnk9IjUuNTY0IiByeD0iNS44MjgiIGN5PSIyMzkuMDAyIiBjeD0iMjI2Ljc0MiIgZmlsbD0iIzgwMmQyNyIgcGFpbnQtb3JkZXI9Im1hcmtlcnMgc3Ryb2tlIGZpbGwiLz48cGF0aCBkPSJNMTkwLjMwMSAyMzcuMjgzYy00LjY3IDAtOC40NTcgMy44NTMtOC40NTcgOC42MDZzMy43ODYgOC42MDcgOC40NTcgOC42MDdjMy4wNDMgMCA0LjgwNi0uOTU4IDYuMzM3LTIuNTE2IDEuNTMtMS41NTcgMi4wODctMy45MTMgMi4wODctNi4yOSAwLS4zNjItLjAyMy0uNzIyLS4wNjQtMS4wNzloLTguMjU3djMuMDQzaDQuODVjLS4xOTcuNzU5LS41MzEgMS40NS0xLjA1OCAxLjk4Ni0uOTQyLjk1OC0yLjAyOCAxLjU0OC0zLjkwMSAxLjU0OC0yLjg3NiAwLTUuMjA4LTIuMzcyLTUuMjA4LTUuMjk5IDAtMi45MjYgMi4zMzItNS4yOTkgNS4yMDgtNS4yOTkgMS4zOTkgMCAyLjYxOC40MDcgMy41ODQgMS4yOTNsMi4zODEtMi4zOGMwLS4wMDItLjAwMy0uMDA0LS4wMDQtLjAwNS0xLjU4OC0xLjUyNC0zLjYyLTIuMjE1LTUuOTU1LTIuMjE1em00LjQzIDUuNjYuMDAzLjAwNnYtLjAwM3oiIGZpbGw9IiNmZmYiIHBhaW50LW9yZGVyPSJtYXJrZXJzIHN0cm9rZSBmaWxsIi8+PHBhdGggZD0ibTIxNS4xODQgMjUxLjkyOS03Ljk4IDcuOTc5IDI4LjQ3NyAyOC40NzVhNS4yMzMgNS4yMzMgMCAwIDAgLjQ0OS0yLjEyM3YtMzEuMTY1Yy0uNDY5LjY3NS0uOTM0IDEuMzQ5LTEuMzgyIDIuMDA1LS43OTIgMS4yNzUtMS42ODIgMi42NC0yLjQ2NSAzLjk5LTIuMzQ3IDQuMDY1LTMuOTgyIDguMDM4LTQuNTg1IDEzLjc5NC0uMTYyLjQ4NS0uNTI3Ljc5OC0uOTMuNzk5LS4zNjMtLjAwMS0uNjk3LS4yNTUtLjg3OS0uNjY3di0uMDEyYy0uNTkzLTUuODIyLTIuMjM3LTkuODItNC42LTEzLjkxNC0uNzgzLTEuMzUtMS42NzMtMi43MTUtMi40NjYtMy45OS0xLjEzNy0xLjY2Ni0yLjMyNy0zLjQtMy42MzctNS4xNjlsLS4wMDItLjAwM3oiIGZpbGw9IiNjM2MzYzMiLz48cGF0aCBkPSJtMjEyLjk4MyAyNDguNDk1LTM2Ljk1MiAzNi45NTN2LjgxMmE1LjIyNyA1LjIyNyAwIDAgMCA1LjIzOCA1LjIzOGgxLjAxNWwzNS42NjYtMzUuNjY2YTEzNi4yNzUgMTM2LjI3NSAwIDAgMC0yLjc2NC0zLjkgMzcuNTc1IDM3LjU3NSAwIDAgMC0uOTg5LTEuNDQgMzUuMTI3IDM1LjEyNyAwIDAgMC0uOTUtMS41MDhjLS4wODMtLjE2Mi0uMTc2LS4zMjYtLjI2NC0uNDg5eiIgZmlsbD0iI2ZkZGM0ZiIgcGFpbnQtb3JkZXI9Im1hcmtlcnMgc3Ryb2tlIGZpbGwiLz48cGF0aCBkPSJtMjExLjk5OCAyNjEuMDgzLTYuMTUyIDYuMTUxIDI0LjI2NCAyNC4yNjRoLjc4MWE1LjIyNyA1LjIyNyAwIDAgMCA1LjIzOS01LjIzOHYtMS4wNDV6IiBmaWxsPSIjZmZmIiBwYWludC1vcmRlcj0ibWFya2VycyBzdHJva2UgZmlsbCIvPjwvZz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik05NjcuNDg0IDBINTYuNTE3QzI1LjMwNCAwIDAgMjUuMzA0IDAgNTYuNTE3djkxMC45NjZDMCA5OTguNjk0IDI1LjI5NyAxMDI0IDU2LjUyMiAxMDI0SDU0N1Y2MjhINDE0VjQ3M2gxMzNWMzU5LjAyOWMwLTEzMi4yNjIgODAuNzczLTIwNC4yODIgMTk4Ljc1Ni0yMDQuMjgyIDU2LjUxMyAwIDEwNS4wODYgNC4yMDggMTE5LjI0NCA2LjA4OVYyOTlsLTgxLjYxNi4wMzdjLTYzLjk5MyAwLTc2LjM4NCAzMC40OTItNzYuMzg0IDc1LjIzNlY0NzNoMTUzLjQ4N2wtMTkuOTg2IDE1NUg3MDd2Mzk2aDI2MC40ODRjMzEuMjEzIDAgNTYuNTE2LTI1LjMwMyA1Ni41MTYtNTYuNTE2VjU2LjUxNUMxMDI0IDI1LjMwMyA5OTguNjk3IDAgOTY3LjQ4NCAwIiBmaWxsPSIjRkZGRkZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c7,#b800b1,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0MDAgNDAwIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwMHpNMTYzLjQgMzA1LjVjODguNyAwIDEzNy4yLTczLjUgMTM3LjItMTM3LjIgMC0yLjEgMC00LjItLjEtNi4yIDkuNC02LjggMTcuNi0xNS4zIDI0LjEtMjUtOC42IDMuOC0xNy45IDYuNC0yNy43IDcuNiAxMC02IDE3LjYtMTUuNCAyMS4yLTI2LjctOS4zIDUuNS0xOS42IDkuNS0zMC42IDExLjctOC44LTkuNC0yMS4zLTE1LjItMzUuMi0xNS4yLTI2LjYgMC00OC4yIDIxLjYtNDguMiA0OC4yIDAgMy44LjQgNy41IDEuMyAxMS00MC4xLTItNzUuNi0yMS4yLTk5LjQtNTAuNC00LjEgNy4xLTYuNSAxNS40LTYuNSAyNC4yIDAgMTYuNyA4LjUgMzEuNSAyMS41IDQwLjEtNy45LS4yLTE1LjMtMi40LTIxLjgtNnYuNmMwIDIzLjQgMTYuNiA0Mi44IDM4LjcgNDcuMy00IDEuMS04LjMgMS43LTEyLjcgMS43LTMuMSAwLTYuMS0uMy05LjEtLjkgNi4xIDE5LjIgMjMuOSAzMy4xIDQ1IDMzLjUtMTYuNSAxMi45LTM3LjMgMjAuNi01OS45IDIwLjYtMy45IDAtNy43LS4yLTExLjUtLjcgMjEuMSAxMy44IDQ2LjUgMjEuOCA3My43IDIxLjgiIHN0eWxlPSJmaWxsOiNmZmYiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaembedediting.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-media-embed/mediaembedediting.css',
                ],
                names: [],
                mappings:
                  'AAMC,0CAGC,kBAAmB,CAFnB,YAAa,CACb,qBAcD,CAXC,sEAEC,cAAe,CAEf,iBAMD,CAJC,wGAEC,aAAc,CADd,eAED,CAWD,6kBACC,YACD,CAYF,2LACC,mBACD,CC1CA,MACC,0CAA2C,CAE3C,mDAA4D,CAC5D,2EACD,CAEA,mBACC,aA+FD,CA7FC,0CAEC,0CAA2C,CAD3C,0CA6BD,CA1BC,uEAIC,uBAA2B,CAC3B,qBAAsB,CAHtB,kDAAmD,CACnD,qCAAsC,CAFtC,qDAUD,CAJC,gFAEC,WAAY,CADZ,UAED,CAGD,4EACC,sDAAuD,CAGvD,iBAAkB,CADlB,iBAAkB,CAElB,sBAAuB,CAHvB,kBAUD,CALC,kFACC,4DAA6D,CAC7D,cAAe,CACf,yBACD,CAIF,wDAEC,gBAAiB,CADjB,eAED,CAEA,4UAIC,wvGACD,CAEA,2EACC,kBAaD,CAXC,wGACC,orBACD,CAEA,6GACC,UAKD,CAHC,mHACC,UACD,CAIF,4EACC,2DAcD,CAZC,yGACC,4jHACD,CAGA,8GACC,aAKD,CAHC,oHACC,UACD,CAIF,6EAEC,iDAaD,CAXC,0GACC,wiCACD,CAEA,+GACC,aAKD,CAHC,qHACC,UACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-media__wrapper {\n\t& .ck-media__placeholder {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\n\t\t& .ck-media__placeholder__url {\n\t\t\t/* Otherwise the URL will overflow when the content is very narrow. */\n\t\t\tmax-width: 100%;\n\n\t\t\tposition: relative;\n\n\t\t\t& .ck-media__placeholder__url__text {\n\t\t\t\toverflow: hidden;\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="twitter.com"],\n\t&[data-oembed-url*="google.com/maps"],\n\t&[data-oembed-url*="goo.gl/maps"],\n\t&[data-oembed-url*="maps.google.com"],\n\t&[data-oembed-url*="maps.app.goo.gl"],\n\t&[data-oembed-url*="facebook.com"],\n\t&[data-oembed-url*="instagram.com"] {\n\t\t& .ck-media__placeholder__icon * {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/* Disable all mouse interaction as long as the editor is not read–only.\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/58 */\n.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper > *:not(.ck-media__placeholder) {\n\tpointer-events: none;\n}\n\n/* Disable all mouse interaction when the widget is not selected (e.g. to avoid opening links by accident).\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/18 */\n.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder {\n\tpointer-events: none;\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-media-embed-placeholder-icon-size: 3em;\n\n\t--ck-color-media-embed-placeholder-url-text: hsl(0, 0%, 46%);\n\t--ck-color-media-embed-placeholder-url-text-hover: var(--ck-color-base-text);\n}\n\n.ck-media__wrapper {\n\tmargin: 0 auto;\n\n\t& .ck-media__placeholder {\n\t\tpadding: calc( 3 * var(--ck-spacing-standard) );\n\t\tbackground: var(--ck-color-base-foreground);\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tmin-width: var(--ck-media-embed-placeholder-icon-size);\n\t\t\theight: var(--ck-media-embed-placeholder-icon-size);\n\t\t\tmargin-bottom: var(--ck-spacing-large);\n\t\t\tbackground-position: center;\n\t\t\tbackground-size: cover;\n\n\t\t\t& .ck-icon {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: var(--ck-color-media-embed-placeholder-url-text);\n\t\t\twhite-space: nowrap;\n\t\t\ttext-align: center;\n\t\t\tfont-style: italic;\n\t\t\ttext-overflow: ellipsis;\n\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--ck-color-media-embed-placeholder-url-text-hover);\n\t\t\t\tcursor: pointer;\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="open.spotify.com"] {\n\t\tmax-width: 300px;\n\t\tmax-height: 380px;\n\t}\n\n\t&[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon {\n\t\tbackground-image: url(data:image/svg+xml;base64,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);\n\t}\n\n\t&[data-oembed-url*="facebook.com"] .ck-media__placeholder {\n\t\tbackground: hsl(220, 46%, 48%);\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIxMDI0cHgiIGhlaWdodD0iMTAyNHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPiAgICAgICAgPHRpdGxlPkZpbGwgMTwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgaWQ9ImZMb2dvX1doaXRlIiBmaWxsPSIjRkZGRkZFIj4gICAgICAgICAgICA8cGF0aCBkPSJNOTY3LjQ4NCwwIEw1Ni41MTcsMCBDMjUuMzA0LDAgMCwyNS4zMDQgMCw1Ni41MTcgTDAsOTY3LjQ4MyBDMCw5OTguNjk0IDI1LjI5NywxMDI0IDU2LjUyMiwxMDI0IEw1NDcsMTAyNCBMNTQ3LDYyOCBMNDE0LDYyOCBMNDE0LDQ3MyBMNTQ3LDQ3MyBMNTQ3LDM1OS4wMjkgQzU0NywyMjYuNzY3IDYyNy43NzMsMTU0Ljc0NyA3NDUuNzU2LDE1NC43NDcgQzgwMi4yNjksMTU0Ljc0NyA4NTAuODQyLDE1OC45NTUgODY1LDE2MC44MzYgTDg2NSwyOTkgTDc4My4zODQsMjk5LjAzNyBDNzE5LjM5MSwyOTkuMDM3IDcwNywzMjkuNTI5IDcwNywzNzQuMjczIEw3MDcsNDczIEw4NjAuNDg3LDQ3MyBMODQwLjUwMSw2MjggTDcwNyw2MjggTDcwNywxMDI0IEw5NjcuNDg0LDEwMjQgQzk5OC42OTcsMTAyNCAxMDI0LDk5OC42OTcgMTAyNCw5NjcuNDg0IEwxMDI0LDU2LjUxNSBDMTAyNCwyNS4zMDMgOTk4LjY5NywwIDk2Ny40ODQsMCIgaWQ9IkZpbGwtMSI+PC9wYXRoPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+);\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(220, 100%, 90%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="instagram.com"] .ck-media__placeholder {\n\t\tbackground: linear-gradient(-135deg,hsl(246, 100%, 39%),hsl(302, 100%, 36%),hsl(0, 100%, 48%));\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,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);\n\t\t}\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(302, 100%, 94%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder {\n\t\t/* Use gradient to contrast with focused widget (ckeditor/ckeditor5-media-embed#22). */\n\t\tbackground: linear-gradient( to right, hsl(201, 85%, 70%), hsl(201, 85%, 35%) );\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IldoaXRlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQwMCA0MDAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQwMCA0MDA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPi5zdDB7ZmlsbDojRkZGRkZGO308L3N0eWxlPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00MDAsMjAwYzAsMTEwLjUtODkuNSwyMDAtMjAwLDIwMFMwLDMxMC41LDAsMjAwUzg5LjUsMCwyMDAsMFM0MDAsODkuNSw0MDAsMjAweiBNMTYzLjQsMzA1LjVjODguNywwLDEzNy4yLTczLjUsMTM3LjItMTM3LjJjMC0yLjEsMC00LjItMC4xLTYuMmM5LjQtNi44LDE3LjYtMTUuMywyNC4xLTI1Yy04LjYsMy44LTE3LjksNi40LTI3LjcsNy42YzEwLTYsMTcuNi0xNS40LDIxLjItMjYuN2MtOS4zLDUuNS0xOS42LDkuNS0zMC42LDExLjdjLTguOC05LjQtMjEuMy0xNS4yLTM1LjItMTUuMmMtMjYuNiwwLTQ4LjIsMjEuNi00OC4yLDQ4LjJjMCwzLjgsMC40LDcuNSwxLjMsMTFjLTQwLjEtMi03NS42LTIxLjItOTkuNC01MC40Yy00LjEsNy4xLTYuNSwxNS40LTYuNSwyNC4yYzAsMTYuNyw4LjUsMzEuNSwyMS41LDQwLjFjLTcuOS0wLjItMTUuMy0yLjQtMjEuOC02YzAsMC4yLDAsMC40LDAsMC42YzAsMjMuNCwxNi42LDQyLjgsMzguNyw0Ny4zYy00LDEuMS04LjMsMS43LTEyLjcsMS43Yy0zLjEsMC02LjEtMC4zLTkuMS0wLjljNi4xLDE5LjIsMjMuOSwzMy4xLDQ1LDMzLjVjLTE2LjUsMTIuOS0zNy4zLDIwLjYtNTkuOSwyMC42Yy0zLjksMC03LjctMC4yLTExLjUtMC43QzExMC44LDI5Ny41LDEzNi4yLDMwNS41LDE2My40LDMwNS41Ii8+PC9zdmc+);\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(201, 100%, 86%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          3525: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-media-form{align-items:flex-start;display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-field-view{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaform.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css',
                ],
                names: [],
                mappings:
                  'AAOA,kBAEC,sBAAuB,CADvB,YAAa,CAEb,kBAAmB,CACnB,gBAqBD,CAnBC,yCACC,oBACD,CAEA,4BACC,YACD,CCbA,oCDCD,kBAeE,cAUF,CARE,yCACC,eACD,CAEA,6BACC,cACD,CCtBD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-media-form {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          7583: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              ':root{--ck-color-mention-background:rgba(153,0,48,.1);--ck-color-mention-text:#990030}.ck-content .mention{background:var(--ck-color-mention-background);color:var(--ck-color-mention-text)}',
              '',
              {
                version: 3,
                sources: ['webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-mention/mention.css'],
                names: [],
                mappings: 'AAKA,MACC,+CAAwD,CACxD,+BACD,CAEA,qBACC,6CAA8C,CAC9C,kCACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-mention-background: hsla(341, 100%, 30%, 0.1);\n\t--ck-color-mention-text: hsl(341, 100%, 30%);\n}\n\n.ck-content .mention {\n\tbackground: var(--ck-color-mention-background);\n\tcolor: var(--ck-color-mention-text);\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          6391: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              ':root{--ck-mention-list-max-height:300px}.ck.ck-mentions{max-height:var(--ck-mention-list-max-height);overflow-x:hidden;overflow-y:auto;overscroll-behavior:contain}.ck.ck-mentions>.ck-list__item{flex-shrink:0;overflow:hidden}',
              '',
              {
                version: 3,
                sources: ['webpack://./node_modules/@ckeditor/ckeditor5-mention/theme/mentionui.css'],
                names: [],
                mappings: 'AAKA,MACC,kCACD,CAEA,gBACC,4CAA6C,CAM7C,iBAAkB,CAJlB,eAAgB,CAMhB,2BAQD,CAJC,+BAEC,aAAc,CADd,eAED',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-mention-list-max-height: 300px;\n}\n\n.ck.ck-mentions {\n\tmax-height: var(--ck-mention-list-max-height);\n\n\toverflow-y: auto;\n\n\t/* Prevent unnecessary horizontal scrollbar in Safari\n\thttps://github.com/ckeditor/ckeditor5-mention/issues/41 */\n\toverflow-x: hidden;\n\n\toverscroll-behavior: contain;\n\n\t/* Prevent unnecessary vertical scrollbar in Safari\n\thttps://github.com/ckeditor/ckeditor5-mention/issues/41 */\n\t& > .ck-list__item {\n\t\toverflow: hidden;\n\t\tflex-shrink: 0;\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          4082: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-input-color{display:flex;flex-direction:row-reverse;width:100%}.ck.ck-input-color>input.ck.ck-input-text{flex-grow:1;min-width:auto}.ck.ck-input-color>div.ck.ck-dropdown{min-width:auto}.ck.ck-input-color>div.ck.ck-dropdown>.ck-input-color__button .ck-dropdown__arrow{display:none}.ck.ck-input-color .ck.ck-input-color__button{display:flex}.ck.ck-input-color .ck.ck-input-color__button .ck.ck-input-color__button__preview{overflow:hidden;position:relative}.ck.ck-input-color .ck.ck-input-color__button .ck.ck-input-color__button__preview>.ck.ck-input-color__button__preview__no-color-indicator{display:block;position:absolute}[dir=ltr] .ck.ck-input-color>.ck.ck-input-text{border-bottom-right-radius:0;border-top-right-radius:0}[dir=rtl] .ck.ck-input-color>.ck.ck-input-text{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button{padding:0}[dir=ltr] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button{border-bottom-left-radius:0;border-left-width:0;border-top-left-radius:0}[dir=rtl] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button{border-bottom-right-radius:0;border-right-width:0;border-top-right-radius:0}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button.ck-disabled{background:var(--ck-color-input-disabled-background)}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview{border-radius:0}.ck-rounded-corners .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview,.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview{border:1px solid var(--ck-color-input-border);height:20px;width:20px}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview>.ck.ck-input-color__button__preview__no-color-indicator{background:red;border-radius:2px;height:150%;left:50%;top:-30%;transform:rotate(45deg);transform-origin:50%;width:8%}.ck.ck-input-color .ck.ck-input-color__remove-color{border-bottom:1px solid var(--ck-color-input-border);border-bottom-left-radius:0;border-bottom-right-radius:0;padding:calc(var(--ck-spacing-standard)/2) var(--ck-spacing-standard);width:100%}[dir=ltr] .ck.ck-input-color .ck.ck-input-color__remove-color{border-top-right-radius:0}[dir=rtl] .ck.ck-input-color .ck.ck-input-color__remove-color{border-top-left-radius:0}.ck.ck-input-color .ck.ck-input-color__remove-color .ck.ck-icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-input-color .ck.ck-input-color__remove-color .ck.ck-icon{margin-left:var(--ck-spacing-standard);margin-right:0}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-table/theme/colorinput.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/colorinput.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css',
                ],
                names: [],
                mappings:
                  'AAKA,mBAEC,YAAa,CACb,0BAA2B,CAF3B,UAgCD,CA5BC,0CAEC,WAAY,CADZ,cAED,CAEA,sCACC,cAMD,CAHC,kFACC,YACD,CAGD,8CAEC,YAWD,CATC,kFAEC,eAAgB,CADhB,iBAOD,CAJC,0IAEC,aAAc,CADd,iBAED,CC1BF,+CAGE,4BAA6B,CAD7B,yBAQF,CAVA,+CAQE,2BAA4B,CAD5B,wBAGF,CAGC,wEACC,SAoCD,CArCA,kFAME,2BAA4B,CAF5B,mBAAoB,CACpB,wBAgCF,CArCA,kFAYE,4BAA6B,CAF7B,oBAAqB,CACrB,yBA0BF,CAtBC,oFACC,oDACD,CAEA,4GC9BF,eD+CE,CAjBA,+PC1BD,qCD2CC,CAjBA,4GAKC,6CAA8C,CAD9C,WAAY,CADZ,UAcD,CAVC,oKAKC,cAA6B,CAC7B,iBAAkB,CAHlB,WAAY,CADZ,QAAS,CADT,QAAS,CAMT,uBAAwB,CACxB,oBAAqB,CAJrB,QAKD,CAKH,oDAEC,oDAAqD,CAGrD,2BAA4B,CAC5B,4BAA6B,CAH7B,qEAAwE,CAFxE,UAuBD,CAxBA,8DASE,yBAeF,CAxBA,8DAaE,wBAWF,CARC,gEACC,uCAMD,CAPA,0EAKE,sCAAuC,CADvC,cAGF',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-input-color {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: row-reverse;\n\n\t& > input.ck.ck-input-text {\n\t\tmin-width: auto;\n\t\tflex-grow: 1;\n\t}\n\n\t& > div.ck.ck-dropdown {\n\t\tmin-width: auto;\n\n\t\t/* This dropdown has no arrow but a color preview instead. */\n\t\t& > .ck-input-color__button .ck-dropdown__arrow {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& .ck.ck-input-color__button {\n\t\t/* Resolving issue with misaligned buttons on Safari (see #10589) */\n\t\tdisplay: flex;\n\n\t\t& .ck.ck-input-color__button__preview {\n\t\t\tposition: relative;\n\t\t\toverflow: hidden;\n\n\t\t\t& > .ck.ck-input-color__button__preview__no-color-indicator {\n\t\t\t\tposition: absolute;\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../mixins/_rounded.css";\n\n.ck.ck-input-color {\n\t& > .ck.ck-input-text {\n\t\t@mixin ck-dir ltr {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\t}\n\n\t& > .ck.ck-dropdown {\n\t\t& > .ck.ck-button.ck-input-color__button {\n\t\t\tpadding: 0;\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tborder-left-width: 0;\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tborder-right-width: 0;\n\t\t\t\tborder-top-right-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\n\t\t\t&.ck-disabled {\n\t\t\t\tbackground: var(--ck-color-input-disabled-background);\n\t\t\t}\n\n\t\t\t& > .ck.ck-input-color__button__preview {\n\t\t\t\t@mixin ck-rounded-corners;\n\n\t\t\t\twidth: 20px;\n\t\t\t\theight: 20px;\n\t\t\t\tborder: 1px solid var(--ck-color-input-border);\n\n\t\t\t\t& > .ck.ck-input-color__button__preview__no-color-indicator {\n\t\t\t\t\ttop: -30%;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\theight: 150%;\n\t\t\t\t\twidth: 8%;\n\t\t\t\t\tbackground: hsl(0, 100%, 50%);\n\t\t\t\t\tborder-radius: 2px;\n\t\t\t\t\ttransform: rotate(45deg);\n\t\t\t\t\ttransform-origin: 50%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck.ck-input-color__remove-color {\n\t\twidth: 100%;\n\t\tborder-bottom: 1px solid var(--ck-color-input-border);\n\t\tpadding: calc(var(--ck-spacing-standard) / 2) var(--ck-spacing-standard);\n\n\t\tborder-bottom-left-radius: 0;\n\t\tborder-bottom-right-radius: 0;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tborder-top-right-radius: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tborder-top-left-radius: 0;\n\t\t}\n\n\t\t& .ck.ck-icon {\n\t\t\tmargin-right: var(--ck-spacing-standard);\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: 0;\n\t\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          4880: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-form{padding:0 0 var(--ck-spacing-large)}.ck.ck-form:focus{outline:none}.ck.ck-form .ck.ck-input-text{min-width:100%;width:0}.ck.ck-form .ck.ck-dropdown{min-width:100%}.ck.ck-form .ck.ck-dropdown .ck-dropdown__button:not(:focus){border:1px solid var(--ck-color-base-border)}.ck.ck-form .ck.ck-dropdown .ck-dropdown__button .ck-button__label{width:100%}',
              '',
              {
                version: 3,
                sources: ['webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/form.css'],
                names: [],
                mappings: 'AAKA,YACC,mCAyBD,CAvBC,kBAEC,YACD,CAEA,8BACC,cAAe,CACf,OACD,CAEA,4BACC,cAWD,CARE,6DACC,4CACD,CAEA,mEACC,UACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form {\n\tpadding: 0 0 var(--ck-spacing-large);\n\n\t&:focus {\n\t\t/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */\n\t\toutline: none;\n\t}\n\n\t& .ck.ck-input-text {\n\t\tmin-width: 100%;\n\t\twidth: 0;\n\t}\n\n\t& .ck.ck-dropdown {\n\t\tmin-width: 100%;\n\n\t\t& .ck-dropdown__button {\n\t\t\t&:not(:focus) {\n\t\t\t\tborder: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\n\t\t\t& .ck-button__label {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          9865: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-form__row{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between}.ck.ck-form__row>:not(.ck-label){flex-grow:1}.ck.ck-form__row.ck-table-form__action-row .ck-button-cancel,.ck.ck-form__row.ck-table-form__action-row .ck-button-save{justify-content:center}.ck.ck-form__row{padding:var(--ck-spacing-standard) var(--ck-spacing-large) 0}[dir=ltr] .ck.ck-form__row>:not(.ck-label)+*{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-form__row>:not(.ck-label)+*{margin-right:var(--ck-spacing-large)}.ck.ck-form__row>.ck-label{min-width:100%;width:100%}.ck.ck-form__row.ck-table-form__action-row{margin-top:var(--ck-spacing-large)}.ck.ck-form__row.ck-table-form__action-row .ck-button .ck-button__label{color:var(--ck-color-text)}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-table/theme/formrow.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/formrow.css',
                ],
                names: [],
                mappings:
                  'AAKA,iBACC,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CACjB,6BAaD,CAVC,iCACC,WACD,CAGC,wHAEC,sBACD,CCbF,iBACC,4DA2BD,CAvBE,6CAEE,mCAMF,CARA,6CAME,oCAEF,CAGD,2BAEC,cAAe,CADf,UAED,CAEA,2CACC,kCAKD,CAHC,wEACC,0BACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form__row {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\tjustify-content: space-between;\n\n\t/* Ignore labels that work as fieldset legends */\n\t& > *:not(.ck-label) {\n\t\tflex-grow: 1;\n\t}\n\n\t&.ck-table-form__action-row {\n\t\t& .ck-button-save,\n\t\t& .ck-button-cancel {\n\t\t\tjustify-content: center;\n\t\t}\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-form__row {\n\tpadding: var(--ck-spacing-standard) var(--ck-spacing-large) 0;\n\n\t/* Ignore labels that work as fieldset legends */\n\t& > *:not(.ck-label) {\n\t\t& + * {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: var(--ck-spacing-large);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: var(--ck-spacing-large);\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck-label {\n\t\twidth: 100%;\n\t\tmin-width: 100%;\n\t}\n\n\t&.ck-table-form__action-row {\n\t\tmargin-top: var(--ck-spacing-large);\n\n\t\t& .ck-button .ck-button__label {\n\t\t\tcolor: var(--ck-color-text);\n\t\t}\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          8085: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck .ck-insert-table-dropdown__grid{display:flex;flex-direction:row;flex-wrap:wrap}:root{--ck-insert-table-dropdown-padding:10px;--ck-insert-table-dropdown-box-height:11px;--ck-insert-table-dropdown-box-width:12px;--ck-insert-table-dropdown-box-margin:1px}.ck .ck-insert-table-dropdown__grid{padding:var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0;width:calc(var(--ck-insert-table-dropdown-box-width)*10 + var(--ck-insert-table-dropdown-box-margin)*20 + var(--ck-insert-table-dropdown-padding)*2)}.ck .ck-insert-table-dropdown__label{text-align:center}.ck .ck-insert-table-dropdown-grid-box{border:1px solid var(--ck-color-base-border);border-radius:1px;height:var(--ck-insert-table-dropdown-box-height);margin:var(--ck-insert-table-dropdown-box-margin);outline:none;width:var(--ck-insert-table-dropdown-box-width)}.ck .ck-insert-table-dropdown-grid-box.ck-on{background:var(--ck-color-focus-outer-shadow);border-color:var(--ck-color-focus-border)}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-table/theme/inserttable.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/inserttable.css',
                ],
                names: [],
                mappings:
                  'AAKA,oCACC,YAAa,CACb,kBAAmB,CACnB,cACD,CCJA,MACC,uCAAwC,CACxC,0CAA2C,CAC3C,yCAA0C,CAC1C,yCACD,CAEA,oCAGC,yFAA0F,CAD1F,oJAED,CAEA,qCACC,iBACD,CAEA,uCAIC,4CAA6C,CAC7C,iBAAkB,CAHlB,iDAAkD,CAClD,iDAAkD,CAGlD,YAAa,CALb,+CAWD,CAJC,6CAEC,6CAA8C,CAD9C,yCAED',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-insert-table-dropdown__grid {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: wrap;\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-insert-table-dropdown-padding: 10px;\n\t--ck-insert-table-dropdown-box-height: 11px;\n\t--ck-insert-table-dropdown-box-width: 12px;\n\t--ck-insert-table-dropdown-box-margin: 1px;\n}\n\n.ck .ck-insert-table-dropdown__grid {\n\t/* The width of a container should match 10 items in a row so there will be a 10x10 grid. */\n\twidth: calc(var(--ck-insert-table-dropdown-box-width) * 10 + var(--ck-insert-table-dropdown-box-margin) * 20 + var(--ck-insert-table-dropdown-padding) * 2);\n\tpadding: var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0;\n}\n\n.ck .ck-insert-table-dropdown__label {\n\ttext-align: center;\n}\n\n.ck .ck-insert-table-dropdown-grid-box {\n\twidth: var(--ck-insert-table-dropdown-box-width);\n\theight: var(--ck-insert-table-dropdown-box-height);\n\tmargin: var(--ck-insert-table-dropdown-box-margin);\n\tborder: 1px solid var(--ck-color-base-border);\n\tborder-radius: 1px;\n\toutline: none;\n\n\t&.ck-on {\n\t\tborder-color: var(--ck-color-focus-border);\n\t\tbackground: var(--ck-color-focus-outer-shadow);\n\t}\n}\n\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          4104: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck-content .table{display:table;margin:.9em auto}.ck-content .table table{border:1px double #b3b3b3;border-collapse:collapse;border-spacing:0;height:100%;width:100%}.ck-content .table table td,.ck-content .table table th{border:1px solid #bfbfbf;min-width:2em;padding:.4em}.ck-content .table table th{background:rgba(0,0,0,.05);font-weight:700}.ck-content[dir=rtl] .table th{text-align:right}.ck-content[dir=ltr] .table th{text-align:left}.ck-editor__editable .ck-table-bogus-paragraph{display:inline-block;width:100%}',
              '',
              {
                version: 3,
                sources: ['webpack://./node_modules/@ckeditor/ckeditor5-table/theme/table.css'],
                names: [],
                mappings:
                  'AAKA,mBAKC,aAAc,CADd,gBAiCD,CA9BC,yBAYC,yBAAkC,CAVlC,wBAAyB,CACzB,gBAAiB,CAKjB,WAAY,CADZ,UAsBD,CAfC,wDAQC,wBAAiC,CANjC,aAAc,CACd,YAMD,CAEA,4BAEC,0BAA+B,CAD/B,eAED,CAMF,+BACC,gBACD,CAEA,+BACC,eACD,CAEA,+CAKC,oBAAqB,CAMrB,UACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .table {\n\t/* Give the table widget some air and center it horizontally */\n\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\tmargin: 0.9em auto;\n\tdisplay: table;\n\n\t& table {\n\t\t/* The table cells should have slight borders */\n\t\tborder-collapse: collapse;\n\t\tborder-spacing: 0;\n\n\t\t/* Table width and height are set on the parent <figure>. Make sure the table inside stretches\n\t\tto the full dimensions of the container (https://github.com/ckeditor/ckeditor5/issues/6186). */\n\t\twidth: 100%;\n\t\theight: 100%;\n\n\t\t/* The outer border of the table should be slightly darker than the inner lines.\n\t\tAlso see https://github.com/ckeditor/ckeditor5-table/issues/50. */\n\t\tborder: 1px double hsl(0, 0%, 70%);\n\n\t\t& td,\n\t\t& th {\n\t\t\tmin-width: 2em;\n\t\t\tpadding: .4em;\n\n\t\t\t/* The border is inherited from .ck-editor__nested-editable styles, so theoretically it\'s not necessary here.\n\t\t\tHowever, the border is a content style, so it should use .ck-content (so it works outside the editor).\n\t\t\tHence, the duplication. See https://github.com/ckeditor/ckeditor5/issues/6314 */\n\t\t\tborder: 1px solid hsl(0, 0%, 75%);\n\t\t}\n\n\t\t& th {\n\t\t\tfont-weight: bold;\n\t\t\tbackground: hsla(0, 0%, 0%, 5%);\n\t\t}\n\t}\n}\n\n/* Text alignment of the table header should match the editor settings and override the native browser styling,\nwhen content is available outside the editor. See https://github.com/ckeditor/ckeditor5/issues/6638 */\n.ck-content[dir="rtl"] .table th {\n\ttext-align: right;\n}\n\n.ck-content[dir="ltr"] .table th {\n\ttext-align: left;\n}\n\n.ck-editor__editable .ck-table-bogus-paragraph {\n\t/*\n\t * Use display:inline-block to force Chrome/Safari to limit text mutations to this element.\n\t * See https://github.com/ckeditor/ckeditor5/issues/6062.\n\t */\n\tdisplay: inline-block;\n\n\t/*\n\t * Inline HTML elements nested in the span should always be dimensioned in relation to the whole cell width.\n\t * See https://github.com/ckeditor/ckeditor5/issues/9117.\n\t */\n\twidth: 100%;\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          5737: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row{flex-wrap:wrap}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar:first-of-type{flex-grow:0.57}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar:last-of-type{flex-grow:0.43}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar .ck-button{flex-grow:1}.ck.ck-table-cell-properties-form{width:320px}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__padding-row{align-self:flex-end;padding:0;width:25%}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar{background:none;margin-top:var(--ck-spacing-standard)}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-table/theme/tablecellproperties.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tablecellproperties.css',
                ],
                names: [],
                mappings:
                  'AAOE,6FACC,cAiBD,CAdE,0HAEC,cACD,CAEA,yHAEC,cACD,CAEA,uHACC,WACD,CClBJ,kCACC,WAkBD,CAfE,2FACC,mBAAoB,CACpB,SAAU,CACV,SACD,CAGC,4GACC,eAAgB,CAGhB,qCACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-cell-properties-form {\n\t& .ck-form__row {\n\t\t&.ck-table-cell-properties-form__alignment-row {\n\t\t\tflex-wrap: wrap;\n\n\t\t\t& .ck.ck-toolbar {\n\t\t\t\t&:first-of-type {\n\t\t\t\t\t/* 4 buttons out of 7 (h-alignment + v-alignment) = 0.57 */\n\t\t\t\t\tflex-grow: 0.57;\n\t\t\t\t}\n\n\t\t\t\t&:last-of-type {\n\t\t\t\t\t/* 3 buttons out of 7 (h-alignment + v-alignment) = 0.43 */\n\t\t\t\t\tflex-grow: 0.43;\n\t\t\t\t}\n\n\t\t\t\t& .ck-button {\n\t\t\t\t\tflex-grow: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-cell-properties-form {\n\twidth: 320px;\n\n\t& .ck-form__row {\n\t\t&.ck-table-cell-properties-form__padding-row {\n\t\t\talign-self: flex-end;\n\t\t\tpadding: 0;\n\t\t\twidth: 25%;\n\t\t}\n\n\t\t&.ck-table-cell-properties-form__alignment-row {\n\t\t\t& .ck.ck-toolbar {\n\t\t\t\tbackground: none;\n\n\t\t\t\t/* Compensate for missing input label that would push the margin (toolbar has no inputs). */\n\t\t\t\tmargin-top: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          4777: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              ':root{--ck-color-table-focused-cell-background:rgba(158,201,250,.3)}.ck-widget.table td.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table td.ck-editor__nested-editable:focus,.ck-widget.table th.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table th.ck-editor__nested-editable:focus{background:var(--ck-color-table-focused-cell-background);border-style:none;outline:1px solid var(--ck-color-focus-border);outline-offset:-1px}',
              '',
              {
                version: 3,
                sources: ['webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableediting.css'],
                names: [],
                mappings: 'AAKA,MACC,6DACD,CAKE,8QAGC,wDAAyD,CAKzD,iBAAkB,CAClB,8CAA+C,CAC/C,mBACD',
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-table-focused-cell-background: hsla(212, 90%, 80%, .3);\n}\n\n.ck-widget.table {\n\t& td,\n\t& th {\n\t\t&.ck-editor__nested-editable.ck-editor__nested-editable_focused,\n\t\t&.ck-editor__nested-editable:focus {\n\t\t\t/* A very slight background to highlight the focused cell */\n\t\t\tbackground: var(--ck-color-table-focused-cell-background);\n\n\t\t\t/* Fixes the problem where surrounding cells cover the focused cell's border.\n\t\t\tIt does not fix the problem in all places but the UX is improved.\n\t\t\tSee https://github.com/ckeditor/ckeditor5-table/issues/29. */\n\t\t\tborder-style: none;\n\t\t\toutline: 1px solid var(--ck-color-focus-border);\n\t\t\toutline-offset: -1px; /* progressive enhancement - no IE support */\n\t\t}\n\t}\n}\n",
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          198: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-table-form .ck-form__row.ck-table-form__background-row,.ck.ck-table-form .ck-form__row.ck-table-form__border-row{flex-wrap:wrap}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row{align-items:center;flex-wrap:wrap}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-labeled-field-view{align-items:center;display:flex;flex-direction:column-reverse}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-labeled-field-view .ck.ck-dropdown,.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimension-operator{flex-grow:0}.ck.ck-table-form .ck.ck-labeled-field-view{position:relative}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{bottom:calc(var(--ck-table-properties-error-arrow-size)*-1);left:50%;position:absolute;transform:translate(-50%,100%);z-index:1}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status:after{content:"";left:50%;position:absolute;top:calc(var(--ck-table-properties-error-arrow-size)*-1);transform:translateX(-50%)}:root{--ck-table-properties-error-arrow-size:6px;--ck-table-properties-min-error-width:150px}.ck.ck-table-form .ck-form__row.ck-table-form__border-row .ck-labeled-field-view>.ck-label{font-size:var(--ck-font-size-tiny);text-align:center}.ck.ck-table-form .ck-form__row.ck-table-form__border-row .ck-table-form__border-style,.ck.ck-table-form .ck-form__row.ck-table-form__border-row .ck-table-form__border-width{max-width:80px;min-width:80px;width:80px}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row{padding:0}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimensions-row__height,.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimensions-row__width{margin:0}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimension-operator{align-self:flex-end;display:inline-block;height:var(--ck-ui-component-min-height);line-height:var(--ck-ui-component-min-height);margin:0 var(--ck-spacing-small)}.ck.ck-table-form .ck.ck-labeled-field-view{padding-top:var(--ck-spacing-standard)}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{border-radius:0}.ck-rounded-corners .ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status,.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{background:var(--ck-color-base-error);color:var(--ck-color-base-background);min-width:var(--ck-table-properties-min-error-width);padding:var(--ck-spacing-small) var(--ck-spacing-medium);text-align:center}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status:after{border-color:transparent transparent var(--ck-color-base-error) transparent;border-style:solid;border-width:0 var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size)}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{animation:ck-table-form-labeled-view-status-appear .15s ease both}.ck.ck-table-form .ck.ck-labeled-field-view .ck-input.ck-error:not(:focus)+.ck.ck-labeled-field-view__status{display:none}@keyframes ck-table-form-labeled-view-status-appear{0%{opacity:0}to{opacity:1}}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-table/theme/tableform.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableform.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css',
                ],
                names: [],
                mappings:
                  'AAWE,wHACC,cACD,CAEA,8DAEC,kBAAmB,CADnB,cAgBD,CAbC,qFAGC,kBAAmB,CAFnB,YAAa,CACb,6BAMD,CAEA,sMACC,WACD,CAIF,4CAEC,iBAoBD,CAlBC,8EAGC,2DAAgE,CADhE,QAAS,CADT,iBAAkB,CAGlB,8BAA+B,CAG/B,SAUD,CAPC,oFACC,UAAW,CAGX,QAAS,CAFT,iBAAkB,CAClB,wDAA6D,CAE7D,0BACD,CChDH,MACC,0CAA2C,CAC3C,2CACD,CAMI,2FACC,kCAAmC,CACnC,iBACD,CAGD,8KAIC,cAAe,CADf,cAAe,CADf,UAGD,CAGD,8DACC,SAcD,CAZC,yMAEC,QACD,CAEA,iGACC,mBAAoB,CACpB,oBAAqB,CACrB,wCAAyC,CACzC,6CAA8C,CAC9C,gCACD,CAIF,4CACC,sCAyBD,CAvBC,8ECxCD,eDyDC,CAjBA,mMCpCA,qCDqDA,CAjBA,8EAGC,qCAAsC,CACtC,qCAAsC,CAEtC,oDAAqD,CADrD,wDAAyD,CAEzD,iBAUD,CAPC,oFACC,2EAA4E,CAE5E,kBAAmB,CADnB,kJAED,CAdD,8EAgBC,iEACD,CAGA,6GACC,YACD,CAIF,oDACC,GACC,SACD,CAEA,GACC,SACD,CACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-form {\n\t& .ck-form__row {\n\t\t&.ck-table-form__border-row {\n\t\t\tflex-wrap: wrap;\n\t\t}\n\n\t\t&.ck-table-form__background-row {\n\t\t\tflex-wrap: wrap;\n\t\t}\n\n\t\t&.ck-table-form__dimensions-row {\n\t\t\tflex-wrap: wrap;\n\t\t\talign-items: center;\n\n\t\t\t& .ck-labeled-field-view {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column-reverse;\n\t\t\t\talign-items: center;\n\n\t\t\t\t& .ck.ck-dropdown {\n\t\t\t\t\tflex-grow: 0;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& .ck-table-form__dimension-operator {\n\t\t\t\tflex-grow: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck.ck-labeled-field-view {\n\t\t/* Allow absolute positioning of the status (error) balloons. */\n\t\tposition: relative;\n\n\t\t& .ck.ck-labeled-field-view__status {\n\t\t\tposition: absolute;\n\t\t\tleft: 50%;\n\t\t\tbottom: calc( -1 * var(--ck-table-properties-error-arrow-size) );\n\t\t\ttransform: translate(-50%,100%);\n\n\t\t\t/* Make sure the balloon status stays on top of other form elements. */\n\t\t\tz-index: 1;\n\n\t\t\t/* The arrow pointing towards the field. */\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: calc( -1 * var(--ck-table-properties-error-arrow-size) );\n\t\t\t\tleft: 50%;\n\t\t\t\ttransform: translateX( -50% );\n\t\t\t}\n\t\t}\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_rounded.css";\n\n:root {\n\t--ck-table-properties-error-arrow-size: 6px;\n\t--ck-table-properties-min-error-width: 150px;\n}\n\n.ck.ck-table-form {\n\t& .ck-form__row {\n\t\t&.ck-table-form__border-row {\n\t\t\t& .ck-labeled-field-view {\n\t\t\t\t& > .ck-label {\n\t\t\t\t\tfont-size: var(--ck-font-size-tiny);\n\t\t\t\t\ttext-align: center;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& .ck-table-form__border-style,\n\t\t\t& .ck-table-form__border-width {\n\t\t\t\twidth: 80px;\n\t\t\t\tmin-width: 80px;\n\t\t\t\tmax-width: 80px;\n\t\t\t}\n\t\t}\n\n\t\t&.ck-table-form__dimensions-row {\n\t\t\tpadding: 0;\n\n\t\t\t& .ck-table-form__dimensions-row__width,\n\t\t\t& .ck-table-form__dimensions-row__height {\n\t\t\t\tmargin: 0\n\t\t\t}\n\n\t\t\t& .ck-table-form__dimension-operator {\n\t\t\t\talign-self: flex-end;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\theight: var(--ck-ui-component-min-height);\n\t\t\t\tline-height: var(--ck-ui-component-min-height);\n\t\t\t\tmargin: 0 var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck.ck-labeled-field-view {\n\t\tpadding-top: var(--ck-spacing-standard);\n\n\t\t& .ck.ck-labeled-field-view__status {\n\t\t\t@mixin ck-rounded-corners;\n\n\t\t\tbackground: var(--ck-color-base-error);\n\t\t\tcolor: var(--ck-color-base-background);\n\t\t\tpadding: var(--ck-spacing-small) var(--ck-spacing-medium);\n\t\t\tmin-width: var(--ck-table-properties-min-error-width);\n\t\t\ttext-align: center;\n\n\t\t\t/* The arrow pointing towards the field. */\n\t\t\t&::after {\n\t\t\t\tborder-color: transparent transparent var(--ck-color-base-error) transparent;\n\t\t\t\tborder-width: 0 var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size);\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\n\t\t\tanimation: ck-table-form-labeled-view-status-appear .15s ease both;\n\t\t}\n\n\t\t/* Hide the error balloon when the field is blurred. Makes the experience much more clear. */\n\t\t& .ck-input.ck-error:not(:focus) + .ck.ck-labeled-field-view__status {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n@keyframes ck-table-form-labeled-view-status-appear {\n\t0% {\n\t\topacity: 0;\n\t}\n\n\t100% {\n\t\topacity: 1;\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          9221: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row{align-content:baseline;flex-basis:0;flex-wrap:wrap}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row .ck.ck-toolbar .ck-toolbar__items{flex-wrap:nowrap}.ck.ck-table-properties-form{width:320px}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row{align-self:flex-end;padding:0}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row .ck.ck-toolbar{background:none;margin-top:var(--ck-spacing-standard)}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row .ck.ck-toolbar .ck-toolbar__items>*{width:40px}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-table/theme/tableproperties.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableproperties.css',
                ],
                names: [],
                mappings:
                  'AAOE,mFAGC,sBAAuB,CADvB,YAAa,CADb,cAOD,CAHC,qHACC,gBACD,CCTH,6BACC,WAmBD,CAhBE,mFACC,mBAAoB,CACpB,SAYD,CAVC,kGACC,eAAgB,CAGhB,qCAKD,CAHC,uHACC,UACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-properties-form {\n\t& .ck-form__row {\n\t\t&.ck-table-properties-form__alignment-row {\n\t\t\tflex-wrap: wrap;\n\t\t\tflex-basis: 0;\n\t\t\talign-content: baseline;\n\n\t\t\t& .ck.ck-toolbar .ck-toolbar__items {\n\t\t\t\tflex-wrap: nowrap;\n\t\t\t}\n\t\t}\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-properties-form {\n\twidth: 320px;\n\n\t& .ck-form__row {\n\t\t&.ck-table-properties-form__alignment-row {\n\t\t\talign-self: flex-end;\n\t\t\tpadding: 0;\n\n\t\t\t& .ck.ck-toolbar {\n\t\t\t\tbackground: none;\n\n\t\t\t\t/* Compensate for missing input label that would push the margin (toolbar has no inputs). */\n\t\t\t\tmargin-top: var(--ck-spacing-standard);\n\n\t\t\t\t& .ck-toolbar__items > * {\n\t\t\t\t\twidth: 40px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          5593: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              ':root{--ck-table-selected-cell-background:rgba(158,207,250,.3)}.ck.ck-editor__editable .table table td.ck-editor__editable_selected,.ck.ck-editor__editable .table table th.ck-editor__editable_selected{box-shadow:unset;caret-color:transparent;outline:unset;position:relative}.ck.ck-editor__editable .table table td.ck-editor__editable_selected:after,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:after{background-color:var(--ck-table-selected-cell-background);bottom:0;content:"";left:0;pointer-events:none;position:absolute;right:0;top:0}.ck.ck-editor__editable .table table td.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table td.ck-editor__editable_selected:focus,.ck.ck-editor__editable .table table th.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:focus{background-color:initial}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget{outline:unset}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget>.ck-widget__selection-handle,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget>.ck-widget__selection-handle{display:none}',
              '',
              {
                version: 3,
                sources: ['webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableselection.css'],
                names: [],
                mappings:
                  'AAKA,MACC,wDACD,CAGC,0IAKC,gBAAiB,CAFjB,uBAAwB,CACxB,aAAc,CAFd,iBAiCD,CA3BC,sJAGC,yDAA0D,CAK1D,QAAS,CAPT,UAAW,CAKX,MAAO,CAJP,mBAAoB,CAEpB,iBAAkB,CAGlB,OAAQ,CAFR,KAID,CAEA,wTAEC,wBACD,CAMA,gKACC,aAKD,CAHC,0NACC,YACD',
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-table-selected-cell-background: hsla(208, 90%, 80%, .3);\n}\n\n.ck.ck-editor__editable .table table {\n\t& td.ck-editor__editable_selected,\n\t& th.ck-editor__editable_selected {\n\t\tposition: relative;\n\t\tcaret-color: transparent;\n\t\toutline: unset;\n\t\tbox-shadow: unset;\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/6446 */\n\t\t&:after {\n\t\t\tcontent: '';\n\t\t\tpointer-events: none;\n\t\t\tbackground-color: var(--ck-table-selected-cell-background);\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t}\n\n\t\t& ::selection,\n\t\t&:focus {\n\t\t\tbackground-color: transparent;\n\t\t}\n\n\t\t/*\n\t\t * To reduce the amount of noise, all widgets in the table selection have no outline and no selection handle.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9491.\n\t\t */\n\t\t& .ck-widget {\n\t\t\toutline: unset;\n\n\t\t\t& > .ck-widget__selection-handle {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n",
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          4499: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-button,a.ck.ck-button{align-items:center;display:inline-flex;justify-content:left;position:relative;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{display:none}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{-webkit-appearance:none;border:1px solid transparent;cursor:default;font-size:inherit;line-height:1;min-height:var(--ck-ui-component-min-height);min-width:var(--ck-ui-component-min-height);padding:var(--ck-spacing-tiny);text-align:center;transition:box-shadow .2s ease-in-out,border .2s ease-in-out;vertical-align:middle;white-space:nowrap}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{color:inherit;cursor:inherit;font-size:inherit;font-weight:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{color:inherit}[dir=ltr] .ck.ck-button .ck-button__keystroke,[dir=ltr] a.ck.ck-button .ck-button__keystroke{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-button .ck-button__keystroke,[dir=rtl] a.ck.ck-button .ck-button__keystroke{margin-right:var(--ck-spacing-large)}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{font-weight:700;opacity:.7}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__keystroke,a.ck.ck-button.ck-disabled .ck-button__keystroke{opacity:.3}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(var(--ck-spacing-small)*-1);margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:var(--ck-spacing-small);margin-right:calc(var(--ck-spacing-small)*-1)}.ck.ck-button.ck-button_with-keystroke .ck-button__label,a.ck.ck-button.ck-button_with-keystroke .ck-button__label{flex-grow:1}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{color:var(--ck-color-button-on-color)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/button/button.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/button.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/mixins/_button.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css',
                ],
                names: [],
                mappings:
                  'AAOA,6BAMC,kBAAmB,CADnB,mBAAoB,CAEpB,oBAAqB,CAHrB,iBAAkB,CCFlB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBDkBD,CAdC,iEACC,YACD,CAGC,yGACC,oBACD,CAID,iFACC,sBACD,CEjBD,6BCAC,oDD4ID,CCzIE,6EACC,0DACD,CAEA,+EACC,2DACD,CAID,qDACC,6DACD,CDfD,6BEDC,eF6ID,CA5IA,wIEGE,qCFyIF,CA5IA,6BA6BC,uBAAwB,CANxB,4BAA6B,CAjB7B,cAAe,CAcf,iBAAkB,CAHlB,aAAc,CAJd,4CAA6C,CAD7C,2CAA4C,CAJ5C,8BAA+B,CAC/B,iBAAkB,CAiBlB,4DAA8D,CAnB9D,qBAAsB,CAFtB,kBAuID,CA7GC,oFGhCA,2BAA2B,CCF3B,2CAA8B,CDC9B,YHqCA,CAIC,kJAEC,aACD,CAGD,iEAIC,aAAc,CACd,cAAe,CAHf,iBAAkB,CAClB,mBAAoB,CAMpB,qBASD,CAlBA,qFAYE,eAMF,CAlBA,qFAgBE,gBAEF,CAEA,yEACC,aAYD,CAbA,6FAIE,mCASF,CAbA,6FAQE,oCAKF,CAbA,yEAWC,eAAiB,CACjB,UACD,CAIC,oIIrFD,oDJyFC,CAOA,gLKhGD,kCLkGC,CAEA,iGACC,UACD,CAGD,qEACC,yDAcD,CAXC,2HAEE,4CAA+C,CAC/C,oCAOF,CAVA,2HAQE,mCAAoC,CADpC,6CAGF,CAKA,mHACC,WACD,CAID,yCC/HA,+CDmIA,CChIC,yFACC,qDACD,CAEA,2FACC,sDACD,CAID,iEACC,wDACD,CDgHA,yCAGC,qCACD,CAEA,2DACC,iCACD,CAEA,+DACC,mCACD,CAID,2CC/IC,mDDoJD,CCjJE,2FACC,yDACD,CAEA,6FACC,0DACD,CAID,mEACC,4DACD,CDgID,2CAIC,wCACD,CAEA,uCAEC,eACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-unselectable;\n\n\tposition: relative;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: left;\n\n\t& .ck-button__label {\n\t\tdisplay: none;\n\t}\n\n\t&.ck-button_with-text {\n\t\t& .ck-button__label {\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n\n\t/* Center the icon horizontally in a button without text. */\n\t&:not(.ck-button_with-text)  {\n\t\tjustify-content: center;\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../mixins/_button.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-button-colors --ck-color-button-default;\n\t@mixin ck-rounded-corners;\n\n\twhite-space: nowrap;\n\tcursor: default;\n\tvertical-align: middle;\n\tpadding: var(--ck-spacing-tiny);\n\ttext-align: center;\n\n\t/* A very important piece of styling. Go to variable declaration to learn more. */\n\tmin-width: var(--ck-ui-component-min-height);\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Normalize the height of the line. Removing this will break consistent height\n\tamong text and text-less buttons (with icons). */\n\tline-height: 1;\n\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t/* Avoid flickering when the foucs border shows up. */\n\tborder: 1px solid transparent;\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .2s ease-in-out, border .2s ease-in-out;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/189 */\n\t-webkit-appearance: none;\n\n\t&:active,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t/* Allow icon coloring using the text "color" property. */\n\t& .ck-button__icon {\n\t\t& use,\n\t\t& use * {\n\t\t\tcolor: inherit;\n\t\t}\n\t}\n\n\t& .ck-button__label {\n\t\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\t\tfont-size: inherit;\n\t\tfont-weight: inherit;\n\t\tcolor: inherit;\n\t\tcursor: inherit;\n\n\t\t/* Must be consistent with .ck-icon\'s vertical align. Otherwise, buttons with and\n\t\twithout labels (but with icons) have different sizes in Chrome */\n\t\tvertical-align: middle;\n\n\t\t@mixin ck-dir ltr {\n\t\t\ttext-align: left;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\n\t& .ck-button__keystroke {\n\t\tcolor: inherit;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: var(--ck-spacing-large);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-right: var(--ck-spacing-large);\n\t\t}\n\n\t\tfont-weight: bold;\n\t\topacity: .7;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t&.ck-disabled {\n\t\t&:active,\n\t\t&:focus {\n\t\t\t/* The disabled button should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t\t& .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t& .ck-button__keystroke {\n\t\t\topacity: .3;\n\t\t}\n\t}\n\n\t&.ck-button_with-text {\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-standard);\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-button_with-keystroke {\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__label {\n\t\t\tflex-grow: 1;\n\t\t}\n\t}\n\n\t/* A style of the button which is currently on, e.g. its feature is active. */\n\t&.ck-on {\n\t\t@mixin ck-button-colors --ck-color-button-on;\n\n\t\tcolor: var(--ck-color-button-on-color);\n\t}\n\n\t&.ck-button-save {\n\t\tcolor: var(--ck-color-button-save);\n\t}\n\n\t&.ck-button-cancel {\n\t\tcolor: var(--ck-color-button-cancel);\n\t}\n}\n\n/* A style of the button which handles the primary action. */\n.ck.ck-button-action,\na.ck.ck-button-action {\n\t@mixin ck-button-colors --ck-color-button-action;\n\n\tcolor: var(--ck-color-button-action-text);\n}\n\n.ck.ck-button-bold,\na.ck.ck-button-bold {\n\tfont-weight: bold;\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements a button of given background color.\n *\n * @param {String} $background - Background color of the button.\n * @param {String} $border - Border color of the button.\n */\n@define-mixin ck-button-colors $prefix {\n\tbackground: var($(prefix)-background);\n\n\t&:not(.ck-disabled) {\n\t\t&:hover {\n\t\t\tbackground: var($(prefix)-hover-background);\n\t\t}\n\n\t\t&:active {\n\t\t\tbackground: var($(prefix)-active-background);\n\t\t}\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t&.ck-disabled {\n\t\tbackground: var($(prefix)-disabled-background);\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          9681: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:calc(1.07692em + 1px);--ck-switch-button-translation:calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - 2px);--ck-switch-button-inner-hover-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(var(--ck-spacing-large)*2)}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(var(--ck-spacing-large)*2)}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{background:var(--ck-color-switch-button-off-background);border:1px solid transparent;transition:background .4s ease,box-shadow .2s ease-in-out,outline .2s ease-in-out;width:var(--ck-switch-button-toggle-width)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(var(--ck-border-radius)*.5)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{background:var(--ck-color-switch-button-inner-background);height:var(--ck-switch-button-toggle-inner-size);transition:all .3s ease;width:var(--ck-switch-button-toggle-inner-size)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:var(--ck-switch-button-inner-hover-shadow)}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton:focus{border-color:transparent;box-shadow:none;outline:none}.ck.ck-button.ck-switchbutton:focus .ck-button__toggle{box-shadow:0 0 0 1px var(--ck-color-base-background),0 0 0 5px var(--ck-color-focus-outer-shadow);outline:var(--ck-focus-ring);outline-offset:1px}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var( --ck-switch-button-translation ))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(var( --ck-switch-button-translation )*-1))}.ck.ck-button.ck-switchbutton.ck-on:active,.ck.ck-button.ck-switchbutton:active{background:transparent}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/button/switchbutton.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/switchbutton.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css',
                ],
                names: [],
                mappings:
                  'AASE,4HACC,aACD,CCCF,MAEC,8CAA+C,CAE/C,0DAAgE,CAChE,2HAIC,CACD,0FACD,CAGC,0DAGE,4CAOF,CAVA,0DAQE,2CAEF,CAEA,iDC3BA,eDmEA,CAxCA,yICvBC,qCD+DD,CAxCA,2DAKE,gBAmCF,CAxCA,2DAUE,iBA8BF,CAxCA,iDAkBC,uDAAwD,CAFxD,4BAA6B,CAD7B,iFAAsF,CAEtF,0CAuBD,CApBC,2EC/CD,eD0DC,CAXA,6LC3CA,qCAAsC,CD6CpC,8CASF,CAXA,2EAOC,yDAA0D,CAD1D,gDAAiD,CAIjD,uBAA0B,CAL1B,+CAMD,CAEA,uDACC,6DAKD,CAHC,iFACC,qDACD,CAIF,6DEvEA,kCFyEA,CAGA,oCACC,wBAAyB,CAEzB,eAAgB,CADhB,YAQD,CALC,uDACC,iGAAmG,CAEnG,4BAA6B,CAD7B,kBAED,CAIA,uDACC,sDAkBD,CAhBC,6DACC,4DACD,CAEA,2FAKE,2DAMF,CAXA,2FASE,oEAEF,CAKF,gFACC,sBACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-button.ck-switchbutton {\n\t& .ck-button__toggle {\n\t\tdisplay: block;\n\n\t\t& .ck-button__toggle__inner {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/* Note: To avoid rendering issues (aliasing) but to preserve the responsive nature\nof the component, floating–point numbers have been used which, for the default font size\n(see: --ck-font-size-base), will generate simple integers. */\n:root {\n\t/* 34px at 13px font-size */\n\t--ck-switch-button-toggle-width: 2.6153846154em;\n\t/* 14px at 13px font-size */\n\t--ck-switch-button-toggle-inner-size: calc(1.0769230769em + 1px);\n\t--ck-switch-button-translation: calc(\n\t\tvar(--ck-switch-button-toggle-width) -\n\t\tvar(--ck-switch-button-toggle-inner-size) -\n\t\t2px /* Border */\n\t);\n\t--ck-switch-button-inner-hover-shadow: 0 0 0 5px var(--ck-color-switch-button-inner-shadow);\n}\n\n.ck.ck-button.ck-switchbutton {\n\t& .ck-button__label {\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-right: calc(2 * var(--ck-spacing-large));\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-left: calc(2 * var(--ck-spacing-large));\n\t\t}\n\t}\n\n\t& .ck-button__toggle {\n\t\t@mixin ck-rounded-corners;\n\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Make sure the toggle is always to the right as far as possible. */\n\t\t\tmargin-left: auto;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Make sure the toggle is always to the left as far as possible. */\n\t\t\tmargin-right: auto;\n\t\t}\n\n\t\t/* Apply some smooth transition to the box-shadow and border. */\n\t\t/* Gently animate the background color of the toggle switch */\n\t\ttransition: background 400ms ease, box-shadow .2s ease-in-out, outline .2s ease-in-out;\n\t\tborder: 1px solid transparent;\n\t\twidth: var(--ck-switch-button-toggle-width);\n\t\tbackground: var(--ck-color-switch-button-off-background);\n\n\t\t& .ck-button__toggle__inner {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-radius: calc(.5 * var(--ck-border-radius));\n\t\t\t}\n\n\t\t\twidth: var(--ck-switch-button-toggle-inner-size);\n\t\t\theight: var(--ck-switch-button-toggle-inner-size);\n\t\t\tbackground: var(--ck-color-switch-button-inner-background);\n\n\t\t\t/* Gently animate the inner part of the toggle switch */\n\t\t\ttransition: all 300ms ease;\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground: var(--ck-color-switch-button-off-hover-background);\n\n\t\t\t& .ck-button__toggle__inner {\n\t\t\t\tbox-shadow: var(--ck-switch-button-inner-hover-shadow);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-button__toggle {\n\t\t@mixin ck-disabled;\n\t}\n\n\t/* Overriding default .ck-button:focus styles + an outline around the toogle */\n\t&:focus {\n\t\tborder-color: transparent;\n\t\toutline: none;\n\t\tbox-shadow: none;\n\n\t\t& .ck-button__toggle {\n\t\t\tbox-shadow: 0 0 0 1px var(--ck-color-base-background), 0 0 0 5px var(--ck-color-focus-outer-shadow);\n\t\t\toutline-offset: 1px;\n\t\t\toutline: var(--ck-focus-ring);\n\t\t}\n\t}\n\n\t&.ck-on {\n\t\t& .ck-button__toggle {\n\t\t\tbackground: var(--ck-color-switch-button-on-background);\n\n\t\t\t&:hover {\n\t\t\t\tbackground: var(--ck-color-switch-button-on-hover-background);\n\t\t\t}\n\n\t\t\t& .ck-button__toggle__inner {\n\t\t\t\t/*\n\t\t\t\t* Move the toggle switch to the right. It will be animated.\n\t\t\t\t*/\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\ttransform: translateX( var( --ck-switch-button-translation ) );\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\ttransform: translateX( calc( -1 * var( --ck-switch-button-translation ) ) );\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Regular buttons get a backgound when active. Switch buttons announce that through the switch toggle instead */\n\t&:active, &.ck-on:active {\n\t\tbackground: transparent;\n\t}\n\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          4923: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-color-grid{display:grid}:root{--ck-color-grid-tile-size:24px;--ck-color-color-grid-check-icon:#166fd4}.ck.ck-color-grid{grid-gap:5px;padding:8px}.ck.ck-color-grid__tile{border:0;height:var(--ck-color-grid-tile-size);min-height:var(--ck-color-grid-tile-size);min-width:var(--ck-color-grid-tile-size);padding:0;transition:box-shadow .2s ease;width:var(--ck-color-grid-tile-size)}.ck.ck-color-grid__tile.ck-disabled{cursor:unset;transition:unset}.ck.ck-color-grid__tile.ck-color-table__color-tile_bordered{box-shadow:0 0 0 1px var(--ck-color-base-border)}.ck.ck-color-grid__tile .ck.ck-icon{color:var(--ck-color-color-grid-check-icon);display:none}.ck.ck-color-grid__tile.ck-on{box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-base-text)}.ck.ck-color-grid__tile.ck-on .ck.ck-icon{display:block}.ck.ck-color-grid__tile.ck-on,.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){border:0}.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-focus-border)}.ck.ck-color-grid__label{padding:0 var(--ck-spacing-standard)}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/colorgrid/colorgrid.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/colorgrid/colorgrid.css',
                ],
                names: [],
                mappings:
                  'AAKA,kBACC,YACD,CCAA,MACC,8BAA+B,CAK/B,wCACD,CAEA,kBACC,YAAa,CACb,WACD,CAEA,wBAOC,QAAS,CALT,qCAAsC,CAEtC,yCAA0C,CAD1C,wCAAyC,CAEzC,SAAU,CACV,8BAA+B,CAL/B,oCAyCD,CAjCC,oCACC,YAAa,CACb,gBACD,CAEA,4DACC,gDACD,CAEA,oCAEC,2CAA4C,CAD5C,YAED,CAEA,8BACC,8FAKD,CAHC,0CACC,aACD,CAGD,8HAIC,QACD,CAEA,gGAEC,iGACD,CAGD,yBACC,oCACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-color-grid {\n\tdisplay: grid;\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-color-grid-tile-size: 24px;\n\n\t/* Not using global colors here because these may change but some colors in a pallette\n\t * require special treatment. For instance, this ensures no matter what the UI text color is,\n\t * the check icon will look good on the black color tile. */\n\t--ck-color-color-grid-check-icon: hsl(212, 81%, 46%);\n}\n\n.ck.ck-color-grid {\n\tgrid-gap: 5px;\n\tpadding: 8px;\n}\n\n.ck.ck-color-grid__tile {\n\twidth: var(--ck-color-grid-tile-size);\n\theight: var(--ck-color-grid-tile-size);\n\tmin-width: var(--ck-color-grid-tile-size);\n\tmin-height: var(--ck-color-grid-tile-size);\n\tpadding: 0;\n\ttransition: .2s ease box-shadow;\n\tborder: 0;\n\n\t&.ck-disabled {\n\t\tcursor: unset;\n\t\ttransition: unset;\n\t}\n\n\t&.ck-color-table__color-tile_bordered {\n\t\tbox-shadow: 0 0 0 1px var(--ck-color-base-border);\n\t}\n\n\t& .ck.ck-icon {\n\t\tdisplay: none;\n\t\tcolor: var(--ck-color-color-grid-check-icon);\n\t}\n\n\t&.ck-on {\n\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-base-text);\n\n\t\t& .ck.ck-icon {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t&.ck-on,\n\t&:focus:not( .ck-disabled ),\n\t&:hover:not( .ck-disabled ) {\n\t\t/* Disable the default .ck-button\'s border ring. */\n\t\tborder: 0;\n\t}\n\n\t&:focus:not( .ck-disabled ),\n\t&:hover:not( .ck-disabled ) {\n\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-focus-border);\n\t}\n}\n\n.ck.ck-color-grid__label {\n\tpadding: 0 var(--ck-spacing-standard);\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          3488: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              ':root{--ck-dropdown-max-width:75vw}.ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-dropdown__panel{display:none;max-width:var(--ck-dropdown-max-width);position:absolute;z-index:var(--ck-z-modal)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{bottom:auto;top:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s{left:50%;transform:translateX(-50%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw{left:75%;transform:translateX(-75%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme{left:25%;transform:translateX(-25%)}.ck.ck-toolbar .ck-dropdown__panel{z-index:calc(var(--ck-z-modal) + 1)}:root{--ck-dropdown-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{margin-left:var(--ck-spacing-standard);right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{overflow:hidden;text-overflow:ellipsis;width:7em}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-dropdown__button_label-width_auto .ck-button__label{width:auto}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active{box-shadow:none}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active:focus,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active:focus{box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-dropdown__panel{border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dropdown__panel{background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;box-shadow:var(--ck-drop-shadow),0 0;min-width:100%}.ck.ck-dropdown__panel.ck-dropdown__panel_se{border-top-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_sw{border-top-right-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_ne{border-bottom-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_nw{border-bottom-right-radius:0}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/dropdown.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/dropdown.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css',
                ],
                names: [],
                mappings:
                  'AAKA,MACC,4BACD,CAEA,gBACC,oBAAqB,CACrB,iBA2ED,CAzEC,oCACC,mBAAoB,CACpB,2BACD,CAGA,+CACC,UACD,CAEA,oCACC,YAAa,CAEb,sCAAuC,CAEvC,iBAAkB,CAHlB,yBA4DD,CAvDC,+DACC,oBACD,CAEA,mSAKC,WACD,CAEA,mSAUC,WAAY,CADZ,QAED,CAEA,oHAEC,MACD,CAEA,oHAEC,OACD,CAEA,kHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAQF,mCACC,mCACD,CCpFA,MACC,sDACD,CAEA,gBAEC,iBA2ED,CAzEC,oCACC,mCACD,CAGC,8CAIC,sCAAuC,CAHvC,gCAID,CAIA,8CACC,+BAAgC,CAGhC,oCACD,CAGD,gDC/BA,kCDiCA,CAIE,mFAEC,oCACD,CAIA,mFAEC,qCACD,CAID,iEAEC,eAAgB,CAChB,sBAAuB,CAFvB,SAGD,CAGA,6EC1DD,kCD4DC,CAGA,qDACC,2BAA4B,CAC5B,4BACD,CAEA,sGACC,UACD,CAGA,yHAEC,eAKD,CAHC,qIE7EF,2CF+EE,CAKH,uBGlFC,eH8GD,CA5BA,qFG9EE,qCH0GF,CA5BA,uBAIC,oDAAqD,CACrD,sDAAuD,CACvD,QAAS,CE1FT,oCAA8B,CF6F9B,cAmBD,CAfC,6CACC,wBACD,CAEA,6CACC,yBACD,CAEA,6CACC,2BACD,CAEA,6CACC,4BACD',
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-dropdown-max-width: 75vw;\n}\n\n.ck.ck-dropdown {\n\tdisplay: inline-block;\n\tposition: relative;\n\n\t& .ck-dropdown__arrow {\n\t\tpointer-events: none;\n\t\tz-index: var(--ck-z-default);\n\t}\n\n\t/* Dropdown button should span horizontally, e.g. in vertical toolbars */\n\t& .ck-button.ck-dropdown__button {\n\t\twidth: 100%;\n\t}\n\n\t& .ck-dropdown__panel {\n\t\tdisplay: none;\n\t\tz-index: var(--ck-z-modal);\n\t\tmax-width: var(--ck-dropdown-max-width);\n\n\t\tposition: absolute;\n\n\t\t&.ck-dropdown__panel-visible {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_n,\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_nme {\n\t\t\tbottom: 100%;\n\t\t}\n\n\t\t&.ck-dropdown__panel_se,\n\t\t&.ck-dropdown__panel_sw,\n\t\t&.ck-dropdown__panel_smw,\n\t\t&.ck-dropdown__panel_sme,\n\t\t&.ck-dropdown__panel_s {\n\t\t\t/*\n\t\t\t * Using transform: translate3d( 0, 100%, 0 ) causes blurry dropdown on Chrome 67-78+ on non-retina displays.\n\t\t\t * See https://github.com/ckeditor/ckeditor5/issues/1053.\n\t\t\t */\n\t\t\ttop: 100%;\n\t\t\tbottom: auto;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_se {\n\t\t\tleft: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_sw {\n\t\t\tright: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_s,\n\t\t&.ck-dropdown__panel_n {\n\t\t\t/* Positioning panels relative to the center of the button */\n\t\t\tleft: 50%;\n\t\t\ttransform: translateX(-50%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_smw {\n\t\t\t/* Positioning panels relative to the middle-west of the button */\n\t\t\tleft: 75%;\n\t\t\ttransform: translateX(-75%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nme,\n\t\t&.ck-dropdown__panel_sme {\n\t\t\t/* Positioning panels relative to the middle-east of the button */\n\t\t\tleft: 25%;\n\t\t\ttransform: translateX(-25%);\n\t\t}\n\t}\n}\n\n/*\n * Toolbar dropdown panels should be always above the UI (eg. other dropdown panels) from the editor's content.\n * See https://github.com/ckeditor/ckeditor5/issues/7874\n */\n.ck.ck-toolbar .ck-dropdown__panel {\n\tz-index: calc( var(--ck-z-modal) + 1 );\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-dropdown-arrow-size: calc(0.5 * var(--ck-icon-size));\n}\n\n.ck.ck-dropdown {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-dropdown__arrow {\n\t\twidth: var(--ck-dropdown-arrow-size);\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-dropdown__arrow {\n\t\t\tright: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-dropdown__arrow {\n\t\t\tleft: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-dropdown__arrow {\n\t\t@mixin ck-disabled;\n\t}\n\n\t& .ck-button.ck-dropdown__button {\n\t\t@mixin ck-dir ltr {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-right: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t/* #23 */\n\t\t& .ck-button__label {\n\t\t\twidth: 7em;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t\t&.ck-disabled .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/816 */\n\t\t&.ck-on {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t&.ck-dropdown__button_label-width_auto .ck-button__label {\n\t\t\twidth: auto;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/8699 */\n\t\t&.ck-off:active,\n\t\t&.ck-on:active {\n\t\t\tbox-shadow: none;\n\t\t\t\n\t\t\t&:focus {\n\t\t\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-dropdown__panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tbackground: var(--ck-color-dropdown-panel-background);\n\tborder: 1px solid var(--ck-color-dropdown-panel-border);\n\tbottom: 0;\n\n\t/* Make sure the panel is at least as wide as the drop-down\'s button. */\n\tmin-width: 100%;\n\n\t/* Disabled corner border radius to be consistent with the .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-dropdown__panel_se {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_sw {\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_ne {\n\t\tborder-bottom-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_nw {\n\t\tborder-bottom-right-radius: 0;\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          6875: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-dropdown .ck-dropdown__panel .ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list,.ck.ck-dropdown .ck-dropdown__panel .ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/listdropdown.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css',
                ],
                names: [],
                mappings:
                  'AAOA,6CCIC,eDqBD,CAzBA,iICQE,qCAAsC,CDJtC,wBAqBF,CAfE,mFCND,eDYC,CANA,6MCFA,qCAAsC,CDKpC,2BAA4B,CAC5B,4BAA6B,CAF7B,wBAIF,CAEA,kFCdD,eDmBC,CALA,2MCVA,qCAAsC,CDYpC,wBAAyB,CACzB,yBAEF',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-dropdown .ck-dropdown__panel .ck-list {\n\t/* Disabled radius of top-left border to be consistent with .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t/* Make sure the button belonging to the first/last child of the list goes well with the\n\tborder radius of the entire panel. */\n\t& .ck-list__item {\n\t\t&:first-child .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\n\t\t&:last-child .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-top-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          66: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-splitbutton{font-size:inherit}.ck.ck-splitbutton .ck-splitbutton__action:focus{z-index:calc(var(--ck-z-default) + 1)}:root{--ck-color-split-button-hover-background:#ebebeb;--ck-color-split-button-hover-border:#b3b3b3}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-bottom-right-radius:unset;border-top-right-radius:unset}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-bottom-left-radius:unset;border-top-left-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow{min-width:unset}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-bottom-left-radius:unset;border-top-left-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-bottom-right-radius:unset;border-top-right-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow svg{width:var(--ck-dropdown-arrow-size)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover),.ck.ck-splitbutton:hover>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover){background:var(--ck-color-split-button-hover-background)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{background-color:var(--ck-color-split-button-hover-border);content:"";height:100%;position:absolute;width:1px}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{left:-1px}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{right:-1px}.ck.ck-splitbutton.ck-splitbutton_open{border-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__action{border-bottom-left-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__arrow{border-bottom-right-radius:0}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/splitbutton.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/splitbutton.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css',
                ],
                names: [],
                mappings:
                  'AAKA,mBAEC,iBAKD,CAHC,iDACC,qCACD,CCJD,MACC,gDAAyD,CACzD,4CACD,CAMC,oIAKE,gCAAiC,CADjC,6BASF,CAbA,oIAWE,+BAAgC,CADhC,4BAGF,CAEA,0CAGC,eAiBD,CApBA,oDAQE,+BAAgC,CADhC,4BAaF,CApBA,oDAcE,gCAAiC,CADjC,6BAOF,CAHC,8CACC,mCACD,CASA,0KACC,wDACD,CAIA,8JAKC,0DAA2D,CAJ3D,UAAW,CAGX,WAAY,CAFZ,iBAAkB,CAClB,SAGD,CAGC,kLACC,SACD,CAIA,kLACC,UACD,CAMF,uCC7EA,eDuFA,CAVA,qHCzEC,qCDmFD,CARE,qKACC,2BACD,CAEA,mKACC,4BACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-splitbutton {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-splitbutton__action:focus {\n\t\tz-index: calc(var(--ck-z-default) + 1);\n\t}\n}\n\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-color-split-button-hover-background: hsl(0, 0%, 92%);\n\t--ck-color-split-button-hover-border: hsl(0, 0%, 70%);\n}\n\n.ck.ck-splitbutton {\n\t/*\n\t * Note: ck-rounded and ck-dir mixins don\'t go together (because they both use @nest).\n\t */\n\t&:hover > .ck-splitbutton__action,\n\t&.ck-splitbutton_open > .ck-splitbutton__action {\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the action button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the action button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\t}\n\n\t& > .ck-splitbutton__arrow {\n\t\t/* It\'s a text-less button and since the icon is positioned absolutely in such situation,\n\t\tit must get some arbitrary min-width. */\n\t\tmin-width: unset;\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the arrow button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the arrow button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t& svg {\n\t\t\twidth: var(--ck-dropdown-arrow-size);\n\t\t}\n\t}\n\n\t/* When the split button is "open" (the arrow is on) or being hovered, it should get some styling\n\tas a whole. The background of both buttons should stand out and there should be a visual\n\tseparation between both buttons. */\n\t&.ck-splitbutton_open,\n\t&:hover {\n\t\t/* When the split button hovered as a whole, not as individual buttons. */\n\t\t& > .ck-button:not(.ck-on):not(.ck-disabled):not(:hover) {\n\t\t\tbackground: var(--ck-color-split-button-hover-background);\n\t\t}\n\n\t\t/* Splitbutton separator needs to be set with the ::after pseudoselector\n\t\tto display properly the borders on focus */\n\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\tcontent: \'\';\n\t\t\tposition: absolute;\n\t\t\twidth: 1px;\n\t\t\theight: 100%;\n\t\t\tbackground-color: var(--ck-color-split-button-hover-border);\n\t\t}\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\t\tleft: -1px;\n\t\t\t}\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\t\tright: -1px;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Don\'t round the bottom left and right corners of the buttons when "open"\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-splitbutton_open {\n\t\t@mixin ck-rounded-corners {\n\t\t\t& > .ck-splitbutton__action {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t}\n\n\t\t\t& > .ck-splitbutton__arrow {\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          5075: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              ':root{--ck-toolbar-dropdown-max-width:60vw}.ck.ck-toolbar-dropdown>.ck-dropdown__panel{max-width:var(--ck-toolbar-dropdown-max-width);width:max-content}.ck.ck-toolbar-dropdown>.ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/toolbardropdown.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/toolbardropdown.css',
                ],
                names: [],
                mappings: 'AAKA,MACC,oCACD,CAEA,4CAGC,8CAA+C,CAD/C,iBAQD,CAJE,6DACC,qCACD,CCZF,oCACC,QACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-toolbar-dropdown-max-width: 60vw;\n}\n\n.ck.ck-toolbar-dropdown > .ck-dropdown__panel {\n\t/* https://github.com/ckeditor/ckeditor5/issues/5586 */\n\twidth: max-content;\n\tmax-width: var(--ck-toolbar-dropdown-max-width);\n\n\t& .ck-button {\n\t\t&:focus {\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-toolbar-dropdown .ck-toolbar {\n\tborder: 0;\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          4547: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              ':root{--ck-color-editable-blur-selection:#d9d9d9}.ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable.ck-rounded-corners:not(.ck-editor__nested-editable){border-radius:var(--ck-border-radius)}.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable){border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}.ck.ck-editor__editable_inline{border:1px solid transparent;overflow:auto;padding:0 var(--ck-spacing-standard)}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-editor__editable_inline.ck-blurred ::selection{background:var(--ck-color-editable-blur-selection)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-base-foreground)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-base-foreground)}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/editorui/editorui.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css',
                ],
                names: [],
                mappings:
                  'AAWA,MACC,0CACD,CAEA,yDCJC,eDWD,CAPA,yJCAE,qCDOF,CAJC,oEEPA,2BAA2B,CCF3B,qCAA8B,CDC9B,YFWA,CAGD,+BAGC,4BAA6B,CAF7B,aAAc,CACd,oCA6BD,CA1BC,wCACC,eACD,CAEA,wCACC,gBACD,CAGA,4CACC,kCACD,CAGA,2CAKC,qCACD,CAGA,sDACC,kDACD,CAKA,gEACC,mDACD,CAIA,gEACC,gDACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_focus.css";\n@import "../../mixins/_button.css";\n\n:root {\n\t--ck-color-editable-blur-selection: hsl(0, 0%, 85%);\n}\n\n.ck.ck-editor__editable:not(.ck-editor__nested-editable) {\n\t@mixin ck-rounded-corners;\n\n\t&.ck-focused {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\t}\n}\n\n.ck.ck-editor__editable_inline {\n\toverflow: auto;\n\tpadding: 0 var(--ck-spacing-standard);\n\tborder: 1px solid transparent;\n\n\t&[dir="ltr"] {\n\t\ttext-align: left;\n\t}\n\n\t&[dir="rtl"] {\n\t\ttext-align: right;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/116 */\n\t& > *:first-child {\n\t\tmargin-top: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/847 */\n\t& > *:last-child {\n\t\t/*\n\t\t * This value should match with the default margins of the block elements (like .media or .image)\n\t\t * to avoid a content jumping when the fake selection container shows up (See https://github.com/ckeditor/ckeditor5/issues/9825).\n\t\t */\n\t\tmargin-bottom: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/6517 */\n\t&.ck-blurred ::selection {\n\t\tbackground: var(--ck-color-editable-blur-selection);\n\t}\n}\n\n/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/111 */\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_n"] {\n\t&::after {\n\t\tborder-bottom-color: var(--ck-color-base-foreground);\n\t}\n}\n\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_s"] {\n\t&::after {\n\t\tborder-top-color: var(--ck-color-base-foreground);\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          5523: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-form__header{align-items:center;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between}:root{--ck-form-header-height:38px}.ck.ck-form__header{border-bottom:1px solid var(--ck-color-base-border);height:var(--ck-form-header-height);line-height:var(--ck-form-header-height);padding:var(--ck-spacing-small) var(--ck-spacing-large)}.ck.ck-form__header .ck-form__header__label{font-weight:700}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/formheader/formheader.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/formheader/formheader.css',
                ],
                names: [],
                mappings:
                  'AAKA,oBAIC,kBAAmB,CAHnB,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CAEjB,6BACD,CCNA,MACC,4BACD,CAEA,oBAIC,mDAAoD,CAFpD,mCAAoC,CACpC,wCAAyC,CAFzC,uDAQD,CAHC,4CACC,eACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form__header {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-form-header-height: 38px;\n}\n\n.ck.ck-form__header {\n\tpadding: var(--ck-spacing-small) var(--ck-spacing-large);\n\theight: var(--ck-form-header-height);\n\tline-height: var(--ck-form-header-height);\n\tborder-bottom: 1px solid var(--ck-color-base-border);\n\n\t& .ck-form__header__label {\n\t\tfont-weight: bold;\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          1174: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{font-size:.8333350694em;height:var(--ck-icon-size);width:var(--ck-icon-size);will-change:transform}.ck.ck-icon,.ck.ck-icon *{color:inherit;cursor:inherit}.ck.ck-icon :not([fill]){fill:currentColor}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/icon/icon.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/icon/icon.css',
                ],
                names: [],
                mappings:
                  'AAKA,YACC,qBACD,CCFA,MACC,0EACD,CAEA,YAKC,uBAAwB,CAHxB,0BAA2B,CAD3B,yBAA0B,CAY1B,qBAcD,CAZC,0BARA,aAAc,CAGd,cAgBA,CAJC,yBAEC,iBACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-icon {\n\tvertical-align: middle;\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-icon-size: calc(var(--ck-line-height-base) * var(--ck-font-size-normal));\n}\n\n.ck.ck-icon {\n\twidth: var(--ck-icon-size);\n\theight: var(--ck-icon-size);\n\n\t/* Multiplied by the height of the line in "px" should give SVG "viewport" dimensions */\n\tfont-size: .8333350694em;\n\n\tcolor: inherit;\n\n\t/* Inherit cursor style (#5). */\n\tcursor: inherit;\n\n\t/* This will prevent blurry icons on Firefox. See #340. */\n\twill-change: transform;\n\n\t& * {\n\t\t/* Inherit cursor style (#5). */\n\t\tcursor: inherit;\n\n\t\t/* Allows dynamic coloring of the icons. */\n\t\tcolor: inherit;\n\n\t\t&:not([fill]) {\n\t\t\t/* Needed by FF. */\n\t\t\tfill: currentColor;\n\t\t}\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          6985: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              ':root{--ck-input-width:18em;--ck-input-text-width:var(--ck-input-width)}.ck.ck-input{border-radius:0}.ck-rounded-corners .ck.ck-input,.ck.ck-input.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input{background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);min-height:var(--ck-ui-component-min-height);min-width:var(--ck-input-width);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);transition:box-shadow .1s ease-in-out,border .1s ease-in-out}.ck.ck-input:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-input[readonly]{background:var(--ck-color-input-disabled-background);border:1px solid var(--ck-color-input-disabled-border);color:var(--ck-color-input-disabled-text)}.ck.ck-input[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-input.ck-error{animation:ck-input-shake .3s ease both;border-color:var(--ck-color-input-error-border)}.ck.ck-input.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),0 0}@keyframes ck-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/input/input.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css',
                ],
                names: [],
                mappings:
                  'AASA,MACC,qBAAsB,CAGtB,2CACD,CAEA,aCLC,eD2CD,CAtCA,iECDE,qCDuCF,CAtCA,aAGC,2CAA4C,CAC5C,6CAA8C,CAK9C,4CAA6C,CAH7C,+BAAgC,CADhC,6DAA8D,CAO9D,4DA0BD,CAxBC,mBEnBA,2BAA2B,CCF3B,2CAA8B,CDC9B,YFuBA,CAEA,uBAEC,oDAAqD,CADrD,sDAAuD,CAEvD,yCAMD,CAJC,6BG/BD,oDHkCC,CAGD,sBAEC,sCAAuC,CADvC,+CAMD,CAHC,4BGzCD,iDH2CC,CAIF,0BACC,IACC,0BACD,CAEA,IACC,yBACD,CAEA,IACC,0BACD,CAEA,IACC,yBACD,CACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-input-width: 18em;\n\n\t/* Backward compatibility. */\n\t--ck-input-text-width: var(--ck-input-width);\n}\n\n.ck.ck-input {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-input-background);\n\tborder: 1px solid var(--ck-color-input-border);\n\tpadding: var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);\n\tmin-width: var(--ck-input-width);\n\n\t/* This is important to stay of the same height as surrounding buttons */\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .1s ease-in-out, border .1s ease-in-out;\n\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t&[readonly] {\n\t\tborder: 1px solid var(--ck-color-input-disabled-border);\n\t\tbackground: var(--ck-color-input-disabled-background);\n\t\tcolor: var(--ck-color-input-disabled-text);\n\n\t\t&:focus {\n\t\t\t/* The read-only input should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\tborder-color: var(--ck-color-input-error-border);\n\t\tanimation: ck-input-shake .3s ease both;\n\n\t\t&:focus {\n\t\t\t@mixin ck-box-shadow var(--ck-focus-error-outer-shadow);\n\t\t}\n\t}\n}\n\n@keyframes ck-input-shake {\n\t20% {\n\t\ttransform: translateX(-2px);\n\t}\n\n\t40% {\n\t\ttransform: translateX(2px);\n\t}\n\n\t60% {\n\t\ttransform: translateX(-1px);\n\t}\n\n\t80% {\n\t\ttransform: translateX(1px);\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          2751: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/label/label.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/label/label.css',
                ],
                names: [],
                mappings: 'AAKA,aACC,aACD,CAEA,mBACC,YACD,CCNA,aACC,eACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tdisplay: block;\n}\n\n.ck.ck-voice-label {\n\tdisplay: none;\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tfont-weight: bold;\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          8111: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{display:flex;position:relative}.ck.ck-labeled-field-view .ck.ck-label{display:block;position:absolute}:root{--ck-labeled-field-view-transition:.1s cubic-bezier(0,0,0.24,0.95);--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-spacing-medium);--ck-color-labeled-field-label-background:var(--ck-color-base-background)}.ck.ck-labeled-field-view{border-radius:0}.ck-rounded-corners .ck.ck-labeled-field-view,.ck.ck-labeled-field-view.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{width:100%}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{top:0}[dir=ltr] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{left:0}[dir=rtl] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{right:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{background:var(--ck-color-labeled-field-label-background);font-weight:400;line-height:normal;max-width:100%;overflow:hidden;padding:0 calc(var(--ck-font-size-tiny)*.5);pointer-events:none;text-overflow:ellipsis;transform:translate(var(--ck-spacing-medium),-6px) scale(.75);transform-origin:0 0;transition:transform var(--ck-labeled-field-view-transition),padding var(--ck-labeled-field-view-transition),background var(--ck-labeled-field-view-transition)}.ck.ck-labeled-field-view.ck-error .ck-input:not([readonly])+.ck.ck-label,.ck.ck-labeled-field-view.ck-error>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view .ck-labeled-field-view__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-field-view .ck-labeled-field-view__status.ck-labeled-field-view__status_error{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-input-disabled-text)}[dir=ltr] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=ltr] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(var(--ck-spacing-medium),calc(var(--ck-font-size-base)*.6)) scale(1)}[dir=rtl] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=rtl] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(calc(var(--ck-spacing-medium)*-1),calc(var(--ck-font-size-base)*.6)) scale(1)}.ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{background:transparent;max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width));padding:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck.ck-button{background:transparent}.ck.ck-labeled-field-view.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck-button>.ck-button__label{opacity:0}.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown+.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard))}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/labeledfield/labeledfieldview.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/labeledfield/labeledfieldview.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css',
                ],
                names: [],
                mappings:
                  'AAMC,mEACC,YAAa,CACb,iBACD,CAEA,uCACC,aAAc,CACd,iBACD,CCND,MACC,kEAAsE,CACtE,gFAAiF,CACjF,yEACD,CAEA,0BCHC,eD4GD,CAzGA,2FCCE,qCDwGF,CAtGC,mEACC,UAmCD,CAjCC,gFACC,KA+BD,CAhCA,0FAIE,MA4BF,CAhCA,0FAQE,OAwBF,CAhCA,gFAiBC,yDAA0D,CAG1D,eAAmB,CADnB,kBAAoB,CAOpB,cAAe,CAFf,eAAgB,CANhB,2CAA8C,CAP9C,mBAAoB,CAYpB,sBAAuB,CARvB,6DAA+D,CAH/D,oBAAqB,CAgBrB,+JAID,CAQA,mKACC,gCACD,CAGD,yDACC,mCAAoC,CACpC,kCAAmC,CAInC,kBAKD,CAHC,6FACC,gCACD,CAID,4OAEC,yCACD,CAIA,oUAGE,wFAYF,CAfA,oUAOE,iGAQF,CAfA,gTAaC,sBAAuB,CAFvB,iEAAkE,CAGlE,SACD,CAKA,8FACC,sBACD,CAGA,yIACC,SACD,CAGA,kMACC,8HACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-labeled-field-view {\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t& .ck.ck-label {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-labeled-field-view-transition: .1s cubic-bezier(0, 0, 0.24, 0.95);\n\t--ck-labeled-field-empty-unfocused-max-width: 100% - 2 * var(--ck-spacing-medium);\n\t--ck-color-labeled-field-label-background: var(--ck-color-base-background);\n}\n\n.ck.ck-labeled-field-view {\n\t@mixin ck-rounded-corners;\n\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\twidth: 100%;\n\n\t\t& > .ck.ck-label {\n\t\t\ttop: 0px;\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tleft: 0px;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tright: 0px;\n\t\t\t}\n\n\t\t\tpointer-events: none;\n\t\t\ttransform-origin: 0 0;\n\n\t\t\t/* By default, display the label scaled down above the field. */\n\t\t\ttransform: translate(var(--ck-spacing-medium), -6px) scale(.75);\n\n\t\t\tbackground: var(--ck-color-labeled-field-label-background);\n\t\t\tpadding: 0 calc(.5 * var(--ck-font-size-tiny));\n\t\t\tline-height: initial;\n\t\t\tfont-weight: normal;\n\n\t\t\t/* Prevent overflow when the label is longer than the input */\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\n\t\t\tmax-width: 100%;\n\n\t\t\ttransition:\n\t\t\t\ttransform var(--ck-labeled-field-view-transition),\n\t\t\t\tpadding var(--ck-labeled-field-view-transition),\n\t\t\t\tbackground var(--ck-labeled-field-view-transition);\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\t& > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\n\t\t& .ck-input:not([readonly]) + .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t& .ck-labeled-field-view__status {\n\t\tfont-size: var(--ck-font-size-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\n\t\t/* Let the info wrap to the next line to avoid stretching the layout horizontally.\n\t\tThe status could be very long. */\n\t\twhite-space: normal;\n\n\t\t&.ck-labeled-field-view__status_error {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t/* Disabled fields and fields that have no focus should fade out. */\n\t&.ck-disabled > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\tcolor: var(--ck-color-input-disabled-text);\n\t}\n\n\t/* Fields that are disabled or not focused and without a placeholder should have full-sized labels. */\n\t/* stylelint-disable-next-line no-descending-specificity */\n\t&.ck-disabled.ck-labeled-field-view_empty > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t@mixin ck-dir ltr {\n\t\t\ttransform: translate(var(--ck-spacing-medium), calc(0.6 * var(--ck-font-size-base))) scale(1);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttransform: translate(calc(-1 * var(--ck-spacing-medium)), calc(0.6 * var(--ck-font-size-base))) scale(1);\n\t\t}\n\n\t\t/* Compensate for the default translate position. */\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width));\n\n\t\tbackground: transparent;\n\t\tpadding: 0;\n\t}\n\n\t/*------ DropdownView integration ----------------------------------------------------------------------------------- */\n\n\t/* Make sure dropdown\' background color in any of dropdown\'s state does not collide with labeled field. */\n\t& > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck.ck-button {\n\t\tbackground: transparent;\n\t}\n\n\t/* When the dropdown is "empty", the labeled field label replaces its label. */\n\t&.ck-labeled-field-view_empty > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck-button > .ck-button__label {\n\t\topacity: 0;\n\t}\n\n\t/* Make sure the label of the empty, unfocused input does not cover the dropdown arrow. */\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown + .ck-label {\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard));\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          1162: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-list{display:flex;flex-direction:column;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{background:var(--ck-color-list-background);list-style-type:none}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item .ck-button{border-radius:0;min-height:unset;padding:calc(var(--ck-line-height-base)*.2*var(--ck-font-size-base)) calc(var(--ck-line-height-base)*.4*var(--ck-font-size-base));text-align:left;width:100%}.ck.ck-list__item .ck-button .ck-button__label{line-height:calc(var(--ck-line-height-base)*1.2*var(--ck-font-size-base))}.ck.ck-list__item .ck-button:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item .ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item .ck-button.ck-on:focus:not(.ck-switchbutton):not(.ck-disabled){border-color:var(--ck-color-base-background)}.ck.ck-list__item .ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item .ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item .ck-switchbutton.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck.ck-list__separator{background:var(--ck-color-base-border);height:1px;width:100%}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/list/list.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/list/list.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css',
                ],
                names: [],
                mappings:
                  'AAOA,YAGC,YAAa,CACb,qBAAsB,CCFtB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBDaD,CAZC,2DAEC,aACD,CAKA,kCACC,iBAAkB,CAClB,2BACD,CEfD,YCEC,eDGD,CALA,+DCME,qCDDF,CALA,YAIC,0CAA2C,CAD3C,oBAED,CAEA,kBACC,cAAe,CACf,cA2DD,CAzDC,6BAIC,eAAgB,CAHhB,gBAAiB,CAQjB,iIAEiE,CARjE,eAAgB,CADhB,UAwCD,CA7BC,+CAEC,yEACD,CAEA,oCACC,eACD,CAEA,mCACC,oDAAqD,CACrD,yCAaD,CAXC,0CACC,eACD,CAEA,2DACC,0DACD,CAEA,iFACC,4CACD,CAGD,qDACC,uDACD,CAMA,yCACC,0CAA2C,CAC3C,aAMD,CAJC,iEACC,uDAAwD,CACxD,aACD,CAKH,uBAGC,sCAAuC,CAFvC,UAAW,CACX,UAED',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-list {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t& .ck-list__item,\n\t& .ck-list__separator {\n\t\tdisplay: block;\n\t}\n\n\t/* Make sure that whatever child of the list item gets focus, it remains on the\n\ttop. Thanks to that, styles like box-shadow, outline, etc. are not masked by\n\tadjacent list items. */\n\t& .ck-list__item > *:focus {\n\t\tposition: relative;\n\t\tz-index: var(--ck-z-default);\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-list {\n\t@mixin ck-rounded-corners;\n\n\tlist-style-type: none;\n\tbackground: var(--ck-color-list-background);\n}\n\n.ck.ck-list__item {\n\tcursor: default;\n\tmin-width: 12em;\n\n\t& .ck-button {\n\t\tmin-height: unset;\n\t\twidth: 100%;\n\t\ttext-align: left;\n\t\tborder-radius: 0;\n\n\t\t/* List items should have the same height. Use absolute units to make sure it is so\n\t\t   because e.g. different heading styles may have different height\n\t\t   https://github.com/ckeditor/ckeditor5-heading/issues/63 */\n\t\tpadding:\n\t\t\tcalc(.2 * var(--ck-line-height-base) * var(--ck-font-size-base))\n\t\t\tcalc(.4 * var(--ck-line-height-base) * var(--ck-font-size-base));\n\n\t\t& .ck-button__label {\n\t\t\t/* https://github.com/ckeditor/ckeditor5-heading/issues/63 */\n\t\t\tline-height: calc(1.2 * var(--ck-line-height-base) * var(--ck-font-size-base));\n\t\t}\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-button-on-background);\n\t\t\tcolor: var(--ck-color-list-button-on-text);\n\n\t\t\t&:active {\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-on-background-focus);\n\t\t\t}\n\n\t\t\t&:focus:not(.ck-switchbutton):not(.ck-disabled) {\n\t\t\t\tborder-color: var(--ck-color-base-background);\n\t\t\t}\n\t\t}\n\n\t\t&:hover:not(.ck-disabled) {\n\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t}\n\t}\n\n\t/* It\'s unnecessary to change the background/text of a switch toggle; it has different ways\n\tof conveying its state (like the switcher) */\n\t& .ck-switchbutton {\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-background);\n\t\t\tcolor: inherit;\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t\t\tcolor: inherit;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-list__separator {\n\theight: 1px;\n\twidth: 100%;\n\tbackground: var(--ck-color-base-border);\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          8245: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-modal)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-border-width:1px;--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px;--ck-balloon-arrow-drop-shadow:0 2px 2px var(--ck-color-shadow-drop)}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{background:var(--ck-color-panel-background);border:var(--ck-balloon-border-width) solid var(--ck-color-panel-border);box-shadow:var(--ck-drop-shadow),0 0;min-height:15px}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{border-style:solid;height:0;width:0}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-width:0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width)}.ck.ck-balloon-panel[class*=arrow_n]:before{border-color:transparent transparent var(--ck-color-panel-border) transparent;margin-top:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_n]:after{border-color:transparent transparent var(--ck-color-panel-background) transparent;margin-top:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-width:var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-color:var(--ck-color-panel-border) transparent transparent;filter:drop-shadow(var(--ck-balloon-arrow-drop-shadow));margin-bottom:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_s]:after{border-color:var(--ck-color-panel-background) transparent transparent transparent;margin-bottom:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_e]:after,.ck.ck-balloon-panel[class*=arrow_e]:before{border-width:var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_e]:before{border-color:transparent transparent transparent var(--ck-color-panel-border);margin-right:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_e]:after{border-color:transparent transparent transparent var(--ck-color-panel-background);margin-right:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_w]:after,.ck.ck-balloon-panel[class*=arrow_w]:before{border-width:var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0}.ck.ck-balloon-panel[class*=arrow_w]:before{border-color:transparent var(--ck-color-panel-border) transparent transparent;margin-left:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_w]:after{border-color:transparent var(--ck-color-panel-background) transparent transparent;margin-left:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);right:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);margin-right:calc(var(--ck-balloon-arrow-half-width)*2);right:25%}.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:before{margin-right:calc(var(--ck-balloon-arrow-half-width)*2);right:25%;top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_e:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_e:before{margin-top:calc(var(--ck-balloon-arrow-half-width)*-1);right:calc(var(--ck-balloon-arrow-height)*-1);top:50%}.ck.ck-balloon-panel.ck-balloon-panel_arrow_w:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_w:before{left:calc(var(--ck-balloon-arrow-height)*-1);margin-top:calc(var(--ck-balloon-arrow-half-width)*-1);top:50%}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonpanel.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonpanel.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css',
                ],
                names: [],
                mappings:
                  'AAKA,MAEC,8DACD,CAEA,qBACC,YAAa,CACb,iBAAkB,CAElB,yBAyCD,CAtCE,+GAEC,UAAW,CACX,iBACD,CAEA,wDACC,6CACD,CAEA,uDACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAGD,8CACC,aACD,CC9CD,MACC,6BAA8B,CAC9B,6BAA8B,CAC9B,8BAA+B,CAC/B,iCAAkC,CAClC,oEACD,CAEA,qBCLC,eDmMD,CA9LA,iFCDE,qCD+LF,CA9LA,qBAMC,2CAA4C,CAC5C,wEAAyE,CEdzE,oCAA8B,CFW9B,eA0LD,CApLE,+GAIC,kBAAmB,CADnB,QAAS,CADT,OAGD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,kDACD,CAEA,2CACC,iFAAkF,CAClF,gFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,iEAAkE,CAClE,uDAAwD,CACxD,qDACD,CAEA,2CACC,iFAAkF,CAClF,mFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,oDACD,CAEA,2CACC,iFAAkF,CAClF,kFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,mDACD,CAEA,2CACC,iFAAkF,CAClF,iFACD,CAIA,yGAEC,QAAS,CACT,uDAA0D,CAC1D,2CACD,CAIA,2GAEC,+CAAkD,CAClD,2CACD,CAIA,2GAEC,gDAAmD,CACnD,2CACD,CAIA,yGAIC,8CAAiD,CAFjD,QAAS,CACT,uDAED,CAIA,2GAGC,8CAAiD,CADjD,+CAED,CAIA,2GAGC,8CAAiD,CADjD,gDAED,CAIA,6GAIC,8CAAiD,CADjD,uDAA0D,CAD1D,SAGD,CAIA,6GAIC,8CAAiD,CAFjD,QAAS,CACT,sDAED,CAIA,6GAGC,uDAA0D,CAD1D,SAAU,CAEV,2CACD,CAIA,6GAEC,QAAS,CACT,sDAAyD,CACzD,2CACD,CAIA,yGAGC,sDAAyD,CADzD,6CAAgD,CAEhD,OACD,CAIA,yGAEC,4CAA+C,CAC/C,sDAAyD,CACzD,OACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* Make sure the balloon arrow does not float over its children. */\n\t--ck-balloon-panel-arrow-z-index: calc(var(--ck-z-default) - 3);\n}\n\n.ck.ck-balloon-panel {\n\tdisplay: none;\n\tposition: absolute;\n\n\tz-index: var(--ck-z-modal);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tposition: absolute;\n\t\t}\n\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_visible {\n\t\tdisplay: block;\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-border-width: 1px;\n\t--ck-balloon-arrow-offset: 2px;\n\t--ck-balloon-arrow-height: 10px;\n\t--ck-balloon-arrow-half-width: 8px;\n\t--ck-balloon-arrow-drop-shadow: 0 2px 2px var(--ck-color-shadow-drop);\n}\n\n.ck.ck-balloon-panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: var(--ck-balloon-border-width) solid var(--ck-color-panel-border);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t\tborder-style: solid;\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-border) transparent;\n\t\t\tmargin-top: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-background) transparent;\n\t\t\tmargin-top: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: var(--ck-color-panel-border) transparent transparent;\n\t\t\tfilter: drop-shadow(var(--ck-balloon-arrow-drop-shadow));\n\t\t\tmargin-bottom: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: var(--ck-color-panel-background) transparent transparent transparent;\n\t\t\tmargin-bottom: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_e"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent transparent transparent var(--ck-color-panel-border);\n\t\t\tmargin-right: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent transparent transparent var(--ck-color-panel-background);\n\t\t\tmargin-right: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_w"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0;\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent var(--ck-color-panel-border) transparent transparent;\n\t\t\tmargin-left: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent var(--ck-color-panel-background) transparent transparent;\n\t\t\tmargin-left: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_n {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_ne {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_s {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_se {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_smw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nmw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_e {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t\tmargin-top: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: 50%;\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_w {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t\tmargin-top: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: 50%;\n\t\t}\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          1757: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck .ck-balloon-rotator__navigation{align-items:center;display:flex;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-bottom:var(--ck-spacing-small);margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-left:var(--ck-spacing-small);margin-right:var(--ck-spacing-standard)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonrotator.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonrotator.css',
                ],
                names: [],
                mappings:
                  'AAKA,oCAEC,kBAAmB,CADnB,YAAa,CAEb,sBACD,CAKA,6CACC,sBACD,CCXA,oCACC,6CAA8C,CAC9C,sDAAuD,CACvD,iCAgBD,CAbC,sCAGC,qCAAsC,CAFtC,oCAAqC,CACrC,kCAED,CAGA,iEAIC,mCAAoC,CAHpC,uCAID,CAMA,2DACC,eACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n/* Buttons inside a toolbar should be centered when rotator bar is wider.\n * See: https://github.com/ckeditor/ckeditor5-ui/issues/495\n */\n.ck .ck-balloon-rotator__content .ck-toolbar {\n\tjustify-content: center;\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tbackground: var(--ck-color-toolbar-background);\n\tborder-bottom: 1px solid var(--ck-color-toolbar-border);\n\tpadding: 0 var(--ck-spacing-small);\n\n\t/* Let's keep similar appearance to `ck-toolbar`. */\n\t& > * {\n\t\tmargin-right: var(--ck-spacing-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t/* Gives counter more breath than buttons. */\n\t& .ck-balloon-rotator__counter {\n\t\tmargin-right: var(--ck-spacing-standard);\n\n\t\t/* We need to use smaller margin because of previous button's right margin. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n.ck .ck-balloon-rotator__content {\n\n\t/* Disable default annotation shadow inside rotator with fake panels. */\n\t& .ck.ck-annotation-wrapper {\n\t\tbox-shadow: none;\n\t}\n}\n",
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          3553: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);box-shadow:var(--ck-drop-shadow),0 0;height:100%;min-height:15px;width:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/fakepanel.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/fakepanel.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css',
                ],
                names: [],
                mappings:
                  'AAKA,mBACC,iBAAkB,CAGlB,mCACD,CAEA,uBACC,iBACD,CAEA,mCACC,SACD,CAEA,oCACC,SACD,CCfA,MACC,6CAA8C,CAC9C,2CACD,CAGA,uBAKC,2CAA4C,CAC5C,6CAA8C,CAC9C,qCAAsC,CCXtC,oCAA8B,CDc9B,WAAY,CAPZ,eAAgB,CAMhB,UAED,CAEA,mCACC,0DAA2D,CAC3D,uDACD,CAEA,oCACC,kEAAqE,CACrE,+DACD,CACA,oCACC,kEAAqE,CACrE,+DACD,CAGA,yIAGC,4CACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-fake-panel {\n\tposition: absolute;\n\n\t/* Fake panels should be placed under main balloon content. */\n\tz-index: calc(var(--ck-z-modal) - 1);\n}\n\n.ck .ck-fake-panel div {\n\tposition: absolute;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tz-index: 2;\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tz-index: 1;\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-fake-panel-offset-horizontal: 6px;\n\t--ck-balloon-fake-panel-offset-vertical: 6px;\n}\n\n/* Let\'s use `.ck-balloon-panel` appearance. See: balloonpanel.css. */\n.ck .ck-fake-panel div {\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: 1px solid var(--ck-color-panel-border);\n\tborder-radius: var(--ck-border-radius);\n\n\twidth: 100%;\n\theight: 100%;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tmargin-left: var(--ck-balloon-fake-panel-offset-horizontal);\n\tmargin-top: var(--ck-balloon-fake-panel-offset-vertical);\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 2);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 2);\n}\n.ck .ck-fake-panel div:nth-child( 3 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 3);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 3);\n}\n\n/* If balloon is positioned above element, we need to move fake panel to the top. */\n.ck .ck-balloon-panel_arrow_s + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_se + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_sw + .ck-fake-panel {\n\t--ck-balloon-fake-panel-offset-vertical: -6px;\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          3609: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{position:fixed;top:0;z-index:var(--ck-z-modal)}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{position:absolute;top:auto}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{border-top-left-radius:0;border-top-right-radius:0;border-width:0 1px 1px;box-shadow:var(--ck-drop-shadow),0 0}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/stickypanel.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/stickypanel.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css',
                ],
                names: [],
                mappings:
                  'AAMC,qDAEC,cAAe,CACf,KAAM,CAFN,yBAGD,CAEA,kEAEC,iBAAkB,CADlB,QAED,CCPA,qDAIC,wBAAyB,CACzB,yBAA0B,CAF1B,sBAAuB,CCFxB,oCDKA',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\tz-index: var(--ck-z-modal); /* #315 */\n\t\tposition: fixed;\n\t\ttop: 0;\n\t}\n\n\t& .ck-sticky-panel__content_sticky_bottom-limit {\n\t\ttop: auto;\n\t\tposition: absolute;\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\t@mixin ck-drop-shadow;\n\n\t\tborder-width: 0 1px 1px;\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          1590: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck-vertical-form .ck-button:after{bottom:-1px;content:"";position:absolute;right:-1px;top:-1px;width:0;z-index:1}.ck-vertical-form .ck-button:focus:after{display:none}@media screen and (max-width:600px){.ck.ck-responsive-form .ck-button:after{bottom:-1px;content:"";position:absolute;right:-1px;top:-1px;width:0;z-index:1}.ck.ck-responsive-form .ck-button:focus:after{display:none}}.ck-vertical-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form{padding:var(--ck-spacing-large)}.ck.ck-responsive-form:focus{outline:none}[dir=ltr] .ck.ck-responsive-form>:not(:first-child),[dir=rtl] .ck.ck-responsive-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-responsive-form{padding:0;width:calc(var(--ck-input-width)*.8)}.ck.ck-responsive-form .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) 0}.ck.ck-responsive-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-responsive-form .ck-labeled-field-view .ck-labeled-field-view__error{white-space:normal}.ck.ck-responsive-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form>.ck-button:last-child,.ck.ck-responsive-form>.ck-button:nth-last-child(2){border-radius:0;margin-top:var(--ck-spacing-large);padding:var(--ck-spacing-standard)}.ck.ck-responsive-form>.ck-button:last-child:not(:focus),.ck.ck-responsive-form>.ck-button:nth-last-child(2):not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-responsive-form>.ck-button:last-child,[dir=ltr] .ck.ck-responsive-form>.ck-button:nth-last-child(2),[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2){margin-left:0}[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child:last-of-type,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2):last-of-type{border-right:1px solid var(--ck-color-base-border)}}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/responsive-form/responsiveform.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/responsive-form/responsiveform.css',
                ],
                names: [],
                mappings:
                  'AAQC,mCAMC,WAAY,CALZ,UAAW,CAEX,iBAAkB,CAClB,UAAW,CACX,QAAS,CAHT,OAAQ,CAKR,SACD,CAEA,yCACC,YACD,CCdA,oCDoBE,wCAMC,WAAY,CALZ,UAAW,CAEX,iBAAkB,CAClB,UAAW,CACX,QAAS,CAHT,OAAQ,CAKR,SACD,CAEA,8CACC,YACD,CC9BF,CCAD,qDACC,kDACD,CAEA,uBACC,+BAmED,CAjEC,6BAEC,YACD,CASC,uGACC,sCACD,CDvBD,oCCMD,uBAqBE,SAAU,CACV,oCA8CF,CA5CE,8CACC,wDAWD,CATC,6DACC,WAAY,CACZ,UACD,CAGA,4EACC,kBACD,CAKA,0DACC,kDACD,CAGD,iGAIC,eAAgB,CADhB,kCAAmC,CADnC,kCAmBD,CAfC,yHACC,gDACD,CARD,0OAeE,aAMF,CAJE,+IACC,kDACD,CDpEH',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck-vertical-form .ck-button {\n\t&::after {\n\t\tcontent: "";\n\t\twidth: 0;\n\t\tposition: absolute;\n\t\tright: -1px;\n\t\ttop: -1px;\n\t\tbottom: -1px;\n\t\tz-index: 1;\n\t}\n\n\t&:focus::after {\n\t\tdisplay: none;\n\t}\n}\n\n.ck.ck-responsive-form {\n\t@mixin ck-media-phone {\n\t\t& .ck-button {\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\tposition: absolute;\n\t\t\t\tright: -1px;\n\t\t\t\ttop: -1px;\n\t\t\t\tbottom: -1px;\n\t\t\t\tz-index: 1;\n\t\t\t}\n\n\t\t\t&:focus::after {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck-vertical-form > .ck-button:nth-last-child(2)::after {\n\tborder-right: 1px solid var(--ck-color-base-border);\n}\n\n.ck.ck-responsive-form {\n\tpadding: var(--ck-spacing-large);\n\n\t&:focus {\n\t\t/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */\n\t\toutline: none;\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& > :not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& > :not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tpadding: 0;\n\t\twidth: calc(.8 * var(--ck-input-width));\n\n\t\t& .ck-labeled-field-view {\n\t\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) 0;\n\n\t\t\t& .ck-input-text {\n\t\t\t\tmin-width: 0;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\n\t\t\t/* Let the long error messages wrap in the narrow form. */\n\t\t\t& .ck-labeled-field-view__error {\n\t\t\t\twhite-space: normal;\n\t\t\t}\n\t\t}\n\n\t\t/* Styles for two last buttons in the form (save&cancel, edit&unlink, etc.). */\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\t&::after {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\n\t\t& > .ck-button:nth-last-child(1),\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\tpadding: var(--ck-spacing-standard);\n\t\t\tmargin-top: var(--ck-spacing-large);\n\t\t\tborder-radius: 0;\n\n\t\t\t&:not(:focus) {\n\t\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\n\t\t\t\t&:last-of-type {\n\t\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          6706: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-block-toolbar-button{position:absolute;z-index:var(--ck-z-default)}:root{--ck-color-block-toolbar-button:var(--ck-color-text);--ck-block-toolbar-button-size:var(--ck-font-size-normal)}.ck.ck-block-toolbar-button{color:var(--ck-color-block-toolbar-button);font-size:var(--ck-block-toolbar-size)}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/toolbar/blocktoolbar.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/blocktoolbar.css',
                ],
                names: [],
                mappings: 'AAKA,4BACC,iBAAkB,CAClB,2BACD,CCHA,MACC,oDAAqD,CACrD,yDACD,CAEA,4BACC,0CAA2C,CAC3C,sCACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-block-toolbar-button {\n\tposition: absolute;\n\tz-index: var(--ck-z-default);\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-block-toolbar-button: var(--ck-color-text);\n\t--ck-block-toolbar-button-size: var(--ck-font-size-normal);\n}\n\n.ck.ck-block-toolbar-button {\n\tcolor: var(--ck-color-block-toolbar-button);\n\tfont-size: var(--ck-block-toolbar-size);\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          5571: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-toolbar{align-items:center;display:flex;flex-flow:row nowrap;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-toolbar>.ck-toolbar__items{align-items:center;display:flex;flex-flow:row wrap;flex-grow:1}.ck.ck-toolbar .ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar .ck.ck-toolbar__separator:first-child,.ck.ck-toolbar .ck.ck-toolbar__separator:last-child{display:none}.ck.ck-toolbar .ck-toolbar__line-break{flex-basis:100%}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck-dropdown__button .ck-dropdown__arrow{display:none}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);border:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck.ck-toolbar .ck.ck-toolbar__separator{align-self:stretch;background:var(--ck-color-toolbar-border);margin-bottom:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);min-width:1px;width:1px}.ck.ck-toolbar .ck-toolbar__line-break{height:0}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break){margin-right:var(--ck-spacing-small)}.ck.ck-toolbar>.ck-toolbar__items:empty+.ck.ck-toolbar__separator{display:none}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break),.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{margin-bottom:var(--ck-spacing-small);margin-top:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items>.ck{border-radius:0;margin:0;width:100%}.ck.ck-toolbar.ck-toolbar_compact{padding:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>*{margin:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>:not(:first-child):not(:last-child){border-radius:0}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck.ck-button.ck-dropdown__button{padding-left:var(--ck-spacing-tiny)}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck{margin-right:0}.ck.ck-toolbar[dir=rtl]:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-left:0}.ck.ck-toolbar.ck-toolbar_compact[dir=rtl]>.ck-toolbar__items>.ck:first-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-toolbar.ck-toolbar_compact[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-bottom-right-radius:0;border-top-right-radius:0}.ck.ck-toolbar.ck-toolbar_grouping[dir=rtl]>.ck-toolbar__items:not(:empty):not(:only-child),.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__separator,[dir=rtl] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-right:0}.ck.ck-toolbar.ck-toolbar_compact[dir=ltr]>.ck-toolbar__items>.ck:first-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.ck.ck-toolbar.ck-toolbar_compact[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-toolbar.ck-toolbar_grouping[dir=ltr]>.ck-toolbar__items:not(:empty):not(:only-child),.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__separator,[dir=ltr] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-right:var(--ck-spacing-small)}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/toolbar/toolbar.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/toolbar.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css',
                ],
                names: [],
                mappings:
                  'AAOA,eAKC,kBAAmB,CAFnB,YAAa,CACb,oBAAqB,CCFrB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBD6CD,CA3CC,kCAGC,kBAAmB,CAFnB,YAAa,CACb,kBAAmB,CAEnB,WAED,CAEA,yCACC,oBAWD,CAJC,yGAEC,YACD,CAGD,uCACC,eACD,CAEA,sDACC,gBACD,CAEA,sDACC,qBACD,CAEA,sDACC,gBACD,CAGC,yFACC,YACD,CE/CF,eCGC,eDuFD,CA1FA,qECOE,qCDmFF,CA1FA,eAGC,6CAA8C,CAE9C,+CAAgD,CADhD,iCAsFD,CAnFC,yCACC,kBAAmB,CAGnB,yCAA0C,CAO1C,qCAAsC,CADtC,kCAAmC,CAPnC,aAAc,CADd,SAUD,CAEA,uCACC,QACD,CAGC,gEAEC,oCACD,CAIA,kEACC,YACD,CAGD,gHAIC,qCAAsC,CADtC,kCAED,CAEA,mCAEC,SAaD,CAVC,0DAQC,eAAgB,CAHhB,QAAS,CAHT,UAOD,CAGD,kCAEC,SAWD,CATC,uDAEC,QAMD,CAHC,yFACC,eACD,CASD,kFACC,mCACD,CApFF,qCAwFE,QAEF,CAYC,+FACC,cACD,CAEA,iJAEC,mCACD,CAEA,qHACC,aACD,CAIC,6JAEC,2BAA4B,CAD5B,wBAED,CAGA,2JAEC,4BAA6B,CAD7B,yBAED,CASD,8RACC,mCACD,CAWA,qHACC,cACD,CAIC,6JAEC,4BAA6B,CAD7B,yBAED,CAGA,2JAEC,2BAA4B,CAD5B,wBAED,CASD,8RACC,oCACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\talign-items: center;\n\n\t& > .ck-toolbar__items {\n\t\tdisplay: flex;\n\t\tflex-flow: row wrap;\n\t\talign-items: center;\n\t\tflex-grow: 1;\n\n\t}\n\n\t& .ck.ck-toolbar__separator {\n\t\tdisplay: inline-block;\n\n\t\t/*\n\t\t * A leading or trailing separator makes no sense (separates from nothing on one side).\n\t\t * For instance, it can happen when toolbar items (also separators) are getting grouped one by one and\n\t\t * moved to another toolbar in the dropdown.\n\t\t */\n\t\t&:first-child,\n\t\t&:last-child {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\tflex-basis: 100%;\n\t}\n\n\t&.ck-toolbar_grouping > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t&.ck-toolbar_vertical > .ck-toolbar__items {\n\t\tflex-direction: column;\n\t}\n\n\t&.ck-toolbar_floating > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t& > .ck-dropdown__button .ck-dropdown__arrow {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-toolbar-background);\n\tpadding: 0 var(--ck-spacing-small);\n\tborder: 1px solid var(--ck-color-toolbar-border);\n\n\t& .ck.ck-toolbar__separator {\n\t\talign-self: stretch;\n\t\twidth: 1px;\n\t\tmin-width: 1px;\n\t\tbackground: var(--ck-color-toolbar-border);\n\n\t\t/*\n\t\t * These margins make the separators look better in balloon toolbars (when aligned with the "tip").\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/7493.\n\t\t */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\theight: 0;\n\t}\n\n\t& > .ck-toolbar__items {\n\t\t& > *:not(.ck-toolbar__line-break) {\n\t\t\t/* (#11) Separate toolbar items. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\n\t\t/* Don\'t display a separator after an empty items container, for instance,\n\t\twhen all items were grouped */\n\t\t&:empty + .ck.ck-toolbar__separator {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& > .ck-toolbar__items > *:not(.ck-toolbar__line-break),\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/* Make sure items wrapped to the next line have v-spacing */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t&.ck-toolbar_vertical {\n\t\t/* Items in a vertical toolbar span the entire width. */\n\t\tpadding: 0;\n\n\t\t/* Specificity matters here. See https://github.com/ckeditor/ckeditor5-theme-lark/issues/168. */\n\t\t& > .ck-toolbar__items > .ck {\n\t\t\t/* Items in a vertical toolbar should span the horizontal space. */\n\t\t\twidth: 100%;\n\n\t\t\t/* Items in a vertical toolbar should have no margin. */\n\t\t\tmargin: 0;\n\n\t\t\t/* Items in a vertical toolbar span the entire width so rounded corners are pointless. */\n\t\t\tborder-radius: 0;\n\t\t}\n\t}\n\n\t&.ck-toolbar_compact {\n\t\t/* No spacing around items. */\n\t\tpadding: 0;\n\n\t\t& > .ck-toolbar__items > * {\n\t\t\t/* Compact toolbar items have no spacing between them. */\n\t\t\tmargin: 0;\n\n\t\t\t/* "Middle" children should have no rounded corners. */\n\t\t\t&:not(:first-child):not(:last-child) {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/*\n\t\t * Dropdown button has asymmetric padding to fit the arrow.\n\t\t * This button has no arrow so let\'s revert that padding back to normal.\n\t\t */\n\t\t& > .ck.ck-button.ck-dropdown__button {\n\t\t\tpadding-left: var(--ck-spacing-tiny);\n\t\t}\n\t}\n\n\t@nest .ck-toolbar-container & {\n\t\tborder: 0;\n\t}\n}\n\n/* stylelint-disable */\n\n/*\n * Styles for RTL toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="rtl"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="rtl"] {\n\t& > .ck-toolbar__items > .ck {\n\t\tmargin-right: 0;\n\t}\n\n\t&:not(.ck-toolbar_compact) > .ck-toolbar__items > .ck {\n\t\t/* (#11) Separate toolbar items. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-left: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n/*\n * Styles for LTR toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="ltr"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="ltr"] {\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-right: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n}\n\n/* stylelint-enable */\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          9948: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck.ck-balloon-panel.ck-tooltip{--ck-balloon-border-width:0px;--ck-balloon-arrow-offset:0px;--ck-balloon-arrow-half-width:4px;--ck-balloon-arrow-height:4px;--ck-color-panel-background:var(--ck-color-tooltip-background);padding:0 var(--ck-spacing-medium);pointer-events:none;z-index:calc(var(--ck-z-modal) + 100)}.ck.ck-balloon-panel.ck-tooltip .ck-tooltip__text{color:var(--ck-color-tooltip-text);font-size:.9em;line-height:1.5}.ck.ck-balloon-panel.ck-tooltip{box-shadow:none}.ck.ck-balloon-panel.ck-tooltip:before{display:none}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/tooltip.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/tooltip/tooltip.css',
                ],
                names: [],
                mappings:
                  'AAKA,gCCGC,6BAA8B,CAC9B,6BAA8B,CAC9B,iCAAkC,CAClC,6BAA8B,CAC9B,8DAA+D,CAE/D,kCAAmC,CDPnC,mBAAoB,CAEpB,qCACD,CCMC,kDAGC,kCAAmC,CAFnC,cAAe,CACf,eAED,CAbD,gCAgBC,eAMD,CAHC,uCACC,YACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-balloon-panel.ck-tooltip {\n\t/* Keep tooltips transparent for any interactions. */\n\tpointer-events: none;\n\n\tz-index: calc( var(--ck-z-modal) + 100 );\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-balloon-panel.ck-tooltip {\n\t--ck-balloon-border-width: 0px;\n\t--ck-balloon-arrow-offset: 0px;\n\t--ck-balloon-arrow-half-width: 4px;\n\t--ck-balloon-arrow-height: 4px;\n\t--ck-color-panel-background: var(--ck-color-tooltip-background);\n\n\tpadding: 0 var(--ck-spacing-medium);\n\n\t& .ck-tooltip__text {\n\t\tfont-size: .9em;\n\t\tline-height: 1.5;\n\t\tcolor: var(--ck-color-tooltip-text);\n\t}\n\n\t/* Reset balloon panel styles */\n\tbox-shadow: none;\n\n\t/* Hide the default shadow of the .ck-balloon-panel tip */\n\t&::before {\n\t\tdisplay: none;\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          6150: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck-hidden{display:none!important}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset,.ck.ck-reset_all{box-sizing:border-box;height:auto;position:static;width:auto}:root{--ck-z-default:1;--ck-z-modal:calc(var(--ck-z-default) + 999)}.ck-transitions-disabled,.ck-transitions-disabled *{transition:none!important}:root{--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#ccced1;--ck-color-base-action:#53a336;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#2977ff;--ck-color-base-active-focus:#0d65ff;--ck-color-base-error:#db3700;--ck-color-focus-border-coordinates:218,81.8%,56.9%;--ck-color-focus-border:hsl(var(--ck-color-focus-border-coordinates));--ck-color-focus-outer-shadow:#cae1fc;--ck-color-focus-disabled-shadow:rgba(119,186,248,.3);--ck-color-focus-error-shadow:rgba(255,64,31,.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,.15);--ck-color-shadow-drop-active:rgba(0,0,0,.2);--ck-color-shadow-inner:rgba(0,0,0,.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#f0f0f0;--ck-color-button-default-active-background:#f0f0f0;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#f0f7ff;--ck-color-button-on-hover-background:#dbecff;--ck-color-button-on-active-background:#dbecff;--ck-color-button-on-disabled-background:#f0f2f4;--ck-color-button-on-color:#2977ff;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#4d9d30;--ck-color-button-action-active-background:#4d9d30;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#939393;--ck-color-switch-button-off-hover-background:#7d7d7d;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#4d9d30;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:var(--ck-color-base-border);--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:var(--ck-color-base-border);--ck-color-input-disabled-text:#757575;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-button-on-color);--ck-color-list-button-on-background-focus:var(--ck-color-button-on-color);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-background);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,176,255,.1);--ck-color-link-fake-selection:rgba(31,176,255,.3);--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset,.ck.ck-reset_all{word-wrap:break-word;background:transparent;border:0;margin:0;padding:0;text-decoration:none;transition:none;vertical-align:middle}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset_all{border-collapse:collapse;color:var(--ck-color-text);cursor:auto;float:none;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);text-align:left;white-space:nowrap}.ck-reset_all .ck-rtl :not(.ck-reset_all-excluded *){text-align:right}.ck-reset_all iframe:not(.ck-reset_all-excluded *){vertical-align:inherit}.ck-reset_all textarea:not(.ck-reset_all-excluded *){white-space:pre-wrap}.ck-reset_all input[type=password]:not(.ck-reset_all-excluded *),.ck-reset_all input[type=text]:not(.ck-reset_all-excluded *),.ck-reset_all textarea:not(.ck-reset_all-excluded *){cursor:text}.ck-reset_all input[type=password][disabled]:not(.ck-reset_all-excluded *),.ck-reset_all input[type=text][disabled]:not(.ck-reset_all-excluded *),.ck-reset_all textarea[disabled]:not(.ck-reset_all-excluded *){cursor:default}.ck-reset_all fieldset:not(.ck-reset_all-excluded *){border:2px groove #dfdee3;padding:10px}.ck-reset_all button:not(.ck-reset_all-excluded *)::-moz-focus-inner{border:0;padding:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_hidden.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_reset.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_zindex.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_transition.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_colors.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_disabled.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_focus.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_fonts.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_reset.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_rounded.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_shadow.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_spacing.css',
                ],
                names: [],
                mappings:
                  'AAQA,WAGC,sBACD,CCPA,2EAGC,qBAAsB,CAEtB,WAAY,CACZ,eAAgB,CAFhB,UAGD,CCPA,MACC,gBAAiB,CACjB,4CACD,CCAA,oDAEC,yBACD,CCNA,MACC,kCAAmD,CACnD,+BAAoD,CACpD,8BAAkD,CAClD,8BAAuD,CACvD,6BAAmD,CACnD,yBAA+C,CAC/C,8BAAsD,CACtD,oCAA4D,CAC5D,6BAAkD,CAIlD,mDAA4D,CAC5D,qEAA+E,CAC/E,qCAA4D,CAC5D,qDAA8D,CAC9D,gDAAyD,CACzD,yCAAqD,CACrD,sCAAsD,CACtD,4CAA0D,CAC1D,sCAAsD,CAItD,gDAAuD,CACvD,kDAAiE,CACjE,mDAAkE,CAClE,yDAA8D,CAE9D,uCAA6D,CAC7D,6CAAoE,CACpE,8CAAoE,CACpE,gDAAiE,CACjE,kCAAyD,CAGzD,+DAAsE,CACtE,iDAAsE,CACtE,kDAAsE,CACtE,oDAAoE,CACpE,6DAAsE,CAEtE,8BAAoD,CACpD,gCAAqD,CAErD,+CAA8D,CAC9D,qDAAiE,CACjE,+EAAqF,CACrF,oDAAuE,CACvE,yEAA8E,CAC9E,oDAAgE,CAIhE,oEAA2E,CAC3E,4DAAoE,CAIpE,2DAAoE,CACpE,mDAA6D,CAC7D,wDAAgE,CAChE,+CAA0D,CAC1D,4CAA2D,CAC3D,4DAAoE,CACpE,sCAAsD,CAItD,0DAAmE,CACnE,uFAA6F,CAC7F,oEAA2E,CAC3E,0EAA+E,CAC/E,8DAAsE,CAItE,2DAAoE,CACpE,mDAA6D,CAI7D,6DAAsE,CACtE,qDAA+D,CAI/D,uDAAgE,CAChE,uDAAiE,CAIjE,0CAAyD,CAIzD,wCAA2D,CAI3D,+BAAoD,CACpD,uDAAmE,CACnE,kDAAgE,CCnGhE,wBAAyB,CCAzB,0CAA2C,CAK3C,gGAAiG,CAKjG,4GAA6G,CAK7G,sGAAuG,CAKvG,sDAAuD,CCvBvD,wBAAyB,CACzB,6BAA8B,CAC9B,wDAA6D,CAE7D,yBAA0B,CAC1B,2BAA4B,CAC5B,yBAA0B,CAC1B,wBAAyB,CACzB,0BAA2B,CCJ3B,kCJmGD,CI7FA,2EAaC,oBAAqB,CANrB,sBAAuB,CADvB,QAAS,CAFT,QAAS,CACT,SAAU,CAGV,oBAAqB,CAErB,eAAgB,CADhB,qBAKD,CAKA,8DAGC,wBAAyB,CAEzB,0BAA2B,CAG3B,WAAY,CACZ,UAAW,CALX,iGAAkG,CAElG,eAAgB,CAChB,kBAGD,CAGC,qDACC,gBACD,CAEA,mDAEC,sBACD,CAEA,qDACC,oBACD,CAEA,mLAGC,WACD,CAEA,iNAGC,cACD,CAEA,qDAEC,yBAAoC,CADpC,YAED,CAEA,qEAGC,QAAQ,CADR,SAED,CAMD,8BAEC,gBACD,CCnFA,MACC,sBAAuB,CCAvB,gEAAiE,CAKjE,0DAA2D,CAK3D,wEAAyE,CCbzE,uBAA8B,CAC9B,mDAA2D,CAC3D,4CAAkD,CAClD,oDAA4D,CAC5D,mDAA2D,CAC3D,kDAA2D,CAC3D,yDFFD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which hides an element in DOM.\n */\n.ck-hidden {\n\t/* Override selector specificity. Otherwise, all elements with some display\n\tstyle defined will override this one, which is not a desired result. */\n\tdisplay: none !important;\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n\tbox-sizing: border-box;\n\twidth: auto;\n\theight: auto;\n\tposition: static;\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-z-default: 1;\n\t--ck-z-modal: calc( var(--ck-z-default) + 999 );\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class that disables all transitions of the element and its children.\n */\n.ck-transitions-disabled,\n.ck-transitions-disabled * {\n\ttransition: none !important;\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-base-foreground: \t\t\t\t\t\t\t\thsl(0, 0%, 98%);\n\t--ck-color-base-background: \t\t\t\t\t\t\t\thsl(0, 0%, 100%);\n\t--ck-color-base-border: \t\t\t\t\t\t\t\t\thsl(220, 6%, 81%);\n\t--ck-color-base-action: \t\t\t\t\t\t\t\t\thsl(104, 50.2%, 42.5%);\n\t--ck-color-base-focus: \t\t\t\t\t\t\t\t\t\thsl(209, 92%, 70%);\n\t--ck-color-base-text: \t\t\t\t\t\t\t\t\t\thsl(0, 0%, 20%);\n\t--ck-color-base-active: \t\t\t\t\t\t\t\t\thsl(218.1, 100%, 58%);\n\t--ck-color-base-active-focus:\t\t\t\t\t\t\t\thsl(218.2, 100%, 52.5%);\n\t--ck-color-base-error:\t\t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t/* -- Generic colors ------------------------------------------------------------------------ */\n\n\t--ck-color-focus-border-coordinates: \t\t\t\t\t\t218, 81.8%, 56.9%;\n\t--ck-color-focus-border: \t\t\t\t\t\t\t\t\thsl(var(--ck-color-focus-border-coordinates));\n\t--ck-color-focus-outer-shadow:\t\t\t\t\t\t\t\thsl(212.4, 89.3%, 89%);\n\t--ck-color-focus-disabled-shadow:\t\t\t\t\t\t\thsla(209, 90%, 72%,.3);\n\t--ck-color-focus-error-shadow:\t\t\t\t\t\t\t\thsla(9,100%,56%,.3);\n\t--ck-color-text: \t\t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-shadow-drop: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.15);\n\t--ck-color-shadow-drop-active:\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.2);\n\t--ck-color-shadow-inner: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Buttons ------------------------------------------------------------------------------- */\n\n\t--ck-color-button-default-background: \t\t\t\t\t\ttransparent;\n\t--ck-color-button-default-hover-background: \t\t\t\thsl(0, 0%, 94.1%);\n\t--ck-color-button-default-active-background: \t\t\t\thsl(0, 0%, 94.1%);\n\t--ck-color-button-default-disabled-background: \t\t\t\ttransparent;\n\n\t--ck-color-button-on-background: \t\t\t\t\t\t\thsl(212, 100%, 97.1%);\n\t--ck-color-button-on-hover-background: \t\t\t\t\t\thsl(211.7, 100%, 92.9%);\n\t--ck-color-button-on-active-background: \t\t\t\t\thsl(211.7, 100%, 92.9%);\n\t--ck-color-button-on-disabled-background: \t\t\t\t\thsl(211, 15%, 95%);\n\t--ck-color-button-on-color:\t\t\t\t\t\t\t\t\thsl(218.1, 100%, 58%);\n\n\n\t--ck-color-button-action-background: \t\t\t\t\t\tvar(--ck-color-base-action);\n\t--ck-color-button-action-hover-background: \t\t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-button-action-active-background: \t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-button-action-disabled-background: \t\t\t\thsl(104, 44%, 58%);\n\t--ck-color-button-action-text: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t--ck-color-button-save: \t\t\t\t\t\t\t\t\thsl(120, 100%, 27%);\n\t--ck-color-button-cancel: \t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t--ck-color-switch-button-off-background:\t\t\t\t\thsl(0, 0%, 57.6%);\n\t--ck-color-switch-button-off-hover-background:\t\t\t\thsl(0, 0%, 49%);\n\t--ck-color-switch-button-on-background:\t\t\t\t\t\tvar(--ck-color-button-action-background);\n\t--ck-color-switch-button-on-hover-background:\t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-switch-button-inner-background:\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-switch-button-inner-shadow:\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Dropdown ------------------------------------------------------------------------------ */\n\n\t--ck-color-dropdown-panel-background: \t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-dropdown-panel-border: \t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Input --------------------------------------------------------------------------------- */\n\n\t--ck-color-input-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-input-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\t--ck-color-input-error-border:\t\t\t\t\t\t\t\tvar(--ck-color-base-error);\n\t--ck-color-input-text: \t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-input-disabled-background: \t\t\t\t\t\thsl(0, 0%, 95%);\n\t--ck-color-input-disabled-border: \t\t\t\t\t\t\tvar(--ck-color-base-border);\n\t--ck-color-input-disabled-text: \t\t\t\t\t\t\thsl(0, 0%, 46%);\n\n\t/* -- List ---------------------------------------------------------------------------------- */\n\n\t--ck-color-list-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-list-button-hover-background: \t\t\t\t\tvar(--ck-color-button-default-hover-background);\n\t--ck-color-list-button-on-background: \t\t\t\t\t\tvar(--ck-color-button-on-color);\n\t--ck-color-list-button-on-background-focus: \t\t\t\tvar(--ck-color-button-on-color);\n\t--ck-color-list-button-on-text:\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Panel --------------------------------------------------------------------------------- */\n\n\t--ck-color-panel-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-panel-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Toolbar ------------------------------------------------------------------------------- */\n\n\t--ck-color-toolbar-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-toolbar-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Tooltip ------------------------------------------------------------------------------- */\n\n\t--ck-color-tooltip-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-tooltip-text: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Engine -------------------------------------------------------------------------------- */\n\n\t--ck-color-engine-placeholder-text: \t\t\t\t\t\thsl(0, 0%, 44%);\n\n\t/* -- Upload -------------------------------------------------------------------------------- */\n\n\t--ck-color-upload-bar-background:\t\t \t\t\t\t\thsl(209, 92%, 70%);\n\n\t/* -- Link -------------------------------------------------------------------------------- */\n\n\t--ck-color-link-default:\t\t\t\t\t\t\t\t\thsl(240, 100%, 47%);\n\t--ck-color-link-selected-background:\t\t\t\t\t\thsla(201, 100%, 56%, 0.1);\n\t--ck-color-link-fake-selection:\t\t\t\t\t\t\t\thsla(201, 100%, 56%, 0.3);\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * An opacity value of disabled UI item.\n\t */\n\t--ck-disabled-opacity: .5;\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * The geometry of the of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow-geometry: 0 0 0 3px;\n\n\t/**\n\t * A visual style of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when disabled).\n\t */\n\t--ck-focus-disabled-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when has errors).\n\t */\n\t--ck-focus-error-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);\n\n\t/**\n\t * A visual style of focused element's border or outline.\n\t */\n\t--ck-focus-ring: 1px solid var(--ck-color-focus-border);\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-font-size-base: 13px;\n\t--ck-line-height-base: 1.84615;\n\t--ck-font-face: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;\n\n\t--ck-font-size-tiny: 0.7em;\n\t--ck-font-size-small: 0.75em;\n\t--ck-font-size-normal: 1em;\n\t--ck-font-size-big: 1.4em;\n\t--ck-font-size-large: 1.8em;\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* This is super-important. This is **manually** adjusted so a button without an icon\n\tis never smaller than a button with icon, additionally making sure that text-less buttons\n\tare perfect squares. The value is also shared by other components which should stay "in-line"\n\twith buttons. */\n\t--ck-ui-component-min-height: 2.3em;\n}\n\n/**\n * Resets an element, ignoring its children.\n */\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n\t/* Do not include inheritable rules here. */\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\tbackground: transparent;\n\ttext-decoration: none;\n\tvertical-align: middle;\n\ttransition: none;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/105 */\n\tword-wrap: break-word;\n}\n\n/**\n * Resets an element AND its children.\n */\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n\t/* These are rule inherited by all children elements. */\n\tborder-collapse: collapse;\n\tfont: normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);\n\tcolor: var(--ck-color-text);\n\ttext-align: left;\n\twhite-space: nowrap;\n\tcursor: auto;\n\tfloat: none;\n}\n\n.ck-reset_all {\n\t& .ck-rtl *:not(.ck-reset_all-excluded *) {\n\t\ttext-align: right;\n\t}\n\n\t& iframe:not(.ck-reset_all-excluded *) {\n\t\t/* For IE */\n\t\tvertical-align: inherit;\n\t}\n\n\t& textarea:not(.ck-reset_all-excluded *) {\n\t\twhite-space: pre-wrap;\n\t}\n\n\t& textarea:not(.ck-reset_all-excluded *),\n\t& input[type="text"]:not(.ck-reset_all-excluded *),\n\t& input[type="password"]:not(.ck-reset_all-excluded *) {\n\t\tcursor: text;\n\t}\n\n\t& textarea[disabled]:not(.ck-reset_all-excluded *),\n\t& input[type="text"][disabled]:not(.ck-reset_all-excluded *),\n\t& input[type="password"][disabled]:not(.ck-reset_all-excluded *) {\n\t\tcursor: default;\n\t}\n\n\t& fieldset:not(.ck-reset_all-excluded *) {\n\t\tpadding: 10px;\n\t\tborder: 2px groove hsl(255, 7%, 88%);\n\t}\n\n\t& button:not(.ck-reset_all-excluded *)::-moz-focus-inner {\n\t\t/* See http://stackoverflow.com/questions/5517744/remove-extra-button-spacing-padding-in-firefox */\n\t\tpadding: 0;\n\t\tborder: 0\n\t}\n}\n\n/**\n * Default UI rules for RTL languages.\n */\n.ck[dir="rtl"],\n.ck[dir="rtl"] .ck {\n\ttext-align: right;\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Default border-radius value.\n */\n:root{\n\t--ck-border-radius: 2px;\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * A visual style of element's inner shadow (i.e. input).\n\t */\n\t--ck-inner-shadow: 2px 2px 3px var(--ck-color-shadow-inner) inset;\n\n\t/**\n\t * A visual style of element's drop shadow (i.e. panel).\n\t */\n\t--ck-drop-shadow: 0 1px 2px 1px var(--ck-color-shadow-drop);\n\n\t/**\n\t * A visual style of element's active shadow (i.e. comment or suggestion).\n\t */\n\t--ck-drop-shadow-active: 0 3px 6px 1px var(--ck-color-shadow-drop-active);\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-spacing-unit: \t\t\t\t\t\t0.6em;\n\t--ck-spacing-large: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 1.5);\n\t--ck-spacing-standard: \t\t\t\t\tvar(--ck-spacing-unit);\n\t--ck-spacing-medium: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.8);\n\t--ck-spacing-small: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.5);\n\t--ck-spacing-tiny: \t\t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.3);\n\t--ck-spacing-extra-tiny: \t\t\t\tcalc(var(--ck-spacing-unit) * 0.16);\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          6507: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              ':root{--ck-color-resizer:var(--ck-color-focus-border);--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2;--ck-resizer-border-radius:var(--ck-border-radius);--ck-resizer-tooltip-offset:10px;--ck-resizer-tooltip-height:calc(var(--ck-spacing-small)*2 + 10px)}.ck .ck-widget,.ck .ck-widget.ck-widget_with-selection-handle{position:relative}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{position:absolute}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);color:var(--ck-color-resizer-tooltip-text);display:block;font-size:var(--ck-font-size-tiny);height:var(--ck-resizer-tooltip-height);line-height:var(--ck-resizer-tooltip-height);padding:0 var(--ck-spacing-small)}.ck .ck-size-view.ck-orientation-above-center,.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{left:var(--ck-resizer-tooltip-offset);top:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{right:var(--ck-resizer-tooltip-offset);top:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-above-center{left:50%;top:calc(var(--ck-resizer-tooltip-height)*-1);transform:translate(-50%)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-color:transparent;outline-style:solid;outline-width:var(--ck-widget-outline-thickness);transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{background-color:var(--ck-color-widget-editable-focus-background);border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{background-color:initial;border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;box-sizing:border-box;left:calc(0px - var(--ck-widget-outline-thickness));opacity:0;padding:4px;top:0;transform:translateY(-100%);transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{color:var(--ck-color-widget-drag-handler-icon-color);height:var(--ck-widget-handler-icon-size);width:var(--ck-widget-handler-icon-size)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{background-color:var(--ck-color-widget-hover-border);opacity:1}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{background-color:var(--ck-color-focus-border);opacity:1}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:1}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck.ck-editor__editable.ck-read-only .ck-widget{transition:none}.ck.ck-editor__editable.ck-read-only .ck-widget:not(.ck-widget_selected){--ck-widget-outline-thickness:0px}.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle:hover,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handle:first-child,.ck.ck-editor__editable>.ck-widget.ck-widget_with-selection-handle:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widget.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widget.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css',
                ],
                names: [],
                mappings:
                  'AAKA,MACC,+CAAgD,CAChD,6CAAsD,CACtD,uCAAgD,CAEhD,kDAAmD,CACnD,gCAAiC,CACjC,kEACD,CAOA,8DAEC,iBAqBD,CAnBC,4EACC,iBAOD,CALC,qFAGC,aACD,CASD,iLACC,kBACD,CAGD,kBACC,qDAAsD,CAEtD,qDAAsD,CACtD,6CAA8C,CAF9C,0CAA2C,CAI3C,aAAc,CADd,kCAAmC,CAGnC,uCAAwC,CACxC,4CAA6C,CAF7C,iCAsCD,CAlCC,8NAKC,iBACD,CAEA,0CAEC,qCAAsC,CADtC,oCAED,CAEA,2CAEC,sCAAuC,CADvC,oCAED,CAEA,8CACC,uCAAwC,CACxC,sCACD,CAEA,6CACC,uCAAwC,CACxC,qCACD,CAGA,8CAEC,QAAS,CADT,6CAAgD,CAEhD,yBACD,CCjFD,MACC,iCAAkC,CAClC,kCAAmC,CACnC,4CAA6C,CAC7C,wCAAyC,CAEzC,wCAAiD,CACjD,sCAAkD,CAClD,2EAA4E,CAC5E,yEACD,CAEA,eAGC,yBAA0B,CAD1B,mBAAoB,CADpB,gDAAiD,CAGjD,6GAUD,CARC,0EAEC,6EACD,CAEA,qBACC,iDACD,CAGD,gCACC,4BAWD,CAPC,yGAKC,iEAAkE,CCnCnE,2BAA2B,CCF3B,qCAA8B,CDC9B,YDqCA,CAIA,4EAKC,wBAA6B,CAa7B,iEAAkE,CAhBlE,qBAAsB,CAoBtB,mDAAoD,CAhBpD,SAAU,CALV,WAAY,CAsBZ,KAAM,CAFN,2BAA4B,CAT5B,6SAgCD,CAnBC,qFAIC,oDAAqD,CADrD,yCAA0C,CAD1C,wCAWD,CANC,kHACC,SAAU,CAGV,+DACD,CAID,wHACC,SACD,CAID,kFAEC,oDAAqD,CADrD,SAED,CAKC,oMAEC,6CAA8C,CAD9C,SAOD,CAHC,gRACC,SACD,CAOH,qFACC,SAAU,CACV,oDACD,CAGA,gDAEC,eAkBD,CAhBC,yEAOC,iCACD,CAGC,gOAEC,gDACD,CAOD,wIAEC,mDAQD,CALE,ghBAEC,gDACD,CAKH,yKAOC,yDACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-resizer: var(--ck-color-focus-border);\n\t--ck-color-resizer-tooltip-background: hsl(0, 0%, 15%);\n\t--ck-color-resizer-tooltip-text: hsl(0, 0%, 95%);\n\n\t--ck-resizer-border-radius: var(--ck-border-radius);\n\t--ck-resizer-tooltip-offset: 10px;\n\t--ck-resizer-tooltip-height: calc(var(--ck-spacing-small) * 2 + 10px);\n}\n\n.ck .ck-widget {\n\t/* This is neccessary for type around UI to be positioned properly. */\n\tposition: relative;\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n\n\t& .ck-widget__selection-handle {\n\t\tposition: absolute;\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the icon in not a subject to font-size or line-height to avoid\n\t\t\tunnecessary spacing around it. */\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t/* Show the selection handle on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n\n\t/* Show the selection handle when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n}\n\n.ck .ck-size-view {\n\tbackground: var(--ck-color-resizer-tooltip-background);\n\tcolor: var(--ck-color-resizer-tooltip-text);\n\tborder: 1px solid var(--ck-color-resizer-tooltip-text);\n\tborder-radius: var(--ck-resizer-border-radius);\n\tfont-size: var(--ck-font-size-tiny);\n\tdisplay: block;\n\tpadding: 0 var(--ck-spacing-small);\n\theight: var(--ck-resizer-tooltip-height);\n\tline-height: var(--ck-resizer-tooltip-height);\n\n\t&.ck-orientation-top-left,\n\t&.ck-orientation-top-right,\n\t&.ck-orientation-bottom-right,\n\t&.ck-orientation-bottom-left,\n\t&.ck-orientation-above-center {\n\t\tposition: absolute;\n\t}\n\n\t&.ck-orientation-top-left {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-top-right {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-right {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-left {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t/* Class applied if the widget is too small to contain the size label */\n\t&.ck-orientation-above-center {\n\t\ttop: calc(var(--ck-resizer-tooltip-height) * -1);\n\t\tleft: 50%;\n\t\ttransform: translate(-50%);\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n\n:root {\n\t--ck-widget-outline-thickness: 3px;\n\t--ck-widget-handler-icon-size: 16px;\n\t--ck-widget-handler-animation-duration: 200ms;\n\t--ck-widget-handler-animation-curve: ease;\n\n\t--ck-color-widget-blurred-border: hsl(0, 0%, 87%);\n\t--ck-color-widget-hover-border: hsl(43, 100%, 62%);\n\t--ck-color-widget-editable-focus-background: var(--ck-color-base-background);\n\t--ck-color-widget-drag-handler-icon-color: var(--ck-color-base-background);\n}\n\n.ck .ck-widget {\n\toutline-width: var(--ck-widget-outline-thickness);\n\toutline-style: solid;\n\toutline-color: transparent;\n\ttransition: outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border);\n\t}\n\n\t&:hover {\n\t\toutline-color: var(--ck-color-widget-hover-border);\n\t}\n}\n\n.ck .ck-editor__nested-editable {\n\tborder: 1px solid transparent;\n\n\t/* The :focus style is applied before .ck-editor__nested-editable_focused class is rendered in the view.\n\tThese styles show a different border for a blink of an eye, so `:focus` need to have same styles applied. */\n\t&.ck-editor__nested-editable_focused,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\n\t\tbackground-color: var(--ck-color-widget-editable-focus-background);\n\t}\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t& .ck-widget__selection-handle {\n\t\tpadding: 4px;\n\t\tbox-sizing: border-box;\n\n\t\t/* Background and opacity will be animated as the handler shows up or the widget gets selected. */\n\t\tbackground-color: transparent;\n\t\topacity: 0;\n\n\t\t/* Transition:\n\t\t   * background-color for the .ck-widget_selected state change,\n\t\t   * visibility for hiding the handler,\n\t\t   * opacity for the proper look of the icon when the handler disappears. */\n\t\ttransition:\n\t\t\tbackground-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\tvisibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\topacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t/* Make only top corners round. */\n\t\tborder-radius: var(--ck-border-radius) var(--ck-border-radius) 0 0;\n\n\t\t/* Place the drag handler outside the widget wrapper. */\n\t\ttransform: translateY(-100%);\n\t\tleft: calc(0px - var(--ck-widget-outline-thickness));\n\t\ttop: 0;\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the dimensions of the icon are independent of the fon-size of the content. */\n\t\t\twidth: var(--ck-widget-handler-icon-size);\n\t\t\theight: var(--ck-widget-handler-icon-size);\n\t\t\tcolor: var(--ck-color-widget-drag-handler-icon-color);\n\n\t\t\t/* The "selected" part of the icon is invisible by default */\n\t\t\t& .ck-icon__selected-indicator {\n\t\t\t\topacity: 0;\n\n\t\t\t\t/* Note: The animation is longer on purpose. Simply feels better. */\n\t\t\t\ttransition: opacity 300ms var(--ck-widget-handler-animation-curve);\n\t\t\t}\n\t\t}\n\n\t\t/* Advertise using the look of the icon that once clicked the handler, the widget will be selected. */\n\t\t&:hover .ck-icon .ck-icon__selected-indicator {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t/* Show the selection handler on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\topacity: 1;\n\t\tbackground-color: var(--ck-color-widget-hover-border);\n\t}\n\n\t/* Show the selection handler when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\t& > .ck-widget__selection-handle {\n\t\t\topacity: 1;\n\t\t\tbackground-color: var(--ck-color-focus-border);\n\n\t\t\t/* When the widget is selected, notify the user using the proper look of the icon. */\n\t\t\t& .ck-icon .ck-icon__selected-indicator {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* In a RTL environment, align the selection handler to the right side of the widget */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle {\n\tleft: auto;\n\tright: calc(0px - var(--ck-widget-outline-thickness));\n}\n\n/* https://github.com/ckeditor/ckeditor5/issues/6415 */\n.ck.ck-editor__editable.ck-read-only .ck-widget {\n\t/* Prevent the :hover outline from showing up because of the used outline-color transition. */\n\ttransition: none;\n\n\t&:not(.ck-widget_selected) {\n\t\t/* Disable visual effects of hover/active widget when CKEditor is in readOnly mode.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/1261\n\t\t *\n\t\t * Leave the unit because this custom property is used in calc() by other features.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/6775\n\t\t */\n\t\t--ck-widget-outline-thickness: 0px;\n\t}\n\n\t&.ck-widget_with-selection-handle {\n\t\t& .ck-widget__selection-handle,\n\t\t& .ck-widget__selection-handle:hover {\n\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t}\n\t}\n}\n\n/* Style the widget when it\'s selected but the editable it belongs to lost focus. */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck.ck-editor__editable.ck-blurred .ck-widget {\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline-color: var(--ck-color-widget-blurred-border);\n\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t& > .ck-widget__selection-handle,\n\t\t\t& > .ck-widget__selection-handle:hover {\n\t\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-editor__editable > .ck-widget.ck-widget_with-selection-handle:first-child,\n.ck.ck-editor__editable blockquote > .ck-widget.ck-widget_with-selection-handle:first-child {\n\t/* Do not crop selection handler if a widget is a first-child in the blockquote or in the root editable.\n\tIn fact, anything with overflow: hidden.\n\thttps://github.com/ckeditor/ckeditor5-block-quote/issues/28\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/44\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/66 */\n\tmargin-top: calc(1em + var(--ck-widget-handler-icon-size));\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          2263: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck .ck-widget_with-resizer{position:relative}.ck .ck-widget__resizer{display:none;left:0;pointer-events:none;position:absolute;top:0}.ck-focused .ck-widget_with-resizer.ck-widget_selected>.ck-widget__resizer{display:block}.ck .ck-widget__resizer__handle{pointer-events:all;position:absolute}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{cursor:nesw-resize}:root{--ck-resizer-size:10px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-border-width:1px}.ck .ck-widget__resizer{outline:1px solid var(--ck-color-resizer)}.ck .ck-widget__resizer__handle{background:var(--ck-color-focus-border);border:var(--ck-resizer-border-width) solid #fff;border-radius:var(--ck-resizer-border-radius);height:var(--ck-resizer-size);width:var(--ck-resizer-size)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{left:var(--ck-resizer-offset);top:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{right:var(--ck-resizer-offset);top:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right{bottom:var(--ck-resizer-offset);right:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left{bottom:var(--ck-resizer-offset);left:var(--ck-resizer-offset)}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widgetresize.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widgetresize.css',
                ],
                names: [],
                mappings:
                  'AAKA,4BAEC,iBACD,CAEA,wBACC,YAAa,CAMb,MAAO,CAFP,mBAAoB,CAHpB,iBAAkB,CAMlB,KACD,CAGC,2EACC,aACD,CAGD,gCAIC,kBAAmB,CAHnB,iBAcD,CATC,4IAEC,kBACD,CAEA,4IAEC,kBACD,CCpCD,MACC,sBAAuB,CAGvB,yDAAiE,CACjE,6BACD,CAEA,wBACC,yCACD,CAEA,gCAGC,uCAAwC,CACxC,gDAA6D,CAC7D,6CAA8C,CAH9C,6BAA8B,CAD9B,4BAyBD,CAnBC,oEAEC,6BAA8B,CAD9B,4BAED,CAEA,qEAEC,8BAA+B,CAD/B,4BAED,CAEA,wEACC,+BAAgC,CAChC,8BACD,CAEA,uEACC,+BAAgC,CAChC,6BACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget_with-resizer {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n}\n\n.ck .ck-widget__resizer {\n\tdisplay: none;\n\tposition: absolute;\n\n\t/* The wrapper itself should not interfere with the pointer device, only the handles should. */\n\tpointer-events: none;\n\n\tleft: 0;\n\ttop: 0;\n}\n\n.ck-focused .ck-widget_with-resizer.ck-widget_selected {\n\t& > .ck-widget__resizer {\n\t\tdisplay: block;\n\t}\n}\n\n.ck .ck-widget__resizer__handle {\n\tposition: absolute;\n\n\t/* Resizers are the only UI elements that should interfere with a pointer device. */\n\tpointer-events: all;\n\n\t&.ck-widget__resizer__handle-top-left,\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tcursor: nwse-resize;\n\t}\n\n\t&.ck-widget__resizer__handle-top-right,\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tcursor: nesw-resize;\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-resizer-size: 10px;\n\n\t/* Set the resizer with a 50% offset. */\n\t--ck-resizer-offset: calc( ( var(--ck-resizer-size) / -2 ) - 2px);\n\t--ck-resizer-border-width: 1px;\n}\n\n.ck .ck-widget__resizer {\n\toutline: 1px solid var(--ck-color-resizer);\n}\n\n.ck .ck-widget__resizer__handle {\n\twidth: var(--ck-resizer-size);\n\theight: var(--ck-resizer-size);\n\tbackground: var(--ck-color-focus-border);\n\tborder: var(--ck-resizer-border-width) solid hsl(0, 0%, 100%);\n\tborder-radius: var(--ck-resizer-border-radius);\n\n\t&.ck-widget__resizer__handle-top-left {\n\t\ttop: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-top-right {\n\t\ttop: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          5137: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck .ck-widget .ck-widget__type-around__button{display:block;overflow:hidden;position:absolute;z-index:var(--ck-z-default)}.ck .ck-widget .ck-widget__type-around__button svg{left:50%;position:absolute;top:50%;z-index:calc(var(--ck-z-default) + 2)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_before{left:min(10%,30px);top:calc(var(--ck-widget-outline-thickness)*-.5);transform:translateY(-50%)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_after{bottom:calc(var(--ck-widget-outline-thickness)*-.5);right:min(10%,30px);transform:translateY(50%)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{content:"";display:block;left:1px;position:absolute;top:1px;z-index:calc(var(--ck-z-default) + 1)}.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:none;left:0;position:absolute;right:0}.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__fake-caret{left:calc(var(--ck-widget-outline-thickness)*-1);right:calc(var(--ck-widget-outline-thickness)*-1)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:block;top:calc(var(--ck-widget-outline-thickness)*-1 - 1px)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__fake-caret{bottom:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck.ck-editor__editable.ck-read-only .ck-widget__type-around,.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around,.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around{display:none}:root{--ck-widget-type-around-button-size:20px;--ck-color-widget-type-around-button-active:var(--ck-color-focus-border);--ck-color-widget-type-around-button-hover:var(--ck-color-widget-hover-border);--ck-color-widget-type-around-button-blurred-editable:var(--ck-color-widget-blurred-border);--ck-color-widget-type-around-button-radar-start-alpha:0;--ck-color-widget-type-around-button-radar-end-alpha:.3;--ck-color-widget-type-around-button-icon:var(--ck-color-base-background)}.ck .ck-widget .ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button);border-radius:100px;height:var(--ck-widget-type-around-button-size);opacity:0;pointer-events:none;transition:opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);width:var(--ck-widget-type-around-button-size)}.ck .ck-widget .ck-widget__type-around__button svg{height:8px;margin-top:1px;transform:translate(-50%,-50%);transition:transform .5s ease;width:10px}.ck .ck-widget .ck-widget__type-around__button svg *{stroke-dasharray:10;stroke-dashoffset:0;fill:none;stroke:var(--ck-color-widget-type-around-button-icon);stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round}.ck .ck-widget .ck-widget__type-around__button svg line{stroke-dasharray:7}.ck .ck-widget .ck-widget__type-around__button:hover{animation:ck-widget-type-around-button-sonar 1s ease infinite}.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:ck-widget-type-around-arrow-dash 2s linear}.ck .ck-widget .ck-widget__type-around__button:hover svg line{animation:ck-widget-type-around-arrow-tip-dash 2s linear}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:1;pointer-events:auto}.ck .ck-widget:not(.ck-widget_selected)>.ck-widget__type-around>.ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button-hover)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover{background:var(--ck-color-widget-type-around-button-active)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{background:linear-gradient(135deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.3));border-radius:100px;height:calc(var(--ck-widget-type-around-button-size) - 2px);width:calc(var(--ck-widget-type-around-button-size) - 2px)}.ck .ck-widget.ck-widget_with-selection-handle>.ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:20px}.ck .ck-widget .ck-widget__type-around__fake-caret{animation:ck-widget-type-around-fake-caret-pulse 1s linear infinite normal forwards;background:var(--ck-color-base-text);height:1px;outline:1px solid hsla(0,0%,100%,.5);pointer-events:none}.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_after,.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_before{outline-color:transparent}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected:hover,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:0}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:0;margin-right:20px}.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover){background:var(--ck-color-widget-type-around-button-blurred-editable)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover) svg *{stroke:#999}@keyframes ck-widget-type-around-arrow-dash{0%{stroke-dashoffset:10}20%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-arrow-tip-dash{0%,20%{stroke-dashoffset:7}40%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-button-sonar{0%{box-shadow:0 0 0 0 hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}50%{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-end-alpha))}to{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}}@keyframes ck-widget-type-around-fake-caret-pulse{0%{opacity:1}49%{opacity:1}50%{opacity:0}99%{opacity:0}to{opacity:1}}',
              '',
              {
                version: 3,
                sources: [
                  'webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widgettypearound.css',
                  'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widgettypearound.css',
                ],
                names: [],
                mappings:
                  'AASC,+CACC,aAAc,CAEd,eAAgB,CADhB,iBAAkB,CAElB,2BAwBD,CAtBC,mDAGC,QAAS,CAFT,iBAAkB,CAClB,OAAQ,CAER,qCACD,CAEA,qFAGC,kBAAoB,CADpB,gDAAoD,CAGpD,0BACD,CAEA,oFAEC,mDAAuD,CACvD,mBAAqB,CAErB,yBACD,CAUA,mLACC,UAAW,CACX,aAAc,CAGd,QAAS,CAFT,iBAAkB,CAClB,OAAQ,CAER,qCACD,CAMD,2EACC,YAAa,CAEb,MAAO,CADP,iBAAkB,CAElB,OACD,CAOA,iFACC,gDAAqD,CACrD,iDACD,CAKA,wHAEC,aAAc,CADd,qDAED,CAKA,uHACC,wDAA6D,CAC7D,aACD,CAoBD,mOACC,YACD,CC3GA,MACC,wCAAyC,CACzC,wEAAyE,CACzE,8EAA+E,CAC/E,2FAA4F,CAC5F,wDAAyD,CACzD,uDAAwD,CACxD,yEACD,CAgBC,+CAGC,oDAAqD,CACrD,mBAAoB,CAFpB,+CAAgD,CAVjD,SAAU,CACV,mBAAoB,CAYnB,uMAAyM,CAJzM,8CAkDD,CA1CC,mDAEC,UAAW,CAGX,cAAe,CAFf,8BAA+B,CAC/B,6BAA8B,CAH9B,UAoBD,CAdC,qDACC,mBAAoB,CACpB,mBAAoB,CAEpB,SAAU,CACV,qDAAsD,CACtD,kBAAmB,CACnB,oBAAqB,CACrB,qBACD,CAEA,wDACC,kBACD,CAGD,qDAIC,6DAcD,CARE,kEACC,oDACD,CAEA,8DACC,wDACD,CAUF,uKAvED,SAAU,CACV,mBAwEC,CAOD,gGACC,0DACD,CAOA,uKAEC,2DAQD,CANC,mLAIC,uEAAkF,CADlF,mBAAoB,CADpB,2DAA4D,CAD5D,0DAID,CAOD,8GACC,gBACD,CAKA,mDAGC,mFAAoF,CAOpF,oCAAqC,CARrC,UAAW,CAOX,oCAAwC,CARxC,mBAUD,CAOC,6JAEC,yBACD,CAUA,yKACC,iDACD,CAMA,uOAlJD,SAAU,CACV,mBAmJC,CAoBA,6yBACC,SACD,CASF,uHACC,aAAc,CACd,iBACD,CAYG,iRAlMF,SAAU,CACV,mBAmME,CAQH,kIACC,qEAKD,CAHC,wIACC,WACD,CAGD,4CACC,GACC,oBACD,CACA,OACC,mBACD,CACD,CAEA,gDACC,OACC,mBACD,CACA,OACC,mBACD,CACD,CAEA,8CACC,GACC,6HACD,CACA,IACC,6HACD,CACA,GACC,+HACD,CACD,CAEA,kDACC,GACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,GACC,SACD,CACD',
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\toverflow: hidden;\n\t\tz-index: var(--ck-z-default);\n\n\t\t& svg {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\tz-index: calc(var(--ck-z-default) + 2);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_before {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\ttop: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tleft: min(10%, 30px);\n\n\t\t\ttransform: translateY(-50%);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_after {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\tbottom: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tright: min(10%, 30px);\n\n\t\t\ttransform: translateY(50%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 1px;\n\t\t\tleft: 1px;\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tdisplay: none;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t}\n\n\t/*\n\t * When the widget is hovered the "fake caret" would normally be narrower than the\n\t * extra outline displayed around the widget. Let\'s extend the "fake caret" to match\n\t * the full width of the widget.\n\t */\n\t&:hover > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tleft: calc( -1 * var(--ck-widget-outline-thickness) );\n\t\tright: calc( -1 * var(--ck-widget-outline-thickness) );\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed before the widget (backward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_before > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\ttop: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed after the widget (forward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_after > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tbottom: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n}\n\n/*\n * Integration with the read-only mode of the editor.\n */\n.ck.ck-editor__editable.ck-read-only .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the restricted editing mode (feature) of the editor.\n */\n.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the #isEnabled property of the WidgetTypeAround plugin.\n */\n.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around {\n\tdisplay: none;\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-widget-type-around-button-size: 20px;\n\t--ck-color-widget-type-around-button-active: var(--ck-color-focus-border);\n\t--ck-color-widget-type-around-button-hover: var(--ck-color-widget-hover-border);\n\t--ck-color-widget-type-around-button-blurred-editable: var(--ck-color-widget-blurred-border);\n\t--ck-color-widget-type-around-button-radar-start-alpha: 0;\n\t--ck-color-widget-type-around-button-radar-end-alpha: .3;\n\t--ck-color-widget-type-around-button-icon: var(--ck-color-base-background);\n}\n\n@define-mixin ck-widget-type-around-button-visible {\n\topacity: 1;\n\tpointer-events: auto;\n}\n\n@define-mixin ck-widget-type-around-button-hidden {\n\topacity: 0;\n\tpointer-events: none;\n}\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\twidth: var(--ck-widget-type-around-button-size);\n\t\theight: var(--ck-widget-type-around-button-size);\n\t\tbackground: var(--ck-color-widget-type-around-button);\n\t\tborder-radius: 100px;\n\t\ttransition: opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve), background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t@mixin ck-widget-type-around-button-hidden;\n\n\t\t& svg {\n\t\t\twidth: 10px;\n\t\t\theight: 8px;\n\t\t\ttransform: translate(-50%,-50%);\n\t\t\ttransition: transform .5s ease;\n\t\t\tmargin-top: 1px;\n\n\t\t\t& * {\n\t\t\t\tstroke-dasharray: 10;\n\t\t\t\tstroke-dashoffset: 0;\n\n\t\t\t\tfill: none;\n\t\t\t\tstroke: var(--ck-color-widget-type-around-button-icon);\n\t\t\t\tstroke-width: 1.5px;\n\t\t\t\tstroke-linecap: round;\n\t\t\t\tstroke-linejoin: round;\n\t\t\t}\n\n\t\t\t& line {\n\t\t\t\tstroke-dasharray: 7;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\t/*\n\t\t\t * Display the "sonar" around the button when hovered.\n\t\t\t */\n\t\t\tanimation: ck-widget-type-around-button-sonar 1s ease infinite;\n\n\t\t\t/*\n\t\t\t * Animate active button\'s icon.\n\t\t\t */\n\t\t\t& svg {\n\t\t\t\t& polyline {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-dash 2s linear;\n\t\t\t\t}\n\n\t\t\t\t& line {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-tip-dash 2s linear;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * Show type around buttons when the widget gets selected or being hovered.\n\t */\n\t&.ck-widget_selected,\n\t&:hover {\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-visible;\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when the widget is NOT selected (but the buttons are visible\n\t * and still can be hovered).\n\t */\n\t&:not(.ck-widget_selected) > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\tbackground: var(--ck-color-widget-type-around-button-hover);\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\tbackground: var(--ck-color-widget-type-around-button-active);\n\n\t\t&::after {\n\t\t\twidth: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\theight: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\tborder-radius: 100px;\n\t\t\tbackground: linear-gradient(135deg, hsla(0,0%,100%,0) 0%, hsla(0,0%,100%,.3) 100%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the "before" button when the widget has a selection handle. Because some space\n\t * is consumed by the handle, the button must be moved slightly to the right to let it breathe.\n\t */\n\t&.ck-widget_with-selection-handle > .ck-widget__type-around > .ck-widget__type-around__button_before {\n\t\tmargin-left: 20px;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& .ck-widget__type-around__fake-caret {\n\t\tpointer-events: none;\n\t\theight: 1px;\n\t\tanimation: ck-widget-type-around-fake-caret-pulse linear 1s infinite normal forwards;\n\n\t\t/*\n\t\t * The semi-transparent-outline+background combo improves the contrast\n\t\t * when the background underneath the fake caret is dark.\n\t\t */\n\t\toutline: solid 1px hsla(0, 0%, 100%, .5);\n\t\tbackground: var(--ck-color-base-text);\n\t}\n\n\t/*\n\t * Styles of the widget when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t * Despite the widget being physically selected in the model, its outline should disappear.\n\t */\n\t&.ck-widget_selected {\n\t\t&.ck-widget_type-around_show-fake-caret_before,\n\t\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t\toutline-color: transparent;\n\t\t}\n\t}\n\n\t&.ck-widget_type-around_show-fake-caret_before,\n\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t/*\n\t\t * When the "fake caret" is visible we simulate that the widget is not selected\n\t\t * (despite being physically selected), so the outline color should be for the\n\t\t * unselected widget.\n\t\t */\n\t\t&.ck-widget_selected:hover {\n\t\t\toutline-color: var(--ck-color-widget-hover-border);\n\t\t}\n\n\t\t/*\n\t\t * Styles of the type around buttons when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t\t * In this state, the type around buttons would collide with the fake carets so they should disappear.\n\t\t */\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the selection handle. When the caret is visible, simply\n\t\t * hide the handle because it intersects with the caret (and does not make much sense anyway).\n\t\t */\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t&.ck-widget_selected,\n\t\t\t&.ck-widget_selected:hover {\n\t\t\t\t& > .ck-widget__selection-handle {\n\t\t\t\t\topacity: 0\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the resize UI. When the caret is visible, simply\n\t\t * hide the resize UI because it creates too much noise. It can be visible when the user\n\t\t * hovers the widget, though.\n\t\t */\n\t\t&.ck-widget_selected.ck-widget_with-resizer > .ck-widget__resizer {\n\t\t\topacity: 0\n\t\t}\n\t}\n}\n\n/*\n * Styles for the "before" button when the widget has a selection handle in an RTL environment.\n * The selection handler is aligned to the right side of the widget so there is no need to create\n * additional space for it next to the "before" button.\n */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around > .ck-widget__type-around__button_before {\n\tmargin-left: 0;\n\tmargin-right: 20px;\n}\n\n/*\n * Hide type around buttons when the widget is selected as a child of a selected\n * nested editable (e.g. mulit-cell table selection).\n *\n * See https://github.com/ckeditor/ckeditor5/issues/7263.\n */\n.ck-editor__nested-editable.ck-editor__editable_selected {\n\t& .ck-widget {\n\t\t&.ck-widget_selected,\n\t\t&:hover {\n\t\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*\n * Styles for the buttons when the widget is selected but the user clicked outside of the editor (blurred the editor).\n */\n.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button:not(:hover) {\n\tbackground: var(--ck-color-widget-type-around-button-blurred-editable);\n\n\t& svg * {\n\t\tstroke: hsl(0,0%,60%);\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-dash {\n\t0% {\n\t\tstroke-dashoffset: 10;\n\t}\n\t20%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-tip-dash {\n\t0%, 20% {\n\t\tstroke-dashoffset: 7;\n\t}\n\t40%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-button-sonar {\n\t0% {\n\t\tbox-shadow: 0 0 0 0 hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n\t50% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-end-alpha));\n\t}\n\t100% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n}\n\n@keyframes ck-widget-type-around-fake-caret-pulse {\n\t0% {\n\t\topacity: 1;\n\t}\n\t49% {\n\t\topacity: 1;\n\t}\n\t50% {\n\t\topacity: 0;\n\t}\n\t99% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          6710: (e, t, n) => {
            n.d(t, { Z: () => a });
            var o = n(4015),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              e.id,
              '.ck-emoji__actions .ck-button{border:0;font-size:20px;padding:.3em .5em 0}',
              '',
              {
                version: 3,
                sources: ['webpack://./node_modules/@wwalc/ckeditor5-emoji/theme/emojilistview.css'],
                names: [],
                mappings: 'AACI,8BAGI,QAAQ,CAFR,cAAe,CACf,mBAEJ',
                sourcesContent: [
                  '.ck-emoji__actions {\n    & .ck-button {\n        font-size: 20px;\n        padding:0.3em 0.5em 0;\n        border:0;\n    }\n}\n',
                ],
                sourceRoot: '',
              },
            ]);
            const a = s;
          },
          3645: (e) => {
            e.exports = function (e) {
              var t = [];
              return (
                (t.toString = function () {
                  return this.map(function (t) {
                    var n = e(t);
                    return t[2] ? '@media '.concat(t[2], ' {').concat(n, '}') : n;
                  }).join('');
                }),
                (t.i = function (e, n, o) {
                  'string' == typeof e && (e = [[null, e, '']]);
                  var i = {};
                  if (o)
                    for (var r = 0; r < this.length; r++) {
                      var s = this[r][0];
                      null != s && (i[s] = !0);
                    }
                  for (var a = 0; a < e.length; a++) {
                    var l = [].concat(e[a]);
                    (o && i[l[0]]) || (n && (l[2] ? (l[2] = ''.concat(n, ' and ').concat(l[2])) : (l[2] = n)), t.push(l));
                  }
                }),
                t
              );
            };
          },
          4015: (e) => {
            function t(e, t) {
              return (
                (function (e) {
                  if (Array.isArray(e)) return e;
                })(e) ||
                (function (e, t) {
                  var n = e && (('undefined' != typeof Symbol && e[Symbol.iterator]) || e['@@iterator']);
                  if (null == n) return;
                  var o,
                    i,
                    r = [],
                    s = !0,
                    a = !1;
                  try {
                    for (n = n.call(e); !(s = (o = n.next()).done) && (r.push(o.value), !t || r.length !== t); s = !0);
                  } catch (e) {
                    (a = !0), (i = e);
                  } finally {
                    try {
                      s || null == n.return || n.return();
                    } finally {
                      if (a) throw i;
                    }
                  }
                  return r;
                })(e, t) ||
                (function (e, t) {
                  if (!e) return;
                  if ('string' == typeof e) return n(e, t);
                  var o = Object.prototype.toString.call(e).slice(8, -1);
                  'Object' === o && e.constructor && (o = e.constructor.name);
                  if ('Map' === o || 'Set' === o) return Array.from(e);
                  if ('Arguments' === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o)) return n(e, t);
                })(e, t) ||
                (function () {
                  throw new TypeError(
                    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
                  );
                })()
              );
            }
            function n(e, t) {
              (null == t || t > e.length) && (t = e.length);
              for (var n = 0, o = new Array(t); n < t; n++) o[n] = e[n];
              return o;
            }
            e.exports = function (e) {
              var n = t(e, 4),
                o = n[1],
                i = n[3];
              if (!i) return o;
              if ('function' == typeof btoa) {
                var r = btoa(unescape(encodeURIComponent(JSON.stringify(i)))),
                  s = 'sourceMappingURL=data:application/json;charset=utf-8;base64,'.concat(r),
                  a = '/*# '.concat(s, ' */'),
                  l = i.sources.map(function (e) {
                    return '/*# sourceURL='.concat(i.sourceRoot || '').concat(e, ' */');
                  });
                return [o].concat(l).concat([a]).join('\n');
              }
              return [o].join('\n');
            };
          },
          3379: (e, t, n) => {
            var o,
              i = function () {
                return void 0 === o && (o = Boolean(window && document && document.all && !window.atob)), o;
              },
              r = (function () {
                var e = {};
                return function (t) {
                  if (void 0 === e[t]) {
                    var n = document.querySelector(t);
                    if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement)
                      try {
                        n = n.contentDocument.head;
                      } catch (e) {
                        n = null;
                      }
                    e[t] = n;
                  }
                  return e[t];
                };
              })(),
              s = [];
            function a(e) {
              for (var t = -1, n = 0; n < s.length; n++)
                if (s[n].identifier === e) {
                  t = n;
                  break;
                }
              return t;
            }
            function l(e, t) {
              for (var n = {}, o = [], i = 0; i < e.length; i++) {
                var r = e[i],
                  l = t.base ? r[0] + t.base : r[0],
                  c = n[l] || 0,
                  d = ''.concat(l, ' ').concat(c);
                n[l] = c + 1;
                var u = a(d),
                  h = { css: r[1], media: r[2], sourceMap: r[3] };
                -1 !== u ? (s[u].references++, s[u].updater(h)) : s.push({ identifier: d, updater: f(h, t), references: 1 }), o.push(d);
              }
              return o;
            }
            function c(e) {
              var t = document.createElement('style'),
                o = e.attributes || {};
              if (void 0 === o.nonce) {
                var i = n.nc;
                i && (o.nonce = i);
              }
              if (
                (Object.keys(o).forEach(function (e) {
                  t.setAttribute(e, o[e]);
                }),
                'function' == typeof e.insert)
              )
                e.insert(t);
              else {
                var s = r(e.insert || 'head');
                if (!s)
                  throw new Error(
                    "Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid."
                  );
                s.appendChild(t);
              }
              return t;
            }
            var d,
              u =
                ((d = []),
                function (e, t) {
                  return (d[e] = t), d.filter(Boolean).join('\n');
                });
            function h(e, t, n, o) {
              var i = n ? '' : o.media ? '@media '.concat(o.media, ' {').concat(o.css, '}') : o.css;
              if (e.styleSheet) e.styleSheet.cssText = u(t, i);
              else {
                var r = document.createTextNode(i),
                  s = e.childNodes;
                s[t] && e.removeChild(s[t]), s.length ? e.insertBefore(r, s[t]) : e.appendChild(r);
              }
            }
            function m(e, t, n) {
              var o = n.css,
                i = n.media,
                r = n.sourceMap;
              if (
                (i ? e.setAttribute('media', i) : e.removeAttribute('media'),
                r &&
                  'undefined' != typeof btoa &&
                  (o += '\n/*# sourceMappingURL=data:application/json;base64,'.concat(
                    btoa(unescape(encodeURIComponent(JSON.stringify(r)))),
                    ' */'
                  )),
                e.styleSheet)
              )
                e.styleSheet.cssText = o;
              else {
                for (; e.firstChild; ) e.removeChild(e.firstChild);
                e.appendChild(document.createTextNode(o));
              }
            }
            var g = null,
              p = 0;
            function f(e, t) {
              var n, o, i;
              if (t.singleton) {
                var r = p++;
                (n = g || (g = c(t))), (o = h.bind(null, n, r, !1)), (i = h.bind(null, n, r, !0));
              } else
                (n = c(t)),
                  (o = m.bind(null, n, t)),
                  (i = function () {
                    !(function (e) {
                      if (null === e.parentNode) return !1;
                      e.parentNode.removeChild(e);
                    })(n);
                  });
              return (
                o(e),
                function (t) {
                  if (t) {
                    if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
                    o((e = t));
                  } else i();
                }
              );
            }
            e.exports = function (e, t) {
              (t = t || {}).singleton || 'boolean' == typeof t.singleton || (t.singleton = i());
              var n = l((e = e || []), t);
              return function (e) {
                if (((e = e || []), '[object Array]' === Object.prototype.toString.call(e))) {
                  for (var o = 0; o < n.length; o++) {
                    var i = a(n[o]);
                    s[i].references--;
                  }
                  for (var r = l(e, t), c = 0; c < n.length; c++) {
                    var d = a(n[c]);
                    0 === s[d].references && (s[d].updater(), s.splice(d, 1));
                  }
                  n = r;
                }
              };
            };
          },
        },
        t = {};
      function n(o) {
        var i = t[o];
        if (void 0 !== i) return i.exports;
        var r = (t[o] = { id: o, exports: {} });
        return e[o](r, r.exports, n), r.exports;
      }
      (n.n = (e) => {
        var t = e && e.__esModule ? () => e.default : () => e;
        return n.d(t, { a: t }), t;
      }),
        (n.d = (e, t) => {
          for (var o in t) n.o(t, o) && !n.o(e, o) && Object.defineProperty(e, o, { enumerable: !0, get: t[o] });
        }),
        (n.g = (function () {
          if ('object' == typeof globalThis) return globalThis;
          try {
            return this || new Function('return this')();
          } catch (e) {
            if ('object' == typeof window) return window;
          }
        })()),
        (n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
        (n.nc = void 0);
      var o = {};
      return (
        (() => {
          n.d(o, { default: () => Sv });
          const e = function () {
            return function e() {
              e.called = !0;
            };
          };
          class t {
            constructor(t, n) {
              (this.source = t), (this.name = n), (this.path = []), (this.stop = e()), (this.off = e());
            }
          }
          const i = new Array(256).fill('').map((e, t) => ('0' + t.toString(16)).slice(-2));
          function r() {
            const e = (4294967296 * Math.random()) >>> 0,
              t = (4294967296 * Math.random()) >>> 0,
              n = (4294967296 * Math.random()) >>> 0,
              o = (4294967296 * Math.random()) >>> 0;
            return (
              'e' +
              i[(e >> 0) & 255] +
              i[(e >> 8) & 255] +
              i[(e >> 16) & 255] +
              i[(e >> 24) & 255] +
              i[(t >> 0) & 255] +
              i[(t >> 8) & 255] +
              i[(t >> 16) & 255] +
              i[(t >> 24) & 255] +
              i[(n >> 0) & 255] +
              i[(n >> 8) & 255] +
              i[(n >> 16) & 255] +
              i[(n >> 24) & 255] +
              i[(o >> 0) & 255] +
              i[(o >> 8) & 255] +
              i[(o >> 16) & 255] +
              i[(o >> 24) & 255]
            );
          }
          const s = {
            get(e = 'normal') {
              return 'number' != typeof e ? this[e] || this.normal : e;
            },
            highest: 1e5,
            high: 1e3,
            normal: 0,
            low: -1e3,
            lowest: -1e5,
          };
          function a(e, t) {
            const n = s.get(t.priority);
            for (let o = 0; o < e.length; o++) if (s.get(e[o].priority) < n) return void e.splice(o, 0, t);
            e.push(t);
          }
          class l extends Error {
            constructor(e, t, n) {
              super(
                (function (e, t) {
                  const n = new WeakSet(),
                    o = (e, t) => {
                      if ('object' == typeof t && null !== t) {
                        if (n.has(t)) return `[object ${t.constructor.name}]`;
                        n.add(t);
                      }
                      return t;
                    },
                    i = t ? ` ${JSON.stringify(t, o)}` : '',
                    r = d(e);
                  return e + i + r;
                })(e, n)
              ),
                (this.name = 'CKEditorError'),
                (this.context = t),
                (this.data = n);
            }
            is(e) {
              return 'CKEditorError' === e;
            }
            static rethrowUnexpectedError(e, t) {
              if (e.is && e.is('CKEditorError')) throw e;
              const n = new l(e.message, t);
              throw ((n.stack = e.stack), n);
            }
          }
          function c(e, t) {
            console.warn(...u(e, t));
          }
          function d(e) {
            return `\nRead more: https://ckeditor.com/docs/ckeditor5/latest/support/error-codes.html#error-${e}`;
          }
          function u(e, t) {
            const n = d(e);
            return t ? [e, t, n] : [e, n];
          }
          const h = '35.1.0',
            m = 'object' == typeof window ? window : n.g;
          if (m.CKEDITOR_VERSION) throw new l('ckeditor-duplicated-modules', null);
          m.CKEDITOR_VERSION = h;
          const g = Symbol('listeningTo'),
            p = Symbol('emitterId'),
            f = Symbol('delegations');
          function k(e) {
            return class extends e {
              on(e, t, n) {
                this.listenTo(this, e, t, n);
              }
              once(e, t, n) {
                let o = !1;
                this.listenTo(
                  this,
                  e,
                  (e, ...n) => {
                    o || ((o = !0), e.off(), t.call(this, e, ...n));
                  },
                  n
                );
              }
              off(e, t) {
                this.stopListening(this, e, t);
              }
              listenTo(e, t, n, o = {}) {
                let i, r;
                this[g] || (this[g] = {});
                const s = this[g];
                _(e) || w(e);
                const a = _(e);
                (i = s[a]) || (i = s[a] = { emitter: e, callbacks: {} }),
                  (r = i.callbacks[t]) || (r = i.callbacks[t] = []),
                  r.push(n),
                  (function (e, t, n, o, i) {
                    t._addEventListener ? t._addEventListener(n, o, i) : e._addEventListener.call(t, n, o, i);
                  })(this, e, t, n, o);
              }
              stopListening(e, t, n) {
                const o = this[g];
                let i = e && _(e);
                const r = o && i ? o[i] : void 0,
                  s = r && t ? r.callbacks[t] : void 0;
                if (!(!o || (e && !r) || (t && !s)))
                  if (n) {
                    x(this, e, t, n);
                    -1 !== s.indexOf(n) && (1 === s.length ? delete r.callbacks[t] : x(this, e, t, n));
                  } else if (s) {
                    for (; (n = s.pop()); ) x(this, e, t, n);
                    delete r.callbacks[t];
                  } else if (r) {
                    for (t in r.callbacks) this.stopListening(e, t);
                    delete o[i];
                  } else {
                    for (i in o) this.stopListening(o[i].emitter);
                    delete this[g];
                  }
              }
              fire(e, ...n) {
                try {
                  const o = e instanceof t ? e : new t(this, e),
                    i = o.name;
                  let r = C(this, i);
                  if ((o.path.push(this), r)) {
                    const e = [o, ...n];
                    r = Array.from(r);
                    for (
                      let t = 0;
                      t < r.length &&
                      (r[t].callback.apply(this, e),
                      o.off.called && (delete o.off.called, this._removeEventListener(i, r[t].callback)),
                      !o.stop.called);
                      t++
                    );
                  }
                  const s = this[f];
                  if (s) {
                    const e = s.get(i),
                      t = s.get('*');
                    e && v(e, o, n), t && v(t, o, n);
                  }
                  return o.return;
                } catch (e) {
                  l.rethrowUnexpectedError(e, this);
                }
              }
              delegate(...e) {
                return {
                  to: (t, n) => {
                    this[f] || (this[f] = new Map()),
                      e.forEach((e) => {
                        const o = this[f].get(e);
                        o ? o.set(t, n) : this[f].set(e, new Map([[t, n]]));
                      });
                  },
                };
              }
              stopDelegating(e, t) {
                if (this[f])
                  if (e)
                    if (t) {
                      const n = this[f].get(e);
                      n && n.delete(t);
                    } else this[f].delete(e);
                  else this[f].clear();
              }
              _addEventListener(e, t, n) {
                !(function (e, t) {
                  const n = y(e);
                  if (n[t]) return;
                  let o = t,
                    i = null;
                  const r = [];
                  for (; '' !== o && !n[o]; )
                    (n[o] = { callbacks: [], childEvents: [] }),
                      r.push(n[o]),
                      i && n[o].childEvents.push(i),
                      (i = o),
                      (o = o.substr(0, o.lastIndexOf(':')));
                  if ('' !== o) {
                    for (const e of r) e.callbacks = n[o].callbacks.slice();
                    n[o].childEvents.push(i);
                  }
                })(this, e);
                const o = A(this, e),
                  i = { callback: t, priority: s.get(n.priority) };
                for (const e of o) a(e, i);
              }
              _removeEventListener(e, t) {
                const n = A(this, e);
                for (const e of n) for (let n = 0; n < e.length; n++) e[n].callback == t && (e.splice(n, 1), n--);
              }
            };
          }
          const b = k(Object);
          function w(e, t) {
            e[p] || (e[p] = t || r());
          }
          function _(e) {
            return e[p];
          }
          function y(e) {
            return e._events || Object.defineProperty(e, '_events', { value: {} }), e._events;
          }
          function A(e, t) {
            const n = y(e)[t];
            if (!n) return [];
            let o = [n.callbacks];
            for (let t = 0; t < n.childEvents.length; t++) {
              const i = A(e, n.childEvents[t]);
              o = o.concat(i);
            }
            return o;
          }
          function C(e, t) {
            let n;
            return e._events && (n = e._events[t]) && n.callbacks.length
              ? n.callbacks
              : t.indexOf(':') > -1
              ? C(e, t.substr(0, t.lastIndexOf(':')))
              : null;
          }
          function v(e, n, o) {
            for (let [i, r] of e) {
              r ? 'function' == typeof r && (r = r(n.name)) : (r = n.name);
              const e = new t(n.source, r);
              (e.path = [...n.path]), i.fire(e, ...o);
            }
          }
          function x(e, t, n, o) {
            t._removeEventListener ? t._removeEventListener(n, o) : e._removeEventListener.call(t, n, o);
          }
          [
            'on',
            'once',
            'off',
            'listenTo',
            'stopListening',
            'fire',
            'delegate',
            'stopDelegating',
            '_addEventListener',
            '_removeEventListener',
          ].forEach((e) => {
            k[e] = b.prototype[e];
          });
          const E = function (e) {
              var t = typeof e;
              return null != e && ('object' == t || 'function' == t);
            },
            D = Symbol('observableProperties'),
            T = Symbol('boundObservables'),
            I = Symbol('boundProperties'),
            S = Symbol('decoratedMethods'),
            M = Symbol('decoratedOriginal');
          function B(e) {
            return class extends e {
              set(e, t) {
                if (E(e))
                  return void Object.keys(e).forEach((t) => {
                    this.set(t, e[t]);
                  }, this);
                P(this);
                const n = this[D];
                if (e in this && !n.has(e)) throw new l('observable-set-cannot-override', this);
                Object.defineProperty(this, e, {
                  enumerable: !0,
                  configurable: !0,
                  get: () => n.get(e),
                  set(t) {
                    const o = n.get(e);
                    let i = this.fire(`set:${e}`, e, t, o);
                    void 0 === i && (i = t), (o === i && n.has(e)) || (n.set(e, i), this.fire(`change:${e}`, e, i, o));
                  },
                }),
                  (this[e] = t);
              }
              bind(...e) {
                if (!e.length || !j(e)) throw new l('observable-bind-wrong-properties', this);
                if (new Set(e).size !== e.length) throw new l('observable-bind-duplicate-properties', this);
                P(this);
                const t = this[I];
                e.forEach((e) => {
                  if (t.has(e)) throw new l('observable-bind-rebind', this);
                });
                const n = new Map();
                return (
                  e.forEach((e) => {
                    const o = { property: e, to: [] };
                    t.set(e, o), n.set(e, o);
                  }),
                  { to: z, toMany: L, _observable: this, _bindProperties: e, _to: [], _bindings: n }
                );
              }
              unbind(...e) {
                if (!this[D]) return;
                const t = this[I],
                  n = this[T];
                if (e.length) {
                  if (!j(e)) throw new l('observable-unbind-wrong-properties', this);
                  e.forEach((e) => {
                    const o = t.get(e);
                    o &&
                      (o.to.forEach(([e, t]) => {
                        const i = n.get(e),
                          r = i[t];
                        r.delete(o), r.size || delete i[t], Object.keys(i).length || (n.delete(e), this.stopListening(e, 'change'));
                      }),
                      t.delete(e));
                  });
                } else
                  n.forEach((e, t) => {
                    this.stopListening(t, 'change');
                  }),
                    n.clear(),
                    t.clear();
              }
              decorate(e) {
                P(this);
                const t = this[e];
                if (!t) throw new l('observablemixin-cannot-decorate-undefined', this, { object: this, methodName: e });
                this.on(e, (e, n) => {
                  e.return = t.apply(this, n);
                }),
                  (this[e] = function (...t) {
                    return this.fire(e, t);
                  }),
                  (this[e][M] = t),
                  this[S] || (this[S] = []),
                  this[S].push(e);
              }
              stopListening(e, t, n) {
                if (!e && this[S]) {
                  for (const e of this[S]) this[e] = this[e][M];
                  delete this[S];
                }
                b.prototype.stopListening.call(this, e, t, n);
              }
            };
          }
          const N = B(b);
          function P(e) {
            e[D] ||
              (Object.defineProperty(e, D, { value: new Map() }),
              Object.defineProperty(e, T, { value: new Map() }),
              Object.defineProperty(e, I, { value: new Map() }));
          }
          function z(...e) {
            const t = (function (...e) {
                if (!e.length) throw new l('observable-bind-to-parse-error', null);
                const t = { to: [] };
                let n;
                'function' == typeof e[e.length - 1] && (t.callback = e.pop());
                return (
                  e.forEach((e) => {
                    if ('string' == typeof e) n.properties.push(e);
                    else {
                      if ('object' != typeof e) throw new l('observable-bind-to-parse-error', null);
                      (n = { observable: e, properties: [] }), t.to.push(n);
                    }
                  }),
                  t
                );
              })(...e),
              n = Array.from(this._bindings.keys()),
              o = n.length;
            if (!t.callback && t.to.length > 1) throw new l('observable-bind-to-no-callback', this);
            if (o > 1 && t.callback) throw new l('observable-bind-to-extra-callback', this);
            var i;
            t.to.forEach((e) => {
              if (e.properties.length && e.properties.length !== o) throw new l('observable-bind-to-properties-length', this);
              e.properties.length || (e.properties = this._bindProperties);
            }),
              (this._to = t.to),
              t.callback && (this._bindings.get(n[0]).callback = t.callback),
              (i = this._observable),
              this._to.forEach((e) => {
                const t = i[T];
                let n;
                t.get(e.observable) ||
                  i.listenTo(e.observable, 'change', (o, r) => {
                    (n = t.get(e.observable)[r]),
                      n &&
                        n.forEach((e) => {
                          O(i, e.property);
                        });
                  });
              }),
              (function (e) {
                let t;
                e._bindings.forEach((n, o) => {
                  e._to.forEach((i) => {
                    (t = i.properties[n.callback ? 0 : e._bindProperties.indexOf(o)]),
                      n.to.push([i.observable, t]),
                      (function (e, t, n, o) {
                        const i = e[T],
                          r = i.get(n),
                          s = r || {};
                        s[o] || (s[o] = new Set());
                        s[o].add(t), r || i.set(n, s);
                      })(e._observable, n, i.observable, t);
                  });
                });
              })(this),
              this._bindProperties.forEach((e) => {
                O(this._observable, e);
              });
          }
          function L(e, t, n) {
            if (this._bindings.size > 1) throw new l('observable-bind-to-many-not-one-binding', this);
            this.to(
              ...(function (e, t) {
                const n = e.map((e) => [e, t]);
                return Array.prototype.concat.apply([], n);
              })(e, t),
              n
            );
          }
          function j(e) {
            return e.every((e) => 'string' == typeof e);
          }
          function O(e, t) {
            const n = e[I].get(t);
            let o;
            n.callback
              ? (o = n.callback.apply(
                  e,
                  n.to.map((e) => e[0][e[1]])
                ))
              : ((o = n.to[0]), (o = o[0][o[1]])),
              Object.prototype.hasOwnProperty.call(e, t) ? (e[t] = o) : e.set(t, o);
          }
          function R(e, ...t) {
            t.forEach((t) => {
              const n = Object.getOwnPropertyNames(t),
                o = Object.getOwnPropertySymbols(t);
              n.concat(o).forEach((n) => {
                if (n in e.prototype) return;
                if ('function' == typeof t && ('length' == n || 'name' == n || 'prototype' == n)) return;
                const o = Object.getOwnPropertyDescriptor(t, n);
                (o.enumerable = !1), Object.defineProperty(e.prototype, n, o);
              });
            });
          }
          [
            'set',
            'bind',
            'unbind',
            'decorate',
            'on',
            'once',
            'off',
            'listenTo',
            'stopListening',
            'fire',
            'delegate',
            'stopDelegating',
            '_addEventListener',
            '_removeEventListener',
          ].forEach((e) => {
            B[e] = N.prototype[e];
          });
          class V {
            constructor(e) {
              (this.editor = e), this.set('isEnabled', !0), (this._disableStack = new Set());
            }
            forceDisabled(e) {
              this._disableStack.add(e),
                1 == this._disableStack.size && (this.on('set:isEnabled', F, { priority: 'highest' }), (this.isEnabled = !1));
            }
            clearForceDisabled(e) {
              this._disableStack.delete(e), 0 == this._disableStack.size && (this.off('set:isEnabled', F), (this.isEnabled = !0));
            }
            destroy() {
              this.stopListening();
            }
            static get isContextPlugin() {
              return !1;
            }
          }
          function F(e) {
            (e.return = !1), e.stop();
          }
          R(V, B);
          class H {
            constructor(e) {
              (this.editor = e),
                this.set('value', void 0),
                this.set('isEnabled', !1),
                (this.affectsData = !0),
                (this._disableStack = new Set()),
                this.decorate('execute'),
                this.listenTo(this.editor.model.document, 'change', () => {
                  this.refresh();
                }),
                this.on(
                  'execute',
                  (e) => {
                    this.isEnabled || e.stop();
                  },
                  { priority: 'high' }
                ),
                this.listenTo(e, 'change:isReadOnly', (e, t, n) => {
                  n && this.affectsData ? this.forceDisabled('readOnlyMode') : this.clearForceDisabled('readOnlyMode');
                });
            }
            refresh() {
              this.isEnabled = !0;
            }
            forceDisabled(e) {
              this._disableStack.add(e),
                1 == this._disableStack.size && (this.on('set:isEnabled', U, { priority: 'highest' }), (this.isEnabled = !1));
            }
            clearForceDisabled(e) {
              this._disableStack.delete(e), 0 == this._disableStack.size && (this.off('set:isEnabled', U), this.refresh());
            }
            execute() {}
            destroy() {
              this.stopListening();
            }
          }
          function U(e) {
            (e.return = !1), e.stop();
          }
          R(H, B);
          class q extends H {
            constructor(e) {
              super(e), (this._childCommandsDefinitions = []);
            }
            refresh() {}
            execute(...e) {
              const t = this._getFirstEnabledCommand();
              return !!t && t.execute(e);
            }
            registerChildCommand(e, t = { priority: 'normal' }) {
              a(this._childCommandsDefinitions, { command: e, priority: t.priority }),
                e.on('change:isEnabled', () => this._checkEnabled()),
                this._checkEnabled();
            }
            _checkEnabled() {
              this.isEnabled = !!this._getFirstEnabledCommand();
            }
            _getFirstEnabledCommand() {
              const e = this._childCommandsDefinitions.find(({ command: e }) => e.isEnabled);
              return e && e.command;
            }
          }
          const W = 'object' == typeof global && global && global.Object === Object && global;
          var G = 'object' == typeof self && self && self.Object === Object && self;
          const $ = W || G || Function('return this')();
          const Y = $.Symbol;
          var K = Object.prototype,
            Q = K.hasOwnProperty,
            Z = K.toString,
            J = Y ? Y.toStringTag : void 0;
          const X = function (e) {
            var t = Q.call(e, J),
              n = e[J];
            try {
              e[J] = void 0;
              var o = !0;
            } catch (e) {}
            var i = Z.call(e);
            return o && (t ? (e[J] = n) : delete e[J]), i;
          };
          var ee = Object.prototype.toString;
          const te = function (e) {
            return ee.call(e);
          };
          var ne = Y ? Y.toStringTag : void 0;
          const oe = function (e) {
            return null == e ? (void 0 === e ? '[object Undefined]' : '[object Null]') : ne && ne in Object(e) ? X(e) : te(e);
          };
          const ie = function (e, t) {
            return function (n) {
              return e(t(n));
            };
          };
          const re = ie(Object.getPrototypeOf, Object);
          const se = function (e) {
            return null != e && 'object' == typeof e;
          };
          var ae = Function.prototype,
            le = Object.prototype,
            ce = ae.toString,
            de = le.hasOwnProperty,
            ue = ce.call(Object);
          const he = function (e) {
            if (!se(e) || '[object Object]' != oe(e)) return !1;
            var t = re(e);
            if (null === t) return !0;
            var n = de.call(t, 'constructor') && t.constructor;
            return 'function' == typeof n && n instanceof n && ce.call(n) == ue;
          };
          const me = function () {
            (this.__data__ = []), (this.size = 0);
          };
          const ge = function (e, t) {
            return e === t || (e != e && t != t);
          };
          const pe = function (e, t) {
            for (var n = e.length; n--; ) if (ge(e[n][0], t)) return n;
            return -1;
          };
          var fe = Array.prototype.splice;
          const ke = function (e) {
            var t = this.__data__,
              n = pe(t, e);
            return !(n < 0) && (n == t.length - 1 ? t.pop() : fe.call(t, n, 1), --this.size, !0);
          };
          const be = function (e) {
            var t = this.__data__,
              n = pe(t, e);
            return n < 0 ? void 0 : t[n][1];
          };
          const we = function (e) {
            return pe(this.__data__, e) > -1;
          };
          const _e = function (e, t) {
            var n = this.__data__,
              o = pe(n, e);
            return o < 0 ? (++this.size, n.push([e, t])) : (n[o][1] = t), this;
          };
          function ye(e) {
            var t = -1,
              n = null == e ? 0 : e.length;
            for (this.clear(); ++t < n; ) {
              var o = e[t];
              this.set(o[0], o[1]);
            }
          }
          (ye.prototype.clear = me), (ye.prototype.delete = ke), (ye.prototype.get = be), (ye.prototype.has = we), (ye.prototype.set = _e);
          const Ae = ye;
          const Ce = function () {
            (this.__data__ = new Ae()), (this.size = 0);
          };
          const ve = function (e) {
            var t = this.__data__,
              n = t.delete(e);
            return (this.size = t.size), n;
          };
          const xe = function (e) {
            return this.__data__.get(e);
          };
          const Ee = function (e) {
            return this.__data__.has(e);
          };
          const De = function (e) {
            if (!E(e)) return !1;
            var t = oe(e);
            return '[object Function]' == t || '[object GeneratorFunction]' == t || '[object AsyncFunction]' == t || '[object Proxy]' == t;
          };
          const Te = $['__core-js_shared__'];
          var Ie = (function () {
            var e = /[^.]+$/.exec((Te && Te.keys && Te.keys.IE_PROTO) || '');
            return e ? 'Symbol(src)_1.' + e : '';
          })();
          const Se = function (e) {
            return !!Ie && Ie in e;
          };
          var Me = Function.prototype.toString;
          const Be = function (e) {
            if (null != e) {
              try {
                return Me.call(e);
              } catch (e) {}
              try {
                return e + '';
              } catch (e) {}
            }
            return '';
          };
          var Ne = /^\[object .+?Constructor\]$/,
            Pe = Function.prototype,
            ze = Object.prototype,
            Le = Pe.toString,
            je = ze.hasOwnProperty,
            Oe = RegExp(
              '^' +
                Le.call(je)
                  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
                  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') +
                '$'
            );
          const Re = function (e) {
            return !(!E(e) || Se(e)) && (De(e) ? Oe : Ne).test(Be(e));
          };
          const Ve = function (e, t) {
            return null == e ? void 0 : e[t];
          };
          const Fe = function (e, t) {
            var n = Ve(e, t);
            return Re(n) ? n : void 0;
          };
          const He = Fe($, 'Map');
          const Ue = Fe(Object, 'create');
          const qe = function () {
            (this.__data__ = Ue ? Ue(null) : {}), (this.size = 0);
          };
          const We = function (e) {
            var t = this.has(e) && delete this.__data__[e];
            return (this.size -= t ? 1 : 0), t;
          };
          var Ge = Object.prototype.hasOwnProperty;
          const $e = function (e) {
            var t = this.__data__;
            if (Ue) {
              var n = t[e];
              return '__lodash_hash_undefined__' === n ? void 0 : n;
            }
            return Ge.call(t, e) ? t[e] : void 0;
          };
          var Ye = Object.prototype.hasOwnProperty;
          const Ke = function (e) {
            var t = this.__data__;
            return Ue ? void 0 !== t[e] : Ye.call(t, e);
          };
          const Qe = function (e, t) {
            var n = this.__data__;
            return (this.size += this.has(e) ? 0 : 1), (n[e] = Ue && void 0 === t ? '__lodash_hash_undefined__' : t), this;
          };
          function Ze(e) {
            var t = -1,
              n = null == e ? 0 : e.length;
            for (this.clear(); ++t < n; ) {
              var o = e[t];
              this.set(o[0], o[1]);
            }
          }
          (Ze.prototype.clear = qe), (Ze.prototype.delete = We), (Ze.prototype.get = $e), (Ze.prototype.has = Ke), (Ze.prototype.set = Qe);
          const Je = Ze;
          const Xe = function () {
            (this.size = 0), (this.__data__ = { hash: new Je(), map: new (He || Ae)(), string: new Je() });
          };
          const et = function (e) {
            var t = typeof e;
            return 'string' == t || 'number' == t || 'symbol' == t || 'boolean' == t ? '__proto__' !== e : null === e;
          };
          const tt = function (e, t) {
            var n = e.__data__;
            return et(t) ? n['string' == typeof t ? 'string' : 'hash'] : n.map;
          };
          const nt = function (e) {
            var t = tt(this, e).delete(e);
            return (this.size -= t ? 1 : 0), t;
          };
          const ot = function (e) {
            return tt(this, e).get(e);
          };
          const it = function (e) {
            return tt(this, e).has(e);
          };
          const rt = function (e, t) {
            var n = tt(this, e),
              o = n.size;
            return n.set(e, t), (this.size += n.size == o ? 0 : 1), this;
          };
          function st(e) {
            var t = -1,
              n = null == e ? 0 : e.length;
            for (this.clear(); ++t < n; ) {
              var o = e[t];
              this.set(o[0], o[1]);
            }
          }
          (st.prototype.clear = Xe), (st.prototype.delete = nt), (st.prototype.get = ot), (st.prototype.has = it), (st.prototype.set = rt);
          const at = st;
          const lt = function (e, t) {
            var n = this.__data__;
            if (n instanceof Ae) {
              var o = n.__data__;
              if (!He || o.length < 199) return o.push([e, t]), (this.size = ++n.size), this;
              n = this.__data__ = new at(o);
            }
            return n.set(e, t), (this.size = n.size), this;
          };
          function ct(e) {
            var t = (this.__data__ = new Ae(e));
            this.size = t.size;
          }
          (ct.prototype.clear = Ce), (ct.prototype.delete = ve), (ct.prototype.get = xe), (ct.prototype.has = Ee), (ct.prototype.set = lt);
          const dt = ct;
          const ut = function (e, t) {
            for (var n = -1, o = null == e ? 0 : e.length; ++n < o && !1 !== t(e[n], n, e); );
            return e;
          };
          const ht = (function () {
            try {
              var e = Fe(Object, 'defineProperty');
              return e({}, '', {}), e;
            } catch (e) {}
          })();
          const mt = function (e, t, n) {
            '__proto__' == t && ht ? ht(e, t, { configurable: !0, enumerable: !0, value: n, writable: !0 }) : (e[t] = n);
          };
          var gt = Object.prototype.hasOwnProperty;
          const pt = function (e, t, n) {
            var o = e[t];
            (gt.call(e, t) && ge(o, n) && (void 0 !== n || t in e)) || mt(e, t, n);
          };
          const ft = function (e, t, n, o) {
            var i = !n;
            n || (n = {});
            for (var r = -1, s = t.length; ++r < s; ) {
              var a = t[r],
                l = o ? o(n[a], e[a], a, n, e) : void 0;
              void 0 === l && (l = e[a]), i ? mt(n, a, l) : pt(n, a, l);
            }
            return n;
          };
          const kt = function (e, t) {
            for (var n = -1, o = Array(e); ++n < e; ) o[n] = t(n);
            return o;
          };
          const bt = function (e) {
            return se(e) && '[object Arguments]' == oe(e);
          };
          var wt = Object.prototype,
            _t = wt.hasOwnProperty,
            yt = wt.propertyIsEnumerable;
          const At = bt(
            (function () {
              return arguments;
            })()
          )
            ? bt
            : function (e) {
                return se(e) && _t.call(e, 'callee') && !yt.call(e, 'callee');
              };
          const Ct = Array.isArray;
          const vt = function () {
            return !1;
          };
          var xt = 'object' == typeof exports && exports && !exports.nodeType && exports,
            Et = xt && 'object' == typeof module && module && !module.nodeType && module,
            Dt = Et && Et.exports === xt ? $.Buffer : void 0;
          const Tt = (Dt ? Dt.isBuffer : void 0) || vt;
          var It = /^(?:0|[1-9]\d*)$/;
          const St = function (e, t) {
            var n = typeof e;
            return (
              !!(t = null == t ? 9007199254740991 : t) && ('number' == n || ('symbol' != n && It.test(e))) && e > -1 && e % 1 == 0 && e < t
            );
          };
          const Mt = function (e) {
            return 'number' == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
          };
          var Bt = {};
          (Bt['[object Float32Array]'] =
            Bt['[object Float64Array]'] =
            Bt['[object Int8Array]'] =
            Bt['[object Int16Array]'] =
            Bt['[object Int32Array]'] =
            Bt['[object Uint8Array]'] =
            Bt['[object Uint8ClampedArray]'] =
            Bt['[object Uint16Array]'] =
            Bt['[object Uint32Array]'] =
              !0),
            (Bt['[object Arguments]'] =
              Bt['[object Array]'] =
              Bt['[object ArrayBuffer]'] =
              Bt['[object Boolean]'] =
              Bt['[object DataView]'] =
              Bt['[object Date]'] =
              Bt['[object Error]'] =
              Bt['[object Function]'] =
              Bt['[object Map]'] =
              Bt['[object Number]'] =
              Bt['[object Object]'] =
              Bt['[object RegExp]'] =
              Bt['[object Set]'] =
              Bt['[object String]'] =
              Bt['[object WeakMap]'] =
                !1);
          const Nt = function (e) {
            return se(e) && Mt(e.length) && !!Bt[oe(e)];
          };
          const Pt = function (e) {
            return function (t) {
              return e(t);
            };
          };
          var zt = 'object' == typeof exports && exports && !exports.nodeType && exports,
            Lt = zt && 'object' == typeof module && module && !module.nodeType && module,
            jt = Lt && Lt.exports === zt && W.process;
          const Ot = (function () {
            try {
              var e = Lt && Lt.require && Lt.require('util').types;
              return e || (jt && jt.binding && jt.binding('util'));
            } catch (e) {}
          })();
          var Rt = Ot && Ot.isTypedArray;
          const Vt = Rt ? Pt(Rt) : Nt;
          var Ft = Object.prototype.hasOwnProperty;
          const Ht = function (e, t) {
            var n = Ct(e),
              o = !n && At(e),
              i = !n && !o && Tt(e),
              r = !n && !o && !i && Vt(e),
              s = n || o || i || r,
              a = s ? kt(e.length, String) : [],
              l = a.length;
            for (var c in e)
              (!t && !Ft.call(e, c)) ||
                (s &&
                  ('length' == c ||
                    (i && ('offset' == c || 'parent' == c)) ||
                    (r && ('buffer' == c || 'byteLength' == c || 'byteOffset' == c)) ||
                    St(c, l))) ||
                a.push(c);
            return a;
          };
          var Ut = Object.prototype;
          const qt = function (e) {
            var t = e && e.constructor;
            return e === (('function' == typeof t && t.prototype) || Ut);
          };
          const Wt = ie(Object.keys, Object);
          var Gt = Object.prototype.hasOwnProperty;
          const $t = function (e) {
            if (!qt(e)) return Wt(e);
            var t = [];
            for (var n in Object(e)) Gt.call(e, n) && 'constructor' != n && t.push(n);
            return t;
          };
          const Yt = function (e) {
            return null != e && Mt(e.length) && !De(e);
          };
          const Kt = function (e) {
            return Yt(e) ? Ht(e) : $t(e);
          };
          const Qt = function (e, t) {
            return e && ft(t, Kt(t), e);
          };
          const Zt = function (e) {
            var t = [];
            if (null != e) for (var n in Object(e)) t.push(n);
            return t;
          };
          var Jt = Object.prototype.hasOwnProperty;
          const Xt = function (e) {
            if (!E(e)) return Zt(e);
            var t = qt(e),
              n = [];
            for (var o in e) ('constructor' != o || (!t && Jt.call(e, o))) && n.push(o);
            return n;
          };
          const en = function (e) {
            return Yt(e) ? Ht(e, !0) : Xt(e);
          };
          const tn = function (e, t) {
            return e && ft(t, en(t), e);
          };
          var nn = 'object' == typeof exports && exports && !exports.nodeType && exports,
            on = nn && 'object' == typeof module && module && !module.nodeType && module,
            rn = on && on.exports === nn ? $.Buffer : void 0,
            sn = rn ? rn.allocUnsafe : void 0;
          const an = function (e, t) {
            if (t) return e.slice();
            var n = e.length,
              o = sn ? sn(n) : new e.constructor(n);
            return e.copy(o), o;
          };
          const ln = function (e, t) {
            var n = -1,
              o = e.length;
            for (t || (t = Array(o)); ++n < o; ) t[n] = e[n];
            return t;
          };
          const cn = function (e, t) {
            for (var n = -1, o = null == e ? 0 : e.length, i = 0, r = []; ++n < o; ) {
              var s = e[n];
              t(s, n, e) && (r[i++] = s);
            }
            return r;
          };
          const dn = function () {
            return [];
          };
          var un = Object.prototype.propertyIsEnumerable,
            hn = Object.getOwnPropertySymbols;
          const mn = hn
            ? function (e) {
                return null == e
                  ? []
                  : ((e = Object(e)),
                    cn(hn(e), function (t) {
                      return un.call(e, t);
                    }));
              }
            : dn;
          const gn = function (e, t) {
            return ft(e, mn(e), t);
          };
          const pn = function (e, t) {
            for (var n = -1, o = t.length, i = e.length; ++n < o; ) e[i + n] = t[n];
            return e;
          };
          const fn = Object.getOwnPropertySymbols
            ? function (e) {
                for (var t = []; e; ) pn(t, mn(e)), (e = re(e));
                return t;
              }
            : dn;
          const kn = function (e, t) {
            return ft(e, fn(e), t);
          };
          const bn = function (e, t, n) {
            var o = t(e);
            return Ct(e) ? o : pn(o, n(e));
          };
          const wn = function (e) {
            return bn(e, Kt, mn);
          };
          const _n = function (e) {
            return bn(e, en, fn);
          };
          const yn = Fe($, 'DataView');
          const An = Fe($, 'Promise');
          const Cn = Fe($, 'Set');
          const vn = Fe($, 'WeakMap');
          var xn = '[object Map]',
            En = '[object Promise]',
            Dn = '[object Set]',
            Tn = '[object WeakMap]',
            In = '[object DataView]',
            Sn = Be(yn),
            Mn = Be(He),
            Bn = Be(An),
            Nn = Be(Cn),
            Pn = Be(vn),
            zn = oe;
          ((yn && zn(new yn(new ArrayBuffer(1))) != In) ||
            (He && zn(new He()) != xn) ||
            (An && zn(An.resolve()) != En) ||
            (Cn && zn(new Cn()) != Dn) ||
            (vn && zn(new vn()) != Tn)) &&
            (zn = function (e) {
              var t = oe(e),
                n = '[object Object]' == t ? e.constructor : void 0,
                o = n ? Be(n) : '';
              if (o)
                switch (o) {
                  case Sn:
                    return In;
                  case Mn:
                    return xn;
                  case Bn:
                    return En;
                  case Nn:
                    return Dn;
                  case Pn:
                    return Tn;
                }
              return t;
            });
          const Ln = zn;
          var jn = Object.prototype.hasOwnProperty;
          const On = function (e) {
            var t = e.length,
              n = new e.constructor(t);
            return t && 'string' == typeof e[0] && jn.call(e, 'index') && ((n.index = e.index), (n.input = e.input)), n;
          };
          const Rn = $.Uint8Array;
          const Vn = function (e) {
            var t = new e.constructor(e.byteLength);
            return new Rn(t).set(new Rn(e)), t;
          };
          const Fn = function (e, t) {
            var n = t ? Vn(e.buffer) : e.buffer;
            return new e.constructor(n, e.byteOffset, e.byteLength);
          };
          var Hn = /\w*$/;
          const Un = function (e) {
            var t = new e.constructor(e.source, Hn.exec(e));
            return (t.lastIndex = e.lastIndex), t;
          };
          var qn = Y ? Y.prototype : void 0,
            Wn = qn ? qn.valueOf : void 0;
          const Gn = function (e) {
            return Wn ? Object(Wn.call(e)) : {};
          };
          const $n = function (e, t) {
            var n = t ? Vn(e.buffer) : e.buffer;
            return new e.constructor(n, e.byteOffset, e.length);
          };
          const Yn = function (e, t, n) {
            var o = e.constructor;
            switch (t) {
              case '[object ArrayBuffer]':
                return Vn(e);
              case '[object Boolean]':
              case '[object Date]':
                return new o(+e);
              case '[object DataView]':
                return Fn(e, n);
              case '[object Float32Array]':
              case '[object Float64Array]':
              case '[object Int8Array]':
              case '[object Int16Array]':
              case '[object Int32Array]':
              case '[object Uint8Array]':
              case '[object Uint8ClampedArray]':
              case '[object Uint16Array]':
              case '[object Uint32Array]':
                return $n(e, n);
              case '[object Map]':
              case '[object Set]':
                return new o();
              case '[object Number]':
              case '[object String]':
                return new o(e);
              case '[object RegExp]':
                return Un(e);
              case '[object Symbol]':
                return Gn(e);
            }
          };
          var Kn = Object.create;
          const Qn = (function () {
            function e() {}
            return function (t) {
              if (!E(t)) return {};
              if (Kn) return Kn(t);
              e.prototype = t;
              var n = new e();
              return (e.prototype = void 0), n;
            };
          })();
          const Zn = function (e) {
            return 'function' != typeof e.constructor || qt(e) ? {} : Qn(re(e));
          };
          const Jn = function (e) {
            return se(e) && '[object Map]' == Ln(e);
          };
          var Xn = Ot && Ot.isMap;
          const eo = Xn ? Pt(Xn) : Jn;
          const to = function (e) {
            return se(e) && '[object Set]' == Ln(e);
          };
          var no = Ot && Ot.isSet;
          const oo = no ? Pt(no) : to;
          var io = '[object Arguments]',
            ro = '[object Function]',
            so = '[object Object]',
            ao = {};
          (ao[io] =
            ao['[object Array]'] =
            ao['[object ArrayBuffer]'] =
            ao['[object DataView]'] =
            ao['[object Boolean]'] =
            ao['[object Date]'] =
            ao['[object Float32Array]'] =
            ao['[object Float64Array]'] =
            ao['[object Int8Array]'] =
            ao['[object Int16Array]'] =
            ao['[object Int32Array]'] =
            ao['[object Map]'] =
            ao['[object Number]'] =
            ao['[object Object]'] =
            ao['[object RegExp]'] =
            ao['[object Set]'] =
            ao['[object String]'] =
            ao['[object Symbol]'] =
            ao['[object Uint8Array]'] =
            ao['[object Uint8ClampedArray]'] =
            ao['[object Uint16Array]'] =
            ao['[object Uint32Array]'] =
              !0),
            (ao['[object Error]'] = ao[ro] = ao['[object WeakMap]'] = !1);
          const lo = function e(t, n, o, i, r, s) {
            var a,
              l = 1 & n,
              c = 2 & n,
              d = 4 & n;
            if ((o && (a = r ? o(t, i, r, s) : o(t)), void 0 !== a)) return a;
            if (!E(t)) return t;
            var u = Ct(t);
            if (u) {
              if (((a = On(t)), !l)) return ln(t, a);
            } else {
              var h = Ln(t),
                m = h == ro || '[object GeneratorFunction]' == h;
              if (Tt(t)) return an(t, l);
              if (h == so || h == io || (m && !r)) {
                if (((a = c || m ? {} : Zn(t)), !l)) return c ? kn(t, tn(a, t)) : gn(t, Qt(a, t));
              } else {
                if (!ao[h]) return r ? t : {};
                a = Yn(t, h, l);
              }
            }
            s || (s = new dt());
            var g = s.get(t);
            if (g) return g;
            s.set(t, a),
              oo(t)
                ? t.forEach(function (i) {
                    a.add(e(i, n, o, i, t, s));
                  })
                : eo(t) &&
                  t.forEach(function (i, r) {
                    a.set(r, e(i, n, o, r, t, s));
                  });
            var p = u ? void 0 : (d ? (c ? _n : wn) : c ? en : Kt)(t);
            return (
              ut(p || t, function (i, r) {
                p && (i = t[(r = i)]), pt(a, r, e(i, n, o, r, t, s));
              }),
              a
            );
          };
          const co = function (e, t) {
            return lo(e, 5, (t = 'function' == typeof t ? t : void 0));
          };
          const uo = function (e) {
            return se(e) && 1 === e.nodeType && !he(e);
          };
          class ho {
            constructor(e, t) {
              (this._config = {}), t && this.define(mo(t)), e && this._setObjectToTarget(this._config, e);
            }
            set(e, t) {
              this._setToTarget(this._config, e, t);
            }
            define(e, t) {
              this._setToTarget(this._config, e, t, !0);
            }
            get(e) {
              return this._getFromSource(this._config, e);
            }
            *names() {
              for (const e of Object.keys(this._config)) yield e;
            }
            _setToTarget(e, t, n, o = !1) {
              if (he(t)) return void this._setObjectToTarget(e, t, o);
              const i = t.split('.');
              t = i.pop();
              for (const t of i) he(e[t]) || (e[t] = {}), (e = e[t]);
              if (he(n)) return he(e[t]) || (e[t] = {}), (e = e[t]), void this._setObjectToTarget(e, n, o);
              (o && void 0 !== e[t]) || (e[t] = n);
            }
            _getFromSource(e, t) {
              const n = t.split('.');
              t = n.pop();
              for (const t of n) {
                if (!he(e[t])) {
                  e = null;
                  break;
                }
                e = e[t];
              }
              return e ? mo(e[t]) : void 0;
            }
            _setObjectToTarget(e, t, n) {
              Object.keys(t).forEach((o) => {
                this._setToTarget(e, o, t[o], n);
              });
            }
          }
          function mo(e) {
            return co(e, go);
          }
          function go(e) {
            return uo(e) ? e : void 0;
          }
          function po(e) {
            return !(!e || !e[Symbol.iterator]);
          }
          class fo extends b {
            constructor(e = {}, t = {}) {
              super();
              const n = po(e);
              if (
                (n || (t = e),
                (this._items = []),
                (this._itemMap = new Map()),
                (this._idProperty = t.idProperty || 'id'),
                (this._bindToExternalToInternalMap = new WeakMap()),
                (this._bindToInternalToExternalMap = new WeakMap()),
                (this._skippedIndexesFromExternal = []),
                n)
              )
                for (const t of e) this._items.push(t), this._itemMap.set(this._getItemIdBeforeAdding(t), t);
            }
            get length() {
              return this._items.length;
            }
            get first() {
              return this._items[0] || null;
            }
            get last() {
              return this._items[this.length - 1] || null;
            }
            add(e, t) {
              return this.addMany([e], t);
            }
            addMany(e, t) {
              if (void 0 === t) t = this._items.length;
              else if (t > this._items.length || t < 0) throw new l('collection-add-item-invalid-index', this);
              let n = 0;
              for (const o of e) {
                const e = this._getItemIdBeforeAdding(o),
                  i = t + n;
                this._items.splice(i, 0, o), this._itemMap.set(e, o), this.fire('add', o, i), n++;
              }
              return this.fire('change', { added: e, removed: [], index: t }), this;
            }
            get(e) {
              let t;
              if ('string' == typeof e) t = this._itemMap.get(e);
              else {
                if ('number' != typeof e) throw new l('collection-get-invalid-arg', this);
                t = this._items[e];
              }
              return t || null;
            }
            has(e) {
              if ('string' == typeof e) return this._itemMap.has(e);
              {
                const t = e[this._idProperty];
                return t && this._itemMap.has(t);
              }
            }
            getIndex(e) {
              let t;
              return (t = 'string' == typeof e ? this._itemMap.get(e) : e), t ? this._items.indexOf(t) : -1;
            }
            remove(e) {
              const [t, n] = this._remove(e);
              return this.fire('change', { added: [], removed: [t], index: n }), t;
            }
            map(e, t) {
              return this._items.map(e, t);
            }
            find(e, t) {
              return this._items.find(e, t);
            }
            filter(e, t) {
              return this._items.filter(e, t);
            }
            clear() {
              this._bindToCollection && (this.stopListening(this._bindToCollection), (this._bindToCollection = null));
              const e = Array.from(this._items);
              for (; this.length; ) this._remove(0);
              this.fire('change', { added: [], removed: e, index: 0 });
            }
            bindTo(e) {
              if (this._bindToCollection) throw new l('collection-bind-to-rebind', this);
              return (
                (this._bindToCollection = e),
                {
                  as: (e) => {
                    this._setUpBindToBinding((t) => new e(t));
                  },
                  using: (e) => {
                    'function' == typeof e ? this._setUpBindToBinding(e) : this._setUpBindToBinding((t) => t[e]);
                  },
                }
              );
            }
            _setUpBindToBinding(e) {
              const t = this._bindToCollection,
                n = (n, o, i) => {
                  const r = t._bindToCollection == this,
                    s = t._bindToInternalToExternalMap.get(o);
                  if (r && s) this._bindToExternalToInternalMap.set(o, s), this._bindToInternalToExternalMap.set(s, o);
                  else {
                    const n = e(o);
                    if (!n) return void this._skippedIndexesFromExternal.push(i);
                    let r = i;
                    for (const e of this._skippedIndexesFromExternal) i > e && r--;
                    for (const e of t._skippedIndexesFromExternal) r >= e && r++;
                    this._bindToExternalToInternalMap.set(o, n), this._bindToInternalToExternalMap.set(n, o), this.add(n, r);
                    for (let e = 0; e < t._skippedIndexesFromExternal.length; e++)
                      r <= t._skippedIndexesFromExternal[e] && t._skippedIndexesFromExternal[e]++;
                  }
                };
              for (const e of t) n(0, e, t.getIndex(e));
              this.listenTo(t, 'add', n),
                this.listenTo(t, 'remove', (e, t, n) => {
                  const o = this._bindToExternalToInternalMap.get(t);
                  o && this.remove(o),
                    (this._skippedIndexesFromExternal = this._skippedIndexesFromExternal.reduce(
                      (e, t) => (n < t && e.push(t - 1), n > t && e.push(t), e),
                      []
                    ));
                });
            }
            _getItemIdBeforeAdding(e) {
              const t = this._idProperty;
              let n;
              if (t in e) {
                if (((n = e[t]), 'string' != typeof n)) throw new l('collection-add-invalid-id', this);
                if (this.get(n)) throw new l('collection-add-item-already-exists', this);
              } else e[t] = n = r();
              return n;
            }
            _remove(e) {
              let t,
                n,
                o,
                i = !1;
              const r = this._idProperty;
              if (
                ('string' == typeof e
                  ? ((n = e), (o = this._itemMap.get(n)), (i = !o), o && (t = this._items.indexOf(o)))
                  : 'number' == typeof e
                  ? ((t = e), (o = this._items[t]), (i = !o), o && (n = o[r]))
                  : ((o = e), (n = o[r]), (t = this._items.indexOf(o)), (i = -1 == t || !this._itemMap.get(n))),
                i)
              )
                throw new l('collection-remove-404', this);
              this._items.splice(t, 1), this._itemMap.delete(n);
              const s = this._bindToInternalToExternalMap.get(o);
              return (
                this._bindToInternalToExternalMap.delete(o), this._bindToExternalToInternalMap.delete(s), this.fire('remove', o, t), [o, t]
              );
            }
            [Symbol.iterator]() {
              return this._items[Symbol.iterator]();
            }
          }
          class ko {
            constructor(e, t = [], n = []) {
              (this._context = e), (this._plugins = new Map()), (this._availablePlugins = new Map());
              for (const e of t) e.pluginName && this._availablePlugins.set(e.pluginName, e);
              this._contextPlugins = new Map();
              for (const [e, t] of n)
                this._contextPlugins.set(e, t), this._contextPlugins.set(t, e), e.pluginName && this._availablePlugins.set(e.pluginName, e);
            }
            *[Symbol.iterator]() {
              for (const e of this._plugins) 'function' == typeof e[0] && (yield e);
            }
            get(e) {
              const t = this._plugins.get(e);
              if (!t) {
                let t = e;
                throw (
                  ('function' == typeof e && (t = e.pluginName || e.name),
                  new l('plugincollection-plugin-not-loaded', this._context, { plugin: t }))
                );
              }
              return t;
            }
            has(e) {
              return this._plugins.has(e);
            }
            init(e, t = [], n = []) {
              const o = this,
                i = this._context;
              !(function e(t, n = new Set()) {
                t.forEach((t) => {
                  a(t) &&
                    (n.has(t) ||
                      (n.add(t),
                      t.pluginName && !o._availablePlugins.has(t.pluginName) && o._availablePlugins.set(t.pluginName, t),
                      t.requires && e(t.requires, n)));
                });
              })(e),
                h(e);
              const r = [
                ...(function e(t, n = new Set()) {
                  return t
                    .map((e) => (a(e) ? e : o._availablePlugins.get(e)))
                    .reduce(
                      (t, o) =>
                        n.has(o) ? t : (n.add(o), o.requires && (h(o.requires, o), e(o.requires, n).forEach((e) => t.add(e))), t.add(o)),
                      new Set()
                    );
                })(e.filter((e) => !d(e, t))),
              ];
              !(function (e, t) {
                for (const n of t) {
                  if ('function' != typeof n) throw new l('plugincollection-replace-plugin-invalid-type', null, { pluginItem: n });
                  const t = n.pluginName;
                  if (!t) throw new l('plugincollection-replace-plugin-missing-name', null, { pluginItem: n });
                  if (n.requires && n.requires.length)
                    throw new l('plugincollection-plugin-for-replacing-cannot-have-dependencies', null, { pluginName: t });
                  const i = o._availablePlugins.get(t);
                  if (!i) throw new l('plugincollection-plugin-for-replacing-not-exist', null, { pluginName: t });
                  const r = e.indexOf(i);
                  if (-1 === r) {
                    if (o._contextPlugins.has(i)) return;
                    throw new l('plugincollection-plugin-for-replacing-not-loaded', null, { pluginName: t });
                  }
                  if (i.requires && i.requires.length)
                    throw new l('plugincollection-replaced-plugin-cannot-have-dependencies', null, { pluginName: t });
                  e.splice(r, 1, n), o._availablePlugins.set(t, n);
                }
              })(r, n);
              const s = (function (e) {
                return e.map((e) => {
                  const t = o._contextPlugins.get(e) || new e(i);
                  return o._add(e, t), t;
                });
              })(r);
              return m(s, 'init')
                .then(() => m(s, 'afterInit'))
                .then(() => s);
              function a(e) {
                return 'function' == typeof e;
              }
              function c(e) {
                return a(e) && e.isContextPlugin;
              }
              function d(e, t) {
                return t.some((t) => t === e || u(e) === t || u(t) === e);
              }
              function u(e) {
                return a(e) ? e.pluginName || e.name : e;
              }
              function h(e, n = null) {
                e.map((e) => (a(e) ? e : o._availablePlugins.get(e) || e)).forEach((e) => {
                  !(function (e, t) {
                    if (a(e)) return;
                    if (t) throw new l('plugincollection-soft-required', i, { missingPlugin: e, requiredBy: u(t) });
                    throw new l('plugincollection-plugin-not-found', i, { plugin: e });
                  })(e, n),
                    (function (e, t) {
                      if (!c(t)) return;
                      if (c(e)) return;
                      throw new l('plugincollection-context-required', i, { plugin: u(e), requiredBy: u(t) });
                    })(e, n),
                    (function (e, n) {
                      if (!n) return;
                      if (!d(e, t)) return;
                      throw new l('plugincollection-required', i, { plugin: u(e), requiredBy: u(n) });
                    })(e, n);
                });
              }
              function m(e, t) {
                return e.reduce((e, n) => (n[t] ? (o._contextPlugins.has(n) ? e : e.then(n[t].bind(n))) : e), Promise.resolve());
              }
            }
            destroy() {
              const e = [];
              for (const [, t] of this) 'function' != typeof t.destroy || this._contextPlugins.has(t) || e.push(t.destroy());
              return Promise.all(e);
            }
            _add(e, t) {
              this._plugins.set(e, t);
              const n = e.pluginName;
              if (n) {
                if (this._plugins.has(n))
                  throw new l('plugincollection-plugin-name-conflict', null, {
                    pluginName: n,
                    plugin1: this._plugins.get(n).constructor,
                    plugin2: e,
                  });
                this._plugins.set(n, t);
              }
            }
          }
          function bo(e) {
            return Array.isArray(e) ? e : [e];
          }
          let wo;
          R(ko, k);
          try {
            wo = { window, document };
          } catch (e) {
            wo = { window: {}, document: {} };
          }
          const _o = wo;
          function yo(e, t, n = 1) {
            if ('number' != typeof n) throw new l('translation-service-quantity-not-a-number', null, { quantity: n });
            const o = Object.keys(_o.window.CKEDITOR_TRANSLATIONS).length;
            1 === o && (e = Object.keys(_o.window.CKEDITOR_TRANSLATIONS)[0]);
            const i = t.id || t.string;
            if (
              0 === o ||
              !(function (e, t) {
                return !!_o.window.CKEDITOR_TRANSLATIONS[e] && !!_o.window.CKEDITOR_TRANSLATIONS[e].dictionary[t];
              })(e, i)
            )
              return 1 !== n ? t.plural : t.string;
            const r = _o.window.CKEDITOR_TRANSLATIONS[e].dictionary,
              s = _o.window.CKEDITOR_TRANSLATIONS[e].getPluralForm || ((e) => (1 === e ? 0 : 1)),
              a = r[i];
            if ('string' == typeof a) return a;
            return a[Number(s(n))];
          }
          _o.window.CKEDITOR_TRANSLATIONS || (_o.window.CKEDITOR_TRANSLATIONS = {});
          const Ao = ['ar', 'ara', 'fa', 'per', 'fas', 'he', 'heb', 'ku', 'kur', 'ug', 'uig'];
          function Co(e) {
            return Ao.includes(e) ? 'rtl' : 'ltr';
          }
          class vo {
            constructor(e = {}) {
              (this.uiLanguage = e.uiLanguage || 'en'),
                (this.contentLanguage = e.contentLanguage || this.uiLanguage),
                (this.uiLanguageDirection = Co(this.uiLanguage)),
                (this.contentLanguageDirection = Co(this.contentLanguage)),
                (this.t = (e, t) => this._t(e, t));
            }
            get language() {
              return (
                console.warn(
                  'locale-deprecated-language-property: The Locale#language property has been deprecated and will be removed in the near future. Please use #uiLanguage and #contentLanguage properties instead.'
                ),
                this.uiLanguage
              );
            }
            _t(e, t = []) {
              (t = bo(t)), 'string' == typeof e && (e = { string: e });
              const n = !!e.plural ? t[0] : 1;
              return (function (e, t) {
                return e.replace(/%(\d+)/g, (e, n) => (n < t.length ? t[n] : e));
              })(yo(this.uiLanguage, e, n), t);
            }
          }
          class xo {
            constructor(e) {
              this.config = new ho(e, this.constructor.defaultConfig);
              const t = this.constructor.builtinPlugins;
              this.config.define('plugins', t), (this.plugins = new ko(this, t));
              const n = this.config.get('language') || {};
              (this.locale = new vo({ uiLanguage: 'string' == typeof n ? n : n.ui, contentLanguage: this.config.get('language.content') })),
                (this.t = this.locale.t),
                (this.editors = new fo()),
                (this._contextOwner = null);
            }
            initPlugins() {
              const e = this.config.get('plugins') || [],
                t = this.config.get('substitutePlugins') || [];
              for (const n of e.concat(t)) {
                if ('function' != typeof n) throw new l('context-initplugins-constructor-only', null, { Plugin: n });
                if (!0 !== n.isContextPlugin) throw new l('context-initplugins-invalid-plugin', null, { Plugin: n });
              }
              return this.plugins.init(e, [], t);
            }
            destroy() {
              return Promise.all(Array.from(this.editors, (e) => e.destroy())).then(() => this.plugins.destroy());
            }
            _addEditor(e, t) {
              if (this._contextOwner) throw new l('context-addeditor-private-context');
              this.editors.add(e), t && (this._contextOwner = e);
            }
            _removeEditor(e) {
              return this.editors.has(e) && this.editors.remove(e), this._contextOwner === e ? this.destroy() : Promise.resolve();
            }
            _getEditorConfig() {
              const e = {};
              for (const t of this.config.names()) ['plugins', 'removePlugins', 'extraPlugins'].includes(t) || (e[t] = this.config.get(t));
              return e;
            }
            static create(e) {
              return new Promise((t) => {
                const n = new this(e);
                t(n.initPlugins().then(() => n));
              });
            }
          }
          class Eo {
            constructor(e) {
              this.context = e;
            }
            destroy() {
              this.stopListening();
            }
            static get isContextPlugin() {
              return !0;
            }
          }
          R(Eo, B);
          class Do {
            is() {
              throw new Error('is() method is abstract');
            }
          }
          function To(e, t) {
            const n = Math.min(e.length, t.length);
            for (let o = 0; o < n; o++) if (e[o] != t[o]) return o;
            return e.length == t.length ? 'same' : e.length < t.length ? 'prefix' : 'extension';
          }
          const Io = function (e) {
            return lo(e, 4);
          };
          class So extends k(Do) {
            constructor(e) {
              super(), (this.document = e), (this.parent = null);
            }
            get index() {
              let e;
              if (!this.parent) return null;
              if (-1 == (e = this.parent.getChildIndex(this))) throw new l('view-node-not-found-in-parent', this);
              return e;
            }
            get nextSibling() {
              const e = this.index;
              return (null !== e && this.parent.getChild(e + 1)) || null;
            }
            get previousSibling() {
              const e = this.index;
              return (null !== e && this.parent.getChild(e - 1)) || null;
            }
            get root() {
              let e = this;
              for (; e.parent; ) e = e.parent;
              return e;
            }
            isAttached() {
              return this.root.is('rootElement');
            }
            getPath() {
              const e = [];
              let t = this;
              for (; t.parent; ) e.unshift(t.index), (t = t.parent);
              return e;
            }
            getAncestors(e = {}) {
              const t = [];
              let n = e.includeSelf ? this : this.parent;
              for (; n; ) t[e.parentFirst ? 'push' : 'unshift'](n), (n = n.parent);
              return t;
            }
            getCommonAncestor(e, t = {}) {
              const n = this.getAncestors(t),
                o = e.getAncestors(t);
              let i = 0;
              for (; n[i] == o[i] && n[i]; ) i++;
              return 0 === i ? null : n[i - 1];
            }
            isBefore(e) {
              if (this == e) return !1;
              if (this.root !== e.root) return !1;
              const t = this.getPath(),
                n = e.getPath(),
                o = To(t, n);
              switch (o) {
                case 'prefix':
                  return !0;
                case 'extension':
                  return !1;
                default:
                  return t[o] < n[o];
              }
            }
            isAfter(e) {
              return this != e && this.root === e.root && !this.isBefore(e);
            }
            _remove() {
              this.parent._removeChildren(this.index);
            }
            _fireChange(e, t) {
              this.fire(`change:${e}`, t), this.parent && this.parent._fireChange(e, t);
            }
            toJSON() {
              const e = Io(this);
              return delete e.parent, e;
            }
          }
          So.prototype.is = function (e) {
            return 'node' === e || 'view:node' === e;
          };
          class Mo extends So {
            constructor(e, t) {
              super(e), (this._textData = t);
            }
            get data() {
              return this._textData;
            }
            get _data() {
              return this.data;
            }
            set _data(e) {
              this._fireChange('text', this), (this._textData = e);
            }
            isSimilar(e) {
              return e instanceof Mo && (this === e || this.data === e.data);
            }
            _clone() {
              return new Mo(this.document, this.data);
            }
          }
          Mo.prototype.is = function (e) {
            return '$text' === e || 'view:$text' === e || 'text' === e || 'view:text' === e || 'node' === e || 'view:node' === e;
          };
          class Bo extends Do {
            constructor(e, t, n) {
              if ((super(), (this.textNode = e), t < 0 || t > e.data.length)) throw new l('view-textproxy-wrong-offsetintext', this);
              if (n < 0 || t + n > e.data.length) throw new l('view-textproxy-wrong-length', this);
              (this.data = e.data.substring(t, t + n)), (this.offsetInText = t);
            }
            get offsetSize() {
              return this.data.length;
            }
            get isPartial() {
              return this.data.length !== this.textNode.data.length;
            }
            get parent() {
              return this.textNode.parent;
            }
            get root() {
              return this.textNode.root;
            }
            get document() {
              return this.textNode.document;
            }
            getAncestors(e = {}) {
              const t = [];
              let n = e.includeSelf ? this.textNode : this.parent;
              for (; null !== n; ) t[e.parentFirst ? 'push' : 'unshift'](n), (n = n.parent);
              return t;
            }
          }
          function No(e) {
            return po(e)
              ? new Map(e)
              : (function (e) {
                  const t = new Map();
                  for (const n in e) t.set(n, e[n]);
                  return t;
                })(e);
          }
          Bo.prototype.is = function (e) {
            return '$textProxy' === e || 'view:$textProxy' === e || 'textProxy' === e || 'view:textProxy' === e;
          };
          class Po {
            constructor(...e) {
              (this._patterns = []), this.add(...e);
            }
            add(...e) {
              for (let t of e) ('string' == typeof t || t instanceof RegExp) && (t = { name: t }), this._patterns.push(t);
            }
            match(...e) {
              for (const t of e)
                for (const e of this._patterns) {
                  const n = zo(t, e);
                  if (n) return { element: t, pattern: e, match: n };
                }
              return null;
            }
            matchAll(...e) {
              const t = [];
              for (const n of e)
                for (const e of this._patterns) {
                  const o = zo(n, e);
                  o && t.push({ element: n, pattern: e, match: o });
                }
              return t.length > 0 ? t : null;
            }
            getElementName() {
              if (1 !== this._patterns.length) return null;
              const e = this._patterns[0],
                t = e.name;
              return 'function' == typeof e || !t || t instanceof RegExp ? null : t;
            }
          }
          function zo(e, t) {
            if ('function' == typeof t) return t(e);
            const n = {};
            return (t.name &&
              ((n.name = (function (e, t) {
                if (e instanceof RegExp) return !!t.match(e);
                return e === t;
              })(t.name, e.name)),
              !n.name)) ||
              (t.attributes &&
                ((n.attributes = (function (e, t) {
                  const n = new Set(t.getAttributeKeys());
                  he(e)
                    ? (void 0 !== e.style && c('matcher-pattern-deprecated-attributes-style-key', e),
                      void 0 !== e.class && c('matcher-pattern-deprecated-attributes-class-key', e))
                    : (n.delete('style'), n.delete('class'));
                  return Lo(e, n, (e) => t.getAttribute(e));
                })(t.attributes, e)),
                !n.attributes)) ||
              (t.classes &&
                ((n.classes = (function (e, t) {
                  return Lo(e, t.getClassNames(), () => {});
                })(t.classes, e)),
                !n.classes)) ||
              (t.styles &&
                ((n.styles = (function (e, t) {
                  return Lo(e, t.getStyleNames(!0), (e) => t.getStyle(e));
                })(t.styles, e)),
                !n.styles))
              ? null
              : n;
          }
          function Lo(e, t, n) {
            const o = (function (e) {
                if (Array.isArray(e))
                  return e.map((e) =>
                    he(e)
                      ? ((void 0 !== e.key && void 0 !== e.value) || c('matcher-pattern-missing-key-or-value', e), [e.key, e.value])
                      : [e, !0]
                  );
                if (he(e)) return Object.entries(e);
                return [[e, !0]];
              })(e),
              i = Array.from(t),
              r = [];
            if (
              (o.forEach(([e, t]) => {
                i.forEach((o) => {
                  (function (e, t) {
                    return !0 === e || e === t || (e instanceof RegExp && t.match(e));
                  })(e, o) &&
                    (function (e, t, n) {
                      if (!0 === e) return !0;
                      const o = n(t);
                      return e === o || (e instanceof RegExp && !!String(o).match(e));
                    })(t, o, n) &&
                    r.push(o);
                });
              }),
              o.length && !(r.length < o.length))
            )
              return r;
          }
          const jo = function (e) {
            return 'symbol' == typeof e || (se(e) && '[object Symbol]' == oe(e));
          };
          var Oo = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
            Ro = /^\w*$/;
          const Vo = function (e, t) {
            if (Ct(e)) return !1;
            var n = typeof e;
            return (
              !('number' != n && 'symbol' != n && 'boolean' != n && null != e && !jo(e)) ||
              Ro.test(e) ||
              !Oo.test(e) ||
              (null != t && e in Object(t))
            );
          };
          function Fo(e, t) {
            if ('function' != typeof e || (null != t && 'function' != typeof t)) throw new TypeError('Expected a function');
            var n = function () {
              var o = arguments,
                i = t ? t.apply(this, o) : o[0],
                r = n.cache;
              if (r.has(i)) return r.get(i);
              var s = e.apply(this, o);
              return (n.cache = r.set(i, s) || r), s;
            };
            return (n.cache = new (Fo.Cache || at)()), n;
          }
          Fo.Cache = at;
          const Ho = Fo;
          var Uo = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
            qo = /\\(\\)?/g,
            Wo = (function (e) {
              var t = Ho(e, function (e) {
                  return 500 === n.size && n.clear(), e;
                }),
                n = t.cache;
              return t;
            })(function (e) {
              var t = [];
              return (
                46 === e.charCodeAt(0) && t.push(''),
                e.replace(Uo, function (e, n, o, i) {
                  t.push(o ? i.replace(qo, '$1') : n || e);
                }),
                t
              );
            });
          const Go = Wo;
          const $o = function (e, t) {
            for (var n = -1, o = null == e ? 0 : e.length, i = Array(o); ++n < o; ) i[n] = t(e[n], n, e);
            return i;
          };
          var Yo = Y ? Y.prototype : void 0,
            Ko = Yo ? Yo.toString : void 0;
          const Qo = function e(t) {
            if ('string' == typeof t) return t;
            if (Ct(t)) return $o(t, e) + '';
            if (jo(t)) return Ko ? Ko.call(t) : '';
            var n = t + '';
            return '0' == n && 1 / t == -Infinity ? '-0' : n;
          };
          const Zo = function (e) {
            return null == e ? '' : Qo(e);
          };
          const Jo = function (e, t) {
            return Ct(e) ? e : Vo(e, t) ? [e] : Go(Zo(e));
          };
          const Xo = function (e) {
            var t = null == e ? 0 : e.length;
            return t ? e[t - 1] : void 0;
          };
          const ei = function (e) {
            if ('string' == typeof e || jo(e)) return e;
            var t = e + '';
            return '0' == t && 1 / e == -Infinity ? '-0' : t;
          };
          const ti = function (e, t) {
            for (var n = 0, o = (t = Jo(t, e)).length; null != e && n < o; ) e = e[ei(t[n++])];
            return n && n == o ? e : void 0;
          };
          const ni = function (e, t, n) {
            var o = -1,
              i = e.length;
            t < 0 && (t = -t > i ? 0 : i + t), (n = n > i ? i : n) < 0 && (n += i), (i = t > n ? 0 : (n - t) >>> 0), (t >>>= 0);
            for (var r = Array(i); ++o < i; ) r[o] = e[o + t];
            return r;
          };
          const oi = function (e, t) {
            return t.length < 2 ? e : ti(e, ni(t, 0, -1));
          };
          const ii = function (e, t) {
            return (t = Jo(t, e)), null == (e = oi(e, t)) || delete e[ei(Xo(t))];
          };
          const ri = function (e, t) {
            return null == e || ii(e, t);
          };
          const si = function (e, t, n) {
            var o = null == e ? void 0 : ti(e, t);
            return void 0 === o ? n : o;
          };
          const ai = function (e, t, n) {
            ((void 0 !== n && !ge(e[t], n)) || (void 0 === n && !(t in e))) && mt(e, t, n);
          };
          const li = (function (e) {
            return function (t, n, o) {
              for (var i = -1, r = Object(t), s = o(t), a = s.length; a--; ) {
                var l = s[e ? a : ++i];
                if (!1 === n(r[l], l, r)) break;
              }
              return t;
            };
          })();
          const ci = function (e) {
            return se(e) && Yt(e);
          };
          const di = function (e, t) {
            if (('constructor' !== t || 'function' != typeof e[t]) && '__proto__' != t) return e[t];
          };
          const ui = function (e) {
            return ft(e, en(e));
          };
          const hi = function (e, t, n, o, i, r, s) {
            var a = di(e, n),
              l = di(t, n),
              c = s.get(l);
            if (c) ai(e, n, c);
            else {
              var d = r ? r(a, l, n + '', e, t, s) : void 0,
                u = void 0 === d;
              if (u) {
                var h = Ct(l),
                  m = !h && Tt(l),
                  g = !h && !m && Vt(l);
                (d = l),
                  h || m || g
                    ? Ct(a)
                      ? (d = a)
                      : ci(a)
                      ? (d = ln(a))
                      : m
                      ? ((u = !1), (d = an(l, !0)))
                      : g
                      ? ((u = !1), (d = $n(l, !0)))
                      : (d = [])
                    : he(l) || At(l)
                    ? ((d = a), At(a) ? (d = ui(a)) : (E(a) && !De(a)) || (d = Zn(l)))
                    : (u = !1);
              }
              u && (s.set(l, d), i(d, l, o, r, s), s.delete(l)), ai(e, n, d);
            }
          };
          const mi = function e(t, n, o, i, r) {
            t !== n &&
              li(
                n,
                function (s, a) {
                  if ((r || (r = new dt()), E(s))) hi(t, n, a, o, e, i, r);
                  else {
                    var l = i ? i(di(t, a), s, a + '', t, n, r) : void 0;
                    void 0 === l && (l = s), ai(t, a, l);
                  }
                },
                en
              );
          };
          const gi = function (e) {
            return e;
          };
          const pi = function (e, t, n) {
            switch (n.length) {
              case 0:
                return e.call(t);
              case 1:
                return e.call(t, n[0]);
              case 2:
                return e.call(t, n[0], n[1]);
              case 3:
                return e.call(t, n[0], n[1], n[2]);
            }
            return e.apply(t, n);
          };
          var fi = Math.max;
          const ki = function (e, t, n) {
            return (
              (t = fi(void 0 === t ? e.length - 1 : t, 0)),
              function () {
                for (var o = arguments, i = -1, r = fi(o.length - t, 0), s = Array(r); ++i < r; ) s[i] = o[t + i];
                i = -1;
                for (var a = Array(t + 1); ++i < t; ) a[i] = o[i];
                return (a[t] = n(s)), pi(e, this, a);
              }
            );
          };
          const bi = function (e) {
            return function () {
              return e;
            };
          };
          const wi = ht
            ? function (e, t) {
                return ht(e, 'toString', { configurable: !0, enumerable: !1, value: bi(t), writable: !0 });
              }
            : gi;
          var _i = Date.now;
          const yi = function (e) {
            var t = 0,
              n = 0;
            return function () {
              var o = _i(),
                i = 16 - (o - n);
              if (((n = o), i > 0)) {
                if (++t >= 800) return arguments[0];
              } else t = 0;
              return e.apply(void 0, arguments);
            };
          };
          const Ai = yi(wi);
          const Ci = function (e, t) {
            return Ai(ki(e, t, gi), e + '');
          };
          const vi = function (e, t, n) {
            if (!E(n)) return !1;
            var o = typeof t;
            return !!('number' == o ? Yt(n) && St(t, n.length) : 'string' == o && t in n) && ge(n[t], e);
          };
          const xi = function (e) {
            return Ci(function (t, n) {
              var o = -1,
                i = n.length,
                r = i > 1 ? n[i - 1] : void 0,
                s = i > 2 ? n[2] : void 0;
              for (
                r = e.length > 3 && 'function' == typeof r ? (i--, r) : void 0,
                  s && vi(n[0], n[1], s) && ((r = i < 3 ? void 0 : r), (i = 1)),
                  t = Object(t);
                ++o < i;

              ) {
                var a = n[o];
                a && e(t, a, o, r);
              }
              return t;
            });
          };
          const Ei = xi(function (e, t, n) {
            mi(e, t, n);
          });
          const Di = function (e, t, n, o) {
            if (!E(e)) return e;
            for (var i = -1, r = (t = Jo(t, e)).length, s = r - 1, a = e; null != a && ++i < r; ) {
              var l = ei(t[i]),
                c = n;
              if ('__proto__' === l || 'constructor' === l || 'prototype' === l) return e;
              if (i != s) {
                var d = a[l];
                void 0 === (c = o ? o(d, l, a) : void 0) && (c = E(d) ? d : St(t[i + 1]) ? [] : {});
              }
              pt(a, l, c), (a = a[l]);
            }
            return e;
          };
          const Ti = function (e, t, n) {
            return null == e ? e : Di(e, t, n);
          };
          class Ii {
            constructor(e) {
              (this._styles = {}), (this._styleProcessor = e);
            }
            get isEmpty() {
              const e = Object.entries(this._styles);
              return !Array.from(e).length;
            }
            get size() {
              return this.isEmpty ? 0 : this.getStyleNames().length;
            }
            setTo(e) {
              this.clear();
              const t = Array.from(
                (function (e) {
                  let t = null,
                    n = 0,
                    o = 0,
                    i = null;
                  const r = new Map();
                  if ('' === e) return r;
                  ';' != e.charAt(e.length - 1) && (e += ';');
                  for (let s = 0; s < e.length; s++) {
                    const a = e.charAt(s);
                    if (null === t)
                      switch (a) {
                        case ':':
                          i || ((i = e.substr(n, s - n)), (o = s + 1));
                          break;
                        case '"':
                        case "'":
                          t = a;
                          break;
                        case ';': {
                          const t = e.substr(o, s - o);
                          i && r.set(i.trim(), t.trim()), (i = null), (n = s + 1);
                          break;
                        }
                      }
                    else a === t && (t = null);
                  }
                  return r;
                })(e).entries()
              );
              for (const [e, n] of t) this._styleProcessor.toNormalizedForm(e, n, this._styles);
            }
            has(e) {
              if (this.isEmpty) return !1;
              const t = this._styleProcessor.getReducedForm(e, this._styles).find(([t]) => t === e);
              return Array.isArray(t);
            }
            set(e, t) {
              if (E(e)) for (const [t, n] of Object.entries(e)) this._styleProcessor.toNormalizedForm(t, n, this._styles);
              else this._styleProcessor.toNormalizedForm(e, t, this._styles);
            }
            remove(e) {
              const t = Mi(e);
              ri(this._styles, t), delete this._styles[e], this._cleanEmptyObjectsOnPath(t);
            }
            getNormalized(e) {
              return this._styleProcessor.getNormalized(e, this._styles);
            }
            toString() {
              return this.isEmpty
                ? ''
                : this._getStylesEntries()
                    .map((e) => e.join(':'))
                    .sort()
                    .join(';') + ';';
            }
            getAsString(e) {
              if (this.isEmpty) return;
              if (this._styles[e] && !E(this._styles[e])) return this._styles[e];
              const t = this._styleProcessor.getReducedForm(e, this._styles).find(([t]) => t === e);
              return Array.isArray(t) ? t[1] : void 0;
            }
            getStyleNames(e = !1) {
              if (this.isEmpty) return [];
              if (e) return this._styleProcessor.getStyleNames(this._styles);
              return this._getStylesEntries().map(([e]) => e);
            }
            clear() {
              this._styles = {};
            }
            _getStylesEntries() {
              const e = [],
                t = Object.keys(this._styles);
              for (const n of t) e.push(...this._styleProcessor.getReducedForm(n, this._styles));
              return e;
            }
            _cleanEmptyObjectsOnPath(e) {
              const t = e.split('.');
              if (!(t.length > 1)) return;
              const n = t.splice(0, t.length - 1).join('.'),
                o = si(this._styles, n);
              if (!o) return;
              !Array.from(Object.keys(o)).length && this.remove(n);
            }
          }
          class Si {
            constructor() {
              (this._normalizers = new Map()),
                (this._extractors = new Map()),
                (this._reducers = new Map()),
                (this._consumables = new Map());
            }
            toNormalizedForm(e, t, n) {
              if (E(t)) Bi(n, Mi(e), t);
              else if (this._normalizers.has(e)) {
                const o = this._normalizers.get(e),
                  { path: i, value: r } = o(t);
                Bi(n, i, r);
              } else Bi(n, e, t);
            }
            getNormalized(e, t) {
              if (!e) return Ei({}, t);
              if (void 0 !== t[e]) return t[e];
              if (this._extractors.has(e)) {
                const n = this._extractors.get(e);
                if ('string' == typeof n) return si(t, n);
                const o = n(e, t);
                if (o) return o;
              }
              return si(t, Mi(e));
            }
            getReducedForm(e, t) {
              const n = this.getNormalized(e, t);
              if (void 0 === n) return [];
              if (this._reducers.has(e)) {
                return this._reducers.get(e)(n);
              }
              return [[e, n]];
            }
            getStyleNames(e) {
              const t = Array.from(this._consumables.keys()).filter((t) => {
                  const n = this.getNormalized(t, e);
                  return n && 'object' == typeof n ? Object.keys(n).length : n;
                }),
                n = new Set([...t, ...Object.keys(e)]);
              return Array.from(n.values());
            }
            getRelatedStyles(e) {
              return this._consumables.get(e) || [];
            }
            setNormalizer(e, t) {
              this._normalizers.set(e, t);
            }
            setExtractor(e, t) {
              this._extractors.set(e, t);
            }
            setReducer(e, t) {
              this._reducers.set(e, t);
            }
            setStyleRelation(e, t) {
              this._mapStyleNames(e, t);
              for (const n of t) this._mapStyleNames(n, [e]);
            }
            _mapStyleNames(e, t) {
              this._consumables.has(e) || this._consumables.set(e, []), this._consumables.get(e).push(...t);
            }
          }
          function Mi(e) {
            return e.replace('-', '.');
          }
          function Bi(e, t, n) {
            let o = n;
            E(n) && (o = Ei({}, si(e, t), n)), Ti(e, t, o);
          }
          class Ni extends So {
            constructor(e, t, n, o) {
              if (
                (super(e),
                (this.name = t),
                (this._attrs = (function (e) {
                  const t = No(e);
                  for (const [e, n] of t) null === n ? t.delete(e) : 'string' != typeof n && t.set(e, String(n));
                  return t;
                })(n)),
                (this._children = []),
                o && this._insertChild(0, o),
                (this._classes = new Set()),
                this._attrs.has('class'))
              ) {
                const e = this._attrs.get('class');
                Pi(this._classes, e), this._attrs.delete('class');
              }
              (this._styles = new Ii(this.document.stylesProcessor)),
                this._attrs.has('style') && (this._styles.setTo(this._attrs.get('style')), this._attrs.delete('style')),
                (this._customProperties = new Map()),
                (this._unsafeAttributesToRender = []);
            }
            get childCount() {
              return this._children.length;
            }
            get isEmpty() {
              return 0 === this._children.length;
            }
            getChild(e) {
              return this._children[e];
            }
            getChildIndex(e) {
              return this._children.indexOf(e);
            }
            getChildren() {
              return this._children[Symbol.iterator]();
            }
            *getAttributeKeys() {
              this._classes.size > 0 && (yield 'class'), this._styles.isEmpty || (yield 'style'), yield* this._attrs.keys();
            }
            *getAttributes() {
              yield* this._attrs.entries(),
                this._classes.size > 0 && (yield ['class', this.getAttribute('class')]),
                this._styles.isEmpty || (yield ['style', this.getAttribute('style')]);
            }
            getAttribute(e) {
              if ('class' == e) return this._classes.size > 0 ? [...this._classes].join(' ') : void 0;
              if ('style' == e) {
                const e = this._styles.toString();
                return '' == e ? void 0 : e;
              }
              return this._attrs.get(e);
            }
            hasAttribute(e) {
              return 'class' == e ? this._classes.size > 0 : 'style' == e ? !this._styles.isEmpty : this._attrs.has(e);
            }
            isSimilar(e) {
              if (!(e instanceof Ni)) return !1;
              if (this === e) return !0;
              if (this.name != e.name) return !1;
              if (this._attrs.size !== e._attrs.size || this._classes.size !== e._classes.size || this._styles.size !== e._styles.size)
                return !1;
              for (const [t, n] of this._attrs) if (!e._attrs.has(t) || e._attrs.get(t) !== n) return !1;
              for (const t of this._classes) if (!e._classes.has(t)) return !1;
              for (const t of this._styles.getStyleNames())
                if (!e._styles.has(t) || e._styles.getAsString(t) !== this._styles.getAsString(t)) return !1;
              return !0;
            }
            hasClass(...e) {
              for (const t of e) if (!this._classes.has(t)) return !1;
              return !0;
            }
            getClassNames() {
              return this._classes.keys();
            }
            getStyle(e) {
              return this._styles.getAsString(e);
            }
            getNormalizedStyle(e) {
              return this._styles.getNormalized(e);
            }
            getStyleNames(e) {
              return this._styles.getStyleNames(e);
            }
            hasStyle(...e) {
              for (const t of e) if (!this._styles.has(t)) return !1;
              return !0;
            }
            findAncestor(...e) {
              const t = new Po(...e);
              let n = this.parent;
              for (; n && !n.is('documentFragment'); ) {
                if (t.match(n)) return n;
                n = n.parent;
              }
              return null;
            }
            getCustomProperty(e) {
              return this._customProperties.get(e);
            }
            *getCustomProperties() {
              yield* this._customProperties.entries();
            }
            getIdentity() {
              const e = Array.from(this._classes).sort().join(','),
                t = this._styles.toString(),
                n = Array.from(this._attrs)
                  .map((e) => `${e[0]}="${e[1]}"`)
                  .sort()
                  .join(' ');
              return this.name + ('' == e ? '' : ` class="${e}"`) + (t ? ` style="${t}"` : '') + ('' == n ? '' : ` ${n}`);
            }
            shouldRenderUnsafeAttribute(e) {
              return this._unsafeAttributesToRender.includes(e);
            }
            _clone(e = !1) {
              const t = [];
              if (e) for (const n of this.getChildren()) t.push(n._clone(e));
              const n = new this.constructor(this.document, this.name, this._attrs, t);
              return (
                (n._classes = new Set(this._classes)),
                n._styles.set(this._styles.getNormalized()),
                (n._customProperties = new Map(this._customProperties)),
                (n.getFillerOffset = this.getFillerOffset),
                (n._unsafeAttributesToRender = this._unsafeAttributesToRender),
                n
              );
            }
            _appendChild(e) {
              return this._insertChild(this.childCount, e);
            }
            _insertChild(e, t) {
              this._fireChange('children', this);
              let n = 0;
              const o = (function (e, t) {
                if ('string' == typeof t) return [new Mo(e, t)];
                po(t) || (t = [t]);
                return Array.from(t).map((t) => ('string' == typeof t ? new Mo(e, t) : t instanceof Bo ? new Mo(e, t.data) : t));
              })(this.document, t);
              for (const t of o)
                null !== t.parent && t._remove(), (t.parent = this), (t.document = this.document), this._children.splice(e, 0, t), e++, n++;
              return n;
            }
            _removeChildren(e, t = 1) {
              this._fireChange('children', this);
              for (let n = e; n < e + t; n++) this._children[n].parent = null;
              return this._children.splice(e, t);
            }
            _setAttribute(e, t) {
              (t = String(t)),
                this._fireChange('attributes', this),
                'class' == e ? Pi(this._classes, t) : 'style' == e ? this._styles.setTo(t) : this._attrs.set(e, t);
            }
            _removeAttribute(e) {
              return (
                this._fireChange('attributes', this),
                'class' == e
                  ? this._classes.size > 0 && (this._classes.clear(), !0)
                  : 'style' == e
                  ? !this._styles.isEmpty && (this._styles.clear(), !0)
                  : this._attrs.delete(e)
              );
            }
            _addClass(e) {
              this._fireChange('attributes', this);
              for (const t of bo(e)) this._classes.add(t);
            }
            _removeClass(e) {
              this._fireChange('attributes', this);
              for (const t of bo(e)) this._classes.delete(t);
            }
            _setStyle(e, t) {
              this._fireChange('attributes', this), he(e) ? this._styles.set(e) : this._styles.set(e, t);
            }
            _removeStyle(e) {
              this._fireChange('attributes', this);
              for (const t of bo(e)) this._styles.remove(t);
            }
            _setCustomProperty(e, t) {
              this._customProperties.set(e, t);
            }
            _removeCustomProperty(e) {
              return this._customProperties.delete(e);
            }
          }
          function Pi(e, t) {
            const n = t.split(/\s+/);
            e.clear(), n.forEach((t) => e.add(t));
          }
          Ni.prototype.is = function (e, t) {
            return t
              ? t === this.name && ('element' === e || 'view:element' === e)
              : 'element' === e || 'view:element' === e || 'node' === e || 'view:node' === e;
          };
          class zi extends Ni {
            constructor(...e) {
              super(...e), (this.getFillerOffset = Li);
            }
          }
          function Li() {
            const e = [...this.getChildren()],
              t = e[this.childCount - 1];
            if (t && t.is('element', 'br')) return this.childCount;
            for (const t of e) if (!t.is('uiElement')) return null;
            return this.childCount;
          }
          zi.prototype.is = function (e, t) {
            return t
              ? t === this.name && ('containerElement' === e || 'view:containerElement' === e || 'element' === e || 'view:element' === e)
              : 'containerElement' === e ||
                  'view:containerElement' === e ||
                  'element' === e ||
                  'view:element' === e ||
                  'node' === e ||
                  'view:node' === e;
          };
          class ji extends B(zi) {
            constructor(...e) {
              super(...e);
              const t = e[0];
              this.set('isReadOnly', !1),
                this.set('isFocused', !1),
                this.bind('isReadOnly').to(t),
                this.bind('isFocused').to(t, 'isFocused', (e) => e && t.selection.editableElement == this),
                this.listenTo(t.selection, 'change', () => {
                  this.isFocused = t.isFocused && t.selection.editableElement == this;
                });
            }
            destroy() {
              this.stopListening();
            }
          }
          ji.prototype.is = function (e, t) {
            return t
              ? t === this.name &&
                  ('editableElement' === e ||
                    'view:editableElement' === e ||
                    'containerElement' === e ||
                    'view:containerElement' === e ||
                    'element' === e ||
                    'view:element' === e)
              : 'editableElement' === e ||
                  'view:editableElement' === e ||
                  'containerElement' === e ||
                  'view:containerElement' === e ||
                  'element' === e ||
                  'view:element' === e ||
                  'node' === e ||
                  'view:node' === e;
          };
          const Oi = Symbol('rootName');
          class Ri extends ji {
            constructor(e, t) {
              super(e, t), (this.rootName = 'main');
            }
            get rootName() {
              return this.getCustomProperty(Oi);
            }
            set rootName(e) {
              this._setCustomProperty(Oi, e);
            }
            set _name(e) {
              this.name = e;
            }
          }
          Ri.prototype.is = function (e, t) {
            return t
              ? t === this.name &&
                  ('rootElement' === e ||
                    'view:rootElement' === e ||
                    'editableElement' === e ||
                    'view:editableElement' === e ||
                    'containerElement' === e ||
                    'view:containerElement' === e ||
                    'element' === e ||
                    'view:element' === e)
              : 'rootElement' === e ||
                  'view:rootElement' === e ||
                  'editableElement' === e ||
                  'view:editableElement' === e ||
                  'containerElement' === e ||
                  'view:containerElement' === e ||
                  'element' === e ||
                  'view:element' === e ||
                  'node' === e ||
                  'view:node' === e;
          };
          class Vi {
            constructor(e = {}) {
              if (!e.boundaries && !e.startPosition) throw new l('view-tree-walker-no-start-position', null);
              if (e.direction && 'forward' != e.direction && 'backward' != e.direction)
                throw new l('view-tree-walker-unknown-direction', e.startPosition, { direction: e.direction });
              (this.boundaries = e.boundaries || null),
                e.startPosition
                  ? (this.position = Fi._createAt(e.startPosition))
                  : (this.position = Fi._createAt(e.boundaries['backward' == e.direction ? 'end' : 'start'])),
                (this.direction = e.direction || 'forward'),
                (this.singleCharacters = !!e.singleCharacters),
                (this.shallow = !!e.shallow),
                (this.ignoreElementEnd = !!e.ignoreElementEnd),
                (this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null),
                (this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null);
            }
            [Symbol.iterator]() {
              return this;
            }
            skip(e) {
              let t, n, o;
              do {
                (o = this.position), ({ done: t, value: n } = this.next());
              } while (!t && e(n));
              t || (this.position = o);
            }
            next() {
              return 'forward' == this.direction ? this._next() : this._previous();
            }
            _next() {
              let e = this.position.clone();
              const t = this.position,
                n = e.parent;
              if (null === n.parent && e.offset === n.childCount) return { done: !0, value: void 0 };
              if (n === this._boundaryEndParent && e.offset == this.boundaries.end.offset) return { done: !0, value: void 0 };
              let o;
              if (n instanceof Mo) {
                if (e.isAtEnd) return (this.position = Fi._createAfter(n)), this._next();
                o = n.data[e.offset];
              } else o = n.getChild(e.offset);
              if (o instanceof Ni)
                return (
                  this.shallow ? e.offset++ : (e = new Fi(o, 0)), (this.position = e), this._formatReturnValue('elementStart', o, t, e, 1)
                );
              if (o instanceof Mo) {
                if (this.singleCharacters) return (e = new Fi(o, 0)), (this.position = e), this._next();
                {
                  let n,
                    i = o.data.length;
                  return (
                    o == this._boundaryEndParent
                      ? ((i = this.boundaries.end.offset), (n = new Bo(o, 0, i)), (e = Fi._createAfter(n)))
                      : ((n = new Bo(o, 0, o.data.length)), e.offset++),
                    (this.position = e),
                    this._formatReturnValue('text', n, t, e, i)
                  );
                }
              }
              if ('string' == typeof o) {
                let o;
                if (this.singleCharacters) o = 1;
                else {
                  o = (n === this._boundaryEndParent ? this.boundaries.end.offset : n.data.length) - e.offset;
                }
                const i = new Bo(n, e.offset, o);
                return (e.offset += o), (this.position = e), this._formatReturnValue('text', i, t, e, o);
              }
              return (
                (e = Fi._createAfter(n)),
                (this.position = e),
                this.ignoreElementEnd ? this._next() : this._formatReturnValue('elementEnd', n, t, e)
              );
            }
            _previous() {
              let e = this.position.clone();
              const t = this.position,
                n = e.parent;
              if (null === n.parent && 0 === e.offset) return { done: !0, value: void 0 };
              if (n == this._boundaryStartParent && e.offset == this.boundaries.start.offset) return { done: !0, value: void 0 };
              let o;
              if (n instanceof Mo) {
                if (e.isAtStart) return (this.position = Fi._createBefore(n)), this._previous();
                o = n.data[e.offset - 1];
              } else o = n.getChild(e.offset - 1);
              if (o instanceof Ni)
                return this.shallow
                  ? (e.offset--, (this.position = e), this._formatReturnValue('elementStart', o, t, e, 1))
                  : ((e = new Fi(o, o.childCount)),
                    (this.position = e),
                    this.ignoreElementEnd ? this._previous() : this._formatReturnValue('elementEnd', o, t, e));
              if (o instanceof Mo) {
                if (this.singleCharacters) return (e = new Fi(o, o.data.length)), (this.position = e), this._previous();
                {
                  let n,
                    i = o.data.length;
                  if (o == this._boundaryStartParent) {
                    const t = this.boundaries.start.offset;
                    (n = new Bo(o, t, o.data.length - t)), (i = n.data.length), (e = Fi._createBefore(n));
                  } else (n = new Bo(o, 0, o.data.length)), e.offset--;
                  return (this.position = e), this._formatReturnValue('text', n, t, e, i);
                }
              }
              if ('string' == typeof o) {
                let o;
                if (this.singleCharacters) o = 1;
                else {
                  const t = n === this._boundaryStartParent ? this.boundaries.start.offset : 0;
                  o = e.offset - t;
                }
                e.offset -= o;
                const i = new Bo(n, e.offset, o);
                return (this.position = e), this._formatReturnValue('text', i, t, e, o);
              }
              return (e = Fi._createBefore(n)), (this.position = e), this._formatReturnValue('elementStart', n, t, e, 1);
            }
            _formatReturnValue(e, t, n, o, i) {
              return (
                t instanceof Bo &&
                  (t.offsetInText + t.data.length == t.textNode.data.length &&
                    ('forward' != this.direction || (this.boundaries && this.boundaries.end.isEqual(this.position))
                      ? (n = Fi._createAfter(t.textNode))
                      : ((o = Fi._createAfter(t.textNode)), (this.position = o))),
                  0 === t.offsetInText &&
                    ('backward' != this.direction || (this.boundaries && this.boundaries.start.isEqual(this.position))
                      ? (n = Fi._createBefore(t.textNode))
                      : ((o = Fi._createBefore(t.textNode)), (this.position = o)))),
                { done: !1, value: { type: e, item: t, previousPosition: n, nextPosition: o, length: i } }
              );
            }
          }
          class Fi extends Do {
            constructor(e, t) {
              super(), (this.parent = e), (this.offset = t);
            }
            get nodeAfter() {
              return this.parent.is('$text') ? null : this.parent.getChild(this.offset) || null;
            }
            get nodeBefore() {
              return this.parent.is('$text') ? null : this.parent.getChild(this.offset - 1) || null;
            }
            get isAtStart() {
              return 0 === this.offset;
            }
            get isAtEnd() {
              const e = this.parent.is('$text') ? this.parent.data.length : this.parent.childCount;
              return this.offset === e;
            }
            get root() {
              return this.parent.root;
            }
            get editableElement() {
              let e = this.parent;
              for (; !(e instanceof ji); ) {
                if (!e.parent) return null;
                e = e.parent;
              }
              return e;
            }
            getShiftedBy(e) {
              const t = Fi._createAt(this),
                n = t.offset + e;
              return (t.offset = n < 0 ? 0 : n), t;
            }
            getLastMatchingPosition(e, t = {}) {
              t.startPosition = this;
              const n = new Vi(t);
              return n.skip(e), n.position;
            }
            getAncestors() {
              return this.parent.is('documentFragment') ? [this.parent] : this.parent.getAncestors({ includeSelf: !0 });
            }
            getCommonAncestor(e) {
              const t = this.getAncestors(),
                n = e.getAncestors();
              let o = 0;
              for (; t[o] == n[o] && t[o]; ) o++;
              return 0 === o ? null : t[o - 1];
            }
            isEqual(e) {
              return this.parent == e.parent && this.offset == e.offset;
            }
            isBefore(e) {
              return 'before' == this.compareWith(e);
            }
            isAfter(e) {
              return 'after' == this.compareWith(e);
            }
            compareWith(e) {
              if (this.root !== e.root) return 'different';
              if (this.isEqual(e)) return 'same';
              const t = this.parent.is('node') ? this.parent.getPath() : [],
                n = e.parent.is('node') ? e.parent.getPath() : [];
              t.push(this.offset), n.push(e.offset);
              const o = To(t, n);
              switch (o) {
                case 'prefix':
                  return 'before';
                case 'extension':
                  return 'after';
                default:
                  return t[o] < n[o] ? 'before' : 'after';
              }
            }
            getWalker(e = {}) {
              return (e.startPosition = this), new Vi(e);
            }
            clone() {
              return new Fi(this.parent, this.offset);
            }
            static _createAt(e, t) {
              if (e instanceof Fi) return new this(e.parent, e.offset);
              {
                const n = e;
                if ('end' == t) t = n.is('$text') ? n.data.length : n.childCount;
                else {
                  if ('before' == t) return this._createBefore(n);
                  if ('after' == t) return this._createAfter(n);
                  if (0 !== t && !t) throw new l('view-createpositionat-offset-required', n);
                }
                return new Fi(n, t);
              }
            }
            static _createAfter(e) {
              if (e.is('$textProxy')) return new Fi(e.textNode, e.offsetInText + e.data.length);
              if (!e.parent) throw new l('view-position-after-root', e, { root: e });
              return new Fi(e.parent, e.index + 1);
            }
            static _createBefore(e) {
              if (e.is('$textProxy')) return new Fi(e.textNode, e.offsetInText);
              if (!e.parent) throw new l('view-position-before-root', e, { root: e });
              return new Fi(e.parent, e.index);
            }
          }
          Fi.prototype.is = function (e) {
            return 'position' === e || 'view:position' === e;
          };
          class Hi extends Do {
            constructor(e, t = null) {
              super(), (this.start = e.clone()), (this.end = t ? t.clone() : e.clone());
            }
            *[Symbol.iterator]() {
              yield* new Vi({ boundaries: this, ignoreElementEnd: !0 });
            }
            get isCollapsed() {
              return this.start.isEqual(this.end);
            }
            get isFlat() {
              return this.start.parent === this.end.parent;
            }
            get root() {
              return this.start.root;
            }
            getEnlarged() {
              let e = this.start.getLastMatchingPosition(Ui, { direction: 'backward' }),
                t = this.end.getLastMatchingPosition(Ui);
              return (
                e.parent.is('$text') && e.isAtStart && (e = Fi._createBefore(e.parent)),
                t.parent.is('$text') && t.isAtEnd && (t = Fi._createAfter(t.parent)),
                new Hi(e, t)
              );
            }
            getTrimmed() {
              let e = this.start.getLastMatchingPosition(Ui);
              if (e.isAfter(this.end) || e.isEqual(this.end)) return new Hi(e, e);
              let t = this.end.getLastMatchingPosition(Ui, { direction: 'backward' });
              const n = e.nodeAfter,
                o = t.nodeBefore;
              return n && n.is('$text') && (e = new Fi(n, 0)), o && o.is('$text') && (t = new Fi(o, o.data.length)), new Hi(e, t);
            }
            isEqual(e) {
              return this == e || (this.start.isEqual(e.start) && this.end.isEqual(e.end));
            }
            containsPosition(e) {
              return e.isAfter(this.start) && e.isBefore(this.end);
            }
            containsRange(e, t = !1) {
              e.isCollapsed && (t = !1);
              const n = this.containsPosition(e.start) || (t && this.start.isEqual(e.start)),
                o = this.containsPosition(e.end) || (t && this.end.isEqual(e.end));
              return n && o;
            }
            getDifference(e) {
              const t = [];
              return (
                this.isIntersecting(e)
                  ? (this.containsPosition(e.start) && t.push(new Hi(this.start, e.start)),
                    this.containsPosition(e.end) && t.push(new Hi(e.end, this.end)))
                  : t.push(this.clone()),
                t
              );
            }
            getIntersection(e) {
              if (this.isIntersecting(e)) {
                let t = this.start,
                  n = this.end;
                return this.containsPosition(e.start) && (t = e.start), this.containsPosition(e.end) && (n = e.end), new Hi(t, n);
              }
              return null;
            }
            getWalker(e = {}) {
              return (e.boundaries = this), new Vi(e);
            }
            getCommonAncestor() {
              return this.start.getCommonAncestor(this.end);
            }
            getContainedElement() {
              if (this.isCollapsed) return null;
              let e = this.start.nodeAfter,
                t = this.end.nodeBefore;
              return (
                this.start.parent.is('$text') && this.start.isAtEnd && this.start.parent.nextSibling && (e = this.start.parent.nextSibling),
                this.end.parent.is('$text') &&
                  this.end.isAtStart &&
                  this.end.parent.previousSibling &&
                  (t = this.end.parent.previousSibling),
                e && e.is('element') && e === t ? e : null
              );
            }
            clone() {
              return new Hi(this.start, this.end);
            }
            *getItems(e = {}) {
              (e.boundaries = this), (e.ignoreElementEnd = !0);
              const t = new Vi(e);
              for (const e of t) yield e.item;
            }
            *getPositions(e = {}) {
              e.boundaries = this;
              const t = new Vi(e);
              yield t.position;
              for (const e of t) yield e.nextPosition;
            }
            isIntersecting(e) {
              return this.start.isBefore(e.end) && this.end.isAfter(e.start);
            }
            static _createFromParentsAndOffsets(e, t, n, o) {
              return new this(new Fi(e, t), new Fi(n, o));
            }
            static _createFromPositionAndShift(e, t) {
              const n = e,
                o = e.getShiftedBy(t);
              return t > 0 ? new this(n, o) : new this(o, n);
            }
            static _createIn(e) {
              return this._createFromParentsAndOffsets(e, 0, e, e.childCount);
            }
            static _createOn(e) {
              const t = e.is('$textProxy') ? e.offsetSize : 1;
              return this._createFromPositionAndShift(Fi._createBefore(e), t);
            }
          }
          function Ui(e) {
            return !(!e.item.is('attributeElement') && !e.item.is('uiElement'));
          }
          function qi(e) {
            let t = 0;
            for (const n of e) t++;
            return t;
          }
          Hi.prototype.is = function (e) {
            return 'range' === e || 'view:range' === e;
          };
          class Wi extends k(Do) {
            constructor(...e) {
              super(),
                (this._ranges = []),
                (this._lastRangeBackward = !1),
                (this._isFake = !1),
                (this._fakeSelectionLabel = ''),
                e.length && this.setTo(...e);
            }
            get isFake() {
              return this._isFake;
            }
            get fakeSelectionLabel() {
              return this._fakeSelectionLabel;
            }
            get anchor() {
              if (!this._ranges.length) return null;
              const e = this._ranges[this._ranges.length - 1];
              return (this._lastRangeBackward ? e.end : e.start).clone();
            }
            get focus() {
              if (!this._ranges.length) return null;
              const e = this._ranges[this._ranges.length - 1];
              return (this._lastRangeBackward ? e.start : e.end).clone();
            }
            get isCollapsed() {
              return 1 === this.rangeCount && this._ranges[0].isCollapsed;
            }
            get rangeCount() {
              return this._ranges.length;
            }
            get isBackward() {
              return !this.isCollapsed && this._lastRangeBackward;
            }
            get editableElement() {
              return this.anchor ? this.anchor.editableElement : null;
            }
            *getRanges() {
              for (const e of this._ranges) yield e.clone();
            }
            getFirstRange() {
              let e = null;
              for (const t of this._ranges) (e && !t.start.isBefore(e.start)) || (e = t);
              return e ? e.clone() : null;
            }
            getLastRange() {
              let e = null;
              for (const t of this._ranges) (e && !t.end.isAfter(e.end)) || (e = t);
              return e ? e.clone() : null;
            }
            getFirstPosition() {
              const e = this.getFirstRange();
              return e ? e.start.clone() : null;
            }
            getLastPosition() {
              const e = this.getLastRange();
              return e ? e.end.clone() : null;
            }
            isEqual(e) {
              if (this.isFake != e.isFake) return !1;
              if (this.isFake && this.fakeSelectionLabel != e.fakeSelectionLabel) return !1;
              if (this.rangeCount != e.rangeCount) return !1;
              if (0 === this.rangeCount) return !0;
              if (!this.anchor.isEqual(e.anchor) || !this.focus.isEqual(e.focus)) return !1;
              for (const t of this._ranges) {
                let n = !1;
                for (const o of e._ranges)
                  if (t.isEqual(o)) {
                    n = !0;
                    break;
                  }
                if (!n) return !1;
              }
              return !0;
            }
            isSimilar(e) {
              if (this.isBackward != e.isBackward) return !1;
              const t = qi(this.getRanges());
              if (t != qi(e.getRanges())) return !1;
              if (0 == t) return !0;
              for (let t of this.getRanges()) {
                t = t.getTrimmed();
                let n = !1;
                for (let o of e.getRanges())
                  if (((o = o.getTrimmed()), t.start.isEqual(o.start) && t.end.isEqual(o.end))) {
                    n = !0;
                    break;
                  }
                if (!n) return !1;
              }
              return !0;
            }
            getSelectedElement() {
              return 1 !== this.rangeCount ? null : this.getFirstRange().getContainedElement();
            }
            setTo(...e) {
              let [t, n, o] = e;
              if (('object' == typeof n && ((o = n), (n = void 0)), null === t)) this._setRanges([]), this._setFakeOptions(o);
              else if (t instanceof Wi || t instanceof Gi)
                this._setRanges(t.getRanges(), t.isBackward), this._setFakeOptions({ fake: t.isFake, label: t.fakeSelectionLabel });
              else if (t instanceof Hi) this._setRanges([t], o && o.backward), this._setFakeOptions(o);
              else if (t instanceof Fi) this._setRanges([new Hi(t)]), this._setFakeOptions(o);
              else if (t instanceof So) {
                const e = !!o && !!o.backward;
                let i;
                if (void 0 === n) throw new l('view-selection-setto-required-second-parameter', this);
                (i = 'in' == n ? Hi._createIn(t) : 'on' == n ? Hi._createOn(t) : new Hi(Fi._createAt(t, n))),
                  this._setRanges([i], e),
                  this._setFakeOptions(o);
              } else {
                if (!po(t)) throw new l('view-selection-setto-not-selectable', this);
                this._setRanges(t, o && o.backward), this._setFakeOptions(o);
              }
              this.fire('change');
            }
            setFocus(e, t) {
              if (null === this.anchor) throw new l('view-selection-setfocus-no-ranges', this);
              const n = Fi._createAt(e, t);
              if ('same' == n.compareWith(this.focus)) return;
              const o = this.anchor;
              this._ranges.pop(),
                'before' == n.compareWith(o) ? this._addRange(new Hi(n, o), !0) : this._addRange(new Hi(o, n)),
                this.fire('change');
            }
            _setRanges(e, t = !1) {
              (e = Array.from(e)), (this._ranges = []);
              for (const t of e) this._addRange(t);
              this._lastRangeBackward = !!t;
            }
            _setFakeOptions(e = {}) {
              (this._isFake = !!e.fake), (this._fakeSelectionLabel = (e.fake && e.label) || '');
            }
            _addRange(e, t = !1) {
              if (!(e instanceof Hi)) throw new l('view-selection-add-range-not-range', this);
              this._pushRange(e), (this._lastRangeBackward = !!t);
            }
            _pushRange(e) {
              for (const t of this._ranges)
                if (e.isIntersecting(t)) throw new l('view-selection-range-intersects', this, { addedRange: e, intersectingRange: t });
              this._ranges.push(new Hi(e.start, e.end));
            }
          }
          Wi.prototype.is = function (e) {
            return 'selection' === e || 'view:selection' === e;
          };
          class Gi extends k(Do) {
            constructor(...e) {
              super(), (this._selection = new Wi()), this._selection.delegate('change').to(this), e.length && this._selection.setTo(...e);
            }
            get isFake() {
              return this._selection.isFake;
            }
            get fakeSelectionLabel() {
              return this._selection.fakeSelectionLabel;
            }
            get anchor() {
              return this._selection.anchor;
            }
            get focus() {
              return this._selection.focus;
            }
            get isCollapsed() {
              return this._selection.isCollapsed;
            }
            get rangeCount() {
              return this._selection.rangeCount;
            }
            get isBackward() {
              return this._selection.isBackward;
            }
            get editableElement() {
              return this._selection.editableElement;
            }
            get _ranges() {
              return this._selection._ranges;
            }
            *getRanges() {
              yield* this._selection.getRanges();
            }
            getFirstRange() {
              return this._selection.getFirstRange();
            }
            getLastRange() {
              return this._selection.getLastRange();
            }
            getFirstPosition() {
              return this._selection.getFirstPosition();
            }
            getLastPosition() {
              return this._selection.getLastPosition();
            }
            getSelectedElement() {
              return this._selection.getSelectedElement();
            }
            isEqual(e) {
              return this._selection.isEqual(e);
            }
            isSimilar(e) {
              return this._selection.isSimilar(e);
            }
            _setTo(...e) {
              this._selection.setTo(...e);
            }
            _setFocus(e, t) {
              this._selection.setFocus(e, t);
            }
          }
          Gi.prototype.is = function (e) {
            return 'selection' === e || 'documentSelection' == e || 'view:selection' == e || 'view:documentSelection' == e;
          };
          class $i extends t {
            constructor(e, t, n) {
              super(e, t), (this.startRange = n), (this._eventPhase = 'none'), (this._currentTarget = null);
            }
            get eventPhase() {
              return this._eventPhase;
            }
            get currentTarget() {
              return this._currentTarget;
            }
          }
          const Yi = Symbol('bubbling contexts');
          function Ki(e) {
            return class extends e {
              fire(e, ...n) {
                try {
                  const o = e instanceof t ? e : new t(this, e),
                    i = Xi(this);
                  if (!i.size) return;
                  if ((Qi(o, 'capturing', this), Zi(i, '$capture', o, ...n))) return o.return;
                  const r = o.startRange || this.selection.getFirstRange(),
                    s = r ? r.getContainedElement() : null,
                    a = !!s && Boolean(Ji(i, s));
                  let l =
                    s ||
                    (function (e) {
                      if (!e) return null;
                      const t = e.start.parent,
                        n = e.end.parent,
                        o = t.getPath(),
                        i = n.getPath();
                      return o.length > i.length ? t : n;
                    })(r);
                  if ((Qi(o, 'atTarget', l), !a)) {
                    if (Zi(i, '$text', o, ...n)) return o.return;
                    Qi(o, 'bubbling', l);
                  }
                  for (; l; ) {
                    if (l.is('rootElement')) {
                      if (Zi(i, '$root', o, ...n)) return o.return;
                    } else if (l.is('element') && Zi(i, l.name, o, ...n)) return o.return;
                    if (Zi(i, l, o, ...n)) return o.return;
                    (l = l.parent), Qi(o, 'bubbling', l);
                  }
                  return Qi(o, 'bubbling', this), Zi(i, '$document', o, ...n), o.return;
                } catch (e) {
                  l.rethrowUnexpectedError(e, this);
                }
              }
              _addEventListener(e, t, n) {
                const o = bo(n.context || '$document'),
                  i = Xi(this);
                for (const r of o) {
                  let o = i.get(r);
                  o || ((o = new b()), i.set(r, o)), this.listenTo(o, e, t, n);
                }
              }
              _removeEventListener(e, t) {
                const n = Xi(this);
                for (const o of n.values()) this.stopListening(o, e, t);
              }
            };
          }
          {
            const e = Ki(Object);
            ['fire', '_addEventListener', '_removeEventListener'].forEach((t) => {
              Ki[t] = e.prototype[t];
            });
          }
          function Qi(e, t, n) {
            e instanceof $i && ((e._eventPhase = t), (e._currentTarget = n));
          }
          function Zi(e, t, n, ...o) {
            const i = 'string' == typeof t ? e.get(t) : Ji(e, t);
            return !!i && (i.fire(n, ...o), n.stop.called);
          }
          function Ji(e, t) {
            for (const [n, o] of e) if ('function' == typeof n && n(t)) return o;
            return null;
          }
          function Xi(e) {
            return e[Yi] || (e[Yi] = new Map()), e[Yi];
          }
          class er extends Ki(N) {
            constructor(e) {
              super(),
                (this.selection = new Gi()),
                (this.roots = new fo({ idProperty: 'rootName' })),
                (this.stylesProcessor = e),
                this.set('isReadOnly', !1),
                this.set('isFocused', !1),
                this.set('isSelecting', !1),
                this.set('isComposing', !1),
                (this._postFixers = new Set());
            }
            getRoot(e = 'main') {
              return this.roots.get(e);
            }
            registerPostFixer(e) {
              this._postFixers.add(e);
            }
            destroy() {
              this.roots.map((e) => e.destroy()), this.stopListening();
            }
            _callPostFixers(e) {
              let t = !1;
              do {
                for (const n of this._postFixers) if (((t = n(e)), t)) break;
              } while (t);
            }
          }
          class tr extends Ni {
            constructor(...e) {
              super(...e), (this.getFillerOffset = nr), (this._priority = 10), (this._id = null), (this._clonesGroup = null);
            }
            get priority() {
              return this._priority;
            }
            get id() {
              return this._id;
            }
            getElementsWithSameId() {
              if (null === this.id) throw new l('attribute-element-get-elements-with-same-id-no-id', this);
              return new Set(this._clonesGroup);
            }
            isSimilar(e) {
              return null !== this.id || null !== e.id ? this.id === e.id : super.isSimilar(e) && this.priority == e.priority;
            }
            _clone(e = !1) {
              const t = super._clone(e);
              return (t._priority = this._priority), (t._id = this._id), t;
            }
          }
          function nr() {
            if (or(this)) return null;
            let e = this.parent;
            for (; e && e.is('attributeElement'); ) {
              if (or(e) > 1) return null;
              e = e.parent;
            }
            return !e || or(e) > 1 ? null : this.childCount;
          }
          function or(e) {
            return Array.from(e.getChildren()).filter((e) => !e.is('uiElement')).length;
          }
          (tr.DEFAULT_PRIORITY = 10),
            (tr.prototype.is = function (e, t) {
              return t
                ? t === this.name && ('attributeElement' === e || 'view:attributeElement' === e || 'element' === e || 'view:element' === e)
                : 'attributeElement' === e ||
                    'view:attributeElement' === e ||
                    'element' === e ||
                    'view:element' === e ||
                    'node' === e ||
                    'view:node' === e;
            });
          class ir extends Ni {
            constructor(e, t, n, o) {
              super(e, t, n, o), (this.getFillerOffset = rr);
            }
            _insertChild(e, t) {
              if (t && (t instanceof So || Array.from(t).length > 0)) throw new l('view-emptyelement-cannot-add', [this, t]);
              return 0;
            }
          }
          function rr() {
            return null;
          }
          ir.prototype.is = function (e, t) {
            return t
              ? t === this.name && ('emptyElement' === e || 'view:emptyElement' === e || 'element' === e || 'view:element' === e)
              : 'emptyElement' === e ||
                  'view:emptyElement' === e ||
                  'element' === e ||
                  'view:element' === e ||
                  'node' === e ||
                  'view:node' === e;
          };
          const sr = (function () {
              try {
                return navigator.userAgent.toLowerCase();
              } catch (e) {
                return '';
              }
            })(),
            ar = {
              isMac: cr(sr),
              isWindows: (function (e) {
                return e.indexOf('windows') > -1;
              })(sr),
              isGecko: (function (e) {
                return !!e.match(/gecko\/\d+/);
              })(sr),
              isSafari: (function (e) {
                return e.indexOf(' applewebkit/') > -1 && -1 === e.indexOf('chrome');
              })(sr),
              isiOS: (function (e) {
                return !!e.match(/iphone|ipad/i) || (cr(e) && navigator.maxTouchPoints > 0);
              })(sr),
              isAndroid: (function (e) {
                return e.indexOf('android') > -1;
              })(sr),
              isBlink: (function (e) {
                return e.indexOf('chrome/') > -1 && e.indexOf('edge/') < 0;
              })(sr),
              features: {
                isRegExpUnicodePropertySupported: (function () {
                  let e = !1;
                  try {
                    e = 0 === 'ć'.search(new RegExp('[\\p{L}]', 'u'));
                  } catch (e) {}
                  return e;
                })(),
              },
            },
            lr = ar;
          function cr(e) {
            return e.indexOf('macintosh') > -1;
          }
          const dr = { ctrl: '⌃', cmd: '⌘', alt: '⌥', shift: '⇧' },
            ur = { ctrl: 'Ctrl+', alt: 'Alt+', shift: 'Shift+' },
            hr = (function () {
              const e = {
                arrowleft: 37,
                arrowup: 38,
                arrowright: 39,
                arrowdown: 40,
                backspace: 8,
                delete: 46,
                enter: 13,
                space: 32,
                esc: 27,
                tab: 9,
                ctrl: 1114112,
                shift: 2228224,
                alt: 4456448,
                cmd: 8912896,
              };
              for (let t = 65; t <= 90; t++) {
                const n = String.fromCharCode(t);
                e[n.toLowerCase()] = t;
              }
              for (let t = 48; t <= 57; t++) e[t - 48] = t;
              for (let t = 112; t <= 123; t++) e['f' + (t - 111)] = t;
              for (const t of "`-=[];',./\\") e[t] = t.charCodeAt(0);
              return e;
            })(),
            mr = Object.fromEntries(Object.entries(hr).map(([e, t]) => [t, e.charAt(0).toUpperCase() + e.slice(1)]));
          function gr(e) {
            let t;
            if ('string' == typeof e) {
              if (((t = hr[e.toLowerCase()]), !t)) throw new l('keyboard-unknown-key', null, { key: e });
            } else
              t = e.keyCode + (e.altKey ? hr.alt : 0) + (e.ctrlKey ? hr.ctrl : 0) + (e.shiftKey ? hr.shift : 0) + (e.metaKey ? hr.cmd : 0);
            return t;
          }
          function pr(e) {
            return (
              'string' == typeof e &&
                (e = (function (e) {
                  return e.split('+').map((e) => e.trim());
                })(e)),
              e
                .map((e) =>
                  'string' == typeof e
                    ? (function (e) {
                        if (e.endsWith('!')) return gr(e.slice(0, -1));
                        const t = gr(e);
                        return lr.isMac && t == hr.ctrl ? hr.cmd : t;
                      })(e)
                    : e
                )
                .reduce((e, t) => t + e, 0)
            );
          }
          function fr(e) {
            let t = pr(e);
            return (
              Object.entries(lr.isMac ? dr : ur).reduce((e, [n, o]) => (0 != (t & hr[n]) && ((t &= ~hr[n]), (e += o)), e), '') +
              (t ? mr[t] : '')
            );
          }
          function kr(e, t) {
            const n = 'ltr' === t;
            switch (e) {
              case hr.arrowleft:
                return n ? 'left' : 'right';
              case hr.arrowright:
                return n ? 'right' : 'left';
              case hr.arrowup:
                return 'up';
              case hr.arrowdown:
                return 'down';
            }
          }
          class br extends Ni {
            constructor(...e) {
              super(...e), (this.getFillerOffset = _r);
            }
            _insertChild(e, t) {
              if (t && (t instanceof So || Array.from(t).length > 0)) throw new l('view-uielement-cannot-add', [this, t]);
              return 0;
            }
            render(e, t) {
              return this.toDomElement(e);
            }
            toDomElement(e) {
              const t = e.createElement(this.name);
              for (const e of this.getAttributeKeys()) t.setAttribute(e, this.getAttribute(e));
              return t;
            }
          }
          function wr(e) {
            e.document.on(
              'arrowKey',
              (t, n) =>
                (function (e, t, n) {
                  if (t.keyCode == hr.arrowright) {
                    const e = t.domTarget.ownerDocument.defaultView.getSelection(),
                      o = 1 == e.rangeCount && e.getRangeAt(0).collapsed;
                    if (o || t.shiftKey) {
                      const t = e.focusNode,
                        i = e.focusOffset,
                        r = n.domPositionToView(t, i);
                      if (null === r) return;
                      let s = !1;
                      const a = r.getLastMatchingPosition(
                        (e) => (e.item.is('uiElement') && (s = !0), !(!e.item.is('uiElement') && !e.item.is('attributeElement')))
                      );
                      if (s) {
                        const t = n.viewPositionToDom(a);
                        o ? e.collapse(t.parent, t.offset) : e.extend(t.parent, t.offset);
                      }
                    }
                  }
                })(0, n, e.domConverter),
              { priority: 'low' }
            );
          }
          function _r() {
            return null;
          }
          br.prototype.is = function (e, t) {
            return t
              ? t === this.name && ('uiElement' === e || 'view:uiElement' === e || 'element' === e || 'view:element' === e)
              : 'uiElement' === e || 'view:uiElement' === e || 'element' === e || 'view:element' === e || 'node' === e || 'view:node' === e;
          };
          class yr extends Ni {
            constructor(...e) {
              super(...e), (this.getFillerOffset = Ar);
            }
            _insertChild(e, t) {
              if (t && (t instanceof So || Array.from(t).length > 0)) throw new l('view-rawelement-cannot-add', [this, t]);
              return 0;
            }
            render() {}
          }
          function Ar() {
            return null;
          }
          yr.prototype.is = function (e, t) {
            return t
              ? t === this.name && ('rawElement' === e || 'view:rawElement' === e || 'element' === e || 'view:element' === e)
              : 'rawElement' === e ||
                  'view:rawElement' === e ||
                  e === this.name ||
                  e === 'view:' + this.name ||
                  'element' === e ||
                  'view:element' === e ||
                  'node' === e ||
                  'view:node' === e;
          };
          class Cr extends k(Do) {
            constructor(e, t) {
              super(), (this.document = e), (this._children = []), t && this._insertChild(0, t);
            }
            [Symbol.iterator]() {
              return this._children[Symbol.iterator]();
            }
            get childCount() {
              return this._children.length;
            }
            get isEmpty() {
              return 0 === this.childCount;
            }
            get root() {
              return this;
            }
            get parent() {
              return null;
            }
            _appendChild(e) {
              return this._insertChild(this.childCount, e);
            }
            getChild(e) {
              return this._children[e];
            }
            getChildIndex(e) {
              return this._children.indexOf(e);
            }
            getChildren() {
              return this._children[Symbol.iterator]();
            }
            _insertChild(e, t) {
              this._fireChange('children', this);
              let n = 0;
              const o = (function (e, t) {
                if ('string' == typeof t) return [new Mo(e, t)];
                po(t) || (t = [t]);
                return Array.from(t).map((t) => ('string' == typeof t ? new Mo(e, t) : t instanceof Bo ? new Mo(e, t.data) : t));
              })(this.document, t);
              for (const t of o) null !== t.parent && t._remove(), (t.parent = this), this._children.splice(e, 0, t), e++, n++;
              return n;
            }
            _removeChildren(e, t = 1) {
              this._fireChange('children', this);
              for (let n = e; n < e + t; n++) this._children[n].parent = null;
              return this._children.splice(e, t);
            }
            _fireChange(e, t) {
              this.fire('change:' + e, t);
            }
          }
          Cr.prototype.is = function (e) {
            return 'documentFragment' === e || 'view:documentFragment' === e;
          };
          class vr {
            constructor(e) {
              (this.document = e), (this._cloneGroups = new Map()), (this._slotFactory = null);
            }
            setSelection(...e) {
              this.document.selection._setTo(...e);
            }
            setSelectionFocus(...e) {
              this.document.selection._setFocus(...e);
            }
            createDocumentFragment(e) {
              return new Cr(this.document, e);
            }
            createText(e) {
              return new Mo(this.document, e);
            }
            createAttributeElement(e, t, n = {}) {
              const o = new tr(this.document, e, t);
              return (
                'number' == typeof n.priority && (o._priority = n.priority),
                n.id && (o._id = n.id),
                n.renderUnsafeAttributes && o._unsafeAttributesToRender.push(...n.renderUnsafeAttributes),
                o
              );
            }
            createContainerElement(e, t, n = {}, o = {}) {
              let i = null;
              he(n) ? (o = n) : (i = n);
              const r = new zi(this.document, e, t, i);
              return o.renderUnsafeAttributes && r._unsafeAttributesToRender.push(...o.renderUnsafeAttributes), r;
            }
            createEditableElement(e, t, n = {}) {
              const o = new ji(this.document, e, t);
              return n.renderUnsafeAttributes && o._unsafeAttributesToRender.push(...n.renderUnsafeAttributes), o;
            }
            createEmptyElement(e, t, n = {}) {
              const o = new ir(this.document, e, t);
              return n.renderUnsafeAttributes && o._unsafeAttributesToRender.push(...n.renderUnsafeAttributes), o;
            }
            createUIElement(e, t, n) {
              const o = new br(this.document, e, t);
              return n && (o.render = n), o;
            }
            createRawElement(e, t, n, o = {}) {
              const i = new yr(this.document, e, t);
              return n && (i.render = n), o.renderUnsafeAttributes && i._unsafeAttributesToRender.push(...o.renderUnsafeAttributes), i;
            }
            setAttribute(e, t, n) {
              n._setAttribute(e, t);
            }
            removeAttribute(e, t) {
              t._removeAttribute(e);
            }
            addClass(e, t) {
              t._addClass(e);
            }
            removeClass(e, t) {
              t._removeClass(e);
            }
            setStyle(e, t, n) {
              he(e) && void 0 === n ? t._setStyle(e) : n._setStyle(e, t);
            }
            removeStyle(e, t) {
              t._removeStyle(e);
            }
            setCustomProperty(e, t, n) {
              n._setCustomProperty(e, t);
            }
            removeCustomProperty(e, t) {
              return t._removeCustomProperty(e);
            }
            breakAttributes(e) {
              return e instanceof Fi ? this._breakAttributes(e) : this._breakAttributesRange(e);
            }
            breakContainer(e) {
              const t = e.parent;
              if (!t.is('containerElement')) throw new l('view-writer-break-non-container-element', this.document);
              if (!t.parent) throw new l('view-writer-break-root', this.document);
              if (e.isAtStart) return Fi._createBefore(t);
              if (!e.isAtEnd) {
                const n = t._clone(!1);
                this.insert(Fi._createAfter(t), n);
                const o = new Hi(e, Fi._createAt(t, 'end')),
                  i = new Fi(n, 0);
                this.move(o, i);
              }
              return Fi._createAfter(t);
            }
            mergeAttributes(e) {
              const t = e.offset,
                n = e.parent;
              if (n.is('$text')) return e;
              if (n.is('attributeElement') && 0 === n.childCount) {
                const e = n.parent,
                  t = n.index;
                return n._remove(), this._removeFromClonedElementsGroup(n), this.mergeAttributes(new Fi(e, t));
              }
              const o = n.getChild(t - 1),
                i = n.getChild(t);
              if (!o || !i) return e;
              if (o.is('$text') && i.is('$text')) return Ir(o, i);
              if (o.is('attributeElement') && i.is('attributeElement') && o.isSimilar(i)) {
                const e = o.childCount;
                return (
                  o._appendChild(i.getChildren()), i._remove(), this._removeFromClonedElementsGroup(i), this.mergeAttributes(new Fi(o, e))
                );
              }
              return e;
            }
            mergeContainers(e) {
              const t = e.nodeBefore,
                n = e.nodeAfter;
              if (!(t && n && t.is('containerElement') && n.is('containerElement')))
                throw new l('view-writer-merge-containers-invalid-position', this.document);
              const o = t.getChild(t.childCount - 1),
                i = o instanceof Mo ? Fi._createAt(o, 'end') : Fi._createAt(t, 'end');
              return this.move(Hi._createIn(n), Fi._createAt(t, 'end')), this.remove(Hi._createOn(n)), i;
            }
            insert(e, t) {
              Mr((t = po(t) ? [...t] : [t]), this.document);
              const n = t.reduce((e, t) => {
                const n = e[e.length - 1],
                  o = !t.is('uiElement');
                return n && n.breakAttributes == o ? n.nodes.push(t) : e.push({ breakAttributes: o, nodes: [t] }), e;
              }, []);
              let o = null,
                i = e;
              for (const { nodes: e, breakAttributes: t } of n) {
                const n = this._insertNodes(i, e, t);
                o || (o = n.start), (i = n.end);
              }
              return o ? new Hi(o, i) : new Hi(e);
            }
            remove(e) {
              const t = e instanceof Hi ? e : Hi._createOn(e);
              if ((Nr(t, this.document), t.isCollapsed)) return new Cr(this.document);
              const { start: n, end: o } = this._breakAttributesRange(t, !0),
                i = n.parent,
                r = o.offset - n.offset,
                s = i._removeChildren(n.offset, r);
              for (const e of s) this._removeFromClonedElementsGroup(e);
              const a = this.mergeAttributes(n);
              return (t.start = a), (t.end = a.clone()), new Cr(this.document, s);
            }
            clear(e, t) {
              Nr(e, this.document);
              const n = e.getWalker({ direction: 'backward', ignoreElementEnd: !0 });
              for (const o of n) {
                const n = o.item;
                let i;
                if (n.is('element') && t.isSimilar(n)) i = Hi._createOn(n);
                else if (!o.nextPosition.isAfter(e.start) && n.is('$textProxy')) {
                  const e = n.getAncestors().find((e) => e.is('element') && t.isSimilar(e));
                  e && (i = Hi._createIn(e));
                }
                i && (i.end.isAfter(e.end) && (i.end = e.end), i.start.isBefore(e.start) && (i.start = e.start), this.remove(i));
              }
            }
            move(e, t) {
              let n;
              if (t.isAfter(e.end)) {
                const o = (t = this._breakAttributes(t, !0)).parent,
                  i = o.childCount;
                (e = this._breakAttributesRange(e, !0)), (n = this.remove(e)), (t.offset += o.childCount - i);
              } else n = this.remove(e);
              return this.insert(t, n);
            }
            wrap(e, t) {
              if (!(t instanceof tr)) throw new l('view-writer-wrap-invalid-attribute', this.document);
              if ((Nr(e, this.document), e.isCollapsed)) {
                let o = e.start;
                o.parent.is('element') &&
                  ((n = o.parent), !Array.from(n.getChildren()).some((e) => !e.is('uiElement'))) &&
                  (o = o.getLastMatchingPosition((e) => e.item.is('uiElement'))),
                  (o = this._wrapPosition(o, t));
                const i = this.document.selection;
                return i.isCollapsed && i.getFirstPosition().isEqual(e.start) && this.setSelection(o), new Hi(o);
              }
              return this._wrapRange(e, t);
              var n;
            }
            unwrap(e, t) {
              if (!(t instanceof tr)) throw new l('view-writer-unwrap-invalid-attribute', this.document);
              if ((Nr(e, this.document), e.isCollapsed)) return e;
              const { start: n, end: o } = this._breakAttributesRange(e, !0),
                i = n.parent,
                r = this._unwrapChildren(i, n.offset, o.offset, t),
                s = this.mergeAttributes(r.start);
              s.isEqual(r.start) || r.end.offset--;
              const a = this.mergeAttributes(r.end);
              return new Hi(s, a);
            }
            rename(e, t) {
              const n = new zi(this.document, e, t.getAttributes());
              return this.insert(Fi._createAfter(t), n), this.move(Hi._createIn(t), Fi._createAt(n, 0)), this.remove(Hi._createOn(t)), n;
            }
            clearClonedElementsGroup(e) {
              this._cloneGroups.delete(e);
            }
            createPositionAt(e, t) {
              return Fi._createAt(e, t);
            }
            createPositionAfter(e) {
              return Fi._createAfter(e);
            }
            createPositionBefore(e) {
              return Fi._createBefore(e);
            }
            createRange(...e) {
              return new Hi(...e);
            }
            createRangeOn(e) {
              return Hi._createOn(e);
            }
            createRangeIn(e) {
              return Hi._createIn(e);
            }
            createSelection(...e) {
              return new Wi(...e);
            }
            createSlot(e) {
              if (!this._slotFactory) throw new l('view-writer-invalid-create-slot-context', this.document);
              return this._slotFactory(this, e);
            }
            _registerSlotFactory(e) {
              this._slotFactory = e;
            }
            _clearSlotFactory() {
              this._slotFactory = null;
            }
            _insertNodes(e, t, n) {
              let o, i;
              if (((o = n ? xr(e) : e.parent.is('$text') ? e.parent.parent : e.parent), !o))
                throw new l('view-writer-invalid-position-container', this.document);
              i = n ? this._breakAttributes(e, !0) : e.parent.is('$text') ? Tr(e) : e;
              const r = o._insertChild(i.offset, t);
              for (const e of t) this._addToClonedElementsGroup(e);
              const s = i.getShiftedBy(r),
                a = this.mergeAttributes(i);
              a.isEqual(i) || s.offset--;
              const c = this.mergeAttributes(s);
              return new Hi(a, c);
            }
            _wrapChildren(e, t, n, o) {
              let i = t;
              const r = [];
              for (; i < n; ) {
                const t = e.getChild(i),
                  n = t.is('$text'),
                  s = t.is('attributeElement');
                if (s && this._wrapAttributeElement(o, t)) r.push(new Fi(e, i));
                else if (n || !s || Er(o, t)) {
                  const n = o._clone();
                  t._remove(), n._appendChild(t), e._insertChild(i, n), this._addToClonedElementsGroup(n), r.push(new Fi(e, i));
                } else this._wrapChildren(t, 0, t.childCount, o);
                i++;
              }
              let s = 0;
              for (const e of r) {
                if (((e.offset -= s), e.offset == t)) continue;
                this.mergeAttributes(e).isEqual(e) || (s++, n--);
              }
              return Hi._createFromParentsAndOffsets(e, t, e, n);
            }
            _unwrapChildren(e, t, n, o) {
              let i = t;
              const r = [];
              for (; i < n; ) {
                const t = e.getChild(i);
                if (t.is('attributeElement'))
                  if (t.isSimilar(o)) {
                    const o = t.getChildren(),
                      s = t.childCount;
                    t._remove(),
                      e._insertChild(i, o),
                      this._removeFromClonedElementsGroup(t),
                      r.push(new Fi(e, i), new Fi(e, i + s)),
                      (i += s),
                      (n += s - 1);
                  } else
                    this._unwrapAttributeElement(o, t)
                      ? (r.push(new Fi(e, i), new Fi(e, i + 1)), i++)
                      : (this._unwrapChildren(t, 0, t.childCount, o), i++);
                else i++;
              }
              let s = 0;
              for (const e of r) {
                if (((e.offset -= s), e.offset == t || e.offset == n)) continue;
                this.mergeAttributes(e).isEqual(e) || (s++, n--);
              }
              return Hi._createFromParentsAndOffsets(e, t, e, n);
            }
            _wrapRange(e, t) {
              const { start: n, end: o } = this._breakAttributesRange(e, !0),
                i = n.parent,
                r = this._wrapChildren(i, n.offset, o.offset, t),
                s = this.mergeAttributes(r.start);
              s.isEqual(r.start) || r.end.offset--;
              const a = this.mergeAttributes(r.end);
              return new Hi(s, a);
            }
            _wrapPosition(e, t) {
              if (t.isSimilar(e.parent)) return Dr(e.clone());
              e.parent.is('$text') && (e = Tr(e));
              const n = this.createAttributeElement('_wrapPosition-fake-element');
              (n._priority = Number.POSITIVE_INFINITY), (n.isSimilar = () => !1), e.parent._insertChild(e.offset, n);
              const o = new Hi(e, e.getShiftedBy(1));
              this.wrap(o, t);
              const i = new Fi(n.parent, n.index);
              n._remove();
              const r = i.nodeBefore,
                s = i.nodeAfter;
              return r instanceof Mo && s instanceof Mo ? Ir(r, s) : Dr(i);
            }
            _wrapAttributeElement(e, t) {
              if (!Pr(e, t)) return !1;
              if (e.name !== t.name || e.priority !== t.priority) return !1;
              for (const n of e.getAttributeKeys())
                if ('class' !== n && 'style' !== n && t.hasAttribute(n) && t.getAttribute(n) !== e.getAttribute(n)) return !1;
              for (const n of e.getStyleNames()) if (t.hasStyle(n) && t.getStyle(n) !== e.getStyle(n)) return !1;
              for (const n of e.getAttributeKeys())
                'class' !== n && 'style' !== n && (t.hasAttribute(n) || this.setAttribute(n, e.getAttribute(n), t));
              for (const n of e.getStyleNames()) t.hasStyle(n) || this.setStyle(n, e.getStyle(n), t);
              for (const n of e.getClassNames()) t.hasClass(n) || this.addClass(n, t);
              return !0;
            }
            _unwrapAttributeElement(e, t) {
              if (!Pr(e, t)) return !1;
              if (e.name !== t.name || e.priority !== t.priority) return !1;
              for (const n of e.getAttributeKeys())
                if ('class' !== n && 'style' !== n && (!t.hasAttribute(n) || t.getAttribute(n) !== e.getAttribute(n))) return !1;
              if (!t.hasClass(...e.getClassNames())) return !1;
              for (const n of e.getStyleNames()) if (!t.hasStyle(n) || t.getStyle(n) !== e.getStyle(n)) return !1;
              for (const n of e.getAttributeKeys()) 'class' !== n && 'style' !== n && this.removeAttribute(n, t);
              return this.removeClass(Array.from(e.getClassNames()), t), this.removeStyle(Array.from(e.getStyleNames()), t), !0;
            }
            _breakAttributesRange(e, t = !1) {
              const n = e.start,
                o = e.end;
              if ((Nr(e, this.document), e.isCollapsed)) {
                const n = this._breakAttributes(e.start, t);
                return new Hi(n, n);
              }
              const i = this._breakAttributes(o, t),
                r = i.parent.childCount,
                s = this._breakAttributes(n, t);
              return (i.offset += i.parent.childCount - r), new Hi(s, i);
            }
            _breakAttributes(e, t = !1) {
              const n = e.offset,
                o = e.parent;
              if (e.parent.is('emptyElement')) throw new l('view-writer-cannot-break-empty-element', this.document);
              if (e.parent.is('uiElement')) throw new l('view-writer-cannot-break-ui-element', this.document);
              if (e.parent.is('rawElement')) throw new l('view-writer-cannot-break-raw-element', this.document);
              if (!t && o.is('$text') && Br(o.parent)) return e.clone();
              if (Br(o)) return e.clone();
              if (o.is('$text')) return this._breakAttributes(Tr(e), t);
              if (n == o.childCount) {
                const e = new Fi(o.parent, o.index + 1);
                return this._breakAttributes(e, t);
              }
              if (0 === n) {
                const e = new Fi(o.parent, o.index);
                return this._breakAttributes(e, t);
              }
              {
                const e = o.index + 1,
                  i = o._clone();
                o.parent._insertChild(e, i), this._addToClonedElementsGroup(i);
                const r = o.childCount - n,
                  s = o._removeChildren(n, r);
                i._appendChild(s);
                const a = new Fi(o.parent, e);
                return this._breakAttributes(a, t);
              }
            }
            _addToClonedElementsGroup(e) {
              if (!e.root.is('rootElement')) return;
              if (e.is('element')) for (const t of e.getChildren()) this._addToClonedElementsGroup(t);
              const t = e.id;
              if (!t) return;
              let n = this._cloneGroups.get(t);
              n || ((n = new Set()), this._cloneGroups.set(t, n)), n.add(e), (e._clonesGroup = n);
            }
            _removeFromClonedElementsGroup(e) {
              if (e.is('element')) for (const t of e.getChildren()) this._removeFromClonedElementsGroup(t);
              const t = e.id;
              if (!t) return;
              const n = this._cloneGroups.get(t);
              n && n.delete(e);
            }
          }
          function xr(e) {
            let t = e.parent;
            for (; !Br(t); ) {
              if (!t) return;
              t = t.parent;
            }
            return t;
          }
          function Er(e, t) {
            return e.priority < t.priority || (!(e.priority > t.priority) && e.getIdentity() < t.getIdentity());
          }
          function Dr(e) {
            const t = e.nodeBefore;
            if (t && t.is('$text')) return new Fi(t, t.data.length);
            const n = e.nodeAfter;
            return n && n.is('$text') ? new Fi(n, 0) : e;
          }
          function Tr(e) {
            if (e.offset == e.parent.data.length) return new Fi(e.parent.parent, e.parent.index + 1);
            if (0 === e.offset) return new Fi(e.parent.parent, e.parent.index);
            const t = e.parent.data.slice(e.offset);
            return (
              (e.parent._data = e.parent.data.slice(0, e.offset)),
              e.parent.parent._insertChild(e.parent.index + 1, new Mo(e.root.document, t)),
              new Fi(e.parent.parent, e.parent.index + 1)
            );
          }
          function Ir(e, t) {
            const n = e.data.length;
            return (e._data += t.data), t._remove(), new Fi(e, n);
          }
          const Sr = [Mo, tr, zi, ir, yr, br];
          function Mr(e, t) {
            for (const n of e) {
              if (!Sr.some((e) => n instanceof e)) throw new l('view-writer-insert-invalid-node-type', t);
              n.is('$text') || Mr(n.getChildren(), t);
            }
          }
          function Br(e) {
            return e && (e.is('containerElement') || e.is('documentFragment'));
          }
          function Nr(e, t) {
            const n = xr(e.start),
              o = xr(e.end);
            if (!n || !o || n !== o) throw new l('view-writer-invalid-range-container', t);
          }
          function Pr(e, t) {
            return null === e.id && null === t.id;
          }
          function zr(e) {
            return '[object Text]' == Object.prototype.toString.call(e);
          }
          const Lr = (e) => e.createTextNode(' '),
            jr = (e) => {
              const t = e.createElement('span');
              return (t.dataset.ckeFiller = 'true'), (t.innerText = ' '), t;
            },
            Or = (e) => {
              const t = e.createElement('br');
              return (t.dataset.ckeFiller = 'true'), t;
            },
            Rr = '⁠'.repeat(7);
          function Vr(e) {
            return zr(e) && e.data.substr(0, 7) === Rr;
          }
          function Fr(e) {
            return 7 == e.data.length && Vr(e);
          }
          function Hr(e) {
            return Vr(e) ? e.data.slice(7) : e.data;
          }
          function Ur(e, t) {
            if (t.keyCode == hr.arrowleft) {
              const e = t.domTarget.ownerDocument.defaultView.getSelection();
              if (1 == e.rangeCount && e.getRangeAt(0).collapsed) {
                const t = e.getRangeAt(0).startContainer,
                  n = e.getRangeAt(0).startOffset;
                Vr(t) && n <= 7 && e.collapse(t, 0);
              }
            }
          }
          function qr(e, t, n, o = !1) {
            n =
              n ||
              function (e, t) {
                return e === t;
              };
            const i = Array.isArray(e) ? e : Array.prototype.slice.call(e),
              r = Array.isArray(t) ? t : Array.prototype.slice.call(t),
              s = (function (e, t, n) {
                const o = Wr(e, t, n);
                if (-1 === o) return { firstIndex: -1, lastIndexOld: -1, lastIndexNew: -1 };
                const i = Gr(e, o),
                  r = Gr(t, o),
                  s = Wr(i, r, n),
                  a = e.length - s,
                  l = t.length - s;
                return { firstIndex: o, lastIndexOld: a, lastIndexNew: l };
              })(i, r, n);
            return o
              ? (function (e, t) {
                  const { firstIndex: n, lastIndexOld: o, lastIndexNew: i } = e;
                  if (-1 === n) return Array(t).fill('equal');
                  let r = [];
                  n > 0 && (r = r.concat(Array(n).fill('equal')));
                  i - n > 0 && (r = r.concat(Array(i - n).fill('insert')));
                  o - n > 0 && (r = r.concat(Array(o - n).fill('delete')));
                  i < t && (r = r.concat(Array(t - i).fill('equal')));
                  return r;
                })(s, r.length)
              : (function (e, t) {
                  const n = [],
                    { firstIndex: o, lastIndexOld: i, lastIndexNew: r } = t;
                  r - o > 0 && n.push({ index: o, type: 'insert', values: e.slice(o, r) });
                  i - o > 0 && n.push({ index: o + (r - o), type: 'delete', howMany: i - o });
                  return n;
                })(r, s);
          }
          function Wr(e, t, n) {
            for (let o = 0; o < Math.max(e.length, t.length); o++) if (void 0 === e[o] || void 0 === t[o] || !n(e[o], t[o])) return o;
            return -1;
          }
          function Gr(e, t) {
            return e.slice(t).reverse();
          }
          function $r(e, t, n) {
            n =
              n ||
              function (e, t) {
                return e === t;
              };
            const o = e.length,
              i = t.length;
            if (o > 200 || i > 200 || o + i > 300) return $r.fastDiff(e, t, n, !0);
            let r, s;
            if (i < o) {
              const n = e;
              (e = t), (t = n), (r = 'delete'), (s = 'insert');
            } else (r = 'insert'), (s = 'delete');
            const a = e.length,
              l = t.length,
              c = l - a,
              d = {},
              u = {};
            function h(o) {
              const i = (void 0 !== u[o - 1] ? u[o - 1] : -1) + 1,
                c = void 0 !== u[o + 1] ? u[o + 1] : -1,
                h = i > c ? -1 : 1;
              d[o + h] && (d[o] = d[o + h].slice(0)), d[o] || (d[o] = []), d[o].push(i > c ? r : s);
              let m = Math.max(i, c),
                g = m - o;
              for (; g < a && m < l && n(e[g], t[m]); ) g++, m++, d[o].push('equal');
              return m;
            }
            let m,
              g = 0;
            do {
              for (m = -g; m < c; m++) u[m] = h(m);
              for (m = c + g; m > c; m--) u[m] = h(m);
              (u[c] = h(c)), g++;
            } while (u[c] !== l);
            return d[c].slice(1);
          }
          function Yr(e, t, n) {
            e.insertBefore(n, e.childNodes[t] || null);
          }
          function Kr(e) {
            const t = e.parentNode;
            t && t.removeChild(e);
          }
          function Qr(e) {
            return e && e.nodeType === Node.COMMENT_NODE;
          }
          function Zr(e) {
            if (e) {
              if (e.defaultView) return e instanceof e.defaultView.Document;
              if (e.ownerDocument && e.ownerDocument.defaultView) return e instanceof e.ownerDocument.defaultView.Node;
            }
            return !1;
          }
          $r.fastDiff = qr;
          var Jr = n(3379),
            Xr = n.n(Jr),
            es = n(4401),
            ts = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(es.Z, ts);
          es.Z.locals;
          class ns extends N {
            constructor(e, t) {
              super(),
                (this.domDocuments = new Set()),
                (this.domConverter = e),
                (this.markedAttributes = new Set()),
                (this.markedChildren = new Set()),
                (this.markedTexts = new Set()),
                (this.selection = t),
                this.set('isFocused', !1),
                this.set('isSelecting', !1),
                lr.isBlink &&
                  !lr.isAndroid &&
                  this.on('change:isSelecting', () => {
                    this.isSelecting || this.render();
                  }),
                (this._inlineFiller = null),
                (this._fakeSelectionContainer = null);
            }
            markToSync(e, t) {
              if ('text' === e) this.domConverter.mapViewToDom(t.parent) && this.markedTexts.add(t);
              else {
                if (!this.domConverter.mapViewToDom(t)) return;
                if ('attributes' === e) this.markedAttributes.add(t);
                else {
                  if ('children' !== e) throw new l('view-renderer-unknown-type', this);
                  this.markedChildren.add(t);
                }
              }
            }
            render() {
              let e = null;
              const t = !(lr.isBlink && !lr.isAndroid) || !this.isSelecting;
              for (const e of this.markedChildren) this._updateChildrenMappings(e);
              t
                ? (this._inlineFiller && !this._isSelectionInInlineFiller() && this._removeInlineFiller(),
                  this._inlineFiller
                    ? (e = this._getInlineFillerPosition())
                    : this._needsInlineFillerAtSelection() && ((e = this.selection.getFirstPosition()), this.markedChildren.add(e.parent)))
                : this._inlineFiller &&
                  this._inlineFiller.parentNode &&
                  ((e = this.domConverter.domPositionToView(this._inlineFiller)),
                  e && e.parent.is('$text') && (e = Fi._createBefore(e.parent)));
              for (const e of this.markedAttributes) this._updateAttrs(e);
              for (const t of this.markedChildren) this._updateChildren(t, { inlineFillerPosition: e });
              for (const t of this.markedTexts)
                !this.markedChildren.has(t.parent) &&
                  this.domConverter.mapViewToDom(t.parent) &&
                  this._updateText(t, { inlineFillerPosition: e });
              if (t)
                if (e) {
                  const t = this.domConverter.viewPositionToDom(e),
                    n = t.parent.ownerDocument;
                  Vr(t.parent) ? (this._inlineFiller = t.parent) : (this._inlineFiller = os(n, t.parent, t.offset));
                } else this._inlineFiller = null;
              this._updateFocus(),
                this._updateSelection(),
                this.markedTexts.clear(),
                this.markedAttributes.clear(),
                this.markedChildren.clear();
            }
            _updateChildrenMappings(e) {
              if (!this.domConverter.mapViewToDom(e)) return;
              const t = Array.from(this.domConverter.mapViewToDom(e).childNodes),
                n = Array.from(this.domConverter.viewChildrenToDom(e, { withChildren: !1 })),
                o = this._diffNodeLists(t, n),
                i = this._findReplaceActions(o, t, n);
              if (-1 !== i.indexOf('replace')) {
                const o = { equal: 0, insert: 0, delete: 0 };
                for (const r of i)
                  if ('replace' === r) {
                    const i = o.equal + o.insert,
                      r = o.equal + o.delete,
                      s = e.getChild(i);
                    !s || s.is('uiElement') || s.is('rawElement') || this._updateElementMappings(s, t[r]), Kr(n[i]), o.equal++;
                  } else o[r]++;
              }
            }
            _updateElementMappings(e, t) {
              this.domConverter.unbindDomElement(t),
                this.domConverter.bindElements(t, e),
                this.markedChildren.add(e),
                this.markedAttributes.add(e);
            }
            _getInlineFillerPosition() {
              const e = this.selection.getFirstPosition();
              return e.parent.is('$text') ? Fi._createBefore(e.parent) : e;
            }
            _isSelectionInInlineFiller() {
              if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
              const e = this.selection.getFirstPosition(),
                t = this.domConverter.viewPositionToDom(e);
              return !!(t && zr(t.parent) && Vr(t.parent));
            }
            _removeInlineFiller() {
              const e = this._inlineFiller;
              if (!Vr(e)) throw new l('view-renderer-filler-was-lost', this);
              Fr(e) ? e.remove() : (e.data = e.data.substr(7)), (this._inlineFiller = null);
            }
            _needsInlineFillerAtSelection() {
              if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
              const e = this.selection.getFirstPosition(),
                t = e.parent,
                n = e.offset;
              if (!this.domConverter.mapViewToDom(t.root)) return !1;
              if (!t.is('element')) return !1;
              if (
                !(function (e) {
                  if ('false' == e.getAttribute('contenteditable')) return !1;
                  const t = e.findAncestor((e) => e.hasAttribute('contenteditable'));
                  return !t || 'true' == t.getAttribute('contenteditable');
                })(t)
              )
                return !1;
              if (n === t.getFillerOffset()) return !1;
              const o = e.nodeBefore,
                i = e.nodeAfter;
              return !(o instanceof Mo || i instanceof Mo);
            }
            _updateText(e, t) {
              const n = this.domConverter.findCorrespondingDomText(e),
                o = this.domConverter.viewToDom(e),
                i = n.data;
              let r = o.data;
              const s = t.inlineFillerPosition;
              if ((s && s.parent == e.parent && s.offset == e.index && (r = Rr + r), i != r)) {
                const e = qr(i, r);
                for (const t of e) 'insert' === t.type ? n.insertData(t.index, t.values.join('')) : n.deleteData(t.index, t.howMany);
              }
            }
            _updateAttrs(e) {
              const t = this.domConverter.mapViewToDom(e);
              if (!t) return;
              const n = Array.from(t.attributes).map((e) => e.name),
                o = e.getAttributeKeys();
              for (const n of o) this.domConverter.setDomElementAttribute(t, n, e.getAttribute(n), e);
              for (const o of n) e.hasAttribute(o) || this.domConverter.removeDomElementAttribute(t, o);
            }
            _updateChildren(e, t) {
              const n = this.domConverter.mapViewToDom(e);
              if (!n) return;
              const o = t.inlineFillerPosition,
                i = this.domConverter.mapViewToDom(e).childNodes,
                r = Array.from(this.domConverter.viewChildrenToDom(e, { bind: !0 }));
              o && o.parent === e && os(n.ownerDocument, r, o.offset);
              const s = this._diffNodeLists(i, r);
              let a = 0;
              const l = new Set();
              for (const e of s) 'delete' === e ? (l.add(i[a]), Kr(i[a])) : 'equal' === e && a++;
              a = 0;
              for (const e of s)
                'insert' === e
                  ? (Yr(n, a, r[a]), a++)
                  : 'equal' === e && (this._markDescendantTextToSync(this.domConverter.domToView(r[a])), a++);
              for (const e of l) e.parentNode || this.domConverter.unbindDomElement(e);
            }
            _diffNodeLists(e, t) {
              return $r(
                (e = (function (e, t) {
                  const n = Array.from(e);
                  if (0 == n.length || !t) return n;
                  n[n.length - 1] == t && n.pop();
                  return n;
                })(e, this._fakeSelectionContainer)),
                t,
                rs.bind(null, this.domConverter)
              );
            }
            _findReplaceActions(e, t, n) {
              if (-1 === e.indexOf('insert') || -1 === e.indexOf('delete')) return e;
              let o = [],
                i = [],
                r = [];
              const s = { equal: 0, insert: 0, delete: 0 };
              for (const a of e)
                'insert' === a
                  ? r.push(n[s.equal + s.insert])
                  : 'delete' === a
                  ? i.push(t[s.equal + s.delete])
                  : ((o = o.concat($r(i, r, is).map((e) => ('equal' === e ? 'replace' : e)))), o.push('equal'), (i = []), (r = [])),
                  s[a]++;
              return o.concat($r(i, r, is).map((e) => ('equal' === e ? 'replace' : e)));
            }
            _markDescendantTextToSync(e) {
              if (e)
                if (e.is('$text')) this.markedTexts.add(e);
                else if (e.is('element')) for (const t of e.getChildren()) this._markDescendantTextToSync(t);
            }
            _updateSelection() {
              if (lr.isBlink && !lr.isAndroid && this.isSelecting && !this.markedChildren.size) return;
              if (0 === this.selection.rangeCount) return this._removeDomSelection(), void this._removeFakeSelection();
              const e = this.domConverter.mapViewToDom(this.selection.editableElement);
              this.isFocused &&
                e &&
                (this.selection.isFake ? this._updateFakeSelection(e) : (this._removeFakeSelection(), this._updateDomSelection(e)));
            }
            _updateFakeSelection(e) {
              const t = e.ownerDocument;
              this._fakeSelectionContainer ||
                (this._fakeSelectionContainer = (function (e) {
                  const t = e.createElement('div');
                  return (
                    (t.className = 'ck-fake-selection-container'),
                    Object.assign(t.style, { position: 'fixed', top: 0, left: '-9999px', width: '42px' }),
                    (t.textContent = ' '),
                    t
                  );
                })(t));
              const n = this._fakeSelectionContainer;
              if ((this.domConverter.bindFakeSelection(n, this.selection), !this._fakeSelectionNeedsUpdate(e))) return;
              (n.parentElement && n.parentElement == e) || e.appendChild(n), (n.textContent = this.selection.fakeSelectionLabel || ' ');
              const o = t.getSelection(),
                i = t.createRange();
              o.removeAllRanges(), i.selectNodeContents(n), o.addRange(i);
            }
            _updateDomSelection(e) {
              const t = e.ownerDocument.defaultView.getSelection();
              if (!this._domSelectionNeedsUpdate(t)) return;
              const n = this.domConverter.viewPositionToDom(this.selection.anchor),
                o = this.domConverter.viewPositionToDom(this.selection.focus);
              t.collapse(n.parent, n.offset),
                t.extend(o.parent, o.offset),
                lr.isGecko &&
                  (function (e, t) {
                    const n = e.parent;
                    if (n.nodeType != Node.ELEMENT_NODE || e.offset != n.childNodes.length - 1) return;
                    const o = n.childNodes[e.offset];
                    o && 'BR' == o.tagName && t.addRange(t.getRangeAt(0));
                  })(o, t);
            }
            _domSelectionNeedsUpdate(e) {
              if (!this.domConverter.isDomSelectionCorrect(e)) return !0;
              const t = e && this.domConverter.domSelectionToView(e);
              return (!t || !this.selection.isEqual(t)) && !(!this.selection.isCollapsed && this.selection.isSimilar(t));
            }
            _fakeSelectionNeedsUpdate(e) {
              const t = this._fakeSelectionContainer,
                n = e.ownerDocument.getSelection();
              return (
                !t ||
                t.parentElement !== e ||
                (n.anchorNode !== t && !t.contains(n.anchorNode)) ||
                t.textContent !== this.selection.fakeSelectionLabel
              );
            }
            _removeDomSelection() {
              for (const e of this.domDocuments) {
                const t = e.getSelection();
                if (t.rangeCount) {
                  const n = e.activeElement,
                    o = this.domConverter.mapDomToView(n);
                  n && o && t.removeAllRanges();
                }
              }
            }
            _removeFakeSelection() {
              const e = this._fakeSelectionContainer;
              e && e.remove();
            }
            _updateFocus() {
              if (this.isFocused) {
                const e = this.selection.editableElement;
                e && this.domConverter.focus(e);
              }
            }
          }
          function os(e, t, n) {
            const o = t instanceof Array ? t : t.childNodes,
              i = o[n];
            if (zr(i)) return (i.data = Rr + i.data), i;
            {
              const i = e.createTextNode(Rr);
              return Array.isArray(t) ? o.splice(n, 0, i) : Yr(t, n, i), i;
            }
          }
          function is(e, t) {
            return Zr(e) && Zr(t) && !zr(e) && !zr(t) && !Qr(e) && !Qr(t) && e.tagName.toLowerCase() === t.tagName.toLowerCase();
          }
          function rs(e, t, n) {
            return t === n || (zr(t) && zr(n) ? t.data === n.data : !(!e.isBlockFiller(t) || !e.isBlockFiller(n)));
          }
          function ss(e) {
            let t = 0;
            for (; e.previousSibling; ) (e = e.previousSibling), t++;
            return t;
          }
          function as(e) {
            const t = [];
            let n = e;
            for (; n && n.nodeType != Node.DOCUMENT_NODE; ) t.unshift(n), (n = n.parentNode);
            return t;
          }
          const ls = Or(_o.document),
            cs = Lr(_o.document),
            ds = jr(_o.document),
            us = 'data-ck-unsafe-attribute-',
            hs = 'data-ck-unsafe-element';
          class ms {
            constructor(e, t = {}) {
              (this.document = e),
                (this.renderingMode = t.renderingMode || 'editing'),
                (this.blockFillerMode = t.blockFillerMode || ('editing' === this.renderingMode ? 'br' : 'nbsp')),
                (this.preElements = ['pre']),
                (this.blockElements = [
                  'address',
                  'article',
                  'aside',
                  'blockquote',
                  'caption',
                  'center',
                  'dd',
                  'details',
                  'dir',
                  'div',
                  'dl',
                  'dt',
                  'fieldset',
                  'figcaption',
                  'figure',
                  'footer',
                  'form',
                  'h1',
                  'h2',
                  'h3',
                  'h4',
                  'h5',
                  'h6',
                  'header',
                  'hgroup',
                  'legend',
                  'li',
                  'main',
                  'menu',
                  'nav',
                  'ol',
                  'p',
                  'pre',
                  'section',
                  'summary',
                  'table',
                  'tbody',
                  'td',
                  'tfoot',
                  'th',
                  'thead',
                  'tr',
                  'ul',
                ]),
                (this.inlineObjectElements = [
                  'object',
                  'iframe',
                  'input',
                  'button',
                  'textarea',
                  'select',
                  'option',
                  'video',
                  'embed',
                  'audio',
                  'img',
                  'canvas',
                ]),
                (this.unsafeElements = ['script', 'style']),
                (this._domDocument = 'editing' === this.renderingMode ? _o.document : _o.document.implementation.createHTMLDocument('')),
                (this._domToViewMapping = new WeakMap()),
                (this._viewToDomMapping = new WeakMap()),
                (this._fakeSelectionMapping = new WeakMap()),
                (this._rawContentElementMatcher = new Po()),
                (this._encounteredRawContentDomNodes = new WeakSet());
            }
            bindFakeSelection(e, t) {
              this._fakeSelectionMapping.set(e, new Wi(t));
            }
            fakeSelectionToView(e) {
              return this._fakeSelectionMapping.get(e);
            }
            bindElements(e, t) {
              this._domToViewMapping.set(e, t), this._viewToDomMapping.set(t, e);
            }
            unbindDomElement(e) {
              const t = this._domToViewMapping.get(e);
              if (t) {
                this._domToViewMapping.delete(e), this._viewToDomMapping.delete(t);
                for (const t of Array.from(e.children)) this.unbindDomElement(t);
              }
            }
            bindDocumentFragments(e, t) {
              this._domToViewMapping.set(e, t), this._viewToDomMapping.set(t, e);
            }
            shouldRenderAttribute(e, t, n) {
              return (
                'data' === this.renderingMode ||
                (!(e = e.toLowerCase()).startsWith('on') &&
                  ('srcdoc' !== e || !t.match(/\bon\S+\s*=|javascript:|<\s*\/*script/i)) &&
                  (('img' === n && ('src' === e || 'srcset' === e)) ||
                    ('source' === n && 'srcset' === e) ||
                    !t.match(/^\s*(javascript:|data:(image\/svg|text\/x?html))/i)))
              );
            }
            setContentOf(e, t) {
              if ('data' === this.renderingMode) return void (e.innerHTML = t);
              const n = new DOMParser().parseFromString(t, 'text/html'),
                o = n.createDocumentFragment(),
                i = n.body.childNodes;
              for (; i.length > 0; ) o.appendChild(i[0]);
              const r = n.createTreeWalker(o, NodeFilter.SHOW_ELEMENT),
                s = [];
              let a;
              for (; (a = r.nextNode()); ) s.push(a);
              for (const e of s) {
                for (const t of e.getAttributeNames()) this.setDomElementAttribute(e, t, e.getAttribute(t));
                const t = e.tagName.toLowerCase();
                this._shouldRenameElement(t) && (fs(t), e.replaceWith(this._createReplacementDomElement(t, e)));
              }
              for (; e.firstChild; ) e.firstChild.remove();
              e.append(o);
            }
            viewToDom(e, t = {}) {
              if (e.is('$text')) {
                const t = this._processDataFromViewText(e);
                return this._domDocument.createTextNode(t);
              }
              {
                if (this.mapViewToDom(e)) return this.mapViewToDom(e);
                let n;
                if (e.is('documentFragment')) (n = this._domDocument.createDocumentFragment()), t.bind && this.bindDocumentFragments(n, e);
                else {
                  if (e.is('uiElement'))
                    return (
                      (n =
                        '$comment' === e.name
                          ? this._domDocument.createComment(e.getCustomProperty('$rawContent'))
                          : e.render(this._domDocument, this)),
                      t.bind && this.bindElements(n, e),
                      n
                    );
                  this._shouldRenameElement(e.name)
                    ? (fs(e.name), (n = this._createReplacementDomElement(e.name)))
                    : (n = e.hasAttribute('xmlns')
                        ? this._domDocument.createElementNS(e.getAttribute('xmlns'), e.name)
                        : this._domDocument.createElement(e.name)),
                    e.is('rawElement') && e.render(n, this),
                    t.bind && this.bindElements(n, e);
                  for (const t of e.getAttributeKeys()) this.setDomElementAttribute(n, t, e.getAttribute(t), e);
                }
                if (!1 !== t.withChildren) for (const o of this.viewChildrenToDom(e, t)) n.appendChild(o);
                return n;
              }
            }
            setDomElementAttribute(e, t, n, o) {
              const i = this.shouldRenderAttribute(t, n, e.tagName.toLowerCase()) || (o && o.shouldRenderUnsafeAttribute(t));
              i || c('domconverter-unsafe-attribute-detected', { domElement: e, key: t, value: n }),
                e.hasAttribute(t) && !i ? e.removeAttribute(t) : e.hasAttribute(us + t) && i && e.removeAttribute(us + t),
                e.setAttribute(i ? t : us + t, n);
            }
            removeDomElementAttribute(e, t) {
              t != hs && (e.removeAttribute(t), e.removeAttribute(us + t));
            }
            *viewChildrenToDom(e, t = {}) {
              const n = e.getFillerOffset && e.getFillerOffset();
              let o = 0;
              for (const i of e.getChildren()) {
                n === o && (yield this._getBlockFiller());
                const e = i.is('element') && i.getCustomProperty('dataPipeline:transparentRendering');
                e && 'data' == this.renderingMode
                  ? yield* this.viewChildrenToDom(i, t)
                  : (e && c('domconverter-transparent-rendering-unsupported-in-editing-pipeline', { viewElement: i }),
                    yield this.viewToDom(i, t)),
                  o++;
              }
              n === o && (yield this._getBlockFiller());
            }
            viewRangeToDom(e) {
              const t = this.viewPositionToDom(e.start),
                n = this.viewPositionToDom(e.end),
                o = this._domDocument.createRange();
              return o.setStart(t.parent, t.offset), o.setEnd(n.parent, n.offset), o;
            }
            viewPositionToDom(e) {
              const t = e.parent;
              if (t.is('$text')) {
                const n = this.findCorrespondingDomText(t);
                if (!n) return null;
                let o = e.offset;
                return Vr(n) && (o += 7), { parent: n, offset: o };
              }
              {
                let n, o, i;
                if (0 === e.offset) {
                  if (((n = this.mapViewToDom(t)), !n)) return null;
                  i = n.childNodes[0];
                } else {
                  const t = e.nodeBefore;
                  if (((o = t.is('$text') ? this.findCorrespondingDomText(t) : this.mapViewToDom(t)), !o)) return null;
                  (n = o.parentNode), (i = o.nextSibling);
                }
                if (zr(i) && Vr(i)) return { parent: i, offset: 7 };
                return { parent: n, offset: o ? ss(o) + 1 : 0 };
              }
            }
            domToView(e, t = {}) {
              if (this.isBlockFiller(e)) return null;
              const n = this.getHostViewElement(e);
              if (n) return n;
              if (Qr(e) && t.skipComments) return null;
              if (zr(e)) {
                if (Fr(e)) return null;
                {
                  const t = this._processDataFromDomText(e);
                  return '' === t ? null : new Mo(this.document, t);
                }
              }
              {
                if (this.mapDomToView(e)) return this.mapDomToView(e);
                let n;
                if (this.isDocumentFragment(e)) (n = new Cr(this.document)), t.bind && this.bindDocumentFragments(e, n);
                else {
                  (n = this._createViewElement(e, t)), t.bind && this.bindElements(e, n);
                  const o = e.attributes;
                  if (o) for (let e = o.length, t = 0; t < e; t++) n._setAttribute(o[t].name, o[t].value);
                  if (this._isViewElementWithRawContent(n, t) || Qr(e)) {
                    const t = Qr(e) ? e.data : e.innerHTML;
                    return n._setCustomProperty('$rawContent', t), this._encounteredRawContentDomNodes.add(e), n;
                  }
                }
                if (!1 !== t.withChildren) for (const o of this.domChildrenToView(e, t)) n._appendChild(o);
                return n;
              }
            }
            *domChildrenToView(e, t) {
              for (let n = 0; n < e.childNodes.length; n++) {
                const o = e.childNodes[n],
                  i = this.domToView(o, t);
                null !== i && (yield i);
              }
            }
            domSelectionToView(e) {
              if (1 === e.rangeCount) {
                let t = e.getRangeAt(0).startContainer;
                zr(t) && (t = t.parentNode);
                const n = this.fakeSelectionToView(t);
                if (n) return n;
              }
              const t = this.isDomSelectionBackward(e),
                n = [];
              for (let t = 0; t < e.rangeCount; t++) {
                const o = e.getRangeAt(t),
                  i = this.domRangeToView(o);
                i && n.push(i);
              }
              return new Wi(n, { backward: t });
            }
            domRangeToView(e) {
              const t = this.domPositionToView(e.startContainer, e.startOffset),
                n = this.domPositionToView(e.endContainer, e.endOffset);
              return t && n ? new Hi(t, n) : null;
            }
            domPositionToView(e, t = 0) {
              if (this.isBlockFiller(e)) return this.domPositionToView(e.parentNode, ss(e));
              const n = this.mapDomToView(e);
              if (n && (n.is('uiElement') || n.is('rawElement'))) return Fi._createBefore(n);
              if (zr(e)) {
                if (Fr(e)) return this.domPositionToView(e.parentNode, ss(e));
                const n = this.findCorrespondingViewText(e);
                let o = t;
                return n ? (Vr(e) && ((o -= 7), (o = o < 0 ? 0 : o)), new Fi(n, o)) : null;
              }
              if (0 === t) {
                const t = this.mapDomToView(e);
                if (t) return new Fi(t, 0);
              } else {
                const n = e.childNodes[t - 1],
                  o = zr(n) ? this.findCorrespondingViewText(n) : this.mapDomToView(n);
                if (o && o.parent) return new Fi(o.parent, o.index + 1);
              }
              return null;
            }
            mapDomToView(e) {
              return this.getHostViewElement(e) || this._domToViewMapping.get(e);
            }
            findCorrespondingViewText(e) {
              if (Fr(e)) return null;
              const t = this.getHostViewElement(e);
              if (t) return t;
              const n = e.previousSibling;
              if (n) {
                if (!this.isElement(n)) return null;
                const e = this.mapDomToView(n);
                if (e) {
                  const t = e.nextSibling;
                  return t instanceof Mo ? t : null;
                }
              } else {
                const t = this.mapDomToView(e.parentNode);
                if (t) {
                  const e = t.getChild(0);
                  return e instanceof Mo ? e : null;
                }
              }
              return null;
            }
            mapViewToDom(e) {
              return this._viewToDomMapping.get(e);
            }
            findCorrespondingDomText(e) {
              const t = e.previousSibling;
              return t && this.mapViewToDom(t)
                ? this.mapViewToDom(t).nextSibling
                : !t && e.parent && this.mapViewToDom(e.parent)
                ? this.mapViewToDom(e.parent).childNodes[0]
                : null;
            }
            focus(e) {
              const t = this.mapViewToDom(e);
              if (t && t.ownerDocument.activeElement !== t) {
                const { scrollX: e, scrollY: n } = _o.window,
                  o = [];
                gs(t, (e) => {
                  const { scrollLeft: t, scrollTop: n } = e;
                  o.push([t, n]);
                }),
                  t.focus(),
                  gs(t, (e) => {
                    const [t, n] = o.shift();
                    (e.scrollLeft = t), (e.scrollTop = n);
                  }),
                  _o.window.scrollTo(e, n);
              }
            }
            isElement(e) {
              return e && e.nodeType == Node.ELEMENT_NODE;
            }
            isDocumentFragment(e) {
              return e && e.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
            }
            isBlockFiller(e) {
              return 'br' == this.blockFillerMode
                ? e.isEqualNode(ls)
                : !('BR' !== e.tagName || !ps(e, this.blockElements) || 1 !== e.parentNode.childNodes.length) ||
                    e.isEqualNode(ds) ||
                    (function (e, t) {
                      return e.isEqualNode(cs) && ps(e, t) && 1 === e.parentNode.childNodes.length;
                    })(e, this.blockElements);
            }
            isDomSelectionBackward(e) {
              if (e.isCollapsed) return !1;
              const t = this._domDocument.createRange();
              t.setStart(e.anchorNode, e.anchorOffset), t.setEnd(e.focusNode, e.focusOffset);
              const n = t.collapsed;
              return t.detach(), n;
            }
            getHostViewElement(e) {
              const t = as(e);
              for (t.pop(); t.length; ) {
                const e = t.pop(),
                  n = this._domToViewMapping.get(e);
                if (n && (n.is('uiElement') || n.is('rawElement'))) return n;
              }
              return null;
            }
            isDomSelectionCorrect(e) {
              return (
                this._isDomSelectionPositionCorrect(e.anchorNode, e.anchorOffset) &&
                this._isDomSelectionPositionCorrect(e.focusNode, e.focusOffset)
              );
            }
            registerRawContentMatcher(e) {
              this._rawContentElementMatcher.add(e);
            }
            _getBlockFiller() {
              switch (this.blockFillerMode) {
                case 'nbsp':
                  return Lr(this._domDocument);
                case 'markedNbsp':
                  return jr(this._domDocument);
                case 'br':
                  return Or(this._domDocument);
              }
            }
            _isDomSelectionPositionCorrect(e, t) {
              if (zr(e) && Vr(e) && t < 7) return !1;
              if (this.isElement(e) && Vr(e.childNodes[t])) return !1;
              const n = this.mapDomToView(e);
              return !n || (!n.is('uiElement') && !n.is('rawElement'));
            }
            _processDataFromViewText(e) {
              let t = e.data;
              if (e.getAncestors().some((e) => this.preElements.includes(e.name))) return t;
              if (' ' == t.charAt(0)) {
                const n = this._getTouchingInlineViewNode(e, !1);
                (!(n && n.is('$textProxy') && this._nodeEndsWithSpace(n)) && n) || (t = ' ' + t.substr(1));
              }
              if (' ' == t.charAt(t.length - 1)) {
                const n = this._getTouchingInlineViewNode(e, !0),
                  o = n && n.is('$textProxy') && ' ' == n.data.charAt(0);
                (' ' != t.charAt(t.length - 2) && n && !o) || (t = t.substr(0, t.length - 1) + ' ');
              }
              return t.replace(/ {2}/g, '  ');
            }
            _nodeEndsWithSpace(e) {
              if (e.getAncestors().some((e) => this.preElements.includes(e.name))) return !1;
              const t = this._processDataFromViewText(e);
              return ' ' == t.charAt(t.length - 1);
            }
            _processDataFromDomText(e) {
              let t = e.data;
              if (
                (function (e, t) {
                  return as(e).some((e) => e.tagName && t.includes(e.tagName.toLowerCase()));
                })(e, this.preElements)
              )
                return Hr(e);
              t = t.replace(/[ \n\t\r]{1,}/g, ' ');
              const n = this._getTouchingInlineDomNode(e, !1),
                o = this._getTouchingInlineDomNode(e, !0),
                i = this._checkShouldLeftTrimDomText(e, n),
                r = this._checkShouldRightTrimDomText(e, o);
              i && (t = t.replace(/^ /, '')), r && (t = t.replace(/ $/, '')), (t = Hr(new Text(t))), (t = t.replace(/ \u00A0/g, '  '));
              const s = o && this.isElement(o) && 'BR' != o.tagName,
                a = o && zr(o) && ' ' == o.data.charAt(0);
              return (
                (/( |\u00A0)\u00A0$/.test(t) || !o || s || a) && (t = t.replace(/\u00A0$/, ' ')),
                (i || (n && this.isElement(n) && 'BR' != n.tagName)) && (t = t.replace(/^\u00A0/, ' ')),
                t
              );
            }
            _checkShouldLeftTrimDomText(e, t) {
              return (
                !t ||
                (this.isElement(t)
                  ? 'BR' === t.tagName
                  : !this._encounteredRawContentDomNodes.has(e.previousSibling) && /[^\S\u00A0]/.test(t.data.charAt(t.data.length - 1)))
              );
            }
            _checkShouldRightTrimDomText(e, t) {
              return !t && !Vr(e);
            }
            _getTouchingInlineViewNode(e, t) {
              const n = new Vi({ startPosition: t ? Fi._createAfter(e) : Fi._createBefore(e), direction: t ? 'forward' : 'backward' });
              for (const e of n) {
                if (e.item.is('element') && this.inlineObjectElements.includes(e.item.name)) return e.item;
                if (e.item.is('containerElement')) return null;
                if (e.item.is('element', 'br')) return null;
                if (e.item.is('$textProxy')) return e.item;
              }
              return null;
            }
            _getTouchingInlineDomNode(e, t) {
              if (!e.parentNode) return null;
              const n = t ? 'firstChild' : 'lastChild',
                o = t ? 'nextSibling' : 'previousSibling';
              let i = !0,
                r = e;
              do {
                if (
                  (!i && r[n] ? (r = r[n]) : r[o] ? ((r = r[o]), (i = !1)) : ((r = r.parentNode), (i = !0)), !r || this._isBlockElement(r))
                )
                  return null;
              } while (!zr(r) && 'BR' != r.tagName && !this._isInlineObjectElement(r));
              return r;
            }
            _isBlockElement(e) {
              return this.isElement(e) && this.blockElements.includes(e.tagName.toLowerCase());
            }
            _isInlineObjectElement(e) {
              return this.isElement(e) && this.inlineObjectElements.includes(e.tagName.toLowerCase());
            }
            _createViewElement(e, t) {
              if (Qr(e)) return new br(this.document, '$comment');
              const n = t.keepOriginalCase ? e.tagName : e.tagName.toLowerCase();
              return new Ni(this.document, n);
            }
            _isViewElementWithRawContent(e, t) {
              return !1 !== t.withChildren && !!this._rawContentElementMatcher.match(e);
            }
            _shouldRenameElement(e) {
              const t = e.toLowerCase();
              return 'editing' === this.renderingMode && this.unsafeElements.includes(t);
            }
            _createReplacementDomElement(e, t) {
              const n = this._domDocument.createElement('span');
              if ((n.setAttribute(hs, e), t)) {
                for (; t.firstChild; ) n.appendChild(t.firstChild);
                for (const e of t.getAttributeNames()) n.setAttribute(e, t.getAttribute(e));
              }
              return n;
            }
          }
          function gs(e, t) {
            let n = e;
            for (; n; ) t(n), (n = n.parentElement);
          }
          function ps(e, t) {
            const n = e.parentNode;
            return !!n && !!n.tagName && t.includes(n.tagName.toLowerCase());
          }
          function fs(e) {
            'script' === e && c('domconverter-unsafe-script-element-detected'),
              'style' === e && c('domconverter-unsafe-style-element-detected');
          }
          function ks(e) {
            const t = Object.prototype.toString.apply(e);
            return '[object Window]' == t || '[object global]' == t;
          }
          function bs(e) {
            return class extends e {
              listenTo(e, t, n, o = {}) {
                if (Zr(e) || ks(e)) {
                  const i = { capture: !!o.useCapture, passive: !!o.usePassive },
                    r = this._getProxyEmitter(e, i) || new _s(e, i);
                  this.listenTo(r, t, n, o);
                } else b.prototype.listenTo.call(this, e, t, n, o);
              }
              stopListening(e, t, n) {
                if (Zr(e) || ks(e)) {
                  const o = this._getAllProxyEmitters(e);
                  for (const e of o) this.stopListening(e, t, n);
                } else b.prototype.stopListening.call(this, e, t, n);
              }
              _getProxyEmitter(e, t) {
                return (function (e, t) {
                  const n = e[g];
                  return n && n[t] ? n[t].emitter : null;
                })(this, ys(e, t));
              }
              _getAllProxyEmitters(e) {
                return [
                  { capture: !1, passive: !1 },
                  { capture: !1, passive: !0 },
                  { capture: !0, passive: !1 },
                  { capture: !0, passive: !0 },
                ]
                  .map((t) => this._getProxyEmitter(e, t))
                  .filter((e) => !!e);
              }
            };
          }
          const ws = bs(b);
          [
            '_getProxyEmitter',
            '_getAllProxyEmitters',
            'on',
            'once',
            'off',
            'listenTo',
            'stopListening',
            'fire',
            'delegate',
            'stopDelegating',
            '_addEventListener',
            '_removeEventListener',
          ].forEach((e) => {
            bs[e] = ws.prototype[e];
          });
          class _s extends b {
            constructor(e, t) {
              super(), w(this, ys(e, t)), (this._domNode = e), (this._options = t);
            }
            attach(e) {
              if (this._domListeners && this._domListeners[e]) return;
              const t = this._createDomListener(e);
              this._domNode.addEventListener(e, t, this._options),
                this._domListeners || (this._domListeners = {}),
                (this._domListeners[e] = t);
            }
            detach(e) {
              let t;
              !this._domListeners[e] || ((t = this._events[e]) && t.callbacks.length) || this._domListeners[e].removeListener();
            }
            _addEventListener(e, t, n) {
              this.attach(e), b.prototype._addEventListener.call(this, e, t, n);
            }
            _removeEventListener(e, t) {
              b.prototype._removeEventListener.call(this, e, t), this.detach(e);
            }
            _createDomListener(e) {
              const t = (t) => {
                this.fire(e, t);
              };
              return (
                (t.removeListener = () => {
                  this._domNode.removeEventListener(e, t, this._options), delete this._domListeners[e];
                }),
                t
              );
            }
          }
          function ys(e, t) {
            let n = (function (e) {
              return e['data-ck-expando'] || (e['data-ck-expando'] = r());
            })(e);
            for (const e of Object.keys(t).sort()) t[e] && (n += '-' + e);
            return n;
          }
          class As extends ws {
            constructor(e) {
              super(), (this.view = e), (this.document = e.document), (this.isEnabled = !1);
            }
            enable() {
              this.isEnabled = !0;
            }
            disable() {
              this.isEnabled = !1;
            }
            destroy() {
              this.disable(), this.stopListening();
            }
            checkShouldIgnoreEventFromTarget(e) {
              return (
                e && 3 === e.nodeType && (e = e.parentNode),
                !(!e || 1 !== e.nodeType) && e.matches('[data-cke-ignore-events], [data-cke-ignore-events] *')
              );
            }
          }
          const Cs = function (e) {
            return this.__data__.set(e, '__lodash_hash_undefined__'), this;
          };
          const vs = function (e) {
            return this.__data__.has(e);
          };
          function xs(e) {
            var t = -1,
              n = null == e ? 0 : e.length;
            for (this.__data__ = new at(); ++t < n; ) this.add(e[t]);
          }
          (xs.prototype.add = xs.prototype.push = Cs), (xs.prototype.has = vs);
          const Es = xs;
          const Ds = function (e, t) {
            for (var n = -1, o = null == e ? 0 : e.length; ++n < o; ) if (t(e[n], n, e)) return !0;
            return !1;
          };
          const Ts = function (e, t) {
            return e.has(t);
          };
          const Is = function (e, t, n, o, i, r) {
            var s = 1 & n,
              a = e.length,
              l = t.length;
            if (a != l && !(s && l > a)) return !1;
            var c = r.get(e),
              d = r.get(t);
            if (c && d) return c == t && d == e;
            var u = -1,
              h = !0,
              m = 2 & n ? new Es() : void 0;
            for (r.set(e, t), r.set(t, e); ++u < a; ) {
              var g = e[u],
                p = t[u];
              if (o) var f = s ? o(p, g, u, t, e, r) : o(g, p, u, e, t, r);
              if (void 0 !== f) {
                if (f) continue;
                h = !1;
                break;
              }
              if (m) {
                if (
                  !Ds(t, function (e, t) {
                    if (!Ts(m, t) && (g === e || i(g, e, n, o, r))) return m.push(t);
                  })
                ) {
                  h = !1;
                  break;
                }
              } else if (g !== p && !i(g, p, n, o, r)) {
                h = !1;
                break;
              }
            }
            return r.delete(e), r.delete(t), h;
          };
          const Ss = function (e) {
            var t = -1,
              n = Array(e.size);
            return (
              e.forEach(function (e, o) {
                n[++t] = [o, e];
              }),
              n
            );
          };
          const Ms = function (e) {
            var t = -1,
              n = Array(e.size);
            return (
              e.forEach(function (e) {
                n[++t] = e;
              }),
              n
            );
          };
          var Bs = Y ? Y.prototype : void 0,
            Ns = Bs ? Bs.valueOf : void 0;
          const Ps = function (e, t, n, o, i, r, s) {
            switch (n) {
              case '[object DataView]':
                if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                (e = e.buffer), (t = t.buffer);
              case '[object ArrayBuffer]':
                return !(e.byteLength != t.byteLength || !r(new Rn(e), new Rn(t)));
              case '[object Boolean]':
              case '[object Date]':
              case '[object Number]':
                return ge(+e, +t);
              case '[object Error]':
                return e.name == t.name && e.message == t.message;
              case '[object RegExp]':
              case '[object String]':
                return e == t + '';
              case '[object Map]':
                var a = Ss;
              case '[object Set]':
                var l = 1 & o;
                if ((a || (a = Ms), e.size != t.size && !l)) return !1;
                var c = s.get(e);
                if (c) return c == t;
                (o |= 2), s.set(e, t);
                var d = Is(a(e), a(t), o, i, r, s);
                return s.delete(e), d;
              case '[object Symbol]':
                if (Ns) return Ns.call(e) == Ns.call(t);
            }
            return !1;
          };
          var zs = Object.prototype.hasOwnProperty;
          const Ls = function (e, t, n, o, i, r) {
            var s = 1 & n,
              a = wn(e),
              l = a.length;
            if (l != wn(t).length && !s) return !1;
            for (var c = l; c--; ) {
              var d = a[c];
              if (!(s ? d in t : zs.call(t, d))) return !1;
            }
            var u = r.get(e),
              h = r.get(t);
            if (u && h) return u == t && h == e;
            var m = !0;
            r.set(e, t), r.set(t, e);
            for (var g = s; ++c < l; ) {
              var p = e[(d = a[c])],
                f = t[d];
              if (o) var k = s ? o(f, p, d, t, e, r) : o(p, f, d, e, t, r);
              if (!(void 0 === k ? p === f || i(p, f, n, o, r) : k)) {
                m = !1;
                break;
              }
              g || (g = 'constructor' == d);
            }
            if (m && !g) {
              var b = e.constructor,
                w = t.constructor;
              b == w ||
                !('constructor' in e) ||
                !('constructor' in t) ||
                ('function' == typeof b && b instanceof b && 'function' == typeof w && w instanceof w) ||
                (m = !1);
            }
            return r.delete(e), r.delete(t), m;
          };
          var js = '[object Arguments]',
            Os = '[object Array]',
            Rs = '[object Object]',
            Vs = Object.prototype.hasOwnProperty;
          const Fs = function (e, t, n, o, i, r) {
            var s = Ct(e),
              a = Ct(t),
              l = s ? Os : Ln(e),
              c = a ? Os : Ln(t),
              d = (l = l == js ? Rs : l) == Rs,
              u = (c = c == js ? Rs : c) == Rs,
              h = l == c;
            if (h && Tt(e)) {
              if (!Tt(t)) return !1;
              (s = !0), (d = !1);
            }
            if (h && !d) return r || (r = new dt()), s || Vt(e) ? Is(e, t, n, o, i, r) : Ps(e, t, l, n, o, i, r);
            if (!(1 & n)) {
              var m = d && Vs.call(e, '__wrapped__'),
                g = u && Vs.call(t, '__wrapped__');
              if (m || g) {
                var p = m ? e.value() : e,
                  f = g ? t.value() : t;
                return r || (r = new dt()), i(p, f, n, o, r);
              }
            }
            return !!h && (r || (r = new dt()), Ls(e, t, n, o, i, r));
          };
          const Hs = function e(t, n, o, i, r) {
            return t === n || (null == t || null == n || (!se(t) && !se(n)) ? t != t && n != n : Fs(t, n, o, i, e, r));
          };
          const Us = function (e, t, n) {
            var o = (n = 'function' == typeof n ? n : void 0) ? n(e, t) : void 0;
            return void 0 === o ? Hs(e, t, void 0, n) : !!o;
          };
          class qs extends As {
            constructor(e) {
              super(e),
                (this._config = { childList: !0, characterData: !0, characterDataOldValue: !0, subtree: !0 }),
                (this.domConverter = e.domConverter),
                (this.renderer = e._renderer),
                (this._domElements = []),
                (this._mutationObserver = new window.MutationObserver(this._onMutations.bind(this)));
            }
            flush() {
              this._onMutations(this._mutationObserver.takeRecords());
            }
            observe(e) {
              this._domElements.push(e), this.isEnabled && this._mutationObserver.observe(e, this._config);
            }
            enable() {
              super.enable();
              for (const e of this._domElements) this._mutationObserver.observe(e, this._config);
            }
            disable() {
              super.disable(), this._mutationObserver.disconnect();
            }
            destroy() {
              super.destroy(), this._mutationObserver.disconnect();
            }
            _onMutations(e) {
              if (0 === e.length) return;
              const t = this.domConverter,
                n = new Map(),
                o = new Set();
              for (const n of e)
                if ('childList' === n.type) {
                  const e = t.mapDomToView(n.target);
                  if (e && (e.is('uiElement') || e.is('rawElement'))) continue;
                  e && !this._isBogusBrMutation(n) && o.add(e);
                }
              for (const i of e) {
                const e = t.mapDomToView(i.target);
                if ((!e || (!e.is('uiElement') && !e.is('rawElement'))) && 'characterData' === i.type) {
                  const e = t.findCorrespondingViewText(i.target);
                  e && !o.has(e.parent)
                    ? n.set(e, { type: 'text', oldText: e.data, newText: Hr(i.target), node: e })
                    : !e && Vr(i.target) && o.add(t.mapDomToView(i.target.parentNode));
                }
              }
              const i = [];
              for (const e of n.values()) this.renderer.markToSync('text', e.node), i.push(e);
              for (const e of o) {
                const n = t.mapViewToDom(e),
                  o = Array.from(e.getChildren()),
                  r = Array.from(t.domChildrenToView(n, { withChildren: !1 }));
                Us(o, r, a) ||
                  (this.renderer.markToSync('children', e), i.push({ type: 'children', oldChildren: o, newChildren: r, node: e }));
              }
              const r = e[0].target.ownerDocument.getSelection();
              let s = null;
              if (r && r.anchorNode) {
                const e = t.domPositionToView(r.anchorNode, r.anchorOffset),
                  n = t.domPositionToView(r.focusNode, r.focusOffset);
                e && n && ((s = new Wi(e)), s.setFocus(n));
              }
              function a(e, t) {
                if (!Array.isArray(e)) return e === t || (!(!e.is('$text') || !t.is('$text')) && e.data === t.data);
              }
              i.length && (this.document.fire('mutations', i, s), this.view.forceRender());
            }
            _isBogusBrMutation(e) {
              let t = null;
              return (
                null === e.nextSibling &&
                  0 === e.removedNodes.length &&
                  1 == e.addedNodes.length &&
                  (t = this.domConverter.domToView(e.addedNodes[0], { withChildren: !1 })),
                t && t.is('element', 'br')
              );
            }
          }
          const Ws = xi(function (e, t) {
            ft(t, en(t), e);
          });
          class Gs {
            constructor(e, t, n) {
              (this.view = e), (this.document = e.document), (this.domEvent = t), (this.domTarget = t.target), Ws(this, n);
            }
            get target() {
              return this.view.domConverter.mapDomToView(this.domTarget);
            }
            preventDefault() {
              this.domEvent.preventDefault();
            }
            stopPropagation() {
              this.domEvent.stopPropagation();
            }
          }
          class $s extends As {
            constructor(e) {
              super(e), (this.useCapture = !1);
            }
            observe(e) {
              ('string' == typeof this.domEventType ? [this.domEventType] : this.domEventType).forEach((t) => {
                this.listenTo(
                  e,
                  t,
                  (e, t) => {
                    this.isEnabled && !this.checkShouldIgnoreEventFromTarget(t.target) && this.onDomEvent(t);
                  },
                  { useCapture: this.useCapture }
                );
              });
            }
            fire(e, t, n) {
              this.isEnabled && this.document.fire(e, new Gs(this.view, t, n));
            }
          }
          class Ys extends $s {
            constructor(e) {
              super(e), (this.domEventType = ['keydown', 'keyup']);
            }
            onDomEvent(e) {
              const t = {
                keyCode: e.keyCode,
                altKey: e.altKey,
                ctrlKey: e.ctrlKey,
                shiftKey: e.shiftKey,
                metaKey: e.metaKey,
                get keystroke() {
                  return gr(this);
                },
              };
              this.fire(e.type, e, t);
            }
          }
          const Ks = function () {
            return $.Date.now();
          };
          var Qs = /\s/;
          const Zs = function (e) {
            for (var t = e.length; t-- && Qs.test(e.charAt(t)); );
            return t;
          };
          var Js = /^\s+/;
          const Xs = function (e) {
            return e ? e.slice(0, Zs(e) + 1).replace(Js, '') : e;
          };
          var ea = /^[-+]0x[0-9a-f]+$/i,
            ta = /^0b[01]+$/i,
            na = /^0o[0-7]+$/i,
            oa = parseInt;
          const ia = function (e) {
            if ('number' == typeof e) return e;
            if (jo(e)) return NaN;
            if (E(e)) {
              var t = 'function' == typeof e.valueOf ? e.valueOf() : e;
              e = E(t) ? t + '' : t;
            }
            if ('string' != typeof e) return 0 === e ? e : +e;
            e = Xs(e);
            var n = ta.test(e);
            return n || na.test(e) ? oa(e.slice(2), n ? 2 : 8) : ea.test(e) ? NaN : +e;
          };
          var ra = Math.max,
            sa = Math.min;
          const aa = function (e, t, n) {
            var o,
              i,
              r,
              s,
              a,
              l,
              c = 0,
              d = !1,
              u = !1,
              h = !0;
            if ('function' != typeof e) throw new TypeError('Expected a function');
            function m(t) {
              var n = o,
                r = i;
              return (o = i = void 0), (c = t), (s = e.apply(r, n));
            }
            function g(e) {
              return (c = e), (a = setTimeout(f, t)), d ? m(e) : s;
            }
            function p(e) {
              var n = e - l;
              return void 0 === l || n >= t || n < 0 || (u && e - c >= r);
            }
            function f() {
              var e = Ks();
              if (p(e)) return k(e);
              a = setTimeout(
                f,
                (function (e) {
                  var n = t - (e - l);
                  return u ? sa(n, r - (e - c)) : n;
                })(e)
              );
            }
            function k(e) {
              return (a = void 0), h && o ? m(e) : ((o = i = void 0), s);
            }
            function b() {
              var e = Ks(),
                n = p(e);
              if (((o = arguments), (i = this), (l = e), n)) {
                if (void 0 === a) return g(l);
                if (u) return clearTimeout(a), (a = setTimeout(f, t)), m(l);
              }
              return void 0 === a && (a = setTimeout(f, t)), s;
            }
            return (
              (t = ia(t) || 0),
              E(n) &&
                ((d = !!n.leading), (r = (u = 'maxWait' in n) ? ra(ia(n.maxWait) || 0, t) : r), (h = 'trailing' in n ? !!n.trailing : h)),
              (b.cancel = function () {
                void 0 !== a && clearTimeout(a), (c = 0), (o = l = i = a = void 0);
              }),
              (b.flush = function () {
                return void 0 === a ? s : k(Ks());
              }),
              b
            );
          };
          class la extends As {
            constructor(e) {
              super(e),
                (this._fireSelectionChangeDoneDebounced = aa((e) => {
                  this.document.fire('selectionChangeDone', e);
                }, 200));
            }
            observe() {
              const e = this.document;
              e.on(
                'arrowKey',
                (t, n) => {
                  e.selection.isFake && this.isEnabled && n.preventDefault();
                },
                { context: '$capture' }
              ),
                e.on(
                  'arrowKey',
                  (t, n) => {
                    e.selection.isFake && this.isEnabled && this._handleSelectionMove(n.keyCode);
                  },
                  { priority: 'lowest' }
                );
            }
            destroy() {
              super.destroy(), this._fireSelectionChangeDoneDebounced.cancel();
            }
            _handleSelectionMove(e) {
              const t = this.document.selection,
                n = new Wi(t.getRanges(), { backward: t.isBackward, fake: !1 });
              (e != hr.arrowleft && e != hr.arrowup) || n.setTo(n.getFirstPosition()),
                (e != hr.arrowright && e != hr.arrowdown) || n.setTo(n.getLastPosition());
              const o = { oldSelection: t, newSelection: n, domSelection: null };
              this.document.fire('selectionChange', o), this._fireSelectionChangeDoneDebounced(o);
            }
          }
          class ca extends As {
            constructor(e) {
              super(e),
                (this.mutationObserver = e.getObserver(qs)),
                (this.selection = this.document.selection),
                (this.domConverter = e.domConverter),
                (this._documents = new WeakSet()),
                (this._fireSelectionChangeDoneDebounced = aa((e) => {
                  this.document.fire('selectionChangeDone', e);
                }, 200)),
                (this._clearInfiniteLoopInterval = setInterval(() => this._clearInfiniteLoop(), 1e3)),
                (this._documentIsSelectingInactivityTimeoutDebounced = aa(() => (this.document.isSelecting = !1), 5e3)),
                (this._loopbackCounter = 0);
            }
            observe(e) {
              const t = e.ownerDocument,
                n = () => {
                  (this.document.isSelecting = !1), this._documentIsSelectingInactivityTimeoutDebounced.cancel();
                };
              this.listenTo(
                e,
                'selectstart',
                () => {
                  (this.document.isSelecting = !0), this._documentIsSelectingInactivityTimeoutDebounced();
                },
                { priority: 'highest' }
              ),
                this.listenTo(e, 'keydown', n, { priority: 'highest' }),
                this.listenTo(e, 'keyup', n, { priority: 'highest' }),
                this._documents.has(t) ||
                  (this.listenTo(t, 'mouseup', n, { priority: 'highest' }),
                  this.listenTo(t, 'selectionchange', (e, n) => {
                    this._handleSelectionChange(n, t), this._documentIsSelectingInactivityTimeoutDebounced();
                  }),
                  this._documents.add(t));
            }
            destroy() {
              super.destroy(),
                clearInterval(this._clearInfiniteLoopInterval),
                this._fireSelectionChangeDoneDebounced.cancel(),
                this._documentIsSelectingInactivityTimeoutDebounced.cancel();
            }
            _handleSelectionChange(e, t) {
              if (!this.isEnabled) return;
              const n = t.defaultView.getSelection();
              if (this.checkShouldIgnoreEventFromTarget(n.anchorNode)) return;
              this.mutationObserver.flush();
              const o = this.domConverter.domSelectionToView(n);
              if (0 != o.rangeCount) {
                if (
                  ((this.view.hasDomSelection = !0),
                  !((this.selection.isEqual(o) && this.domConverter.isDomSelectionCorrect(n)) || ++this._loopbackCounter > 60))
                )
                  if (this.selection.isSimilar(o)) this.view.forceRender();
                  else {
                    const e = { oldSelection: this.selection, newSelection: o, domSelection: n };
                    this.document.fire('selectionChange', e), this._fireSelectionChangeDoneDebounced(e);
                  }
              } else this.view.hasDomSelection = !1;
            }
            _clearInfiniteLoop() {
              this._loopbackCounter = 0;
            }
          }
          class da extends $s {
            constructor(e) {
              super(e), (this.domEventType = ['focus', 'blur']), (this.useCapture = !0);
              const t = this.document;
              t.on('focus', () => {
                (t.isFocused = !0), (this._renderTimeoutId = setTimeout(() => e.change(() => {}), 50));
              }),
                t.on('blur', (n, o) => {
                  const i = t.selection.editableElement;
                  (null !== i && i !== o.target) || ((t.isFocused = !1), e.change(() => {}));
                });
            }
            onDomEvent(e) {
              this.fire(e.type, e);
            }
            destroy() {
              this._renderTimeoutId && clearTimeout(this._renderTimeoutId), super.destroy();
            }
          }
          class ua extends $s {
            constructor(e) {
              super(e), (this.domEventType = ['compositionstart', 'compositionupdate', 'compositionend']);
              const t = this.document;
              t.on('compositionstart', () => {
                t.isComposing = !0;
              }),
                t.on('compositionend', () => {
                  t.isComposing = !1;
                });
            }
            onDomEvent(e) {
              this.fire(e.type, e);
            }
          }
          class ha extends $s {
            constructor(e) {
              super(e), (this.domEventType = ['beforeinput']);
            }
            onDomEvent(e) {
              this.fire(e.type, e);
            }
          }
          class ma {
            constructor() {
              this._replacedElements = [];
            }
            replace(e, t) {
              this._replacedElements.push({ element: e, newElement: t }),
                (e.style.display = 'none'),
                t && e.parentNode.insertBefore(t, e.nextSibling);
            }
            restore() {
              this._replacedElements.forEach(({ element: e, newElement: t }) => {
                (e.style.display = ''), t && t.remove();
              }),
                (this._replacedElements = []);
            }
          }
          function ga(e) {
            return '[object Range]' == Object.prototype.toString.apply(e);
          }
          function pa(e) {
            const t = e.ownerDocument.defaultView.getComputedStyle(e);
            return {
              top: parseInt(t.borderTopWidth, 10),
              right: parseInt(t.borderRightWidth, 10),
              bottom: parseInt(t.borderBottomWidth, 10),
              left: parseInt(t.borderLeftWidth, 10),
            };
          }
          const fa = ['top', 'right', 'bottom', 'left', 'width', 'height'];
          class ka {
            constructor(e) {
              const t = ga(e);
              if ((Object.defineProperty(this, '_source', { value: e._source || e, writable: !0, enumerable: !1 }), _a(e) || t))
                if (t) {
                  const t = ka.getDomRangeRects(e);
                  ba(this, ka.getBoundingRect(t));
                } else ba(this, e.getBoundingClientRect());
              else if (ks(e)) {
                const { innerWidth: t, innerHeight: n } = e;
                ba(this, { top: 0, right: t, bottom: n, left: 0, width: t, height: n });
              } else ba(this, e);
            }
            clone() {
              return new ka(this);
            }
            moveTo(e, t) {
              return (this.top = t), (this.right = e + this.width), (this.bottom = t + this.height), (this.left = e), this;
            }
            moveBy(e, t) {
              return (this.top += t), (this.right += e), (this.left += e), (this.bottom += t), this;
            }
            getIntersection(e) {
              const t = {
                top: Math.max(this.top, e.top),
                right: Math.min(this.right, e.right),
                bottom: Math.min(this.bottom, e.bottom),
                left: Math.max(this.left, e.left),
                width: 0,
                height: 0,
              };
              return (t.width = t.right - t.left), (t.height = t.bottom - t.top), t.width < 0 || t.height < 0 ? null : new ka(t);
            }
            getIntersectionArea(e) {
              const t = this.getIntersection(e);
              return t ? t.getArea() : 0;
            }
            getArea() {
              return this.width * this.height;
            }
            getVisible() {
              const e = this._source;
              let t = this.clone();
              if (!wa(e)) {
                let n = e.parentNode || e.commonAncestorContainer;
                for (; n && !wa(n); ) {
                  const e = new ka(n),
                    o = t.getIntersection(e);
                  if (!o) return null;
                  o.getArea() < t.getArea() && (t = o), (n = n.parentNode);
                }
              }
              return t;
            }
            isEqual(e) {
              for (const t of fa) if (this[t] !== e[t]) return !1;
              return !0;
            }
            contains(e) {
              const t = this.getIntersection(e);
              return !(!t || !t.isEqual(e));
            }
            excludeScrollbarsAndBorders() {
              const e = this._source;
              let t, n, o;
              if (ks(e))
                (t = e.innerWidth - e.document.documentElement.clientWidth),
                  (n = e.innerHeight - e.document.documentElement.clientHeight),
                  (o = e.getComputedStyle(e.document.documentElement).direction);
              else {
                const i = pa(e);
                (t = e.offsetWidth - e.clientWidth - i.left - i.right),
                  (n = e.offsetHeight - e.clientHeight - i.top - i.bottom),
                  (o = e.ownerDocument.defaultView.getComputedStyle(e).direction),
                  (this.left += i.left),
                  (this.top += i.top),
                  (this.right -= i.right),
                  (this.bottom -= i.bottom),
                  (this.width = this.right - this.left),
                  (this.height = this.bottom - this.top);
              }
              return (this.width -= t), 'ltr' === o ? (this.right -= t) : (this.left += t), (this.height -= n), (this.bottom -= n), this;
            }
            static getDomRangeRects(e) {
              const t = [],
                n = Array.from(e.getClientRects());
              if (n.length) for (const e of n) t.push(new ka(e));
              else {
                let n = e.startContainer;
                zr(n) && (n = n.parentNode);
                const o = new ka(n.getBoundingClientRect());
                (o.right = o.left), (o.width = 0), t.push(o);
              }
              return t;
            }
            static getBoundingRect(e) {
              const t = {
                left: Number.POSITIVE_INFINITY,
                top: Number.POSITIVE_INFINITY,
                right: Number.NEGATIVE_INFINITY,
                bottom: Number.NEGATIVE_INFINITY,
                width: 0,
                height: 0,
              };
              let n = 0;
              for (const o of e)
                n++,
                  (t.left = Math.min(t.left, o.left)),
                  (t.top = Math.min(t.top, o.top)),
                  (t.right = Math.max(t.right, o.right)),
                  (t.bottom = Math.max(t.bottom, o.bottom));
              return 0 == n ? null : ((t.width = t.right - t.left), (t.height = t.bottom - t.top), new ka(t));
            }
          }
          function ba(e, t) {
            for (const n of fa) e[n] = t[n];
          }
          function wa(e) {
            return !!_a(e) && e === e.ownerDocument.body;
          }
          function _a(e) {
            return uo(e);
          }
          class ya {
            constructor(e, t) {
              ya._observerInstance || ya._createObserver(),
                (this._element = e),
                (this._callback = t),
                ya._addElementCallback(e, t),
                ya._observerInstance.observe(e);
            }
            destroy() {
              ya._deleteElementCallback(this._element, this._callback);
            }
            static _addElementCallback(e, t) {
              ya._elementCallbacks || (ya._elementCallbacks = new Map());
              let n = ya._elementCallbacks.get(e);
              n || ((n = new Set()), ya._elementCallbacks.set(e, n)), n.add(t);
            }
            static _deleteElementCallback(e, t) {
              const n = ya._getElementCallbacks(e);
              n && (n.delete(t), n.size || (ya._elementCallbacks.delete(e), ya._observerInstance.unobserve(e))),
                ya._elementCallbacks && !ya._elementCallbacks.size && ((ya._observerInstance = null), (ya._elementCallbacks = null));
            }
            static _getElementCallbacks(e) {
              return ya._elementCallbacks ? ya._elementCallbacks.get(e) : null;
            }
            static _createObserver() {
              ya._observerInstance = new _o.window.ResizeObserver((e) => {
                for (const t of e) {
                  const e = ya._getElementCallbacks(t.target);
                  if (e) for (const n of e) n(t);
                }
              });
            }
          }
          function Aa(e) {
            return !!(e && e.getClientRects && e.getClientRects().length);
          }
          function Ca(e) {
            const t = e.next();
            return t.done ? null : t.value;
          }
          (ya._observerInstance = null), (ya._elementCallbacks = null);
          class va extends bs(N) {
            constructor() {
              super(),
                this.set('isFocused', !1),
                this.set('focusedElement', null),
                (this._elements = new Set()),
                (this._nextEventLoopTimeout = null);
            }
            add(e) {
              if (this._elements.has(e)) throw new l('focustracker-add-element-already-exist', this);
              this.listenTo(e, 'focus', () => this._focus(e), { useCapture: !0 }),
                this.listenTo(e, 'blur', () => this._blur(), { useCapture: !0 }),
                this._elements.add(e);
            }
            remove(e) {
              e === this.focusedElement && this._blur(), this._elements.has(e) && (this.stopListening(e), this._elements.delete(e));
            }
            destroy() {
              this.stopListening();
            }
            _focus(e) {
              clearTimeout(this._nextEventLoopTimeout), (this.focusedElement = e), (this.isFocused = !0);
            }
            _blur() {
              clearTimeout(this._nextEventLoopTimeout),
                (this._nextEventLoopTimeout = setTimeout(() => {
                  (this.focusedElement = null), (this.isFocused = !1);
                }, 0));
            }
          }
          class xa {
            constructor() {
              this._listener = Object.create(bs);
            }
            listenTo(e) {
              this._listener.listenTo(e, 'keydown', (e, t) => {
                this._listener.fire('_keydown:' + gr(t), t);
              });
            }
            set(e, t, n = {}) {
              const o = pr(e),
                i = n.priority;
              this._listener.listenTo(
                this._listener,
                '_keydown:' + o,
                (e, n) => {
                  t(n, () => {
                    n.preventDefault(), n.stopPropagation(), e.stop();
                  }),
                    (e.return = !0);
                },
                { priority: i }
              );
            }
            press(e) {
              return !!this._listener.fire('_keydown:' + gr(e), e);
            }
            destroy() {
              this._listener.stopListening();
            }
          }
          class Ea extends As {
            constructor(e) {
              super(e),
                this.document.on('keydown', (e, t) => {
                  if (this.isEnabled && ((n = t.keyCode) == hr.arrowright || n == hr.arrowleft || n == hr.arrowup || n == hr.arrowdown)) {
                    const n = new $i(this.document, 'arrowKey', this.document.selection.getFirstRange());
                    this.document.fire(n, t), n.stop.called && e.stop();
                  }
                  var n;
                });
            }
            observe() {}
          }
          class Da extends As {
            constructor(e) {
              super(e);
              const t = this.document;
              t.on('keydown', (e, n) => {
                if (!this.isEnabled || n.keyCode != hr.tab || n.ctrlKey) return;
                const o = new $i(t, 'tab', t.selection.getFirstRange());
                t.fire(o, n), o.stop.called && e.stop();
              });
            }
            observe() {}
          }
          function Ta(e, t, n) {
            const o = t.clone().moveBy(0, n),
              i = t.clone().moveBy(0, -n),
              r = new ka(e).excludeScrollbarsAndBorders();
            if (![i, o].every((e) => r.contains(e))) {
              let { scrollX: s, scrollY: a } = e;
              Ma(i, r) ? (a -= r.top - t.top + n) : Sa(o, r) && (a += t.bottom - r.bottom + n),
                Ba(t, r) ? (s -= r.left - t.left + n) : Na(t, r) && (s += t.right - r.right + n),
                e.scrollTo(s, a);
            }
          }
          function Ia(e, t) {
            const n = Pa(e);
            let o, i;
            for (; e != n.document.body; )
              (i = t()),
                (o = new ka(e).excludeScrollbarsAndBorders()),
                o.contains(i) ||
                  (Ma(i, o) ? (e.scrollTop -= o.top - i.top) : Sa(i, o) && (e.scrollTop += i.bottom - o.bottom),
                  Ba(i, o) ? (e.scrollLeft -= o.left - i.left) : Na(i, o) && (e.scrollLeft += i.right - o.right)),
                (e = e.parentNode);
          }
          function Sa(e, t) {
            return e.bottom > t.bottom;
          }
          function Ma(e, t) {
            return e.top < t.top;
          }
          function Ba(e, t) {
            return e.left < t.left;
          }
          function Na(e, t) {
            return e.right > t.right;
          }
          function Pa(e) {
            return ga(e) ? e.startContainer.ownerDocument.defaultView : e.ownerDocument.defaultView;
          }
          function za(e) {
            if (ga(e)) {
              let t = e.commonAncestorContainer;
              return zr(t) && (t = t.parentNode), t;
            }
            return e.parentNode;
          }
          function La(e, t) {
            const n = Pa(e),
              o = new ka(e);
            if (n === t) return o;
            {
              let e = n;
              for (; e != t; ) {
                const t = e.frameElement,
                  n = new ka(t).excludeScrollbarsAndBorders();
                o.moveBy(n.left, n.top), (e = e.parent);
              }
            }
            return o;
          }
          class ja extends N {
            constructor(e) {
              super(),
                (this.document = new er(e)),
                (this.domConverter = new ms(this.document)),
                (this.domRoots = new Map()),
                this.set('isRenderingInProgress', !1),
                this.set('hasDomSelection', !1),
                (this._renderer = new ns(this.domConverter, this.document.selection)),
                this._renderer.bind('isFocused', 'isSelecting').to(this.document, 'isFocused', 'isSelecting'),
                (this._initialDomRootAttributes = new WeakMap()),
                (this._observers = new Map()),
                (this._ongoingChange = !1),
                (this._postFixersInProgress = !1),
                (this._renderingDisabled = !1),
                (this._hasChangedSinceTheLastRendering = !1),
                (this._writer = new vr(this.document)),
                this.addObserver(qs),
                this.addObserver(ca),
                this.addObserver(da),
                this.addObserver(Ys),
                this.addObserver(la),
                this.addObserver(ua),
                this.addObserver(Ea),
                this.addObserver(Da),
                lr.isAndroid && this.addObserver(ha),
                this.document.on('arrowKey', Ur, { priority: 'low' }),
                wr(this),
                this.on('render', () => {
                  this._render(), this.document.fire('layoutChanged'), (this._hasChangedSinceTheLastRendering = !1);
                }),
                this.listenTo(this.document.selection, 'change', () => {
                  this._hasChangedSinceTheLastRendering = !0;
                }),
                this.listenTo(this.document, 'change:isFocused', () => {
                  this._hasChangedSinceTheLastRendering = !0;
                });
            }
            attachDomRoot(e, t = 'main') {
              const n = this.document.getRoot(t);
              n._name = e.tagName.toLowerCase();
              const o = {};
              for (const { name: t, value: i } of Array.from(e.attributes))
                (o[t] = i), 'class' === t ? this._writer.addClass(i.split(' '), n) : this._writer.setAttribute(t, i, n);
              this._initialDomRootAttributes.set(e, o);
              const i = () => {
                this._writer.setAttribute('contenteditable', (!n.isReadOnly).toString(), n),
                  n.isReadOnly ? this._writer.addClass('ck-read-only', n) : this._writer.removeClass('ck-read-only', n);
              };
              i(),
                this.domRoots.set(t, e),
                this.domConverter.bindElements(e, n),
                this._renderer.markToSync('children', n),
                this._renderer.markToSync('attributes', n),
                this._renderer.domDocuments.add(e.ownerDocument),
                n.on('change:children', (e, t) => this._renderer.markToSync('children', t)),
                n.on('change:attributes', (e, t) => this._renderer.markToSync('attributes', t)),
                n.on('change:text', (e, t) => this._renderer.markToSync('text', t)),
                n.on('change:isReadOnly', () => this.change(i)),
                n.on('change', () => {
                  this._hasChangedSinceTheLastRendering = !0;
                });
              for (const n of this._observers.values()) n.observe(e, t);
            }
            detachDomRoot(e) {
              const t = this.domRoots.get(e);
              Array.from(t.attributes).forEach(({ name: e }) => t.removeAttribute(e));
              const n = this._initialDomRootAttributes.get(t);
              for (const e in n) t.setAttribute(e, n[e]);
              this.domRoots.delete(e), this.domConverter.unbindDomElement(t);
            }
            getDomRoot(e = 'main') {
              return this.domRoots.get(e);
            }
            addObserver(e) {
              let t = this._observers.get(e);
              if (t) return t;
              (t = new e(this)), this._observers.set(e, t);
              for (const [e, n] of this.domRoots) t.observe(n, e);
              return t.enable(), t;
            }
            getObserver(e) {
              return this._observers.get(e);
            }
            disableObservers() {
              for (const e of this._observers.values()) e.disable();
            }
            enableObservers() {
              for (const e of this._observers.values()) e.enable();
            }
            scrollToTheSelection() {
              const e = this.document.selection.getFirstRange();
              e &&
                (function ({ target: e, viewportOffset: t = 0 }) {
                  const n = Pa(e);
                  let o = n,
                    i = null;
                  for (; o; ) {
                    let r;
                    (r = za(o == n ? e : i)), Ia(r, () => La(e, o));
                    const s = La(e, o);
                    if ((Ta(o, s, t), o.parent != o)) {
                      if (((i = o.frameElement), (o = o.parent), !i)) return;
                    } else o = null;
                  }
                })({ target: this.domConverter.viewRangeToDom(e), viewportOffset: 20 });
            }
            focus() {
              if (!this.document.isFocused) {
                const e = this.document.selection.editableElement;
                e && (this.domConverter.focus(e), this.forceRender());
              }
            }
            change(e) {
              if (this.isRenderingInProgress || this._postFixersInProgress) throw new l('cannot-change-view-tree', this);
              try {
                if (this._ongoingChange) return e(this._writer);
                this._ongoingChange = !0;
                const t = e(this._writer);
                return (
                  (this._ongoingChange = !1),
                  !this._renderingDisabled &&
                    this._hasChangedSinceTheLastRendering &&
                    ((this._postFixersInProgress = !0),
                    this.document._callPostFixers(this._writer),
                    (this._postFixersInProgress = !1),
                    this.fire('render')),
                  t
                );
              } catch (e) {
                l.rethrowUnexpectedError(e, this);
              }
            }
            forceRender() {
              (this._hasChangedSinceTheLastRendering = !0), this.change(() => {});
            }
            destroy() {
              for (const e of this._observers.values()) e.destroy();
              this.document.destroy(), this.stopListening();
            }
            createPositionAt(e, t) {
              return Fi._createAt(e, t);
            }
            createPositionAfter(e) {
              return Fi._createAfter(e);
            }
            createPositionBefore(e) {
              return Fi._createBefore(e);
            }
            createRange(...e) {
              return new Hi(...e);
            }
            createRangeOn(e) {
              return Hi._createOn(e);
            }
            createRangeIn(e) {
              return Hi._createIn(e);
            }
            createSelection(...e) {
              return new Wi(...e);
            }
            _disableRendering(e) {
              (this._renderingDisabled = e), 0 == e && this.change(() => {});
            }
            _render() {
              (this.isRenderingInProgress = !0),
                this.disableObservers(),
                this._renderer.render(),
                this.enableObservers(),
                (this.isRenderingInProgress = !1);
            }
          }
          class Oa {
            is() {
              throw new Error('is() method is abstract');
            }
          }
          class Ra extends Oa {
            constructor(e) {
              super(), (this.parent = null), (this._attrs = No(e));
            }
            get document() {
              return null;
            }
            get index() {
              let e;
              if (!this.parent) return null;
              if (null === (e = this.parent.getChildIndex(this))) throw new l('model-node-not-found-in-parent', this);
              return e;
            }
            get startOffset() {
              let e;
              if (!this.parent) return null;
              if (null === (e = this.parent.getChildStartOffset(this))) throw new l('model-node-not-found-in-parent', this);
              return e;
            }
            get offsetSize() {
              return 1;
            }
            get endOffset() {
              return this.parent ? this.startOffset + this.offsetSize : null;
            }
            get nextSibling() {
              const e = this.index;
              return (null !== e && this.parent.getChild(e + 1)) || null;
            }
            get previousSibling() {
              const e = this.index;
              return (null !== e && this.parent.getChild(e - 1)) || null;
            }
            get root() {
              let e = this;
              for (; e.parent; ) e = e.parent;
              return e;
            }
            isAttached() {
              return this.root.is('rootElement');
            }
            getPath() {
              const e = [];
              let t = this;
              for (; t.parent; ) e.unshift(t.startOffset), (t = t.parent);
              return e;
            }
            getAncestors(e = {}) {
              const t = [];
              let n = e.includeSelf ? this : this.parent;
              for (; n; ) t[e.parentFirst ? 'push' : 'unshift'](n), (n = n.parent);
              return t;
            }
            getCommonAncestor(e, t = {}) {
              const n = this.getAncestors(t),
                o = e.getAncestors(t);
              let i = 0;
              for (; n[i] == o[i] && n[i]; ) i++;
              return 0 === i ? null : n[i - 1];
            }
            isBefore(e) {
              if (this == e) return !1;
              if (this.root !== e.root) return !1;
              const t = this.getPath(),
                n = e.getPath(),
                o = To(t, n);
              switch (o) {
                case 'prefix':
                  return !0;
                case 'extension':
                  return !1;
                default:
                  return t[o] < n[o];
              }
            }
            isAfter(e) {
              return this != e && this.root === e.root && !this.isBefore(e);
            }
            hasAttribute(e) {
              return this._attrs.has(e);
            }
            getAttribute(e) {
              return this._attrs.get(e);
            }
            getAttributes() {
              return this._attrs.entries();
            }
            getAttributeKeys() {
              return this._attrs.keys();
            }
            toJSON() {
              const e = {};
              return this._attrs.size && (e.attributes = Array.from(this._attrs).reduce((e, t) => ((e[t[0]] = t[1]), e), {})), e;
            }
            _clone(e) {
              return new Ra(this._attrs);
            }
            _remove() {
              this.parent._removeChildren(this.index);
            }
            _setAttribute(e, t) {
              this._attrs.set(e, t);
            }
            _setAttributesTo(e) {
              this._attrs = No(e);
            }
            _removeAttribute(e) {
              return this._attrs.delete(e);
            }
            _clearAttributes() {
              this._attrs.clear();
            }
          }
          Ra.prototype.is = function (e) {
            return 'node' === e || 'model:node' === e;
          };
          class Va {
            constructor(e) {
              (this._nodes = []), e && this._insertNodes(0, e);
            }
            [Symbol.iterator]() {
              return this._nodes[Symbol.iterator]();
            }
            get length() {
              return this._nodes.length;
            }
            get maxOffset() {
              return this._nodes.reduce((e, t) => e + t.offsetSize, 0);
            }
            getNode(e) {
              return this._nodes[e] || null;
            }
            getNodeIndex(e) {
              const t = this._nodes.indexOf(e);
              return -1 == t ? null : t;
            }
            getNodeStartOffset(e) {
              const t = this.getNodeIndex(e);
              return null === t ? null : this._nodes.slice(0, t).reduce((e, t) => e + t.offsetSize, 0);
            }
            indexToOffset(e) {
              if (e == this._nodes.length) return this.maxOffset;
              const t = this._nodes[e];
              if (!t) throw new l('model-nodelist-index-out-of-bounds', this);
              return this.getNodeStartOffset(t);
            }
            offsetToIndex(e) {
              let t = 0;
              for (const n of this._nodes) {
                if (e >= t && e < t + n.offsetSize) return this.getNodeIndex(n);
                t += n.offsetSize;
              }
              if (t != e) throw new l('model-nodelist-offset-out-of-bounds', this, { offset: e, nodeList: this });
              return this.length;
            }
            _insertNodes(e, t) {
              for (const e of t) if (!(e instanceof Ra)) throw new l('model-nodelist-insertnodes-not-node', this);
              this._nodes.splice(e, 0, ...t);
            }
            _removeNodes(e, t = 1) {
              return this._nodes.splice(e, t);
            }
            toJSON() {
              return this._nodes.map((e) => e.toJSON());
            }
          }
          class Fa extends Ra {
            constructor(e, t) {
              super(t), (this._data = e || '');
            }
            get offsetSize() {
              return this.data.length;
            }
            get data() {
              return this._data;
            }
            toJSON() {
              const e = super.toJSON();
              return (e.data = this.data), e;
            }
            _clone() {
              return new Fa(this.data, this.getAttributes());
            }
            static fromJSON(e) {
              return new Fa(e.data, e.attributes);
            }
          }
          Fa.prototype.is = function (e) {
            return '$text' === e || 'model:$text' === e || 'text' === e || 'model:text' === e || 'node' === e || 'model:node' === e;
          };
          class Ha extends Oa {
            constructor(e, t, n) {
              if ((super(), (this.textNode = e), t < 0 || t > e.offsetSize)) throw new l('model-textproxy-wrong-offsetintext', this);
              if (n < 0 || t + n > e.offsetSize) throw new l('model-textproxy-wrong-length', this);
              (this.data = e.data.substring(t, t + n)), (this.offsetInText = t);
            }
            get startOffset() {
              return null !== this.textNode.startOffset ? this.textNode.startOffset + this.offsetInText : null;
            }
            get offsetSize() {
              return this.data.length;
            }
            get endOffset() {
              return null !== this.startOffset ? this.startOffset + this.offsetSize : null;
            }
            get isPartial() {
              return this.offsetSize !== this.textNode.offsetSize;
            }
            get parent() {
              return this.textNode.parent;
            }
            get root() {
              return this.textNode.root;
            }
            getPath() {
              const e = this.textNode.getPath();
              return e.length > 0 && (e[e.length - 1] += this.offsetInText), e;
            }
            getAncestors(e = {}) {
              const t = [];
              let n = e.includeSelf ? this : this.parent;
              for (; n; ) t[e.parentFirst ? 'push' : 'unshift'](n), (n = n.parent);
              return t;
            }
            hasAttribute(e) {
              return this.textNode.hasAttribute(e);
            }
            getAttribute(e) {
              return this.textNode.getAttribute(e);
            }
            getAttributes() {
              return this.textNode.getAttributes();
            }
            getAttributeKeys() {
              return this.textNode.getAttributeKeys();
            }
          }
          Ha.prototype.is = function (e) {
            return '$textProxy' === e || 'model:$textProxy' === e || 'textProxy' === e || 'model:textProxy' === e;
          };
          class Ua extends Ra {
            constructor(e, t, n) {
              super(t), (this.name = e), (this._children = new Va()), n && this._insertChild(0, n);
            }
            get childCount() {
              return this._children.length;
            }
            get maxOffset() {
              return this._children.maxOffset;
            }
            get isEmpty() {
              return 0 === this.childCount;
            }
            getChild(e) {
              return this._children.getNode(e);
            }
            getChildren() {
              return this._children[Symbol.iterator]();
            }
            getChildIndex(e) {
              return this._children.getNodeIndex(e);
            }
            getChildStartOffset(e) {
              return this._children.getNodeStartOffset(e);
            }
            offsetToIndex(e) {
              return this._children.offsetToIndex(e);
            }
            getNodeByPath(e) {
              let t = this;
              for (const n of e) t = t.getChild(t.offsetToIndex(n));
              return t;
            }
            findAncestor(e, t = {}) {
              let n = t.includeSelf ? this : this.parent;
              for (; n; ) {
                if (n.name === e) return n;
                n = n.parent;
              }
              return null;
            }
            toJSON() {
              const e = super.toJSON();
              if (((e.name = this.name), this._children.length > 0)) {
                e.children = [];
                for (const t of this._children) e.children.push(t.toJSON());
              }
              return e;
            }
            _clone(e = !1) {
              const t = e ? Array.from(this._children).map((e) => e._clone(!0)) : void 0;
              return new Ua(this.name, this.getAttributes(), t);
            }
            _appendChild(e) {
              this._insertChild(this.childCount, e);
            }
            _insertChild(e, t) {
              const n = (function (e) {
                if ('string' == typeof e) return [new Fa(e)];
                po(e) || (e = [e]);
                return Array.from(e).map((e) =>
                  'string' == typeof e ? new Fa(e) : e instanceof Ha ? new Fa(e.data, e.getAttributes()) : e
                );
              })(t);
              for (const e of n) null !== e.parent && e._remove(), (e.parent = this);
              this._children._insertNodes(e, n);
            }
            _removeChildren(e, t = 1) {
              const n = this._children._removeNodes(e, t);
              for (const e of n) e.parent = null;
              return n;
            }
            static fromJSON(e) {
              let t;
              if (e.children) {
                t = [];
                for (const n of e.children) n.name ? t.push(Ua.fromJSON(n)) : t.push(Fa.fromJSON(n));
              }
              return new Ua(e.name, e.attributes, t);
            }
          }
          Ua.prototype.is = function (e, t) {
            return t
              ? t === this.name && ('element' === e || 'model:element' === e)
              : 'element' === e || 'model:element' === e || 'node' === e || 'model:node' === e;
          };
          class qa {
            constructor(e = {}) {
              if (!e.boundaries && !e.startPosition) throw new l('model-tree-walker-no-start-position', null);
              const t = e.direction || 'forward';
              if ('forward' != t && 'backward' != t) throw new l('model-tree-walker-unknown-direction', e, { direction: t });
              (this.direction = t),
                (this.boundaries = e.boundaries || null),
                e.startPosition
                  ? (this.position = e.startPosition.clone())
                  : (this.position = Ga._createAt(this.boundaries['backward' == this.direction ? 'end' : 'start'])),
                (this.position.stickiness = 'toNone'),
                (this.singleCharacters = !!e.singleCharacters),
                (this.shallow = !!e.shallow),
                (this.ignoreElementEnd = !!e.ignoreElementEnd),
                (this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null),
                (this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null),
                (this._visitedParent = this.position.parent);
            }
            [Symbol.iterator]() {
              return this;
            }
            skip(e) {
              let t, n, o, i;
              do {
                (o = this.position), (i = this._visitedParent), ({ done: t, value: n } = this.next());
              } while (!t && e(n));
              t || ((this.position = o), (this._visitedParent = i));
            }
            next() {
              return 'forward' == this.direction ? this._next() : this._previous();
            }
            _next() {
              const e = this.position,
                t = this.position.clone(),
                n = this._visitedParent;
              if (null === n.parent && t.offset === n.maxOffset) return { done: !0, value: void 0 };
              if (n === this._boundaryEndParent && t.offset == this.boundaries.end.offset) return { done: !0, value: void 0 };
              const o = $a(t, n),
                i = o || Ya(t, n, o);
              if (i instanceof Ua)
                return (
                  this.shallow ? t.offset++ : (t.path.push(0), (this._visitedParent = i)),
                  (this.position = t),
                  Wa('elementStart', i, e, t, 1)
                );
              if (i instanceof Fa) {
                let o;
                if (this.singleCharacters) o = 1;
                else {
                  let e = i.endOffset;
                  this._boundaryEndParent == n && this.boundaries.end.offset < e && (e = this.boundaries.end.offset), (o = e - t.offset);
                }
                const r = t.offset - i.startOffset,
                  s = new Ha(i, r, o);
                return (t.offset += o), (this.position = t), Wa('text', s, e, t, o);
              }
              return (
                t.path.pop(),
                t.offset++,
                (this.position = t),
                (this._visitedParent = n.parent),
                this.ignoreElementEnd ? this._next() : Wa('elementEnd', n, e, t)
              );
            }
            _previous() {
              const e = this.position,
                t = this.position.clone(),
                n = this._visitedParent;
              if (null === n.parent && 0 === t.offset) return { done: !0, value: void 0 };
              if (n == this._boundaryStartParent && t.offset == this.boundaries.start.offset) return { done: !0, value: void 0 };
              const o = t.parent,
                i = $a(t, o),
                r = i || Ka(t, o, i);
              if (r instanceof Ua)
                return (
                  t.offset--,
                  this.shallow
                    ? ((this.position = t), Wa('elementStart', r, e, t, 1))
                    : (t.path.push(r.maxOffset),
                      (this.position = t),
                      (this._visitedParent = r),
                      this.ignoreElementEnd ? this._previous() : Wa('elementEnd', r, e, t))
                );
              if (r instanceof Fa) {
                let o;
                if (this.singleCharacters) o = 1;
                else {
                  let e = r.startOffset;
                  this._boundaryStartParent == n && this.boundaries.start.offset > e && (e = this.boundaries.start.offset),
                    (o = t.offset - e);
                }
                const i = t.offset - r.startOffset,
                  s = new Ha(r, i - o, o);
                return (t.offset -= o), (this.position = t), Wa('text', s, e, t, o);
              }
              return t.path.pop(), (this.position = t), (this._visitedParent = n.parent), Wa('elementStart', n, e, t, 1);
            }
          }
          function Wa(e, t, n, o, i) {
            return { done: !1, value: { type: e, item: t, previousPosition: n, nextPosition: o, length: i } };
          }
          class Ga extends Oa {
            constructor(e, t, n = 'toNone') {
              if ((super(), !e.is('element') && !e.is('documentFragment'))) throw new l('model-position-root-invalid', e);
              if (!(t instanceof Array) || 0 === t.length) throw new l('model-position-path-incorrect-format', e, { path: t });
              e.is('rootElement') ? (t = t.slice()) : ((t = [...e.getPath(), ...t]), (e = e.root)),
                (this.root = e),
                (this.path = t),
                (this.stickiness = n);
            }
            get offset() {
              return this.path[this.path.length - 1];
            }
            set offset(e) {
              this.path[this.path.length - 1] = e;
            }
            get parent() {
              let e = this.root;
              for (let t = 0; t < this.path.length - 1; t++)
                if (((e = e.getChild(e.offsetToIndex(this.path[t]))), !e))
                  throw new l('model-position-path-incorrect', this, { position: this });
              if (e.is('$text')) throw new l('model-position-path-incorrect', this, { position: this });
              return e;
            }
            get index() {
              return this.parent.offsetToIndex(this.offset);
            }
            get textNode() {
              return $a(this, this.parent);
            }
            get nodeAfter() {
              const e = this.parent;
              return Ya(this, e, $a(this, e));
            }
            get nodeBefore() {
              const e = this.parent;
              return Ka(this, e, $a(this, e));
            }
            get isAtStart() {
              return 0 === this.offset;
            }
            get isAtEnd() {
              return this.offset == this.parent.maxOffset;
            }
            compareWith(e) {
              if (this.root != e.root) return 'different';
              const t = To(this.path, e.path);
              switch (t) {
                case 'same':
                  return 'same';
                case 'prefix':
                  return 'before';
                case 'extension':
                  return 'after';
                default:
                  return this.path[t] < e.path[t] ? 'before' : 'after';
              }
            }
            getLastMatchingPosition(e, t = {}) {
              t.startPosition = this;
              const n = new qa(t);
              return n.skip(e), n.position;
            }
            getParentPath() {
              return this.path.slice(0, -1);
            }
            getAncestors() {
              const e = this.parent;
              return e.is('documentFragment') ? [e] : e.getAncestors({ includeSelf: !0 });
            }
            findAncestor(e) {
              const t = this.parent;
              return t.is('element') ? t.findAncestor(e, { includeSelf: !0 }) : null;
            }
            getCommonPath(e) {
              if (this.root != e.root) return [];
              const t = To(this.path, e.path),
                n = 'string' == typeof t ? Math.min(this.path.length, e.path.length) : t;
              return this.path.slice(0, n);
            }
            getCommonAncestor(e) {
              const t = this.getAncestors(),
                n = e.getAncestors();
              let o = 0;
              for (; t[o] == n[o] && t[o]; ) o++;
              return 0 === o ? null : t[o - 1];
            }
            getShiftedBy(e) {
              const t = this.clone(),
                n = t.offset + e;
              return (t.offset = n < 0 ? 0 : n), t;
            }
            isAfter(e) {
              return 'after' == this.compareWith(e);
            }
            isBefore(e) {
              return 'before' == this.compareWith(e);
            }
            isEqual(e) {
              return 'same' == this.compareWith(e);
            }
            isTouching(e) {
              let t = null,
                n = null;
              switch (this.compareWith(e)) {
                case 'same':
                  return !0;
                case 'before':
                  (t = Ga._createAt(this)), (n = Ga._createAt(e));
                  break;
                case 'after':
                  (t = Ga._createAt(e)), (n = Ga._createAt(this));
                  break;
                default:
                  return !1;
              }
              let o = t.parent;
              for (; t.path.length + n.path.length; ) {
                if (t.isEqual(n)) return !0;
                if (t.path.length > n.path.length) {
                  if (t.offset !== o.maxOffset) return !1;
                  (t.path = t.path.slice(0, -1)), (o = o.parent), t.offset++;
                } else {
                  if (0 !== n.offset) return !1;
                  n.path = n.path.slice(0, -1);
                }
              }
              throw new Error('unreachable code');
            }
            hasSameParentAs(e) {
              if (this.root !== e.root) return !1;
              return 'same' == To(this.getParentPath(), e.getParentPath());
            }
            getTransformedByOperation(e) {
              let t;
              switch (e.type) {
                case 'insert':
                  t = this._getTransformedByInsertOperation(e);
                  break;
                case 'move':
                case 'remove':
                case 'reinsert':
                  t = this._getTransformedByMoveOperation(e);
                  break;
                case 'split':
                  t = this._getTransformedBySplitOperation(e);
                  break;
                case 'merge':
                  t = this._getTransformedByMergeOperation(e);
                  break;
                default:
                  t = Ga._createAt(this);
              }
              return t;
            }
            _getTransformedByInsertOperation(e) {
              return this._getTransformedByInsertion(e.position, e.howMany);
            }
            _getTransformedByMoveOperation(e) {
              return this._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
            }
            _getTransformedBySplitOperation(e) {
              const t = e.movedRange;
              return t.containsPosition(this) || (t.start.isEqual(this) && 'toNext' == this.stickiness)
                ? this._getCombined(e.splitPosition, e.moveTargetPosition)
                : e.graveyardPosition
                ? this._getTransformedByMove(e.graveyardPosition, e.insertionPosition, 1)
                : this._getTransformedByInsertion(e.insertionPosition, 1);
            }
            _getTransformedByMergeOperation(e) {
              const t = e.movedRange;
              let n;
              return (
                t.containsPosition(this) || t.start.isEqual(this)
                  ? ((n = this._getCombined(e.sourcePosition, e.targetPosition)),
                    e.sourcePosition.isBefore(e.targetPosition) && (n = n._getTransformedByDeletion(e.deletionPosition, 1)))
                  : (n = this.isEqual(e.deletionPosition)
                      ? Ga._createAt(e.deletionPosition)
                      : this._getTransformedByMove(e.deletionPosition, e.graveyardPosition, 1)),
                n
              );
            }
            _getTransformedByDeletion(e, t) {
              const n = Ga._createAt(this);
              if (this.root != e.root) return n;
              if ('same' == To(e.getParentPath(), this.getParentPath())) {
                if (e.offset < this.offset) {
                  if (e.offset + t > this.offset) return null;
                  n.offset -= t;
                }
              } else if ('prefix' == To(e.getParentPath(), this.getParentPath())) {
                const o = e.path.length - 1;
                if (e.offset <= this.path[o]) {
                  if (e.offset + t > this.path[o]) return null;
                  n.path[o] -= t;
                }
              }
              return n;
            }
            _getTransformedByInsertion(e, t) {
              const n = Ga._createAt(this);
              if (this.root != e.root) return n;
              if ('same' == To(e.getParentPath(), this.getParentPath()))
                (e.offset < this.offset || (e.offset == this.offset && 'toPrevious' != this.stickiness)) && (n.offset += t);
              else if ('prefix' == To(e.getParentPath(), this.getParentPath())) {
                const o = e.path.length - 1;
                e.offset <= this.path[o] && (n.path[o] += t);
              }
              return n;
            }
            _getTransformedByMove(e, t, n) {
              if (((t = t._getTransformedByDeletion(e, n)), e.isEqual(t))) return Ga._createAt(this);
              const o = this._getTransformedByDeletion(e, n);
              return null === o ||
                (e.isEqual(this) && 'toNext' == this.stickiness) ||
                (e.getShiftedBy(n).isEqual(this) && 'toPrevious' == this.stickiness)
                ? this._getCombined(e, t)
                : o._getTransformedByInsertion(t, n);
            }
            _getCombined(e, t) {
              const n = e.path.length - 1,
                o = Ga._createAt(t);
              return (
                (o.stickiness = this.stickiness),
                (o.offset = o.offset + this.path[n] - e.offset),
                (o.path = [...o.path, ...this.path.slice(n + 1)]),
                o
              );
            }
            toJSON() {
              return { root: this.root.toJSON(), path: Array.from(this.path), stickiness: this.stickiness };
            }
            clone() {
              return new this.constructor(this.root, this.path, this.stickiness);
            }
            static _createAt(e, t, n = 'toNone') {
              if (e instanceof Ga) return new Ga(e.root, e.path, e.stickiness);
              {
                const o = e;
                if ('end' == t) t = o.maxOffset;
                else {
                  if ('before' == t) return this._createBefore(o, n);
                  if ('after' == t) return this._createAfter(o, n);
                  if (0 !== t && !t) throw new l('model-createpositionat-offset-required', [this, e]);
                }
                if (!o.is('element') && !o.is('documentFragment')) throw new l('model-position-parent-incorrect', [this, e]);
                const i = o.getPath();
                return i.push(t), new this(o.root, i, n);
              }
            }
            static _createAfter(e, t) {
              if (!e.parent) throw new l('model-position-after-root', [this, e], { root: e });
              return this._createAt(e.parent, e.endOffset, t);
            }
            static _createBefore(e, t) {
              if (!e.parent) throw new l('model-position-before-root', e, { root: e });
              return this._createAt(e.parent, e.startOffset, t);
            }
            static fromJSON(e, t) {
              if ('$graveyard' === e.root) {
                const n = new Ga(t.graveyard, e.path);
                return (n.stickiness = e.stickiness), n;
              }
              if (!t.getRoot(e.root)) throw new l('model-position-fromjson-no-root', t, { rootName: e.root });
              return new Ga(t.getRoot(e.root), e.path, e.stickiness);
            }
          }
          function $a(e, t) {
            const n = t.getChild(t.offsetToIndex(e.offset));
            return n && n.is('$text') && n.startOffset < e.offset ? n : null;
          }
          function Ya(e, t, n) {
            return null !== n ? null : t.getChild(t.offsetToIndex(e.offset));
          }
          function Ka(e, t, n) {
            return null !== n ? null : t.getChild(t.offsetToIndex(e.offset) - 1);
          }
          Ga.prototype.is = function (e) {
            return 'position' === e || 'model:position' === e;
          };
          class Qa extends Oa {
            constructor(e, t) {
              super(),
                (this.start = Ga._createAt(e)),
                (this.end = t ? Ga._createAt(t) : Ga._createAt(e)),
                (this.start.stickiness = this.isCollapsed ? 'toNone' : 'toNext'),
                (this.end.stickiness = this.isCollapsed ? 'toNone' : 'toPrevious');
            }
            *[Symbol.iterator]() {
              yield* new qa({ boundaries: this, ignoreElementEnd: !0 });
            }
            get isCollapsed() {
              return this.start.isEqual(this.end);
            }
            get isFlat() {
              return 'same' == To(this.start.getParentPath(), this.end.getParentPath());
            }
            get root() {
              return this.start.root;
            }
            containsPosition(e) {
              return e.isAfter(this.start) && e.isBefore(this.end);
            }
            containsRange(e, t = !1) {
              e.isCollapsed && (t = !1);
              const n = this.containsPosition(e.start) || (t && this.start.isEqual(e.start)),
                o = this.containsPosition(e.end) || (t && this.end.isEqual(e.end));
              return n && o;
            }
            containsItem(e) {
              const t = Ga._createBefore(e);
              return this.containsPosition(t) || this.start.isEqual(t);
            }
            isEqual(e) {
              return this.start.isEqual(e.start) && this.end.isEqual(e.end);
            }
            isIntersecting(e) {
              return this.start.isBefore(e.end) && this.end.isAfter(e.start);
            }
            getDifference(e) {
              const t = [];
              return (
                this.isIntersecting(e)
                  ? (this.containsPosition(e.start) && t.push(new Qa(this.start, e.start)),
                    this.containsPosition(e.end) && t.push(new Qa(e.end, this.end)))
                  : t.push(new Qa(this.start, this.end)),
                t
              );
            }
            getIntersection(e) {
              if (this.isIntersecting(e)) {
                let t = this.start,
                  n = this.end;
                return this.containsPosition(e.start) && (t = e.start), this.containsPosition(e.end) && (n = e.end), new Qa(t, n);
              }
              return null;
            }
            getJoined(e, t = !1) {
              let n = this.isIntersecting(e);
              if (
                (n ||
                  (n = this.start.isBefore(e.start)
                    ? t
                      ? this.end.isTouching(e.start)
                      : this.end.isEqual(e.start)
                    : t
                    ? e.end.isTouching(this.start)
                    : e.end.isEqual(this.start)),
                !n)
              )
                return null;
              let o = this.start,
                i = this.end;
              return e.start.isBefore(o) && (o = e.start), e.end.isAfter(i) && (i = e.end), new Qa(o, i);
            }
            getMinimalFlatRanges() {
              const e = [],
                t = this.start.getCommonPath(this.end).length,
                n = Ga._createAt(this.start);
              let o = n.parent;
              for (; n.path.length > t + 1; ) {
                const t = o.maxOffset - n.offset;
                0 !== t && e.push(new Qa(n, n.getShiftedBy(t))), (n.path = n.path.slice(0, -1)), n.offset++, (o = o.parent);
              }
              for (; n.path.length <= this.end.path.length; ) {
                const t = this.end.path[n.path.length - 1],
                  o = t - n.offset;
                0 !== o && e.push(new Qa(n, n.getShiftedBy(o))), (n.offset = t), n.path.push(0);
              }
              return e;
            }
            getWalker(e = {}) {
              return (e.boundaries = this), new qa(e);
            }
            *getItems(e = {}) {
              (e.boundaries = this), (e.ignoreElementEnd = !0);
              const t = new qa(e);
              for (const e of t) yield e.item;
            }
            *getPositions(e = {}) {
              e.boundaries = this;
              const t = new qa(e);
              yield t.position;
              for (const e of t) yield e.nextPosition;
            }
            getTransformedByOperation(e) {
              switch (e.type) {
                case 'insert':
                  return this._getTransformedByInsertOperation(e);
                case 'move':
                case 'remove':
                case 'reinsert':
                  return this._getTransformedByMoveOperation(e);
                case 'split':
                  return [this._getTransformedBySplitOperation(e)];
                case 'merge':
                  return [this._getTransformedByMergeOperation(e)];
              }
              return [new Qa(this.start, this.end)];
            }
            getTransformedByOperations(e) {
              const t = [new Qa(this.start, this.end)];
              for (const n of e)
                for (let e = 0; e < t.length; e++) {
                  const o = t[e].getTransformedByOperation(n);
                  t.splice(e, 1, ...o), (e += o.length - 1);
                }
              for (let e = 0; e < t.length; e++) {
                const n = t[e];
                for (let o = e + 1; o < t.length; o++) {
                  const e = t[o];
                  (n.containsRange(e) || e.containsRange(n) || n.isEqual(e)) && t.splice(o, 1);
                }
              }
              return t;
            }
            getCommonAncestor() {
              return this.start.getCommonAncestor(this.end);
            }
            getContainedElement() {
              if (this.isCollapsed) return null;
              const e = this.start.nodeAfter,
                t = this.end.nodeBefore;
              return e && e.is('element') && e === t ? e : null;
            }
            toJSON() {
              return { start: this.start.toJSON(), end: this.end.toJSON() };
            }
            clone() {
              return new this.constructor(this.start, this.end);
            }
            _getTransformedByInsertOperation(e, t = !1) {
              return this._getTransformedByInsertion(e.position, e.howMany, t);
            }
            _getTransformedByMoveOperation(e, t = !1) {
              const n = e.sourcePosition,
                o = e.howMany,
                i = e.targetPosition;
              return this._getTransformedByMove(n, i, o, t);
            }
            _getTransformedBySplitOperation(e) {
              const t = this.start._getTransformedBySplitOperation(e);
              let n = this.end._getTransformedBySplitOperation(e);
              return (
                this.end.isEqual(e.insertionPosition) && (n = this.end.getShiftedBy(1)),
                t.root != n.root && (n = this.end.getShiftedBy(-1)),
                new Qa(t, n)
              );
            }
            _getTransformedByMergeOperation(e) {
              if (this.start.isEqual(e.targetPosition) && this.end.isEqual(e.deletionPosition)) return new Qa(this.start);
              let t = this.start._getTransformedByMergeOperation(e),
                n = this.end._getTransformedByMergeOperation(e);
              return (
                t.root != n.root && (n = this.end.getShiftedBy(-1)),
                t.isAfter(n)
                  ? (e.sourcePosition.isBefore(e.targetPosition)
                      ? ((t = Ga._createAt(n)), (t.offset = 0))
                      : (e.deletionPosition.isEqual(t) || (n = e.deletionPosition), (t = e.targetPosition)),
                    new Qa(t, n))
                  : new Qa(t, n)
              );
            }
            _getTransformedByInsertion(e, t, n = !1) {
              if (n && this.containsPosition(e))
                return [new Qa(this.start, e), new Qa(e.getShiftedBy(t), this.end._getTransformedByInsertion(e, t))];
              {
                const n = new Qa(this.start, this.end);
                return (n.start = n.start._getTransformedByInsertion(e, t)), (n.end = n.end._getTransformedByInsertion(e, t)), [n];
              }
            }
            _getTransformedByMove(e, t, n, o = !1) {
              if (this.isCollapsed) {
                const o = this.start._getTransformedByMove(e, t, n);
                return [new Qa(o)];
              }
              const i = Qa._createFromPositionAndShift(e, n),
                r = t._getTransformedByDeletion(e, n);
              if (this.containsPosition(t) && !o && (i.containsPosition(this.start) || i.containsPosition(this.end))) {
                const o = this.start._getTransformedByMove(e, t, n),
                  i = this.end._getTransformedByMove(e, t, n);
                return [new Qa(o, i)];
              }
              let s;
              const a = this.getDifference(i);
              let l = null;
              const c = this.getIntersection(i);
              if (
                (1 == a.length
                  ? (l = new Qa(a[0].start._getTransformedByDeletion(e, n), a[0].end._getTransformedByDeletion(e, n)))
                  : 2 == a.length && (l = new Qa(this.start, this.end._getTransformedByDeletion(e, n))),
                (s = l ? l._getTransformedByInsertion(r, n, null !== c || o) : []),
                c)
              ) {
                const e = new Qa(c.start._getCombined(i.start, r), c.end._getCombined(i.start, r));
                2 == s.length ? s.splice(1, 0, e) : s.push(e);
              }
              return s;
            }
            _getTransformedByDeletion(e, t) {
              let n = this.start._getTransformedByDeletion(e, t),
                o = this.end._getTransformedByDeletion(e, t);
              return null == n && null == o ? null : (null == n && (n = e), null == o && (o = e), new Qa(n, o));
            }
            static _createFromPositionAndShift(e, t) {
              const n = e,
                o = e.getShiftedBy(t);
              return t > 0 ? new this(n, o) : new this(o, n);
            }
            static _createIn(e) {
              return new this(Ga._createAt(e, 0), Ga._createAt(e, e.maxOffset));
            }
            static _createOn(e) {
              return this._createFromPositionAndShift(Ga._createBefore(e), e.offsetSize);
            }
            static _createFromRanges(e) {
              if (0 === e.length) throw new l('range-create-from-ranges-empty-array', null);
              if (1 == e.length) return e[0].clone();
              const t = e[0];
              e.sort((e, t) => (e.start.isAfter(t.start) ? 1 : -1));
              const n = e.indexOf(t),
                o = new this(t.start, t.end);
              if (n > 0) for (let t = n - 1; e[t].end.isEqual(o.start); t++) o.start = Ga._createAt(e[t].start);
              for (let t = n + 1; t < e.length && e[t].start.isEqual(o.end); t++) o.end = Ga._createAt(e[t].end);
              return o;
            }
            static fromJSON(e, t) {
              return new this(Ga.fromJSON(e.start, t), Ga.fromJSON(e.end, t));
            }
          }
          Qa.prototype.is = function (e) {
            return 'range' === e || 'model:range' === e;
          };
          class Za extends b {
            constructor() {
              super(),
                (this._modelToViewMapping = new WeakMap()),
                (this._viewToModelMapping = new WeakMap()),
                (this._viewToModelLengthCallbacks = new Map()),
                (this._markerNameToElements = new Map()),
                (this._elementToMarkerNames = new Map()),
                (this._deferredBindingRemovals = new Map()),
                (this._unboundMarkerNames = new Set()),
                this.on(
                  'modelToViewPosition',
                  (e, t) => {
                    if (t.viewPosition) return;
                    const n = this._modelToViewMapping.get(t.modelPosition.parent);
                    if (!n) throw new l('mapping-model-position-view-parent-not-found', this, { modelPosition: t.modelPosition });
                    t.viewPosition = this.findPositionIn(n, t.modelPosition.offset);
                  },
                  { priority: 'low' }
                ),
                this.on(
                  'viewToModelPosition',
                  (e, t) => {
                    if (t.modelPosition) return;
                    const n = this.findMappedViewAncestor(t.viewPosition),
                      o = this._viewToModelMapping.get(n),
                      i = this._toModelOffset(t.viewPosition.parent, t.viewPosition.offset, n);
                    t.modelPosition = Ga._createAt(o, i);
                  },
                  { priority: 'low' }
                );
            }
            bindElements(e, t) {
              this._modelToViewMapping.set(e, t), this._viewToModelMapping.set(t, e);
            }
            unbindViewElement(e, t = {}) {
              const n = this.toModelElement(e);
              if (this._elementToMarkerNames.has(e)) for (const t of this._elementToMarkerNames.get(e)) this._unboundMarkerNames.add(t);
              t.defer
                ? this._deferredBindingRemovals.set(e, e.root)
                : (this._viewToModelMapping.delete(e), this._modelToViewMapping.get(n) == e && this._modelToViewMapping.delete(n));
            }
            unbindModelElement(e) {
              const t = this.toViewElement(e);
              this._modelToViewMapping.delete(e), this._viewToModelMapping.get(t) == e && this._viewToModelMapping.delete(t);
            }
            bindElementToMarker(e, t) {
              const n = this._markerNameToElements.get(t) || new Set();
              n.add(e);
              const o = this._elementToMarkerNames.get(e) || new Set();
              o.add(t), this._markerNameToElements.set(t, n), this._elementToMarkerNames.set(e, o);
            }
            unbindElementFromMarkerName(e, t) {
              const n = this._markerNameToElements.get(t);
              n && (n.delete(e), 0 == n.size && this._markerNameToElements.delete(t));
              const o = this._elementToMarkerNames.get(e);
              o && (o.delete(t), 0 == o.size && this._elementToMarkerNames.delete(e));
            }
            flushUnboundMarkerNames() {
              const e = Array.from(this._unboundMarkerNames);
              return this._unboundMarkerNames.clear(), e;
            }
            flushDeferredBindings() {
              for (const [e, t] of this._deferredBindingRemovals) e.root == t && this.unbindViewElement(e);
              this._deferredBindingRemovals = new Map();
            }
            clearBindings() {
              (this._modelToViewMapping = new WeakMap()),
                (this._viewToModelMapping = new WeakMap()),
                (this._markerNameToElements = new Map()),
                (this._elementToMarkerNames = new Map()),
                (this._unboundMarkerNames = new Set()),
                (this._deferredBindingRemovals = new Map());
            }
            toModelElement(e) {
              return this._viewToModelMapping.get(e);
            }
            toViewElement(e) {
              return this._modelToViewMapping.get(e);
            }
            toModelRange(e) {
              return new Qa(this.toModelPosition(e.start), this.toModelPosition(e.end));
            }
            toViewRange(e) {
              return new Hi(this.toViewPosition(e.start), this.toViewPosition(e.end));
            }
            toModelPosition(e) {
              const t = { viewPosition: e, mapper: this };
              return this.fire('viewToModelPosition', t), t.modelPosition;
            }
            toViewPosition(e, t = {}) {
              const n = { modelPosition: e, mapper: this, isPhantom: t.isPhantom };
              return this.fire('modelToViewPosition', n), n.viewPosition;
            }
            markerNameToElements(e) {
              const t = this._markerNameToElements.get(e);
              if (!t) return null;
              const n = new Set();
              for (const e of t)
                if (e.is('attributeElement')) for (const t of e.getElementsWithSameId()) n.add(t);
                else n.add(e);
              return n;
            }
            registerViewToModelLength(e, t) {
              this._viewToModelLengthCallbacks.set(e, t);
            }
            findMappedViewAncestor(e) {
              let t = e.parent;
              for (; !this._viewToModelMapping.has(t); ) t = t.parent;
              return t;
            }
            _toModelOffset(e, t, n) {
              if (n != e) {
                return this._toModelOffset(e.parent, e.index, n) + this._toModelOffset(e, t, e);
              }
              if (e.is('$text')) return t;
              let o = 0;
              for (let n = 0; n < t; n++) o += this.getModelLength(e.getChild(n));
              return o;
            }
            getModelLength(e) {
              if (this._viewToModelLengthCallbacks.get(e.name)) {
                return this._viewToModelLengthCallbacks.get(e.name)(e);
              }
              if (this._viewToModelMapping.has(e)) return 1;
              if (e.is('$text')) return e.data.length;
              if (e.is('uiElement')) return 0;
              {
                let t = 0;
                for (const n of e.getChildren()) t += this.getModelLength(n);
                return t;
              }
            }
            findPositionIn(e, t) {
              let n,
                o = 0,
                i = 0,
                r = 0;
              if (e.is('$text')) return new Fi(e, t);
              for (; i < t; ) (n = e.getChild(r)), (o = this.getModelLength(n)), (i += o), r++;
              return i == t ? this._moveViewPositionToTextNode(new Fi(e, r)) : this.findPositionIn(n, t - (i - o));
            }
            _moveViewPositionToTextNode(e) {
              const t = e.nodeBefore,
                n = e.nodeAfter;
              return t instanceof Mo ? new Fi(t, t.data.length) : n instanceof Mo ? new Fi(n, 0) : e;
            }
          }
          class Ja {
            constructor() {
              (this._consumable = new Map()), (this._textProxyRegistry = new Map());
            }
            add(e, t) {
              (t = Xa(t)),
                e instanceof Ha && (e = this._getSymbolForTextProxy(e)),
                this._consumable.has(e) || this._consumable.set(e, new Map()),
                this._consumable.get(e).set(t, !0);
            }
            consume(e, t) {
              return (
                (t = Xa(t)),
                e instanceof Ha && (e = this._getSymbolForTextProxy(e)),
                !!this.test(e, t) && (this._consumable.get(e).set(t, !1), !0)
              );
            }
            test(e, t) {
              (t = Xa(t)), e instanceof Ha && (e = this._getSymbolForTextProxy(e));
              const n = this._consumable.get(e);
              if (void 0 === n) return null;
              const o = n.get(t);
              return void 0 === o ? null : o;
            }
            revert(e, t) {
              (t = Xa(t)), e instanceof Ha && (e = this._getSymbolForTextProxy(e));
              const n = this.test(e, t);
              return !1 === n ? (this._consumable.get(e).set(t, !0), !0) : !0 !== n && null;
            }
            verifyAllConsumed(e) {
              const t = [];
              for (const [n, o] of this._consumable)
                for (const [i, r] of o) {
                  const o = i.split(':')[0];
                  r && e == o && t.push({ event: i, item: n.name || n.description });
                }
              if (t.length) throw new l('conversion-model-consumable-not-consumed', null, { items: t });
            }
            _getSymbolForTextProxy(e) {
              let t = null;
              const n = this._textProxyRegistry.get(e.startOffset);
              if (n) {
                const o = n.get(e.endOffset);
                o && (t = o.get(e.parent));
              }
              return t || (t = this._addSymbolForTextProxy(e)), t;
            }
            _addSymbolForTextProxy(e) {
              const t = e.startOffset,
                n = e.endOffset,
                o = e.parent,
                i = Symbol('$textProxy:' + e.data);
              let r, s;
              return (
                (r = this._textProxyRegistry.get(t)),
                r || ((r = new Map()), this._textProxyRegistry.set(t, r)),
                (s = r.get(n)),
                s || ((s = new Map()), r.set(n, s)),
                s.set(o, i),
                i
              );
            }
          }
          function Xa(e) {
            const t = e.split(':');
            return 'insert' == t[0] ? t[0] : 'addMarker' == t[0] || 'removeMarker' == t[0] ? e : t.length > 1 ? t[0] + ':' + t[1] : t[0];
          }
          class el extends b {
            constructor(e) {
              super(), (this._conversionApi = { dispatcher: this, ...e }), (this._firedEventsMap = new WeakMap());
            }
            convertChanges(e, t, n) {
              const o = this._createConversionApi(n, e.getRefreshedItems());
              for (const t of e.getMarkersToRemove()) this._convertMarkerRemove(t.name, t.range, o);
              const i = this._reduceChanges(e.getChanges());
              for (const e of i)
                'insert' === e.type
                  ? this._convertInsert(Qa._createFromPositionAndShift(e.position, e.length), o)
                  : 'reinsert' === e.type
                  ? this._convertReinsert(Qa._createFromPositionAndShift(e.position, e.length), o)
                  : 'remove' === e.type
                  ? this._convertRemove(e.position, e.length, e.name, o)
                  : this._convertAttribute(e.range, e.attributeKey, e.attributeOldValue, e.attributeNewValue, o);
              for (const e of o.mapper.flushUnboundMarkerNames()) {
                const n = t.get(e).getRange();
                this._convertMarkerRemove(e, n, o), this._convertMarkerAdd(e, n, o);
              }
              for (const t of e.getMarkersToAdd()) this._convertMarkerAdd(t.name, t.range, o);
              o.mapper.flushDeferredBindings(), o.consumable.verifyAllConsumed('insert');
            }
            convert(e, t, n, o = {}) {
              const i = this._createConversionApi(n, void 0, o);
              this._convertInsert(e, i);
              for (const [e, n] of t) this._convertMarkerAdd(e, n, i);
              i.consumable.verifyAllConsumed('insert');
            }
            convertSelection(e, t, n) {
              const o = Array.from(t.getMarkersAtPosition(e.getFirstPosition())),
                i = this._createConversionApi(n);
              if ((this._addConsumablesForSelection(i.consumable, e, o), this.fire('selection', { selection: e }, i), e.isCollapsed)) {
                for (const t of o) {
                  const n = t.getRange();
                  if (!tl(e.getFirstPosition(), t, i.mapper)) continue;
                  const o = { item: e, markerName: t.name, markerRange: n };
                  i.consumable.test(e, 'addMarker:' + t.name) && this.fire(`addMarker:${t.name}`, o, i);
                }
                for (const t of e.getAttributeKeys()) {
                  const n = {
                    item: e,
                    range: e.getFirstRange(),
                    attributeKey: t,
                    attributeOldValue: null,
                    attributeNewValue: e.getAttribute(t),
                  };
                  i.consumable.test(e, 'attribute:' + n.attributeKey) && this.fire(`attribute:${n.attributeKey}:$text`, n, i);
                }
              }
            }
            _convertInsert(e, t, n = {}) {
              n.doNotAddConsumables || this._addConsumablesForInsert(t.consumable, Array.from(e));
              for (const n of Array.from(e.getWalker({ shallow: !0 })).map(nl)) this._testAndFire('insert', n, t);
            }
            _convertRemove(e, t, n, o) {
              this.fire(`remove:${n}`, { position: e, length: t }, o);
            }
            _convertAttribute(e, t, n, o, i) {
              this._addConsumablesForRange(i.consumable, e, `attribute:${t}`);
              for (const r of e) {
                const e = {
                  item: r.item,
                  range: Qa._createFromPositionAndShift(r.previousPosition, r.length),
                  attributeKey: t,
                  attributeOldValue: n,
                  attributeNewValue: o,
                };
                this._testAndFire(`attribute:${t}`, e, i);
              }
            }
            _convertReinsert(e, t) {
              const n = Array.from(e.getWalker({ shallow: !0 }));
              this._addConsumablesForInsert(t.consumable, n);
              for (const e of n.map(nl)) this._testAndFire('insert', { ...e, reconversion: !0 }, t);
            }
            _convertMarkerAdd(e, t, n) {
              if ('$graveyard' == t.root.rootName) return;
              const o = `addMarker:${e}`;
              if ((n.consumable.add(t, o), this.fire(o, { markerName: e, markerRange: t }, n), n.consumable.consume(t, o))) {
                this._addConsumablesForRange(n.consumable, t, o);
                for (const i of t.getItems()) {
                  if (!n.consumable.test(i, o)) continue;
                  const r = { item: i, range: Qa._createOn(i), markerName: e, markerRange: t };
                  this.fire(o, r, n);
                }
              }
            }
            _convertMarkerRemove(e, t, n) {
              '$graveyard' != t.root.rootName && this.fire(`removeMarker:${e}`, { markerName: e, markerRange: t }, n);
            }
            _reduceChanges(e) {
              const t = { changes: e };
              return this.fire('reduceChanges', t), t.changes;
            }
            _addConsumablesForInsert(e, t) {
              for (const n of t) {
                const t = n.item;
                if (null === e.test(t, 'insert')) {
                  e.add(t, 'insert');
                  for (const n of t.getAttributeKeys()) e.add(t, 'attribute:' + n);
                }
              }
              return e;
            }
            _addConsumablesForRange(e, t, n) {
              for (const o of t.getItems()) e.add(o, n);
              return e;
            }
            _addConsumablesForSelection(e, t, n) {
              e.add(t, 'selection');
              for (const o of n) e.add(t, 'addMarker:' + o.name);
              for (const n of t.getAttributeKeys()) e.add(t, 'attribute:' + n);
              return e;
            }
            _testAndFire(e, t, n) {
              const o = (function (e, t) {
                  const n = t.item.is('element') ? t.item.name : '$text';
                  return `${e}:${n}`;
                })(e, t),
                i = t.item.is('$textProxy') ? n.consumable._getSymbolForTextProxy(t.item) : t.item,
                r = this._firedEventsMap.get(n),
                s = r.get(i);
              if (s) {
                if (s.has(o)) return;
                s.add(o);
              } else r.set(i, new Set([o]));
              this.fire(o, t, n);
            }
            _testAndFireAddAttributes(e, t) {
              const n = { item: e, range: Qa._createOn(e) };
              for (const e of n.item.getAttributeKeys())
                (n.attributeKey = e),
                  (n.attributeOldValue = null),
                  (n.attributeNewValue = n.item.getAttribute(e)),
                  this._testAndFire(`attribute:${e}`, n, t);
            }
            _createConversionApi(e, t = new Set(), n = {}) {
              const o = {
                ...this._conversionApi,
                consumable: new Ja(),
                writer: e,
                options: n,
                convertItem: (e) => this._convertInsert(Qa._createOn(e), o),
                convertChildren: (e) => this._convertInsert(Qa._createIn(e), o, { doNotAddConsumables: !0 }),
                convertAttributes: (e) => this._testAndFireAddAttributes(e, o),
                canReuseView: (e) => !t.has(o.mapper.toModelElement(e)),
              };
              return this._firedEventsMap.set(o, new Map()), o;
            }
          }
          function tl(e, t, n) {
            const o = t.getRange(),
              i = Array.from(e.getAncestors());
            i.shift(), i.reverse();
            return !i.some((e) => {
              if (o.containsItem(e)) {
                return !!n.toViewElement(e).getCustomProperty('addHighlight');
              }
            });
          }
          function nl(e) {
            return { item: e.item, range: Qa._createFromPositionAndShift(e.previousPosition, e.length) };
          }
          class ol extends k(Oa) {
            constructor(...e) {
              super(), (this._lastRangeBackward = !1), (this._ranges = []), (this._attrs = new Map()), e.length && this.setTo(...e);
            }
            get anchor() {
              if (this._ranges.length > 0) {
                const e = this._ranges[this._ranges.length - 1];
                return this._lastRangeBackward ? e.end : e.start;
              }
              return null;
            }
            get focus() {
              if (this._ranges.length > 0) {
                const e = this._ranges[this._ranges.length - 1];
                return this._lastRangeBackward ? e.start : e.end;
              }
              return null;
            }
            get isCollapsed() {
              return 1 === this._ranges.length && this._ranges[0].isCollapsed;
            }
            get rangeCount() {
              return this._ranges.length;
            }
            get isBackward() {
              return !this.isCollapsed && this._lastRangeBackward;
            }
            isEqual(e) {
              if (this.rangeCount != e.rangeCount) return !1;
              if (0 === this.rangeCount) return !0;
              if (!this.anchor.isEqual(e.anchor) || !this.focus.isEqual(e.focus)) return !1;
              for (const t of this._ranges) {
                let n = !1;
                for (const o of e._ranges)
                  if (t.isEqual(o)) {
                    n = !0;
                    break;
                  }
                if (!n) return !1;
              }
              return !0;
            }
            *getRanges() {
              for (const e of this._ranges) yield new Qa(e.start, e.end);
            }
            getFirstRange() {
              let e = null;
              for (const t of this._ranges) (e && !t.start.isBefore(e.start)) || (e = t);
              return e ? new Qa(e.start, e.end) : null;
            }
            getLastRange() {
              let e = null;
              for (const t of this._ranges) (e && !t.end.isAfter(e.end)) || (e = t);
              return e ? new Qa(e.start, e.end) : null;
            }
            getFirstPosition() {
              const e = this.getFirstRange();
              return e ? e.start.clone() : null;
            }
            getLastPosition() {
              const e = this.getLastRange();
              return e ? e.end.clone() : null;
            }
            setTo(...e) {
              let [t, n, o] = e;
              if (('object' == typeof n && ((o = n), (n = void 0)), null === t)) this._setRanges([]);
              else if (t instanceof ol) this._setRanges(t.getRanges(), t.isBackward);
              else if (t && 'function' == typeof t.getRanges) this._setRanges(t.getRanges(), t.isBackward);
              else if (t instanceof Qa) this._setRanges([t], !!o && !!o.backward);
              else if (t instanceof Ga) this._setRanges([new Qa(t)]);
              else if (t instanceof Ra) {
                const e = !!o && !!o.backward;
                let i;
                if ('in' == n) i = Qa._createIn(t);
                else if ('on' == n) i = Qa._createOn(t);
                else {
                  if (void 0 === n) throw new l('model-selection-setto-required-second-parameter', [this, t]);
                  i = new Qa(Ga._createAt(t, n));
                }
                this._setRanges([i], e);
              } else {
                if (!po(t)) throw new l('model-selection-setto-not-selectable', [this, t]);
                this._setRanges(t, o && !!o.backward);
              }
            }
            _setRanges(e, t = !1) {
              const n = Array.from(e),
                o = n.some((t) => {
                  if (!(t instanceof Qa)) throw new l('model-selection-set-ranges-not-range', [this, e]);
                  return this._ranges.every((e) => !e.isEqual(t));
                });
              (n.length !== this._ranges.length || o) &&
                (this._replaceAllRanges(n), (this._lastRangeBackward = !!t), this.fire('change:range', { directChange: !0 }));
            }
            setFocus(e, t) {
              if (null === this.anchor) throw new l('model-selection-setfocus-no-ranges', [this, e]);
              const n = Ga._createAt(e, t);
              if ('same' == n.compareWith(this.focus)) return;
              const o = this.anchor;
              this._ranges.length && this._popRange(),
                'before' == n.compareWith(o)
                  ? (this._pushRange(new Qa(n, o)), (this._lastRangeBackward = !0))
                  : (this._pushRange(new Qa(o, n)), (this._lastRangeBackward = !1)),
                this.fire('change:range', { directChange: !0 });
            }
            getAttribute(e) {
              return this._attrs.get(e);
            }
            getAttributes() {
              return this._attrs.entries();
            }
            getAttributeKeys() {
              return this._attrs.keys();
            }
            hasAttribute(e) {
              return this._attrs.has(e);
            }
            removeAttribute(e) {
              this.hasAttribute(e) && (this._attrs.delete(e), this.fire('change:attribute', { attributeKeys: [e], directChange: !0 }));
            }
            setAttribute(e, t) {
              this.getAttribute(e) !== t &&
                (this._attrs.set(e, t), this.fire('change:attribute', { attributeKeys: [e], directChange: !0 }));
            }
            getSelectedElement() {
              return 1 !== this.rangeCount ? null : this.getFirstRange().getContainedElement();
            }
            *getSelectedBlocks() {
              const e = new WeakSet();
              for (const t of this.getRanges()) {
                const n = sl(t.start, e);
                n && al(n, t) && (yield n);
                for (const n of t.getWalker()) {
                  const o = n.item;
                  'elementEnd' == n.type && rl(o, e, t) && (yield o);
                }
                const o = sl(t.end, e);
                o && !t.end.isTouching(Ga._createAt(o, 0)) && al(o, t) && (yield o);
              }
            }
            containsEntireContent(e = this.anchor.root) {
              const t = Ga._createAt(e, 0),
                n = Ga._createAt(e, 'end');
              return t.isTouching(this.getFirstPosition()) && n.isTouching(this.getLastPosition());
            }
            _pushRange(e) {
              this._checkRange(e), this._ranges.push(new Qa(e.start, e.end));
            }
            _checkRange(e) {
              for (let t = 0; t < this._ranges.length; t++)
                if (e.isIntersecting(this._ranges[t]))
                  throw new l('model-selection-range-intersects', [this, e], { addedRange: e, intersectingRange: this._ranges[t] });
            }
            _replaceAllRanges(e) {
              this._removeAllRanges();
              for (const t of e) this._pushRange(t);
            }
            _removeAllRanges() {
              for (; this._ranges.length > 0; ) this._popRange();
            }
            _popRange() {
              this._ranges.pop();
            }
          }
          function il(e, t) {
            return !t.has(e) && (t.add(e), e.root.document.model.schema.isBlock(e) && e.parent);
          }
          function rl(e, t, n) {
            return il(e, t) && al(e, n);
          }
          function sl(e, t) {
            const n = e.parent.root.document.model.schema,
              o = e.parent.getAncestors({ parentFirst: !0, includeSelf: !0 });
            let i = !1;
            const r = o.find((e) => !i && ((i = n.isLimit(e)), !i && il(e, t)));
            return o.forEach((e) => t.add(e)), r;
          }
          function al(e, t) {
            const n = (function (e) {
              const t = e.root.document.model.schema;
              let n = e.parent;
              for (; n; ) {
                if (t.isBlock(n)) return n;
                n = n.parent;
              }
            })(e);
            if (!n) return !0;
            return !t.containsRange(Qa._createOn(n), !0);
          }
          ol.prototype.is = function (e) {
            return 'selection' === e || 'model:selection' === e;
          };
          class ll extends k(Qa) {
            constructor(e, t) {
              super(e, t), cl.call(this);
            }
            detach() {
              this.stopListening();
            }
            toRange() {
              return new Qa(this.start, this.end);
            }
            static fromRange(e) {
              return new ll(e.start, e.end);
            }
          }
          function cl() {
            this.listenTo(
              this.root.document.model,
              'applyOperation',
              (e, t) => {
                const n = t[0];
                n.isDocumentOperation && dl.call(this, n);
              },
              { priority: 'low' }
            );
          }
          function dl(e) {
            const t = this.getTransformedByOperation(e),
              n = Qa._createFromRanges(t),
              o = !n.isEqual(this),
              i = (function (e, t) {
                switch (t.type) {
                  case 'insert':
                    return e.containsPosition(t.position);
                  case 'move':
                  case 'remove':
                  case 'reinsert':
                  case 'merge':
                    return (
                      e.containsPosition(t.sourcePosition) || e.start.isEqual(t.sourcePosition) || e.containsPosition(t.targetPosition)
                    );
                  case 'split':
                    return e.containsPosition(t.splitPosition) || e.containsPosition(t.insertionPosition);
                }
                return !1;
              })(this, e);
            let r = null;
            if (o) {
              '$graveyard' == n.root.rootName && (r = 'remove' == e.type ? e.sourcePosition : e.deletionPosition);
              const t = this.toRange();
              (this.start = n.start), (this.end = n.end), this.fire('change:range', t, { deletionPosition: r });
            } else i && this.fire('change:content', this.toRange(), { deletionPosition: r });
          }
          ll.prototype.is = function (e) {
            return 'liveRange' === e || 'model:liveRange' === e || 'range' == e || 'model:range' === e;
          };
          const ul = 'selection:';
          class hl extends k(Oa) {
            constructor(e) {
              super(),
                (this._selection = new ml(e)),
                this._selection.delegate('change:range').to(this),
                this._selection.delegate('change:attribute').to(this),
                this._selection.delegate('change:marker').to(this);
            }
            get isCollapsed() {
              return this._selection.isCollapsed;
            }
            get anchor() {
              return this._selection.anchor;
            }
            get focus() {
              return this._selection.focus;
            }
            get rangeCount() {
              return this._selection.rangeCount;
            }
            get hasOwnRange() {
              return this._selection.hasOwnRange;
            }
            get isBackward() {
              return this._selection.isBackward;
            }
            get isGravityOverridden() {
              return this._selection.isGravityOverridden;
            }
            get markers() {
              return this._selection.markers;
            }
            get _ranges() {
              return this._selection._ranges;
            }
            getRanges() {
              return this._selection.getRanges();
            }
            getFirstPosition() {
              return this._selection.getFirstPosition();
            }
            getLastPosition() {
              return this._selection.getLastPosition();
            }
            getFirstRange() {
              return this._selection.getFirstRange();
            }
            getLastRange() {
              return this._selection.getLastRange();
            }
            getSelectedBlocks() {
              return this._selection.getSelectedBlocks();
            }
            getSelectedElement() {
              return this._selection.getSelectedElement();
            }
            containsEntireContent(e) {
              return this._selection.containsEntireContent(e);
            }
            destroy() {
              this._selection.destroy();
            }
            getAttributeKeys() {
              return this._selection.getAttributeKeys();
            }
            getAttributes() {
              return this._selection.getAttributes();
            }
            getAttribute(e) {
              return this._selection.getAttribute(e);
            }
            hasAttribute(e) {
              return this._selection.hasAttribute(e);
            }
            refresh() {
              this._selection.updateMarkers(), this._selection._updateAttributes(!1);
            }
            observeMarkers(e) {
              this._selection.observeMarkers(e);
            }
            _setFocus(e, t) {
              this._selection.setFocus(e, t);
            }
            _setTo(...e) {
              this._selection.setTo(...e);
            }
            _setAttribute(e, t) {
              this._selection.setAttribute(e, t);
            }
            _removeAttribute(e) {
              this._selection.removeAttribute(e);
            }
            _getStoredAttributes() {
              return this._selection.getStoredAttributes();
            }
            _overrideGravity() {
              return this._selection.overrideGravity();
            }
            _restoreGravity(e) {
              this._selection.restoreGravity(e);
            }
            static _getStoreAttributeKey(e) {
              return ul + e;
            }
            static _isStoreAttributeKey(e) {
              return e.startsWith(ul);
            }
          }
          hl.prototype.is = function (e) {
            return 'selection' === e || 'model:selection' == e || 'documentSelection' == e || 'model:documentSelection' == e;
          };
          class ml extends ol {
            constructor(e) {
              super(),
                (this.markers = new fo({ idProperty: 'name' })),
                (this._model = e.model),
                (this._document = e),
                (this._attributePriority = new Map()),
                (this._selectionRestorePosition = null),
                (this._hasChangedRange = !1),
                (this._overriddenGravityRegister = new Set()),
                (this._observedMarkers = new Set()),
                this.listenTo(
                  this._model,
                  'applyOperation',
                  (e, t) => {
                    const n = t[0];
                    n.isDocumentOperation &&
                      'marker' != n.type &&
                      'rename' != n.type &&
                      'noop' != n.type &&
                      (0 == this._ranges.length &&
                        this._selectionRestorePosition &&
                        this._fixGraveyardSelection(this._selectionRestorePosition),
                      (this._selectionRestorePosition = null),
                      this._hasChangedRange && ((this._hasChangedRange = !1), this.fire('change:range', { directChange: !1 })));
                  },
                  { priority: 'lowest' }
                ),
                this.on('change:range', () => {
                  this._validateSelectionRanges(this.getRanges());
                }),
                this.listenTo(this._model.markers, 'update', (e, t, n, o) => {
                  this._updateMarker(t, o);
                }),
                this.listenTo(this._document, 'change', (e, t) => {
                  !(function (e, t) {
                    const n = e.document.differ;
                    for (const o of n.getChanges()) {
                      if ('insert' != o.type) continue;
                      const n = o.position.parent;
                      o.length === n.maxOffset &&
                        e.enqueueChange(t, (e) => {
                          const t = Array.from(n.getAttributeKeys()).filter((e) => e.startsWith(ul));
                          for (const o of t) e.removeAttribute(o, n);
                        });
                    }
                  })(this._model, t);
                });
            }
            get isCollapsed() {
              return 0 === this._ranges.length ? this._document._getDefaultRange().isCollapsed : super.isCollapsed;
            }
            get anchor() {
              return super.anchor || this._document._getDefaultRange().start;
            }
            get focus() {
              return super.focus || this._document._getDefaultRange().end;
            }
            get rangeCount() {
              return this._ranges.length ? this._ranges.length : 1;
            }
            get hasOwnRange() {
              return this._ranges.length > 0;
            }
            get isGravityOverridden() {
              return !!this._overriddenGravityRegister.size;
            }
            destroy() {
              for (let e = 0; e < this._ranges.length; e++) this._ranges[e].detach();
              this.stopListening();
            }
            *getRanges() {
              this._ranges.length ? yield* super.getRanges() : yield this._document._getDefaultRange();
            }
            getFirstRange() {
              return super.getFirstRange() || this._document._getDefaultRange();
            }
            getLastRange() {
              return super.getLastRange() || this._document._getDefaultRange();
            }
            setTo(...e) {
              super.setTo(...e), this._updateAttributes(!0), this.updateMarkers();
            }
            setFocus(e, t) {
              super.setFocus(e, t), this._updateAttributes(!0), this.updateMarkers();
            }
            setAttribute(e, t) {
              if (this._setAttribute(e, t)) {
                const t = [e];
                this.fire('change:attribute', { attributeKeys: t, directChange: !0 });
              }
            }
            removeAttribute(e) {
              if (this._removeAttribute(e)) {
                const t = [e];
                this.fire('change:attribute', { attributeKeys: t, directChange: !0 });
              }
            }
            overrideGravity() {
              const e = r();
              return this._overriddenGravityRegister.add(e), 1 === this._overriddenGravityRegister.size && this._updateAttributes(!0), e;
            }
            restoreGravity(e) {
              if (!this._overriddenGravityRegister.has(e)) throw new l('document-selection-gravity-wrong-restore', this, { uid: e });
              this._overriddenGravityRegister.delete(e), this.isGravityOverridden || this._updateAttributes(!0);
            }
            observeMarkers(e) {
              this._observedMarkers.add(e), this.updateMarkers();
            }
            _replaceAllRanges(e) {
              this._validateSelectionRanges(e), super._replaceAllRanges(e);
            }
            _popRange() {
              this._ranges.pop().detach();
            }
            _pushRange(e) {
              const t = this._prepareRange(e);
              t && this._ranges.push(t);
            }
            _validateSelectionRanges(e) {
              for (const t of e)
                if (!this._document._validateSelectionRange(t)) throw new l('document-selection-wrong-position', this, { range: t });
            }
            _prepareRange(e) {
              if ((this._checkRange(e), e.root == this._document.graveyard)) return;
              const t = ll.fromRange(e);
              return (
                t.on('change:range', (e, n, o) => {
                  if (((this._hasChangedRange = !0), t.root == this._document.graveyard)) {
                    this._selectionRestorePosition = o.deletionPosition;
                    const e = this._ranges.indexOf(t);
                    this._ranges.splice(e, 1), t.detach();
                  }
                }),
                t
              );
            }
            updateMarkers() {
              if (!this._observedMarkers.size) return;
              const e = [];
              let t = !1;
              for (const t of this._model.markers) {
                const n = t.name.split(':', 1)[0];
                if (!this._observedMarkers.has(n)) continue;
                const o = t.getRange();
                for (const n of this.getRanges()) o.containsRange(n, !n.isCollapsed) && e.push(t);
              }
              const n = Array.from(this.markers);
              for (const n of e) this.markers.has(n) || (this.markers.add(n), (t = !0));
              for (const n of Array.from(this.markers)) e.includes(n) || (this.markers.remove(n), (t = !0));
              t && this.fire('change:marker', { oldMarkers: n, directChange: !1 });
            }
            _updateMarker(e, t) {
              const n = e.name.split(':', 1)[0];
              if (!this._observedMarkers.has(n)) return;
              let o = !1;
              const i = Array.from(this.markers),
                r = this.markers.has(e);
              if (t) {
                let n = !1;
                for (const e of this.getRanges())
                  if (t.containsRange(e, !e.isCollapsed)) {
                    n = !0;
                    break;
                  }
                n && !r ? (this.markers.add(e), (o = !0)) : !n && r && (this.markers.remove(e), (o = !0));
              } else r && (this.markers.remove(e), (o = !0));
              o && this.fire('change:marker', { oldMarkers: i, directChange: !1 });
            }
            _updateAttributes(e) {
              const t = No(this._getSurroundingAttributes()),
                n = No(this.getAttributes());
              if (e) (this._attributePriority = new Map()), (this._attrs = new Map());
              else for (const [e, t] of this._attributePriority) 'low' == t && (this._attrs.delete(e), this._attributePriority.delete(e));
              this._setAttributesTo(t);
              const o = [];
              for (const [e, t] of this.getAttributes()) (n.has(e) && n.get(e) === t) || o.push(e);
              for (const [e] of n) this.hasAttribute(e) || o.push(e);
              o.length > 0 && this.fire('change:attribute', { attributeKeys: o, directChange: !1 });
            }
            _setAttribute(e, t, n = !0) {
              const o = n ? 'normal' : 'low';
              if ('low' == o && 'normal' == this._attributePriority.get(e)) return !1;
              return super.getAttribute(e) !== t && (this._attrs.set(e, t), this._attributePriority.set(e, o), !0);
            }
            _removeAttribute(e, t = !0) {
              const n = t ? 'normal' : 'low';
              return (
                ('low' != n || 'normal' != this._attributePriority.get(e)) &&
                (this._attributePriority.set(e, n), !!super.hasAttribute(e) && (this._attrs.delete(e), !0))
              );
            }
            _setAttributesTo(e) {
              const t = new Set();
              for (const [t, n] of this.getAttributes()) e.get(t) !== n && this._removeAttribute(t, !1);
              for (const [n, o] of e) {
                this._setAttribute(n, o, !1) && t.add(n);
              }
              return t;
            }
            *getStoredAttributes() {
              const e = this.getFirstPosition().parent;
              if (this.isCollapsed && e.isEmpty)
                for (const t of e.getAttributeKeys())
                  if (t.startsWith(ul)) {
                    const n = t.substr(ul.length);
                    yield [n, e.getAttribute(t)];
                  }
            }
            _getSurroundingAttributes() {
              const e = this.getFirstPosition(),
                t = this._model.schema;
              let n = null;
              if (this.isCollapsed) {
                const o = e.textNode ? e.textNode : e.nodeBefore,
                  i = e.textNode ? e.textNode : e.nodeAfter;
                if ((this.isGravityOverridden || (n = gl(o)), n || (n = gl(i)), !this.isGravityOverridden && !n)) {
                  let e = o;
                  for (; e && !t.isInline(e) && !n; ) (e = e.previousSibling), (n = gl(e));
                }
                if (!n) {
                  let e = i;
                  for (; e && !t.isInline(e) && !n; ) (e = e.nextSibling), (n = gl(e));
                }
                n || (n = this.getStoredAttributes());
              } else {
                const e = this.getFirstRange();
                for (const o of e) {
                  if (o.item.is('element') && t.isObject(o.item)) break;
                  if ('text' == o.type) {
                    n = o.item.getAttributes();
                    break;
                  }
                }
              }
              return n;
            }
            _fixGraveyardSelection(e) {
              const t = this._model.schema.getNearestSelectionRange(e);
              t && this._pushRange(t);
            }
          }
          function gl(e) {
            return e instanceof Ha || e instanceof Fa ? e.getAttributes() : null;
          }
          class pl {
            constructor(e) {
              this._dispatchers = e;
            }
            add(e) {
              for (const t of this._dispatchers) e(t);
              return this;
            }
          }
          const fl = function (e) {
            return lo(e, 5);
          };
          class kl extends pl {
            elementToElement(e) {
              return this.add(
                (function (e) {
                  const t = _l(e.model),
                    n = yl(e.view, 'container');
                  t.attributes.length && (t.children = !0);
                  return (o) => {
                    o.on(
                      `insert:${t.name}`,
                      (function (e, t = Il) {
                        return (n, o, i) => {
                          if (!t(o.item, i.consumable, { preflight: !0 })) return;
                          const r = e(o.item, i, o);
                          if (!r) return;
                          t(o.item, i.consumable);
                          const s = i.mapper.toViewPosition(o.range.start);
                          i.mapper.bindElements(o.item, r),
                            i.writer.insert(s, r),
                            i.convertAttributes(o.item),
                            Dl(r, o.item.getChildren(), i, { reconversion: o.reconversion });
                        };
                      })(n, El(t)),
                      { priority: e.converterPriority || 'normal' }
                    ),
                      (t.children || t.attributes.length) && o.on('reduceChanges', xl(t), { priority: 'low' });
                  };
                })(e)
              );
            }
            elementToStructure(e) {
              return this.add(
                (function (e) {
                  const t = _l(e.model),
                    n = yl(e.view, 'container');
                  return (
                    (t.children = !0),
                    (o) => {
                      if (o._conversionApi.schema.checkChild(t.name, '$text'))
                        throw new l('conversion-element-to-structure-disallowed-text', o, { elementName: t.name });
                      var i, r;
                      o.on(
                        `insert:${t.name}`,
                        ((i = n),
                        (r = El(t)),
                        (e, t, n) => {
                          if (!r(t.item, n.consumable, { preflight: !0 })) return;
                          const o = new Map();
                          n.writer._registerSlotFactory(
                            (function (e, t, n) {
                              return (o, i = 'children') => {
                                const r = o.createContainerElement('$slot');
                                let s = null;
                                if ('children' === i) s = Array.from(e.getChildren());
                                else {
                                  if ('function' != typeof i)
                                    throw new l('conversion-slot-mode-unknown', n.dispatcher, { modeOrFilter: i });
                                  s = Array.from(e.getChildren()).filter((e) => i(e));
                                }
                                return t.set(r, s), r;
                              };
                            })(t.item, o, n)
                          );
                          const s = i(t.item, n, t);
                          if ((n.writer._clearSlotFactory(), !s)) return;
                          !(function (e, t, n) {
                            const o = Array.from(t.values()).flat(),
                              i = new Set(o);
                            if (i.size != o.length) throw new l('conversion-slot-filter-overlap', n.dispatcher, { element: e });
                            if (i.size != e.childCount) throw new l('conversion-slot-filter-incomplete', n.dispatcher, { element: e });
                          })(t.item, o, n),
                            r(t.item, n.consumable);
                          const a = n.mapper.toViewPosition(t.range.start);
                          n.mapper.bindElements(t.item, s),
                            n.writer.insert(a, s),
                            n.convertAttributes(t.item),
                            (function (e, t, n, o) {
                              n.mapper.on('modelToViewPosition', s, { priority: 'highest' });
                              let i = null,
                                r = null;
                              for ([i, r] of t)
                                Dl(e, r, n, o),
                                  n.writer.move(n.writer.createRangeIn(i), n.writer.createPositionBefore(i)),
                                  n.writer.remove(i);
                              function s(e, t) {
                                const n = t.modelPosition.nodeAfter,
                                  o = r.indexOf(n);
                                o < 0 || (t.viewPosition = t.mapper.findPositionIn(i, o));
                              }
                              n.mapper.off('modelToViewPosition', s);
                            })(s, o, n, { reconversion: t.reconversion });
                        }),
                        { priority: e.converterPriority || 'normal' }
                      ),
                        o.on('reduceChanges', xl(t), { priority: 'low' });
                    }
                  );
                })(e)
              );
            }
            attributeToElement(e) {
              return this.add(
                (function (e) {
                  let t = (e = fl(e)).model;
                  'string' == typeof t && (t = { key: t });
                  let n = `attribute:${t.key}`;
                  t.name && (n += ':' + t.name);
                  if (t.values) for (const n of t.values) e.view[n] = yl(e.view[n], 'attribute');
                  else e.view = yl(e.view, 'attribute');
                  const o = Al(e);
                  return (t) => {
                    t.on(
                      n,
                      (function (e) {
                        return (t, n, o) => {
                          if (!o.consumable.test(n.item, t.name)) return;
                          const i = e(n.attributeOldValue, o, n),
                            r = e(n.attributeNewValue, o, n);
                          if (!i && !r) return;
                          o.consumable.consume(n.item, t.name);
                          const s = o.writer,
                            a = s.document.selection;
                          if (n.item instanceof ol || n.item instanceof hl) s.wrap(a.getFirstRange(), r);
                          else {
                            let e = o.mapper.toViewRange(n.range);
                            null !== n.attributeOldValue && i && (e = s.unwrap(e, i)), null !== n.attributeNewValue && r && s.wrap(e, r);
                          }
                        };
                      })(o),
                      { priority: e.converterPriority || 'normal' }
                    );
                  };
                })(e)
              );
            }
            attributeToAttribute(e) {
              return this.add(
                (function (e) {
                  let t = (e = fl(e)).model;
                  'string' == typeof t && (t = { key: t });
                  let n = `attribute:${t.key}`;
                  t.name && (n += ':' + t.name);
                  if (t.values) for (const n of t.values) e.view[n] = Cl(e.view[n]);
                  else e.view = Cl(e.view);
                  const o = Al(e);
                  return (t) => {
                    var i;
                    t.on(
                      n,
                      ((i = o),
                      (e, t, n) => {
                        if (!n.consumable.test(t.item, e.name)) return;
                        const o = i(t.attributeOldValue, n, t),
                          r = i(t.attributeNewValue, n, t);
                        if (!o && !r) return;
                        n.consumable.consume(t.item, e.name);
                        const s = n.mapper.toViewElement(t.item),
                          a = n.writer;
                        if (!s) throw new l('conversion-attribute-to-attribute-on-text', n.dispatcher, t);
                        if (null !== t.attributeOldValue && o)
                          if ('class' == o.key) {
                            const e = bo(o.value);
                            for (const t of e) a.removeClass(t, s);
                          } else if ('style' == o.key) {
                            const e = Object.keys(o.value);
                            for (const t of e) a.removeStyle(t, s);
                          } else a.removeAttribute(o.key, s);
                        if (null !== t.attributeNewValue && r)
                          if ('class' == r.key) {
                            const e = bo(r.value);
                            for (const t of e) a.addClass(t, s);
                          } else if ('style' == r.key) {
                            const e = Object.keys(r.value);
                            for (const t of e) a.setStyle(t, r.value[t], s);
                          } else a.setAttribute(r.key, r.value, s);
                      }),
                      { priority: e.converterPriority || 'normal' }
                    );
                  };
                })(e)
              );
            }
            markerToElement(e) {
              return this.add(
                (function (e) {
                  const t = yl(e.view, 'ui');
                  return (n) => {
                    var o;
                    n.on(
                      `addMarker:${e.model}`,
                      ((o = t),
                      (e, t, n) => {
                        t.isOpening = !0;
                        const i = o(t, n);
                        t.isOpening = !1;
                        const r = o(t, n);
                        if (!i || !r) return;
                        const s = t.markerRange;
                        if (s.isCollapsed && !n.consumable.consume(s, e.name)) return;
                        for (const t of s) if (!n.consumable.consume(t.item, e.name)) return;
                        const a = n.mapper,
                          l = n.writer;
                        l.insert(a.toViewPosition(s.start), i),
                          n.mapper.bindElementToMarker(i, t.markerName),
                          s.isCollapsed || (l.insert(a.toViewPosition(s.end), r), n.mapper.bindElementToMarker(r, t.markerName)),
                          e.stop();
                      }),
                      { priority: e.converterPriority || 'normal' }
                    ),
                      n.on(
                        `removeMarker:${e.model}`,
                        (e, t, n) => {
                          const o = n.mapper.markerNameToElements(t.markerName);
                          if (o) {
                            for (const e of o)
                              n.mapper.unbindElementFromMarkerName(e, t.markerName), n.writer.clear(n.writer.createRangeOn(e), e);
                            n.writer.clearClonedElementsGroup(t.markerName), e.stop();
                          }
                        },
                        { priority: e.converterPriority || 'normal' }
                      );
                  };
                })(e)
              );
            }
            markerToHighlight(e) {
              return this.add(
                (function (e) {
                  return (t) => {
                    var n;
                    t.on(
                      `addMarker:${e.model}`,
                      ((n = e.view),
                      (e, t, o) => {
                        if (!t.item) return;
                        if (!(t.item instanceof ol || t.item instanceof hl || t.item.is('$textProxy'))) return;
                        const i = vl(n, t, o);
                        if (!i) return;
                        if (!o.consumable.consume(t.item, e.name)) return;
                        const r = o.writer,
                          s = bl(r, i),
                          a = r.document.selection;
                        if (t.item instanceof ol || t.item instanceof hl) r.wrap(a.getFirstRange(), s);
                        else {
                          const e = o.mapper.toViewRange(t.range),
                            n = r.wrap(e, s);
                          for (const e of n.getItems())
                            if (e.is('attributeElement') && e.isSimilar(s)) {
                              o.mapper.bindElementToMarker(e, t.markerName);
                              break;
                            }
                        }
                      }),
                      { priority: e.converterPriority || 'normal' }
                    ),
                      t.on(
                        `addMarker:${e.model}`,
                        (function (e) {
                          return (t, n, o) => {
                            if (!n.item) return;
                            if (!(n.item instanceof Ua)) return;
                            const i = vl(e, n, o);
                            if (!i) return;
                            if (!o.consumable.test(n.item, t.name)) return;
                            const r = o.mapper.toViewElement(n.item);
                            if (r && r.getCustomProperty('addHighlight')) {
                              o.consumable.consume(n.item, t.name);
                              for (const e of Qa._createIn(n.item)) o.consumable.consume(e.item, t.name);
                              r.getCustomProperty('addHighlight')(r, i, o.writer), o.mapper.bindElementToMarker(r, n.markerName);
                            }
                          };
                        })(e.view),
                        { priority: e.converterPriority || 'normal' }
                      ),
                      t.on(
                        `removeMarker:${e.model}`,
                        (function (e) {
                          return (t, n, o) => {
                            if (n.markerRange.isCollapsed) return;
                            const i = vl(e, n, o);
                            if (!i) return;
                            const r = bl(o.writer, i),
                              s = o.mapper.markerNameToElements(n.markerName);
                            if (s) {
                              for (const e of s)
                                if ((o.mapper.unbindElementFromMarkerName(e, n.markerName), e.is('attributeElement')))
                                  o.writer.unwrap(o.writer.createRangeOn(e), r);
                                else {
                                  e.getCustomProperty('removeHighlight')(e, i.id, o.writer);
                                }
                              o.writer.clearClonedElementsGroup(n.markerName), t.stop();
                            }
                          };
                        })(e.view),
                        { priority: e.converterPriority || 'normal' }
                      );
                  };
                })(e)
              );
            }
            markerToData(e) {
              return this.add(
                (function (e) {
                  const t = (e = fl(e)).model;
                  let n = e.view;
                  n || (n = (n) => ({ group: t, name: n.substr(e.model.length + 1) }));
                  return (o) => {
                    var i;
                    o.on(
                      `addMarker:${t}`,
                      ((i = n),
                      (e, t, n) => {
                        const o = i(t.markerName, n);
                        if (!o) return;
                        const r = t.markerRange;
                        n.consumable.consume(r, e.name) && (wl(r, !1, n, t, o), wl(r, !0, n, t, o), e.stop());
                      }),
                      { priority: e.converterPriority || 'normal' }
                    ),
                      o.on(
                        `removeMarker:${t}`,
                        (function (e) {
                          return (t, n, o) => {
                            const i = e(n.markerName, o);
                            if (!i) return;
                            const r = o.mapper.markerNameToElements(n.markerName);
                            if (r) {
                              for (const e of r)
                                o.mapper.unbindElementFromMarkerName(e, n.markerName),
                                  e.is('containerElement')
                                    ? (s(`data-${i.group}-start-before`, e),
                                      s(`data-${i.group}-start-after`, e),
                                      s(`data-${i.group}-end-before`, e),
                                      s(`data-${i.group}-end-after`, e))
                                    : o.writer.clear(o.writer.createRangeOn(e), e);
                              o.writer.clearClonedElementsGroup(n.markerName), t.stop();
                            }
                            function s(e, t) {
                              if (t.hasAttribute(e)) {
                                const n = new Set(t.getAttribute(e).split(','));
                                n.delete(i.name),
                                  0 == n.size ? o.writer.removeAttribute(e, t) : o.writer.setAttribute(e, Array.from(n).join(','), t);
                              }
                            }
                          };
                        })(n),
                        { priority: e.converterPriority || 'normal' }
                      );
                  };
                })(e)
              );
            }
          }
          function bl(e, t) {
            const n = e.createAttributeElement('span', t.attributes);
            return t.classes && n._addClass(t.classes), 'number' == typeof t.priority && (n._priority = t.priority), (n._id = t.id), n;
          }
          function wl(e, t, n, o, i) {
            const r = t ? e.start : e.end,
              s = r.nodeAfter && r.nodeAfter.is('element') ? r.nodeAfter : null,
              a = r.nodeBefore && r.nodeBefore.is('element') ? r.nodeBefore : null;
            if (s || a) {
              let e, r;
              (t && s) || (!t && !a) ? ((e = s), (r = !0)) : ((e = a), (r = !1));
              const l = n.mapper.toViewElement(e);
              if (l)
                return void (function (e, t, n, o, i, r) {
                  const s = `data-${r.group}-${t ? 'start' : 'end'}-${n ? 'before' : 'after'}`,
                    a = e.hasAttribute(s) ? e.getAttribute(s).split(',') : [];
                  a.unshift(r.name), o.writer.setAttribute(s, a.join(','), e), o.mapper.bindElementToMarker(e, i.markerName);
                })(l, t, r, n, o, i);
            }
            !(function (e, t, n, o, i) {
              const r = `${i.group}-${t ? 'start' : 'end'}`,
                s = i.name ? { name: i.name } : null,
                a = n.writer.createUIElement(r, s);
              n.writer.insert(e, a), n.mapper.bindElementToMarker(a, o.markerName);
            })(n.mapper.toViewPosition(r), t, n, o, i);
          }
          function _l(e) {
            return (
              'string' == typeof e && (e = { name: e }),
              e.attributes ? Array.isArray(e.attributes) || (e.attributes = [e.attributes]) : (e.attributes = []),
              (e.children = !!e.children),
              e
            );
          }
          function yl(e, t) {
            return 'function' == typeof e
              ? e
              : (n, o) =>
                  (function (e, t, n) {
                    'string' == typeof e && (e = { name: e });
                    let o;
                    const i = t.writer,
                      r = Object.assign({}, e.attributes);
                    if ('container' == n) o = i.createContainerElement(e.name, r);
                    else if ('attribute' == n) {
                      const t = { priority: e.priority || tr.DEFAULT_PRIORITY };
                      o = i.createAttributeElement(e.name, r, t);
                    } else o = i.createUIElement(e.name, r);
                    if (e.styles) {
                      const t = Object.keys(e.styles);
                      for (const n of t) i.setStyle(n, e.styles[n], o);
                    }
                    if (e.classes) {
                      const t = e.classes;
                      if ('string' == typeof t) i.addClass(t, o);
                      else for (const e of t) i.addClass(e, o);
                    }
                    return o;
                  })(e, o, t);
          }
          function Al(e) {
            return e.model.values
              ? (t, n, o) => {
                  const i = e.view[t];
                  return i ? i(t, n, o) : null;
                }
              : e.view;
          }
          function Cl(e) {
            return 'string' == typeof e
              ? (t) => ({ key: e, value: t })
              : 'object' == typeof e
              ? e.value
                ? () => e
                : (t) => ({ key: e.key, value: t })
              : e;
          }
          function vl(e, t, n) {
            const o = 'function' == typeof e ? e(t, n) : e;
            return o ? (o.priority || (o.priority = 10), o.id || (o.id = t.markerName), o) : null;
          }
          function xl(e) {
            const t = (function (e) {
              return (t, n) => {
                if (!t.is('element', e.name)) return !1;
                if ('attribute' == n.type) {
                  if (e.attributes.includes(n.attributeKey)) return !0;
                } else if (e.children) return !0;
                return !1;
              };
            })(e);
            return (e, n) => {
              const o = [];
              n.reconvertedElements || (n.reconvertedElements = new Set());
              for (const e of n.changes) {
                const i = 'attribute' == e.type ? e.range.start.nodeAfter : e.position.parent;
                if (i && t(i, e)) {
                  if (!n.reconvertedElements.has(i)) {
                    n.reconvertedElements.add(i);
                    const e = Ga._createBefore(i);
                    o.push(
                      { type: 'remove', name: i.name, position: e, length: 1 },
                      { type: 'reinsert', name: i.name, position: e, length: 1 }
                    );
                  }
                } else o.push(e);
              }
              n.changes = o;
            };
          }
          function El(e) {
            return (t, n, o = {}) => {
              const i = ['insert'];
              for (const n of e.attributes) t.hasAttribute(n) && i.push(`attribute:${n}`);
              return !!i.every((e) => n.test(t, e)) && (o.preflight || i.forEach((e) => n.consume(t, e)), !0);
            };
          }
          function Dl(e, t, n, o) {
            for (const i of t) Tl(e.root, i, n, o) || n.convertItem(i);
          }
          function Tl(e, t, n, o) {
            const { writer: i, mapper: r } = n;
            if (!o.reconversion) return !1;
            const s = r.toViewElement(t);
            return !(!s || s.root == e) && !!n.canReuseView(s) && (i.move(i.createRangeOn(s), r.toViewPosition(Ga._createBefore(t))), !0);
          }
          function Il(e, t, { preflight: n } = {}) {
            return n ? t.test(e, 'insert') : t.consume(e, 'insert');
          }
          function Sl(e) {
            const { schema: t, document: n } = e.model;
            for (const o of n.getRootNames()) {
              const i = n.getRoot(o);
              if (i.isEmpty && !t.checkChild(i, '$text') && t.checkChild(i, 'paragraph')) return e.insertElement('paragraph', i), !0;
            }
            return !1;
          }
          function Ml(e, t, n) {
            const o = n.createContext(e);
            return !!n.checkChild(o, 'paragraph') && !!n.checkChild(o.push('paragraph'), t);
          }
          function Bl(e, t) {
            const n = t.createElement('paragraph');
            return t.insert(n, e), t.createPositionAt(n, 0);
          }
          class Nl extends pl {
            elementToElement(e) {
              return this.add(Pl(e));
            }
            elementToAttribute(e) {
              return this.add(
                (function (e) {
                  jl((e = fl(e)));
                  const t = Ol(e, !1),
                    n = zl(e.view),
                    o = n ? `element:${n}` : 'element';
                  return (n) => {
                    n.on(o, t, { priority: e.converterPriority || 'low' });
                  };
                })(e)
              );
            }
            attributeToAttribute(e) {
              return this.add(
                (function (e) {
                  e = fl(e);
                  let t = null;
                  ('string' == typeof e.view || e.view.key) &&
                    (t = (function (e) {
                      'string' == typeof e.view && (e.view = { key: e.view });
                      const t = e.view.key;
                      let n;
                      if ('class' == t || 'style' == t) {
                        n = { ['class' == t ? 'classes' : 'styles']: e.view.value };
                      } else {
                        n = { attributes: { [t]: void 0 === e.view.value ? /[\s\S]*/ : e.view.value } };
                      }
                      e.view.name && (n.name = e.view.name);
                      return (e.view = n), t;
                    })(e));
                  jl(e, t);
                  const n = Ol(e, !0);
                  return (t) => {
                    t.on('element', n, { priority: e.converterPriority || 'low' });
                  };
                })(e)
              );
            }
            elementToMarker(e) {
              return this.add(
                (function (e) {
                  const t = (function (e) {
                    return (t, n) => {
                      const o = 'string' == typeof e ? e : e(t, n);
                      return n.writer.createElement('$marker', { 'data-name': o });
                    };
                  })(e.model);
                  return Pl({ ...e, model: t });
                })(e)
              );
            }
            dataToMarker(e) {
              return this.add(
                (function (e) {
                  (e = fl(e)).model || (e.model = (t) => (t ? e.view + ':' + t : e.view));
                  const t = { view: e.view, model: e.model },
                    n = Ll(Rl(t, 'start')),
                    o = Ll(Rl(t, 'end'));
                  return (i) => {
                    i.on(`element:${e.view}-start`, n, { priority: e.converterPriority || 'normal' }),
                      i.on(`element:${e.view}-end`, o, { priority: e.converterPriority || 'normal' });
                    const r = s.get('low'),
                      a = s.get('highest'),
                      l = s.get(e.converterPriority) / a;
                    i.on(
                      'element',
                      (function (e) {
                        return (t, n, o) => {
                          const i = `data-${e.view}`;
                          function r(t, i) {
                            for (const r of i) {
                              const i = e.model(r, o),
                                s = o.writer.createElement('$marker', { 'data-name': i });
                              o.writer.insert(s, t),
                                n.modelCursor.isEqual(t)
                                  ? (n.modelCursor = n.modelCursor.getShiftedBy(1))
                                  : (n.modelCursor = n.modelCursor._getTransformedByInsertion(t, 1)),
                                (n.modelRange = n.modelRange._getTransformedByInsertion(t, 1)[0]);
                            }
                          }
                          (o.consumable.test(n.viewItem, { attributes: i + '-end-after' }) ||
                            o.consumable.test(n.viewItem, { attributes: i + '-start-after' }) ||
                            o.consumable.test(n.viewItem, { attributes: i + '-end-before' }) ||
                            o.consumable.test(n.viewItem, { attributes: i + '-start-before' })) &&
                            (n.modelRange || Object.assign(n, o.convertChildren(n.viewItem, n.modelCursor)),
                            o.consumable.consume(n.viewItem, { attributes: i + '-end-after' }) &&
                              r(n.modelRange.end, n.viewItem.getAttribute(i + '-end-after').split(',')),
                            o.consumable.consume(n.viewItem, { attributes: i + '-start-after' }) &&
                              r(n.modelRange.end, n.viewItem.getAttribute(i + '-start-after').split(',')),
                            o.consumable.consume(n.viewItem, { attributes: i + '-end-before' }) &&
                              r(n.modelRange.start, n.viewItem.getAttribute(i + '-end-before').split(',')),
                            o.consumable.consume(n.viewItem, { attributes: i + '-start-before' }) &&
                              r(n.modelRange.start, n.viewItem.getAttribute(i + '-start-before').split(',')));
                        };
                      })(t),
                      { priority: r + l }
                    );
                  };
                })(e)
              );
            }
          }
          function Pl(e) {
            const t = Ll((e = fl(e))),
              n = zl(e.view),
              o = n ? `element:${n}` : 'element';
            return (n) => {
              n.on(o, t, { priority: e.converterPriority || 'normal' });
            };
          }
          function zl(e) {
            return 'string' == typeof e ? e : 'object' == typeof e && 'string' == typeof e.name ? e.name : null;
          }
          function Ll(e) {
            const t = new Po(e.view);
            return (n, o, i) => {
              const r = t.match(o.viewItem);
              if (!r) return;
              const s = r.match;
              if (((s.name = !0), !i.consumable.test(o.viewItem, s))) return;
              const a = (function (e, t, n) {
                return e instanceof Function ? e(t, n) : n.writer.createElement(e);
              })(e.model, o.viewItem, i);
              a &&
                i.safeInsert(a, o.modelCursor) &&
                (i.consumable.consume(o.viewItem, s), i.convertChildren(o.viewItem, a), i.updateConversionResult(a, o));
            };
          }
          function jl(e, t = null) {
            const n = null === t || ((e) => e.getAttribute(t)),
              o = 'object' != typeof e.model ? e.model : e.model.key,
              i = 'object' != typeof e.model || void 0 === e.model.value ? n : e.model.value;
            e.model = { key: o, value: i };
          }
          function Ol(e, t) {
            const n = new Po(e.view);
            return (o, i, r) => {
              if (!i.modelRange && t) return;
              const s = n.match(i.viewItem);
              if (!s) return;
              if (
                (!(function (e, t) {
                  const n = 'function' == typeof e ? e(t) : e;
                  if ('object' == typeof n && !zl(n)) return !1;
                  return !n.classes && !n.attributes && !n.styles;
                })(e.view, i.viewItem)
                  ? delete s.match.name
                  : (s.match.name = !0),
                !r.consumable.test(i.viewItem, s.match))
              )
                return;
              const a = e.model.key,
                l = 'function' == typeof e.model.value ? e.model.value(i.viewItem, r) : e.model.value;
              if (null === l) return;
              i.modelRange || Object.assign(i, r.convertChildren(i.viewItem, i.modelCursor));
              const c = (function (e, t, n, o) {
                let i = !1;
                for (const r of Array.from(e.getItems({ shallow: n })))
                  o.schema.checkAttribute(r, t.key) && ((i = !0), r.hasAttribute(t.key) || o.writer.setAttribute(t.key, t.value, r));
                return i;
              })(i.modelRange, { key: a, value: l }, t, r);
              c && (r.consumable.test(i.viewItem, { name: !0 }) && (s.match.name = !0), r.consumable.consume(i.viewItem, s.match));
            };
          }
          function Rl(e, t) {
            return {
              view: `${e.view}-${t}`,
              model: (t, n) => {
                const o = t.getAttribute('name'),
                  i = e.model(o, n);
                return n.writer.createElement('$marker', { 'data-name': i });
              },
            };
          }
          class Vl extends N {
            constructor(e, t) {
              super(),
                (this.model = e),
                (this.view = new ja(t)),
                (this.mapper = new Za()),
                (this.downcastDispatcher = new el({ mapper: this.mapper, schema: e.schema }));
              const n = this.model.document,
                o = n.selection,
                i = this.model.markers;
              this.listenTo(
                this.model,
                '_beforeChanges',
                () => {
                  this.view._disableRendering(!0);
                },
                { priority: 'highest' }
              ),
                this.listenTo(
                  this.model,
                  '_afterChanges',
                  () => {
                    this.view._disableRendering(!1);
                  },
                  { priority: 'lowest' }
                ),
                this.listenTo(
                  n,
                  'change',
                  () => {
                    this.view.change((e) => {
                      this.downcastDispatcher.convertChanges(n.differ, i, e), this.downcastDispatcher.convertSelection(o, i, e);
                    });
                  },
                  { priority: 'low' }
                ),
                this.listenTo(
                  this.view.document,
                  'selectionChange',
                  (function (e, t) {
                    return (n, o) => {
                      const i = o.newSelection,
                        r = [];
                      for (const e of i.getRanges()) r.push(t.toModelRange(e));
                      const s = e.createSelection(r, { backward: i.isBackward });
                      s.isEqual(e.document.selection) ||
                        e.change((e) => {
                          e.setSelection(s);
                        });
                    };
                  })(this.model, this.mapper)
                ),
                this.downcastDispatcher.on(
                  'insert:$text',
                  (e, t, n) => {
                    if (!n.consumable.consume(t.item, e.name)) return;
                    const o = n.writer,
                      i = n.mapper.toViewPosition(t.range.start),
                      r = o.createText(t.item.data);
                    o.insert(i, r);
                  },
                  { priority: 'lowest' }
                ),
                this.downcastDispatcher.on(
                  'insert',
                  (e, t, n) => {
                    n.convertAttributes(t.item), t.reconversion || !t.item.is('element') || t.item.isEmpty || n.convertChildren(t.item);
                  },
                  { priority: 'lowest' }
                ),
                this.downcastDispatcher.on(
                  'remove',
                  (e, t, n) => {
                    const o = n.mapper.toViewPosition(t.position),
                      i = t.position.getShiftedBy(t.length),
                      r = n.mapper.toViewPosition(i, { isPhantom: !0 }),
                      s = n.writer.createRange(o, r),
                      a = n.writer.remove(s.getTrimmed());
                    for (const e of n.writer.createRangeIn(a).getItems()) n.mapper.unbindViewElement(e, { defer: !0 });
                  },
                  { priority: 'low' }
                ),
                this.downcastDispatcher.on(
                  'selection',
                  (e, t, n) => {
                    const o = n.writer,
                      i = o.document.selection;
                    for (const e of i.getRanges()) e.isCollapsed && e.end.parent.isAttached() && n.writer.mergeAttributes(e.start);
                    o.setSelection(null);
                  },
                  { priority: 'high' }
                ),
                this.downcastDispatcher.on(
                  'selection',
                  (e, t, n) => {
                    const o = t.selection;
                    if (o.isCollapsed) return;
                    if (!n.consumable.consume(o, 'selection')) return;
                    const i = [];
                    for (const e of o.getRanges()) i.push(n.mapper.toViewRange(e));
                    n.writer.setSelection(i, { backward: o.isBackward });
                  },
                  { priority: 'low' }
                ),
                this.downcastDispatcher.on(
                  'selection',
                  (e, t, n) => {
                    const o = t.selection;
                    if (!o.isCollapsed) return;
                    if (!n.consumable.consume(o, 'selection')) return;
                    const i = n.writer,
                      r = o.getFirstPosition(),
                      s = n.mapper.toViewPosition(r),
                      a = i.breakAttributes(s);
                    i.setSelection(a);
                  },
                  { priority: 'low' }
                ),
                this.view.document.roots.bindTo(this.model.document.roots).using((e) => {
                  if ('$graveyard' == e.rootName) return null;
                  const t = new Ri(this.view.document, e.name);
                  return (t.rootName = e.rootName), this.mapper.bindElements(e, t), t;
                });
            }
            destroy() {
              this.view.destroy(), this.stopListening();
            }
            reconvertMarker(e) {
              const t = 'string' == typeof e ? e : e.name,
                n = this.model.markers.get(t);
              if (!n) throw new l('editingcontroller-reconvertmarker-marker-not-exist', this, { markerName: t });
              this.model.change(() => {
                this.model.markers._refresh(n);
              });
            }
            reconvertItem(e) {
              this.model.change(() => {
                this.model.document.differ._refreshItem(e);
              });
            }
          }
          class Fl {
            constructor() {
              this._commands = new Map();
            }
            add(e, t) {
              this._commands.set(e, t);
            }
            get(e) {
              return this._commands.get(e);
            }
            execute(e, ...t) {
              const n = this.get(e);
              if (!n) throw new l('commandcollection-command-not-found', this, { commandName: e });
              return n.execute(...t);
            }
            *names() {
              yield* this._commands.keys();
            }
            *commands() {
              yield* this._commands.values();
            }
            [Symbol.iterator]() {
              return this._commands[Symbol.iterator]();
            }
            destroy() {
              for (const e of this.commands()) e.destroy();
            }
          }
          class Hl {
            constructor() {
              this._consumables = new Map();
            }
            add(e, t) {
              let n;
              e.is('$text') || e.is('documentFragment')
                ? this._consumables.set(e, !0)
                : (this._consumables.has(e) ? (n = this._consumables.get(e)) : ((n = new ql(e)), this._consumables.set(e, n)), n.add(t));
            }
            test(e, t) {
              const n = this._consumables.get(e);
              return void 0 === n ? null : e.is('$text') || e.is('documentFragment') ? n : n.test(t);
            }
            consume(e, t) {
              return (
                !!this.test(e, t) &&
                (e.is('$text') || e.is('documentFragment') ? this._consumables.set(e, !1) : this._consumables.get(e).consume(t), !0)
              );
            }
            revert(e, t) {
              const n = this._consumables.get(e);
              void 0 !== n && (e.is('$text') || e.is('documentFragment') ? this._consumables.set(e, !0) : n.revert(t));
            }
            static consumablesFromElement(e) {
              const t = { element: e, name: !0, attributes: [], classes: [], styles: [] },
                n = e.getAttributeKeys();
              for (const e of n) 'style' != e && 'class' != e && t.attributes.push(e);
              const o = e.getClassNames();
              for (const e of o) t.classes.push(e);
              const i = e.getStyleNames();
              for (const e of i) t.styles.push(e);
              return t;
            }
            static createFrom(e, t) {
              if ((t || (t = new Hl()), e.is('$text'))) return t.add(e), t;
              e.is('element') && t.add(e, Hl.consumablesFromElement(e)), e.is('documentFragment') && t.add(e);
              for (const n of e.getChildren()) t = Hl.createFrom(n, t);
              return t;
            }
          }
          const Ul = ['attributes', 'classes', 'styles'];
          class ql {
            constructor(e) {
              (this.element = e),
                (this._canConsumeName = null),
                (this._consumables = { attributes: new Map(), styles: new Map(), classes: new Map() });
            }
            add(e) {
              e.name && (this._canConsumeName = !0);
              for (const t of Ul) t in e && this._add(t, e[t]);
            }
            test(e) {
              if (e.name && !this._canConsumeName) return this._canConsumeName;
              for (const t of Ul)
                if (t in e) {
                  const n = this._test(t, e[t]);
                  if (!0 !== n) return n;
                }
              return !0;
            }
            consume(e) {
              e.name && (this._canConsumeName = !1);
              for (const t of Ul) t in e && this._consume(t, e[t]);
            }
            revert(e) {
              e.name && (this._canConsumeName = !0);
              for (const t of Ul) t in e && this._revert(t, e[t]);
            }
            _add(e, t) {
              const n = Ct(t) ? t : [t],
                o = this._consumables[e];
              for (const t of n) {
                if ('attributes' === e && ('class' === t || 'style' === t)) throw new l('viewconsumable-invalid-attribute', this);
                if ((o.set(t, !0), 'styles' === e)) for (const e of this.element.document.stylesProcessor.getRelatedStyles(t)) o.set(e, !0);
              }
            }
            _test(e, t) {
              const n = Ct(t) ? t : [t],
                o = this._consumables[e];
              for (const t of n)
                if ('attributes' !== e || ('class' !== t && 'style' !== t)) {
                  const e = o.get(t);
                  if (void 0 === e) return null;
                  if (!e) return !1;
                } else {
                  const e = 'class' == t ? 'classes' : 'styles',
                    n = this._test(e, [...this._consumables[e].keys()]);
                  if (!0 !== n) return n;
                }
              return !0;
            }
            _consume(e, t) {
              const n = Ct(t) ? t : [t],
                o = this._consumables[e];
              for (const t of n)
                if ('attributes' !== e || ('class' !== t && 'style' !== t)) {
                  if ((o.set(t, !1), 'styles' == e))
                    for (const e of this.element.document.stylesProcessor.getRelatedStyles(t)) o.set(e, !1);
                } else {
                  const e = 'class' == t ? 'classes' : 'styles';
                  this._consume(e, [...this._consumables[e].keys()]);
                }
            }
            _revert(e, t) {
              const n = Ct(t) ? t : [t],
                o = this._consumables[e];
              for (const t of n)
                if ('attributes' !== e || ('class' !== t && 'style' !== t)) {
                  !1 === o.get(t) && o.set(t, !0);
                } else {
                  const e = 'class' == t ? 'classes' : 'styles';
                  this._revert(e, [...this._consumables[e].keys()]);
                }
            }
          }
          class Wl extends N {
            constructor() {
              super(),
                (this._sourceDefinitions = {}),
                (this._attributeProperties = {}),
                this.decorate('checkChild'),
                this.decorate('checkAttribute'),
                this.on(
                  'checkAttribute',
                  (e, t) => {
                    t[0] = new Gl(t[0]);
                  },
                  { priority: 'highest' }
                ),
                this.on(
                  'checkChild',
                  (e, t) => {
                    (t[0] = new Gl(t[0])), (t[1] = this.getDefinition(t[1]));
                  },
                  { priority: 'highest' }
                );
            }
            register(e, t) {
              if (this._sourceDefinitions[e]) throw new l('schema-cannot-register-item-twice', this, { itemName: e });
              (this._sourceDefinitions[e] = [Object.assign({}, t)]), this._clearCache();
            }
            extend(e, t) {
              if (!this._sourceDefinitions[e]) throw new l('schema-cannot-extend-missing-item', this, { itemName: e });
              this._sourceDefinitions[e].push(Object.assign({}, t)), this._clearCache();
            }
            getDefinitions() {
              return this._compiledDefinitions || this._compile(), this._compiledDefinitions;
            }
            getDefinition(e) {
              let t;
              return (
                (t = 'string' == typeof e ? e : 'is' in e && (e.is('$text') || e.is('$textProxy')) ? '$text' : e.name),
                this.getDefinitions()[t]
              );
            }
            isRegistered(e) {
              return !!this.getDefinition(e);
            }
            isBlock(e) {
              const t = this.getDefinition(e);
              return !(!t || !t.isBlock);
            }
            isLimit(e) {
              const t = this.getDefinition(e);
              return !!t && !(!t.isLimit && !t.isObject);
            }
            isObject(e) {
              const t = this.getDefinition(e);
              return !!t && !!(t.isObject || (t.isLimit && t.isSelectable && t.isContent));
            }
            isInline(e) {
              const t = this.getDefinition(e);
              return !(!t || !t.isInline);
            }
            isSelectable(e) {
              const t = this.getDefinition(e);
              return !!t && !(!t.isSelectable && !t.isObject);
            }
            isContent(e) {
              const t = this.getDefinition(e);
              return !!t && !(!t.isContent && !t.isObject);
            }
            checkChild(e, t) {
              return !!t && this._checkContextMatch(t, e);
            }
            checkAttribute(e, t) {
              const n = this.getDefinition(e.last);
              return !!n && n.allowAttributes.includes(t);
            }
            checkMerge(e, t) {
              if (e instanceof Ga) {
                const t = e.nodeBefore,
                  n = e.nodeAfter;
                if (!(t instanceof Ua)) throw new l('schema-check-merge-no-element-before', this);
                if (!(n instanceof Ua)) throw new l('schema-check-merge-no-element-after', this);
                return this.checkMerge(t, n);
              }
              for (const n of t.getChildren()) if (!this.checkChild(e, n)) return !1;
              return !0;
            }
            addChildCheck(e) {
              this.on(
                'checkChild',
                (t, [n, o]) => {
                  if (!o) return;
                  const i = e(n, o);
                  'boolean' == typeof i && (t.stop(), (t.return = i));
                },
                { priority: 'high' }
              );
            }
            addAttributeCheck(e) {
              this.on(
                'checkAttribute',
                (t, [n, o]) => {
                  const i = e(n, o);
                  'boolean' == typeof i && (t.stop(), (t.return = i));
                },
                { priority: 'high' }
              );
            }
            setAttributeProperties(e, t) {
              this._attributeProperties[e] = Object.assign(this.getAttributeProperties(e), t);
            }
            getAttributeProperties(e) {
              return this._attributeProperties[e] || {};
            }
            getLimitElement(e) {
              let t;
              if (e instanceof Ga) t = e.parent;
              else {
                t = (e instanceof Qa ? [e] : Array.from(e.getRanges())).reduce((e, t) => {
                  const n = t.getCommonAncestor();
                  return e ? e.getCommonAncestor(n, { includeSelf: !0 }) : n;
                }, null);
              }
              for (; !this.isLimit(t) && t.parent; ) t = t.parent;
              return t;
            }
            checkAttributeInSelection(e, t) {
              if (e.isCollapsed) {
                const n = [...e.getFirstPosition().getAncestors(), new Fa('', e.getAttributes())];
                return this.checkAttribute(n, t);
              }
              {
                const n = e.getRanges();
                for (const e of n) for (const n of e) if (this.checkAttribute(n.item, t)) return !0;
              }
              return !1;
            }
            *getValidRanges(e, t) {
              e = (function* (e) {
                for (const t of e) yield* t.getMinimalFlatRanges();
              })(e);
              for (const n of e) yield* this._getValidRangesForRange(n, t);
            }
            getNearestSelectionRange(e, t = 'both') {
              if (this.checkChild(e, '$text')) return new Qa(e);
              let n, o;
              const i =
                e
                  .getAncestors()
                  .reverse()
                  .find((e) => this.isLimit(e)) || e.root;
              ('both' != t && 'backward' != t) || (n = new qa({ boundaries: Qa._createIn(i), startPosition: e, direction: 'backward' })),
                ('both' != t && 'forward' != t) || (o = new qa({ boundaries: Qa._createIn(i), startPosition: e }));
              for (const e of (function* (e, t) {
                let n = !1;
                for (; !n; ) {
                  if (((n = !0), e)) {
                    const t = e.next();
                    t.done || ((n = !1), yield { walker: e, value: t.value });
                  }
                  if (t) {
                    const e = t.next();
                    e.done || ((n = !1), yield { walker: t, value: e.value });
                  }
                }
              })(n, o)) {
                const t = e.walker == n ? 'elementEnd' : 'elementStart',
                  o = e.value;
                if (o.type == t && this.isObject(o.item)) return Qa._createOn(o.item);
                if (this.checkChild(o.nextPosition, '$text')) return new Qa(o.nextPosition);
              }
              return null;
            }
            findAllowedParent(e, t) {
              let n = e.parent;
              for (; n; ) {
                if (this.checkChild(n, t)) return n;
                if (this.isLimit(n)) return null;
                n = n.parent;
              }
              return null;
            }
            setAllowedAttributes(e, t, n) {
              const o = n.model;
              for (const [i, r] of Object.entries(t)) o.schema.checkAttribute(e, i) && n.setAttribute(i, r, e);
            }
            removeDisallowedAttributes(e, t) {
              for (const n of e)
                if (n.is('$text')) rc(this, n, t);
                else {
                  const e = Qa._createIn(n).getPositions();
                  for (const n of e) {
                    rc(this, n.nodeBefore || n.parent, t);
                  }
                }
            }
            getAttributesWithProperty(e, t, n) {
              const o = {};
              for (const [i, r] of e.getAttributes()) {
                const e = this.getAttributeProperties(i);
                void 0 !== e[t] && ((void 0 !== n && n !== e[t]) || (o[i] = r));
              }
              return o;
            }
            createContext(e) {
              return new Gl(e);
            }
            _clearCache() {
              this._compiledDefinitions = null;
            }
            _compile() {
              const e = {},
                t = this._sourceDefinitions,
                n = Object.keys(t);
              for (const o of n) e[o] = $l(t[o], o);
              for (const t of n) Yl(e, t);
              for (const t of n) Kl(e, t);
              for (const t of n) Ql(e, t);
              for (const t of n) Zl(e, t), Jl(e, t);
              for (const t of n) Xl(e, t), ec(e, t), tc(e, t);
              this._compiledDefinitions = e;
            }
            _checkContextMatch(e, t, n = t.length - 1) {
              const o = t.getItem(n);
              if (e.allowIn.includes(o.name)) {
                if (0 == n) return !0;
                {
                  const e = this.getDefinition(o);
                  return this._checkContextMatch(e, t, n - 1);
                }
              }
              return !1;
            }
            *_getValidRangesForRange(e, t) {
              let n = e.start,
                o = e.start;
              for (const i of e.getItems({ shallow: !0 }))
                i.is('element') && (yield* this._getValidRangesForRange(Qa._createIn(i), t)),
                  this.checkAttribute(i, t) || (n.isEqual(o) || (yield new Qa(n, o)), (n = Ga._createAfter(i))),
                  (o = Ga._createAfter(i));
              n.isEqual(o) || (yield new Qa(n, o));
            }
          }
          class Gl {
            constructor(e) {
              if (e instanceof Gl) return e;
              let t;
              (t = 'string' == typeof e ? [e] : Array.isArray(e) ? e : e.getAncestors({ includeSelf: !0 })), (this._items = t.map(ic));
            }
            get length() {
              return this._items.length;
            }
            get last() {
              return this._items[this._items.length - 1];
            }
            [Symbol.iterator]() {
              return this._items[Symbol.iterator]();
            }
            push(e) {
              const t = new Gl([e]);
              return (t._items = [...this._items, ...t._items]), t;
            }
            getItem(e) {
              return this._items[e];
            }
            *getNames() {
              yield* this._items.map((e) => e.name);
            }
            endsWith(e) {
              return Array.from(this.getNames()).join(' ').endsWith(e);
            }
            startsWith(e) {
              return Array.from(this.getNames()).join(' ').startsWith(e);
            }
          }
          function $l(e, t) {
            const n = {
              name: t,
              allowIn: [],
              allowContentOf: [],
              allowWhere: [],
              allowAttributes: [],
              allowAttributesOf: [],
              allowChildren: [],
              inheritTypesFrom: [],
            };
            return (
              (function (e, t) {
                for (const n of e) {
                  const e = Object.keys(n).filter((e) => e.startsWith('is'));
                  for (const o of e) t[o] = !!n[o];
                }
              })(e, n),
              nc(e, n, 'allowIn'),
              nc(e, n, 'allowContentOf'),
              nc(e, n, 'allowWhere'),
              nc(e, n, 'allowAttributes'),
              nc(e, n, 'allowAttributesOf'),
              nc(e, n, 'allowChildren'),
              nc(e, n, 'inheritTypesFrom'),
              (function (e, t) {
                for (const n of e) {
                  const e = n.inheritAllFrom;
                  e && (t.allowContentOf.push(e), t.allowWhere.push(e), t.allowAttributesOf.push(e), t.inheritTypesFrom.push(e));
                }
              })(e, n),
              n
            );
          }
          function Yl(e, t) {
            const n = e[t];
            for (const o of n.allowChildren) {
              const n = e[o];
              n && n.allowIn.push(t);
            }
            n.allowChildren.length = 0;
          }
          function Kl(e, t) {
            for (const n of e[t].allowContentOf)
              if (e[n]) {
                oc(e, n).forEach((e) => {
                  e.allowIn.push(t);
                });
              }
            delete e[t].allowContentOf;
          }
          function Ql(e, t) {
            for (const n of e[t].allowWhere) {
              const o = e[n];
              if (o) {
                const n = o.allowIn;
                e[t].allowIn.push(...n);
              }
            }
            delete e[t].allowWhere;
          }
          function Zl(e, t) {
            for (const n of e[t].allowAttributesOf) {
              const o = e[n];
              if (o) {
                const n = o.allowAttributes;
                e[t].allowAttributes.push(...n);
              }
            }
            delete e[t].allowAttributesOf;
          }
          function Jl(e, t) {
            const n = e[t];
            for (const t of n.inheritTypesFrom) {
              const o = e[t];
              if (o) {
                const e = Object.keys(o).filter((e) => e.startsWith('is'));
                for (const t of e) t in n || (n[t] = o[t]);
              }
            }
            delete n.inheritTypesFrom;
          }
          function Xl(e, t) {
            const n = e[t],
              o = n.allowIn.filter((t) => e[t]);
            n.allowIn = Array.from(new Set(o));
          }
          function ec(e, t) {
            const n = e[t];
            for (const o of n.allowIn) {
              e[o].allowChildren.push(t);
            }
          }
          function tc(e, t) {
            const n = e[t];
            n.allowAttributes = Array.from(new Set(n.allowAttributes));
          }
          function nc(e, t, n) {
            for (const o of e) {
              const e = o[n];
              'string' == typeof e ? t[n].push(e) : Array.isArray(e) && t[n].push(...e);
            }
          }
          function oc(e, t) {
            const n = e[t];
            return ((o = e), Object.keys(o).map((e) => o[e])).filter((e) => e.allowIn.includes(n.name));
            var o;
          }
          function ic(e) {
            return 'string' == typeof e || e.is('documentFragment')
              ? { name: 'string' == typeof e ? e : '$documentFragment', *getAttributeKeys() {}, getAttribute() {} }
              : {
                  name: e.is('element') ? e.name : '$text',
                  *getAttributeKeys() {
                    yield* e.getAttributeKeys();
                  },
                  getAttribute: (t) => e.getAttribute(t),
                };
          }
          function rc(e, t, n) {
            for (const o of t.getAttributeKeys()) e.checkAttribute(t, o) || n.removeAttribute(o, t);
          }
          class sc extends b {
            constructor(e) {
              super(),
                (this._splitParts = new Map()),
                (this._cursorParents = new Map()),
                (this._modelCursor = null),
                (this._emptyElementsToKeep = new Set()),
                (this.conversionApi = {
                  ...e,
                  consumable: null,
                  writer: null,
                  store: null,
                  convertItem: (e, t) => this._convertItem(e, t),
                  convertChildren: (e, t) => this._convertChildren(e, t),
                  safeInsert: (e, t) => this._safeInsert(e, t),
                  updateConversionResult: (e, t) => this._updateConversionResult(e, t),
                  splitToAllowedParent: (e, t) => this._splitToAllowedParent(e, t),
                  getSplitParts: (e) => this._getSplitParts(e),
                  keepEmptyElement: (e) => this._keepEmptyElement(e),
                });
            }
            convert(e, t, n = ['$root']) {
              this.fire('viewCleanup', e),
                (this._modelCursor = (function (e, t) {
                  let n;
                  for (const o of new Gl(e)) {
                    const e = {};
                    for (const t of o.getAttributeKeys()) e[t] = o.getAttribute(t);
                    const i = t.createElement(o.name, e);
                    n && t.insert(i, n), (n = Ga._createAt(i, 0));
                  }
                  return n;
                })(n, t)),
                (this.conversionApi.writer = t),
                (this.conversionApi.consumable = Hl.createFrom(e)),
                (this.conversionApi.store = {});
              const { modelRange: o } = this._convertItem(e, this._modelCursor),
                i = t.createDocumentFragment();
              if (o) {
                this._removeEmptyElements();
                for (const e of Array.from(this._modelCursor.parent.getChildren())) t.append(e, i);
                i.markers = (function (e, t) {
                  const n = new Set(),
                    o = new Map(),
                    i = Qa._createIn(e).getItems();
                  for (const e of i) e.is('element', '$marker') && n.add(e);
                  for (const e of n) {
                    const n = e.getAttribute('data-name'),
                      i = t.createPositionBefore(e);
                    o.has(n) ? (o.get(n).end = i.clone()) : o.set(n, new Qa(i.clone())), t.remove(e);
                  }
                  return o;
                })(i, t);
              }
              return (
                (this._modelCursor = null),
                this._splitParts.clear(),
                this._cursorParents.clear(),
                this._emptyElementsToKeep.clear(),
                (this.conversionApi.writer = null),
                (this.conversionApi.store = null),
                i
              );
            }
            _convertItem(e, t) {
              const n = { viewItem: e, modelCursor: t, modelRange: null };
              if (
                (e.is('element')
                  ? this.fire(`element:${e.name}`, n, this.conversionApi)
                  : e.is('$text')
                  ? this.fire('text', n, this.conversionApi)
                  : this.fire('documentFragment', n, this.conversionApi),
                n.modelRange && !(n.modelRange instanceof Qa))
              )
                throw new l('view-conversion-dispatcher-incorrect-result', this);
              return { modelRange: n.modelRange, modelCursor: n.modelCursor };
            }
            _convertChildren(e, t) {
              let n = t.is('position') ? t : Ga._createAt(t, 0);
              const o = new Qa(n);
              for (const t of Array.from(e.getChildren())) {
                const e = this._convertItem(t, n);
                e.modelRange instanceof Qa && ((o.end = e.modelRange.end), (n = e.modelCursor));
              }
              return { modelRange: o, modelCursor: n };
            }
            _safeInsert(e, t) {
              const n = this._splitToAllowedParent(e, t);
              return !!n && (this.conversionApi.writer.insert(e, n.position), !0);
            }
            _updateConversionResult(e, t) {
              const n = this._getSplitParts(e),
                o = this.conversionApi.writer;
              t.modelRange || (t.modelRange = o.createRange(o.createPositionBefore(e), o.createPositionAfter(n[n.length - 1])));
              const i = this._cursorParents.get(e);
              t.modelCursor = i ? o.createPositionAt(i, 0) : t.modelRange.end;
            }
            _splitToAllowedParent(e, t) {
              const { schema: n, writer: o } = this.conversionApi;
              let i = n.findAllowedParent(t, e);
              if (i) {
                if (i === t.parent) return { position: t };
                this._modelCursor.parent.getAncestors().includes(i) && (i = null);
              }
              if (!i) return Ml(t, e, n) ? { position: Bl(t, o) } : null;
              const r = this.conversionApi.writer.split(t, i),
                s = [];
              for (const e of r.range.getWalker())
                if ('elementEnd' == e.type) s.push(e.item);
                else {
                  const t = s.pop(),
                    n = e.item;
                  this._registerSplitPair(t, n);
                }
              const a = r.range.end.parent;
              return this._cursorParents.set(e, a), { position: r.position, cursorParent: a };
            }
            _registerSplitPair(e, t) {
              this._splitParts.has(e) || this._splitParts.set(e, [e]);
              const n = this._splitParts.get(e);
              this._splitParts.set(t, n), n.push(t);
            }
            _getSplitParts(e) {
              let t;
              return (t = this._splitParts.has(e) ? this._splitParts.get(e) : [e]), t;
            }
            _keepEmptyElement(e) {
              this._emptyElementsToKeep.add(e);
            }
            _removeEmptyElements() {
              let e = !1;
              for (const t of this._splitParts.keys())
                t.isEmpty &&
                  !this._emptyElementsToKeep.has(t) &&
                  (this.conversionApi.writer.remove(t), this._splitParts.delete(t), (e = !0));
              e && this._removeEmptyElements();
            }
          }
          class ac {
            getHtml(e) {
              const t = document.implementation.createHTMLDocument('').createElement('div');
              return t.appendChild(e), t.innerHTML;
            }
          }
          class lc {
            constructor(e) {
              (this.domParser = new DOMParser()), (this.domConverter = new ms(e, { renderingMode: 'data' })), (this.htmlWriter = new ac());
            }
            toData(e) {
              const t = this.domConverter.viewToDom(e);
              return this.htmlWriter.getHtml(t);
            }
            toView(e) {
              const t = this._toDom(e);
              return this.domConverter.domToView(t);
            }
            registerRawContentMatcher(e) {
              this.domConverter.registerRawContentMatcher(e);
            }
            useFillerType(e) {
              this.domConverter.blockFillerMode = 'marked' == e ? 'markedNbsp' : 'nbsp';
            }
            _toDom(e) {
              e.match(/<(?:html|body|head|meta)(?:\s[^>]*)?>/i) || (e = `<body>${e}</body>`);
              const t = this.domParser.parseFromString(e, 'text/html'),
                n = t.createDocumentFragment(),
                o = t.body.childNodes;
              for (; o.length > 0; ) n.appendChild(o[0]);
              return n;
            }
          }
          class cc extends b {
            constructor(e, t) {
              super(),
                (this.model = e),
                (this.mapper = new Za()),
                (this.downcastDispatcher = new el({ mapper: this.mapper, schema: e.schema })),
                this.downcastDispatcher.on(
                  'insert:$text',
                  (e, t, n) => {
                    if (!n.consumable.consume(t.item, e.name)) return;
                    const o = n.writer,
                      i = n.mapper.toViewPosition(t.range.start),
                      r = o.createText(t.item.data);
                    o.insert(i, r);
                  },
                  { priority: 'lowest' }
                ),
                this.downcastDispatcher.on(
                  'insert',
                  (e, t, n) => {
                    n.convertAttributes(t.item), t.reconversion || !t.item.is('element') || t.item.isEmpty || n.convertChildren(t.item);
                  },
                  { priority: 'lowest' }
                ),
                (this.upcastDispatcher = new sc({ schema: e.schema })),
                (this.viewDocument = new er(t)),
                (this.stylesProcessor = t),
                (this.htmlProcessor = new lc(this.viewDocument)),
                (this.processor = this.htmlProcessor),
                (this._viewWriter = new vr(this.viewDocument)),
                this.upcastDispatcher.on(
                  'text',
                  (e, t, { schema: n, consumable: o, writer: i }) => {
                    let r = t.modelCursor;
                    if (!o.test(t.viewItem)) return;
                    if (!n.checkChild(r, '$text')) {
                      if (!Ml(r, '$text', n)) return;
                      if (0 == t.viewItem.data.trim().length) return;
                      r = Bl(r, i);
                    }
                    o.consume(t.viewItem);
                    const s = i.createText(t.viewItem.data);
                    i.insert(s, r), (t.modelRange = i.createRange(r, r.getShiftedBy(s.offsetSize))), (t.modelCursor = t.modelRange.end);
                  },
                  { priority: 'lowest' }
                ),
                this.upcastDispatcher.on(
                  'element',
                  (e, t, n) => {
                    if (!t.modelRange && n.consumable.consume(t.viewItem, { name: !0 })) {
                      const { modelRange: e, modelCursor: o } = n.convertChildren(t.viewItem, t.modelCursor);
                      (t.modelRange = e), (t.modelCursor = o);
                    }
                  },
                  { priority: 'lowest' }
                ),
                this.upcastDispatcher.on(
                  'documentFragment',
                  (e, t, n) => {
                    if (!t.modelRange && n.consumable.consume(t.viewItem, { name: !0 })) {
                      const { modelRange: e, modelCursor: o } = n.convertChildren(t.viewItem, t.modelCursor);
                      (t.modelRange = e), (t.modelCursor = o);
                    }
                  },
                  { priority: 'lowest' }
                ),
                N.prototype.decorate.call(this, 'init'),
                N.prototype.decorate.call(this, 'set'),
                N.prototype.decorate.call(this, 'get'),
                this.on(
                  'init',
                  () => {
                    this.fire('ready');
                  },
                  { priority: 'lowest' }
                ),
                this.on(
                  'ready',
                  () => {
                    this.model.enqueueChange({ isUndoable: !1 }, Sl);
                  },
                  { priority: 'lowest' }
                );
            }
            get(e = {}) {
              const { rootName: t = 'main', trim: n = 'empty' } = e;
              if (!this._checkIfRootsExists([t])) throw new l('datacontroller-get-non-existent-root', this);
              const o = this.model.document.getRoot(t);
              return 'empty' !== n || this.model.hasContent(o, { ignoreWhitespaces: !0 }) ? this.stringify(o, e) : '';
            }
            stringify(e, t = {}) {
              const n = this.toView(e, t);
              return this.processor.toData(n);
            }
            toView(e, t = {}) {
              const n = this.viewDocument,
                o = this._viewWriter;
              this.mapper.clearBindings();
              const i = Qa._createIn(e),
                r = new Cr(n);
              this.mapper.bindElements(e, r);
              const s = e.is('documentFragment')
                ? e.markers
                : (function (e) {
                    const t = [],
                      n = e.root.document;
                    if (!n) return new Map();
                    const o = Qa._createIn(e);
                    for (const e of n.model.markers) {
                      const n = e.getRange(),
                        i = n.isCollapsed,
                        r = n.start.isEqual(o.start) || n.end.isEqual(o.end);
                      if (i && r) t.push([e.name, n]);
                      else {
                        const i = o.getIntersection(n);
                        i && t.push([e.name, i]);
                      }
                    }
                    return (
                      t.sort(([e, t], [n, o]) => {
                        if ('after' !== t.end.compareWith(o.start)) return 1;
                        if ('before' !== t.start.compareWith(o.end)) return -1;
                        switch (t.start.compareWith(o.start)) {
                          case 'before':
                            return 1;
                          case 'after':
                            return -1;
                          default:
                            switch (t.end.compareWith(o.end)) {
                              case 'before':
                                return 1;
                              case 'after':
                                return -1;
                              default:
                                return n.localeCompare(e);
                            }
                        }
                      }),
                      new Map(t)
                    );
                  })(e);
              return this.downcastDispatcher.convert(i, s, o, t), r;
            }
            init(e) {
              if (this.model.document.version) throw new l('datacontroller-init-document-not-empty', this);
              let t = {};
              if (('string' == typeof e ? (t.main = e) : (t = e), !this._checkIfRootsExists(Object.keys(t))))
                throw new l('datacontroller-init-non-existent-root', this);
              return (
                this.model.enqueueChange({ isUndoable: !1 }, (e) => {
                  for (const n of Object.keys(t)) {
                    const o = this.model.document.getRoot(n);
                    e.insert(this.parse(t[n], o), o, 0);
                  }
                }),
                Promise.resolve()
              );
            }
            set(e, t = {}) {
              let n = {};
              if (('string' == typeof e ? (n.main = e) : (n = e), !this._checkIfRootsExists(Object.keys(n))))
                throw new l('datacontroller-set-non-existent-root', this);
              this.model.enqueueChange(t.batchType || {}, (e) => {
                e.setSelection(null), e.removeSelectionAttribute(this.model.document.selection.getAttributeKeys());
                for (const t of Object.keys(n)) {
                  const o = this.model.document.getRoot(t);
                  e.remove(e.createRangeIn(o)), e.insert(this.parse(n[t], o), o, 0);
                }
              });
            }
            parse(e, t = '$root') {
              const n = this.processor.toView(e);
              return this.toModel(n, t);
            }
            toModel(e, t = '$root') {
              return this.model.change((n) => this.upcastDispatcher.convert(e, n, t));
            }
            addStyleProcessorRules(e) {
              e(this.stylesProcessor);
            }
            registerRawContentMatcher(e) {
              this.processor && this.processor !== this.htmlProcessor && this.processor.registerRawContentMatcher(e),
                this.htmlProcessor.registerRawContentMatcher(e);
            }
            destroy() {
              this.stopListening();
            }
            _checkIfRootsExists(e) {
              for (const t of e) if (!this.model.document.getRootNames().includes(t)) return !1;
              return !0;
            }
          }
          class dc {
            constructor(e, t) {
              (this._helpers = new Map()),
                (this._downcast = bo(e)),
                this._createConversionHelpers({ name: 'downcast', dispatchers: this._downcast, isDowncast: !0 }),
                (this._upcast = bo(t)),
                this._createConversionHelpers({ name: 'upcast', dispatchers: this._upcast, isDowncast: !1 });
            }
            addAlias(e, t) {
              const n = this._downcast.includes(t);
              if (!this._upcast.includes(t) && !n) throw new l('conversion-add-alias-dispatcher-not-registered', this);
              this._createConversionHelpers({ name: e, dispatchers: [t], isDowncast: n });
            }
            for(e) {
              if (!this._helpers.has(e)) throw new l('conversion-for-unknown-group', this);
              return this._helpers.get(e);
            }
            elementToElement(e) {
              this.for('downcast').elementToElement(e);
              for (const { model: t, view: n } of uc(e))
                this.for('upcast').elementToElement({ model: t, view: n, converterPriority: e.converterPriority });
            }
            attributeToElement(e) {
              this.for('downcast').attributeToElement(e);
              for (const { model: t, view: n } of uc(e))
                this.for('upcast').elementToAttribute({ view: n, model: t, converterPriority: e.converterPriority });
            }
            attributeToAttribute(e) {
              this.for('downcast').attributeToAttribute(e);
              for (const { model: t, view: n } of uc(e)) this.for('upcast').attributeToAttribute({ view: n, model: t });
            }
            _createConversionHelpers({ name: e, dispatchers: t, isDowncast: n }) {
              if (this._helpers.has(e)) throw new l('conversion-group-exists', this);
              const o = n ? new kl(t) : new Nl(t);
              this._helpers.set(e, o);
            }
          }
          function* uc(e) {
            if (e.model.values)
              for (const t of e.model.values) {
                const n = { key: e.model.key, value: t },
                  o = e.view[t],
                  i = e.upcastAlso ? e.upcastAlso[t] : void 0;
                yield* hc(n, o, i);
              }
            else yield* hc(e.model, e.view, e.upcastAlso);
          }
          function* hc(e, t, n) {
            if ((yield { model: e, view: t }, n)) for (const t of bo(n)) yield { model: e, view: t };
          }
          class mc {
            constructor(e = {}) {
              'string' == typeof e && ((e = 'transparent' === e ? { isUndoable: !1 } : {}), c('batch-constructor-deprecated-string-type'));
              const { isUndoable: t = !0, isLocal: n = !0, isUndo: o = !1, isTyping: i = !1 } = e;
              (this.operations = []), (this.isUndoable = t), (this.isLocal = n), (this.isUndo = o), (this.isTyping = i);
            }
            get type() {
              return c('batch-type-deprecated'), 'default';
            }
            get baseVersion() {
              for (const e of this.operations) if (null !== e.baseVersion) return e.baseVersion;
              return null;
            }
            addOperation(e) {
              return (e.batch = this), this.operations.push(e), e;
            }
          }
          class gc {
            constructor(e) {
              (this._markerCollection = e),
                (this._changesInElement = new Map()),
                (this._elementSnapshots = new Map()),
                (this._changedMarkers = new Map()),
                (this._changeCount = 0),
                (this._cachedChanges = null),
                (this._cachedChangesWithGraveyard = null),
                (this._refreshedItems = new Set());
            }
            get isEmpty() {
              return 0 == this._changesInElement.size && 0 == this._changedMarkers.size;
            }
            bufferOperation(e) {
              const t = e;
              switch (t.type) {
                case 'insert':
                  if (this._isInInsertedElement(t.position.parent)) return;
                  this._markInsert(t.position.parent, t.position.offset, t.nodes.maxOffset);
                  break;
                case 'addAttribute':
                case 'removeAttribute':
                case 'changeAttribute':
                  for (const e of t.range.getItems({ shallow: !0 })) this._isInInsertedElement(e.parent) || this._markAttribute(e);
                  break;
                case 'remove':
                case 'move':
                case 'reinsert': {
                  if (t.sourcePosition.isEqual(t.targetPosition) || t.sourcePosition.getShiftedBy(t.howMany).isEqual(t.targetPosition))
                    return;
                  const e = this._isInInsertedElement(t.sourcePosition.parent),
                    n = this._isInInsertedElement(t.targetPosition.parent);
                  e || this._markRemove(t.sourcePosition.parent, t.sourcePosition.offset, t.howMany),
                    n || this._markInsert(t.targetPosition.parent, t.getMovedRangeStart().offset, t.howMany);
                  break;
                }
                case 'rename': {
                  if (this._isInInsertedElement(t.position.parent)) return;
                  this._markRemove(t.position.parent, t.position.offset, 1), this._markInsert(t.position.parent, t.position.offset, 1);
                  const e = Qa._createFromPositionAndShift(t.position, 1);
                  for (const t of this._markerCollection.getMarkersIntersectingRange(e)) {
                    const e = t.getData();
                    this.bufferMarkerChange(t.name, e, e);
                  }
                  break;
                }
                case 'split': {
                  const e = t.splitPosition.parent;
                  this._isInInsertedElement(e) || this._markRemove(e, t.splitPosition.offset, t.howMany),
                    this._isInInsertedElement(t.insertionPosition.parent) ||
                      this._markInsert(t.insertionPosition.parent, t.insertionPosition.offset, 1),
                    t.graveyardPosition && this._markRemove(t.graveyardPosition.parent, t.graveyardPosition.offset, 1);
                  break;
                }
                case 'merge': {
                  const e = t.sourcePosition.parent;
                  this._isInInsertedElement(e.parent) || this._markRemove(e.parent, e.startOffset, 1);
                  const n = t.graveyardPosition.parent;
                  this._markInsert(n, t.graveyardPosition.offset, 1);
                  const o = t.targetPosition.parent;
                  this._isInInsertedElement(o) || this._markInsert(o, t.targetPosition.offset, e.maxOffset);
                  break;
                }
              }
              this._cachedChanges = null;
            }
            bufferMarkerChange(e, t, n) {
              const o = this._changedMarkers.get(e);
              o
                ? ((o.newMarkerData = n), null == o.oldMarkerData.range && null == n.range && this._changedMarkers.delete(e))
                : this._changedMarkers.set(e, { newMarkerData: n, oldMarkerData: t });
            }
            getMarkersToRemove() {
              const e = [];
              for (const [t, n] of this._changedMarkers) null != n.oldMarkerData.range && e.push({ name: t, range: n.oldMarkerData.range });
              return e;
            }
            getMarkersToAdd() {
              const e = [];
              for (const [t, n] of this._changedMarkers) null != n.newMarkerData.range && e.push({ name: t, range: n.newMarkerData.range });
              return e;
            }
            getChangedMarkers() {
              return Array.from(this._changedMarkers).map(([e, t]) => ({
                name: e,
                data: { oldRange: t.oldMarkerData.range, newRange: t.newMarkerData.range },
              }));
            }
            hasDataChanges() {
              if (this._changesInElement.size > 0) return !0;
              for (const { newMarkerData: e, oldMarkerData: t } of this._changedMarkers.values()) {
                if (e.affectsData !== t.affectsData) return !0;
                if (e.affectsData) {
                  const n = e.range && !t.range,
                    o = !e.range && t.range,
                    i = e.range && t.range && !e.range.isEqual(t.range);
                  if (n || o || i) return !0;
                }
              }
              return !1;
            }
            getChanges(e = {}) {
              if (this._cachedChanges)
                return e.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
              let t = [];
              for (const e of this._changesInElement.keys()) {
                const n = this._changesInElement
                    .get(e)
                    .sort((e, t) =>
                      e.offset === t.offset ? (e.type != t.type ? ('remove' == e.type ? -1 : 1) : 0) : e.offset < t.offset ? -1 : 1
                    ),
                  o = this._elementSnapshots.get(e),
                  i = pc(e.getChildren()),
                  r = fc(o.length, n);
                let s = 0,
                  a = 0;
                for (const n of r)
                  if ('i' === n) t.push(this._getInsertDiff(e, s, i[s])), s++;
                  else if ('r' === n) t.push(this._getRemoveDiff(e, s, o[a])), a++;
                  else if ('a' === n) {
                    const n = i[s].attributes,
                      r = o[a].attributes;
                    let l;
                    if ('$text' == i[s].name) l = new Qa(Ga._createAt(e, s), Ga._createAt(e, s + 1));
                    else {
                      const t = e.offsetToIndex(s);
                      l = new Qa(Ga._createAt(e, s), Ga._createAt(e.getChild(t), 0));
                    }
                    t.push(...this._getAttributesDiff(l, r, n)), s++, a++;
                  } else s++, a++;
              }
              t.sort((e, t) =>
                e.position.root != t.position.root
                  ? e.position.root.rootName < t.position.root.rootName
                    ? -1
                    : 1
                  : e.position.isEqual(t.position)
                  ? e.changeCount - t.changeCount
                  : e.position.isBefore(t.position)
                  ? -1
                  : 1
              );
              for (let e = 1, n = 0; e < t.length; e++) {
                const o = t[n],
                  i = t[e],
                  r = 'remove' == o.type && 'remove' == i.type && '$text' == o.name && '$text' == i.name && o.position.isEqual(i.position),
                  s =
                    'insert' == o.type &&
                    'insert' == i.type &&
                    '$text' == o.name &&
                    '$text' == i.name &&
                    o.position.parent == i.position.parent &&
                    o.position.offset + o.length == i.position.offset,
                  a =
                    'attribute' == o.type &&
                    'attribute' == i.type &&
                    o.position.parent == i.position.parent &&
                    o.range.isFlat &&
                    i.range.isFlat &&
                    o.position.offset + o.length == i.position.offset &&
                    o.attributeKey == i.attributeKey &&
                    o.attributeOldValue == i.attributeOldValue &&
                    o.attributeNewValue == i.attributeNewValue;
                r || s || a ? (o.length++, a && (o.range.end = o.range.end.getShiftedBy(1)), (t[e] = null)) : (n = e);
              }
              t = t.filter((e) => e);
              for (const e of t) delete e.changeCount, 'attribute' == e.type && (delete e.position, delete e.length);
              return (
                (this._changeCount = 0),
                (this._cachedChangesWithGraveyard = t),
                (this._cachedChanges = t.filter(kc)),
                e.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice()
              );
            }
            getRefreshedItems() {
              return new Set(this._refreshedItems);
            }
            reset() {
              this._changesInElement.clear(),
                this._elementSnapshots.clear(),
                this._changedMarkers.clear(),
                (this._refreshedItems = new Set()),
                (this._cachedChanges = null);
            }
            _refreshItem(e) {
              if (this._isInInsertedElement(e.parent)) return;
              this._markRemove(e.parent, e.startOffset, e.offsetSize),
                this._markInsert(e.parent, e.startOffset, e.offsetSize),
                this._refreshedItems.add(e);
              const t = Qa._createOn(e);
              for (const e of this._markerCollection.getMarkersIntersectingRange(t)) {
                const t = e.getData();
                this.bufferMarkerChange(e.name, t, t);
              }
              this._cachedChanges = null;
            }
            _markInsert(e, t, n) {
              const o = { type: 'insert', offset: t, howMany: n, count: this._changeCount++ };
              this._markChange(e, o);
            }
            _markRemove(e, t, n) {
              const o = { type: 'remove', offset: t, howMany: n, count: this._changeCount++ };
              this._markChange(e, o), this._removeAllNestedChanges(e, t, n);
            }
            _markAttribute(e) {
              const t = { type: 'attribute', offset: e.startOffset, howMany: e.offsetSize, count: this._changeCount++ };
              this._markChange(e.parent, t);
            }
            _markChange(e, t) {
              this._makeSnapshot(e);
              const n = this._getChangesForElement(e);
              this._handleChange(t, n), n.push(t);
              for (let e = 0; e < n.length; e++) n[e].howMany < 1 && (n.splice(e, 1), e--);
            }
            _getChangesForElement(e) {
              let t;
              return this._changesInElement.has(e) ? (t = this._changesInElement.get(e)) : ((t = []), this._changesInElement.set(e, t)), t;
            }
            _makeSnapshot(e) {
              this._elementSnapshots.has(e) || this._elementSnapshots.set(e, pc(e.getChildren()));
            }
            _handleChange(e, t) {
              e.nodesToHandle = e.howMany;
              for (const n of t) {
                const o = e.offset + e.howMany,
                  i = n.offset + n.howMany;
                if (
                  'insert' == e.type &&
                  ('insert' == n.type &&
                    (e.offset <= n.offset
                      ? (n.offset += e.howMany)
                      : e.offset < i && ((n.howMany += e.nodesToHandle), (e.nodesToHandle = 0))),
                  'remove' == n.type && e.offset < n.offset && (n.offset += e.howMany),
                  'attribute' == n.type)
                )
                  if (e.offset <= n.offset) n.offset += e.howMany;
                  else if (e.offset < i) {
                    const i = n.howMany;
                    (n.howMany = e.offset - n.offset),
                      t.unshift({ type: 'attribute', offset: o, howMany: i - n.howMany, count: this._changeCount++ });
                  }
                if ('remove' == e.type) {
                  if ('insert' == n.type)
                    if (o <= n.offset) n.offset -= e.howMany;
                    else if (o <= i)
                      if (e.offset < n.offset) {
                        const t = o - n.offset;
                        (n.offset = e.offset), (n.howMany -= t), (e.nodesToHandle -= t);
                      } else (n.howMany -= e.nodesToHandle), (e.nodesToHandle = 0);
                    else if (e.offset <= n.offset) (e.nodesToHandle -= n.howMany), (n.howMany = 0);
                    else if (e.offset < i) {
                      const t = i - e.offset;
                      (n.howMany -= t), (e.nodesToHandle -= t);
                    }
                  if (
                    ('remove' == n.type &&
                      (o <= n.offset ? (n.offset -= e.howMany) : e.offset < n.offset && ((e.nodesToHandle += n.howMany), (n.howMany = 0))),
                    'attribute' == n.type)
                  )
                    if (o <= n.offset) n.offset -= e.howMany;
                    else if (e.offset < n.offset) {
                      const t = o - n.offset;
                      (n.offset = e.offset), (n.howMany -= t);
                    } else if (e.offset < i)
                      if (o <= i) {
                        const o = n.howMany;
                        n.howMany = e.offset - n.offset;
                        const i = o - n.howMany - e.nodesToHandle;
                        t.unshift({ type: 'attribute', offset: e.offset, howMany: i, count: this._changeCount++ });
                      } else n.howMany -= i - e.offset;
                }
                if ('attribute' == e.type) {
                  if ('insert' == n.type)
                    if (e.offset < n.offset && o > n.offset) {
                      if (o > i) {
                        const e = { type: 'attribute', offset: i, howMany: o - i, count: this._changeCount++ };
                        this._handleChange(e, t), t.push(e);
                      }
                      (e.nodesToHandle = n.offset - e.offset), (e.howMany = e.nodesToHandle);
                    } else
                      e.offset >= n.offset && e.offset < i && (o > i ? ((e.nodesToHandle = o - i), (e.offset = i)) : (e.nodesToHandle = 0));
                  if ('remove' == n.type && e.offset < n.offset && o > n.offset) {
                    const i = { type: 'attribute', offset: n.offset, howMany: o - n.offset, count: this._changeCount++ };
                    this._handleChange(i, t), t.push(i), (e.nodesToHandle = n.offset - e.offset), (e.howMany = e.nodesToHandle);
                  }
                  'attribute' == n.type &&
                    (e.offset >= n.offset && o <= i
                      ? ((e.nodesToHandle = 0), (e.howMany = 0), (e.offset = 0))
                      : e.offset <= n.offset && o >= i && (n.howMany = 0));
                }
              }
              (e.howMany = e.nodesToHandle), delete e.nodesToHandle;
            }
            _getInsertDiff(e, t, n) {
              return {
                type: 'insert',
                position: Ga._createAt(e, t),
                name: n.name,
                attributes: new Map(n.attributes),
                length: 1,
                changeCount: this._changeCount++,
              };
            }
            _getRemoveDiff(e, t, n) {
              return {
                type: 'remove',
                position: Ga._createAt(e, t),
                name: n.name,
                attributes: new Map(n.attributes),
                length: 1,
                changeCount: this._changeCount++,
              };
            }
            _getAttributesDiff(e, t, n) {
              const o = [];
              n = new Map(n);
              for (const [i, r] of t) {
                const t = n.has(i) ? n.get(i) : null;
                t !== r &&
                  o.push({
                    type: 'attribute',
                    position: e.start,
                    range: e.clone(),
                    length: 1,
                    attributeKey: i,
                    attributeOldValue: r,
                    attributeNewValue: t,
                    changeCount: this._changeCount++,
                  }),
                  n.delete(i);
              }
              for (const [t, i] of n)
                o.push({
                  type: 'attribute',
                  position: e.start,
                  range: e.clone(),
                  length: 1,
                  attributeKey: t,
                  attributeOldValue: null,
                  attributeNewValue: i,
                  changeCount: this._changeCount++,
                });
              return o;
            }
            _isInInsertedElement(e) {
              const t = e.parent;
              if (!t) return !1;
              const n = this._changesInElement.get(t),
                o = e.startOffset;
              if (n) for (const e of n) if ('insert' == e.type && o >= e.offset && o < e.offset + e.howMany) return !0;
              return this._isInInsertedElement(t);
            }
            _removeAllNestedChanges(e, t, n) {
              const o = new Qa(Ga._createAt(e, t), Ga._createAt(e, t + n));
              for (const e of o.getItems({ shallow: !0 }))
                e.is('element') &&
                  (this._elementSnapshots.delete(e), this._changesInElement.delete(e), this._removeAllNestedChanges(e, 0, e.maxOffset));
            }
          }
          function pc(e) {
            const t = [];
            for (const n of e)
              if (n.is('$text')) for (let e = 0; e < n.data.length; e++) t.push({ name: '$text', attributes: new Map(n.getAttributes()) });
              else t.push({ name: n.name, attributes: new Map(n.getAttributes()) });
            return t;
          }
          function fc(e, t) {
            const n = [];
            let o = 0,
              i = 0;
            for (const e of t) {
              if (e.offset > o) {
                for (let t = 0; t < e.offset - o; t++) n.push('e');
                i += e.offset - o;
              }
              if ('insert' == e.type) {
                for (let t = 0; t < e.howMany; t++) n.push('i');
                o = e.offset + e.howMany;
              } else if ('remove' == e.type) {
                for (let t = 0; t < e.howMany; t++) n.push('r');
                (o = e.offset), (i += e.howMany);
              } else n.push(...'a'.repeat(e.howMany).split('')), (o = e.offset + e.howMany), (i += e.howMany);
            }
            if (i < e) for (let t = 0; t < e - i - o; t++) n.push('e');
            return n;
          }
          function kc(e) {
            const t = 'position' in e && '$graveyard' == e.position.root.rootName,
              n = 'range' in e && '$graveyard' == e.range.root.rootName;
            return !t && !n;
          }
          class bc {
            constructor() {
              (this._operations = []),
                (this._undoPairs = new Map()),
                (this._undoneOperations = new Set()),
                (this._baseVersionToOperationIndex = new Map()),
                (this._version = 0),
                (this._gaps = new Map());
            }
            get version() {
              return this._version;
            }
            set version(e) {
              this._operations.length && e > this._version + 1 && this._gaps.set(this._version, e), (this._version = e);
            }
            get lastOperation() {
              return this._operations[this._operations.length - 1];
            }
            addOperation(e) {
              if (e.baseVersion !== this.version)
                throw new l('model-document-history-addoperation-incorrect-version', this, { operation: e, historyVersion: this.version });
              this._operations.push(e), this._version++, this._baseVersionToOperationIndex.set(e.baseVersion, this._operations.length - 1);
            }
            getOperations(e, t = this.version) {
              if (!this._operations.length) return [];
              const n = this._operations[0];
              void 0 === e && (e = n.baseVersion);
              let o = t - 1;
              for (const [t, n] of this._gaps) e > t && e < n && (e = n), o > t && o < n && (o = t - 1);
              if (o < n.baseVersion || e > this.lastOperation.baseVersion) return [];
              let i = this._baseVersionToOperationIndex.get(e);
              void 0 === i && (i = 0);
              let r = this._baseVersionToOperationIndex.get(o);
              return void 0 === r && (r = this._operations.length - 1), this._operations.slice(i, r + 1);
            }
            getOperation(e) {
              const t = this._baseVersionToOperationIndex.get(e);
              if (void 0 !== t) return this._operations[t];
            }
            setOperationAsUndone(e, t) {
              this._undoPairs.set(t, e), this._undoneOperations.add(e);
            }
            isUndoingOperation(e) {
              return this._undoPairs.has(e);
            }
            isUndoneOperation(e) {
              return this._undoneOperations.has(e);
            }
            getUndoneOperation(e) {
              return this._undoPairs.get(e);
            }
            reset() {
              (this._version = 0),
                (this._undoPairs = new Map()),
                (this._operations = []),
                (this._undoneOperations = new Set()),
                (this._gaps = new Map()),
                (this._baseVersionToOperationIndex = new Map());
            }
          }
          class wc extends Ua {
            constructor(e, t, n = 'main') {
              super(t), (this._document = e), (this.rootName = n);
            }
            get document() {
              return this._document;
            }
            toJSON() {
              return this.rootName;
            }
          }
          function _c(e, t) {
            return (
              !!(n = e.charAt(t - 1)) &&
              1 == n.length &&
              /[\ud800-\udbff]/.test(n) &&
              (function (e) {
                return !!e && 1 == e.length && /[\udc00-\udfff]/.test(e);
              })(e.charAt(t))
            );
            var n;
          }
          function yc(e, t) {
            return !!(n = e.charAt(t)) && 1 == n.length && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(n);
            var n;
          }
          wc.prototype.is = function (e, t) {
            return t
              ? t === this.name && ('rootElement' === e || 'model:rootElement' === e || 'element' === e || 'model:element' === e)
              : 'rootElement' === e ||
                  'model:rootElement' === e ||
                  'element' === e ||
                  'model:element' === e ||
                  'node' === e ||
                  'model:node' === e;
          };
          const Ac = (function () {
            const e = /\p{Regional_Indicator}{2}/u.source,
              t =
                '(?:' +
                [
                  /\p{Emoji}[\u{E0020}-\u{E007E}]+\u{E007F}/u,
                  /\p{Emoji}\u{FE0F}?\u{20E3}/u,
                  /\p{Emoji}\u{FE0F}/u,
                  /(?=\p{General_Category=Other_Symbol})\p{Emoji}\p{Emoji_Modifier}*/u,
                ]
                  .map((e) => e.source)
                  .join('|') +
                ')';
            return new RegExp(`${e}|${t}(?:‍${t})*`, 'ug');
          })();
          function Cc(e, t) {
            const n = String(e).matchAll(Ac);
            return Array.from(n).some((e) => e.index < t && t < e.index + e[0].length);
          }
          const vc = '$graveyard';
          class xc extends b {
            constructor(e) {
              super(),
                (this.model = e),
                (this.history = new bc()),
                (this.selection = new hl(this)),
                (this.roots = new fo({ idProperty: 'rootName' })),
                (this.differ = new gc(e.markers)),
                (this._postFixers = new Set()),
                (this._hasSelectionChangedFromTheLastChangeBlock = !1),
                this.createRoot('$root', vc),
                this.listenTo(
                  e,
                  'applyOperation',
                  (e, t) => {
                    const n = t[0];
                    n.isDocumentOperation && this.differ.bufferOperation(n);
                  },
                  { priority: 'high' }
                ),
                this.listenTo(
                  e,
                  'applyOperation',
                  (e, t) => {
                    const n = t[0];
                    n.isDocumentOperation && this.history.addOperation(n);
                  },
                  { priority: 'low' }
                ),
                this.listenTo(this.selection, 'change', () => {
                  this._hasSelectionChangedFromTheLastChangeBlock = !0;
                }),
                this.listenTo(e.markers, 'update', (e, t, n, o, i) => {
                  const r = { ...t.getData(), range: o };
                  this.differ.bufferMarkerChange(t.name, i, r),
                    null === n &&
                      t.on('change', (e, n) => {
                        const o = t.getData();
                        this.differ.bufferMarkerChange(t.name, { ...o, range: n }, o);
                      });
                });
            }
            get version() {
              return this.history.version;
            }
            set version(e) {
              this.history.version = e;
            }
            get graveyard() {
              return this.getRoot(vc);
            }
            createRoot(e = '$root', t = 'main') {
              if (this.roots.get(t)) throw new l('model-document-createroot-name-exists', this, { name: t });
              const n = new wc(this, e, t);
              return this.roots.add(n), n;
            }
            destroy() {
              this.selection.destroy(), this.stopListening();
            }
            getRoot(e = 'main') {
              return this.roots.get(e);
            }
            getRootNames() {
              return Array.from(this.roots, (e) => e.rootName).filter((e) => e != vc);
            }
            registerPostFixer(e) {
              this._postFixers.add(e);
            }
            toJSON() {
              const e = Io(this);
              return (e.selection = '[engine.model.DocumentSelection]'), (e.model = '[engine.model.Model]'), e;
            }
            _handleChangeBlock(e) {
              this._hasDocumentChangedFromTheLastChangeBlock() &&
                (this._callPostFixers(e),
                this.selection.refresh(),
                this.differ.hasDataChanges() ? this.fire('change:data', e.batch) : this.fire('change', e.batch),
                this.selection.refresh(),
                this.differ.reset()),
                (this._hasSelectionChangedFromTheLastChangeBlock = !1);
            }
            _hasDocumentChangedFromTheLastChangeBlock() {
              return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock;
            }
            _getDefaultRoot() {
              for (const e of this.roots) if (e !== this.graveyard) return e;
              return this.graveyard;
            }
            _getDefaultRange() {
              const e = this._getDefaultRoot(),
                t = this.model,
                n = t.schema,
                o = t.createPositionFromPath(e, [0]);
              return n.getNearestSelectionRange(o) || t.createRange(o);
            }
            _validateSelectionRange(e) {
              return Ec(e.start) && Ec(e.end);
            }
            _callPostFixers(e) {
              let t = !1;
              do {
                for (const n of this._postFixers) if ((this.selection.refresh(), (t = n(e)), t)) break;
              } while (t);
            }
          }
          function Ec(e) {
            const t = e.textNode;
            if (t) {
              const n = t.data,
                o = e.offset - t.startOffset;
              return !_c(n, o) && !yc(n, o);
            }
            return !0;
          }
          class Dc extends b {
            constructor() {
              super(), (this._markers = new Map());
            }
            [Symbol.iterator]() {
              return this._markers.values();
            }
            has(e) {
              const t = e instanceof Tc ? e.name : e;
              return this._markers.has(t);
            }
            get(e) {
              return this._markers.get(e) || null;
            }
            _set(e, t, n = !1, o = !1) {
              const i = e instanceof Tc ? e.name : e;
              if (i.includes(',')) throw new l('markercollection-incorrect-marker-name', this);
              const r = this._markers.get(i);
              if (r) {
                const e = r.getData(),
                  s = r.getRange();
                let a = !1;
                return (
                  s.isEqual(t) || (r._attachLiveRange(ll.fromRange(t)), (a = !0)),
                  n != r.managedUsingOperations && ((r._managedUsingOperations = n), (a = !0)),
                  'boolean' == typeof o && o != r.affectsData && ((r._affectsData = o), (a = !0)),
                  a && this.fire(`update:${i}`, r, s, t, e),
                  r
                );
              }
              const s = ll.fromRange(t),
                a = new Tc(i, s, n, o);
              return this._markers.set(i, a), this.fire(`update:${i}`, a, null, t, { ...a.getData(), range: null }), a;
            }
            _remove(e) {
              const t = e instanceof Tc ? e.name : e,
                n = this._markers.get(t);
              return (
                !!n && (this._markers.delete(t), this.fire(`update:${t}`, n, n.getRange(), null, n.getData()), this._destroyMarker(n), !0)
              );
            }
            _refresh(e) {
              const t = e instanceof Tc ? e.name : e,
                n = this._markers.get(t);
              if (!n) throw new l('markercollection-refresh-marker-not-exists', this);
              const o = n.getRange();
              this.fire(`update:${t}`, n, o, o, n.getData());
            }
            *getMarkersAtPosition(e) {
              for (const t of this) t.getRange().containsPosition(e) && (yield t);
            }
            *getMarkersIntersectingRange(e) {
              for (const t of this) null !== t.getRange().getIntersection(e) && (yield t);
            }
            destroy() {
              for (const e of this._markers.values()) this._destroyMarker(e);
              (this._markers = null), this.stopListening();
            }
            *getMarkersGroup(e) {
              for (const t of this._markers.values()) t.name.startsWith(e + ':') && (yield t);
            }
            _destroyMarker(e) {
              e.stopListening(), e._detachLiveRange();
            }
          }
          class Tc extends k(Oa) {
            constructor(e, t, n, o) {
              super(),
                (this.name = e),
                (this._liveRange = this._attachLiveRange(t)),
                (this._managedUsingOperations = n),
                (this._affectsData = o);
            }
            get managedUsingOperations() {
              if (!this._liveRange) throw new l('marker-destroyed', this);
              return this._managedUsingOperations;
            }
            get affectsData() {
              if (!this._liveRange) throw new l('marker-destroyed', this);
              return this._affectsData;
            }
            getData() {
              return { range: this.getRange(), affectsData: this.affectsData, managedUsingOperations: this.managedUsingOperations };
            }
            getStart() {
              if (!this._liveRange) throw new l('marker-destroyed', this);
              return this._liveRange.start.clone();
            }
            getEnd() {
              if (!this._liveRange) throw new l('marker-destroyed', this);
              return this._liveRange.end.clone();
            }
            getRange() {
              if (!this._liveRange) throw new l('marker-destroyed', this);
              return this._liveRange.toRange();
            }
            _attachLiveRange(e) {
              return (
                this._liveRange && this._detachLiveRange(),
                e.delegate('change:range').to(this),
                e.delegate('change:content').to(this),
                (this._liveRange = e),
                e
              );
            }
            _detachLiveRange() {
              this._liveRange.stopDelegating('change:range', this),
                this._liveRange.stopDelegating('change:content', this),
                this._liveRange.detach(),
                (this._liveRange = null);
            }
          }
          Tc.prototype.is = function (e) {
            return 'marker' === e || 'model:marker' === e;
          };
          class Ic {
            constructor(e) {
              (this.baseVersion = e), (this.isDocumentOperation = null !== this.baseVersion), (this.batch = null);
            }
            _validate() {}
            toJSON() {
              const e = Object.assign({}, this);
              return (e.__className = this.constructor.className), delete e.batch, delete e.isDocumentOperation, e;
            }
            static get className() {
              return 'Operation';
            }
            static fromJSON(e, t) {
              return new this(e.baseVersion);
            }
          }
          function Sc(e, t) {
            const n = Nc(t),
              o = n.reduce((e, t) => e + t.offsetSize, 0),
              i = e.parent;
            zc(e);
            const r = e.index;
            return i._insertChild(r, n), Pc(i, r + n.length), Pc(i, r), new Qa(e, e.getShiftedBy(o));
          }
          function Mc(e) {
            if (!e.isFlat) throw new l('operation-utils-remove-range-not-flat', this);
            const t = e.start.parent;
            zc(e.start), zc(e.end);
            const n = t._removeChildren(e.start.index, e.end.index - e.start.index);
            return Pc(t, e.start.index), n;
          }
          function Bc(e, t) {
            if (!e.isFlat) throw new l('operation-utils-move-range-not-flat', this);
            const n = Mc(e);
            return Sc((t = t._getTransformedByDeletion(e.start, e.end.offset - e.start.offset)), n);
          }
          function Nc(e) {
            const t = [];
            !(function e(n) {
              if ('string' == typeof n) t.push(new Fa(n));
              else if (n instanceof Ha) t.push(new Fa(n.data, n.getAttributes()));
              else if (n instanceof Ra) t.push(n);
              else if (po(n)) for (const t of n) e(t);
            })(e);
            for (let e = 1; e < t.length; e++) {
              const n = t[e],
                o = t[e - 1];
              n instanceof Fa && o instanceof Fa && Lc(n, o) && (t.splice(e - 1, 2, new Fa(o.data + n.data, o.getAttributes())), e--);
            }
            return t;
          }
          function Pc(e, t) {
            const n = e.getChild(t - 1),
              o = e.getChild(t);
            if (n && o && n.is('$text') && o.is('$text') && Lc(n, o)) {
              const i = new Fa(n.data + o.data, n.getAttributes());
              e._removeChildren(t - 1, 2), e._insertChild(t - 1, i);
            }
          }
          function zc(e) {
            const t = e.textNode,
              n = e.parent;
            if (t) {
              const o = e.offset - t.startOffset,
                i = t.index;
              n._removeChildren(i, 1);
              const r = new Fa(t.data.substr(0, o), t.getAttributes()),
                s = new Fa(t.data.substr(o), t.getAttributes());
              n._insertChild(i, [r, s]);
            }
          }
          function Lc(e, t) {
            const n = e.getAttributes(),
              o = t.getAttributes();
            for (const e of n) {
              if (e[1] !== t.getAttribute(e[0])) return !1;
              o.next();
            }
            return o.next().done;
          }
          const jc = function (e, t) {
            return Hs(e, t);
          };
          class Oc extends Ic {
            constructor(e, t, n, o, i) {
              super(i),
                (this.range = e.clone()),
                (this.key = t),
                (this.oldValue = void 0 === n ? null : n),
                (this.newValue = void 0 === o ? null : o);
            }
            get type() {
              return null === this.oldValue ? 'addAttribute' : null === this.newValue ? 'removeAttribute' : 'changeAttribute';
            }
            clone() {
              return new Oc(this.range, this.key, this.oldValue, this.newValue, this.baseVersion);
            }
            getReversed() {
              return new Oc(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
            }
            toJSON() {
              const e = super.toJSON();
              return (e.range = this.range.toJSON()), e;
            }
            _validate() {
              if (!this.range.isFlat) throw new l('attribute-operation-range-not-flat', this);
              for (const e of this.range.getItems({ shallow: !0 })) {
                if (null !== this.oldValue && !jc(e.getAttribute(this.key), this.oldValue))
                  throw new l('attribute-operation-wrong-old-value', this, { item: e, key: this.key, value: this.oldValue });
                if (null === this.oldValue && null !== this.newValue && e.hasAttribute(this.key))
                  throw new l('attribute-operation-attribute-exists', this, { node: e, key: this.key });
              }
            }
            _execute() {
              jc(this.oldValue, this.newValue) ||
                (function (e, t, n) {
                  zc(e.start), zc(e.end);
                  for (const o of e.getItems({ shallow: !0 })) {
                    const e = o.is('$textProxy') ? o.textNode : o;
                    null !== n ? e._setAttribute(t, n) : e._removeAttribute(t), Pc(e.parent, e.index);
                  }
                  Pc(e.end.parent, e.end.index);
                })(this.range, this.key, this.newValue);
            }
            static get className() {
              return 'AttributeOperation';
            }
            static fromJSON(e, t) {
              return new Oc(Qa.fromJSON(e.range, t), e.key, e.oldValue, e.newValue, e.baseVersion);
            }
          }
          class Rc extends Ic {
            constructor(e, t, n, o) {
              super(o),
                (this.sourcePosition = e.clone()),
                (this.sourcePosition.stickiness = 'toNext'),
                (this.howMany = t),
                (this.targetPosition = n.clone()),
                (this.targetPosition.stickiness = 'toNone');
            }
            get type() {
              return '$graveyard' == this.targetPosition.root.rootName
                ? 'remove'
                : '$graveyard' == this.sourcePosition.root.rootName
                ? 'reinsert'
                : 'move';
            }
            clone() {
              return new Rc(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
            }
            getMovedRangeStart() {
              return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
            }
            getReversed() {
              const e = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);
              return new Rc(this.getMovedRangeStart(), this.howMany, e, this.baseVersion + 1);
            }
            _validate() {
              const e = this.sourcePosition.parent,
                t = this.targetPosition.parent,
                n = this.sourcePosition.offset,
                o = this.targetPosition.offset;
              if (n + this.howMany > e.maxOffset) throw new l('move-operation-nodes-do-not-exist', this);
              if (e === t && n < o && o < n + this.howMany) throw new l('move-operation-range-into-itself', this);
              if (
                this.sourcePosition.root == this.targetPosition.root &&
                'prefix' == To(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath())
              ) {
                const e = this.sourcePosition.path.length - 1;
                if (this.targetPosition.path[e] >= n && this.targetPosition.path[e] < n + this.howMany)
                  throw new l('move-operation-node-into-itself', this);
              }
            }
            _execute() {
              Bc(Qa._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition);
            }
            toJSON() {
              const e = super.toJSON();
              return (e.sourcePosition = this.sourcePosition.toJSON()), (e.targetPosition = this.targetPosition.toJSON()), e;
            }
            static get className() {
              return 'MoveOperation';
            }
            static fromJSON(e, t) {
              const n = Ga.fromJSON(e.sourcePosition, t),
                o = Ga.fromJSON(e.targetPosition, t);
              return new this(n, e.howMany, o, e.baseVersion);
            }
          }
          class Vc extends Ic {
            constructor(e, t, n) {
              super(n),
                (this.position = e.clone()),
                (this.position.stickiness = 'toNone'),
                (this.nodes = new Va(Nc(t))),
                (this.shouldReceiveAttributes = !1);
            }
            get type() {
              return 'insert';
            }
            get howMany() {
              return this.nodes.maxOffset;
            }
            clone() {
              const e = new Va([...this.nodes].map((e) => e._clone(!0))),
                t = new Vc(this.position, e, this.baseVersion);
              return (t.shouldReceiveAttributes = this.shouldReceiveAttributes), t;
            }
            getReversed() {
              const e = this.position.root.document.graveyard,
                t = new Ga(e, [0]);
              return new Rc(this.position, this.nodes.maxOffset, t, this.baseVersion + 1);
            }
            _validate() {
              const e = this.position.parent;
              if (!e || e.maxOffset < this.position.offset) throw new l('insert-operation-position-invalid', this);
            }
            _execute() {
              const e = this.nodes;
              (this.nodes = new Va([...e].map((e) => e._clone(!0)))), Sc(this.position, e);
            }
            toJSON() {
              const e = super.toJSON();
              return (e.position = this.position.toJSON()), (e.nodes = this.nodes.toJSON()), e;
            }
            static get className() {
              return 'InsertOperation';
            }
            static fromJSON(e, t) {
              const n = [];
              for (const t of e.nodes) t.name ? n.push(Ua.fromJSON(t)) : n.push(Fa.fromJSON(t));
              const o = new Vc(Ga.fromJSON(e.position, t), n, e.baseVersion);
              return (o.shouldReceiveAttributes = e.shouldReceiveAttributes), o;
            }
          }
          class Fc extends Ic {
            constructor(e, t, n, o, i, r) {
              super(r),
                (this.name = e),
                (this.oldRange = t ? t.clone() : null),
                (this.newRange = n ? n.clone() : null),
                (this.affectsData = i),
                (this._markers = o);
            }
            get type() {
              return 'marker';
            }
            clone() {
              return new Fc(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
            }
            getReversed() {
              return new Fc(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
            }
            _execute() {
              this.newRange ? this._markers._set(this.name, this.newRange, !0, this.affectsData) : this._markers._remove(this.name);
            }
            toJSON() {
              const e = super.toJSON();
              return (
                this.oldRange && (e.oldRange = this.oldRange.toJSON()),
                this.newRange && (e.newRange = this.newRange.toJSON()),
                delete e._markers,
                e
              );
            }
            static get className() {
              return 'MarkerOperation';
            }
            static fromJSON(e, t) {
              return new Fc(
                e.name,
                e.oldRange ? Qa.fromJSON(e.oldRange, t) : null,
                e.newRange ? Qa.fromJSON(e.newRange, t) : null,
                t.model.markers,
                e.affectsData,
                e.baseVersion
              );
            }
          }
          class Hc extends Ic {
            get type() {
              return 'noop';
            }
            clone() {
              return new Hc(this.baseVersion);
            }
            getReversed() {
              return new Hc(this.baseVersion + 1);
            }
            _execute() {}
            static get className() {
              return 'NoOperation';
            }
          }
          class Uc extends Ic {
            constructor(e, t, n, o) {
              super(o), (this.position = e), (this.position.stickiness = 'toNext'), (this.oldName = t), (this.newName = n);
            }
            get type() {
              return 'rename';
            }
            clone() {
              return new Uc(this.position.clone(), this.oldName, this.newName, this.baseVersion);
            }
            getReversed() {
              return new Uc(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
            }
            _validate() {
              const e = this.position.nodeAfter;
              if (!(e instanceof Ua)) throw new l('rename-operation-wrong-position', this);
              if (e.name !== this.oldName) throw new l('rename-operation-wrong-name', this);
            }
            _execute() {
              this.position.nodeAfter.name = this.newName;
            }
            toJSON() {
              const e = super.toJSON();
              return (e.position = this.position.toJSON()), e;
            }
            static get className() {
              return 'RenameOperation';
            }
            static fromJSON(e, t) {
              return new Uc(Ga.fromJSON(e.position, t), e.oldName, e.newName, e.baseVersion);
            }
          }
          class qc extends Ic {
            constructor(e, t, n, o, i) {
              super(i), (this.root = e), (this.key = t), (this.oldValue = n), (this.newValue = o);
            }
            get type() {
              return null === this.oldValue ? 'addRootAttribute' : null === this.newValue ? 'removeRootAttribute' : 'changeRootAttribute';
            }
            clone() {
              return new qc(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
            }
            getReversed() {
              return new qc(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
            }
            _validate() {
              if (this.root != this.root.root || this.root.is('documentFragment'))
                throw new l('rootattribute-operation-not-a-root', this, { root: this.root, key: this.key });
              if (null !== this.oldValue && this.root.getAttribute(this.key) !== this.oldValue)
                throw new l('rootattribute-operation-wrong-old-value', this, { root: this.root, key: this.key });
              if (null === this.oldValue && null !== this.newValue && this.root.hasAttribute(this.key))
                throw new l('rootattribute-operation-attribute-exists', this, { root: this.root, key: this.key });
            }
            _execute() {
              null !== this.newValue ? this.root._setAttribute(this.key, this.newValue) : this.root._removeAttribute(this.key);
            }
            toJSON() {
              const e = super.toJSON();
              return (e.root = this.root.toJSON()), e;
            }
            static get className() {
              return 'RootAttributeOperation';
            }
            static fromJSON(e, t) {
              if (!t.getRoot(e.root)) throw new l('rootattribute-operation-fromjson-no-root', this, { rootName: e.root });
              return new qc(t.getRoot(e.root), e.key, e.oldValue, e.newValue, e.baseVersion);
            }
          }
          class Wc extends Ic {
            constructor(e, t, n, o, i) {
              super(i),
                (this.sourcePosition = e.clone()),
                (this.sourcePosition.stickiness = 'toPrevious'),
                (this.howMany = t),
                (this.targetPosition = n.clone()),
                (this.targetPosition.stickiness = 'toNext'),
                (this.graveyardPosition = o.clone());
            }
            get type() {
              return 'merge';
            }
            get deletionPosition() {
              return new Ga(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
            }
            get movedRange() {
              const e = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
              return new Qa(this.sourcePosition, e);
            }
            clone() {
              return new Wc(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
            }
            getReversed() {
              const e = this.targetPosition._getTransformedByMergeOperation(this),
                t = this.sourcePosition.path.slice(0, -1),
                n = new Ga(this.sourcePosition.root, t)._getTransformedByMergeOperation(this);
              return new Gc(e, this.howMany, n, this.graveyardPosition, this.baseVersion + 1);
            }
            _validate() {
              const e = this.sourcePosition.parent,
                t = this.targetPosition.parent;
              if (!e.parent) throw new l('merge-operation-source-position-invalid', this);
              if (!t.parent) throw new l('merge-operation-target-position-invalid', this);
              if (this.howMany != e.maxOffset) throw new l('merge-operation-how-many-invalid', this);
            }
            _execute() {
              const e = this.sourcePosition.parent;
              Bc(Qa._createIn(e), this.targetPosition), Bc(Qa._createOn(e), this.graveyardPosition);
            }
            toJSON() {
              const e = super.toJSON();
              return (
                (e.sourcePosition = e.sourcePosition.toJSON()),
                (e.targetPosition = e.targetPosition.toJSON()),
                (e.graveyardPosition = e.graveyardPosition.toJSON()),
                e
              );
            }
            static get className() {
              return 'MergeOperation';
            }
            static fromJSON(e, t) {
              const n = Ga.fromJSON(e.sourcePosition, t),
                o = Ga.fromJSON(e.targetPosition, t),
                i = Ga.fromJSON(e.graveyardPosition, t);
              return new this(n, e.howMany, o, i, e.baseVersion);
            }
          }
          class Gc extends Ic {
            constructor(e, t, n, o, i) {
              super(i),
                (this.splitPosition = e.clone()),
                (this.splitPosition.stickiness = 'toNext'),
                (this.howMany = t),
                (this.insertionPosition = n),
                (this.graveyardPosition = o ? o.clone() : null),
                this.graveyardPosition && (this.graveyardPosition.stickiness = 'toNext');
            }
            get type() {
              return 'split';
            }
            get moveTargetPosition() {
              const e = this.insertionPosition.path.slice();
              return e.push(0), new Ga(this.insertionPosition.root, e);
            }
            get movedRange() {
              const e = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
              return new Qa(this.splitPosition, e);
            }
            clone() {
              return new Gc(this.splitPosition, this.howMany, this.insertionPosition, this.graveyardPosition, this.baseVersion);
            }
            getReversed() {
              const e = this.splitPosition.root.document.graveyard,
                t = new Ga(e, [0]);
              return new Wc(this.moveTargetPosition, this.howMany, this.splitPosition, t, this.baseVersion + 1);
            }
            _validate() {
              const e = this.splitPosition.parent,
                t = this.splitPosition.offset;
              if (!e || e.maxOffset < t) throw new l('split-operation-position-invalid', this);
              if (!e.parent) throw new l('split-operation-split-in-root', this);
              if (this.howMany != e.maxOffset - this.splitPosition.offset) throw new l('split-operation-how-many-invalid', this);
              if (this.graveyardPosition && !this.graveyardPosition.nodeAfter)
                throw new l('split-operation-graveyard-position-invalid', this);
            }
            _execute() {
              const e = this.splitPosition.parent;
              if (this.graveyardPosition) Bc(Qa._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);
              else {
                const t = e._clone();
                Sc(this.insertionPosition, t);
              }
              Bc(new Qa(Ga._createAt(e, this.splitPosition.offset), Ga._createAt(e, e.maxOffset)), this.moveTargetPosition);
            }
            toJSON() {
              const e = super.toJSON();
              return (
                (e.splitPosition = this.splitPosition.toJSON()),
                (e.insertionPosition = this.insertionPosition.toJSON()),
                this.graveyardPosition && (e.graveyardPosition = this.graveyardPosition.toJSON()),
                e
              );
            }
            static get className() {
              return 'SplitOperation';
            }
            static getInsertionPosition(e) {
              const t = e.path.slice(0, -1);
              return t[t.length - 1]++, new Ga(e.root, t, 'toPrevious');
            }
            static fromJSON(e, t) {
              const n = Ga.fromJSON(e.splitPosition, t),
                o = Ga.fromJSON(e.insertionPosition, t),
                i = e.graveyardPosition ? Ga.fromJSON(e.graveyardPosition, t) : null;
              return new this(n, e.howMany, o, i, e.baseVersion);
            }
          }
          const $c = {};
          ($c[Oc.className] = Oc),
            ($c[Vc.className] = Vc),
            ($c[Fc.className] = Fc),
            ($c[Rc.className] = Rc),
            ($c[Hc.className] = Hc),
            ($c[Ic.className] = Ic),
            ($c[Uc.className] = Uc),
            ($c[qc.className] = qc),
            ($c[Gc.className] = Gc),
            ($c[Wc.className] = Wc);
          class Yc extends Ic {
            constructor(e, t) {
              super(null), (this.sourcePosition = e.clone()), (this.howMany = t);
            }
            get type() {
              return 'detach';
            }
            toJSON() {
              const e = super.toJSON();
              return (e.sourcePosition = this.sourcePosition.toJSON()), e;
            }
            _validate() {
              if (this.sourcePosition.root.document) throw new l('detach-operation-on-document-node', this);
            }
            _execute() {
              Mc(Qa._createFromPositionAndShift(this.sourcePosition, this.howMany));
            }
            static get className() {
              return 'DetachOperation';
            }
          }
          class Kc extends Oa {
            constructor(e) {
              super(), (this.markers = new Map()), (this._children = new Va()), e && this._insertChild(0, e);
            }
            [Symbol.iterator]() {
              return this.getChildren();
            }
            get childCount() {
              return this._children.length;
            }
            get maxOffset() {
              return this._children.maxOffset;
            }
            get isEmpty() {
              return 0 === this.childCount;
            }
            get nextSibling() {
              return null;
            }
            get previousSibling() {
              return null;
            }
            get root() {
              return this;
            }
            get parent() {
              return null;
            }
            get document() {
              return null;
            }
            getAncestors() {
              return [];
            }
            getChild(e) {
              return this._children.getNode(e);
            }
            getChildren() {
              return this._children[Symbol.iterator]();
            }
            getChildIndex(e) {
              return this._children.getNodeIndex(e);
            }
            getChildStartOffset(e) {
              return this._children.getNodeStartOffset(e);
            }
            getPath() {
              return [];
            }
            getNodeByPath(e) {
              let t = this;
              for (const n of e) t = t.getChild(t.offsetToIndex(n));
              return t;
            }
            offsetToIndex(e) {
              return this._children.offsetToIndex(e);
            }
            toJSON() {
              const e = [];
              for (const t of this._children) e.push(t.toJSON());
              return e;
            }
            static fromJSON(e) {
              const t = [];
              for (const n of e) n.name ? t.push(Ua.fromJSON(n)) : t.push(Fa.fromJSON(n));
              return new Kc(t);
            }
            _appendChild(e) {
              this._insertChild(this.childCount, e);
            }
            _insertChild(e, t) {
              const n = (function (e) {
                if ('string' == typeof e) return [new Fa(e)];
                po(e) || (e = [e]);
                return Array.from(e).map((e) =>
                  'string' == typeof e ? new Fa(e) : e instanceof Ha ? new Fa(e.data, e.getAttributes()) : e
                );
              })(t);
              for (const e of n) null !== e.parent && e._remove(), (e.parent = this);
              this._children._insertNodes(e, n);
            }
            _removeChildren(e, t = 1) {
              const n = this._children._removeNodes(e, t);
              for (const e of n) e.parent = null;
              return n;
            }
          }
          Kc.prototype.is = function (e) {
            return 'documentFragment' === e || 'model:documentFragment' === e;
          };
          class Qc {
            constructor(e, t) {
              (this.model = e), (this.batch = t);
            }
            createText(e, t) {
              return new Fa(e, t);
            }
            createElement(e, t) {
              return new Ua(e, t);
            }
            createDocumentFragment() {
              return new Kc();
            }
            cloneElement(e, t = !0) {
              return e._clone(t);
            }
            insert(e, t, n = 0) {
              if ((this._assertWriterUsedCorrectly(), e instanceof Fa && '' == e.data)) return;
              const o = Ga._createAt(t, n);
              if (e.parent) {
                if (td(e.root, o.root)) return void this.move(Qa._createOn(e), o);
                if (e.root.document) throw new l('model-writer-insert-forbidden-move', this);
                this.remove(e);
              }
              const i = o.root.document ? o.root.document.version : null,
                r = new Vc(o, e, i);
              if (
                (e instanceof Fa && (r.shouldReceiveAttributes = !0),
                this.batch.addOperation(r),
                this.model.applyOperation(r),
                e instanceof Kc)
              )
                for (const [t, n] of e.markers) {
                  const e = Ga._createAt(n.root, 0),
                    i = { range: new Qa(n.start._getCombined(e, o), n.end._getCombined(e, o)), usingOperation: !0, affectsData: !0 };
                  this.model.markers.has(t) ? this.updateMarker(t, i) : this.addMarker(t, i);
                }
            }
            insertText(e, t, n, o) {
              t instanceof Kc || t instanceof Ua || t instanceof Ga
                ? this.insert(this.createText(e), t, n)
                : this.insert(this.createText(e, t), n, o);
            }
            insertElement(e, t, n, o) {
              t instanceof Kc || t instanceof Ua || t instanceof Ga
                ? this.insert(this.createElement(e), t, n)
                : this.insert(this.createElement(e, t), n, o);
            }
            append(e, t) {
              this.insert(e, t, 'end');
            }
            appendText(e, t, n) {
              t instanceof Kc || t instanceof Ua ? this.insert(this.createText(e), t, 'end') : this.insert(this.createText(e, t), n, 'end');
            }
            appendElement(e, t, n) {
              t instanceof Kc || t instanceof Ua
                ? this.insert(this.createElement(e), t, 'end')
                : this.insert(this.createElement(e, t), n, 'end');
            }
            setAttribute(e, t, n) {
              if ((this._assertWriterUsedCorrectly(), n instanceof Qa)) {
                const o = n.getMinimalFlatRanges();
                for (const n of o) Zc(this, e, t, n);
              } else Jc(this, e, t, n);
            }
            setAttributes(e, t) {
              for (const [n, o] of No(e)) this.setAttribute(n, o, t);
            }
            removeAttribute(e, t) {
              if ((this._assertWriterUsedCorrectly(), t instanceof Qa)) {
                const n = t.getMinimalFlatRanges();
                for (const t of n) Zc(this, e, null, t);
              } else Jc(this, e, null, t);
            }
            clearAttributes(e) {
              this._assertWriterUsedCorrectly();
              const t = (e) => {
                for (const t of e.getAttributeKeys()) this.removeAttribute(t, e);
              };
              if (e instanceof Qa) for (const n of e.getItems()) t(n);
              else t(e);
            }
            move(e, t, n) {
              if ((this._assertWriterUsedCorrectly(), !(e instanceof Qa))) throw new l('writer-move-invalid-range', this);
              if (!e.isFlat) throw new l('writer-move-range-not-flat', this);
              const o = Ga._createAt(t, n);
              if (o.isEqual(e.start)) return;
              if ((this._addOperationForAffectedMarkers('move', e), !td(e.root, o.root)))
                throw new l('writer-move-different-document', this);
              const i = e.root.document ? e.root.document.version : null,
                r = new Rc(e.start, e.end.offset - e.start.offset, o, i);
              this.batch.addOperation(r), this.model.applyOperation(r);
            }
            remove(e) {
              this._assertWriterUsedCorrectly();
              const t = (e instanceof Qa ? e : Qa._createOn(e)).getMinimalFlatRanges().reverse();
              for (const e of t)
                this._addOperationForAffectedMarkers('move', e), ed(e.start, e.end.offset - e.start.offset, this.batch, this.model);
            }
            merge(e) {
              this._assertWriterUsedCorrectly();
              const t = e.nodeBefore,
                n = e.nodeAfter;
              if ((this._addOperationForAffectedMarkers('merge', e), !(t instanceof Ua)))
                throw new l('writer-merge-no-element-before', this);
              if (!(n instanceof Ua)) throw new l('writer-merge-no-element-after', this);
              e.root.document ? this._merge(e) : this._mergeDetached(e);
            }
            createPositionFromPath(e, t, n) {
              return this.model.createPositionFromPath(e, t, n);
            }
            createPositionAt(e, t) {
              return this.model.createPositionAt(e, t);
            }
            createPositionAfter(e) {
              return this.model.createPositionAfter(e);
            }
            createPositionBefore(e) {
              return this.model.createPositionBefore(e);
            }
            createRange(e, t) {
              return this.model.createRange(e, t);
            }
            createRangeIn(e) {
              return this.model.createRangeIn(e);
            }
            createRangeOn(e) {
              return this.model.createRangeOn(e);
            }
            createSelection(...e) {
              return this.model.createSelection(...e);
            }
            _mergeDetached(e) {
              const t = e.nodeBefore,
                n = e.nodeAfter;
              this.move(Qa._createIn(n), Ga._createAt(t, 'end')), this.remove(n);
            }
            _merge(e) {
              const t = Ga._createAt(e.nodeBefore, 'end'),
                n = Ga._createAt(e.nodeAfter, 0),
                o = e.root.document.graveyard,
                i = new Ga(o, [0]),
                r = e.root.document.version,
                s = new Wc(n, e.nodeAfter.maxOffset, t, i, r);
              this.batch.addOperation(s), this.model.applyOperation(s);
            }
            rename(e, t) {
              if ((this._assertWriterUsedCorrectly(), !(e instanceof Ua))) throw new l('writer-rename-not-element-instance', this);
              const n = e.root.document ? e.root.document.version : null,
                o = new Uc(Ga._createBefore(e), e.name, t, n);
              this.batch.addOperation(o), this.model.applyOperation(o);
            }
            split(e, t) {
              this._assertWriterUsedCorrectly();
              let n,
                o,
                i = e.parent;
              if (!i.parent) throw new l('writer-split-element-no-parent', this);
              if ((t || (t = i.parent), !e.parent.getAncestors({ includeSelf: !0 }).includes(t)))
                throw new l('writer-split-invalid-limit-element', this);
              do {
                const t = i.root.document ? i.root.document.version : null,
                  r = i.maxOffset - e.offset,
                  s = Gc.getInsertionPosition(e),
                  a = new Gc(e, r, s, null, t);
                this.batch.addOperation(a),
                  this.model.applyOperation(a),
                  n || o || ((n = i), (o = e.parent.nextSibling)),
                  (i = (e = this.createPositionAfter(e.parent)).parent);
              } while (i !== t);
              return { position: e, range: new Qa(Ga._createAt(n, 'end'), Ga._createAt(o, 0)) };
            }
            wrap(e, t) {
              if ((this._assertWriterUsedCorrectly(), !e.isFlat)) throw new l('writer-wrap-range-not-flat', this);
              const n = t instanceof Ua ? t : new Ua(t);
              if (n.childCount > 0) throw new l('writer-wrap-element-not-empty', this);
              if (null !== n.parent) throw new l('writer-wrap-element-attached', this);
              this.insert(n, e.start);
              const o = new Qa(e.start.getShiftedBy(1), e.end.getShiftedBy(1));
              this.move(o, Ga._createAt(n, 0));
            }
            unwrap(e) {
              if ((this._assertWriterUsedCorrectly(), null === e.parent)) throw new l('writer-unwrap-element-no-parent', this);
              this.move(Qa._createIn(e), this.createPositionAfter(e)), this.remove(e);
            }
            addMarker(e, t) {
              if ((this._assertWriterUsedCorrectly(), !t || 'boolean' != typeof t.usingOperation))
                throw new l('writer-addmarker-no-usingoperation', this);
              const n = t.usingOperation,
                o = t.range,
                i = void 0 !== t.affectsData && t.affectsData;
              if (this.model.markers.has(e)) throw new l('writer-addmarker-marker-exists', this);
              if (!o) throw new l('writer-addmarker-no-range', this);
              return n ? (Xc(this, e, null, o, i), this.model.markers.get(e)) : this.model.markers._set(e, o, n, i);
            }
            updateMarker(e, t) {
              this._assertWriterUsedCorrectly();
              const n = 'string' == typeof e ? e : e.name,
                o = this.model.markers.get(n);
              if (!o) throw new l('writer-updatemarker-marker-not-exists', this);
              if (!t)
                return c('writer-updatemarker-reconvert-using-editingcontroller', { markerName: n }), void this.model.markers._refresh(o);
              const i = 'boolean' == typeof t.usingOperation,
                r = 'boolean' == typeof t.affectsData,
                s = r ? t.affectsData : o.affectsData;
              if (!i && !t.range && !r) throw new l('writer-updatemarker-wrong-options', this);
              const a = o.getRange(),
                d = t.range ? t.range : a;
              i && t.usingOperation !== o.managedUsingOperations
                ? t.usingOperation
                  ? Xc(this, n, null, d, s)
                  : (Xc(this, n, a, null, s), this.model.markers._set(n, d, void 0, s))
                : o.managedUsingOperations
                ? Xc(this, n, a, d, s)
                : this.model.markers._set(n, d, void 0, s);
            }
            removeMarker(e) {
              this._assertWriterUsedCorrectly();
              const t = 'string' == typeof e ? e : e.name;
              if (!this.model.markers.has(t)) throw new l('writer-removemarker-no-marker', this);
              const n = this.model.markers.get(t);
              if (!n.managedUsingOperations) return void this.model.markers._remove(t);
              Xc(this, t, n.getRange(), null, n.affectsData);
            }
            setSelection(...e) {
              this._assertWriterUsedCorrectly(), this.model.document.selection._setTo(...e);
            }
            setSelectionFocus(e, t) {
              this._assertWriterUsedCorrectly(), this.model.document.selection._setFocus(e, t);
            }
            setSelectionAttribute(e, t) {
              if ((this._assertWriterUsedCorrectly(), 'string' == typeof e)) this._setSelectionAttribute(e, t);
              else for (const [t, n] of No(e)) this._setSelectionAttribute(t, n);
            }
            removeSelectionAttribute(e) {
              if ((this._assertWriterUsedCorrectly(), 'string' == typeof e)) this._removeSelectionAttribute(e);
              else for (const t of e) this._removeSelectionAttribute(t);
            }
            overrideSelectionGravity() {
              return this.model.document.selection._overrideGravity();
            }
            restoreSelectionGravity(e) {
              this.model.document.selection._restoreGravity(e);
            }
            _setSelectionAttribute(e, t) {
              const n = this.model.document.selection;
              if (n.isCollapsed && n.anchor.parent.isEmpty) {
                const o = hl._getStoreAttributeKey(e);
                this.setAttribute(o, t, n.anchor.parent);
              }
              n._setAttribute(e, t);
            }
            _removeSelectionAttribute(e) {
              const t = this.model.document.selection;
              if (t.isCollapsed && t.anchor.parent.isEmpty) {
                const n = hl._getStoreAttributeKey(e);
                this.removeAttribute(n, t.anchor.parent);
              }
              t._removeAttribute(e);
            }
            _assertWriterUsedCorrectly() {
              if (this.model._currentWriter !== this) throw new l('writer-incorrect-use', this);
            }
            _addOperationForAffectedMarkers(e, t) {
              for (const n of this.model.markers) {
                if (!n.managedUsingOperations) continue;
                const o = n.getRange();
                let i = !1;
                if ('move' === e) {
                  const e = t;
                  i = e.containsPosition(o.start) || e.start.isEqual(o.start) || e.containsPosition(o.end) || e.end.isEqual(o.end);
                } else {
                  const e = t,
                    n = e.nodeBefore,
                    r = e.nodeAfter,
                    s = o.start.parent == n && o.start.isAtEnd,
                    a = o.end.parent == r && 0 == o.end.offset,
                    l = o.end.nodeAfter == r,
                    c = o.start.nodeAfter == r;
                  i = s || a || l || c;
                }
                i && this.updateMarker(n.name, { range: o });
              }
            }
          }
          function Zc(e, t, n, o) {
            const i = e.model,
              r = i.document;
            let s,
              a,
              l,
              c = o.start;
            for (const e of o.getWalker({ shallow: !0 }))
              (l = e.item.getAttribute(t)), s && a != l && (a != n && d(), (c = s)), (s = e.nextPosition), (a = l);
            function d() {
              const o = new Qa(c, s),
                l = o.root.document ? r.version : null,
                d = new Oc(o, t, a, n, l);
              e.batch.addOperation(d), i.applyOperation(d);
            }
            s instanceof Ga && s != c && a != n && d();
          }
          function Jc(e, t, n, o) {
            const i = e.model,
              r = i.document,
              s = o.getAttribute(t);
            let a, l;
            if (s != n) {
              if (o.root === o) {
                const e = o.document ? r.version : null;
                l = new qc(o, t, s, n, e);
              } else {
                a = new Qa(Ga._createBefore(o), e.createPositionAfter(o));
                const i = a.root.document ? r.version : null;
                l = new Oc(a, t, s, n, i);
              }
              e.batch.addOperation(l), i.applyOperation(l);
            }
          }
          function Xc(e, t, n, o, i) {
            const r = e.model,
              s = r.document,
              a = new Fc(t, n, o, r.markers, !!i, s.version);
            e.batch.addOperation(a), r.applyOperation(a);
          }
          function ed(e, t, n, o) {
            let i;
            if (e.root.document) {
              const n = o.document,
                r = new Ga(n.graveyard, [0]);
              i = new Rc(e, t, r, n.version);
            } else i = new Yc(e, t);
            n.addOperation(i), o.applyOperation(i);
          }
          function td(e, t) {
            return e === t || (e instanceof wc && t instanceof wc);
          }
          function nd(e) {
            e.document.registerPostFixer((t) =>
              (function (e, t) {
                const n = t.document.selection,
                  o = t.schema,
                  i = [];
                let r = !1;
                for (const e of n.getRanges()) {
                  const t = od(e, o);
                  t && !t.isEqual(e) ? (i.push(t), (r = !0)) : i.push(e);
                }
                r &&
                  e.setSelection(
                    (function (e) {
                      const t = [...e],
                        n = new Set();
                      let o = 1;
                      for (; o < t.length; ) {
                        const e = t[o],
                          i = t.slice(0, o);
                        for (const [r, s] of i.entries())
                          if (!n.has(r))
                            if (e.isEqual(s)) n.add(r);
                            else if (e.isIntersecting(s)) {
                              n.add(r), n.add(o);
                              const i = e.getJoined(s);
                              t.push(i);
                            }
                        o++;
                      }
                      return t.filter((e, t) => !n.has(t));
                    })(i),
                    { backward: n.isBackward }
                  );
                return !1;
              })(t, e)
            );
          }
          function od(e, t) {
            return e.isCollapsed
              ? (function (e, t) {
                  const n = e.start,
                    o = t.getNearestSelectionRange(n);
                  if (!o) {
                    const e = n
                      .getAncestors()
                      .reverse()
                      .find((e) => t.isObject(e));
                    return e ? Qa._createOn(e) : null;
                  }
                  if (!o.isCollapsed) return o;
                  const i = o.start;
                  if (n.isEqual(i)) return null;
                  return new Qa(i);
                })(e, t)
              : (function (e, t) {
                  const { start: n, end: o } = e,
                    i = t.checkChild(n, '$text'),
                    r = t.checkChild(o, '$text'),
                    s = t.getLimitElement(n),
                    a = t.getLimitElement(o);
                  if (s === a) {
                    if (i && r) return null;
                    if (
                      (function (e, t, n) {
                        const o = (e.nodeAfter && !n.isLimit(e.nodeAfter)) || n.checkChild(e, '$text'),
                          i = (t.nodeBefore && !n.isLimit(t.nodeBefore)) || n.checkChild(t, '$text');
                        return o || i;
                      })(n, o, t)
                    ) {
                      const e = n.nodeAfter && t.isSelectable(n.nodeAfter) ? null : t.getNearestSelectionRange(n, 'forward'),
                        i = o.nodeBefore && t.isSelectable(o.nodeBefore) ? null : t.getNearestSelectionRange(o, 'backward'),
                        r = e ? e.start : n,
                        s = i ? i.end : o;
                      return new Qa(r, s);
                    }
                  }
                  const l = s && !s.is('rootElement'),
                    c = a && !a.is('rootElement');
                  if (l || c) {
                    const e = n.nodeAfter && o.nodeBefore && n.nodeAfter.parent === o.nodeBefore.parent,
                      i = l && (!e || !rd(n.nodeAfter, t)),
                      r = c && (!e || !rd(o.nodeBefore, t));
                    let d = n,
                      u = o;
                    return i && (d = Ga._createBefore(id(s, t))), r && (u = Ga._createAfter(id(a, t))), new Qa(d, u);
                  }
                  return null;
                })(e, t);
          }
          function id(e, t) {
            let n = e,
              o = n;
            for (; t.isLimit(o) && o.parent; ) (n = o), (o = o.parent);
            return n;
          }
          function rd(e, t) {
            return e && t.isSelectable(e);
          }
          class sd extends k(Ga) {
            constructor(e, t, n = 'toNone') {
              if ((super(e, t, n), !this.root.is('rootElement'))) throw new l('model-liveposition-root-not-rootelement', e);
              ad.call(this);
            }
            detach() {
              this.stopListening();
            }
            toPosition() {
              return new Ga(this.root, this.path.slice(), this.stickiness);
            }
            static fromPosition(e, t) {
              return new this(e.root, e.path.slice(), t || e.stickiness);
            }
          }
          function ad() {
            this.listenTo(
              this.root.document.model,
              'applyOperation',
              (e, t) => {
                const n = t[0];
                n.isDocumentOperation && ld.call(this, n);
              },
              { priority: 'low' }
            );
          }
          function ld(e) {
            const t = this.getTransformedByOperation(e);
            if (!this.isEqual(t)) {
              const e = this.toPosition();
              (this.path = t.path), (this.root = t.root), this.fire('change', e);
            }
          }
          function cd(e, t, n = {}) {
            if (t.isCollapsed) return;
            const o = t.getFirstRange();
            if ('$graveyard' == o.root.rootName) return;
            const i = e.schema;
            e.change((e) => {
              if (
                !n.doNotResetEntireContent &&
                (function (e, t) {
                  const n = e.getLimitElement(t);
                  if (!t.containsEntireContent(n)) return !1;
                  const o = t.getFirstRange();
                  if (o.start.parent == o.end.parent) return !1;
                  return e.checkChild(n, 'paragraph');
                })(i, t)
              )
                return void (function (e, t) {
                  const n = e.model.schema.getLimitElement(t);
                  e.remove(e.createRangeIn(n)), md(e, e.createPositionAt(n, 0), t);
                })(e, t);
              const r = {};
              if (!n.doNotAutoparagraph) {
                const e = t.getSelectedElement();
                e && Object.assign(r, i.getAttributesWithProperty(e, 'copyOnReplace', !0));
              }
              const [s, a] = (function (e) {
                const t = e.root.document.model,
                  n = e.start;
                let o = e.end;
                if (t.hasContent(e, { ignoreMarkers: !0 })) {
                  const n = (function (e) {
                    const t = e.parent,
                      n = t.root.document.model.schema,
                      o = t.getAncestors({ parentFirst: !0, includeSelf: !0 });
                    for (const e of o) {
                      if (n.isLimit(e)) return null;
                      if (n.isBlock(e)) return e;
                    }
                  })(o);
                  if (n && o.isTouching(t.createPositionAt(n, 0))) {
                    const n = t.createSelection(e);
                    t.modifySelection(n, { direction: 'backward' });
                    const i = n.getLastPosition(),
                      r = t.createRange(i, o);
                    t.hasContent(r, { ignoreMarkers: !0 }) || (o = i);
                  }
                }
                return [sd.fromPosition(n, 'toPrevious'), sd.fromPosition(o, 'toNext')];
              })(o);
              s.isTouching(a) || e.remove(e.createRange(s, a)),
                n.leaveUnmerged ||
                  (!(function (e, t, n) {
                    const o = e.model;
                    if (!hd(e.model.schema, t, n)) return;
                    const [i, r] = (function (e, t) {
                      const n = e.getAncestors(),
                        o = t.getAncestors();
                      let i = 0;
                      for (; n[i] && n[i] == o[i]; ) i++;
                      return [n[i], o[i]];
                    })(t, n);
                    if (!i || !r) return;
                    !o.hasContent(i, { ignoreMarkers: !0 }) && o.hasContent(r, { ignoreMarkers: !0 })
                      ? ud(e, t, n, i.parent)
                      : dd(e, t, n, i.parent);
                  })(e, s, a),
                  i.removeDisallowedAttributes(s.parent.getChildren(), e)),
                gd(e, t, s),
                !n.doNotAutoparagraph &&
                  (function (e, t) {
                    const n = e.checkChild(t, '$text'),
                      o = e.checkChild(t, 'paragraph');
                    return !n && o;
                  })(i, s) &&
                  md(e, s, t, r),
                s.detach(),
                a.detach();
            });
          }
          function dd(e, t, n, o) {
            const i = t.parent,
              r = n.parent;
            if (i != o && r != o) {
              for (
                t = e.createPositionAfter(i), (n = e.createPositionBefore(r)).isEqual(t) || e.insert(r, t), e.merge(t);
                n.parent.isEmpty;

              ) {
                const t = n.parent;
                (n = e.createPositionBefore(t)), e.remove(t);
              }
              hd(e.model.schema, t, n) && dd(e, t, n, o);
            }
          }
          function ud(e, t, n, o) {
            const i = t.parent,
              r = n.parent;
            if (i != o && r != o) {
              for (t = e.createPositionAfter(i), (n = e.createPositionBefore(r)).isEqual(t) || e.insert(i, n); t.parent.isEmpty; ) {
                const n = t.parent;
                (t = e.createPositionBefore(n)), e.remove(n);
              }
              (n = e.createPositionBefore(r)),
                (function (e, t) {
                  const n = t.nodeBefore,
                    o = t.nodeAfter;
                  n.name != o.name && e.rename(n, o.name);
                  e.clearAttributes(n), e.setAttributes(Object.fromEntries(o.getAttributes()), n), e.merge(t);
                })(e, n),
                hd(e.model.schema, t, n) && ud(e, t, n, o);
            }
          }
          function hd(e, t, n) {
            const o = t.parent,
              i = n.parent;
            return (
              o != i &&
              !e.isLimit(o) &&
              !e.isLimit(i) &&
              (function (e, t, n) {
                const o = new Qa(e, t);
                for (const e of o.getWalker()) if (n.isLimit(e.item)) return !1;
                return !0;
              })(t, n, e)
            );
          }
          function md(e, t, n, o = {}) {
            const i = e.createElement('paragraph');
            e.model.schema.setAllowedAttributes(i, o, e), e.insert(i, t), gd(e, n, e.createPositionAt(i, 0));
          }
          function gd(e, t, n) {
            t instanceof hl ? e.setSelection(n) : t.setTo(n);
          }
          function pd(e, t) {
            const n = [];
            Array.from(e.getItems({ direction: 'backward' }))
              .map((e) => t.createRangeOn(e))
              .filter((t) => (t.start.isAfter(e.start) || t.start.isEqual(e.start)) && (t.end.isBefore(e.end) || t.end.isEqual(e.end)))
              .forEach((e) => {
                n.push(e.start.parent), t.remove(e);
              }),
              n.forEach((e) => {
                let n = e;
                for (; n.parent && n.isEmpty; ) {
                  const e = t.createRangeOn(n);
                  (n = n.parent), t.remove(e);
                }
              });
          }
          sd.prototype.is = function (e) {
            return 'livePosition' === e || 'model:livePosition' === e || 'position' == e || 'model:position' === e;
          };
          class fd {
            constructor(e, t, n) {
              (this.model = e),
                (this.writer = t),
                (this.position = n),
                (this.canMergeWith = new Set([this.position.parent])),
                (this.schema = e.schema),
                (this._documentFragment = t.createDocumentFragment()),
                (this._documentFragmentPosition = t.createPositionAt(this._documentFragment, 0)),
                (this._firstNode = null),
                (this._lastNode = null),
                (this._lastAutoParagraph = null),
                (this._filterAttributesOf = []),
                (this._affectedStart = null),
                (this._affectedEnd = null);
            }
            handleNodes(e) {
              for (const t of Array.from(e)) this._handleNode(t);
              this._insertPartialFragment(),
                this._lastAutoParagraph && this._updateLastNodeFromAutoParagraph(this._lastAutoParagraph),
                this._mergeOnRight(),
                this.schema.removeDisallowedAttributes(this._filterAttributesOf, this.writer),
                (this._filterAttributesOf = []);
            }
            _updateLastNodeFromAutoParagraph(e) {
              const t = this.writer.createPositionAfter(this._lastNode),
                n = this.writer.createPositionAfter(e);
              if (n.isAfter(t)) {
                if (((this._lastNode = e), this.position.parent != e || !this.position.isAtEnd))
                  throw new l('insertcontent-invalid-insertion-position', this);
                (this.position = n), this._setAffectedBoundaries(this.position);
              }
            }
            getSelectionRange() {
              return this._nodeToSelect ? Qa._createOn(this._nodeToSelect) : this.model.schema.getNearestSelectionRange(this.position);
            }
            getAffectedRange() {
              return this._affectedStart ? new Qa(this._affectedStart, this._affectedEnd) : null;
            }
            destroy() {
              this._affectedStart && this._affectedStart.detach(), this._affectedEnd && this._affectedEnd.detach();
            }
            _handleNode(e) {
              if (this.schema.isObject(e)) return void this._handleObject(e);
              let t = this._checkAndAutoParagraphToAllowedPosition(e);
              t || ((t = this._checkAndSplitToAllowedPosition(e)), t)
                ? (this._appendToFragment(e), this._firstNode || (this._firstNode = e), (this._lastNode = e))
                : this._handleDisallowedNode(e);
            }
            _insertPartialFragment() {
              if (this._documentFragment.isEmpty) return;
              const e = sd.fromPosition(this.position, 'toNext');
              this._setAffectedBoundaries(this.position),
                this._documentFragment.getChild(0) == this._firstNode &&
                  (this.writer.insert(this._firstNode, this.position), this._mergeOnLeft(), (this.position = e.toPosition())),
                this._documentFragment.isEmpty || this.writer.insert(this._documentFragment, this.position),
                (this._documentFragmentPosition = this.writer.createPositionAt(this._documentFragment, 0)),
                (this.position = e.toPosition()),
                e.detach();
            }
            _handleObject(e) {
              this._checkAndSplitToAllowedPosition(e) ? this._appendToFragment(e) : this._tryAutoparagraphing(e);
            }
            _handleDisallowedNode(e) {
              e.is('element') ? this.handleNodes(e.getChildren()) : this._tryAutoparagraphing(e);
            }
            _appendToFragment(e) {
              if (!this.schema.checkChild(this.position, e))
                throw new l('insertcontent-wrong-position', this, { node: e, position: this.position });
              this.writer.insert(e, this._documentFragmentPosition),
                (this._documentFragmentPosition = this._documentFragmentPosition.getShiftedBy(e.offsetSize)),
                this.schema.isObject(e) && !this.schema.checkChild(this.position, '$text')
                  ? (this._nodeToSelect = e)
                  : (this._nodeToSelect = null),
                this._filterAttributesOf.push(e);
            }
            _setAffectedBoundaries(e) {
              this._affectedStart || (this._affectedStart = sd.fromPosition(e, 'toPrevious')),
                (this._affectedEnd && !this._affectedEnd.isBefore(e)) ||
                  (this._affectedEnd && this._affectedEnd.detach(), (this._affectedEnd = sd.fromPosition(e, 'toNext')));
            }
            _mergeOnLeft() {
              const e = this._firstNode;
              if (!(e instanceof Ua)) return;
              if (!this._canMergeLeft(e)) return;
              const t = sd._createBefore(e);
              t.stickiness = 'toNext';
              const n = sd.fromPosition(this.position, 'toNext');
              this._affectedStart.isEqual(t) &&
                (this._affectedStart.detach(), (this._affectedStart = sd._createAt(t.nodeBefore, 'end', 'toPrevious'))),
                this._firstNode === this._lastNode && ((this._firstNode = t.nodeBefore), (this._lastNode = t.nodeBefore)),
                this.writer.merge(t),
                t.isEqual(this._affectedEnd) &&
                  this._firstNode === this._lastNode &&
                  (this._affectedEnd.detach(), (this._affectedEnd = sd._createAt(t.nodeBefore, 'end', 'toNext'))),
                (this.position = n.toPosition()),
                n.detach(),
                this._filterAttributesOf.push(this.position.parent),
                t.detach();
            }
            _mergeOnRight() {
              const e = this._lastNode;
              if (!(e instanceof Ua)) return;
              if (!this._canMergeRight(e)) return;
              const t = sd._createAfter(e);
              if (((t.stickiness = 'toNext'), !this.position.isEqual(t))) throw new l('insertcontent-invalid-insertion-position', this);
              this.position = Ga._createAt(t.nodeBefore, 'end');
              const n = sd.fromPosition(this.position, 'toPrevious');
              this._affectedEnd.isEqual(t) &&
                (this._affectedEnd.detach(), (this._affectedEnd = sd._createAt(t.nodeBefore, 'end', 'toNext'))),
                this._firstNode === this._lastNode && ((this._firstNode = t.nodeBefore), (this._lastNode = t.nodeBefore)),
                this.writer.merge(t),
                t.getShiftedBy(-1).isEqual(this._affectedStart) &&
                  this._firstNode === this._lastNode &&
                  (this._affectedStart.detach(), (this._affectedStart = sd._createAt(t.nodeBefore, 0, 'toPrevious'))),
                (this.position = n.toPosition()),
                n.detach(),
                this._filterAttributesOf.push(this.position.parent),
                t.detach();
            }
            _canMergeLeft(e) {
              const t = e.previousSibling;
              return t instanceof Ua && this.canMergeWith.has(t) && this.model.schema.checkMerge(t, e);
            }
            _canMergeRight(e) {
              const t = e.nextSibling;
              return t instanceof Ua && this.canMergeWith.has(t) && this.model.schema.checkMerge(e, t);
            }
            _tryAutoparagraphing(e) {
              const t = this.writer.createElement('paragraph');
              this._getAllowedIn(this.position.parent, t) && this.schema.checkChild(t, e) && (t._appendChild(e), this._handleNode(t));
            }
            _checkAndAutoParagraphToAllowedPosition(e) {
              if (this.schema.checkChild(this.position.parent, e)) return !0;
              if (!this.schema.checkChild(this.position.parent, 'paragraph') || !this.schema.checkChild('paragraph', e)) return !1;
              this._insertPartialFragment();
              const t = this.writer.createElement('paragraph');
              return (
                this.writer.insert(t, this.position),
                this._setAffectedBoundaries(this.position),
                (this._lastAutoParagraph = t),
                (this.position = this.writer.createPositionAt(t, 0)),
                !0
              );
            }
            _checkAndSplitToAllowedPosition(e) {
              const t = this._getAllowedIn(this.position.parent, e);
              if (!t) return !1;
              for (t != this.position.parent && this._insertPartialFragment(); t != this.position.parent; )
                if (this.position.isAtStart) {
                  const e = this.position.parent;
                  (this.position = this.writer.createPositionBefore(e)), e.isEmpty && e.parent === t && this.writer.remove(e);
                } else if (this.position.isAtEnd) this.position = this.writer.createPositionAfter(this.position.parent);
                else {
                  const e = this.writer.createPositionAfter(this.position.parent);
                  this._setAffectedBoundaries(this.position),
                    this.writer.split(this.position),
                    (this.position = e),
                    this.canMergeWith.add(this.position.nodeAfter);
                }
              return !0;
            }
            _getAllowedIn(e, t) {
              return this.schema.checkChild(e, t) ? e : this.schema.isLimit(e) ? null : this._getAllowedIn(e.parent, t);
            }
          }
          function kd(e, t, n = 'auto') {
            const o = e.getSelectedElement();
            if (o && t.schema.isObject(o) && !t.schema.isInline(o))
              return 'before' == n || 'after' == n ? t.createRange(t.createPositionAt(o, n)) : t.createRangeOn(o);
            const i = Ca(e.getSelectedBlocks());
            if (!i) return t.createRange(e.focus);
            if (i.isEmpty) return t.createRange(t.createPositionAt(i, 0));
            const r = t.createPositionAfter(i);
            return e.focus.isTouching(r) ? t.createRange(r) : t.createRange(t.createPositionBefore(i));
          }
          function bd(e, t, n, o, i = {}) {
            if (!e.schema.isObject(t)) throw new l('insertobject-element-not-an-object', e, { object: t });
            let r;
            r = n ? (n instanceof ol || n instanceof hl ? n : e.createSelection(n, o)) : e.document.selection;
            let s = r;
            i.findOptimalPosition && e.schema.isBlock(t) && (s = e.createSelection(kd(r, e, i.findOptimalPosition)));
            const a = Ca(r.getSelectedBlocks()),
              c = {};
            return (
              a && Object.assign(c, e.schema.getAttributesWithProperty(a, 'copyOnReplace', !0)),
              e.change((n) => {
                s.isCollapsed || e.deleteContent(s, { doNotAutoparagraph: !0 });
                let o = t;
                const r = s.anchor.parent;
                !e.schema.checkChild(r, t) &&
                  e.schema.checkChild(r, 'paragraph') &&
                  e.schema.checkChild('paragraph', t) &&
                  ((o = n.createElement('paragraph')), n.insert(t, o)),
                  e.schema.setAllowedAttributes(o, c, n);
                const a = e.insertContent(o, s);
                return (
                  a.isCollapsed ||
                    (i.setSelection &&
                      (function (e, t, n, o) {
                        const i = e.model;
                        if ('after' == n) {
                          let n = t.nextSibling;
                          !(n && i.schema.checkChild(n, '$text')) &&
                            i.schema.checkChild(t.parent, 'paragraph') &&
                            ((n = e.createElement('paragraph')),
                            i.schema.setAllowedAttributes(n, o, e),
                            i.insertContent(n, e.createPositionAfter(t))),
                            n && e.setSelection(n, 0);
                        } else {
                          if ('on' != n) throw new l('insertobject-invalid-place-parameter-value', i);
                          e.setSelection(t, 'on');
                        }
                      })(n, t, i.setSelection, c)),
                  a
                );
              })
            );
          }
          const wd = ' ,.?!:;"-()';
          function _d(e, t) {
            const { isForward: n, walker: o, unit: i, schema: r, treatEmojiAsSingleUnit: s } = e,
              { type: a, item: l, nextPosition: c } = t;
            if ('text' == a)
              return 'word' === e.unit
                ? (function (e, t) {
                    let n = e.position.textNode;
                    if (n) {
                      let o = e.position.offset - n.startOffset;
                      for (; !Ad(n.data, o, t) && !Cd(n, o, t); ) {
                        e.next();
                        const i = t ? e.position.nodeAfter : e.position.nodeBefore;
                        if (i && i.is('$text')) {
                          const o = i.data.charAt(t ? 0 : i.data.length - 1);
                          wd.includes(o) || (e.next(), (n = e.position.textNode));
                        }
                        o = e.position.offset - n.startOffset;
                      }
                    }
                    return e.position;
                  })(o, n)
                : (function (e, t, n) {
                    const o = e.position.textNode;
                    if (o) {
                      const i = o.data;
                      let r = e.position.offset - o.startOffset;
                      for (; _c(i, r) || ('character' == t && yc(i, r)) || (n && Cc(i, r)); )
                        e.next(), (r = e.position.offset - o.startOffset);
                    }
                    return e.position;
                  })(o, i, s);
            if (a == (n ? 'elementStart' : 'elementEnd')) {
              if (r.isSelectable(l)) return Ga._createAt(l, n ? 'after' : 'before');
              if (r.checkChild(c, '$text')) return c;
            } else {
              if (r.isLimit(l)) return void o.skip(() => !0);
              if (r.checkChild(c, '$text')) return c;
            }
          }
          function yd(e, t) {
            const n = e.root,
              o = Ga._createAt(n, t ? 'end' : 0);
            return t ? new Qa(e, o) : new Qa(o, e);
          }
          function Ad(e, t, n) {
            const o = t + (n ? 0 : -1);
            return wd.includes(e.charAt(o));
          }
          function Cd(e, t, n) {
            return t === (n ? e.endOffset : 0);
          }
          class vd extends N {
            constructor() {
              super(),
                (this.markers = new Dc()),
                (this.document = new xc(this)),
                (this.schema = new Wl()),
                (this._pendingChanges = []),
                (this._currentWriter = null),
                ['insertContent', 'insertObject', 'deleteContent', 'modifySelection', 'getSelectedContent', 'applyOperation'].forEach((e) =>
                  this.decorate(e)
                ),
                this.on(
                  'applyOperation',
                  (e, t) => {
                    t[0]._validate();
                  },
                  { priority: 'highest' }
                ),
                this.schema.register('$root', { isLimit: !0 }),
                this.schema.register('$container', { allowIn: ['$root', '$container'] }),
                this.schema.register('$block', { allowIn: ['$root', '$container'], isBlock: !0 }),
                this.schema.register('$blockObject', { allowWhere: '$block', isBlock: !0, isObject: !0 }),
                this.schema.register('$inlineObject', { allowWhere: '$text', allowAttributesOf: '$text', isInline: !0, isObject: !0 }),
                this.schema.register('$text', { allowIn: '$block', isInline: !0, isContent: !0 }),
                this.schema.register('$clipboardHolder', { allowContentOf: '$root', allowChildren: '$text', isLimit: !0 }),
                this.schema.register('$documentFragment', { allowContentOf: '$root', allowChildren: '$text', isLimit: !0 }),
                this.schema.register('$marker'),
                this.schema.addChildCheck((e, t) => {
                  if ('$marker' === t.name) return !0;
                }),
                nd(this),
                this.document.registerPostFixer(Sl);
            }
            change(e) {
              try {
                return 0 === this._pendingChanges.length
                  ? (this._pendingChanges.push({ batch: new mc(), callback: e }), this._runPendingChanges()[0])
                  : e(this._currentWriter);
              } catch (e) {
                l.rethrowUnexpectedError(e, this);
              }
            }
            enqueueChange(e, t) {
              try {
                e ? ('function' == typeof e ? ((t = e), (e = new mc())) : e instanceof mc || (e = new mc(e))) : (e = new mc()),
                  this._pendingChanges.push({ batch: e, callback: t }),
                  1 == this._pendingChanges.length && this._runPendingChanges();
              } catch (e) {
                l.rethrowUnexpectedError(e, this);
              }
            }
            applyOperation(e) {
              e._execute();
            }
            insertContent(e, t, n) {
              return (function (e, t, n, o) {
                return e.change((i) => {
                  let r;
                  (r = n ? (n instanceof ol || n instanceof hl ? n : i.createSelection(n, o)) : e.document.selection),
                    r.isCollapsed || e.deleteContent(r, { doNotAutoparagraph: !0 });
                  const s = new fd(e, i, r.anchor);
                  let a;
                  (a = t.is('documentFragment') ? t.getChildren() : [t]), s.handleNodes(a);
                  const l = s.getSelectionRange();
                  l && (r instanceof hl ? i.setSelection(l) : r.setTo(l));
                  const c = s.getAffectedRange() || e.createRange(r.anchor);
                  return s.destroy(), c;
                });
              })(this, e, t, n);
            }
            insertObject(e, t, n, o) {
              return bd(this, e, t, n, o);
            }
            deleteContent(e, t) {
              cd(this, e, t);
            }
            modifySelection(e, t) {
              !(function (e, t, n = {}) {
                const o = e.schema,
                  i = 'backward' != n.direction,
                  r = n.unit ? n.unit : 'character',
                  s = !!n.treatEmojiAsSingleUnit,
                  a = t.focus,
                  l = new qa({ boundaries: yd(a, i), singleCharacters: !0, direction: i ? 'forward' : 'backward' }),
                  c = { walker: l, schema: o, isForward: i, unit: r, treatEmojiAsSingleUnit: s };
                let d;
                for (; (d = l.next()); ) {
                  if (d.done) return;
                  const n = _d(c, d.value);
                  if (n)
                    return void (t instanceof hl
                      ? e.change((e) => {
                          e.setSelectionFocus(n);
                        })
                      : t.setFocus(n));
                }
              })(this, e, t);
            }
            getSelectedContent(e) {
              return (function (e, t) {
                return e.change((e) => {
                  const n = e.createDocumentFragment(),
                    o = t.getFirstRange();
                  if (!o || o.isCollapsed) return n;
                  const i = o.start.root,
                    r = o.start.getCommonPath(o.end),
                    s = i.getNodeByPath(r);
                  let a;
                  a =
                    o.start.parent == o.end.parent
                      ? o
                      : e.createRange(e.createPositionAt(s, o.start.path[r.length]), e.createPositionAt(s, o.end.path[r.length] + 1));
                  const l = a.end.offset - a.start.offset;
                  for (const t of a.getItems({ shallow: !0 }))
                    t.is('$textProxy') ? e.appendText(t.data, t.getAttributes(), n) : e.append(e.cloneElement(t, !0), n);
                  if (a != o) {
                    const t = o._getTransformedByMove(a.start, e.createPositionAt(n, 0), l)[0],
                      i = e.createRange(e.createPositionAt(n, 0), t.start);
                    pd(e.createRange(t.end, e.createPositionAt(n, 'end')), e), pd(i, e);
                  }
                  return n;
                });
              })(this, e);
            }
            hasContent(e, t = {}) {
              const n = e instanceof Qa ? e : Qa._createIn(e);
              if (n.isCollapsed) return !1;
              const { ignoreWhitespaces: o = !1, ignoreMarkers: i = !1 } = t;
              if (!i) for (const e of this.markers.getMarkersIntersectingRange(n)) if (e.affectsData) return !0;
              for (const e of n.getItems())
                if (this.schema.isContent(e)) {
                  if (!e.is('$textProxy')) return !0;
                  if (!o) return !0;
                  if (-1 !== e.data.search(/\S/)) return !0;
                }
              return !1;
            }
            createPositionFromPath(e, t, n) {
              return new Ga(e, t, n);
            }
            createPositionAt(e, t) {
              return Ga._createAt(e, t);
            }
            createPositionAfter(e) {
              return Ga._createAfter(e);
            }
            createPositionBefore(e) {
              return Ga._createBefore(e);
            }
            createRange(e, t) {
              return new Qa(e, t);
            }
            createRangeIn(e) {
              return Qa._createIn(e);
            }
            createRangeOn(e) {
              return Qa._createOn(e);
            }
            createSelection(...e) {
              return new ol(...e);
            }
            createBatch(e) {
              return new mc(e);
            }
            createOperationFromJSON(e) {
              return class {
                static fromJSON(e, t) {
                  return $c[e.__className].fromJSON(e, t);
                }
              }.fromJSON(e, this.document);
            }
            destroy() {
              this.document.destroy(), this.stopListening();
            }
            _runPendingChanges() {
              const e = [];
              this.fire('_beforeChanges');
              try {
                for (; this._pendingChanges.length; ) {
                  const t = this._pendingChanges[0].batch;
                  this._currentWriter = new Qc(this, t);
                  const n = this._pendingChanges[0].callback(this._currentWriter);
                  e.push(n),
                    this.document._handleChangeBlock(this._currentWriter),
                    this._pendingChanges.shift(),
                    (this._currentWriter = null);
                }
              } finally {
                (this._pendingChanges.length = 0), (this._currentWriter = null), this.fire('_afterChanges');
              }
              return e;
            }
          }
          class xd extends xa {
            constructor(e) {
              super(), (this.editor = e);
            }
            set(e, t, n = {}) {
              if ('string' == typeof t) {
                const e = t;
                t = (t, n) => {
                  this.editor.execute(e), n();
                };
              }
              super.set(e, t, n);
            }
          }
          class Ed {
            constructor(e = {}) {
              const t = e.language || (this.constructor.defaultConfig && this.constructor.defaultConfig.language);
              (this._context = e.context || new xo({ language: t })), this._context._addEditor(this, !e.context);
              const n = Array.from(this.constructor.builtinPlugins || []);
              (this.config = new ho(e, this.constructor.defaultConfig)),
                this.config.define('plugins', n),
                this.config.define(this._context._getEditorConfig()),
                (this.plugins = new ko(this, n, this._context.plugins)),
                (this.locale = this._context.locale),
                (this.t = this.locale.t),
                (this._readOnlyLocks = new Set()),
                (this.commands = new Fl()),
                this.set('state', 'initializing'),
                this.once('ready', () => (this.state = 'ready'), { priority: 'high' }),
                this.once('destroy', () => (this.state = 'destroyed'), { priority: 'high' }),
                (this.model = new vd());
              const o = new Si();
              (this.data = new cc(this.model, o)),
                (this.editing = new Vl(this.model, o)),
                this.editing.view.document.bind('isReadOnly').to(this),
                (this.conversion = new dc([this.editing.downcastDispatcher, this.data.downcastDispatcher], this.data.upcastDispatcher)),
                this.conversion.addAlias('dataDowncast', this.data.downcastDispatcher),
                this.conversion.addAlias('editingDowncast', this.editing.downcastDispatcher),
                (this.keystrokes = new xd(this)),
                this.keystrokes.listenTo(this.editing.view.document);
            }
            get isReadOnly() {
              return this._readOnlyLocks.size > 0;
            }
            set isReadOnly(e) {
              throw new l('editor-isreadonly-has-no-setter');
            }
            enableReadOnlyMode(e) {
              if ('string' != typeof e && 'symbol' != typeof e) throw new l('editor-read-only-lock-id-invalid', null, { lockId: e });
              this._readOnlyLocks.has(e) ||
                (this._readOnlyLocks.add(e), 1 === this._readOnlyLocks.size && this.fire('change:isReadOnly', 'isReadOnly', !0, !1));
            }
            disableReadOnlyMode(e) {
              if ('string' != typeof e && 'symbol' != typeof e) throw new l('editor-read-only-lock-id-invalid', null, { lockId: e });
              this._readOnlyLocks.has(e) &&
                (this._readOnlyLocks.delete(e), 0 === this._readOnlyLocks.size && this.fire('change:isReadOnly', 'isReadOnly', !1, !0));
            }
            initPlugins() {
              const e = this.config,
                t = e.get('plugins'),
                n = e.get('removePlugins') || [],
                o = e.get('extraPlugins') || [],
                i = e.get('substitutePlugins') || [];
              return this.plugins.init(t.concat(o), n, i);
            }
            destroy() {
              let e = Promise.resolve();
              return (
                'initializing' == this.state && (e = new Promise((e) => this.once('ready', e))),
                e
                  .then(() => {
                    this.fire('destroy'), this.stopListening(), this.commands.destroy();
                  })
                  .then(() => this.plugins.destroy())
                  .then(() => {
                    this.model.destroy(), this.data.destroy(), this.editing.destroy(), this.keystrokes.destroy();
                  })
                  .then(() => this._context._removeEditor(this))
              );
            }
            execute(...e) {
              try {
                return this.commands.execute(...e);
              } catch (e) {
                l.rethrowUnexpectedError(e, this);
              }
            }
            focus() {
              this.editing.view.focus();
            }
          }
          R(Ed, B);
          class Dd {
            constructor(e) {
              (this.editor = e), (this._components = new Map());
            }
            *names() {
              for (const e of this._components.values()) yield e.originalName;
            }
            add(e, t) {
              this._components.set(Td(e), { callback: t, originalName: e });
            }
            create(e) {
              if (!this.has(e)) throw new l('componentfactory-item-missing', this, { name: e });
              return this._components.get(Td(e)).callback(this.editor.locale);
            }
            has(e) {
              return this._components.has(Td(e));
            }
          }
          function Td(e) {
            return String(e).toLowerCase();
          }
          class Id extends fo {
            constructor(e = []) {
              super(e, { idProperty: 'viewUid' }),
                this.on('add', (e, t, n) => {
                  this._renderViewIntoCollectionParent(t, n);
                }),
                this.on('remove', (e, t) => {
                  t.element && this._parentElement && t.element.remove();
                }),
                (this._parentElement = null);
            }
            destroy() {
              this.map((e) => e.destroy());
            }
            setParent(e) {
              this._parentElement = e;
              for (const e of this) this._renderViewIntoCollectionParent(e);
            }
            delegate(...e) {
              if (!e.length || !e.every((e) => 'string' == typeof e)) throw new l('ui-viewcollection-delegate-wrong-events', this);
              return {
                to: (t) => {
                  for (const n of this) for (const o of e) n.delegate(o).to(t);
                  this.on('add', (n, o) => {
                    for (const n of e) o.delegate(n).to(t);
                  }),
                    this.on('remove', (n, o) => {
                      for (const n of e) o.stopDelegating(n, t);
                    });
                },
              };
            }
            _renderViewIntoCollectionParent(e, t) {
              e.isRendered || e.render(),
                e.element && this._parentElement && this._parentElement.insertBefore(e.element, this._parentElement.children[t]);
            }
          }
          class Sd {
            constructor(e) {
              Object.assign(this, Vd(Rd(e))), (this._isRendered = !1), (this._revertData = null);
            }
            render() {
              const e = this._renderNode({ intoFragment: !0 });
              return (this._isRendered = !0), e;
            }
            apply(e) {
              return (
                (this._revertData = { children: [], bindings: [], attributes: {} }),
                this._renderNode({ node: e, isApplying: !0, revertData: this._revertData }),
                e
              );
            }
            revert(e) {
              if (!this._revertData) throw new l('ui-template-revert-not-applied', [this, e]);
              this._revertTemplateFromNode(e, this._revertData);
            }
            *getViews() {
              yield* (function* e(t) {
                if (t.children) for (const n of t.children) Gd(n) ? yield n : $d(n) && (yield* e(n));
              })(this);
            }
            static bind(e, t) {
              return {
                to: (n, o) => new Bd({ eventNameOrFunction: n, attribute: n, observable: e, emitter: t, callback: o }),
                if: (n, o, i) => new Nd({ observable: e, emitter: t, attribute: n, valueIfTrue: o, callback: i }),
              };
            }
            static extend(e, t) {
              if (e._isRendered) throw new l('template-extend-render', [this, e]);
              qd(e, Vd(Rd(t)));
            }
            _renderNode(e) {
              let t;
              if (((t = e.node ? this.tag && this.text : this.tag ? this.text : !this.text), t))
                throw new l('ui-template-wrong-syntax', this);
              return this.text ? this._renderText(e) : this._renderElement(e);
            }
            _renderElement(e) {
              let t = e.node;
              return (
                t || (t = e.node = document.createElementNS(this.ns || 'http://www.w3.org/1999/xhtml', this.tag)),
                this._renderAttributes(e),
                this._renderElementChildren(e),
                this._setUpListeners(e),
                t
              );
            }
            _renderText(e) {
              let t = e.node;
              return (
                t ? (e.revertData.text = t.textContent) : (t = e.node = document.createTextNode('')),
                Pd(this.text)
                  ? this._bindToObservable({ schema: this.text, updater: Ld(t), data: e })
                  : (t.textContent = this.text.join('')),
                t
              );
            }
            _renderAttributes(e) {
              let t, n, o, i;
              if (!this.attributes) return;
              const r = e.node,
                s = e.revertData;
              for (t in this.attributes)
                if (
                  ((o = r.getAttribute(t)),
                  (n = this.attributes[t]),
                  s && (s.attributes[t] = o),
                  (i = E(n[0]) && n[0].ns ? n[0].ns : null),
                  Pd(n))
                ) {
                  const a = i ? n[0].value : n;
                  s && Kd(t) && a.unshift(o), this._bindToObservable({ schema: a, updater: jd(r, t, i), data: e });
                } else
                  'style' == t && 'string' != typeof n[0]
                    ? this._renderStyleAttribute(n[0], e)
                    : (s && o && Kd(t) && n.unshift(o),
                      (n = n
                        .map((e) => (e && e.value) || e)
                        .reduce((e, t) => e.concat(t), [])
                        .reduce(Hd, '')),
                      Wd(n) || r.setAttributeNS(i, t, n));
            }
            _renderStyleAttribute(e, t) {
              const n = t.node;
              for (const o in e) {
                const i = e[o];
                Pd(i) ? this._bindToObservable({ schema: [i], updater: Od(n, o), data: t }) : (n.style[o] = i);
              }
            }
            _renderElementChildren(e) {
              const t = e.node,
                n = e.intoFragment ? document.createDocumentFragment() : t,
                o = e.isApplying;
              let i = 0;
              for (const r of this.children)
                if (Yd(r)) {
                  if (!o) {
                    r.setParent(t);
                    for (const e of r) n.appendChild(e.element);
                  }
                } else if (Gd(r)) o || (r.isRendered || r.render(), n.appendChild(r.element));
                else if (Zr(r)) n.appendChild(r);
                else if (o) {
                  const t = { children: [], bindings: [], attributes: {} };
                  e.revertData.children.push(t), r._renderNode({ node: n.childNodes[i++], isApplying: !0, revertData: t });
                } else n.appendChild(r.render());
              e.intoFragment && t.appendChild(n);
            }
            _setUpListeners(e) {
              if (this.eventListeners)
                for (const t in this.eventListeners) {
                  const n = this.eventListeners[t].map((n) => {
                    const [o, i] = t.split('@');
                    return n.activateDomEventListener(o, i, e);
                  });
                  e.revertData && e.revertData.bindings.push(n);
                }
            }
            _bindToObservable({ schema: e, updater: t, data: n }) {
              const o = n.revertData;
              zd(e, t, n);
              const i = e
                .filter((e) => !Wd(e))
                .filter((e) => e.observable)
                .map((o) => o.activateAttributeListener(e, t, n));
              o && o.bindings.push(i);
            }
            _revertTemplateFromNode(e, t) {
              for (const e of t.bindings) for (const t of e) t();
              if (t.text) e.textContent = t.text;
              else {
                for (const n in t.attributes) {
                  const o = t.attributes[n];
                  null === o ? e.removeAttribute(n) : e.setAttribute(n, o);
                }
                for (let n = 0; n < t.children.length; ++n) this._revertTemplateFromNode(e.childNodes[n], t.children[n]);
              }
            }
          }
          R(Sd, k);
          class Md {
            constructor(e) {
              Object.assign(this, e);
            }
            getValue(e) {
              const t = this.observable[this.attribute];
              return this.callback ? this.callback(t, e) : t;
            }
            activateAttributeListener(e, t, n) {
              const o = () => zd(e, t, n);
              return (
                this.emitter.listenTo(this.observable, 'change:' + this.attribute, o),
                () => {
                  this.emitter.stopListening(this.observable, 'change:' + this.attribute, o);
                }
              );
            }
          }
          class Bd extends Md {
            activateDomEventListener(e, t, n) {
              const o = (e, n) => {
                (t && !n.target.matches(t)) ||
                  ('function' == typeof this.eventNameOrFunction
                    ? this.eventNameOrFunction(n)
                    : this.observable.fire(this.eventNameOrFunction, n));
              };
              return (
                this.emitter.listenTo(n.node, e, o),
                () => {
                  this.emitter.stopListening(n.node, e, o);
                }
              );
            }
          }
          class Nd extends Md {
            getValue(e) {
              return !Wd(super.getValue(e)) && (this.valueIfTrue || !0);
            }
          }
          function Pd(e) {
            return !!e && (e.value && (e = e.value), Array.isArray(e) ? e.some(Pd) : e instanceof Md);
          }
          function zd(e, t, { node: n }) {
            let o = (function (e, t) {
              return e.map((e) => (e instanceof Md ? e.getValue(t) : e));
            })(e, n);
            (o = 1 == e.length && e[0] instanceof Nd ? o[0] : o.reduce(Hd, '')), Wd(o) ? t.remove() : t.set(o);
          }
          function Ld(e) {
            return {
              set(t) {
                e.textContent = t;
              },
              remove() {
                e.textContent = '';
              },
            };
          }
          function jd(e, t, n) {
            return {
              set(o) {
                e.setAttributeNS(n, t, o);
              },
              remove() {
                e.removeAttributeNS(n, t);
              },
            };
          }
          function Od(e, t) {
            return {
              set(n) {
                e.style[t] = n;
              },
              remove() {
                e.style[t] = null;
              },
            };
          }
          function Rd(e) {
            return co(e, (e) => {
              if (e && (e instanceof Md || $d(e) || Gd(e) || Yd(e))) return e;
            });
          }
          function Vd(e) {
            if (
              ('string' == typeof e
                ? (e = (function (e) {
                    return { text: [e] };
                  })(e))
                : e.text &&
                  (function (e) {
                    e.text = bo(e.text);
                  })(e),
              e.on &&
                ((e.eventListeners = (function (e) {
                  for (const t in e) Fd(e, t);
                  return e;
                })(e.on)),
                delete e.on),
              !e.text)
            ) {
              e.attributes &&
                (function (e) {
                  for (const t in e) e[t].value && (e[t].value = bo(e[t].value)), Fd(e, t);
                })(e.attributes);
              const t = [];
              if (e.children)
                if (Yd(e.children)) t.push(e.children);
                else for (const n of e.children) $d(n) || Gd(n) || Zr(n) ? t.push(n) : t.push(new Sd(n));
              e.children = t;
            }
            return e;
          }
          function Fd(e, t) {
            e[t] = bo(e[t]);
          }
          function Hd(e, t) {
            return Wd(t) ? e : Wd(e) ? t : `${e} ${t}`;
          }
          function Ud(e, t) {
            for (const n in t) e[n] ? e[n].push(...t[n]) : (e[n] = t[n]);
          }
          function qd(e, t) {
            if (
              (t.attributes && (e.attributes || (e.attributes = {}), Ud(e.attributes, t.attributes)),
              t.eventListeners && (e.eventListeners || (e.eventListeners = {}), Ud(e.eventListeners, t.eventListeners)),
              t.text && e.text.push(...t.text),
              t.children && t.children.length)
            ) {
              if (e.children.length != t.children.length) throw new l('ui-template-extend-children-mismatch', e);
              let n = 0;
              for (const o of t.children) qd(e.children[n++], o);
            }
          }
          function Wd(e) {
            return !e && 0 !== e;
          }
          function Gd(e) {
            return e instanceof Jd;
          }
          function $d(e) {
            return e instanceof Sd;
          }
          function Yd(e) {
            return e instanceof Id;
          }
          function Kd(e) {
            return 'class' == e || 'style' == e;
          }
          var Qd = n(6150),
            Zd = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Qd.Z, Zd);
          Qd.Z.locals;
          class Jd {
            constructor(e) {
              (this.element = null),
                (this.isRendered = !1),
                (this.locale = e),
                (this.t = e && e.t),
                (this._viewCollections = new fo()),
                (this._unboundChildren = this.createCollection()),
                this._viewCollections.on('add', (t, n) => {
                  n.locale = e;
                }),
                this.decorate('render');
            }
            get bindTemplate() {
              return this._bindTemplate ? this._bindTemplate : (this._bindTemplate = Sd.bind(this, this));
            }
            createCollection(e) {
              const t = new Id(e);
              return this._viewCollections.add(t), t;
            }
            registerChild(e) {
              po(e) || (e = [e]);
              for (const t of e) this._unboundChildren.add(t);
            }
            deregisterChild(e) {
              po(e) || (e = [e]);
              for (const t of e) this._unboundChildren.remove(t);
            }
            setTemplate(e) {
              this.template = new Sd(e);
            }
            extendTemplate(e) {
              Sd.extend(this.template, e);
            }
            render() {
              if (this.isRendered) throw new l('ui-view-render-already-rendered', this);
              this.template && ((this.element = this.template.render()), this.registerChild(this.template.getViews())),
                (this.isRendered = !0);
            }
            destroy() {
              this.stopListening(),
                this._viewCollections.map((e) => e.destroy()),
                this.template && this.template._revertData && this.template.revert(this.element);
            }
          }
          function Xd({ element: e, target: t, positions: n, limiter: o, fitInViewport: i, viewportOffsetConfig: r }) {
            De(t) && (t = t()), De(o) && (o = o());
            const s = (function (e) {
                return e && e.parentNode ? (e.offsetParent === _o.document.body ? null : e.offsetParent) : null;
              })(e),
              a = new ka(e),
              l = new ka(t);
            let c;
            const d =
                (i &&
                  (function (e) {
                    e = Object.assign({ top: 0, bottom: 0, left: 0, right: 0 }, e);
                    const t = new ka(_o.window);
                    return (t.top += e.top), (t.height -= e.top), (t.bottom -= e.bottom), (t.height -= e.bottom), t;
                  })(r)) ||
                null,
              u = { targetRect: l, elementRect: a, positionedElementAncestor: s, viewportRect: d };
            if (o || i) {
              const e = o && new ka(o).getVisible();
              Object.assign(u, { limiterRect: e, viewportRect: d }),
                (c =
                  (function (e, t) {
                    const { elementRect: n } = t,
                      o = n.getArea(),
                      i = e.map((e) => new tu(e, t)).filter((e) => !!e.name);
                    let r = 0,
                      s = null;
                    for (const e of i) {
                      const { limiterIntersectionArea: t, viewportIntersectionArea: n } = e;
                      if (t === o) return e;
                      const i = n ** 2 + t ** 2;
                      i > r && ((r = i), (s = e));
                    }
                    return s;
                  })(n, u) || new tu(n[0], u));
            } else c = new tu(n[0], u);
            return c;
          }
          function eu(e) {
            const { scrollX: t, scrollY: n } = _o.window;
            return e.clone().moveBy(t, n);
          }
          R(Jd, bs), R(Jd, B);
          class tu {
            constructor(e, t) {
              const n = e(t.targetRect, t.elementRect, t.viewportRect);
              if (!n) return;
              const { left: o, top: i, name: r, config: s } = n;
              (this.name = r), (this.config = s), (this._positioningFunctionCorrdinates = { left: o, top: i }), (this._options = t);
            }
            get left() {
              return this._absoluteRect.left;
            }
            get top() {
              return this._absoluteRect.top;
            }
            get limiterIntersectionArea() {
              const e = this._options.limiterRect;
              if (e) {
                const t = this._options.viewportRect;
                if (!t) return e.getIntersectionArea(this._rect);
                {
                  const n = e.getIntersection(t);
                  if (n) return n.getIntersectionArea(this._rect);
                }
              }
              return 0;
            }
            get viewportIntersectionArea() {
              const e = this._options.viewportRect;
              return e ? e.getIntersectionArea(this._rect) : 0;
            }
            get _rect() {
              return (
                this._cachedRect ||
                  (this._cachedRect = this._options.elementRect
                    .clone()
                    .moveTo(this._positioningFunctionCorrdinates.left, this._positioningFunctionCorrdinates.top)),
                this._cachedRect
              );
            }
            get _absoluteRect() {
              return (
                this._cachedAbsoluteRect ||
                  ((this._cachedAbsoluteRect = eu(this._rect)),
                  this._options.positionedElementAncestor &&
                    (function (e, t) {
                      const n = eu(new ka(t)),
                        o = pa(t);
                      let i = 0,
                        r = 0;
                      (i -= n.left), (r -= n.top), (i += t.scrollLeft), (r += t.scrollTop), (i -= o.left), (r -= o.top), e.moveBy(i, r);
                    })(this._cachedAbsoluteRect, this._options.positionedElementAncestor)),
                this._cachedAbsoluteRect
              );
            }
          }
          function nu(e) {
            return (t) => t + e;
          }
          var ou = n(8245),
            iu = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(ou.Z, iu);
          ou.Z.locals;
          const ru = nu('px'),
            su = _o.document.body;
          class au extends Jd {
            constructor(e) {
              super(e);
              const t = this.bindTemplate;
              this.set('top', 0),
                this.set('left', 0),
                this.set('position', 'arrow_nw'),
                this.set('isVisible', !1),
                this.set('withArrow', !0),
                this.set('class'),
                (this.content = this.createCollection()),
                this.setTemplate({
                  tag: 'div',
                  attributes: {
                    class: [
                      'ck',
                      'ck-balloon-panel',
                      t.to('position', (e) => `ck-balloon-panel_${e}`),
                      t.if('isVisible', 'ck-balloon-panel_visible'),
                      t.if('withArrow', 'ck-balloon-panel_with-arrow'),
                      t.to('class'),
                    ],
                    style: { top: t.to('top', ru), left: t.to('left', ru) },
                  },
                  children: this.content,
                });
            }
            show() {
              this.isVisible = !0;
            }
            hide() {
              this.isVisible = !1;
            }
            attachTo(e) {
              this.show();
              const t = au.defaultPositions,
                n = Object.assign(
                  {},
                  {
                    element: this.element,
                    positions: [
                      t.southArrowNorth,
                      t.southArrowNorthMiddleWest,
                      t.southArrowNorthMiddleEast,
                      t.southArrowNorthWest,
                      t.southArrowNorthEast,
                      t.northArrowSouth,
                      t.northArrowSouthMiddleWest,
                      t.northArrowSouthMiddleEast,
                      t.northArrowSouthWest,
                      t.northArrowSouthEast,
                      t.viewportStickyNorth,
                    ],
                    limiter: su,
                    fitInViewport: !0,
                  },
                  e
                ),
                o = au._getOptimalPosition(n),
                i = parseInt(o.left),
                r = parseInt(o.top),
                { name: s, config: a = {} } = o,
                { withArrow: l = !0 } = a;
              Object.assign(this, { top: r, left: i, position: s, withArrow: l });
            }
            pin(e) {
              this.unpin(),
                (this._pinWhenIsVisibleCallback = () => {
                  this.isVisible ? this._startPinning(e) : this._stopPinning();
                }),
                this._startPinning(e),
                this.listenTo(this, 'change:isVisible', this._pinWhenIsVisibleCallback);
            }
            unpin() {
              this._pinWhenIsVisibleCallback &&
                (this._stopPinning(),
                this.stopListening(this, 'change:isVisible', this._pinWhenIsVisibleCallback),
                (this._pinWhenIsVisibleCallback = null),
                this.hide());
            }
            _startPinning(e) {
              this.attachTo(e);
              const t = lu(e.target),
                n = e.limiter ? lu(e.limiter) : su;
              this.listenTo(
                _o.document,
                'scroll',
                (o, i) => {
                  const r = i.target,
                    s = t && r.contains(t),
                    a = n && r.contains(n);
                  (!s && !a && t && n) || this.attachTo(e);
                },
                { useCapture: !0 }
              ),
                this.listenTo(_o.window, 'resize', () => {
                  this.attachTo(e);
                });
            }
            _stopPinning() {
              this.stopListening(_o.document, 'scroll'), this.stopListening(_o.window, 'resize');
            }
          }
          function lu(e) {
            return uo(e) ? e : ga(e) ? e.commonAncestorContainer : 'function' == typeof e ? lu(e()) : null;
          }
          function cu({
            sideOffset: e = au.arrowSideOffset,
            heightOffset: t = au.arrowHeightOffset,
            stickyVerticalOffset: n = au.stickyVerticalOffset,
            config: o,
          } = {}) {
            return {
              northWestArrowSouthWest: (t, n) => ({ top: i(t, n), left: t.left - e, name: 'arrow_sw', ...(o && { config: o }) }),
              northWestArrowSouthMiddleWest: (t, n) => ({
                top: i(t, n),
                left: t.left - 0.25 * n.width - e,
                name: 'arrow_smw',
                ...(o && { config: o }),
              }),
              northWestArrowSouth: (e, t) => ({ top: i(e, t), left: e.left - t.width / 2, name: 'arrow_s', ...(o && { config: o }) }),
              northWestArrowSouthMiddleEast: (t, n) => ({
                top: i(t, n),
                left: t.left - 0.75 * n.width + e,
                name: 'arrow_sme',
                ...(o && { config: o }),
              }),
              northWestArrowSouthEast: (t, n) => ({ top: i(t, n), left: t.left - n.width + e, name: 'arrow_se', ...(o && { config: o }) }),
              northArrowSouthWest: (t, n) => ({ top: i(t, n), left: t.left + t.width / 2 - e, name: 'arrow_sw', ...(o && { config: o }) }),
              northArrowSouthMiddleWest: (t, n) => ({
                top: i(t, n),
                left: t.left + t.width / 2 - 0.25 * n.width - e,
                name: 'arrow_smw',
                ...(o && { config: o }),
              }),
              northArrowSouth: (e, t) => ({
                top: i(e, t),
                left: e.left + e.width / 2 - t.width / 2,
                name: 'arrow_s',
                ...(o && { config: o }),
              }),
              northArrowSouthMiddleEast: (t, n) => ({
                top: i(t, n),
                left: t.left + t.width / 2 - 0.75 * n.width + e,
                name: 'arrow_sme',
                ...(o && { config: o }),
              }),
              northArrowSouthEast: (t, n) => ({
                top: i(t, n),
                left: t.left + t.width / 2 - n.width + e,
                name: 'arrow_se',
                ...(o && { config: o }),
              }),
              northEastArrowSouthWest: (t, n) => ({ top: i(t, n), left: t.right - e, name: 'arrow_sw', ...(o && { config: o }) }),
              northEastArrowSouthMiddleWest: (t, n) => ({
                top: i(t, n),
                left: t.right - 0.25 * n.width - e,
                name: 'arrow_smw',
                ...(o && { config: o }),
              }),
              northEastArrowSouth: (e, t) => ({ top: i(e, t), left: e.right - t.width / 2, name: 'arrow_s', ...(o && { config: o }) }),
              northEastArrowSouthMiddleEast: (t, n) => ({
                top: i(t, n),
                left: t.right - 0.75 * n.width + e,
                name: 'arrow_sme',
                ...(o && { config: o }),
              }),
              northEastArrowSouthEast: (t, n) => ({ top: i(t, n), left: t.right - n.width + e, name: 'arrow_se', ...(o && { config: o }) }),
              southWestArrowNorthWest: (t, n) => ({ top: r(t), left: t.left - e, name: 'arrow_nw', ...(o && { config: o }) }),
              southWestArrowNorthMiddleWest: (t, n) => ({
                top: r(t),
                left: t.left - 0.25 * n.width - e,
                name: 'arrow_nmw',
                ...(o && { config: o }),
              }),
              southWestArrowNorth: (e, t) => ({ top: r(e), left: e.left - t.width / 2, name: 'arrow_n', ...(o && { config: o }) }),
              southWestArrowNorthMiddleEast: (t, n) => ({
                top: r(t),
                left: t.left - 0.75 * n.width + e,
                name: 'arrow_nme',
                ...(o && { config: o }),
              }),
              southWestArrowNorthEast: (t, n) => ({ top: r(t), left: t.left - n.width + e, name: 'arrow_ne', ...(o && { config: o }) }),
              southArrowNorthWest: (t, n) => ({ top: r(t), left: t.left + t.width / 2 - e, name: 'arrow_nw', ...(o && { config: o }) }),
              southArrowNorthMiddleWest: (t, n) => ({
                top: r(t),
                left: t.left + t.width / 2 - 0.25 * n.width - e,
                name: 'arrow_nmw',
                ...(o && { config: o }),
              }),
              southArrowNorth: (e, t) => ({
                top: r(e),
                left: e.left + e.width / 2 - t.width / 2,
                name: 'arrow_n',
                ...(o && { config: o }),
              }),
              southArrowNorthMiddleEast: (t, n) => ({
                top: r(t),
                left: t.left + t.width / 2 - 0.75 * n.width + e,
                name: 'arrow_nme',
                ...(o && { config: o }),
              }),
              southArrowNorthEast: (t, n) => ({
                top: r(t),
                left: t.left + t.width / 2 - n.width + e,
                name: 'arrow_ne',
                ...(o && { config: o }),
              }),
              southEastArrowNorthWest: (t, n) => ({ top: r(t), left: t.right - e, name: 'arrow_nw', ...(o && { config: o }) }),
              southEastArrowNorthMiddleWest: (t, n) => ({
                top: r(t),
                left: t.right - 0.25 * n.width - e,
                name: 'arrow_nmw',
                ...(o && { config: o }),
              }),
              southEastArrowNorth: (e, t) => ({ top: r(e), left: e.right - t.width / 2, name: 'arrow_n', ...(o && { config: o }) }),
              southEastArrowNorthMiddleEast: (t, n) => ({
                top: r(t),
                left: t.right - 0.75 * n.width + e,
                name: 'arrow_nme',
                ...(o && { config: o }),
              }),
              southEastArrowNorthEast: (t, n) => ({ top: r(t), left: t.right - n.width + e, name: 'arrow_ne', ...(o && { config: o }) }),
              westArrowEast: (e, n) => ({
                top: e.top + e.height / 2 - n.height / 2,
                left: e.left - n.width - t,
                name: 'arrow_e',
                ...(o && { config: o }),
              }),
              eastArrowWest: (e, n) => ({
                top: e.top + e.height / 2 - n.height / 2,
                left: e.right + t,
                name: 'arrow_w',
                ...(o && { config: o }),
              }),
              viewportStickyNorth: (e, t, i) =>
                e.getIntersection(i)
                  ? { top: i.top + n, left: e.left + e.width / 2 - t.width / 2, name: 'arrowless', config: { withArrow: !1, ...o } }
                  : null,
            };
            function i(e, n) {
              return e.top - n.height - t;
            }
            function r(e) {
              return e.bottom + t;
            }
          }
          (au.arrowSideOffset = 25),
            (au.arrowHeightOffset = 10),
            (au.stickyVerticalOffset = 20),
            (au._getOptimalPosition = Xd),
            (au.defaultPositions = cu());
          var du = n(9948),
            uu = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(du.Z, uu);
          du.Z.locals;
          const hu = 'ck-tooltip';
          class mu {
            constructor(e) {
              if ((mu._editors.add(e), mu._instance)) return mu._instance;
              (mu._instance = this),
                (this.tooltipTextView = new Jd(e.locale)),
                this.tooltipTextView.set('text', ''),
                this.tooltipTextView.setTemplate({
                  tag: 'span',
                  attributes: { class: ['ck', 'ck-tooltip__text'] },
                  children: [{ text: this.tooltipTextView.bindTemplate.to('text') }],
                }),
                (this.balloonPanelView = new au(e.locale)),
                (this.balloonPanelView.class = hu),
                this.balloonPanelView.content.add(this.tooltipTextView),
                (this._currentElementWithTooltip = null),
                (this._currentTooltipPosition = null),
                (this._pinTooltipDebounced = aa(this._pinTooltip, 600)),
                this.listenTo(_o.document, 'mouseenter', this._onEnterOrFocus.bind(this), { useCapture: !0 }),
                this.listenTo(_o.document, 'mouseleave', this._onLeaveOrBlur.bind(this), { useCapture: !0 }),
                this.listenTo(_o.document, 'focus', this._onEnterOrFocus.bind(this), { useCapture: !0 }),
                this.listenTo(_o.document, 'blur', this._onLeaveOrBlur.bind(this), { useCapture: !0 }),
                this.listenTo(_o.document, 'scroll', this._onScroll.bind(this), { useCapture: !0 }),
                (this._watchdogExcluded = !0);
            }
            destroy(e) {
              mu._editors.delete(e),
                this.stopListening(e.ui),
                mu._editors.size || (this._unpinTooltip(), this.balloonPanelView.destroy(), this.stopListening(), (mu._instance = null));
            }
            _onEnterOrFocus(e, { target: t }) {
              const n = gu(t);
              var o;
              n &&
                n !== this._currentElementWithTooltip &&
                (this._unpinTooltip(),
                this._pinTooltipDebounced(n, {
                  text: (o = n).dataset.ckeTooltipText,
                  position: o.dataset.ckeTooltipPosition || 's',
                  cssClass: o.dataset.ckeTooltipClass || '',
                }));
            }
            _onLeaveOrBlur(e, { target: t, relatedTarget: n }) {
              if ('mouseleave' === e.name) {
                if (!uo(t)) return;
                if (this._currentElementWithTooltip && t !== this._currentElementWithTooltip) return;
                const e = gu(t),
                  o = gu(n);
                e && e !== o && this._unpinTooltip();
              } else {
                if (this._currentElementWithTooltip && t !== this._currentElementWithTooltip) return;
                this._unpinTooltip();
              }
            }
            _onScroll(e, { target: t }) {
              this._currentElementWithTooltip &&
                ((t.contains(this.balloonPanelView.element) && t.contains(this._currentElementWithTooltip)) || this._unpinTooltip());
            }
            _pinTooltip(e, { text: t, position: n, cssClass: o }) {
              const i = Ca(mu._editors.values()).ui.view.body;
              i.has(this.balloonPanelView) || i.add(this.balloonPanelView),
                (this.tooltipTextView.text = t),
                this.balloonPanelView.pin({ target: e, positions: mu.getPositioningFunctions(n) }),
                (this.balloonPanelView.class = [hu, o].filter((e) => e).join(' '));
              for (const e of mu._editors) this.listenTo(e.ui, 'update', this._updateTooltipPosition.bind(this), { priority: 'low' });
              (this._currentElementWithTooltip = e), (this._currentTooltipPosition = n);
            }
            _unpinTooltip() {
              this._pinTooltipDebounced.cancel(), this.balloonPanelView.unpin();
              for (const e of mu._editors) this.stopListening(e.ui, 'update');
              (this._currentElementWithTooltip = null), (this._currentTooltipPosition = null);
            }
            _updateTooltipPosition() {
              Aa(this._currentElementWithTooltip)
                ? this.balloonPanelView.pin({
                    target: this._currentElementWithTooltip,
                    positions: mu.getPositioningFunctions(this._currentTooltipPosition),
                  })
                : this._unpinTooltip();
            }
            static getPositioningFunctions(e) {
              const t = mu.defaultBalloonPositions;
              return {
                s: [t.southArrowNorth, t.southArrowNorthEast, t.southArrowNorthWest],
                n: [t.northArrowSouth],
                e: [t.eastArrowWest],
                w: [t.westArrowEast],
                sw: [t.southArrowNorthEast],
                se: [t.southArrowNorthWest],
              }[e];
            }
          }
          function gu(e) {
            return uo(e) ? e.closest('[data-cke-tooltip-text]:not([data-cke-tooltip-disabled])') : null;
          }
          R(mu, bs),
            (mu.defaultBalloonPositions = cu({ heightOffset: 5, sideOffset: 13 })),
            (mu._instance = null),
            (mu._editors = new Set());
          class pu {
            constructor(e) {
              (this.editor = e),
                (this.componentFactory = new Dd(e)),
                (this.focusTracker = new va()),
                (this.tooltipManager = new mu(e)),
                this.set('viewportOffset', this._readViewportOffsetFromConfig()),
                (this.isReady = !1),
                this.once('ready', () => {
                  this.isReady = !0;
                }),
                (this._editableElementsMap = new Map()),
                (this._focusableToolbarDefinitions = []),
                this.listenTo(e.editing.view.document, 'layoutChanged', () => this.update()),
                this._initFocusTracking();
            }
            get element() {
              return null;
            }
            update() {
              this.fire('update');
            }
            destroy() {
              this.stopListening(), this.focusTracker.destroy(), this.tooltipManager.destroy(this.editor);
              for (const e of this._editableElementsMap.values()) e.ckeditorInstance = null;
              (this._editableElementsMap = new Map()), (this._focusableToolbarDefinitions = []);
            }
            setEditableElement(e, t) {
              this._editableElementsMap.set(e, t), t.ckeditorInstance || (t.ckeditorInstance = this.editor), this.focusTracker.add(t);
              const n = () => {
                this.editor.editing.view.getDomRoot(e) || this.editor.keystrokes.listenTo(t);
              };
              this.isReady ? n() : this.once('ready', n);
            }
            getEditableElement(e = 'main') {
              return this._editableElementsMap.get(e);
            }
            getEditableElementsNames() {
              return this._editableElementsMap.keys();
            }
            addToolbar(e, t = {}) {
              e.isRendered
                ? (this.focusTracker.add(e.element), this.editor.keystrokes.listenTo(e.element))
                : e.once('render', () => {
                    this.focusTracker.add(e.element), this.editor.keystrokes.listenTo(e.element);
                  }),
                this._focusableToolbarDefinitions.push({ toolbarView: e, options: t });
            }
            get _editableElements() {
              return (
                console.warn(
                  'editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.',
                  { editorUI: this }
                ),
                this._editableElementsMap
              );
            }
            _readViewportOffsetFromConfig() {
              const e = this.editor,
                t = e.config.get('ui.viewportOffset');
              if (t) return t;
              const n = e.config.get('toolbar.viewportTopOffset');
              return n
                ? (console.warn(
                    'editor-ui-deprecated-viewport-offset-config: The `toolbar.vieportTopOffset` configuration option is deprecated. It will be removed from future CKEditor versions. Use `ui.viewportOffset.top` instead.'
                  ),
                  { top: n })
                : { top: 0 };
            }
            _initFocusTracking() {
              const e = this.editor,
                t = e.editing.view;
              let n, o;
              e.keystrokes.set('Alt+F10', (e, i) => {
                const r = this.focusTracker.focusedElement;
                Array.from(this._editableElementsMap.values()).includes(r) && !Array.from(t.domRoots.values()).includes(r) && (n = r);
                const s = this._getCurrentFocusedToolbarDefinition();
                (s && o) || (o = this._getFocusableCandidateToolbarDefinitions(s));
                for (let e = 0; e < o.length; e++) {
                  const e = o.shift();
                  if ((o.push(e), e !== s && this._focusFocusableCandidateToolbar(e))) {
                    s && s.options.afterBlur && s.options.afterBlur();
                    break;
                  }
                }
                i();
              }),
                e.keystrokes.set('Esc', (t, o) => {
                  const i = this._getCurrentFocusedToolbarDefinition();
                  i && (n ? (n.focus(), (n = null)) : e.editing.view.focus(), i.options.afterBlur && i.options.afterBlur(), o());
                });
            }
            _getFocusableCandidateToolbarDefinitions() {
              const e = [];
              for (const t of this._focusableToolbarDefinitions) {
                const { toolbarView: n, options: o } = t;
                (Aa(n.element) || o.beforeFocus) && e.push(t);
              }
              return e.sort((e, t) => fu(e) - fu(t)), e;
            }
            _getCurrentFocusedToolbarDefinition() {
              for (const e of this._focusableToolbarDefinitions)
                if (e.toolbarView.element && e.toolbarView.element.contains(this.focusTracker.focusedElement)) return e;
              return null;
            }
            _focusFocusableCandidateToolbar(e) {
              const {
                toolbarView: t,
                options: { beforeFocus: n },
              } = e;
              return n && n(), !!Aa(t.element) && (t.focus(), !0);
            }
          }
          function fu(e) {
            const { toolbarView: t, options: n } = e;
            let o = 10;
            return Aa(t.element) && o--, n.isContextual && o--, o;
          }
          R(pu, B);
          const ku = {
              setData(e) {
                this.data.set(e);
              },
              getData(e) {
                return this.data.get(e);
              },
            },
            bu = ku;
          function wu(e, t) {
            e instanceof HTMLTextAreaElement && (e.value = t), (e.innerHTML = t);
          }
          const _u = {
            updateSourceElement(e = this.data.get()) {
              if (!this.sourceElement) throw new l('editor-missing-sourceelement', this);
              const t = this.config.get('updateSourceElementOnDestroy'),
                n = this.sourceElement instanceof HTMLTextAreaElement;
              wu(this.sourceElement, t || n ? e : '');
            },
          };
          class yu extends Eo {
            static get pluginName() {
              return 'PendingActions';
            }
            init() {
              this.set('hasAny', !1), (this._actions = new fo({ idProperty: '_id' })), this._actions.delegate('add', 'remove').to(this);
            }
            add(e) {
              if ('string' != typeof e) throw new l('pendingactions-add-invalid-message', this);
              const t = Object.create(B);
              return t.set('message', e), this._actions.add(t), (this.hasAny = !0), t;
            }
            remove(e) {
              this._actions.remove(e), (this.hasAny = !!this._actions.length);
            }
            get first() {
              return this._actions.get(0);
            }
            [Symbol.iterator]() {
              return this._actions[Symbol.iterator]();
            }
          }
          const Au =
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>',
            Cu = {
              cancel:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.591 10.177 4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>',
              caption:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 16h9a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2z"/><path d="M17 1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 1.5H3a.5.5 0 0 0-.492.41L2.5 3v9a.5.5 0 0 0 .41.492L3 12.5h14a.5.5 0 0 0 .492-.41L17.5 12V3a.5.5 0 0 0-.41-.492L17 2.5z" fill-opacity=".6"/></svg>',
              check:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>',
              cog: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.333 2 .19 2.263a5.899 5.899 0 0 1 1.458.604L14.714 3.4 16.6 5.286l-1.467 1.733c.263.452.468.942.605 1.46L18 8.666v2.666l-2.263.19a5.899 5.899 0 0 1-.604 1.458l1.467 1.733-1.886 1.886-1.733-1.467a5.899 5.899 0 0 1-1.46.605L11.334 18H8.667l-.19-2.263a5.899 5.899 0 0 1-1.458-.604L5.286 16.6 3.4 14.714l1.467-1.733a5.899 5.899 0 0 1-.604-1.458L2 11.333V8.667l2.262-.189a5.899 5.899 0 0 1 .605-1.459L3.4 5.286 5.286 3.4l1.733 1.467a5.899 5.899 0 0 1 1.46-.605L8.666 2h2.666zM10 6.267a3.733 3.733 0 1 0 0 7.466 3.733 3.733 0 0 0 0-7.466z"/></svg>',
              eraser:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m8.636 9.531-2.758 3.94a.5.5 0 0 0 .122.696l3.224 2.284h1.314l2.636-3.736L8.636 9.53zm.288 8.451L5.14 15.396a2 2 0 0 1-.491-2.786l6.673-9.53a2 2 0 0 1 2.785-.49l3.742 2.62a2 2 0 0 1 .491 2.785l-7.269 10.053-2.147-.066z"/><path d="M4 18h5.523v-1H4zm-2 0h1v-1H2z"/></svg>',
              lowVision:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22 2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>',
              image:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.91 10.54c.26-.23.64-.21.88.03l3.36 3.14 2.23-2.06a.64.64 0 0 1 .87 0l2.52 2.97V4.5H3.2v10.12l3.71-4.08zm10.27-7.51c.6 0 1.09.47 1.09 1.05v11.84c0 .59-.49 1.06-1.09 1.06H2.79c-.6 0-1.09-.47-1.09-1.06V4.08c0-.58.49-1.05 1.1-1.05h14.38zm-5.22 5.56a1.96 1.96 0 1 1 3.4-1.96 1.96 1.96 0 0 1-3.4 1.96z"/></svg>',
              alignBottom:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.239 13.938-2.88-1.663a.75.75 0 0 1 .75-1.3L9 12.067V4.75a.75.75 0 1 1 1.5 0v7.318l1.89-1.093a.75.75 0 0 1 .75 1.3l-2.879 1.663a.752.752 0 0 1-.511.187.752.752 0 0 1-.511-.187zM4.25 17a.75.75 0 1 1 0-1.5h10.5a.75.75 0 0 1 0 1.5H4.25z"/></svg>',
              alignMiddle:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 11.875a.752.752 0 0 1 .508.184l2.883 1.666a.75.75 0 0 1-.659 1.344l-.091-.044-1.892-1.093.001 4.318a.75.75 0 1 1-1.5 0v-4.317l-1.89 1.092a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .51-.187zM15.25 9a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM9.75.375a.75.75 0 0 1 .75.75v4.318l1.89-1.093.092-.045a.75.75 0 0 1 .659 1.344l-2.883 1.667a.752.752 0 0 1-.508.184.752.752 0 0 1-.511-.187L6.359 5.65a.75.75 0 0 1 .75-1.299L9 5.442V1.125a.75.75 0 0 1 .75-.75z"/></svg>',
              alignTop:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m10.261 7.062 2.88 1.663a.75.75 0 0 1-.75 1.3L10.5 8.933v7.317a.75.75 0 1 1-1.5 0V8.932l-1.89 1.093a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .511-.187.752.752 0 0 1 .511.187zM15.25 4a.75.75 0 1 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h10.5z"/></svg>',
              alignLeft:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
              alignCenter:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75z"/></svg>',
              alignRight:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75zm0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75z"/></svg>',
              alignJustify:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
              objectLeft:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zm0-3H18v1.5h-4.5zm0-3H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
              objectCenter:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M15.003 7v5.5a1 1 0 0 1-1 1H5.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H6.5V12h6.997V7.5z"/></svg>',
              objectRight:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2zm0-9h5v1.5H2zm0 3h5v1.5H2zm0 3h5v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>',
              objectFullWidth:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18 7v5.5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm-1.505.5H3.504V12h12.991V7.5z"/></svg>',
              objectInline:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
              objectBlockLeft:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
              objectBlockRight:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>',
              objectSizeFull:
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M18.095 2H1.905C.853 2 0 2.895 0 4v12c0 1.105.853 2 1.905 2h16.19C19.147 18 20 17.105 20 16V4c0-1.105-.853-2-1.905-2zm0 1.5c.263 0 .476.224.476.5v12c0 .276-.213.5-.476.5H1.905a.489.489 0 0 1-.476-.5V4c0-.276.213-.5.476-.5h16.19z"/></svg>',
              objectSizeLarge:
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M13 6H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h11z"/></svg>',
              objectSizeSmall:
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M7 10H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h5z"/></svg>',
              objectSizeMedium:
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M10 8H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h8z"/></svg>',
              pencil:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m7.3 17.37-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506 13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5 9.375 17H19v1.5H8z"/></svg>',
              pilcrow:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.999 2H15a1 1 0 0 1 0 2h-1.004v13a1 1 0 1 1-2 0V4H8.999v13a1 1 0 1 1-2 0v-7A4 4 0 0 1 3 6a4 4 0 0 1 3.999-4z"/></svg>',
              quote:
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>',
              threeVerticalDots: Au,
            };
          function vu({ emitter: e, activator: t, callback: n, contextElements: o }) {
            e.listenTo(document, 'mousedown', (e, i) => {
              if (!t()) return;
              const r = 'function' == typeof i.composedPath ? i.composedPath() : [];
              for (const e of o) if (e.contains(i.target) || r.includes(e)) return;
              n();
            });
          }
          function xu(e) {
            e.set('_isCssTransitionsDisabled', !1),
              (e.disableCssTransitions = () => {
                e._isCssTransitionsDisabled = !0;
              }),
              (e.enableCssTransitions = () => {
                e._isCssTransitionsDisabled = !1;
              }),
              e.extendTemplate({ attributes: { class: [e.bindTemplate.if('_isCssTransitionsDisabled', 'ck-transitions-disabled')] } });
          }
          function Eu({ view: e }) {
            e.listenTo(
              e.element,
              'submit',
              (t, n) => {
                n.preventDefault(), e.fire('submit');
              },
              { useCapture: !0 }
            );
          }
          function Du({ keystrokeHandler: e, focusTracker: t, gridItems: n, numberOfColumns: o }) {
            const i = 'number' == typeof o ? () => o : o;
            function r(e) {
              return (o) => {
                const i = n.find((e) => e.element === t.focusedElement),
                  r = n.getIndex(i),
                  s = e(r, n);
                n.get(s).focus(), o.stopPropagation(), o.preventDefault();
              };
            }
            e.set(
              'arrowright',
              r((e, t) => (e === t.length - 1 ? 0 : e + 1))
            ),
              e.set(
                'arrowleft',
                r((e, t) => (0 === e ? t.length - 1 : e - 1))
              ),
              e.set(
                'arrowup',
                r((e, t) => {
                  let n = e - i();
                  return n < 0 && ((n = e + i() * Math.floor(t.length / i())), n > t.length - 1 && (n -= i())), n;
                })
              ),
              e.set(
                'arrowdown',
                r((e, t) => {
                  let n = e + i();
                  return n > t.length - 1 && (n = e % i()), n;
                })
              );
          }
          const Tu = function (e) {
            return 'string' == typeof e || (!Ct(e) && se(e) && '[object String]' == oe(e));
          };
          class Iu extends Id {
            constructor(e, t = []) {
              super(t), (this.locale = e);
            }
            attachToDom() {
              this._bodyCollectionContainer = new Sd({
                tag: 'div',
                attributes: { class: ['ck', 'ck-reset_all', 'ck-body', 'ck-rounded-corners'], dir: this.locale.uiLanguageDirection },
                children: this,
              }).render();
              let e = document.querySelector('.ck-body-wrapper');
              e ||
                ((e = (function (e, t, n = {}, o = []) {
                  const i = n && n.xmlns,
                    r = i ? e.createElementNS(i, t) : e.createElement(t);
                  for (const e in n) r.setAttribute(e, n[e]);
                  (!Tu(o) && po(o)) || (o = [o]);
                  for (let t of o) Tu(t) && (t = e.createTextNode(t)), r.appendChild(t);
                  return r;
                })(document, 'div', { class: 'ck-body-wrapper' })),
                document.body.appendChild(e)),
                e.appendChild(this._bodyCollectionContainer);
            }
            detachFromDom() {
              super.destroy(), this._bodyCollectionContainer && this._bodyCollectionContainer.remove();
              const e = document.querySelector('.ck-body-wrapper');
              e && 0 == e.childElementCount && e.remove();
            }
          }
          var Su = n(1174),
            Mu = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Su.Z, Mu);
          Su.Z.locals;
          class Bu extends Jd {
            constructor() {
              super();
              const e = this.bindTemplate;
              this.set('content', ''),
                this.set('viewBox', '0 0 20 20'),
                this.set('fillColor', ''),
                this.setTemplate({
                  tag: 'svg',
                  ns: 'http://www.w3.org/2000/svg',
                  attributes: { class: ['ck', 'ck-icon'], viewBox: e.to('viewBox') },
                });
            }
            render() {
              super.render(),
                this._updateXMLContent(),
                this._colorFillPaths(),
                this.on('change:content', () => {
                  this._updateXMLContent(), this._colorFillPaths();
                }),
                this.on('change:fillColor', () => {
                  this._colorFillPaths();
                });
            }
            _updateXMLContent() {
              if (this.content) {
                const e = new DOMParser().parseFromString(this.content.trim(), 'image/svg+xml').querySelector('svg'),
                  t = e.getAttribute('viewBox');
                for (t && (this.viewBox = t); this.element.firstChild; ) this.element.removeChild(this.element.firstChild);
                for (; e.childNodes.length > 0; ) this.element.appendChild(e.childNodes[0]);
              }
            }
            _colorFillPaths() {
              this.fillColor &&
                this.element.querySelectorAll('.ck-icon__fill').forEach((e) => {
                  e.style.fill = this.fillColor;
                });
            }
          }
          var Nu = n(4499),
            Pu = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Nu.Z, Pu);
          Nu.Z.locals;
          class zu extends Jd {
            constructor(e) {
              super(e);
              const t = this.bindTemplate,
                n = r();
              this.set('class'),
                this.set('labelStyle'),
                this.set('icon'),
                this.set('isEnabled', !0),
                this.set('isOn', !1),
                this.set('isVisible', !0),
                this.set('isToggleable', !1),
                this.set('keystroke'),
                this.set('label'),
                this.set('tabindex', -1),
                this.set('tooltip'),
                this.set('tooltipPosition', 's'),
                this.set('type', 'button'),
                this.set('withText', !1),
                this.set('withKeystroke', !1),
                (this.children = this.createCollection()),
                (this.labelView = this._createLabelView(n)),
                (this.iconView = new Bu()),
                this.iconView.extendTemplate({ attributes: { class: 'ck-button__icon' } }),
                (this.keystrokeView = this._createKeystrokeView()),
                this.bind('_tooltipString').to(this, 'tooltip', this, 'label', this, 'keystroke', this._getTooltipString.bind(this));
              const o = {
                tag: 'button',
                attributes: {
                  class: [
                    'ck',
                    'ck-button',
                    t.to('class'),
                    t.if('isEnabled', 'ck-disabled', (e) => !e),
                    t.if('isVisible', 'ck-hidden', (e) => !e),
                    t.to('isOn', (e) => (e ? 'ck-on' : 'ck-off')),
                    t.if('withText', 'ck-button_with-text'),
                    t.if('withKeystroke', 'ck-button_with-keystroke'),
                  ],
                  type: t.to('type', (e) => e || 'button'),
                  tabindex: t.to('tabindex'),
                  'aria-labelledby': `ck-editor__aria-label_${n}`,
                  'aria-disabled': t.if('isEnabled', !0, (e) => !e),
                  'aria-pressed': t.to('isOn', (e) => !!this.isToggleable && String(!!e)),
                  'data-cke-tooltip-text': t.to('_tooltipString'),
                  'data-cke-tooltip-position': t.to('tooltipPosition'),
                },
                children: this.children,
                on: {
                  click: t.to((e) => {
                    this.isEnabled ? this.fire('execute') : e.preventDefault();
                  }),
                },
              };
              lr.isSafari &&
                (o.on.mousedown = t.to((e) => {
                  this.focus(), e.preventDefault();
                })),
                this.setTemplate(o);
            }
            render() {
              super.render(),
                this.icon && (this.iconView.bind('content').to(this, 'icon'), this.children.add(this.iconView)),
                this.children.add(this.labelView),
                this.withKeystroke && this.keystroke && this.children.add(this.keystrokeView);
            }
            focus() {
              this.element.focus();
            }
            _createLabelView(e) {
              const t = new Jd(),
                n = this.bindTemplate;
              return (
                t.setTemplate({
                  tag: 'span',
                  attributes: { class: ['ck', 'ck-button__label'], style: n.to('labelStyle'), id: `ck-editor__aria-label_${e}` },
                  children: [{ text: this.bindTemplate.to('label') }],
                }),
                t
              );
            }
            _createKeystrokeView() {
              const e = new Jd();
              return (
                e.setTemplate({
                  tag: 'span',
                  attributes: { class: ['ck', 'ck-button__keystroke'] },
                  children: [{ text: this.bindTemplate.to('keystroke', (e) => fr(e)) }],
                }),
                e
              );
            }
            _getTooltipString(e, t, n) {
              return e
                ? 'string' == typeof e
                  ? e
                  : (n && (n = fr(n)), e instanceof Function ? e(t, n) : `${t}${n ? ` (${n})` : ''}`)
                : '';
            }
          }
          var Lu = n(9681),
            ju = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Lu.Z, ju);
          Lu.Z.locals;
          class Ou extends zu {
            constructor(e) {
              super(e),
                (this.isToggleable = !0),
                (this.toggleSwitchView = this._createToggleView()),
                this.extendTemplate({ attributes: { class: 'ck-switchbutton' } });
            }
            render() {
              super.render(), this.children.add(this.toggleSwitchView);
            }
            _createToggleView() {
              const e = new Jd();
              return (
                e.setTemplate({
                  tag: 'span',
                  attributes: { class: ['ck', 'ck-button__toggle'] },
                  children: [{ tag: 'span', attributes: { class: ['ck', 'ck-button__toggle__inner'] } }],
                }),
                e
              );
            }
          }
          function Ru(e, t) {
            const n = e.t,
              o = {
                Black: n('Black'),
                'Dim grey': n('Dim grey'),
                Grey: n('Grey'),
                'Light grey': n('Light grey'),
                White: n('White'),
                Red: n('Red'),
                Orange: n('Orange'),
                Yellow: n('Yellow'),
                'Light green': n('Light green'),
                Green: n('Green'),
                Aquamarine: n('Aquamarine'),
                Turquoise: n('Turquoise'),
                'Light blue': n('Light blue'),
                Blue: n('Blue'),
                Purple: n('Purple'),
              };
            return t.map((e) => {
              const t = o[e.label];
              return t && t != e.label && (e.label = t), e;
            });
          }
          function Vu(e) {
            return e.map(Fu).filter((e) => !!e);
          }
          function Fu(e) {
            return 'string' == typeof e
              ? { model: e, label: e, hasBorder: !1, view: { name: 'span', styles: { color: e } } }
              : {
                  model: e.color,
                  label: e.label || e.color,
                  hasBorder: void 0 !== e.hasBorder && e.hasBorder,
                  view: { name: 'span', styles: { color: `${e.color}` } },
                };
          }
          class Hu extends zu {
            constructor(e) {
              super(e);
              const t = this.bindTemplate;
              this.set('color'),
                this.set('hasBorder'),
                (this.icon =
                  '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path class="ck-icon__fill" d="M16.935 5.328a2 2 0 0 1 0 2.829l-7.778 7.778a2 2 0 0 1-2.829 0L3.5 13.107a1.999 1.999 0 1 1 2.828-2.829l.707.707a1 1 0 0 0 1.414 0l5.658-5.657a2 2 0 0 1 2.828 0z"/><path d="M14.814 6.035 8.448 12.4a1 1 0 0 1-1.414 0l-1.413-1.415A1 1 0 1 0 4.207 12.4l2.829 2.829a1 1 0 0 0 1.414 0l7.778-7.778a1 1 0 1 0-1.414-1.415z"/></svg>'),
                this.extendTemplate({
                  attributes: {
                    style: { backgroundColor: t.to('color') },
                    class: ['ck', 'ck-color-grid__tile', t.if('hasBorder', 'ck-color-table__color-tile_bordered')],
                  },
                });
            }
            render() {
              super.render(), (this.iconView.fillColor = 'hsl(0, 0%, 100%)');
            }
          }
          var Uu = n(4923),
            qu = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Uu.Z, qu);
          Uu.Z.locals;
          class Wu extends Jd {
            constructor(e, t) {
              super(e);
              const n = (t && t.colorDefinitions) || [],
                o = {};
              (this.columns = t && t.columns ? t.columns : 5),
                (o.gridTemplateColumns = `repeat( ${this.columns}, 1fr)`),
                this.set('selectedColor'),
                (this.items = this.createCollection()),
                (this.focusTracker = new va()),
                (this.keystrokes = new xa()),
                this.items.on('add', (e, t) => {
                  t.isOn = t.color === this.selectedColor;
                }),
                n.forEach((e) => {
                  const t = new Hu();
                  t.set({ color: e.color, label: e.label, tooltip: !0, hasBorder: e.options.hasBorder }),
                    t.on('execute', () => {
                      this.fire('execute', { value: e.color, hasBorder: e.options.hasBorder, label: e.label });
                    }),
                    this.items.add(t);
                }),
                this.setTemplate({ tag: 'div', children: this.items, attributes: { class: ['ck', 'ck-color-grid'], style: o } }),
                this.on('change:selectedColor', (e, t, n) => {
                  for (const e of this.items) e.isOn = e.color === n;
                });
            }
            focus() {
              this.items.length && this.items.first.focus();
            }
            focusLast() {
              this.items.length && this.items.last.focus();
            }
            render() {
              super.render();
              for (const e of this.items) this.focusTracker.add(e.element);
              this.items.on('add', (e, t) => {
                this.focusTracker.add(t.element);
              }),
                this.items.on('remove', (e, t) => {
                  this.focusTracker.remove(t.element);
                }),
                this.keystrokes.listenTo(this.element),
                Du({
                  keystrokeHandler: this.keystrokes,
                  focusTracker: this.focusTracker,
                  gridItems: this.items,
                  numberOfColumns: this.columns,
                });
            }
            destroy() {
              super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
            }
          }
          const Gu =
            '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';
          class $u extends zu {
            constructor(e) {
              super(e),
                (this.arrowView = this._createArrowView()),
                this.extendTemplate({
                  attributes: { 'aria-haspopup': !0, 'aria-expanded': this.bindTemplate.to('isOn', (e) => String(e)) },
                }),
                this.delegate('execute').to(this, 'open');
            }
            render() {
              super.render(), this.children.add(this.arrowView);
            }
            _createArrowView() {
              const e = new Bu();
              return (e.content = Gu), e.extendTemplate({ attributes: { class: 'ck-dropdown__arrow' } }), e;
            }
          }
          var Yu = n(66),
            Ku = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Yu.Z, Ku);
          Yu.Z.locals;
          class Qu extends Jd {
            constructor(e) {
              super(e);
              const t = this.bindTemplate;
              this.set('class'),
                this.set('icon'),
                this.set('isEnabled', !0),
                this.set('isOn', !1),
                this.set('isToggleable', !1),
                this.set('isVisible', !0),
                this.set('keystroke'),
                this.set('label'),
                this.set('tabindex', -1),
                this.set('tooltip'),
                this.set('tooltipPosition', 's'),
                this.set('type', 'button'),
                this.set('withText', !1),
                (this.children = this.createCollection()),
                (this.actionView = this._createActionView()),
                (this.arrowView = this._createArrowView()),
                (this.keystrokes = new xa()),
                (this.focusTracker = new va()),
                this.setTemplate({
                  tag: 'div',
                  attributes: {
                    class: [
                      'ck',
                      'ck-splitbutton',
                      t.to('class'),
                      t.if('isVisible', 'ck-hidden', (e) => !e),
                      this.arrowView.bindTemplate.if('isOn', 'ck-splitbutton_open'),
                    ],
                  },
                  children: this.children,
                });
            }
            render() {
              super.render(),
                this.children.add(this.actionView),
                this.children.add(this.arrowView),
                this.focusTracker.add(this.actionView.element),
                this.focusTracker.add(this.arrowView.element),
                this.keystrokes.listenTo(this.element),
                this.keystrokes.set('arrowright', (e, t) => {
                  this.focusTracker.focusedElement === this.actionView.element && (this.arrowView.focus(), t());
                }),
                this.keystrokes.set('arrowleft', (e, t) => {
                  this.focusTracker.focusedElement === this.arrowView.element && (this.actionView.focus(), t());
                });
            }
            destroy() {
              super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
            }
            focus() {
              this.actionView.focus();
            }
            _createActionView() {
              const e = new zu();
              return (
                e
                  .bind(
                    'icon',
                    'isEnabled',
                    'isOn',
                    'isToggleable',
                    'keystroke',
                    'label',
                    'tabindex',
                    'tooltip',
                    'tooltipPosition',
                    'type',
                    'withText'
                  )
                  .to(this),
                e.extendTemplate({ attributes: { class: 'ck-splitbutton__action' } }),
                e.delegate('execute').to(this),
                e
              );
            }
            _createArrowView() {
              const e = new zu(),
                t = e.bindTemplate;
              return (
                (e.icon = Gu),
                e.extendTemplate({
                  attributes: {
                    class: ['ck-splitbutton__arrow'],
                    'data-cke-tooltip-disabled': t.to('isOn'),
                    'aria-haspopup': !0,
                    'aria-expanded': t.to('isOn', (e) => String(e)),
                  },
                }),
                e.bind('isEnabled').to(this),
                e.bind('label').to(this),
                e.bind('tooltip').to(this),
                e.delegate('execute').to(this, 'open'),
                e
              );
            }
          }
          class Zu extends Jd {
            constructor(e) {
              super(e);
              const t = this.bindTemplate;
              this.set('isVisible', !1),
                this.set('position', 'se'),
                (this.children = this.createCollection()),
                this.setTemplate({
                  tag: 'div',
                  attributes: {
                    class: [
                      'ck',
                      'ck-reset',
                      'ck-dropdown__panel',
                      t.to('position', (e) => `ck-dropdown__panel_${e}`),
                      t.if('isVisible', 'ck-dropdown__panel-visible'),
                    ],
                  },
                  children: this.children,
                  on: { selectstart: t.to((e) => e.preventDefault()) },
                });
            }
            focus() {
              this.children.length &&
                ('function' == typeof this.children.first.focus
                  ? this.children.first.focus()
                  : c('ui-dropdown-panel-focus-child-missing-focus', { childView: this.children.first, dropdownPanel: this }));
            }
            focusLast() {
              if (this.children.length) {
                const e = this.children.last;
                'function' == typeof e.focusLast ? e.focusLast() : e.focus();
              }
            }
          }
          var Ju = n(3488),
            Xu = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Ju.Z, Xu);
          Ju.Z.locals;
          class eh extends Jd {
            constructor(e, t, n) {
              super(e);
              const o = this.bindTemplate;
              (this.buttonView = t),
                (this.panelView = n),
                this.set('isOpen', !1),
                this.set('isEnabled', !0),
                this.set('class'),
                this.set('id'),
                this.set('panelPosition', 'auto'),
                (this.keystrokes = new xa()),
                this.setTemplate({
                  tag: 'div',
                  attributes: {
                    class: ['ck', 'ck-dropdown', o.to('class'), o.if('isEnabled', 'ck-disabled', (e) => !e)],
                    id: o.to('id'),
                    'aria-describedby': o.to('ariaDescribedById'),
                  },
                  children: [t, n],
                }),
                t.extendTemplate({ attributes: { class: ['ck-dropdown__button'], 'data-cke-tooltip-disabled': o.to('isOpen') } });
            }
            render() {
              super.render(),
                this.listenTo(this.buttonView, 'open', () => {
                  this.isOpen = !this.isOpen;
                }),
                this.panelView.bind('isVisible').to(this, 'isOpen'),
                this.on('change:isOpen', () => {
                  this.isOpen
                    ? ('auto' === this.panelPosition
                        ? (this.panelView.position = eh._getOptimalPosition({
                            element: this.panelView.element,
                            target: this.buttonView.element,
                            fitInViewport: !0,
                            positions: this._panelPositions,
                          }).name)
                        : (this.panelView.position = this.panelPosition),
                      this.panelView.focus())
                    : this.focus();
                }),
                this.keystrokes.listenTo(this.element);
              const e = (e, t) => {
                this.isOpen && ((this.isOpen = !1), t());
              };
              this.keystrokes.set('arrowdown', (e, t) => {
                this.buttonView.isEnabled && !this.isOpen && ((this.isOpen = !0), t());
              }),
                this.keystrokes.set('arrowright', (e, t) => {
                  this.isOpen && t();
                }),
                this.keystrokes.set('arrowleft', e),
                this.keystrokes.set('esc', e);
            }
            focus() {
              this.buttonView.focus();
            }
            get _panelPositions() {
              const {
                south: e,
                north: t,
                southEast: n,
                southWest: o,
                northEast: i,
                northWest: r,
                southMiddleEast: s,
                southMiddleWest: a,
                northMiddleEast: l,
                northMiddleWest: c,
              } = eh.defaultPanelPositions;
              return 'rtl' !== this.locale.uiLanguageDirection ? [n, o, s, a, e, i, r, l, c, t] : [o, n, a, s, e, r, i, c, l, t];
            }
          }
          (eh.defaultPanelPositions = {
            south: (e, t) => ({ top: e.bottom, left: e.left - (t.width - e.width) / 2, name: 's' }),
            southEast: (e) => ({ top: e.bottom, left: e.left, name: 'se' }),
            southWest: (e, t) => ({ top: e.bottom, left: e.left - t.width + e.width, name: 'sw' }),
            southMiddleEast: (e, t) => ({ top: e.bottom, left: e.left - (t.width - e.width) / 4, name: 'sme' }),
            southMiddleWest: (e, t) => ({ top: e.bottom, left: e.left - (3 * (t.width - e.width)) / 4, name: 'smw' }),
            north: (e, t) => ({ top: e.top - t.height, left: e.left - (t.width - e.width) / 2, name: 'n' }),
            northEast: (e, t) => ({ top: e.top - t.height, left: e.left, name: 'ne' }),
            northWest: (e, t) => ({ top: e.top - t.height, left: e.left - t.width + e.width, name: 'nw' }),
            northMiddleEast: (e, t) => ({ top: e.top - t.height, left: e.left - (t.width - e.width) / 4, name: 'nme' }),
            northMiddleWest: (e, t) => ({ top: e.top - t.height, left: e.left - (3 * (t.width - e.width)) / 4, name: 'nmw' }),
          }),
            (eh._getOptimalPosition = Xd);
          class th {
            constructor(e) {
              if ((Object.assign(this, e), e.actions && e.keystrokeHandler))
                for (const t in e.actions) {
                  let n = e.actions[t];
                  'string' == typeof n && (n = [n]);
                  for (const o of n)
                    e.keystrokeHandler.set(o, (e, n) => {
                      this[t](), n();
                    });
                }
            }
            get first() {
              return this.focusables.find(nh) || null;
            }
            get last() {
              return this.focusables.filter(nh).slice(-1)[0] || null;
            }
            get next() {
              return this._getFocusableItem(1);
            }
            get previous() {
              return this._getFocusableItem(-1);
            }
            get current() {
              let e = null;
              return null === this.focusTracker.focusedElement
                ? null
                : (this.focusables.find((t, n) => {
                    const o = t.element === this.focusTracker.focusedElement;
                    return o && (e = n), o;
                  }),
                  e);
            }
            focusFirst() {
              this._focus(this.first);
            }
            focusLast() {
              this._focus(this.last);
            }
            focusNext() {
              this._focus(this.next);
            }
            focusPrevious() {
              this._focus(this.previous);
            }
            _focus(e) {
              e && e.focus();
            }
            _getFocusableItem(e) {
              const t = this.current,
                n = this.focusables.length;
              if (!n) return null;
              if (null === t) return this[1 === e ? 'first' : 'last'];
              let o = (t + n + e) % n;
              do {
                const t = this.focusables.get(o);
                if (nh(t)) return t;
                o = (o + n + e) % n;
              } while (o !== t);
              return null;
            }
          }
          function nh(e) {
            return !(!e.focus || !Aa(e.element));
          }
          class oh extends Jd {
            constructor(e) {
              super(e), this.setTemplate({ tag: 'span', attributes: { class: ['ck', 'ck-toolbar__separator'] } });
            }
          }
          class ih extends Jd {
            constructor(e) {
              super(e), this.setTemplate({ tag: 'span', attributes: { class: ['ck', 'ck-toolbar__line-break'] } });
            }
          }
          function rh(e) {
            return Array.isArray(e)
              ? { items: e, removeItems: [] }
              : e
              ? Object.assign({ items: [], removeItems: [] }, e)
              : { items: [], removeItems: [] };
          }
          var sh = n(5571),
            ah = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(sh.Z, ah);
          sh.Z.locals;
          class lh extends Jd {
            constructor(e, t) {
              super(e);
              const n = this.bindTemplate,
                o = this.t;
              (this.options = t || {}),
                this.set('ariaLabel', o('Editor toolbar')),
                this.set('maxWidth', 'auto'),
                (this.items = this.createCollection()),
                (this.focusTracker = new va()),
                (this.keystrokes = new xa()),
                this.set('class'),
                this.set('isCompact', !1),
                (this.itemsView = new ch(e)),
                (this.children = this.createCollection()),
                this.children.add(this.itemsView),
                (this.focusables = this.createCollection());
              const i = 'rtl' === e.uiLanguageDirection;
              this._focusCycler = new th({
                focusables: this.focusables,
                focusTracker: this.focusTracker,
                keystrokeHandler: this.keystrokes,
                actions: {
                  focusPrevious: [i ? 'arrowright' : 'arrowleft', 'arrowup'],
                  focusNext: [i ? 'arrowleft' : 'arrowright', 'arrowdown'],
                },
              });
              const r = ['ck', 'ck-toolbar', n.to('class'), n.if('isCompact', 'ck-toolbar_compact')];
              var s;
              this.options.shouldGroupWhenFull && this.options.isFloating && r.push('ck-toolbar_floating'),
                this.setTemplate({
                  tag: 'div',
                  attributes: { class: r, role: 'toolbar', 'aria-label': n.to('ariaLabel'), style: { maxWidth: n.to('maxWidth') } },
                  children: this.children,
                  on: {
                    mousedown:
                      ((s = this),
                      s.bindTemplate.to((e) => {
                        e.target === s.element && e.preventDefault();
                      })),
                  },
                }),
                (this._behavior = this.options.shouldGroupWhenFull ? new uh(this) : new dh(this));
            }
            render() {
              super.render();
              for (const e of this.items) this.focusTracker.add(e.element);
              this.items.on('add', (e, t) => {
                this.focusTracker.add(t.element);
              }),
                this.items.on('remove', (e, t) => {
                  this.focusTracker.remove(t.element);
                }),
                this.keystrokes.listenTo(this.element),
                this._behavior.render(this);
            }
            destroy() {
              return this._behavior.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy(), super.destroy();
            }
            focus() {
              this._focusCycler.focusFirst();
            }
            focusLast() {
              this._focusCycler.focusLast();
            }
            fillFromConfig(e, t) {
              const n = rh(e),
                o = n.items.filter(
                  (e, o, i) =>
                    '|' === e ||
                    (-1 === n.removeItems.indexOf(e) &&
                      ('-' === e
                        ? !this.options.shouldGroupWhenFull || (c('toolbarview-line-break-ignored-when-grouping-items', i), !1)
                        : !!t.has(e) || (c('toolbarview-item-unavailable', { name: e }), !1)))
                ),
                i = this._cleanSeparators(o).map((e) => ('|' === e ? new oh() : '-' === e ? new ih() : t.create(e)));
              this.items.addMany(i);
            }
            _cleanSeparators(e) {
              const t = (e) => '-' !== e && '|' !== e,
                n = e.length,
                o = e.findIndex(t),
                i = n - e.slice().reverse().findIndex(t);
              return e.slice(o, i).filter((e, n, o) => {
                if (t(e)) return !0;
                return !(n > 0 && o[n - 1] === e);
              });
            }
          }
          class ch extends Jd {
            constructor(e) {
              super(e),
                (this.children = this.createCollection()),
                this.setTemplate({ tag: 'div', attributes: { class: ['ck', 'ck-toolbar__items'] }, children: this.children });
            }
          }
          class dh {
            constructor(e) {
              const t = e.bindTemplate;
              e.set('isVertical', !1),
                e.itemsView.children.bindTo(e.items).using((e) => e),
                e.focusables.bindTo(e.items).using((e) => e),
                e.extendTemplate({ attributes: { class: [t.if('isVertical', 'ck-toolbar_vertical')] } });
            }
            render() {}
            destroy() {}
          }
          class uh {
            constructor(e) {
              (this.view = e),
                (this.viewChildren = e.children),
                (this.viewFocusables = e.focusables),
                (this.viewItemsView = e.itemsView),
                (this.viewFocusTracker = e.focusTracker),
                (this.viewLocale = e.locale),
                (this.ungroupedItems = e.createCollection()),
                (this.groupedItems = e.createCollection()),
                (this.groupedItemsDropdown = this._createGroupedItemsDropdown()),
                (this.resizeObserver = null),
                (this.cachedPadding = null),
                (this.shouldUpdateGroupingOnNextResize = !1),
                e.itemsView.children.bindTo(this.ungroupedItems).using((e) => e),
                this.ungroupedItems.on('add', this._updateFocusCycleableItems.bind(this)),
                this.ungroupedItems.on('remove', this._updateFocusCycleableItems.bind(this)),
                e.children.on('add', this._updateFocusCycleableItems.bind(this)),
                e.children.on('remove', this._updateFocusCycleableItems.bind(this)),
                e.items.on('change', (e, t) => {
                  const n = t.index;
                  for (const e of t.removed) n >= this.ungroupedItems.length ? this.groupedItems.remove(e) : this.ungroupedItems.remove(e);
                  for (let e = n; e < n + t.added.length; e++) {
                    const o = t.added[e - n];
                    e > this.ungroupedItems.length
                      ? this.groupedItems.add(o, e - this.ungroupedItems.length)
                      : this.ungroupedItems.add(o, e);
                  }
                  this._updateGrouping();
                }),
                e.extendTemplate({ attributes: { class: ['ck-toolbar_grouping'] } });
            }
            render(e) {
              (this.viewElement = e.element), this._enableGroupingOnResize(), this._enableGroupingOnMaxWidthChange(e);
            }
            destroy() {
              this.groupedItemsDropdown.destroy(), this.resizeObserver.destroy();
            }
            _updateGrouping() {
              if (!this.viewElement.ownerDocument.body.contains(this.viewElement)) return;
              if (!Aa(this.viewElement)) return void (this.shouldUpdateGroupingOnNextResize = !0);
              const e = this.groupedItems.length;
              let t;
              for (; this._areItemsOverflowing; ) this._groupLastItem(), (t = !0);
              if (!t && this.groupedItems.length) {
                for (; this.groupedItems.length && !this._areItemsOverflowing; ) this._ungroupFirstItem();
                this._areItemsOverflowing && this._groupLastItem();
              }
              this.groupedItems.length !== e && this.view.fire('groupedItemsUpdate');
            }
            get _areItemsOverflowing() {
              if (!this.ungroupedItems.length) return !1;
              const e = this.viewElement,
                t = this.viewLocale.uiLanguageDirection,
                n = new ka(e.lastChild),
                o = new ka(e);
              if (!this.cachedPadding) {
                const n = _o.window.getComputedStyle(e),
                  o = 'ltr' === t ? 'paddingRight' : 'paddingLeft';
                this.cachedPadding = Number.parseInt(n[o]);
              }
              return 'ltr' === t ? n.right > o.right - this.cachedPadding : n.left < o.left + this.cachedPadding;
            }
            _enableGroupingOnResize() {
              let e;
              (this.resizeObserver = new ya(this.viewElement, (t) => {
                (e && e === t.contentRect.width && !this.shouldUpdateGroupingOnNextResize) ||
                  ((this.shouldUpdateGroupingOnNextResize = !1), this._updateGrouping(), (e = t.contentRect.width));
              })),
                this._updateGrouping();
            }
            _enableGroupingOnMaxWidthChange(e) {
              e.on('change:maxWidth', () => {
                this._updateGrouping();
              });
            }
            _groupLastItem() {
              this.groupedItems.length ||
                (this.viewChildren.add(new oh()),
                this.viewChildren.add(this.groupedItemsDropdown),
                this.viewFocusTracker.add(this.groupedItemsDropdown.element)),
                this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last), 0);
            }
            _ungroupFirstItem() {
              this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first)),
                this.groupedItems.length ||
                  (this.viewChildren.remove(this.groupedItemsDropdown),
                  this.viewChildren.remove(this.viewChildren.last),
                  this.viewFocusTracker.remove(this.groupedItemsDropdown.element));
            }
            _createGroupedItemsDropdown() {
              const e = this.viewLocale,
                t = e.t,
                n = yh(e);
              return (
                (n.class = 'ck-toolbar__grouped-dropdown'),
                (n.panelPosition = 'ltr' === e.uiLanguageDirection ? 'sw' : 'se'),
                Ah(n, []),
                n.buttonView.set({
                  label: t('Show more items'),
                  tooltip: !0,
                  tooltipPosition: 'rtl' === e.uiLanguageDirection ? 'se' : 'sw',
                  icon: Au,
                }),
                n.toolbarView.items.bindTo(this.groupedItems).using((e) => e),
                n
              );
            }
            _updateFocusCycleableItems() {
              this.viewFocusables.clear(),
                this.ungroupedItems.map((e) => {
                  this.viewFocusables.add(e);
                }),
                this.groupedItems.length && this.viewFocusables.add(this.groupedItemsDropdown);
            }
          }
          var hh = n(1162),
            mh = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(hh.Z, mh);
          hh.Z.locals;
          class gh extends Jd {
            constructor() {
              super(),
                (this.items = this.createCollection()),
                (this.focusTracker = new va()),
                (this.keystrokes = new xa()),
                (this._focusCycler = new th({
                  focusables: this.items,
                  focusTracker: this.focusTracker,
                  keystrokeHandler: this.keystrokes,
                  actions: { focusPrevious: 'arrowup', focusNext: 'arrowdown' },
                })),
                this.setTemplate({ tag: 'ul', attributes: { class: ['ck', 'ck-reset', 'ck-list'] }, children: this.items });
            }
            render() {
              super.render();
              for (const e of this.items) this.focusTracker.add(e.element);
              this.items.on('add', (e, t) => {
                this.focusTracker.add(t.element);
              }),
                this.items.on('remove', (e, t) => {
                  this.focusTracker.remove(t.element);
                }),
                this.keystrokes.listenTo(this.element);
            }
            destroy() {
              super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
            }
            focus() {
              this._focusCycler.focusFirst();
            }
            focusLast() {
              this._focusCycler.focusLast();
            }
          }
          class ph extends Jd {
            constructor(e) {
              super(e);
              const t = this.bindTemplate;
              this.set('isVisible', !0),
                (this.children = this.createCollection()),
                this.setTemplate({
                  tag: 'li',
                  attributes: { class: ['ck', 'ck-list__item', t.if('isVisible', 'ck-hidden', (e) => !e)] },
                  children: this.children,
                });
            }
            focus() {
              this.children.first.focus();
            }
          }
          class fh extends Jd {
            constructor(e) {
              super(e), this.setTemplate({ tag: 'li', attributes: { class: ['ck', 'ck-list__separator'] } });
            }
          }
          var kh = n(5075),
            bh = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(kh.Z, bh);
          kh.Z.locals;
          var wh = n(6875),
            _h = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(wh.Z, _h);
          wh.Z.locals;
          function yh(e, t = $u) {
            const n = new t(e),
              o = new Zu(e),
              i = new eh(e, n, o);
            return (
              n.bind('isEnabled').to(i),
              n instanceof $u ? n.bind('isOn').to(i, 'isOpen') : n.arrowView.bind('isOn').to(i, 'isOpen'),
              (function (e) {
                (function (e) {
                  e.on('render', () => {
                    vu({
                      emitter: e,
                      activator: () => e.isOpen,
                      callback: () => {
                        e.isOpen = !1;
                      },
                      contextElements: [e.element],
                    });
                  });
                })(e),
                  (function (e) {
                    e.on('execute', (t) => {
                      t.source instanceof Ou || (e.isOpen = !1);
                    });
                  })(e),
                  (function (e) {
                    e.keystrokes.set('arrowdown', (t, n) => {
                      e.isOpen && (e.panelView.focus(), n());
                    }),
                      e.keystrokes.set('arrowup', (t, n) => {
                        e.isOpen && (e.panelView.focusLast(), n());
                      });
                  })(e);
              })(i),
              i
            );
          }
          function Ah(e, t, n = {}) {
            const o = e.locale,
              i = o.t,
              r = (e.toolbarView = new lh(o));
            r.set('ariaLabel', i('Dropdown toolbar')),
              e.extendTemplate({ attributes: { class: ['ck-toolbar-dropdown'] } }),
              t.map((e) => r.items.add(e)),
              n.enableActiveItemFocusOnDropdownOpen && vh(e, () => r.items.find((e) => e.isOn)),
              e.panelView.children.add(r),
              r.items.delegate('execute').to(e);
          }
          function Ch(e, t) {
            const n = e.locale,
              o = (e.listView = new gh(n));
            o.items.bindTo(t).using(({ type: e, model: t }) => {
              if ('separator' === e) return new fh(n);
              if ('button' === e || 'switchbutton' === e) {
                const o = new ph(n);
                let i;
                return (
                  (i = 'button' === e ? new zu(n) : new Ou(n)),
                  i.bind(...Object.keys(t)).to(t),
                  i.delegate('execute').to(o),
                  o.children.add(i),
                  o
                );
              }
            }),
              e.panelView.children.add(o),
              o.items.delegate('execute').to(e),
              vh(e, () => o.items.find((e) => e instanceof ph && e.children.first.isOn));
          }
          function vh(e, t) {
            e.on(
              'change:isOpen',
              () => {
                if (!e.isOpen) return;
                const n = t();
                n && ('function' == typeof n.focus ? n.focus() : c('ui-dropdown-focus-child-on-open-child-missing-focus', { view: n }));
              },
              { priority: 'low' }
            );
          }
          var xh = n(4547),
            Eh = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(xh.Z, Eh);
          xh.Z.locals;
          class Dh extends Jd {
            constructor(e) {
              super(e), (this.body = new Iu(e));
            }
            render() {
              super.render(), this.body.attachToDom();
            }
            destroy() {
              return this.body.detachFromDom(), super.destroy();
            }
          }
          var Th = n(2751),
            Ih = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Th.Z, Ih);
          Th.Z.locals;
          class Sh extends Jd {
            constructor(e) {
              super(e), this.set('text'), this.set('for'), (this.id = `ck-editor__label_${r()}`);
              const t = this.bindTemplate;
              this.setTemplate({
                tag: 'label',
                attributes: { class: ['ck', 'ck-label'], id: this.id, for: t.to('for') },
                children: [{ text: t.to('text') }],
              });
            }
          }
          class Mh extends Dh {
            constructor(e) {
              super(e),
                (this.top = this.createCollection()),
                (this.main = this.createCollection()),
                (this._voiceLabelView = this._createVoiceLabel()),
                this.setTemplate({
                  tag: 'div',
                  attributes: {
                    class: ['ck', 'ck-reset', 'ck-editor', 'ck-rounded-corners'],
                    role: 'application',
                    dir: e.uiLanguageDirection,
                    lang: e.uiLanguage,
                    'aria-labelledby': this._voiceLabelView.id,
                  },
                  children: [
                    this._voiceLabelView,
                    {
                      tag: 'div',
                      attributes: { class: ['ck', 'ck-editor__top', 'ck-reset_all'], role: 'presentation' },
                      children: this.top,
                    },
                    { tag: 'div', attributes: { class: ['ck', 'ck-editor__main'], role: 'presentation' }, children: this.main },
                  ],
                });
            }
            _createVoiceLabel() {
              const e = this.t,
                t = new Sh();
              return (t.text = e('Rich Text Editor')), t.extendTemplate({ attributes: { class: 'ck-voice-label' } }), t;
            }
          }
          class Bh extends Jd {
            constructor(e, t, n) {
              super(e),
                this.setTemplate({
                  tag: 'div',
                  attributes: {
                    class: ['ck', 'ck-content', 'ck-editor__editable', 'ck-rounded-corners'],
                    lang: e.contentLanguage,
                    dir: e.contentLanguageDirection,
                  },
                }),
                (this.name = null),
                this.set('isFocused', !1),
                (this._editableElement = n),
                (this._hasExternalElement = !!this._editableElement),
                (this._editingView = t);
            }
            render() {
              super.render(),
                this._hasExternalElement
                  ? this.template.apply((this.element = this._editableElement))
                  : (this._editableElement = this.element),
                this.on('change:isFocused', () => this._updateIsFocusedClasses()),
                this._updateIsFocusedClasses();
            }
            destroy() {
              this._hasExternalElement && this.template.revert(this._editableElement), super.destroy();
            }
            _updateIsFocusedClasses() {
              const e = this._editingView;
              function t(t) {
                e.change((n) => {
                  const o = e.document.getRoot(t.name);
                  n.addClass(t.isFocused ? 'ck-focused' : 'ck-blurred', o), n.removeClass(t.isFocused ? 'ck-blurred' : 'ck-focused', o);
                });
              }
              e.isRenderingInProgress
                ? (function n(o) {
                    e.once('change:isRenderingInProgress', (e, i, r) => {
                      r ? n(o) : t(o);
                    });
                  })(this)
                : t(this);
            }
          }
          class Nh extends Bh {
            constructor(e, t, n, o = {}) {
              super(e, t, n);
              const i = e.t;
              this.extendTemplate({ attributes: { role: 'textbox', class: 'ck-editor__editable_inline' } }),
                (this._generateLabel = o.label || (() => i('Editor editing area: %0', this.name)));
            }
            render() {
              super.render();
              const e = this._editingView;
              e.change((t) => {
                const n = e.document.getRoot(this.name);
                t.setAttribute('aria-label', this._generateLabel(this), n);
              });
            }
          }
          var Ph = n(5523),
            zh = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Ph.Z, zh);
          Ph.Z.locals;
          class Lh extends Jd {
            constructor(e, t = {}) {
              super(e);
              const n = this.bindTemplate;
              this.set('label', t.label || ''),
                this.set('class', t.class || null),
                (this.children = this.createCollection()),
                this.setTemplate({ tag: 'div', attributes: { class: ['ck', 'ck-form__header', n.to('class')] }, children: this.children });
              const o = new Jd(e);
              o.setTemplate({ tag: 'span', attributes: { class: ['ck', 'ck-form__header__label'] }, children: [{ text: n.to('label') }] }),
                this.children.add(o);
            }
          }
          var jh = n(6985),
            Oh = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(jh.Z, Oh);
          jh.Z.locals;
          class Rh extends Jd {
            constructor(e) {
              super(e),
                this.set('value'),
                this.set('id'),
                this.set('placeholder'),
                this.set('isReadOnly', !1),
                this.set('hasError', !1),
                this.set('ariaDescribedById'),
                (this.focusTracker = new va()),
                this.bind('isFocused').to(this.focusTracker),
                this.set('isEmpty', !0),
                this.set('inputMode', 'text');
              const t = this.bindTemplate;
              this.setTemplate({
                tag: 'input',
                attributes: {
                  class: [
                    'ck',
                    'ck-input',
                    t.if('isFocused', 'ck-input_focused'),
                    t.if('isEmpty', 'ck-input-text_empty'),
                    t.if('hasError', 'ck-error'),
                  ],
                  id: t.to('id'),
                  placeholder: t.to('placeholder'),
                  readonly: t.to('isReadOnly'),
                  inputmode: t.to('inputMode'),
                  'aria-invalid': t.if('hasError', !0),
                  'aria-describedby': t.to('ariaDescribedById'),
                },
                on: {
                  input: t.to((...e) => {
                    this.fire('input', ...e), this._updateIsEmpty();
                  }),
                  change: t.to(this._updateIsEmpty.bind(this)),
                },
              });
            }
            render() {
              super.render(),
                this.focusTracker.add(this.element),
                this._setDomElementValue(this.value),
                this._updateIsEmpty(),
                this.on('change:value', (e, t, n) => {
                  this._setDomElementValue(n), this._updateIsEmpty();
                });
            }
            destroy() {
              super.destroy(), this.focusTracker.destroy();
            }
            select() {
              this.element.select();
            }
            focus() {
              this.element.focus();
            }
            _updateIsEmpty() {
              this.isEmpty = !this.element.value;
            }
            _setDomElementValue(e) {
              this.element.value = e || 0 === e ? e : '';
            }
          }
          class Vh extends Rh {
            constructor(e) {
              super(e), this.extendTemplate({ attributes: { type: 'text', class: ['ck-input-text'] } });
            }
          }
          var Fh = n(8111),
            Hh = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Fh.Z, Hh);
          Fh.Z.locals;
          class Uh extends Jd {
            constructor(e, t) {
              super(e);
              const n = `ck-labeled-field-view-${r()}`,
                o = `ck-labeled-field-view-status-${r()}`;
              (this.fieldView = t(this, n, o)),
                this.set('label'),
                this.set('isEnabled', !0),
                this.set('isEmpty', !0),
                this.set('isFocused', !1),
                this.set('errorText', null),
                this.set('infoText', null),
                this.set('class'),
                this.set('placeholder'),
                (this.labelView = this._createLabelView(n)),
                (this.statusView = this._createStatusView(o)),
                this.bind('_statusText').to(this, 'errorText', this, 'infoText', (e, t) => e || t);
              const i = this.bindTemplate;
              this.setTemplate({
                tag: 'div',
                attributes: {
                  class: [
                    'ck',
                    'ck-labeled-field-view',
                    i.to('class'),
                    i.if('isEnabled', 'ck-disabled', (e) => !e),
                    i.if('isEmpty', 'ck-labeled-field-view_empty'),
                    i.if('isFocused', 'ck-labeled-field-view_focused'),
                    i.if('placeholder', 'ck-labeled-field-view_placeholder'),
                    i.if('errorText', 'ck-error'),
                  ],
                },
                children: [
                  {
                    tag: 'div',
                    attributes: { class: ['ck', 'ck-labeled-field-view__input-wrapper'] },
                    children: [this.fieldView, this.labelView],
                  },
                  this.statusView,
                ],
              });
            }
            _createLabelView(e) {
              const t = new Sh(this.locale);
              return (t.for = e), t.bind('text').to(this, 'label'), t;
            }
            _createStatusView(e) {
              const t = new Jd(this.locale),
                n = this.bindTemplate;
              return (
                t.setTemplate({
                  tag: 'div',
                  attributes: {
                    class: [
                      'ck',
                      'ck-labeled-field-view__status',
                      n.if('errorText', 'ck-labeled-field-view__status_error'),
                      n.if('_statusText', 'ck-hidden', (e) => !e),
                    ],
                    id: e,
                    role: n.if('errorText', 'alert'),
                  },
                  children: [{ text: n.to('_statusText') }],
                }),
                t
              );
            }
            focus() {
              this.fieldView.focus();
            }
          }
          function qh(e, t, n) {
            const o = new Vh(e.locale);
            return (
              o.set({ id: t, ariaDescribedById: n }),
              o.bind('isReadOnly').to(e, 'isEnabled', (e) => !e),
              o.bind('hasError').to(e, 'errorText', (e) => !!e),
              o.on('input', () => {
                e.errorText = null;
              }),
              e.bind('isEmpty', 'isFocused', 'placeholder').to(o),
              o
            );
          }
          function Wh(e, t, n) {
            const o = yh(e.locale);
            return o.set({ id: t, ariaDescribedById: n }), o.bind('isEnabled').to(e), o;
          }
          class Gh extends Eo {
            static get pluginName() {
              return 'Notification';
            }
            init() {
              this.on(
                'show:warning',
                (e, t) => {
                  window.alert(t.message);
                },
                { priority: 'lowest' }
              );
            }
            showSuccess(e, t = {}) {
              this._showNotification({ message: e, type: 'success', namespace: t.namespace, title: t.title });
            }
            showInfo(e, t = {}) {
              this._showNotification({ message: e, type: 'info', namespace: t.namespace, title: t.title });
            }
            showWarning(e, t = {}) {
              this._showNotification({ message: e, type: 'warning', namespace: t.namespace, title: t.title });
            }
            _showNotification(e) {
              const t = `show:${e.type}` + (e.namespace ? `:${e.namespace}` : '');
              this.fire(t, { message: e.message, type: e.type, title: e.title || '' });
            }
          }
          class $h {
            constructor(e, t) {
              t && Ws(this, t), e && this.set(e);
            }
          }
          R($h, B);
          var Yh = n(1757),
            Kh = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Yh.Z, Kh);
          Yh.Z.locals;
          var Qh = n(3553),
            Zh = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Qh.Z, Zh);
          Qh.Z.locals;
          const Jh = nu('px');
          class Xh extends V {
            static get pluginName() {
              return 'ContextualBalloon';
            }
            constructor(e) {
              super(e),
                (this.positionLimiter = () => {
                  const e = this.editor.editing.view,
                    t = e.document.selection.editableElement;
                  return t ? e.domConverter.mapViewToDom(t.root) : null;
                }),
                this.set('visibleView', null),
                (this.view = new au(e.locale)),
                e.ui.view.body.add(this.view),
                e.ui.focusTracker.add(this.view.element),
                (this._viewToStack = new Map()),
                (this._idToStack = new Map()),
                this.set('_numberOfStacks', 0),
                this.set('_singleViewMode', !1),
                (this._rotatorView = this._createRotatorView()),
                (this._fakePanelsView = this._createFakePanelsView());
            }
            destroy() {
              super.destroy(), this.view.destroy(), this._rotatorView.destroy(), this._fakePanelsView.destroy();
            }
            hasView(e) {
              return Array.from(this._viewToStack.keys()).includes(e);
            }
            add(e) {
              if (this.hasView(e.view)) throw new l('contextualballoon-add-view-exist', [this, e]);
              const t = e.stackId || 'main';
              if (!this._idToStack.has(t))
                return (
                  this._idToStack.set(t, new Map([[e.view, e]])),
                  this._viewToStack.set(e.view, this._idToStack.get(t)),
                  (this._numberOfStacks = this._idToStack.size),
                  void ((this._visibleStack && !e.singleViewMode) || this.showStack(t))
                );
              const n = this._idToStack.get(t);
              e.singleViewMode && this.showStack(t),
                n.set(e.view, e),
                this._viewToStack.set(e.view, n),
                n === this._visibleStack && this._showView(e);
            }
            remove(e) {
              if (!this.hasView(e)) throw new l('contextualballoon-remove-view-not-exist', [this, e]);
              const t = this._viewToStack.get(e);
              this._singleViewMode && this.visibleView === e && (this._singleViewMode = !1),
                this.visibleView === e &&
                  (1 === t.size
                    ? this._idToStack.size > 1
                      ? this._showNextStack()
                      : (this.view.hide(), (this.visibleView = null), this._rotatorView.hideView())
                    : this._showView(Array.from(t.values())[t.size - 2])),
                1 === t.size ? (this._idToStack.delete(this._getStackId(t)), (this._numberOfStacks = this._idToStack.size)) : t.delete(e),
                this._viewToStack.delete(e);
            }
            updatePosition(e) {
              e && (this._visibleStack.get(this.visibleView).position = e),
                this.view.pin(this._getBalloonPosition()),
                this._fakePanelsView.updatePosition();
            }
            showStack(e) {
              this.visibleStack = e;
              const t = this._idToStack.get(e);
              if (!t) throw new l('contextualballoon-showstack-stack-not-exist', this);
              this._visibleStack !== t && this._showView(Array.from(t.values()).pop());
            }
            get _visibleStack() {
              return this._viewToStack.get(this.visibleView);
            }
            _getStackId(e) {
              return Array.from(this._idToStack.entries()).find((t) => t[1] === e)[0];
            }
            _showNextStack() {
              const e = Array.from(this._idToStack.values());
              let t = e.indexOf(this._visibleStack) + 1;
              e[t] || (t = 0), this.showStack(this._getStackId(e[t]));
            }
            _showPrevStack() {
              const e = Array.from(this._idToStack.values());
              let t = e.indexOf(this._visibleStack) - 1;
              e[t] || (t = e.length - 1), this.showStack(this._getStackId(e[t]));
            }
            _createRotatorView() {
              const e = new em(this.editor.locale),
                t = this.editor.locale.t;
              return (
                this.view.content.add(e),
                e.bind('isNavigationVisible').to(this, '_numberOfStacks', this, '_singleViewMode', (e, t) => !t && e > 1),
                e.on('change:isNavigationVisible', () => this.updatePosition(), { priority: 'low' }),
                e.bind('counter').to(this, 'visibleView', this, '_numberOfStacks', (e, n) => {
                  if (n < 2) return '';
                  const o = Array.from(this._idToStack.values()).indexOf(this._visibleStack) + 1;
                  return t('%0 of %1', [o, n]);
                }),
                e.buttonNextView.on('execute', () => {
                  e.focusTracker.isFocused && this.editor.editing.view.focus(), this._showNextStack();
                }),
                e.buttonPrevView.on('execute', () => {
                  e.focusTracker.isFocused && this.editor.editing.view.focus(), this._showPrevStack();
                }),
                e
              );
            }
            _createFakePanelsView() {
              const e = new tm(this.editor.locale, this.view);
              return (
                e
                  .bind('numberOfPanels')
                  .to(this, '_numberOfStacks', this, '_singleViewMode', (e, t) => (!t && e >= 2 ? Math.min(e - 1, 2) : 0)),
                e.listenTo(this.view, 'change:top', () => e.updatePosition()),
                e.listenTo(this.view, 'change:left', () => e.updatePosition()),
                this.editor.ui.view.body.add(e),
                e
              );
            }
            _showView({ view: e, balloonClassName: t = '', withArrow: n = !0, singleViewMode: o = !1 }) {
              (this.view.class = t),
                (this.view.withArrow = n),
                this._rotatorView.showView(e),
                (this.visibleView = e),
                this.view.pin(this._getBalloonPosition()),
                this._fakePanelsView.updatePosition(),
                o && (this._singleViewMode = !0);
            }
            _getBalloonPosition() {
              let e = Array.from(this._visibleStack.values()).pop().position;
              return (
                e &&
                  (e.limiter || (e = Object.assign({}, e, { limiter: this.positionLimiter })),
                  (e = Object.assign({}, e, { viewportOffsetConfig: this.editor.ui.viewportOffset }))),
                e
              );
            }
          }
          class em extends Jd {
            constructor(e) {
              super(e);
              const t = e.t,
                n = this.bindTemplate;
              this.set('isNavigationVisible', !0),
                (this.focusTracker = new va()),
                (this.buttonPrevView = this._createButtonView(
                  t('Previous'),
                  '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z"/></svg>'
                )),
                (this.buttonNextView = this._createButtonView(
                  t('Next'),
                  '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>'
                )),
                (this.content = this.createCollection()),
                this.setTemplate({
                  tag: 'div',
                  attributes: { class: ['ck', 'ck-balloon-rotator'], 'z-index': '-1' },
                  children: [
                    {
                      tag: 'div',
                      attributes: { class: ['ck-balloon-rotator__navigation', n.to('isNavigationVisible', (e) => (e ? '' : 'ck-hidden'))] },
                      children: [
                        this.buttonPrevView,
                        { tag: 'span', attributes: { class: ['ck-balloon-rotator__counter'] }, children: [{ text: n.to('counter') }] },
                        this.buttonNextView,
                      ],
                    },
                    { tag: 'div', attributes: { class: 'ck-balloon-rotator__content' }, children: this.content },
                  ],
                });
            }
            render() {
              super.render(), this.focusTracker.add(this.element);
            }
            destroy() {
              super.destroy(), this.focusTracker.destroy();
            }
            showView(e) {
              this.hideView(), this.content.add(e);
            }
            hideView() {
              this.content.clear();
            }
            _createButtonView(e, t) {
              const n = new zu(this.locale);
              return n.set({ label: e, icon: t, tooltip: !0 }), n;
            }
          }
          class tm extends Jd {
            constructor(e, t) {
              super(e);
              const n = this.bindTemplate;
              this.set('top', 0),
                this.set('left', 0),
                this.set('height', 0),
                this.set('width', 0),
                this.set('numberOfPanels', 0),
                (this.content = this.createCollection()),
                (this._balloonPanelView = t),
                this.setTemplate({
                  tag: 'div',
                  attributes: {
                    class: ['ck-fake-panel', n.to('numberOfPanels', (e) => (e ? '' : 'ck-hidden'))],
                    style: { top: n.to('top', Jh), left: n.to('left', Jh), width: n.to('width', Jh), height: n.to('height', Jh) },
                  },
                  children: this.content,
                }),
                this.on('change:numberOfPanels', (e, t, n, o) => {
                  n > o ? this._addPanels(n - o) : this._removePanels(o - n), this.updatePosition();
                });
            }
            _addPanels(e) {
              for (; e--; ) {
                const e = new Jd();
                e.setTemplate({ tag: 'div' }), this.content.add(e), this.registerChild(e);
              }
            }
            _removePanels(e) {
              for (; e--; ) {
                const e = this.content.last;
                this.content.remove(e), this.deregisterChild(e), e.destroy();
              }
            }
            updatePosition() {
              if (this.numberOfPanels) {
                const { top: e, left: t } = this._balloonPanelView,
                  { width: n, height: o } = new ka(this._balloonPanelView.element);
                Object.assign(this, { top: e, left: t, width: n, height: o });
              }
            }
          }
          var nm = n(3609),
            om = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(nm.Z, om);
          nm.Z.locals;
          const im = nu('px');
          class rm extends Jd {
            constructor(e) {
              super(e);
              const t = this.bindTemplate;
              this.set('isActive', !1),
                this.set('isSticky', !1),
                this.set('limiterElement', null),
                this.set('limiterBottomOffset', 50),
                this.set('viewportTopOffset', 0),
                this.set('_marginLeft', null),
                this.set('_isStickyToTheLimiter', !1),
                this.set('_hasViewportTopOffset', !1),
                (this.content = this.createCollection()),
                (this._contentPanelPlaceholder = new Sd({
                  tag: 'div',
                  attributes: {
                    class: ['ck', 'ck-sticky-panel__placeholder'],
                    style: {
                      display: t.to('isSticky', (e) => (e ? 'block' : 'none')),
                      height: t.to('isSticky', (e) => (e ? im(this._panelRect.height) : null)),
                    },
                  },
                }).render()),
                (this._contentPanel = new Sd({
                  tag: 'div',
                  attributes: {
                    class: [
                      'ck',
                      'ck-sticky-panel__content',
                      t.if('isSticky', 'ck-sticky-panel__content_sticky'),
                      t.if('_isStickyToTheLimiter', 'ck-sticky-panel__content_sticky_bottom-limit'),
                    ],
                    style: {
                      width: t.to('isSticky', (e) => (e ? im(this._contentPanelPlaceholder.getBoundingClientRect().width) : null)),
                      top: t.to('_hasViewportTopOffset', (e) => (e ? im(this.viewportTopOffset) : null)),
                      bottom: t.to('_isStickyToTheLimiter', (e) => (e ? im(this.limiterBottomOffset) : null)),
                      marginLeft: t.to('_marginLeft'),
                    },
                  },
                  children: this.content,
                }).render()),
                this.setTemplate({
                  tag: 'div',
                  attributes: { class: ['ck', 'ck-sticky-panel'] },
                  children: [this._contentPanelPlaceholder, this._contentPanel],
                });
            }
            render() {
              super.render(),
                this._checkIfShouldBeSticky(),
                this.listenTo(_o.window, 'scroll', () => {
                  this._checkIfShouldBeSticky();
                }),
                this.listenTo(this, 'change:isActive', () => {
                  this._checkIfShouldBeSticky();
                });
            }
            _checkIfShouldBeSticky() {
              const e = (this._panelRect = this._contentPanel.getBoundingClientRect());
              let t;
              this.limiterElement
                ? ((t = this._limiterRect = this.limiterElement.getBoundingClientRect()),
                  (this.isSticky =
                    this.isActive && t.top < this.viewportTopOffset && this._panelRect.height + this.limiterBottomOffset < t.height))
                : (this.isSticky = !1),
                this.isSticky
                  ? ((this._isStickyToTheLimiter = t.bottom < e.height + this.limiterBottomOffset + this.viewportTopOffset),
                    (this._hasViewportTopOffset = !this._isStickyToTheLimiter && !!this.viewportTopOffset),
                    (this._marginLeft = this._isStickyToTheLimiter ? null : im(-_o.window.scrollX)))
                  : ((this._isStickyToTheLimiter = !1), (this._hasViewportTopOffset = !1), (this._marginLeft = null));
            }
          }
          nu('px');
          var sm = n(6706),
            am = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(sm.Z, am);
          sm.Z.locals, nu('px');
          nu('px');
          var lm = n(8894),
            cm = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(lm.Z, cm);
          lm.Z.locals;
          const dm = new WeakMap();
          function um(e) {
            const { view: t, element: n, text: o, isDirectHost: i = !0, keepOnFocus: r = !1 } = e,
              s = t.document;
            dm.has(s) || (dm.set(s, new Map()), s.registerPostFixer((e) => mm(s, e))),
              dm.get(s).set(n, { text: o, isDirectHost: i, keepOnFocus: r, hostElement: i ? n : null }),
              t.change((e) => mm(s, e));
          }
          function hm(e, t) {
            return !!t.hasClass('ck-placeholder') && (e.removeClass('ck-placeholder', t), !0);
          }
          function mm(e, t) {
            const n = dm.get(e),
              o = [];
            let i = !1;
            for (const [e, r] of n) r.isDirectHost && (o.push(e), gm(t, e, r) && (i = !0));
            for (const [e, r] of n) {
              if (r.isDirectHost) continue;
              const n = pm(e);
              n && (o.includes(n) || ((r.hostElement = n), gm(t, e, r) && (i = !0)));
            }
            return i;
          }
          function gm(e, t, n) {
            const { text: o, isDirectHost: i, hostElement: r } = n;
            let s = !1;
            r.getAttribute('data-placeholder') !== o && (e.setAttribute('data-placeholder', o, r), (s = !0));
            return (
              (i || 1 == t.childCount) &&
              (function (e, t) {
                if (!e.isAttached()) return !1;
                const n = Array.from(e.getChildren()).some((e) => !e.is('uiElement'));
                if (n) return !1;
                if (t) return !0;
                const o = e.document;
                if (!o.isFocused) return !0;
                const i = o.selection.anchor;
                return !!i && i.parent !== e;
              })(r, n.keepOnFocus)
                ? (function (e, t) {
                    return !t.hasClass('ck-placeholder') && (e.addClass('ck-placeholder', t), !0);
                  })(e, r) && (s = !0)
                : hm(e, r) && (s = !0),
              s
            );
          }
          function pm(e) {
            if (e.childCount) {
              const t = e.getChild(0);
              if (t.is('element') && !t.is('uiElement') && !t.is('attributeElement')) return t;
            }
            return null;
          }
          const fm = new Map();
          function km(e, t, n) {
            let o = fm.get(e);
            o || ((o = new Map()), fm.set(e, o)), o.set(t, n);
          }
          function bm(e) {
            return [e];
          }
          function wm(e, t, n = {}) {
            const o = (function (e, t) {
              const n = fm.get(e);
              return n && n.has(t) ? n.get(t) : bm;
            })(e.constructor, t.constructor);
            try {
              return o((e = e.clone()), t, n);
            } catch (e) {
              throw e;
            }
          }
          function _m(e, t, n) {
            (e = e.slice()), (t = t.slice());
            const o = new ym(n.document, n.useRelations, n.forceWeakRemove);
            o.setOriginalOperations(e), o.setOriginalOperations(t);
            const i = o.originalOperations;
            if (0 == e.length || 0 == t.length) return { operationsA: e, operationsB: t, originalOperations: i };
            const r = new WeakMap();
            for (const t of e) r.set(t, 0);
            const s = {
              nextBaseVersionA: e[e.length - 1].baseVersion + 1,
              nextBaseVersionB: t[t.length - 1].baseVersion + 1,
              originalOperationsACount: e.length,
              originalOperationsBCount: t.length,
            };
            let a = 0;
            for (; a < e.length; ) {
              const n = e[a],
                i = r.get(n);
              if (i == t.length) {
                a++;
                continue;
              }
              const s = t[i],
                l = wm(n, s, o.getContext(n, s, !0)),
                c = wm(s, n, o.getContext(s, n, !1));
              o.updateRelation(n, s), o.setOriginalOperations(l, n), o.setOriginalOperations(c, s);
              for (const e of l) r.set(e, i + c.length);
              e.splice(a, 1, ...l), t.splice(i, 1, ...c);
            }
            if (n.padWithNoOps) {
              const n = e.length - s.originalOperationsACount,
                o = t.length - s.originalOperationsBCount;
              Cm(e, o - n), Cm(t, n - o);
            }
            return Am(e, s.nextBaseVersionB), Am(t, s.nextBaseVersionA), { operationsA: e, operationsB: t, originalOperations: i };
          }
          class ym {
            constructor(e, t, n = !1) {
              (this.originalOperations = new Map()),
                (this._history = e.history),
                (this._useRelations = t),
                (this._forceWeakRemove = !!n),
                (this._relations = new Map());
            }
            setOriginalOperations(e, t = null) {
              const n = t ? this.originalOperations.get(t) : null;
              for (const t of e) this.originalOperations.set(t, n || t);
            }
            updateRelation(e, t) {
              if (e instanceof Rc)
                t instanceof Wc
                  ? e.targetPosition.isEqual(t.sourcePosition) || t.movedRange.containsPosition(e.targetPosition)
                    ? this._setRelation(e, t, 'insertAtSource')
                    : e.targetPosition.isEqual(t.deletionPosition)
                    ? this._setRelation(e, t, 'insertBetween')
                    : e.targetPosition.isAfter(t.sourcePosition) && this._setRelation(e, t, 'moveTargetAfter')
                  : t instanceof Rc &&
                    (e.targetPosition.isEqual(t.sourcePosition) || e.targetPosition.isBefore(t.sourcePosition)
                      ? this._setRelation(e, t, 'insertBefore')
                      : this._setRelation(e, t, 'insertAfter'));
              else if (e instanceof Gc) {
                if (t instanceof Wc) e.splitPosition.isBefore(t.sourcePosition) && this._setRelation(e, t, 'splitBefore');
                else if (t instanceof Rc)
                  if (e.splitPosition.isEqual(t.sourcePosition) || e.splitPosition.isBefore(t.sourcePosition))
                    this._setRelation(e, t, 'splitBefore');
                  else {
                    const n = Qa._createFromPositionAndShift(t.sourcePosition, t.howMany);
                    if (e.splitPosition.hasSameParentAs(t.sourcePosition) && n.containsPosition(e.splitPosition)) {
                      const o = n.end.offset - e.splitPosition.offset,
                        i = e.splitPosition.offset - n.start.offset;
                      this._setRelation(e, t, { howMany: o, offset: i });
                    }
                  }
              } else if (e instanceof Wc)
                t instanceof Wc
                  ? (e.targetPosition.isEqual(t.sourcePosition) || this._setRelation(e, t, 'mergeTargetNotMoved'),
                    e.sourcePosition.isEqual(t.targetPosition) && this._setRelation(e, t, 'mergeSourceNotMoved'),
                    e.sourcePosition.isEqual(t.sourcePosition) && this._setRelation(e, t, 'mergeSameElement'))
                  : t instanceof Gc && e.sourcePosition.isEqual(t.splitPosition) && this._setRelation(e, t, 'splitAtSource');
              else if (e instanceof Fc) {
                const n = e.newRange;
                if (!n) return;
                if (t instanceof Rc) {
                  const o = Qa._createFromPositionAndShift(t.sourcePosition, t.howMany),
                    i = o.containsPosition(n.start) || o.start.isEqual(n.start),
                    r = o.containsPosition(n.end) || o.end.isEqual(n.end);
                  (!i && !r) ||
                    o.containsRange(n) ||
                    this._setRelation(e, t, { side: i ? 'left' : 'right', path: i ? n.start.path.slice() : n.end.path.slice() });
                } else if (t instanceof Wc) {
                  const o = n.start.isEqual(t.targetPosition),
                    i = n.start.isEqual(t.deletionPosition),
                    r = n.end.isEqual(t.deletionPosition),
                    s = n.end.isEqual(t.sourcePosition);
                  (o || i || r || s) &&
                    this._setRelation(e, t, {
                      wasInLeftElement: o,
                      wasStartBeforeMergedElement: i,
                      wasEndBeforeMergedElement: r,
                      wasInRightElement: s,
                    });
                }
              }
            }
            getContext(e, t, n) {
              return {
                aIsStrong: n,
                aWasUndone: this._wasUndone(e),
                bWasUndone: this._wasUndone(t),
                abRelation: this._useRelations ? this._getRelation(e, t) : null,
                baRelation: this._useRelations ? this._getRelation(t, e) : null,
                forceWeakRemove: this._forceWeakRemove,
              };
            }
            _wasUndone(e) {
              const t = this.originalOperations.get(e);
              return t.wasUndone || this._history.isUndoneOperation(t);
            }
            _getRelation(e, t) {
              const n = this.originalOperations.get(t),
                o = this._history.getUndoneOperation(n);
              if (!o) return null;
              const i = this.originalOperations.get(e),
                r = this._relations.get(i);
              return (r && r.get(o)) || null;
            }
            _setRelation(e, t, n) {
              const o = this.originalOperations.get(e),
                i = this.originalOperations.get(t);
              let r = this._relations.get(o);
              r || ((r = new Map()), this._relations.set(o, r)), r.set(i, n);
            }
          }
          function Am(e, t) {
            for (const n of e) n.baseVersion = t++;
          }
          function Cm(e, t) {
            for (let n = 0; n < t; n++) e.push(new Hc(0));
          }
          function vm(e, t, n) {
            const o = e.nodes.getNode(0).getAttribute(t);
            if (o == n) return null;
            const i = new Qa(e.position, e.position.getShiftedBy(e.howMany));
            return new Oc(i, t, o, n, 0);
          }
          function xm(e, t) {
            return null === e.targetPosition._getTransformedByDeletion(t.sourcePosition, t.howMany);
          }
          function Em(e, t) {
            const n = [];
            for (let o = 0; o < e.length; o++) {
              const i = e[o],
                r = new Rc(i.start, i.end.offset - i.start.offset, t, 0);
              n.push(r);
              for (let t = o + 1; t < e.length; t++) e[t] = e[t]._getTransformedByMove(r.sourcePosition, r.targetPosition, r.howMany)[0];
              t = t._getTransformedByMove(r.sourcePosition, r.targetPosition, r.howMany);
            }
            return n;
          }
          km(Oc, Oc, (e, t, n) => {
            if (e.key === t.key && e.range.start.hasSameParentAs(t.range.start)) {
              const o = e.range.getDifference(t.range).map((t) => new Oc(t, e.key, e.oldValue, e.newValue, 0)),
                i = e.range.getIntersection(t.range);
              return i && n.aIsStrong && o.push(new Oc(i, t.key, t.newValue, e.newValue, 0)), 0 == o.length ? [new Hc(0)] : o;
            }
            return [e];
          }),
            km(Oc, Vc, (e, t) => {
              if (e.range.start.hasSameParentAs(t.position) && e.range.containsPosition(t.position)) {
                const n = e.range
                  ._getTransformedByInsertion(t.position, t.howMany, !t.shouldReceiveAttributes)
                  .map((t) => new Oc(t, e.key, e.oldValue, e.newValue, e.baseVersion));
                if (t.shouldReceiveAttributes) {
                  const o = vm(t, e.key, e.oldValue);
                  o && n.unshift(o);
                }
                return n;
              }
              return (e.range = e.range._getTransformedByInsertion(t.position, t.howMany, !1)[0]), [e];
            }),
            km(Oc, Wc, (e, t) => {
              const n = [];
              e.range.start.hasSameParentAs(t.deletionPosition) &&
                (e.range.containsPosition(t.deletionPosition) || e.range.start.isEqual(t.deletionPosition)) &&
                n.push(Qa._createFromPositionAndShift(t.graveyardPosition, 1));
              const o = e.range._getTransformedByMergeOperation(t);
              return o.isCollapsed || n.push(o), n.map((t) => new Oc(t, e.key, e.oldValue, e.newValue, e.baseVersion));
            }),
            km(Oc, Rc, (e, t) => {
              const n = (function (e, t) {
                const n = Qa._createFromPositionAndShift(t.sourcePosition, t.howMany);
                let o = null,
                  i = [];
                n.containsRange(e, !0)
                  ? (o = e)
                  : e.start.hasSameParentAs(n.start)
                  ? ((i = e.getDifference(n)), (o = e.getIntersection(n)))
                  : (i = [e]);
                const r = [];
                for (let e of i) {
                  e = e._getTransformedByDeletion(t.sourcePosition, t.howMany);
                  const n = t.getMovedRangeStart(),
                    o = e.start.hasSameParentAs(n),
                    i = e._getTransformedByInsertion(n, t.howMany, o);
                  r.push(...i);
                }
                o && r.push(o._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany, !1)[0]);
                return r;
              })(e.range, t);
              return n.map((t) => new Oc(t, e.key, e.oldValue, e.newValue, e.baseVersion));
            }),
            km(Oc, Gc, (e, t) => {
              if (e.range.end.isEqual(t.insertionPosition)) return t.graveyardPosition || e.range.end.offset++, [e];
              if (e.range.start.hasSameParentAs(t.splitPosition) && e.range.containsPosition(t.splitPosition)) {
                const n = e.clone();
                return (
                  (n.range = new Qa(t.moveTargetPosition.clone(), e.range.end._getCombined(t.splitPosition, t.moveTargetPosition))),
                  (e.range.end = t.splitPosition.clone()),
                  (e.range.end.stickiness = 'toPrevious'),
                  [e, n]
                );
              }
              return (e.range = e.range._getTransformedBySplitOperation(t)), [e];
            }),
            km(Vc, Oc, (e, t) => {
              const n = [e];
              if (e.shouldReceiveAttributes && e.position.hasSameParentAs(t.range.start) && t.range.containsPosition(e.position)) {
                const o = vm(e, t.key, t.newValue);
                o && n.push(o);
              }
              return n;
            }),
            km(
              Vc,
              Vc,
              (e, t, n) => (
                (e.position.isEqual(t.position) && n.aIsStrong) || (e.position = e.position._getTransformedByInsertOperation(t)), [e]
              )
            ),
            km(Vc, Rc, (e, t) => ((e.position = e.position._getTransformedByMoveOperation(t)), [e])),
            km(Vc, Gc, (e, t) => ((e.position = e.position._getTransformedBySplitOperation(t)), [e])),
            km(Vc, Wc, (e, t) => ((e.position = e.position._getTransformedByMergeOperation(t)), [e])),
            km(
              Fc,
              Vc,
              (e, t) => (
                e.oldRange && (e.oldRange = e.oldRange._getTransformedByInsertOperation(t)[0]),
                e.newRange && (e.newRange = e.newRange._getTransformedByInsertOperation(t)[0]),
                [e]
              )
            ),
            km(Fc, Fc, (e, t, n) => {
              if (e.name == t.name) {
                if (!n.aIsStrong) return [new Hc(0)];
                e.oldRange = t.newRange ? t.newRange.clone() : null;
              }
              return [e];
            }),
            km(
              Fc,
              Wc,
              (e, t) => (
                e.oldRange && (e.oldRange = e.oldRange._getTransformedByMergeOperation(t)),
                e.newRange && (e.newRange = e.newRange._getTransformedByMergeOperation(t)),
                [e]
              )
            ),
            km(Fc, Rc, (e, t, n) => {
              if ((e.oldRange && (e.oldRange = Qa._createFromRanges(e.oldRange._getTransformedByMoveOperation(t))), e.newRange)) {
                if (n.abRelation) {
                  const o = Qa._createFromRanges(e.newRange._getTransformedByMoveOperation(t));
                  if ('left' == n.abRelation.side && t.targetPosition.isEqual(e.newRange.start))
                    return (e.newRange.end = o.end), (e.newRange.start.path = n.abRelation.path), [e];
                  if ('right' == n.abRelation.side && t.targetPosition.isEqual(e.newRange.end))
                    return (e.newRange.start = o.start), (e.newRange.end.path = n.abRelation.path), [e];
                }
                e.newRange = Qa._createFromRanges(e.newRange._getTransformedByMoveOperation(t));
              }
              return [e];
            }),
            km(Fc, Gc, (e, t, n) => {
              if ((e.oldRange && (e.oldRange = e.oldRange._getTransformedBySplitOperation(t)), e.newRange)) {
                if (n.abRelation) {
                  const o = e.newRange._getTransformedBySplitOperation(t);
                  return (
                    e.newRange.start.isEqual(t.splitPosition) && n.abRelation.wasStartBeforeMergedElement
                      ? (e.newRange.start = Ga._createAt(t.insertionPosition))
                      : e.newRange.start.isEqual(t.splitPosition) &&
                        !n.abRelation.wasInLeftElement &&
                        (e.newRange.start = Ga._createAt(t.moveTargetPosition)),
                    e.newRange.end.isEqual(t.splitPosition) && n.abRelation.wasInRightElement
                      ? (e.newRange.end = Ga._createAt(t.moveTargetPosition))
                      : e.newRange.end.isEqual(t.splitPosition) && n.abRelation.wasEndBeforeMergedElement
                      ? (e.newRange.end = Ga._createAt(t.insertionPosition))
                      : (e.newRange.end = o.end),
                    [e]
                  );
                }
                e.newRange = e.newRange._getTransformedBySplitOperation(t);
              }
              return [e];
            }),
            km(
              Wc,
              Vc,
              (e, t) => (
                e.sourcePosition.hasSameParentAs(t.position) && (e.howMany += t.howMany),
                (e.sourcePosition = e.sourcePosition._getTransformedByInsertOperation(t)),
                (e.targetPosition = e.targetPosition._getTransformedByInsertOperation(t)),
                [e]
              )
            ),
            km(Wc, Wc, (e, t, n) => {
              if (e.sourcePosition.isEqual(t.sourcePosition) && e.targetPosition.isEqual(t.targetPosition)) {
                if (n.bWasUndone) {
                  const n = t.graveyardPosition.path.slice();
                  return n.push(0), (e.sourcePosition = new Ga(t.graveyardPosition.root, n)), (e.howMany = 0), [e];
                }
                return [new Hc(0)];
              }
              if (
                e.sourcePosition.isEqual(t.sourcePosition) &&
                !e.targetPosition.isEqual(t.targetPosition) &&
                !n.bWasUndone &&
                'splitAtSource' != n.abRelation
              ) {
                const o = '$graveyard' == e.targetPosition.root.rootName,
                  i = '$graveyard' == t.targetPosition.root.rootName,
                  r = o && !i;
                if ((i && !o) || (!r && n.aIsStrong)) {
                  const n = t.targetPosition._getTransformedByMergeOperation(t),
                    o = e.targetPosition._getTransformedByMergeOperation(t);
                  return [new Rc(n, e.howMany, o, 0)];
                }
                return [new Hc(0)];
              }
              return (
                e.sourcePosition.hasSameParentAs(t.targetPosition) && (e.howMany += t.howMany),
                (e.sourcePosition = e.sourcePosition._getTransformedByMergeOperation(t)),
                (e.targetPosition = e.targetPosition._getTransformedByMergeOperation(t)),
                (e.graveyardPosition.isEqual(t.graveyardPosition) && n.aIsStrong) ||
                  (e.graveyardPosition = e.graveyardPosition._getTransformedByMergeOperation(t)),
                [e]
              );
            }),
            km(Wc, Rc, (e, t, n) => {
              const o = Qa._createFromPositionAndShift(t.sourcePosition, t.howMany);
              return 'remove' == t.type &&
                !n.bWasUndone &&
                !n.forceWeakRemove &&
                e.deletionPosition.hasSameParentAs(t.sourcePosition) &&
                o.containsPosition(e.sourcePosition)
                ? [new Hc(0)]
                : (e.sourcePosition.hasSameParentAs(t.targetPosition) && (e.howMany += t.howMany),
                  e.sourcePosition.hasSameParentAs(t.sourcePosition) && (e.howMany -= t.howMany),
                  (e.sourcePosition = e.sourcePosition._getTransformedByMoveOperation(t)),
                  (e.targetPosition = e.targetPosition._getTransformedByMoveOperation(t)),
                  e.graveyardPosition.isEqual(t.targetPosition) ||
                    (e.graveyardPosition = e.graveyardPosition._getTransformedByMoveOperation(t)),
                  [e]);
            }),
            km(Wc, Gc, (e, t, n) => {
              if (
                (t.graveyardPosition &&
                  ((e.graveyardPosition = e.graveyardPosition._getTransformedByDeletion(t.graveyardPosition, 1)),
                  e.deletionPosition.isEqual(t.graveyardPosition) && (e.howMany = t.howMany)),
                e.targetPosition.isEqual(t.splitPosition))
              ) {
                const o = 0 != t.howMany,
                  i = t.graveyardPosition && e.deletionPosition.isEqual(t.graveyardPosition);
                if (o || i || 'mergeTargetNotMoved' == n.abRelation)
                  return (e.sourcePosition = e.sourcePosition._getTransformedBySplitOperation(t)), [e];
              }
              if (e.sourcePosition.isEqual(t.splitPosition)) {
                if ('mergeSourceNotMoved' == n.abRelation)
                  return (e.howMany = 0), (e.targetPosition = e.targetPosition._getTransformedBySplitOperation(t)), [e];
                if ('mergeSameElement' == n.abRelation || e.sourcePosition.offset > 0)
                  return (
                    (e.sourcePosition = t.moveTargetPosition.clone()),
                    (e.targetPosition = e.targetPosition._getTransformedBySplitOperation(t)),
                    [e]
                  );
              }
              return (
                e.sourcePosition.hasSameParentAs(t.splitPosition) && (e.howMany = t.splitPosition.offset),
                (e.sourcePosition = e.sourcePosition._getTransformedBySplitOperation(t)),
                (e.targetPosition = e.targetPosition._getTransformedBySplitOperation(t)),
                [e]
              );
            }),
            km(Rc, Vc, (e, t) => {
              const n = Qa._createFromPositionAndShift(e.sourcePosition, e.howMany)._getTransformedByInsertOperation(t, !1)[0];
              return (
                (e.sourcePosition = n.start),
                (e.howMany = n.end.offset - n.start.offset),
                e.targetPosition.isEqual(t.position) || (e.targetPosition = e.targetPosition._getTransformedByInsertOperation(t)),
                [e]
              );
            }),
            km(Rc, Rc, (e, t, n) => {
              const o = Qa._createFromPositionAndShift(e.sourcePosition, e.howMany),
                i = Qa._createFromPositionAndShift(t.sourcePosition, t.howMany);
              let r,
                s = n.aIsStrong,
                a = !n.aIsStrong;
              if (
                ('insertBefore' == n.abRelation || 'insertAfter' == n.baRelation
                  ? (a = !0)
                  : ('insertAfter' != n.abRelation && 'insertBefore' != n.baRelation) || (a = !1),
                (r =
                  e.targetPosition.isEqual(t.targetPosition) && a
                    ? e.targetPosition._getTransformedByDeletion(t.sourcePosition, t.howMany)
                    : e.targetPosition._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany)),
                xm(e, t) && xm(t, e))
              )
                return [t.getReversed()];
              if (o.containsPosition(t.targetPosition) && o.containsRange(i, !0))
                return (
                  (o.start = o.start._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany)),
                  (o.end = o.end._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany)),
                  Em([o], r)
                );
              if (i.containsPosition(e.targetPosition) && i.containsRange(o, !0))
                return (
                  (o.start = o.start._getCombined(t.sourcePosition, t.getMovedRangeStart())),
                  (o.end = o.end._getCombined(t.sourcePosition, t.getMovedRangeStart())),
                  Em([o], r)
                );
              const l = To(e.sourcePosition.getParentPath(), t.sourcePosition.getParentPath());
              if ('prefix' == l || 'extension' == l)
                return (
                  (o.start = o.start._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany)),
                  (o.end = o.end._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany)),
                  Em([o], r)
                );
              'remove' != e.type || 'remove' == t.type || n.aWasUndone || n.forceWeakRemove
                ? 'remove' == e.type || 'remove' != t.type || n.bWasUndone || n.forceWeakRemove || (s = !1)
                : (s = !0);
              const c = [],
                d = o.getDifference(i);
              for (const e of d) {
                (e.start = e.start._getTransformedByDeletion(t.sourcePosition, t.howMany)),
                  (e.end = e.end._getTransformedByDeletion(t.sourcePosition, t.howMany));
                const n = 'same' == To(e.start.getParentPath(), t.getMovedRangeStart().getParentPath()),
                  o = e._getTransformedByInsertion(t.getMovedRangeStart(), t.howMany, n);
                c.push(...o);
              }
              const u = o.getIntersection(i);
              return (
                null !== u &&
                  s &&
                  ((u.start = u.start._getCombined(t.sourcePosition, t.getMovedRangeStart())),
                  (u.end = u.end._getCombined(t.sourcePosition, t.getMovedRangeStart())),
                  0 === c.length
                    ? c.push(u)
                    : 1 == c.length
                    ? i.start.isBefore(o.start) || i.start.isEqual(o.start)
                      ? c.unshift(u)
                      : c.push(u)
                    : c.splice(1, 0, u)),
                0 === c.length ? [new Hc(e.baseVersion)] : Em(c, r)
              );
            }),
            km(Rc, Gc, (e, t, n) => {
              let o = e.targetPosition.clone();
              (e.targetPosition.isEqual(t.insertionPosition) && t.graveyardPosition && 'moveTargetAfter' != n.abRelation) ||
                (o = e.targetPosition._getTransformedBySplitOperation(t));
              const i = Qa._createFromPositionAndShift(e.sourcePosition, e.howMany);
              if (i.end.isEqual(t.insertionPosition)) return t.graveyardPosition || e.howMany++, (e.targetPosition = o), [e];
              if (i.start.hasSameParentAs(t.splitPosition) && i.containsPosition(t.splitPosition)) {
                let e = new Qa(t.splitPosition, i.end);
                e = e._getTransformedBySplitOperation(t);
                return Em([new Qa(i.start, t.splitPosition), e], o);
              }
              e.targetPosition.isEqual(t.splitPosition) && 'insertAtSource' == n.abRelation && (o = t.moveTargetPosition),
                e.targetPosition.isEqual(t.insertionPosition) && 'insertBetween' == n.abRelation && (o = e.targetPosition);
              const r = [i._getTransformedBySplitOperation(t)];
              if (t.graveyardPosition) {
                const o = i.start.isEqual(t.graveyardPosition) || i.containsPosition(t.graveyardPosition);
                e.howMany > 1 && o && !n.aWasUndone && r.push(Qa._createFromPositionAndShift(t.insertionPosition, 1));
              }
              return Em(r, o);
            }),
            km(Rc, Wc, (e, t, n) => {
              const o = Qa._createFromPositionAndShift(e.sourcePosition, e.howMany);
              if (t.deletionPosition.hasSameParentAs(e.sourcePosition) && o.containsPosition(t.sourcePosition))
                if ('remove' != e.type || n.forceWeakRemove) {
                  if (1 == e.howMany)
                    return n.bWasUndone
                      ? ((e.sourcePosition = t.graveyardPosition.clone()),
                        (e.targetPosition = e.targetPosition._getTransformedByMergeOperation(t)),
                        [e])
                      : [new Hc(0)];
                } else if (!n.aWasUndone) {
                  const n = [];
                  let o = t.graveyardPosition.clone(),
                    i = t.targetPosition._getTransformedByMergeOperation(t);
                  e.howMany > 1 &&
                    (n.push(new Rc(e.sourcePosition, e.howMany - 1, e.targetPosition, 0)),
                    (o = o._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany - 1)),
                    (i = i._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany - 1)));
                  const r = t.deletionPosition._getCombined(e.sourcePosition, e.targetPosition),
                    s = new Rc(o, 1, r, 0),
                    a = s.getMovedRangeStart().path.slice();
                  a.push(0);
                  const l = new Ga(s.targetPosition.root, a);
                  i = i._getTransformedByMove(o, r, 1);
                  const c = new Rc(i, t.howMany, l, 0);
                  return n.push(s), n.push(c), n;
                }
              const i = Qa._createFromPositionAndShift(e.sourcePosition, e.howMany)._getTransformedByMergeOperation(t);
              return (
                (e.sourcePosition = i.start),
                (e.howMany = i.end.offset - i.start.offset),
                (e.targetPosition = e.targetPosition._getTransformedByMergeOperation(t)),
                [e]
              );
            }),
            km(Uc, Vc, (e, t) => ((e.position = e.position._getTransformedByInsertOperation(t)), [e])),
            km(Uc, Wc, (e, t) =>
              e.position.isEqual(t.deletionPosition)
                ? ((e.position = t.graveyardPosition.clone()), (e.position.stickiness = 'toNext'), [e])
                : ((e.position = e.position._getTransformedByMergeOperation(t)), [e])
            ),
            km(Uc, Rc, (e, t) => ((e.position = e.position._getTransformedByMoveOperation(t)), [e])),
            km(Uc, Uc, (e, t, n) => {
              if (e.position.isEqual(t.position)) {
                if (!n.aIsStrong) return [new Hc(0)];
                e.oldName = t.newName;
              }
              return [e];
            }),
            km(Uc, Gc, (e, t) => {
              if ('same' == To(e.position.path, t.splitPosition.getParentPath()) && !t.graveyardPosition) {
                const t = new Uc(e.position.getShiftedBy(1), e.oldName, e.newName, 0);
                return [e, t];
              }
              return (e.position = e.position._getTransformedBySplitOperation(t)), [e];
            }),
            km(qc, qc, (e, t, n) => {
              if (e.root === t.root && e.key === t.key) {
                if (!n.aIsStrong || e.newValue === t.newValue) return [new Hc(0)];
                e.oldValue = t.newValue;
              }
              return [e];
            }),
            km(
              Gc,
              Vc,
              (e, t) => (
                e.splitPosition.hasSameParentAs(t.position) && e.splitPosition.offset < t.position.offset && (e.howMany += t.howMany),
                (e.splitPosition = e.splitPosition._getTransformedByInsertOperation(t)),
                (e.insertionPosition = e.insertionPosition._getTransformedByInsertOperation(t)),
                [e]
              )
            ),
            km(Gc, Wc, (e, t, n) => {
              if (!e.graveyardPosition && !n.bWasUndone && e.splitPosition.hasSameParentAs(t.sourcePosition)) {
                const n = t.graveyardPosition.path.slice();
                n.push(0);
                const o = new Ga(t.graveyardPosition.root, n),
                  i = Gc.getInsertionPosition(new Ga(t.graveyardPosition.root, n)),
                  r = new Gc(o, 0, i, null, 0);
                return (
                  (e.splitPosition = e.splitPosition._getTransformedByMergeOperation(t)),
                  (e.insertionPosition = Gc.getInsertionPosition(e.splitPosition)),
                  (e.graveyardPosition = r.insertionPosition.clone()),
                  (e.graveyardPosition.stickiness = 'toNext'),
                  [r, e]
                );
              }
              return (
                e.splitPosition.hasSameParentAs(t.deletionPosition) && !e.splitPosition.isAfter(t.deletionPosition) && e.howMany--,
                e.splitPosition.hasSameParentAs(t.targetPosition) && (e.howMany += t.howMany),
                (e.splitPosition = e.splitPosition._getTransformedByMergeOperation(t)),
                (e.insertionPosition = Gc.getInsertionPosition(e.splitPosition)),
                e.graveyardPosition && (e.graveyardPosition = e.graveyardPosition._getTransformedByMergeOperation(t)),
                [e]
              );
            }),
            km(Gc, Rc, (e, t, n) => {
              const o = Qa._createFromPositionAndShift(t.sourcePosition, t.howMany);
              if (e.graveyardPosition) {
                const i = o.start.isEqual(e.graveyardPosition) || o.containsPosition(e.graveyardPosition);
                if (!n.bWasUndone && i) {
                  const n = e.splitPosition._getTransformedByMoveOperation(t),
                    o = e.graveyardPosition._getTransformedByMoveOperation(t),
                    i = o.path.slice();
                  i.push(0);
                  const r = new Ga(o.root, i);
                  return [new Rc(n, e.howMany, r, 0)];
                }
                e.graveyardPosition = e.graveyardPosition._getTransformedByMoveOperation(t);
              }
              const i = e.splitPosition.isEqual(t.targetPosition);
              if (i && ('insertAtSource' == n.baRelation || 'splitBefore' == n.abRelation))
                return (
                  (e.howMany += t.howMany),
                  (e.splitPosition = e.splitPosition._getTransformedByDeletion(t.sourcePosition, t.howMany)),
                  (e.insertionPosition = Gc.getInsertionPosition(e.splitPosition)),
                  [e]
                );
              if (i && n.abRelation && n.abRelation.howMany) {
                const { howMany: t, offset: o } = n.abRelation;
                return (e.howMany += t), (e.splitPosition = e.splitPosition.getShiftedBy(o)), [e];
              }
              if (e.splitPosition.hasSameParentAs(t.sourcePosition) && o.containsPosition(e.splitPosition)) {
                const n = t.howMany - (e.splitPosition.offset - t.sourcePosition.offset);
                return (
                  (e.howMany -= n),
                  e.splitPosition.hasSameParentAs(t.targetPosition) &&
                    e.splitPosition.offset < t.targetPosition.offset &&
                    (e.howMany += t.howMany),
                  (e.splitPosition = t.sourcePosition.clone()),
                  (e.insertionPosition = Gc.getInsertionPosition(e.splitPosition)),
                  [e]
                );
              }
              return (
                t.sourcePosition.isEqual(t.targetPosition) ||
                  (e.splitPosition.hasSameParentAs(t.sourcePosition) &&
                    e.splitPosition.offset <= t.sourcePosition.offset &&
                    (e.howMany -= t.howMany),
                  e.splitPosition.hasSameParentAs(t.targetPosition) &&
                    e.splitPosition.offset < t.targetPosition.offset &&
                    (e.howMany += t.howMany)),
                (e.splitPosition.stickiness = 'toNone'),
                (e.splitPosition = e.splitPosition._getTransformedByMoveOperation(t)),
                (e.splitPosition.stickiness = 'toNext'),
                e.graveyardPosition
                  ? (e.insertionPosition = e.insertionPosition._getTransformedByMoveOperation(t))
                  : (e.insertionPosition = Gc.getInsertionPosition(e.splitPosition)),
                [e]
              );
            }),
            km(Gc, Gc, (e, t, n) => {
              if (e.splitPosition.isEqual(t.splitPosition)) {
                if (!e.graveyardPosition && !t.graveyardPosition) return [new Hc(0)];
                if (e.graveyardPosition && t.graveyardPosition && e.graveyardPosition.isEqual(t.graveyardPosition)) return [new Hc(0)];
                if ('splitBefore' == n.abRelation)
                  return (e.howMany = 0), (e.graveyardPosition = e.graveyardPosition._getTransformedBySplitOperation(t)), [e];
              }
              if (e.graveyardPosition && t.graveyardPosition && e.graveyardPosition.isEqual(t.graveyardPosition)) {
                const o = '$graveyard' == e.splitPosition.root.rootName,
                  i = '$graveyard' == t.splitPosition.root.rootName,
                  r = o && !i;
                if ((i && !o) || (!r && n.aIsStrong)) {
                  const n = [];
                  return (
                    t.howMany && n.push(new Rc(t.moveTargetPosition, t.howMany, t.splitPosition, 0)),
                    e.howMany && n.push(new Rc(e.splitPosition, e.howMany, e.moveTargetPosition, 0)),
                    n
                  );
                }
                return [new Hc(0)];
              }
              if (
                (e.graveyardPosition && (e.graveyardPosition = e.graveyardPosition._getTransformedBySplitOperation(t)),
                e.splitPosition.isEqual(t.insertionPosition) && 'splitBefore' == n.abRelation)
              )
                return e.howMany++, [e];
              if (t.splitPosition.isEqual(e.insertionPosition) && 'splitBefore' == n.baRelation) {
                const n = t.insertionPosition.path.slice();
                n.push(0);
                const o = new Ga(t.insertionPosition.root, n);
                return [e, new Rc(e.insertionPosition, 1, o, 0)];
              }
              return (
                e.splitPosition.hasSameParentAs(t.splitPosition) &&
                  e.splitPosition.offset < t.splitPosition.offset &&
                  (e.howMany -= t.howMany),
                (e.splitPosition = e.splitPosition._getTransformedBySplitOperation(t)),
                (e.insertionPosition = Gc.getInsertionPosition(e.splitPosition)),
                [e]
              );
            });
          class Dm extends $s {
            constructor(e) {
              super(e), (this.domEventType = 'click');
            }
            onDomEvent(e) {
              this.fire(e.type, e);
            }
          }
          class Tm extends $s {
            constructor(e) {
              super(e), (this.domEventType = ['mousedown', 'mouseup', 'mouseover', 'mouseout']);
            }
            onDomEvent(e) {
              this.fire(e.type, e);
            }
          }
          class Im {
            constructor(e) {
              this.document = e;
            }
            createDocumentFragment(e) {
              return new Cr(this.document, e);
            }
            createElement(e, t, n) {
              return new Ni(this.document, e, t, n);
            }
            createText(e) {
              return new Mo(this.document, e);
            }
            clone(e, t = !1) {
              return e._clone(t);
            }
            appendChild(e, t) {
              return t._appendChild(e);
            }
            insertChild(e, t, n) {
              return n._insertChild(e, t);
            }
            removeChildren(e, t, n) {
              return n._removeChildren(e, t);
            }
            remove(e) {
              const t = e.parent;
              return t ? this.removeChildren(t.getChildIndex(e), 1, t) : [];
            }
            replace(e, t) {
              const n = e.parent;
              if (n) {
                const o = n.getChildIndex(e);
                return this.removeChildren(o, 1, n), this.insertChild(o, t, n), !0;
              }
              return !1;
            }
            unwrapElement(e) {
              const t = e.parent;
              if (t) {
                const n = t.getChildIndex(e);
                this.remove(e), this.insertChild(n, e.getChildren(), t);
              }
            }
            rename(e, t) {
              const n = new Ni(this.document, e, t.getAttributes(), t.getChildren());
              return this.replace(t, n) ? n : null;
            }
            setAttribute(e, t, n) {
              n._setAttribute(e, t);
            }
            removeAttribute(e, t) {
              t._removeAttribute(e);
            }
            addClass(e, t) {
              t._addClass(e);
            }
            removeClass(e, t) {
              t._removeClass(e);
            }
            setStyle(e, t, n) {
              he(e) && void 0 === n ? t._setStyle(e) : n._setStyle(e, t);
            }
            removeStyle(e, t) {
              t._removeStyle(e);
            }
            setCustomProperty(e, t, n) {
              n._setCustomProperty(e, t);
            }
            removeCustomProperty(e, t) {
              return t._removeCustomProperty(e);
            }
            createPositionAt(e, t) {
              return Fi._createAt(e, t);
            }
            createPositionAfter(e) {
              return Fi._createAfter(e);
            }
            createPositionBefore(e) {
              return Fi._createBefore(e);
            }
            createRange(e, t) {
              return new Hi(e, t);
            }
            createRangeOn(e) {
              return Hi._createOn(e);
            }
            createRangeIn(e) {
              return Hi._createIn(e);
            }
            createSelection(...e) {
              return new Wi(...e);
            }
          }
          const Sm = /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i,
            Mm = /^rgb\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}[0-9]{1,3}[ %]?\)$/i,
            Bm = /^rgba\([ ]?([0-9]{1,3}[ %]?,[ ]?){3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i,
            Nm = /^hsl\([ ]?([0-9]{1,3}[ %]?[,]?[ ]*){3}(1|[0-9]+%|[0]?\.?[0-9]+)?\)$/i,
            Pm = /^hsla\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i,
            zm = new Set([
              'black',
              'silver',
              'gray',
              'white',
              'maroon',
              'red',
              'purple',
              'fuchsia',
              'green',
              'lime',
              'olive',
              'yellow',
              'navy',
              'blue',
              'teal',
              'aqua',
              'orange',
              'aliceblue',
              'antiquewhite',
              'aquamarine',
              'azure',
              'beige',
              'bisque',
              'blanchedalmond',
              'blueviolet',
              'brown',
              'burlywood',
              'cadetblue',
              'chartreuse',
              'chocolate',
              'coral',
              'cornflowerblue',
              'cornsilk',
              'crimson',
              'cyan',
              'darkblue',
              'darkcyan',
              'darkgoldenrod',
              'darkgray',
              'darkgreen',
              'darkgrey',
              'darkkhaki',
              'darkmagenta',
              'darkolivegreen',
              'darkorange',
              'darkorchid',
              'darkred',
              'darksalmon',
              'darkseagreen',
              'darkslateblue',
              'darkslategray',
              'darkslategrey',
              'darkturquoise',
              'darkviolet',
              'deeppink',
              'deepskyblue',
              'dimgray',
              'dimgrey',
              'dodgerblue',
              'firebrick',
              'floralwhite',
              'forestgreen',
              'gainsboro',
              'ghostwhite',
              'gold',
              'goldenrod',
              'greenyellow',
              'grey',
              'honeydew',
              'hotpink',
              'indianred',
              'indigo',
              'ivory',
              'khaki',
              'lavender',
              'lavenderblush',
              'lawngreen',
              'lemonchiffon',
              'lightblue',
              'lightcoral',
              'lightcyan',
              'lightgoldenrodyellow',
              'lightgray',
              'lightgreen',
              'lightgrey',
              'lightpink',
              'lightsalmon',
              'lightseagreen',
              'lightskyblue',
              'lightslategray',
              'lightslategrey',
              'lightsteelblue',
              'lightyellow',
              'limegreen',
              'linen',
              'magenta',
              'mediumaquamarine',
              'mediumblue',
              'mediumorchid',
              'mediumpurple',
              'mediumseagreen',
              'mediumslateblue',
              'mediumspringgreen',
              'mediumturquoise',
              'mediumvioletred',
              'midnightblue',
              'mintcream',
              'mistyrose',
              'moccasin',
              'navajowhite',
              'oldlace',
              'olivedrab',
              'orangered',
              'orchid',
              'palegoldenrod',
              'palegreen',
              'paleturquoise',
              'palevioletred',
              'papayawhip',
              'peachpuff',
              'peru',
              'pink',
              'plum',
              'powderblue',
              'rosybrown',
              'royalblue',
              'saddlebrown',
              'salmon',
              'sandybrown',
              'seagreen',
              'seashell',
              'sienna',
              'skyblue',
              'slateblue',
              'slategray',
              'slategrey',
              'snow',
              'springgreen',
              'steelblue',
              'tan',
              'thistle',
              'tomato',
              'turquoise',
              'violet',
              'wheat',
              'whitesmoke',
              'yellowgreen',
              'activeborder',
              'activecaption',
              'appworkspace',
              'background',
              'buttonface',
              'buttonhighlight',
              'buttonshadow',
              'buttontext',
              'captiontext',
              'graytext',
              'highlight',
              'highlighttext',
              'inactiveborder',
              'inactivecaption',
              'inactivecaptiontext',
              'infobackground',
              'infotext',
              'menu',
              'menutext',
              'scrollbar',
              'threeddarkshadow',
              'threedface',
              'threedhighlight',
              'threedlightshadow',
              'threedshadow',
              'window',
              'windowframe',
              'windowtext',
              'rebeccapurple',
              'currentcolor',
              'transparent',
            ]);
          function Lm(e) {
            return e.startsWith('#')
              ? Sm.test(e)
              : e.startsWith('rgb')
              ? Mm.test(e) || Bm.test(e)
              : e.startsWith('hsl')
              ? Nm.test(e) || Pm.test(e)
              : zm.has(e.toLowerCase());
          }
          const jm = ['none', 'hidden', 'dotted', 'dashed', 'solid', 'double', 'groove', 'ridge', 'inset', 'outset'];
          function Om(e) {
            return jm.includes(e);
          }
          const Rm = /^([+-]?[0-9]*([.][0-9]+)?(px|cm|mm|in|pc|pt|ch|em|ex|rem|vh|vw|vmin|vmax)|0)$/;
          function Vm(e) {
            return Rm.test(e);
          }
          const Fm = /^[+-]?[0-9]*([.][0-9]+)?%$/;
          const Hm = ['repeat-x', 'repeat-y', 'repeat', 'space', 'round', 'no-repeat'];
          function Um(e) {
            return Hm.includes(e);
          }
          const qm = ['center', 'top', 'bottom', 'left', 'right'];
          function Wm(e) {
            return qm.includes(e);
          }
          const Gm = ['fixed', 'scroll', 'local'];
          function $m(e) {
            return Gm.includes(e);
          }
          const Ym = /^url\(/;
          function Km(e) {
            return Ym.test(e);
          }
          function Qm(e = '') {
            if ('' === e) return { top: void 0, right: void 0, bottom: void 0, left: void 0 };
            const t = eg(e),
              n = t[0],
              o = t[2] || n,
              i = t[1] || n;
            return { top: n, bottom: o, right: i, left: t[3] || i };
          }
          function Zm(e) {
            return (t) => {
              const { top: n, right: o, bottom: i, left: r } = t,
                s = [];
              return (
                [n, o, r, i].every((e) => !!e)
                  ? s.push([e, Jm(t)])
                  : (n && s.push([e + '-top', n]),
                    o && s.push([e + '-right', o]),
                    i && s.push([e + '-bottom', i]),
                    r && s.push([e + '-left', r])),
                s
              );
            };
          }
          function Jm({ top: e, right: t, bottom: n, left: o }) {
            const i = [];
            return o !== t ? i.push(e, t, n, o) : n !== e ? i.push(e, t, n) : t !== e ? i.push(e, t) : i.push(e), i.join(' ');
          }
          function Xm(e) {
            return (t) => ({ path: e, value: Qm(t) });
          }
          function eg(e) {
            return e
              .replace(/, /g, ',')
              .split(' ')
              .map((e) => e.replace(/,/g, ', '));
          }
          function tg(e) {
            e.setNormalizer('background', (e) => {
              const t = {},
                n = eg(e);
              for (const e of n)
                Um(e)
                  ? ((t.repeat = t.repeat || []), t.repeat.push(e))
                  : Wm(e)
                  ? ((t.position = t.position || []), t.position.push(e))
                  : $m(e)
                  ? (t.attachment = e)
                  : Lm(e)
                  ? (t.color = e)
                  : Km(e) && (t.image = e);
              return { path: 'background', value: t };
            }),
              e.setNormalizer('background-color', (e) => ({ path: 'background.color', value: e })),
              e.setReducer('background', (e) => {
                const t = [];
                return t.push(['background-color', e.color]), t;
              }),
              e.setStyleRelation('background', ['background-color']);
          }
          function ng(e) {
            e.setNormalizer('border', (e) => {
              const { color: t, style: n, width: o } = cg(e);
              return { path: 'border', value: { color: Qm(t), style: Qm(n), width: Qm(o) } };
            }),
              e.setNormalizer('border-top', og('top')),
              e.setNormalizer('border-right', og('right')),
              e.setNormalizer('border-bottom', og('bottom')),
              e.setNormalizer('border-left', og('left')),
              e.setNormalizer('border-color', ig('color')),
              e.setNormalizer('border-width', ig('width')),
              e.setNormalizer('border-style', ig('style')),
              e.setNormalizer('border-top-color', sg('color', 'top')),
              e.setNormalizer('border-top-style', sg('style', 'top')),
              e.setNormalizer('border-top-width', sg('width', 'top')),
              e.setNormalizer('border-right-color', sg('color', 'right')),
              e.setNormalizer('border-right-style', sg('style', 'right')),
              e.setNormalizer('border-right-width', sg('width', 'right')),
              e.setNormalizer('border-bottom-color', sg('color', 'bottom')),
              e.setNormalizer('border-bottom-style', sg('style', 'bottom')),
              e.setNormalizer('border-bottom-width', sg('width', 'bottom')),
              e.setNormalizer('border-left-color', sg('color', 'left')),
              e.setNormalizer('border-left-style', sg('style', 'left')),
              e.setNormalizer('border-left-width', sg('width', 'left')),
              e.setExtractor('border-top', ag('top')),
              e.setExtractor('border-right', ag('right')),
              e.setExtractor('border-bottom', ag('bottom')),
              e.setExtractor('border-left', ag('left')),
              e.setExtractor('border-top-color', 'border.color.top'),
              e.setExtractor('border-right-color', 'border.color.right'),
              e.setExtractor('border-bottom-color', 'border.color.bottom'),
              e.setExtractor('border-left-color', 'border.color.left'),
              e.setExtractor('border-top-width', 'border.width.top'),
              e.setExtractor('border-right-width', 'border.width.right'),
              e.setExtractor('border-bottom-width', 'border.width.bottom'),
              e.setExtractor('border-left-width', 'border.width.left'),
              e.setExtractor('border-top-style', 'border.style.top'),
              e.setExtractor('border-right-style', 'border.style.right'),
              e.setExtractor('border-bottom-style', 'border.style.bottom'),
              e.setExtractor('border-left-style', 'border.style.left'),
              e.setReducer('border-color', Zm('border-color')),
              e.setReducer('border-style', Zm('border-style')),
              e.setReducer('border-width', Zm('border-width')),
              e.setReducer('border-top', dg('top')),
              e.setReducer('border-right', dg('right')),
              e.setReducer('border-bottom', dg('bottom')),
              e.setReducer('border-left', dg('left')),
              e.setReducer(
                'border',
                (function () {
                  return (t) => {
                    const n = lg(t, 'top'),
                      o = lg(t, 'right'),
                      i = lg(t, 'bottom'),
                      r = lg(t, 'left'),
                      s = [n, o, i, r],
                      a = { width: e(s, 'width'), style: e(s, 'style'), color: e(s, 'color') },
                      l = ug(a, 'all');
                    if (l.length) return l;
                    const c = Object.entries(a).reduce(
                      (e, [t, n]) => (n && (e.push([`border-${t}`, n]), s.forEach((e) => delete e[t])), e),
                      []
                    );
                    return [...c, ...ug(n, 'top'), ...ug(o, 'right'), ...ug(i, 'bottom'), ...ug(r, 'left')];
                  };
                  function e(e, t) {
                    return e.map((e) => e[t]).reduce((e, t) => (e == t ? e : null));
                  }
                })()
              ),
              e.setStyleRelation('border', [
                'border-color',
                'border-style',
                'border-width',
                'border-top',
                'border-right',
                'border-bottom',
                'border-left',
                'border-top-color',
                'border-right-color',
                'border-bottom-color',
                'border-left-color',
                'border-top-style',
                'border-right-style',
                'border-bottom-style',
                'border-left-style',
                'border-top-width',
                'border-right-width',
                'border-bottom-width',
                'border-left-width',
              ]),
              e.setStyleRelation('border-color', ['border-top-color', 'border-right-color', 'border-bottom-color', 'border-left-color']),
              e.setStyleRelation('border-style', ['border-top-style', 'border-right-style', 'border-bottom-style', 'border-left-style']),
              e.setStyleRelation('border-width', ['border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width']),
              e.setStyleRelation('border-top', ['border-top-color', 'border-top-style', 'border-top-width']),
              e.setStyleRelation('border-right', ['border-right-color', 'border-right-style', 'border-right-width']),
              e.setStyleRelation('border-bottom', ['border-bottom-color', 'border-bottom-style', 'border-bottom-width']),
              e.setStyleRelation('border-left', ['border-left-color', 'border-left-style', 'border-left-width']);
          }
          function og(e) {
            return (t) => {
              const { color: n, style: o, width: i } = cg(t),
                r = {};
              return (
                void 0 !== n && (r.color = { [e]: n }),
                void 0 !== o && (r.style = { [e]: o }),
                void 0 !== i && (r.width = { [e]: i }),
                { path: 'border', value: r }
              );
            };
          }
          function ig(e) {
            return (t) => ({ path: 'border', value: rg(t, e) });
          }
          function rg(e, t) {
            return { [t]: Qm(e) };
          }
          function sg(e, t) {
            return (n) => ({ path: 'border', value: { [e]: { [t]: n } } });
          }
          function ag(e) {
            return (t, n) => {
              if (n.border) return lg(n.border, e);
            };
          }
          function lg(e, t) {
            const n = {};
            return (
              e.width && e.width[t] && (n.width = e.width[t]),
              e.style && e.style[t] && (n.style = e.style[t]),
              e.color && e.color[t] && (n.color = e.color[t]),
              n
            );
          }
          function cg(e) {
            const t = {},
              n = eg(e);
            for (const e of n) Vm(e) || /thin|medium|thick/.test(e) ? (t.width = e) : Om(e) ? (t.style = e) : (t.color = e);
            return t;
          }
          function dg(e) {
            return (t) => ug(t, e);
          }
          function ug(e, t) {
            const n = [];
            if ((e && e.width && n.push('width'), e && e.style && n.push('style'), e && e.color && n.push('color'), 3 == n.length)) {
              const o = n.map((t) => e[t]).join(' ');
              return ['all' == t ? ['border', o] : [`border-${t}`, o]];
            }
            return 'all' == t ? [] : n.map((n) => [`border-${t}-${n}`, e[n]]);
          }
          function hg(e) {
            e.setNormalizer('margin', Xm('margin')),
              e.setNormalizer('margin-top', (e) => ({ path: 'margin.top', value: e })),
              e.setNormalizer('margin-right', (e) => ({ path: 'margin.right', value: e })),
              e.setNormalizer('margin-bottom', (e) => ({ path: 'margin.bottom', value: e })),
              e.setNormalizer('margin-left', (e) => ({ path: 'margin.left', value: e })),
              e.setReducer('margin', Zm('margin')),
              e.setStyleRelation('margin', ['margin-top', 'margin-right', 'margin-bottom', 'margin-left']);
          }
          function mg(e) {
            e.setNormalizer('padding', Xm('padding')),
              e.setNormalizer('padding-top', (e) => ({ path: 'padding.top', value: e })),
              e.setNormalizer('padding-right', (e) => ({ path: 'padding.right', value: e })),
              e.setNormalizer('padding-bottom', (e) => ({ path: 'padding.bottom', value: e })),
              e.setNormalizer('padding-left', (e) => ({ path: 'padding.left', value: e })),
              e.setReducer('padding', Zm('padding')),
              e.setStyleRelation('padding', ['padding-top', 'padding-right', 'padding-bottom', 'padding-left']);
          }
          class gg extends pu {
            constructor(e, t) {
              super(e), (this.view = t), (this._toolbarConfig = rh(e.config.get('toolbar'))), (this._elementReplacer = new ma());
            }
            get element() {
              return this.view.element;
            }
            init(e) {
              const t = this.editor,
                n = this.view,
                o = t.editing.view,
                i = n.editable,
                r = o.document.getRoot();
              (i.name = r.rootName), n.render();
              const s = i.element;
              this.setEditableElement(i.name, s),
                n.editable.bind('isFocused').to(this.focusTracker),
                o.attachDomRoot(s),
                e && this._elementReplacer.replace(e, this.element),
                this._initPlaceholder(),
                this._initToolbar(),
                this.fire('ready');
            }
            destroy() {
              const e = this.view,
                t = this.editor.editing.view;
              this._elementReplacer.restore(), t.detachDomRoot(e.editable.name), e.destroy(), super.destroy();
            }
            _initToolbar() {
              const e = this.view;
              e.stickyPanel.bind('isActive').to(this.focusTracker, 'isFocused'),
                (e.stickyPanel.limiterElement = e.element),
                e.stickyPanel.bind('viewportTopOffset').to(this, 'viewportOffset', ({ top: e }) => e),
                e.toolbar.fillFromConfig(this._toolbarConfig, this.componentFactory),
                this.addToolbar(e.toolbar);
            }
            _initPlaceholder() {
              const e = this.editor,
                t = e.editing.view,
                n = t.document.getRoot(),
                o = e.sourceElement,
                i = e.config.get('placeholder') || (o && 'textarea' === o.tagName.toLowerCase() && o.getAttribute('placeholder'));
              i && um({ view: t, element: n, text: i, isDirectHost: !1, keepOnFocus: !0 });
            }
          }
          var pg = n(3638),
            fg = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(pg.Z, fg);
          pg.Z.locals;
          class kg extends Mh {
            constructor(e, t, n = {}) {
              super(e),
                (this.stickyPanel = new rm(e)),
                (this.toolbar = new lh(e, { shouldGroupWhenFull: n.shouldToolbarGroupWhenFull })),
                (this.editable = new Nh(e, t));
            }
            render() {
              super.render(), this.stickyPanel.content.add(this.toolbar), this.top.add(this.stickyPanel), this.main.add(this.editable);
            }
          }
          class bg extends Ed {
            constructor(e, t = {}) {
              if (!uo(e) && void 0 !== t.initialData) throw new l('editor-create-initial-data', null);
              super(t),
                void 0 === this.config.get('initialData') &&
                  this.config.set(
                    'initialData',
                    (function (e) {
                      return uo(e) ? ((t = e), t instanceof HTMLTextAreaElement ? t.value : t.innerHTML) : e;
                      var t;
                    })(e)
                  ),
                uo(e) && (this.sourceElement = e),
                this.model.document.createRoot();
              const n = !this.config.get('toolbar.shouldNotGroupWhenFull'),
                o = new kg(this.locale, this.editing.view, { shouldToolbarGroupWhenFull: n });
              (this.ui = new gg(this, o)),
                (function (e) {
                  if (!De(e.updateSourceElement)) throw new l('attachtoform-missing-elementapi-interface', e);
                  const t = e.sourceElement;
                  if (t && 'textarea' === t.tagName.toLowerCase() && t.form) {
                    let n;
                    const o = t.form,
                      i = () => e.updateSourceElement();
                    De(o.submit) &&
                      ((n = o.submit),
                      (o.submit = () => {
                        i(), n.apply(o);
                      })),
                      o.addEventListener('submit', i),
                      e.on('destroy', () => {
                        o.removeEventListener('submit', i), n && (o.submit = n);
                      });
                  }
                })(this);
            }
            destroy() {
              return this.sourceElement && this.updateSourceElement(), this.ui.destroy(), super.destroy();
            }
            static create(e, t = {}) {
              return new Promise((n) => {
                const o = new this(e, t);
                n(
                  o
                    .initPlugins()
                    .then(() => o.ui.init(uo(e) ? e : null))
                    .then(() => o.data.init(o.config.get('initialData')))
                    .then(() => o.fire('ready'))
                    .then(() => o)
                );
              });
            }
          }
          R(bg, bu), R(bg, _u);
          const wg = ['left', 'right', 'center', 'justify'];
          function _g(e) {
            return wg.includes(e);
          }
          function yg(e, t) {
            return 'rtl' == t.contentLanguageDirection ? 'right' === e : 'left' === e;
          }
          function Ag(e) {
            const t = e
                .map((e) => {
                  let t;
                  return (t = 'string' == typeof e ? { name: e } : e), t;
                })
                .filter((e) => {
                  const t = !!wg.includes(e.name);
                  return t || c('alignment-config-name-not-recognized', { option: e }), t;
                }),
              n = t.filter((e) => !!e.className).length;
            if (n && n < t.length) throw new l('alignment-config-classnames-are-missing', { configuredOptions: e });
            return (
              t.forEach((t, n, o) => {
                const i = o.slice(n + 1);
                if (i.some((e) => e.name == t.name))
                  throw new l('alignment-config-name-already-defined', { option: t, configuredOptions: e });
                if (t.className) {
                  if (i.some((e) => e.className == t.className))
                    throw new l('alignment-config-classname-already-defined', { option: t, configuredOptions: e });
                }
              }),
              t
            );
          }
          const Cg = 'alignment';
          class vg extends H {
            refresh() {
              const e = this.editor.locale,
                t = Ca(this.editor.model.document.selection.getSelectedBlocks());
              (this.isEnabled = !!t && this._canBeAligned(t)),
                this.isEnabled && t.hasAttribute('alignment')
                  ? (this.value = t.getAttribute('alignment'))
                  : (this.value = 'rtl' === e.contentLanguageDirection ? 'right' : 'left');
            }
            execute(e = {}) {
              const t = this.editor,
                n = t.locale,
                o = t.model,
                i = o.document,
                r = e.value;
              o.change((e) => {
                const t = Array.from(i.selection.getSelectedBlocks()).filter((e) => this._canBeAligned(e)),
                  o = t[0].getAttribute('alignment');
                yg(r, n) || o === r || !r
                  ? (function (e, t) {
                      for (const n of e) t.removeAttribute(Cg, n);
                    })(t, e)
                  : (function (e, t, n) {
                      for (const o of e) t.setAttribute(Cg, n, o);
                    })(t, e, r);
              });
            }
            _canBeAligned(e) {
              return this.editor.model.schema.checkAttribute(e, Cg);
            }
          }
          class xg extends V {
            static get pluginName() {
              return 'AlignmentEditing';
            }
            constructor(e) {
              super(e), e.config.define('alignment', { options: [...wg.map((e) => ({ name: e }))] });
            }
            init() {
              const e = this.editor,
                t = e.locale,
                n = e.model.schema,
                o = Ag(e.config.get('alignment.options')).filter((e) => _g(e.name) && !yg(e.name, t)),
                i = o.some((e) => !!e.className);
              n.extend('$block', { allowAttributes: 'alignment' }),
                e.model.schema.setAttributeProperties('alignment', { isFormatting: !0 }),
                i
                  ? e.conversion.attributeToAttribute(
                      (function (e) {
                        const t = { model: { key: 'alignment', values: e.map((e) => e.name) }, view: {} };
                        for (const n of e) t.view[n.name] = { key: 'class', value: n.className };
                        return t;
                      })(o)
                    )
                  : e.conversion.for('downcast').attributeToAttribute(
                      (function (e) {
                        const t = { model: { key: 'alignment', values: e.map((e) => e.name) }, view: {} };
                        for (const { name: n } of e) t.view[n] = { key: 'style', value: { 'text-align': n } };
                        return t;
                      })(o)
                    );
              const r = (function (e) {
                const t = [];
                for (const { name: n } of e)
                  t.push({ view: { key: 'style', value: { 'text-align': n } }, model: { key: 'alignment', value: n } });
                return t;
              })(o);
              for (const t of r) e.conversion.for('upcast').attributeToAttribute(t);
              const s = (function (e) {
                const t = [];
                for (const { name: n } of e) t.push({ view: { key: 'align', value: n }, model: { key: 'alignment', value: n } });
                return t;
              })(o);
              for (const t of s) e.conversion.for('upcast').attributeToAttribute(t);
              e.commands.add('alignment', new vg(e));
            }
          }
          const Eg = new Map([
            ['left', Cu.alignLeft],
            ['right', Cu.alignRight],
            ['center', Cu.alignCenter],
            ['justify', Cu.alignJustify],
          ]);
          class Dg extends V {
            get localizedOptionTitles() {
              const e = this.editor.t;
              return { left: e('Align left'), right: e('Align right'), center: e('Align center'), justify: e('Justify') };
            }
            static get pluginName() {
              return 'AlignmentUI';
            }
            init() {
              const e = this.editor,
                t = e.ui.componentFactory,
                n = e.t,
                o = Ag(e.config.get('alignment.options'));
              o
                .map((e) => e.name)
                .filter(_g)
                .forEach((e) => this._addButton(e)),
                t.add('alignment', (i) => {
                  const r = yh(i),
                    s = o.map((e) => t.create(`alignment:${e.name}`));
                  Ah(r, s, { enableActiveItemFocusOnDropdownOpen: !0 }),
                    r.buttonView.set({ label: n('Text alignment'), tooltip: !0 }),
                    (r.toolbarView.isVertical = !0),
                    (r.toolbarView.ariaLabel = n('Text alignment toolbar')),
                    r.extendTemplate({ attributes: { class: 'ck-alignment-dropdown' } });
                  const a = 'rtl' === i.contentLanguageDirection ? Eg.get('right') : Eg.get('left');
                  return (
                    r.buttonView.bind('icon').toMany(s, 'isOn', (...e) => {
                      const t = e.findIndex((e) => e);
                      return t < 0 ? a : s[t].icon;
                    }),
                    r.bind('isEnabled').toMany(s, 'isEnabled', (...e) => e.some((e) => e)),
                    this.listenTo(r, 'execute', () => {
                      e.editing.view.focus();
                    }),
                    r
                  );
                });
            }
            _addButton(e) {
              const t = this.editor;
              t.ui.componentFactory.add(`alignment:${e}`, (n) => {
                const o = t.commands.get('alignment'),
                  i = new zu(n);
                return (
                  i.set({ label: this.localizedOptionTitles[e], icon: Eg.get(e), tooltip: !0, isToggleable: !0 }),
                  i.bind('isEnabled').to(o),
                  i.bind('isOn').to(o, 'value', (t) => t === e),
                  this.listenTo(i, 'execute', () => {
                    t.execute('alignment', { value: e }), t.editing.view.focus();
                  }),
                  i
                );
              });
            }
          }
          class Tg {
            constructor(e, t = 20) {
              (this.model = e),
                (this.size = 0),
                (this.limit = t),
                (this.isLocked = !1),
                (this._changeCallback = (e, t) => {
                  t.isLocal && t.isUndoable && t !== this._batch && this._reset(!0);
                }),
                (this._selectionChangeCallback = () => {
                  this._reset();
                }),
                this.model.document.on('change', this._changeCallback),
                this.model.document.selection.on('change:range', this._selectionChangeCallback),
                this.model.document.selection.on('change:attribute', this._selectionChangeCallback);
            }
            get batch() {
              return this._batch || (this._batch = this.model.createBatch({ isTyping: !0 })), this._batch;
            }
            input(e) {
              (this.size += e), this.size >= this.limit && this._reset(!0);
            }
            lock() {
              this.isLocked = !0;
            }
            unlock() {
              this.isLocked = !1;
            }
            destroy() {
              this.model.document.off('change', this._changeCallback),
                this.model.document.selection.off('change:range', this._selectionChangeCallback),
                this.model.document.selection.off('change:attribute', this._selectionChangeCallback);
            }
            _reset(e) {
              (this.isLocked && !e) || ((this._batch = null), (this.size = 0));
            }
          }
          class Ig extends H {
            constructor(e, t) {
              super(e), (this._buffer = new Tg(e.model, t));
            }
            get buffer() {
              return this._buffer;
            }
            destroy() {
              super.destroy(), this._buffer.destroy();
            }
            execute(e = {}) {
              const t = this.editor.model,
                n = t.document,
                o = e.text || '',
                i = o.length,
                r = e.range ? t.createSelection(e.range) : n.selection,
                s = e.resultRange;
              t.enqueueChange(this._buffer.batch, (e) => {
                this._buffer.lock(),
                  t.deleteContent(r),
                  o && t.insertContent(e.createText(o, n.selection.getAttributes()), r),
                  s ? e.setSelection(s) : r.is('documentSelection') || e.setSelection(r),
                  this._buffer.unlock(),
                  this._buffer.input(i);
              });
            }
          }
          function Sg(e) {
            if (e.newChildren.length - e.oldChildren.length != 1) return;
            const t = (function (e, t) {
              const n = [];
              let o = 0,
                i = null;
              return (
                e.forEach((e) => {
                  'equal' == e
                    ? (r(), o++)
                    : 'insert' == e
                    ? (i && 'insert' == i.type ? i.values.push(t[o]) : (r(), (i = { type: 'insert', index: o, values: [t[o]] })), o++)
                    : i && 'delete' == i.type
                    ? i.howMany++
                    : (r(), (i = { type: 'delete', index: o, howMany: 1 }));
                }),
                r(),
                n
              );
              function r() {
                i && (n.push(i), (i = null));
              }
            })($r(e.oldChildren, e.newChildren, Mg), e.newChildren);
            if (t.length > 1) return;
            const n = t[0];
            return n.values[0] && n.values[0].is('$text') ? n : void 0;
          }
          function Mg(e, t) {
            return e && e.is('$text') && t && t.is('$text') ? e.data === t.data : e === t;
          }
          function Bg(e, t) {
            const n = t.selection,
              o = e.shiftKey && e.keyCode === hr.delete,
              i = !n.isCollapsed;
            return o && i;
          }
          const Ng = [
            gr('arrowUp'),
            gr('arrowRight'),
            gr('arrowDown'),
            gr('arrowLeft'),
            9,
            16,
            17,
            18,
            19,
            20,
            27,
            33,
            34,
            35,
            36,
            45,
            91,
            93,
            144,
            145,
            173,
            174,
            175,
            176,
            177,
            178,
            179,
            255,
          ];
          for (let e = 112; e <= 135; e++) Ng.push(e);
          function Pg(e) {
            return !(!e.ctrlKey && !e.metaKey) || Ng.includes(e.keyCode);
          }
          class zg {
            constructor(e) {
              (this.editor = e), (this.editing = this.editor.editing);
            }
            handle(e, t) {
              if (
                (function (e) {
                  if (0 == e.length) return !1;
                  for (const t of e) if ('children' === t.type && !Sg(t)) return !0;
                  return !1;
                })(e)
              )
                this._handleContainerChildrenMutations(e, t);
              else for (const n of e) this._handleTextMutation(n, t), this._handleTextNodeInsertion(n);
            }
            _handleContainerChildrenMutations(e, t) {
              const n = (function (e) {
                const t = e.map((e) => e.node).reduce((e, t) => e.getCommonAncestor(t, { includeSelf: !0 }));
                if (!t) return;
                return t.getAncestors({ includeSelf: !0, parentFirst: !0 }).find((e) => e.is('containerElement') || e.is('rootElement'));
              })(e);
              if (!n) return;
              const o = this.editor.editing.view.domConverter.mapViewToDom(n),
                i = new ms(this.editor.editing.view.document),
                r = this.editor.data.toModel(i.domToView(o)).getChild(0),
                s = this.editor.editing.mapper.toModelElement(n);
              if (!s) return;
              const a = Array.from(r.getChildren()),
                l = Array.from(s.getChildren()),
                c = a[a.length - 1],
                d = l[l.length - 1],
                u = c && c.is('element', 'softBreak'),
                h = d && !d.is('element', 'softBreak');
              u && h && a.pop();
              const m = this.editor.model.schema;
              if (!Lg(a, m) || !Lg(l, m)) return;
              const g = a
                  .map((e) => (e.is('$text') ? e.data : '@'))
                  .join('')
                  .replace(/\u00A0/g, ' '),
                p = l
                  .map((e) => (e.is('$text') ? e.data : '@'))
                  .join('')
                  .replace(/\u00A0/g, ' ');
              if (p === g) return;
              const f = $r(p, g),
                { firstChangeAt: k, insertions: b, deletions: w } = jg(f);
              let _ = null;
              t && (_ = this.editing.mapper.toModelRange(t.getFirstRange()));
              const y = g.substr(k, b),
                A = this.editor.model.createRange(this.editor.model.createPositionAt(s, k), this.editor.model.createPositionAt(s, k + w));
              this.editor.execute('input', { text: y, range: A, resultRange: _ });
            }
            _handleTextMutation(e, t) {
              if ('text' != e.type) return;
              const n = e.newText.replace(/\u00A0/g, ' '),
                o = e.oldText.replace(/\u00A0/g, ' ');
              if (o === n) return;
              const i = $r(o, n),
                { firstChangeAt: r, insertions: s, deletions: a } = jg(i);
              let l = null;
              t && (l = this.editing.mapper.toModelRange(t.getFirstRange()));
              const c = this.editing.view.createPositionAt(e.node, r),
                d = this.editing.mapper.toModelPosition(c),
                u = this.editor.model.createRange(d, d.getShiftedBy(a)),
                h = n.substr(r, s);
              this.editor.execute('input', { text: h, range: u, resultRange: l });
            }
            _handleTextNodeInsertion(e) {
              if ('children' != e.type) return;
              const t = Sg(e),
                n = this.editing.view.createPositionAt(e.node, t.index),
                o = this.editing.mapper.toModelPosition(n),
                i = t.values[0].data;
              this.editor.execute('input', { text: i.replace(/\u00A0/g, ' '), range: this.editor.model.createRange(o) });
            }
          }
          function Lg(e, t) {
            return e.every((e) => t.isInline(e));
          }
          function jg(e) {
            let t = null,
              n = null;
            for (let o = 0; o < e.length; o++) {
              'equal' != e[o] && ((t = null === t ? o : t), (n = o));
            }
            let o = 0,
              i = 0;
            for (let r = t; r <= n; r++) 'insert' != e[r] && o++, 'delete' != e[r] && i++;
            return { insertions: i, deletions: o, firstChangeAt: t };
          }
          class Og extends V {
            static get pluginName() {
              return 'Input';
            }
            init() {
              const e = this.editor,
                t = new Ig(e, e.config.get('typing.undoStep') || 20);
              e.commands.add('input', t),
                (function (e) {
                  let t = null;
                  const n = e.model,
                    o = e.editing.view,
                    i = e.commands.get('input');
                  function r(e) {
                    if (lr.isWindows && Bg(e, o.document)) return;
                    const r = n.document,
                      a = o.document.isComposing,
                      l = t && t.isEqual(r.selection);
                    (t = null),
                      i.isEnabled &&
                        (Pg(e) || r.selection.isCollapsed || (a && 229 === e.keyCode) || (!a && 229 === e.keyCode && l) || s());
                  }
                  function s() {
                    const e = i.buffer;
                    e.lock();
                    const t = e.batch;
                    n.enqueueChange(t, () => {
                      n.deleteContent(n.document.selection);
                    }),
                      e.unlock();
                  }
                  lr.isAndroid
                    ? o.document.on('beforeinput', (e, t) => r(t), { priority: 'lowest' })
                    : o.document.on('keydown', (e, t) => r(t), { priority: 'lowest' }),
                    o.document.on(
                      'compositionstart',
                      function () {
                        const e = n.document,
                          t = 1 !== e.selection.rangeCount || e.selection.getFirstRange().isFlat;
                        e.selection.isCollapsed || t || s();
                      },
                      { priority: 'lowest' }
                    ),
                    o.document.on(
                      'compositionend',
                      () => {
                        t = n.createSelection(n.document.selection);
                      },
                      { priority: 'lowest' }
                    );
                })(e),
                (function (e) {
                  e.editing.view.document.on('mutations', (t, n, o) => {
                    new zg(e).handle(n, o);
                  });
                })(e);
            }
          }
          class Rg extends H {
            constructor(e, t) {
              super(e), (this.direction = t), (this._buffer = new Tg(e.model, e.config.get('typing.undoStep')));
            }
            get buffer() {
              return this._buffer;
            }
            execute(e = {}) {
              const t = this.editor.model,
                n = t.document;
              t.enqueueChange(this._buffer.batch, (o) => {
                this._buffer.lock();
                const i = o.createSelection(e.selection || n.selection),
                  r = e.sequence || 1,
                  s = i.isCollapsed;
                if (
                  (i.isCollapsed && t.modifySelection(i, { direction: this.direction, unit: e.unit, treatEmojiAsSingleUnit: !0 }),
                  this._shouldEntireContentBeReplacedWithParagraph(r))
                )
                  return void this._replaceEntireContentWithParagraph(o);
                if (this._shouldReplaceFirstBlockWithParagraph(i, r)) return void this.editor.execute('paragraph', { selection: i });
                if (i.isCollapsed) return;
                let a = 0;
                i
                  .getFirstRange()
                  .getMinimalFlatRanges()
                  .forEach((e) => {
                    a += qi(e.getWalker({ singleCharacters: !0, ignoreElementEnd: !0, shallow: !0 }));
                  }),
                  t.deleteContent(i, { doNotResetEntireContent: s, direction: this.direction }),
                  this._buffer.input(a),
                  o.setSelection(i),
                  this._buffer.unlock();
              });
            }
            _shouldEntireContentBeReplacedWithParagraph(e) {
              if (e > 1) return !1;
              const t = this.editor.model,
                n = t.document.selection,
                o = t.schema.getLimitElement(n);
              if (!(n.isCollapsed && n.containsEntireContent(o))) return !1;
              if (!t.schema.checkChild(o, 'paragraph')) return !1;
              const i = o.getChild(0);
              return !i || 'paragraph' !== i.name;
            }
            _replaceEntireContentWithParagraph(e) {
              const t = this.editor.model,
                n = t.document.selection,
                o = t.schema.getLimitElement(n),
                i = e.createElement('paragraph');
              e.remove(e.createRangeIn(o)), e.insert(i, o), e.setSelection(i, 0);
            }
            _shouldReplaceFirstBlockWithParagraph(e, t) {
              const n = this.editor.model;
              if (t > 1 || 'backward' != this.direction) return !1;
              if (!e.isCollapsed) return !1;
              const o = e.getFirstPosition(),
                i = n.schema.getLimitElement(o),
                r = i.getChild(0);
              return o.parent == r && !!e.containsEntireContent(r) && !!n.schema.checkChild(i, 'paragraph') && 'paragraph' != r.name;
            }
          }
          class Vg extends As {
            constructor(e) {
              super(e);
              const t = e.document;
              let n = 0;
              function o(e, n, o) {
                const i = new $i(t, 'delete', t.selection.getFirstRange());
                t.fire(i, new Gs(t, n, o)), i.stop.called && e.stop();
              }
              t.on('keyup', (e, t) => {
                (t.keyCode != hr.delete && t.keyCode != hr.backspace) || (n = 0);
              }),
                t.on('keydown', (e, i) => {
                  if (lr.isWindows && Bg(i, t)) return;
                  const r = {};
                  if (i.keyCode == hr.delete) (r.direction = 'forward'), (r.unit = 'character');
                  else {
                    if (i.keyCode != hr.backspace) return;
                    (r.direction = 'backward'), (r.unit = 'codePoint');
                  }
                  const s = lr.isMac ? i.altKey : i.ctrlKey;
                  (r.unit = s ? 'word' : r.unit), (r.sequence = ++n), o(e, i.domEvent, r);
                }),
                lr.isAndroid &&
                  t.on('beforeinput', (t, n) => {
                    if ('deleteContentBackward' != n.domEvent.inputType) return;
                    const i = { unit: 'codepoint', direction: 'backward', sequence: 1 },
                      r = n.domTarget.ownerDocument.defaultView.getSelection();
                    r.anchorNode == r.focusNode &&
                      r.anchorOffset + 1 != r.focusOffset &&
                      (i.selectionToRemove = e.domConverter.domSelectionToView(r)),
                      o(t, n.domEvent, i);
                  });
            }
            observe() {}
          }
          class Fg extends V {
            static get pluginName() {
              return 'Delete';
            }
            init() {
              const e = this.editor,
                t = e.editing.view,
                n = t.document,
                o = e.model.document;
              t.addObserver(Vg), (this._undoOnBackspace = !1);
              const i = new Rg(e, 'forward');
              if (
                (e.commands.add('deleteForward', i),
                e.commands.add('forwardDelete', i),
                e.commands.add('delete', new Rg(e, 'backward')),
                this.listenTo(
                  n,
                  'delete',
                  (n, o) => {
                    const i = { unit: o.unit, sequence: o.sequence };
                    if (o.selectionToRemove) {
                      const t = e.model.createSelection(),
                        n = [];
                      for (const t of o.selectionToRemove.getRanges()) n.push(e.editing.mapper.toModelRange(t));
                      t.setTo(n), (i.selection = t);
                    }
                    e.execute('forward' == o.direction ? 'deleteForward' : 'delete', i), o.preventDefault(), t.scrollToTheSelection();
                  },
                  { priority: 'low' }
                ),
                lr.isAndroid)
              ) {
                let e = null;
                this.listenTo(
                  n,
                  'delete',
                  (t, n) => {
                    const o = n.domTarget.ownerDocument.defaultView.getSelection();
                    e = { anchorNode: o.anchorNode, anchorOffset: o.anchorOffset, focusNode: o.focusNode, focusOffset: o.focusOffset };
                  },
                  { priority: 'lowest' }
                ),
                  this.listenTo(n, 'keyup', (t, n) => {
                    if (e) {
                      const t = n.domTarget.ownerDocument.defaultView.getSelection();
                      t.collapse(e.anchorNode, e.anchorOffset), t.extend(e.focusNode, e.focusOffset), (e = null);
                    }
                  });
              }
              this.editor.plugins.has('UndoEditing') &&
                (this.listenTo(
                  n,
                  'delete',
                  (t, n) => {
                    this._undoOnBackspace &&
                      'backward' == n.direction &&
                      1 == n.sequence &&
                      'codePoint' == n.unit &&
                      ((this._undoOnBackspace = !1), e.execute('undo'), n.preventDefault(), t.stop());
                  },
                  { context: '$capture' }
                ),
                this.listenTo(o, 'change', () => {
                  this._undoOnBackspace = !1;
                }));
            }
            requestUndoOnBackspace() {
              this.editor.plugins.has('UndoEditing') && (this._undoOnBackspace = !0);
            }
          }
          class Hg extends V {
            static get requires() {
              return [Og, Fg];
            }
            static get pluginName() {
              return 'Typing';
            }
          }
          function Ug(e, t) {
            let n = e.start;
            return {
              text: Array.from(e.getItems()).reduce(
                (e, o) => (o.is('$text') || o.is('$textProxy') ? e + o.data : ((n = t.createPositionAfter(o)), '')),
                ''
              ),
              range: t.createRange(n, e.end),
            };
          }
          class qg {
            constructor(e, t) {
              (this.model = e),
                (this.testCallback = t),
                (this.hasMatch = !1),
                this.set('isEnabled', !0),
                this.on('change:isEnabled', () => {
                  this.isEnabled ? this._startListening() : (this.stopListening(e.document.selection), this.stopListening(e.document));
                }),
                this._startListening();
            }
            _startListening() {
              const e = this.model.document;
              this.listenTo(e.selection, 'change:range', (t, { directChange: n }) => {
                n &&
                  (e.selection.isCollapsed
                    ? this._evaluateTextBeforeSelection('selection')
                    : this.hasMatch && (this.fire('unmatched'), (this.hasMatch = !1)));
              }),
                this.listenTo(e, 'change:data', (e, t) => {
                  !t.isUndo && t.isLocal && this._evaluateTextBeforeSelection('data', { batch: t });
                });
            }
            _evaluateTextBeforeSelection(e, t = {}) {
              const n = this.model,
                o = n.document.selection,
                i = n.createRange(n.createPositionAt(o.focus.parent, 0), o.focus),
                { text: r, range: s } = Ug(i, n),
                a = this.testCallback(r);
              if ((!a && this.hasMatch && this.fire('unmatched'), (this.hasMatch = !!a), a)) {
                const n = Object.assign(t, { text: r, range: s });
                'object' == typeof a && Object.assign(n, a), this.fire(`matched:${e}`, n);
              }
            }
          }
          R(qg, B);
          class Wg extends V {
            static get pluginName() {
              return 'TwoStepCaretMovement';
            }
            constructor(e) {
              super(e), (this.attributes = new Set()), (this._overrideUid = null);
            }
            init() {
              const e = this.editor,
                t = e.model,
                n = e.editing.view,
                o = e.locale,
                i = t.document.selection;
              this.listenTo(
                n.document,
                'arrowKey',
                (e, t) => {
                  if (!i.isCollapsed) return;
                  if (t.shiftKey || t.altKey || t.ctrlKey) return;
                  const n = t.keyCode == hr.arrowright,
                    r = t.keyCode == hr.arrowleft;
                  if (!n && !r) return;
                  const s = o.contentLanguageDirection;
                  let a = !1;
                  (a = ('ltr' === s && n) || ('rtl' === s && r) ? this._handleForwardMovement(t) : this._handleBackwardMovement(t)),
                    !0 === a && e.stop();
                },
                { context: '$text', priority: 'highest' }
              ),
                (this._isNextGravityRestorationSkipped = !1),
                this.listenTo(i, 'change:range', (e, t) => {
                  this._isNextGravityRestorationSkipped
                    ? (this._isNextGravityRestorationSkipped = !1)
                    : this._isGravityOverridden &&
                      ((!t.directChange && Kg(i.getFirstPosition(), this.attributes)) || this._restoreGravity());
                });
            }
            registerAttribute(e) {
              this.attributes.add(e);
            }
            _handleForwardMovement(e) {
              const t = this.attributes,
                n = this.editor.model.document.selection,
                o = n.getFirstPosition();
              return (
                !this._isGravityOverridden && (!o.isAtStart || !Gg(n, t)) && (Kg(o, t) ? (Yg(e), this._overrideGravity(), !0) : void 0)
              );
            }
            _handleBackwardMovement(e) {
              const t = this.attributes,
                n = this.editor.model,
                o = n.document.selection,
                i = o.getFirstPosition();
              return this._isGravityOverridden
                ? (Yg(e), this._restoreGravity(), $g(n, t, i), !0)
                : i.isAtStart
                ? !!Gg(o, t) && (Yg(e), $g(n, t, i), !0)
                : (function (e, t) {
                    return Kg(e.getShiftedBy(-1), t);
                  })(i, t)
                ? i.isAtEnd && !Gg(o, t) && Kg(i, t)
                  ? (Yg(e), $g(n, t, i), !0)
                  : ((this._isNextGravityRestorationSkipped = !0), this._overrideGravity(), !1)
                : void 0;
            }
            get _isGravityOverridden() {
              return !!this._overrideUid;
            }
            _overrideGravity() {
              this._overrideUid = this.editor.model.change((e) => e.overrideSelectionGravity());
            }
            _restoreGravity() {
              this.editor.model.change((e) => {
                e.restoreSelectionGravity(this._overrideUid), (this._overrideUid = null);
              });
            }
          }
          function Gg(e, t) {
            for (const n of t) if (e.hasAttribute(n)) return !0;
            return !1;
          }
          function $g(e, t, n) {
            const o = n.nodeBefore;
            e.change((e) => {
              o ? e.setSelectionAttribute(o.getAttributes()) : e.removeSelectionAttribute(t);
            });
          }
          function Yg(e) {
            e.preventDefault();
          }
          function Kg(e, t) {
            const { nodeBefore: n, nodeAfter: o } = e;
            for (const e of t) {
              const t = n ? n.getAttribute(e) : void 0;
              if ((o ? o.getAttribute(e) : void 0) !== t) return !0;
            }
            return !1;
          }
          var Qg = /[\\^$.*+?()[\]{}|]/g,
            Zg = RegExp(Qg.source);
          const Jg = function (e) {
              return (e = Zo(e)) && Zg.test(e) ? e.replace(Qg, '\\$&') : e;
            },
            Xg = {
              copyright: { from: '(c)', to: '©' },
              registeredTrademark: { from: '(r)', to: '®' },
              trademark: { from: '(tm)', to: '™' },
              oneHalf: { from: /(^|[^/a-z0-9])(1\/2)([^/a-z0-9])$/i, to: [null, '½', null] },
              oneThird: { from: /(^|[^/a-z0-9])(1\/3)([^/a-z0-9])$/i, to: [null, '⅓', null] },
              twoThirds: { from: /(^|[^/a-z0-9])(2\/3)([^/a-z0-9])$/i, to: [null, '⅔', null] },
              oneForth: { from: /(^|[^/a-z0-9])(1\/4)([^/a-z0-9])$/i, to: [null, '¼', null] },
              threeQuarters: { from: /(^|[^/a-z0-9])(3\/4)([^/a-z0-9])$/i, to: [null, '¾', null] },
              lessThanOrEqual: { from: '<=', to: '≤' },
              greaterThanOrEqual: { from: '>=', to: '≥' },
              notEqual: { from: '!=', to: '≠' },
              arrowLeft: { from: '<-', to: '←' },
              arrowRight: { from: '->', to: '→' },
              horizontalEllipsis: { from: '...', to: '…' },
              enDash: { from: /(^| )(--)( )$/, to: [null, '–', null] },
              emDash: { from: /(^| )(---)( )$/, to: [null, '—', null] },
              quotesPrimary: { from: rp('"'), to: [null, '“', null, '”'] },
              quotesSecondary: { from: rp("'"), to: [null, '‘', null, '’'] },
              quotesPrimaryEnGb: { from: rp("'"), to: [null, '‘', null, '’'] },
              quotesSecondaryEnGb: { from: rp('"'), to: [null, '“', null, '”'] },
              quotesPrimaryPl: { from: rp('"'), to: [null, '„', null, '”'] },
              quotesSecondaryPl: { from: rp("'"), to: [null, '‚', null, '’'] },
            },
            ep = {
              symbols: ['copyright', 'registeredTrademark', 'trademark'],
              mathematical: [
                'oneHalf',
                'oneThird',
                'twoThirds',
                'oneForth',
                'threeQuarters',
                'lessThanOrEqual',
                'greaterThanOrEqual',
                'notEqual',
                'arrowLeft',
                'arrowRight',
              ],
              typography: ['horizontalEllipsis', 'enDash', 'emDash'],
              quotes: ['quotesPrimary', 'quotesSecondary'],
            },
            tp = ['symbols', 'mathematical', 'typography', 'quotes'];
          function np(e) {
            return 'string' == typeof e ? new RegExp(`(${Jg(e)})$`) : e;
          }
          function op(e) {
            return 'string' == typeof e ? () => [e] : e instanceof Array ? () => e : e;
          }
          function ip(e) {
            return (e.textNode ? e.textNode : e.nodeAfter).getAttributes();
          }
          function rp(e) {
            return new RegExp(`(^|\\s)(${e})([^${e}]*)(${e})$`);
          }
          function sp(e, t, n, o) {
            return o.createRange(ap(e, t, n, !0, o), ap(e, t, n, !1, o));
          }
          function ap(e, t, n, o, i) {
            let r = e.textNode || (o ? e.nodeBefore : e.nodeAfter),
              s = null;
            for (; r && r.getAttribute(t) == n; ) (s = r), (r = o ? r.previousSibling : r.nextSibling);
            return s ? i.createPositionAt(s, o ? 'before' : 'after') : e;
          }
          function lp(e, t, n, o) {
            let i,
              r = null;
            'function' == typeof o
              ? (i = o)
              : ((r = e.commands.get(o)),
                (i = () => {
                  e.execute(o);
                })),
              e.model.document.on('change:data', (s, a) => {
                if ((r && !r.isEnabled) || !t.isEnabled) return;
                const l = Ca(e.model.document.selection.getRanges());
                if (!l.isCollapsed) return;
                if (a.isUndo || !a.isLocal) return;
                const c = Array.from(e.model.document.differ.getChanges()),
                  d = c[0];
                if (1 != c.length || 'insert' !== d.type || '$text' != d.name || 1 != d.length) return;
                const u = d.position.parent;
                if (u.is('element', 'codeBlock')) return;
                if (u.is('element', 'listItem') && 'function' != typeof o && !['numberedList', 'bulletedList', 'todoList'].includes(o))
                  return;
                if (r && !0 === r.value) return;
                const h = u.getChild(0),
                  m = e.model.createRangeOn(h);
                if (!m.containsRange(l) && !l.end.isEqual(m.end)) return;
                const g = n.exec(h.data.substr(0, l.end.offset));
                g &&
                  e.model.enqueueChange((t) => {
                    const n = t.createPositionAt(u, 0),
                      o = t.createPositionAt(u, g[0].length),
                      r = new ll(n, o);
                    if (!1 !== i({ match: g })) {
                      t.remove(r);
                      const n = e.model.document.selection.getFirstRange(),
                        o = t.createRangeIn(u);
                      !u.isEmpty || o.isEqual(n) || o.containsRange(n, !0) || t.remove(u);
                    }
                    r.detach(),
                      e.model.enqueueChange(() => {
                        e.plugins.get('Delete').requestUndoOnBackspace();
                      });
                  });
              });
          }
          function cp(e, t, n, o) {
            let i, r;
            n instanceof RegExp ? (i = n) : (r = n),
              (r =
                r ||
                ((e) => {
                  let t;
                  const n = [],
                    o = [];
                  for (; null !== (t = i.exec(e)) && !(t && t.length < 4); ) {
                    let { index: e, 1: i, 2: r, 3: s } = t;
                    const a = i + r + s;
                    e += t[0].length - a.length;
                    const l = [e, e + i.length],
                      c = [e + i.length + r.length, e + i.length + r.length + s.length];
                    n.push(l), n.push(c), o.push([e + i.length, e + i.length + r.length]);
                  }
                  return { remove: n, format: o };
                })),
              e.model.document.on('change:data', (n, i) => {
                if (i.isUndo || !i.isLocal || !t.isEnabled) return;
                const s = e.model,
                  a = s.document.selection;
                if (!a.isCollapsed) return;
                const l = Array.from(s.document.differ.getChanges()),
                  c = l[0];
                if (1 != l.length || 'insert' !== c.type || '$text' != c.name || 1 != c.length) return;
                const d = a.focus,
                  u = d.parent,
                  { text: h, range: m } = (function (e, t) {
                    let n = e.start;
                    return {
                      text: Array.from(e.getItems()).reduce(
                        (e, o) =>
                          (!o.is('$text') && !o.is('$textProxy')) || o.getAttribute('code')
                            ? ((n = t.createPositionAfter(o)), '')
                            : e + o.data,
                        ''
                      ),
                      range: t.createRange(n, e.end),
                    };
                  })(s.createRange(s.createPositionAt(u, 0), d), s),
                  g = r(h),
                  p = dp(m.start, g.format, s),
                  f = dp(m.start, g.remove, s);
                p.length &&
                  f.length &&
                  s.enqueueChange((t) => {
                    if (!1 !== o(t, p)) {
                      for (const e of f.reverse()) t.remove(e);
                      s.enqueueChange(() => {
                        e.plugins.get('Delete').requestUndoOnBackspace();
                      });
                    }
                  });
              });
          }
          function dp(e, t, n) {
            return t
              .filter((e) => void 0 !== e[0] && void 0 !== e[1])
              .map((t) => n.createRange(e.getShiftedBy(t[0]), e.getShiftedBy(t[1])));
          }
          function up(e, t) {
            return (n, o) => {
              if (!e.commands.get(t).isEnabled) return !1;
              const i = e.model.schema.getValidRanges(o, t);
              for (const e of i) n.setAttribute(t, !0, e);
              n.removeSelectionAttribute(t);
            };
          }
          function* hp(e, t) {
            for (const n of t) n && e.getAttributeProperties(n[0]).copyOnEnter && (yield n);
          }
          class mp extends H {
            execute() {
              const e = this.editor.model,
                t = e.document;
              e.change((n) => {
                !(function (e, t, n, o) {
                  const i = n.isCollapsed,
                    r = n.getFirstRange(),
                    s = r.start.parent,
                    a = r.end.parent;
                  if (o.isLimit(s) || o.isLimit(a)) return void (i || s != a || e.deleteContent(n));
                  if (i) {
                    const e = hp(t.model.schema, n.getAttributes());
                    gp(t, r.start), t.setSelectionAttribute(e);
                  } else {
                    const o = !(r.start.isAtStart && r.end.isAtEnd),
                      i = s == a;
                    e.deleteContent(n, { leaveUnmerged: o }), o && (i ? gp(t, n.focus) : t.setSelection(a, 0));
                  }
                })(this.editor.model, n, t.selection, e.schema),
                  this.fire('afterExecute', { writer: n });
              });
            }
          }
          function gp(e, t) {
            e.split(t), e.setSelection(t.parent.nextSibling, 0);
          }
          class pp extends As {
            constructor(e) {
              super(e);
              const t = this.document;
              t.on('keydown', (e, n) => {
                if (this.isEnabled && n.keyCode == hr.enter) {
                  const o = new $i(t, 'enter', t.selection.getFirstRange());
                  t.fire(o, new Gs(t, n.domEvent, { isSoft: n.shiftKey })), o.stop.called && e.stop();
                }
              });
            }
            observe() {}
          }
          class fp extends V {
            static get pluginName() {
              return 'Enter';
            }
            init() {
              const e = this.editor,
                t = e.editing.view,
                n = t.document;
              t.addObserver(pp),
                e.commands.add('enter', new mp(e)),
                this.listenTo(
                  n,
                  'enter',
                  (n, o) => {
                    o.preventDefault(), o.isSoft || (e.execute('enter'), t.scrollToTheSelection());
                  },
                  { priority: 'low' }
                );
            }
          }
          class kp extends H {
            execute() {
              const e = this.editor.model,
                t = e.document;
              e.change((n) => {
                !(function (e, t, n) {
                  const o = n.isCollapsed,
                    i = n.getFirstRange(),
                    r = i.start.parent,
                    s = i.end.parent,
                    a = r == s;
                  if (o) {
                    const o = hp(e.schema, n.getAttributes());
                    bp(e, t, i.end), t.removeSelectionAttribute(n.getAttributeKeys()), t.setSelectionAttribute(o);
                  } else {
                    const o = !(i.start.isAtStart && i.end.isAtEnd);
                    e.deleteContent(n, { leaveUnmerged: o }), a ? bp(e, t, n.focus) : o && t.setSelection(s, 0);
                  }
                })(e, n, t.selection),
                  this.fire('afterExecute', { writer: n });
              });
            }
            refresh() {
              const e = this.editor.model,
                t = e.document;
              this.isEnabled = (function (e, t) {
                if (t.rangeCount > 1) return !1;
                const n = t.anchor;
                if (!n || !e.checkChild(n, 'softBreak')) return !1;
                const o = t.getFirstRange(),
                  i = o.start.parent,
                  r = o.end.parent;
                if ((wp(i, e) || wp(r, e)) && i !== r) return !1;
                return !0;
              })(e.schema, t.selection);
            }
          }
          function bp(e, t, n) {
            const o = t.createElement('softBreak');
            e.insertContent(o, n), t.setSelection(o, 'after');
          }
          function wp(e, t) {
            return !e.is('rootElement') && (t.isLimit(e) || wp(e.parent, t));
          }
          class _p extends V {
            static get pluginName() {
              return 'ShiftEnter';
            }
            init() {
              const e = this.editor,
                t = e.model.schema,
                n = e.conversion,
                o = e.editing.view,
                i = o.document;
              t.register('softBreak', { allowWhere: '$text', isInline: !0 }),
                n.for('upcast').elementToElement({ model: 'softBreak', view: 'br' }),
                n.for('downcast').elementToElement({ model: 'softBreak', view: (e, { writer: t }) => t.createEmptyElement('br') }),
                o.addObserver(pp),
                e.commands.add('shiftEnter', new kp(e)),
                this.listenTo(
                  i,
                  'enter',
                  (t, n) => {
                    n.preventDefault(), n.isSoft && (e.execute('shiftEnter'), o.scrollToTheSelection());
                  },
                  { priority: 'low' }
                );
            }
          }
          class yp extends H {
            refresh() {
              (this.value = this._getValue()), (this.isEnabled = this._checkEnabled());
            }
            execute(e = {}) {
              const t = this.editor.model,
                n = t.schema,
                o = t.document.selection,
                i = Array.from(o.getSelectedBlocks()),
                r = void 0 === e.forceValue ? !this.value : e.forceValue;
              t.change((e) => {
                if (r) {
                  const t = i.filter((e) => Ap(e) || vp(n, e));
                  this._applyQuote(e, t);
                } else this._removeQuote(e, i.filter(Ap));
              });
            }
            _getValue() {
              const e = Ca(this.editor.model.document.selection.getSelectedBlocks());
              return !(!e || !Ap(e));
            }
            _checkEnabled() {
              if (this.value) return !0;
              const e = this.editor.model.document.selection,
                t = this.editor.model.schema,
                n = Ca(e.getSelectedBlocks());
              return !!n && vp(t, n);
            }
            _removeQuote(e, t) {
              Cp(e, t)
                .reverse()
                .forEach((t) => {
                  if (t.start.isAtStart && t.end.isAtEnd) return void e.unwrap(t.start.parent);
                  if (t.start.isAtStart) {
                    const n = e.createPositionBefore(t.start.parent);
                    return void e.move(t, n);
                  }
                  t.end.isAtEnd || e.split(t.end);
                  const n = e.createPositionAfter(t.end.parent);
                  e.move(t, n);
                });
            }
            _applyQuote(e, t) {
              const n = [];
              Cp(e, t)
                .reverse()
                .forEach((t) => {
                  let o = Ap(t.start);
                  o || ((o = e.createElement('blockQuote')), e.wrap(t, o)), n.push(o);
                }),
                n.reverse().reduce((t, n) => (t.nextSibling == n ? (e.merge(e.createPositionAfter(t)), t) : n));
            }
          }
          function Ap(e) {
            return 'blockQuote' == e.parent.name ? e.parent : null;
          }
          function Cp(e, t) {
            let n,
              o = 0;
            const i = [];
            for (; o < t.length; ) {
              const r = t[o],
                s = t[o + 1];
              n || (n = e.createPositionBefore(r)),
                (s && r.nextSibling == s) || (i.push(e.createRange(n, e.createPositionAfter(r))), (n = null)),
                o++;
            }
            return i;
          }
          function vp(e, t) {
            const n = e.checkChild(t.parent, 'blockQuote'),
              o = e.checkChild(['$root', 'blockQuote'], t);
            return n && o;
          }
          class xp extends V {
            static get pluginName() {
              return 'BlockQuoteEditing';
            }
            static get requires() {
              return [fp, Fg];
            }
            init() {
              const e = this.editor,
                t = e.model.schema;
              e.commands.add('blockQuote', new yp(e)),
                t.register('blockQuote', { inheritAllFrom: '$container' }),
                e.conversion.elementToElement({ model: 'blockQuote', view: 'blockquote' }),
                e.model.document.registerPostFixer((n) => {
                  const o = e.model.document.differ.getChanges();
                  for (const e of o)
                    if ('insert' == e.type) {
                      const o = e.position.nodeAfter;
                      if (!o) continue;
                      if (o.is('element', 'blockQuote') && o.isEmpty) return n.remove(o), !0;
                      if (o.is('element', 'blockQuote') && !t.checkChild(e.position, o)) return n.unwrap(o), !0;
                      if (o.is('element')) {
                        const e = n.createRangeIn(o);
                        for (const o of e.getItems())
                          if (o.is('element', 'blockQuote') && !t.checkChild(n.createPositionBefore(o), o)) return n.unwrap(o), !0;
                      }
                    } else if ('remove' == e.type) {
                      const t = e.position.parent;
                      if (t.is('element', 'blockQuote') && t.isEmpty) return n.remove(t), !0;
                    }
                  return !1;
                });
              const n = this.editor.editing.view.document,
                o = e.model.document.selection,
                i = e.commands.get('blockQuote');
              this.listenTo(
                n,
                'enter',
                (t, n) => {
                  if (!o.isCollapsed || !i.value) return;
                  o.getLastPosition().parent.isEmpty &&
                    (e.execute('blockQuote'), e.editing.view.scrollToTheSelection(), n.preventDefault(), t.stop());
                },
                { context: 'blockquote' }
              ),
                this.listenTo(
                  n,
                  'delete',
                  (t, n) => {
                    if ('backward' != n.direction || !o.isCollapsed || !i.value) return;
                    const r = o.getLastPosition().parent;
                    r.isEmpty &&
                      !r.previousSibling &&
                      (e.execute('blockQuote'), e.editing.view.scrollToTheSelection(), n.preventDefault(), t.stop());
                  },
                  { context: 'blockquote' }
                );
            }
          }
          var Ep = n(636),
            Dp = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Ep.Z, Dp);
          Ep.Z.locals;
          class Tp extends V {
            static get pluginName() {
              return 'BlockQuoteUI';
            }
            init() {
              const e = this.editor,
                t = e.t;
              e.ui.componentFactory.add('blockQuote', (n) => {
                const o = e.commands.get('blockQuote'),
                  i = new zu(n);
                return (
                  i.set({ label: t('Block quote'), icon: Cu.quote, tooltip: !0, isToggleable: !0 }),
                  i.bind('isOn', 'isEnabled').to(o, 'value', 'isEnabled'),
                  this.listenTo(i, 'execute', () => {
                    e.execute('blockQuote'), e.editing.view.focus();
                  }),
                  i
                );
              });
            }
          }
          class Ip extends H {
            constructor(e, t) {
              super(e), (this.attributeKey = t);
            }
            refresh() {
              const e = this.editor.model,
                t = e.document;
              (this.value = this._getValueFromFirstAllowedNode()),
                (this.isEnabled = e.schema.checkAttributeInSelection(t.selection, this.attributeKey));
            }
            execute(e = {}) {
              const t = this.editor.model,
                n = t.document.selection,
                o = void 0 === e.forceValue ? !this.value : e.forceValue;
              t.change((e) => {
                if (n.isCollapsed) o ? e.setSelectionAttribute(this.attributeKey, !0) : e.removeSelectionAttribute(this.attributeKey);
                else {
                  const i = t.schema.getValidRanges(n.getRanges(), this.attributeKey);
                  for (const t of i) o ? e.setAttribute(this.attributeKey, o, t) : e.removeAttribute(this.attributeKey, t);
                }
              });
            }
            _getValueFromFirstAllowedNode() {
              const e = this.editor.model,
                t = e.schema,
                n = e.document.selection;
              if (n.isCollapsed) return n.hasAttribute(this.attributeKey);
              for (const e of n.getRanges())
                for (const n of e.getItems()) if (t.checkAttribute(n, this.attributeKey)) return n.hasAttribute(this.attributeKey);
              return !1;
            }
          }
          const Sp = 'bold';
          class Mp extends V {
            static get pluginName() {
              return 'BoldEditing';
            }
            init() {
              const e = this.editor;
              e.model.schema.extend('$text', { allowAttributes: Sp }),
                e.model.schema.setAttributeProperties(Sp, { isFormatting: !0, copyOnEnter: !0 }),
                e.conversion.attributeToElement({
                  model: Sp,
                  view: 'strong',
                  upcastAlso: [
                    'b',
                    (e) => {
                      const t = e.getStyle('font-weight');
                      return t ? ('bold' == t || Number(t) >= 600 ? { name: !0, styles: ['font-weight'] } : void 0) : null;
                    },
                  ],
                }),
                e.commands.add(Sp, new Ip(e, Sp)),
                e.keystrokes.set('CTRL+B', Sp);
            }
          }
          const Bp = 'bold';
          class Np extends V {
            static get pluginName() {
              return 'BoldUI';
            }
            init() {
              const e = this.editor,
                t = e.t;
              e.ui.componentFactory.add(Bp, (n) => {
                const o = e.commands.get(Bp),
                  i = new zu(n);
                return (
                  i.set({
                    label: t('Bold'),
                    icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>',
                    keystroke: 'CTRL+B',
                    tooltip: !0,
                    isToggleable: !0,
                  }),
                  i.bind('isOn', 'isEnabled').to(o, 'value', 'isEnabled'),
                  this.listenTo(i, 'execute', () => {
                    e.execute(Bp), e.editing.view.focus();
                  }),
                  i
                );
              });
            }
          }
          const Pp = { autoRefresh: !0 },
            zp = 36e5;
          class Lp {
            constructor(e, t = Pp) {
              if (!e) throw new l('token-missing-token-url', this);
              t.initValue && this._validateTokenValue(t.initValue),
                this.set('value', t.initValue),
                (this._refresh =
                  'function' == typeof e
                    ? e
                    : () => {
                        return (
                          (t = e),
                          new Promise((e, n) => {
                            const o = new XMLHttpRequest();
                            o.open('GET', t),
                              o.addEventListener('load', () => {
                                const t = o.status,
                                  i = o.response;
                                return t < 200 || t > 299 ? n(new l('token-cannot-download-new-token', null)) : e(i);
                              }),
                              o.addEventListener('error', () => n(new Error('Network Error'))),
                              o.addEventListener('abort', () => n(new Error('Abort'))),
                              o.send();
                          })
                        );
                        var t;
                      }),
                (this._options = Object.assign({}, Pp, t));
            }
            init() {
              return new Promise((e, t) => {
                this.value
                  ? (this._options.autoRefresh && this._registerRefreshTokenTimeout(), e(this))
                  : this.refreshToken().then(e).catch(t);
              });
            }
            refreshToken() {
              return this._refresh()
                .then((e) => {
                  this._validateTokenValue(e), this.set('value', e), this._options.autoRefresh && this._registerRefreshTokenTimeout();
                })
                .then(() => this);
            }
            destroy() {
              clearTimeout(this._tokenRefreshTimeout);
            }
            _validateTokenValue(e) {
              const t = 'string' == typeof e,
                n = !/^".*"$/.test(e),
                o = t && 3 === e.split('.').length;
              if (!n || !o) throw new l('token-not-in-jwt-format', this);
            }
            _registerRefreshTokenTimeout() {
              const e = this._getTokenRefreshTimeoutTime();
              clearTimeout(this._tokenRefreshTimeout),
                (this._tokenRefreshTimeout = setTimeout(() => {
                  this.refreshToken();
                }, e));
            }
            _getTokenRefreshTimeoutTime() {
              try {
                const [, e] = this.value.split('.'),
                  { exp: t } = JSON.parse(atob(e));
                if (!t) return zp;
                return Math.floor((1e3 * t - Date.now()) / 2);
              } catch (e) {
                return zp;
              }
            }
            static create(e, t = Pp) {
              return new Lp(e, t).init();
            }
          }
          R(Lp, B);
          const jp = Lp,
            Op = /^data:(\S*?);base64,/;
          class Rp {
            constructor(e, t, n) {
              if (!e) throw new l('fileuploader-missing-file', null);
              if (!t) throw new l('fileuploader-missing-token', null);
              if (!n) throw new l('fileuploader-missing-api-address', null);
              (this.file = (function (e) {
                if ('string' != typeof e) return !1;
                const t = e.match(Op);
                return !(!t || !t.length);
              })(e)
                ? (function (e, t = 512) {
                    try {
                      const n = e.match(Op)[1],
                        o = atob(e.replace(Op, '')),
                        i = [];
                      for (let e = 0; e < o.length; e += t) {
                        const n = o.slice(e, e + t),
                          r = new Array(n.length);
                        for (let e = 0; e < n.length; e++) r[e] = n.charCodeAt(e);
                        i.push(new Uint8Array(r));
                      }
                      return new Blob(i, { type: n });
                    } catch (e) {
                      throw new l('fileuploader-decoding-image-data-error', null);
                    }
                  })(e)
                : e),
                (this._token = t),
                (this._apiAddress = n);
            }
            onProgress(e) {
              return this.on('progress', (t, n) => e(n)), this;
            }
            onError(e) {
              return this.once('error', (t, n) => e(n)), this;
            }
            abort() {
              this.xhr.abort();
            }
            send() {
              return this._prepareRequest(), this._attachXHRListeners(), this._sendRequest();
            }
            _prepareRequest() {
              const e = new XMLHttpRequest();
              e.open('POST', this._apiAddress),
                e.setRequestHeader('Authorization', this._token.value),
                (e.responseType = 'json'),
                (this.xhr = e);
            }
            _attachXHRListeners() {
              const e = this,
                t = this.xhr;
              function n(t) {
                return () => e.fire('error', t);
              }
              t.addEventListener('error', n('Network Error')),
                t.addEventListener('abort', n('Abort')),
                t.upload &&
                  t.upload.addEventListener('progress', (e) => {
                    e.lengthComputable && this.fire('progress', { total: e.total, uploaded: e.loaded });
                  }),
                t.addEventListener('load', () => {
                  const e = t.status,
                    n = t.response;
                  if (e < 200 || e > 299) return this.fire('error', n.message || n.error);
                });
            }
            _sendRequest() {
              const e = new FormData(),
                t = this.xhr;
              return (
                e.append('file', this.file),
                new Promise((n, o) => {
                  t.addEventListener('load', () => {
                    const e = t.status,
                      i = t.response;
                    return e < 200 || e > 299
                      ? i.message
                        ? o(new l('fileuploader-uploading-data-failed', this, { message: i.message }))
                        : o(i.error)
                      : n(i);
                  }),
                    t.addEventListener('error', () => o(new Error('Network Error'))),
                    t.addEventListener('abort', () => o(new Error('Abort'))),
                    t.send(e);
                })
              );
            }
          }
          R(Rp, k);
          class Vp {
            constructor(e, t) {
              if (!e) throw new l('uploadgateway-missing-token', null);
              if (!t) throw new l('uploadgateway-missing-api-address', null);
              (this._token = e), (this._apiAddress = t);
            }
            upload(e) {
              return new Rp(e, this._token, this._apiAddress);
            }
          }
          class Fp extends Eo {
            static get pluginName() {
              return 'CloudServicesCore';
            }
            createToken(e, t) {
              return new jp(e, t);
            }
            createUploadGateway(e, t) {
              return new Vp(e, t);
            }
          }
          class Hp {
            constructor(e) {
              (this.files = (function (e) {
                const t = Array.from(e.files || []),
                  n = Array.from(e.items || []);
                if (t.length) return t;
                return n.filter((e) => 'file' === e.kind).map((e) => e.getAsFile());
              })(e)),
                (this._native = e);
            }
            get types() {
              return this._native.types;
            }
            getData(e) {
              return this._native.getData(e);
            }
            setData(e, t) {
              this._native.setData(e, t);
            }
            set effectAllowed(e) {
              this._native.effectAllowed = e;
            }
            get effectAllowed() {
              return this._native.effectAllowed;
            }
            set dropEffect(e) {
              this._native.dropEffect = e;
            }
            get dropEffect() {
              return this._native.dropEffect;
            }
            get isCanceled() {
              return 'none' == this._native.dropEffect || !!this._native.mozUserCancelled;
            }
          }
          class Up extends $s {
            constructor(e) {
              super(e);
              const n = this.document;
              function o(e) {
                return (o, i) => {
                  i.preventDefault();
                  const r = i.dropRange ? [i.dropRange] : null,
                    s = new t(n, e);
                  n.fire(s, { dataTransfer: i.dataTransfer, method: o.name, targetRanges: r, target: i.target }),
                    s.stop.called && i.stopPropagation();
                };
              }
              (this.domEventType = ['paste', 'copy', 'cut', 'drop', 'dragover', 'dragstart', 'dragend', 'dragenter', 'dragleave']),
                this.listenTo(n, 'paste', o('clipboardInput'), { priority: 'low' }),
                this.listenTo(n, 'drop', o('clipboardInput'), { priority: 'low' }),
                this.listenTo(n, 'dragover', o('dragging'), { priority: 'low' });
            }
            onDomEvent(e) {
              const t = { dataTransfer: new Hp(e.clipboardData ? e.clipboardData : e.dataTransfer) };
              ('drop' != e.type && 'dragover' != e.type) ||
                (t.dropRange = (function (e, t) {
                  const n = t.target.ownerDocument,
                    o = t.clientX,
                    i = t.clientY;
                  let r;
                  n.caretRangeFromPoint && n.caretRangeFromPoint(o, i)
                    ? (r = n.caretRangeFromPoint(o, i))
                    : t.rangeParent && ((r = n.createRange()), r.setStart(t.rangeParent, t.rangeOffset), r.collapse(!0));
                  if (r) return e.domConverter.domRangeToView(r);
                  return null;
                })(this.view, e)),
                this.fire(e.type, e, t);
            }
          }
          const qp = ['figcaption', 'li'];
          function Wp(e) {
            let t = '';
            if (e.is('$text') || e.is('$textProxy')) t = e.data;
            else if (e.is('element', 'img') && e.hasAttribute('alt')) t = e.getAttribute('alt');
            else if (e.is('element', 'br')) t = '\n';
            else {
              let n = null;
              for (const o of e.getChildren()) {
                const e = Wp(o);
                n &&
                  (n.is('containerElement') || o.is('containerElement')) &&
                  (qp.includes(n.name) || qp.includes(o.name) ? (t += '\n') : (t += '\n\n')),
                  (t += e),
                  (n = o);
              }
            }
            return t;
          }
          class Gp extends V {
            static get pluginName() {
              return 'ClipboardPipeline';
            }
            init() {
              this.editor.editing.view.addObserver(Up), this._setupPasteDrop(), this._setupCopyCut();
            }
            _setupPasteDrop() {
              const e = this.editor,
                n = e.model,
                o = e.editing.view,
                i = o.document;
              this.listenTo(
                i,
                'clipboardInput',
                (t) => {
                  e.isReadOnly && t.stop();
                },
                { priority: 'highest' }
              ),
                this.listenTo(
                  i,
                  'clipboardInput',
                  (e, n) => {
                    const i = n.dataTransfer;
                    let r = n.content || '';
                    var s;
                    r ||
                      (i.getData('text/html')
                        ? (r = (function (e) {
                            return e
                              .replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, (e, t) => (1 == t.length ? ' ' : t))
                              .replace(/<!--[\s\S]*?-->/g, '');
                          })(i.getData('text/html')))
                        : i.getData('text/plain') &&
                          (((s = (s = i.getData('text/plain'))
                            .replace(/</g, '&lt;')
                            .replace(/>/g, '&gt;')
                            .replace(/\r?\n\r?\n/g, '</p><p>')
                            .replace(/\r?\n/g, '<br>')
                            .replace(/^\s/, '&nbsp;')
                            .replace(/\s$/, '&nbsp;')
                            .replace(/\s\s/g, ' &nbsp;')).includes('</p><p>') ||
                            s.includes('<br>')) &&
                            (s = `<p>${s}</p>`),
                          (r = s)),
                      (r = this.editor.data.htmlProcessor.toView(r)));
                    const a = new t(this, 'inputTransformation');
                    this.fire(a, { content: r, dataTransfer: i, targetRanges: n.targetRanges, method: n.method }),
                      a.stop.called && e.stop(),
                      o.scrollToTheSelection();
                  },
                  { priority: 'low' }
                ),
                this.listenTo(
                  this,
                  'inputTransformation',
                  (e, t) => {
                    if (t.content.isEmpty) return;
                    const o = this.editor.data.toModel(t.content, '$clipboardHolder');
                    0 != o.childCount &&
                      (e.stop(),
                      n.change(() => {
                        this.fire('contentInsertion', {
                          content: o,
                          method: t.method,
                          dataTransfer: t.dataTransfer,
                          targetRanges: t.targetRanges,
                        });
                      }));
                  },
                  { priority: 'low' }
                ),
                this.listenTo(
                  this,
                  'contentInsertion',
                  (e, t) => {
                    t.resultRange = n.insertContent(t.content);
                  },
                  { priority: 'low' }
                );
            }
            _setupCopyCut() {
              const e = this.editor,
                t = e.model.document,
                n = e.editing.view.document;
              function o(o, i) {
                const r = i.dataTransfer;
                i.preventDefault();
                const s = e.data.toView(e.model.getSelectedContent(t.selection));
                n.fire('clipboardOutput', { dataTransfer: r, content: s, method: o.name });
              }
              this.listenTo(n, 'copy', o, { priority: 'low' }),
                this.listenTo(
                  n,
                  'cut',
                  (t, n) => {
                    e.isReadOnly ? n.preventDefault() : o(t, n);
                  },
                  { priority: 'low' }
                ),
                this.listenTo(
                  n,
                  'clipboardOutput',
                  (n, o) => {
                    o.content.isEmpty ||
                      (o.dataTransfer.setData('text/html', this.editor.data.htmlProcessor.toData(o.content)),
                      o.dataTransfer.setData('text/plain', Wp(o.content))),
                      'cut' == o.method && e.model.deleteContent(t.selection);
                  },
                  { priority: 'low' }
                );
            }
          }
          class $p {
            constructor() {
              this._stack = [];
            }
            add(e, t) {
              const n = this._stack,
                o = n[0];
              this._insertDescriptor(e);
              const i = n[0];
              o === i || Yp(o, i) || this.fire('change:top', { oldDescriptor: o, newDescriptor: i, writer: t });
            }
            remove(e, t) {
              const n = this._stack,
                o = n[0];
              this._removeDescriptor(e);
              const i = n[0];
              o === i || Yp(o, i) || this.fire('change:top', { oldDescriptor: o, newDescriptor: i, writer: t });
            }
            _insertDescriptor(e) {
              const t = this._stack,
                n = t.findIndex((t) => t.id === e.id);
              if (Yp(e, t[n])) return;
              n > -1 && t.splice(n, 1);
              let o = 0;
              for (; t[o] && Kp(t[o], e); ) o++;
              t.splice(o, 0, e);
            }
            _removeDescriptor(e) {
              const t = this._stack,
                n = t.findIndex((t) => t.id === e);
              n > -1 && t.splice(n, 1);
            }
          }
          function Yp(e, t) {
            return e && t && e.priority == t.priority && Qp(e.classes) == Qp(t.classes);
          }
          function Kp(e, t) {
            return e.priority > t.priority || (!(e.priority < t.priority) && Qp(e.classes) > Qp(t.classes));
          }
          function Qp(e) {
            return Array.isArray(e) ? e.sort().join(',') : e;
          }
          R($p, k);
          const Zp =
              '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>',
            Jp = 'ck-widget_selected';
          function Xp(e) {
            return !!e.is('element') && !!e.getCustomProperty('widget');
          }
          function ef(e, t, n = {}) {
            if (!e.is('containerElement')) throw new l('widget-to-widget-wrong-element-type', null, { element: e });
            return (
              t.setAttribute('contenteditable', 'false', e),
              t.addClass('ck-widget', e),
              t.setCustomProperty('widget', !0, e),
              (e.getFillerOffset = lf),
              n.label &&
                (function (e, t, n) {
                  n.setCustomProperty('widgetLabel', t, e);
                })(e, n.label, t),
              n.hasSelectionHandle &&
                (function (e, t) {
                  const n = t.createUIElement('div', { class: 'ck ck-widget__selection-handle' }, function (e) {
                    const t = this.toDomElement(e),
                      n = new Bu();
                    return n.set('content', Zp), n.render(), t.appendChild(n.element), t;
                  });
                  t.insert(t.createPositionAt(e, 0), n), t.addClass(['ck-widget_with-selection-handle'], e);
                })(e, t),
              of(e, t),
              e
            );
          }
          function tf(e, t, n) {
            if ((t.classes && n.addClass(bo(t.classes), e), t.attributes))
              for (const o in t.attributes) n.setAttribute(o, t.attributes[o], e);
          }
          function nf(e, t, n) {
            if ((t.classes && n.removeClass(bo(t.classes), e), t.attributes)) for (const o in t.attributes) n.removeAttribute(o, e);
          }
          function of(e, t, n = tf, o = nf) {
            const i = new $p();
            i.on('change:top', (t, i) => {
              i.oldDescriptor && o(e, i.oldDescriptor, i.writer), i.newDescriptor && n(e, i.newDescriptor, i.writer);
            }),
              t.setCustomProperty('addHighlight', (e, t, n) => i.add(t, n), e),
              t.setCustomProperty('removeHighlight', (e, t, n) => i.remove(t, n), e);
          }
          function rf(e) {
            const t = e.getCustomProperty('widgetLabel');
            return t ? ('function' == typeof t ? t() : t) : '';
          }
          function sf(e, t, n = {}) {
            return (
              t.addClass(['ck-editor__editable', 'ck-editor__nested-editable'], e),
              t.setAttribute('role', 'textbox', e),
              n.label && t.setAttribute('aria-label', n.label, e),
              t.setAttribute('contenteditable', e.isReadOnly ? 'false' : 'true', e),
              e.on('change:isReadOnly', (n, o, i) => {
                t.setAttribute('contenteditable', i ? 'false' : 'true', e);
              }),
              e.on('change:isFocused', (n, o, i) => {
                i ? t.addClass('ck-editor__nested-editable_focused', e) : t.removeClass('ck-editor__nested-editable_focused', e);
              }),
              of(e, t),
              e
            );
          }
          function af(e, t) {
            const n = e.getSelectedElement();
            if (n) {
              const o = uf(e);
              if (o) return t.createRange(t.createPositionAt(n, o));
            }
            return kd(e, t);
          }
          function lf() {
            return null;
          }
          const cf = 'widget-type-around';
          function df(e, t, n) {
            return e && Xp(e) && !n.isInline(t);
          }
          function uf(e) {
            return e.getAttribute(cf);
          }
          var hf = n(5137),
            mf = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(hf.Z, mf);
          hf.Z.locals;
          const gf = ['before', 'after'],
            pf = new DOMParser().parseFromString(
              '<svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg"><path d="M9.055.263v3.972h-6.77M1 4.216l2-2.038m-2 2 2 2.038"/></svg>',
              'image/svg+xml'
            ).firstChild,
            ff = 'ck-widget__type-around_disabled';
          class kf extends V {
            static get pluginName() {
              return 'WidgetTypeAround';
            }
            static get requires() {
              return [fp, Fg];
            }
            constructor(e) {
              super(e), (this._currentFakeCaretModelElement = null);
            }
            init() {
              const e = this.editor,
                t = e.editing.view;
              this.on('change:isEnabled', (n, o, i) => {
                t.change((e) => {
                  for (const n of t.document.roots) i ? e.removeClass(ff, n) : e.addClass(ff, n);
                }),
                  i ||
                    e.model.change((e) => {
                      e.removeSelectionAttribute(cf);
                    });
              }),
                this._enableTypeAroundUIInjection(),
                this._enableInsertingParagraphsOnButtonClick(),
                this._enableInsertingParagraphsOnEnterKeypress(),
                this._enableInsertingParagraphsOnTypingKeystroke(),
                this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows(),
                this._enableDeleteIntegration(),
                this._enableInsertContentIntegration(),
                this._enableInsertObjectIntegration(),
                this._enableDeleteContentIntegration();
            }
            destroy() {
              this._currentFakeCaretModelElement = null;
            }
            _insertParagraph(e, t) {
              const n = this.editor,
                o = n.editing.view,
                i = n.model.schema.getAttributesWithProperty(e, 'copyOnReplace', !0);
              n.execute('insertParagraph', { position: n.model.createPositionAt(e, t), attributes: i }),
                o.focus(),
                o.scrollToTheSelection();
            }
            _listenToIfEnabled(e, t, n, o) {
              this.listenTo(
                e,
                t,
                (...e) => {
                  this.isEnabled && n(...e);
                },
                o
              );
            }
            _insertParagraphAccordingToFakeCaretPosition() {
              const e = this.editor.model.document.selection,
                t = uf(e);
              if (!t) return !1;
              const n = e.getSelectedElement();
              return this._insertParagraph(n, t), !0;
            }
            _enableTypeAroundUIInjection() {
              const e = this.editor,
                t = e.model.schema,
                n = e.locale.t,
                o = { before: n('Insert paragraph before block'), after: n('Insert paragraph after block') };
              e.editing.downcastDispatcher.on(
                'insert',
                (e, n, i) => {
                  const r = i.mapper.toViewElement(n.item);
                  df(r, n.item, t) &&
                    (function (e, t, n) {
                      const o = e.createUIElement('div', { class: 'ck ck-reset_all ck-widget__type-around' }, function (e) {
                        const n = this.toDomElement(e);
                        return (
                          (function (e, t) {
                            for (const n of gf) {
                              const o = new Sd({
                                tag: 'div',
                                attributes: {
                                  class: ['ck', 'ck-widget__type-around__button', `ck-widget__type-around__button_${n}`],
                                  title: t[n],
                                },
                                children: [e.ownerDocument.importNode(pf, !0)],
                              });
                              e.appendChild(o.render());
                            }
                          })(n, t),
                          (function (e) {
                            const t = new Sd({ tag: 'div', attributes: { class: ['ck', 'ck-widget__type-around__fake-caret'] } });
                            e.appendChild(t.render());
                          })(n),
                          n
                        );
                      });
                      e.insert(e.createPositionAt(n, 'end'), o);
                    })(i.writer, o, r);
                },
                { priority: 'low' }
              );
            }
            _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
              const e = this.editor,
                t = e.model,
                n = t.document.selection,
                o = t.schema,
                i = e.editing.view;
              function r(e) {
                return `ck-widget_type-around_show-fake-caret_${e}`;
              }
              this._listenToIfEnabled(
                i.document,
                'arrowKey',
                (e, t) => {
                  this._handleArrowKeyPress(e, t);
                },
                { context: [Xp, '$text'], priority: 'high' }
              ),
                this._listenToIfEnabled(n, 'change:range', (t, n) => {
                  n.directChange &&
                    e.model.change((e) => {
                      e.removeSelectionAttribute(cf);
                    });
                }),
                this._listenToIfEnabled(t.document, 'change:data', () => {
                  const t = n.getSelectedElement();
                  if (t) {
                    if (df(e.editing.mapper.toViewElement(t), t, o)) return;
                  }
                  e.model.change((e) => {
                    e.removeSelectionAttribute(cf);
                  });
                }),
                this._listenToIfEnabled(e.editing.downcastDispatcher, 'selection', (e, t, n) => {
                  const i = n.writer;
                  if (this._currentFakeCaretModelElement) {
                    const e = n.mapper.toViewElement(this._currentFakeCaretModelElement);
                    e && (i.removeClass(gf.map(r), e), (this._currentFakeCaretModelElement = null));
                  }
                  const s = t.selection.getSelectedElement();
                  if (!s) return;
                  const a = n.mapper.toViewElement(s);
                  if (!df(a, s, o)) return;
                  const l = uf(t.selection);
                  l && (i.addClass(r(l), a), (this._currentFakeCaretModelElement = s));
                }),
                this._listenToIfEnabled(e.ui.focusTracker, 'change:isFocused', (t, n, o) => {
                  o ||
                    e.model.change((e) => {
                      e.removeSelectionAttribute(cf);
                    });
                });
            }
            _handleArrowKeyPress(e, t) {
              const n = this.editor,
                o = n.model,
                i = o.document.selection,
                r = o.schema,
                s = n.editing.view,
                a = (function (e, t) {
                  const n = kr(e, t);
                  return 'down' === n || 'right' === n;
                })(t.keyCode, n.locale.contentLanguageDirection),
                l = s.document.selection.getSelectedElement();
              let c;
              df(l, n.editing.mapper.toModelElement(l), r)
                ? (c = this._handleArrowKeyPressOnSelectedWidget(a))
                : i.isCollapsed
                ? (c = this._handleArrowKeyPressWhenSelectionNextToAWidget(a))
                : t.shiftKey || (c = this._handleArrowKeyPressWhenNonCollapsedSelection(a)),
                c && (t.preventDefault(), e.stop());
            }
            _handleArrowKeyPressOnSelectedWidget(e) {
              const t = this.editor.model,
                n = uf(t.document.selection);
              return t.change((t) => {
                if (!n) return t.setSelectionAttribute(cf, e ? 'after' : 'before'), !0;
                if (!(n === (e ? 'after' : 'before'))) return t.removeSelectionAttribute(cf), !0;
                return !1;
              });
            }
            _handleArrowKeyPressWhenSelectionNextToAWidget(e) {
              const t = this.editor,
                n = t.model,
                o = n.schema,
                i = t.plugins.get('Widget'),
                r = i._getObjectElementNextToSelection(e);
              return (
                !!df(t.editing.mapper.toViewElement(r), r, o) &&
                (n.change((t) => {
                  i._setSelectionOverElement(r), t.setSelectionAttribute(cf, e ? 'before' : 'after');
                }),
                !0)
              );
            }
            _handleArrowKeyPressWhenNonCollapsedSelection(e) {
              const t = this.editor,
                n = t.model,
                o = n.schema,
                i = t.editing.mapper,
                r = n.document.selection,
                s = e ? r.getLastPosition().nodeBefore : r.getFirstPosition().nodeAfter;
              return (
                !!df(i.toViewElement(s), s, o) &&
                (n.change((t) => {
                  t.setSelection(s, 'on'), t.setSelectionAttribute(cf, e ? 'after' : 'before');
                }),
                !0)
              );
            }
            _enableInsertingParagraphsOnButtonClick() {
              const e = this.editor,
                t = e.editing.view;
              this._listenToIfEnabled(t.document, 'mousedown', (n, o) => {
                const i = o.domTarget.closest('.ck-widget__type-around__button');
                if (!i) return;
                const r = (function (e) {
                    return e.classList.contains('ck-widget__type-around__button_before') ? 'before' : 'after';
                  })(i),
                  s = (function (e, t) {
                    const n = e.closest('.ck-widget');
                    return t.mapDomToView(n);
                  })(i, t.domConverter),
                  a = e.editing.mapper.toModelElement(s);
                this._insertParagraph(a, r), o.preventDefault(), n.stop();
              });
            }
            _enableInsertingParagraphsOnEnterKeypress() {
              const e = this.editor,
                t = e.model.document.selection,
                n = e.editing.view;
              this._listenToIfEnabled(
                n.document,
                'enter',
                (n, o) => {
                  if ('atTarget' != n.eventPhase) return;
                  const i = t.getSelectedElement(),
                    r = e.editing.mapper.toViewElement(i),
                    s = e.model.schema;
                  let a;
                  this._insertParagraphAccordingToFakeCaretPosition()
                    ? (a = !0)
                    : df(r, i, s) && (this._insertParagraph(i, o.isSoft ? 'before' : 'after'), (a = !0)),
                    a && (o.preventDefault(), n.stop());
                },
                { context: Xp }
              );
            }
            _enableInsertingParagraphsOnTypingKeystroke() {
              const e = this.editor.editing.view,
                t = [hr.enter, hr.delete, hr.backspace];
              this._listenToIfEnabled(
                e.document,
                'keydown',
                (e, n) => {
                  t.includes(n.keyCode) || Pg(n) || this._insertParagraphAccordingToFakeCaretPosition();
                },
                { priority: 'high' }
              );
            }
            _enableDeleteIntegration() {
              const e = this.editor,
                t = e.editing.view,
                n = e.model,
                o = n.schema;
              this._listenToIfEnabled(
                t.document,
                'delete',
                (t, i) => {
                  if ('atTarget' != t.eventPhase) return;
                  const r = uf(n.document.selection);
                  if (!r) return;
                  const s = i.direction,
                    a = n.document.selection.getSelectedElement(),
                    l = 'forward' == s;
                  if (('before' === r) === l) e.execute('delete', { selection: n.createSelection(a, 'on') });
                  else {
                    const t = o.getNearestSelectionRange(n.createPositionAt(a, r), s);
                    if (t)
                      if (t.isCollapsed) {
                        const i = n.createSelection(t.start);
                        if ((n.modifySelection(i, { direction: s }), i.focus.isEqual(t.start))) {
                          const e = (function (e, t) {
                            let n = t;
                            for (const o of t.getAncestors({ parentFirst: !0 })) {
                              if (o.childCount > 1 || e.isLimit(o)) break;
                              n = o;
                            }
                            return n;
                          })(o, t.start.parent);
                          n.deleteContent(n.createSelection(e, 'on'), { doNotAutoparagraph: !0 });
                        } else
                          n.change((n) => {
                            n.setSelection(t), e.execute(l ? 'deleteForward' : 'delete');
                          });
                      } else
                        n.change((n) => {
                          n.setSelection(t), e.execute(l ? 'deleteForward' : 'delete');
                        });
                  }
                  i.preventDefault(), t.stop();
                },
                { context: Xp }
              );
            }
            _enableInsertContentIntegration() {
              const e = this.editor,
                t = this.editor.model,
                n = t.document.selection;
              this._listenToIfEnabled(
                e.model,
                'insertContent',
                (e, [o, i]) => {
                  if (i && !i.is('documentSelection')) return;
                  const r = uf(n);
                  return r
                    ? (e.stop(),
                      t.change((e) => {
                        const i = n.getSelectedElement(),
                          s = t.createPositionAt(i, r),
                          a = e.createSelection(s),
                          l = t.insertContent(o, a);
                        return e.setSelection(a), l;
                      }))
                    : void 0;
                },
                { priority: 'high' }
              );
            }
            _enableInsertObjectIntegration() {
              const e = this.editor,
                t = this.editor.model.document.selection;
              this._listenToIfEnabled(
                e.model,
                'insertObject',
                (e, n) => {
                  const [, o, , i = {}] = n;
                  if (o && !o.is('documentSelection')) return;
                  const r = uf(t);
                  r && ((i.findOptimalPosition = r), (n[3] = i));
                },
                { priority: 'high' }
              );
            }
            _enableDeleteContentIntegration() {
              const e = this.editor,
                t = this.editor.model.document.selection;
              this._listenToIfEnabled(
                e.model,
                'deleteContent',
                (e, [n]) => {
                  if (n && !n.is('documentSelection')) return;
                  uf(t) && e.stop();
                },
                { priority: 'high' }
              );
            }
          }
          function bf(e) {
            const t = e.model;
            return (n, o) => {
              const i = o.keyCode == hr.arrowup,
                r = o.keyCode == hr.arrowdown,
                s = o.shiftKey,
                a = t.document.selection;
              if (!i && !r) return;
              const l = r;
              if (
                s &&
                (function (e, t) {
                  return !e.isCollapsed && e.isBackward == t;
                })(a, l)
              )
                return;
              const c = (function (e, t, n) {
                const o = e.model;
                if (n) {
                  const e = t.isCollapsed ? t.focus : t.getLastPosition(),
                    n = wf(o, e, 'forward');
                  if (!n) return null;
                  const i = o.createRange(e, n),
                    r = _f(o.schema, i, 'backward');
                  return r ? o.createRange(e, r) : null;
                }
                {
                  const e = t.isCollapsed ? t.focus : t.getFirstPosition(),
                    n = wf(o, e, 'backward');
                  if (!n) return null;
                  const i = o.createRange(n, e),
                    r = _f(o.schema, i, 'forward');
                  return r ? o.createRange(r, e) : null;
                }
              })(e, a, l);
              if (c) {
                if (c.isCollapsed) {
                  if (a.isCollapsed) return;
                  if (s) return;
                }
                (c.isCollapsed ||
                  (function (e, t, n) {
                    const o = e.model,
                      i = e.view.domConverter;
                    if (n) {
                      const e = o.createSelection(t.start);
                      o.modifySelection(e), e.focus.isAtEnd || t.start.isEqual(e.focus) || (t = o.createRange(e.focus, t.end));
                    }
                    const r = e.mapper.toViewRange(t),
                      s = i.viewRangeToDom(r),
                      a = ka.getDomRangeRects(s);
                    let l;
                    for (const e of a)
                      if (void 0 !== l) {
                        if (Math.round(e.top) >= l) return !1;
                        l = Math.max(l, Math.round(e.bottom));
                      } else l = Math.round(e.bottom);
                    return !0;
                  })(e, c, l)) &&
                  (t.change((e) => {
                    const n = l ? c.end : c.start;
                    if (s) {
                      const o = t.createSelection(a.anchor);
                      o.setFocus(n), e.setSelection(o);
                    } else e.setSelection(n);
                  }),
                  n.stop(),
                  o.preventDefault(),
                  o.stopPropagation());
              }
            };
          }
          function wf(e, t, n) {
            const o = e.schema,
              i = e.createRangeIn(t.root),
              r = 'forward' == n ? 'elementStart' : 'elementEnd';
            for (const { previousPosition: e, item: s, type: a } of i.getWalker({ startPosition: t, direction: n })) {
              if (o.isLimit(s) && !o.isInline(s)) return e;
              if (a == r && o.isBlock(s)) return null;
            }
            return null;
          }
          function _f(e, t, n) {
            const o = 'backward' == n ? t.end : t.start;
            if (e.checkChild(o, '$text')) return o;
            for (const { nextPosition: o } of t.getWalker({ direction: n })) if (e.checkChild(o, '$text')) return o;
            return null;
          }
          var yf = n(6507),
            Af = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(yf.Z, Af);
          yf.Z.locals;
          class Cf extends V {
            static get pluginName() {
              return 'Widget';
            }
            static get requires() {
              return [kf, Fg];
            }
            init() {
              const e = this.editor,
                t = e.editing.view,
                n = t.document;
              (this._previouslySelected = new Set()),
                this.editor.editing.downcastDispatcher.on('selection', (t, n, o) => {
                  const i = o.writer,
                    r = n.selection;
                  if (r.isCollapsed) return;
                  const s = r.getSelectedElement();
                  if (!s) return;
                  const a = e.editing.mapper.toViewElement(s);
                  Xp(a) && o.consumable.consume(r, 'selection') && i.setSelection(i.createRangeOn(a), { fake: !0, label: rf(a) });
                }),
                this.editor.editing.downcastDispatcher.on(
                  'selection',
                  (e, t, n) => {
                    this._clearPreviouslySelectedWidgets(n.writer);
                    const o = n.writer,
                      i = o.document.selection;
                    let r = null;
                    for (const e of i.getRanges())
                      for (const t of e) {
                        const e = t.item;
                        Xp(e) && !vf(e, r) && (o.addClass(Jp, e), this._previouslySelected.add(e), (r = e));
                      }
                  },
                  { priority: 'low' }
                ),
                t.addObserver(Tm),
                this.listenTo(n, 'mousedown', (...e) => this._onMousedown(...e)),
                this.listenTo(
                  n,
                  'arrowKey',
                  (...e) => {
                    this._handleSelectionChangeOnArrowKeyPress(...e);
                  },
                  { context: [Xp, '$text'] }
                ),
                this.listenTo(
                  n,
                  'arrowKey',
                  (...e) => {
                    this._preventDefaultOnArrowKeyPress(...e);
                  },
                  { context: '$root' }
                ),
                this.listenTo(n, 'arrowKey', bf(this.editor.editing), { context: '$text' }),
                this.listenTo(
                  n,
                  'delete',
                  (e, t) => {
                    this._handleDelete('forward' == t.direction) && (t.preventDefault(), e.stop());
                  },
                  { context: '$root' }
                );
            }
            _onMousedown(e, t) {
              const n = this.editor,
                o = n.editing.view,
                i = o.document;
              let r = t.target;
              if (
                (function (e) {
                  for (; e; ) {
                    if (e.is('editableElement') && !e.is('rootElement')) return !0;
                    if (Xp(e)) return !1;
                    e = e.parent;
                  }
                  return !1;
                })(r)
              ) {
                if ((lr.isSafari || lr.isGecko) && t.domEvent.detail >= 3) {
                  const e = n.editing.mapper,
                    o = r.is('attributeElement') ? r.findAncestor((e) => !e.is('attributeElement')) : r,
                    i = e.toModelElement(o);
                  t.preventDefault(),
                    this.editor.model.change((e) => {
                      e.setSelection(i, 'in');
                    });
                }
                return;
              }
              if (!Xp(r) && ((r = r.findAncestor(Xp)), !r)) return;
              lr.isAndroid && t.preventDefault(), i.isFocused || o.focus();
              const s = n.editing.mapper.toModelElement(r);
              this._setSelectionOverElement(s);
            }
            _handleSelectionChangeOnArrowKeyPress(e, t) {
              const n = t.keyCode,
                o = this.editor.model,
                i = o.schema,
                r = o.document.selection,
                s = r.getSelectedElement(),
                a = kr(n, this.editor.locale.contentLanguageDirection),
                l = 'down' == a || 'right' == a,
                c = 'up' == a || 'down' == a;
              if (s && i.isObject(s)) {
                const n = l ? r.getLastPosition() : r.getFirstPosition(),
                  s = i.getNearestSelectionRange(n, l ? 'forward' : 'backward');
                return void (
                  s &&
                  (o.change((e) => {
                    e.setSelection(s);
                  }),
                  t.preventDefault(),
                  e.stop())
                );
              }
              if (!r.isCollapsed && !t.shiftKey) {
                const n = r.getFirstPosition(),
                  s = r.getLastPosition(),
                  a = n.nodeAfter,
                  c = s.nodeBefore;
                return void (
                  ((a && i.isObject(a)) || (c && i.isObject(c))) &&
                  (o.change((e) => {
                    e.setSelection(l ? s : n);
                  }),
                  t.preventDefault(),
                  e.stop())
                );
              }
              if (!r.isCollapsed) return;
              const d = this._getObjectElementNextToSelection(l);
              if (d && i.isObject(d)) {
                if (i.isInline(d) && c) return;
                this._setSelectionOverElement(d), t.preventDefault(), e.stop();
              }
            }
            _preventDefaultOnArrowKeyPress(e, t) {
              const n = this.editor.model,
                o = n.schema,
                i = n.document.selection.getSelectedElement();
              i && o.isObject(i) && (t.preventDefault(), e.stop());
            }
            _handleDelete(e) {
              if (this.editor.isReadOnly) return;
              const t = this.editor.model.document.selection;
              if (!t.isCollapsed) return;
              const n = this._getObjectElementNextToSelection(e);
              return n
                ? (this.editor.model.change((e) => {
                    let o = t.anchor.parent;
                    for (; o.isEmpty; ) {
                      const t = o;
                      (o = t.parent), e.remove(t);
                    }
                    this._setSelectionOverElement(n);
                  }),
                  !0)
                : void 0;
            }
            _setSelectionOverElement(e) {
              this.editor.model.change((t) => {
                t.setSelection(t.createRangeOn(e));
              });
            }
            _getObjectElementNextToSelection(e) {
              const t = this.editor.model,
                n = t.schema,
                o = t.document.selection,
                i = t.createSelection(o);
              if ((t.modifySelection(i, { direction: e ? 'forward' : 'backward' }), i.isEqual(o))) return null;
              const r = e ? i.focus.nodeBefore : i.focus.nodeAfter;
              return r && n.isObject(r) ? r : null;
            }
            _clearPreviouslySelectedWidgets(e) {
              for (const t of this._previouslySelected) e.removeClass(Jp, t);
              this._previouslySelected.clear();
            }
          }
          function vf(e, t) {
            return !!t && Array.from(e.getAncestors()).includes(t);
          }
          const xf = function (e, t, n) {
            var o = !0,
              i = !0;
            if ('function' != typeof e) throw new TypeError('Expected a function');
            return (
              E(n) && ((o = 'leading' in n ? !!n.leading : o), (i = 'trailing' in n ? !!n.trailing : i)),
              aa(e, t, { leading: o, maxWait: t, trailing: i })
            );
          };
          var Ef = n(390),
            Df = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Ef.Z, Df);
          Ef.Z.locals;
          class Tf extends V {
            static get pluginName() {
              return 'DragDrop';
            }
            static get requires() {
              return [Gp, Cf];
            }
            init() {
              const e = this.editor,
                t = e.editing.view;
              (this._draggedRange = null),
                (this._draggingUid = ''),
                (this._draggableElement = null),
                (this._updateDropMarkerThrottled = xf((e) => this._updateDropMarker(e), 40)),
                (this._removeDropMarkerDelayed = Mf(() => this._removeDropMarker(), 40)),
                (this._clearDraggableAttributesDelayed = Mf(() => this._clearDraggableAttributes(), 40)),
                t.addObserver(Up),
                t.addObserver(Tm),
                this._setupDragging(),
                this._setupContentInsertionIntegration(),
                this._setupClipboardInputIntegration(),
                this._setupDropMarker(),
                this._setupDraggableAttributeHandling(),
                this.listenTo(e, 'change:isReadOnly', (e, t, n) => {
                  n ? this.forceDisabled('readOnlyMode') : this.clearForceDisabled('readOnlyMode');
                }),
                this.on('change:isEnabled', (e, t, n) => {
                  n || this._finalizeDragging(!1);
                }),
                lr.isAndroid && this.forceDisabled('noAndroidSupport');
            }
            destroy() {
              return (
                this._draggedRange && (this._draggedRange.detach(), (this._draggedRange = null)),
                this._updateDropMarkerThrottled.cancel(),
                this._removeDropMarkerDelayed.cancel(),
                this._clearDraggableAttributesDelayed.cancel(),
                super.destroy()
              );
            }
            _setupDragging() {
              const e = this.editor,
                t = e.model,
                n = t.document,
                o = e.editing.view,
                i = o.document;
              this.listenTo(
                i,
                'dragstart',
                (o, s) => {
                  const a = n.selection;
                  if (s.target && s.target.is('editableElement')) return void s.preventDefault();
                  const l = s.target ? Bf(s.target) : null;
                  if (l) {
                    const n = e.editing.mapper.toModelElement(l);
                    (this._draggedRange = ll.fromRange(t.createRangeOn(n))),
                      e.plugins.has('WidgetToolbarRepository') && e.plugins.get('WidgetToolbarRepository').forceDisabled('dragDrop');
                  } else if (!i.selection.isCollapsed) {
                    const e = i.selection.getSelectedElement();
                    (e && Xp(e)) || (this._draggedRange = ll.fromRange(a.getFirstRange()));
                  }
                  if (!this._draggedRange) return void s.preventDefault();
                  (this._draggingUid = r()),
                    (s.dataTransfer.effectAllowed = this.isEnabled ? 'copyMove' : 'copy'),
                    s.dataTransfer.setData('application/ckeditor5-dragging-uid', this._draggingUid);
                  const c = t.createSelection(this._draggedRange.toRange()),
                    d = e.data.toView(t.getSelectedContent(c));
                  i.fire('clipboardOutput', { dataTransfer: s.dataTransfer, content: d, method: o.name }),
                    this.isEnabled || (this._draggedRange.detach(), (this._draggedRange = null), (this._draggingUid = ''));
                },
                { priority: 'low' }
              ),
                this.listenTo(
                  i,
                  'dragend',
                  (e, t) => {
                    this._finalizeDragging(!t.dataTransfer.isCanceled && 'move' == t.dataTransfer.dropEffect);
                  },
                  { priority: 'low' }
                ),
                this.listenTo(i, 'dragenter', () => {
                  this.isEnabled && o.focus();
                }),
                this.listenTo(i, 'dragleave', () => {
                  this._removeDropMarkerDelayed();
                }),
                this.listenTo(
                  i,
                  'dragging',
                  (t, n) => {
                    if (!this.isEnabled) return void (n.dataTransfer.dropEffect = 'none');
                    this._removeDropMarkerDelayed.cancel();
                    const o = If(e, n.targetRanges, n.target);
                    this._draggedRange || (n.dataTransfer.dropEffect = 'copy'),
                      lr.isGecko ||
                        ('copy' == n.dataTransfer.effectAllowed
                          ? (n.dataTransfer.dropEffect = 'copy')
                          : ['all', 'copyMove'].includes(n.dataTransfer.effectAllowed) && (n.dataTransfer.dropEffect = 'move')),
                      o && this._updateDropMarkerThrottled(o);
                  },
                  { priority: 'low' }
                );
            }
            _setupClipboardInputIntegration() {
              const e = this.editor,
                t = e.editing.view.document;
              this.listenTo(
                t,
                'clipboardInput',
                (t, n) => {
                  if ('drop' != n.method) return;
                  const o = If(e, n.targetRanges, n.target);
                  if ((this._removeDropMarker(), !o)) return this._finalizeDragging(!1), void t.stop();
                  this._draggedRange &&
                    this._draggingUid != n.dataTransfer.getData('application/ckeditor5-dragging-uid') &&
                    (this._draggedRange.detach(), (this._draggedRange = null), (this._draggingUid = ''));
                  if ('move' == Sf(n.dataTransfer) && this._draggedRange && this._draggedRange.containsRange(o, !0))
                    return this._finalizeDragging(!1), void t.stop();
                  n.targetRanges = [e.editing.mapper.toViewRange(o)];
                },
                { priority: 'high' }
              );
            }
            _setupContentInsertionIntegration() {
              const e = this.editor.plugins.get(Gp);
              e.on(
                'contentInsertion',
                (e, t) => {
                  if (!this.isEnabled || 'drop' !== t.method) return;
                  const n = t.targetRanges.map((e) => this.editor.editing.mapper.toModelRange(e));
                  this.editor.model.change((e) => e.setSelection(n));
                },
                { priority: 'high' }
              ),
                e.on(
                  'contentInsertion',
                  (e, t) => {
                    if (!this.isEnabled || 'drop' !== t.method) return;
                    const n = 'move' == Sf(t.dataTransfer),
                      o = !t.resultRange || !t.resultRange.isCollapsed;
                    this._finalizeDragging(o && n);
                  },
                  { priority: 'lowest' }
                );
            }
            _setupDraggableAttributeHandling() {
              const e = this.editor,
                t = e.editing.view,
                n = t.document;
              this.listenTo(n, 'mousedown', (o, i) => {
                if (lr.isAndroid || !i) return;
                this._clearDraggableAttributesDelayed.cancel();
                let r = Bf(i.target);
                if (lr.isBlink && !e.isReadOnly && !r && !n.selection.isCollapsed) {
                  const e = n.selection.getSelectedElement();
                  (e && Xp(e)) || (r = n.selection.editableElement);
                }
                r &&
                  (t.change((e) => {
                    e.setAttribute('draggable', 'true', r);
                  }),
                  (this._draggableElement = e.editing.mapper.toModelElement(r)));
              }),
                this.listenTo(n, 'mouseup', () => {
                  lr.isAndroid || this._clearDraggableAttributesDelayed();
                });
            }
            _clearDraggableAttributes() {
              const e = this.editor.editing;
              e.view.change((t) => {
                this._draggableElement &&
                  '$graveyard' != this._draggableElement.root.rootName &&
                  t.removeAttribute('draggable', e.mapper.toViewElement(this._draggableElement)),
                  (this._draggableElement = null);
              });
            }
            _setupDropMarker() {
              const e = this.editor;
              e.conversion
                .for('editingDowncast')
                .markerToHighlight({ model: 'drop-target', view: { classes: ['ck-clipboard-drop-target-range'] } }),
                e.conversion.for('editingDowncast').markerToElement({
                  model: 'drop-target',
                  view: (t, { writer: n }) => {
                    if (e.model.schema.checkChild(t.markerRange.start, '$text'))
                      return n.createUIElement('span', { class: 'ck ck-clipboard-drop-target-position' }, function (e) {
                        const t = this.toDomElement(e);
                        return t.append('⁠', e.createElement('span'), '⁠'), t;
                      });
                  },
                });
            }
            _updateDropMarker(e) {
              const t = this.editor,
                n = t.model.markers;
              t.model.change((t) => {
                n.has('drop-target')
                  ? n.get('drop-target').getRange().isEqual(e) || t.updateMarker('drop-target', { range: e })
                  : t.addMarker('drop-target', { range: e, usingOperation: !1, affectsData: !1 });
              });
            }
            _removeDropMarker() {
              const e = this.editor.model;
              this._removeDropMarkerDelayed.cancel(),
                this._updateDropMarkerThrottled.cancel(),
                e.markers.has('drop-target') &&
                  e.change((e) => {
                    e.removeMarker('drop-target');
                  });
            }
            _finalizeDragging(e) {
              const t = this.editor,
                n = t.model;
              this._removeDropMarker(),
                this._clearDraggableAttributes(),
                t.plugins.has('WidgetToolbarRepository') && t.plugins.get('WidgetToolbarRepository').clearForceDisabled('dragDrop'),
                (this._draggingUid = ''),
                this._draggedRange &&
                  (e && this.isEnabled && n.deleteContent(n.createSelection(this._draggedRange), { doNotAutoparagraph: !0 }),
                  this._draggedRange.detach(),
                  (this._draggedRange = null));
            }
          }
          function If(e, t, n) {
            const o = e.model,
              i = e.editing.mapper;
            let r = null;
            const s = t ? t[0].start : null;
            if (
              (n.is('uiElement') && (n = n.parent),
              (r = (function (e, t) {
                const n = e.model,
                  o = e.editing.mapper;
                if (Xp(t)) return n.createRangeOn(o.toModelElement(t));
                if (!t.is('editableElement')) {
                  const e = t.findAncestor((e) => Xp(e) || e.is('editableElement'));
                  if (Xp(e)) return n.createRangeOn(o.toModelElement(e));
                }
                return null;
              })(e, n)),
              r)
            )
              return r;
            const a = (function (e, t) {
                const n = e.editing.mapper,
                  o = e.editing.view,
                  i = n.toModelElement(t);
                if (i) return i;
                const r = o.createPositionBefore(t),
                  s = n.findMappedViewAncestor(r);
                return n.toModelElement(s);
              })(e, n),
              l = s ? i.toModelPosition(s) : null;
            return l
              ? ((r = (function (e, t, n) {
                  const o = e.model;
                  if (!o.schema.checkChild(n, '$block')) return null;
                  const i = o.createPositionAt(n, 0),
                    r = t.path.slice(0, i.path.length),
                    s = o.createPositionFromPath(t.root, r).nodeAfter;
                  if (s && o.schema.isObject(s)) return o.createRangeOn(s);
                  return null;
                })(e, l, a)),
                r ||
                  ((r = o.schema.getNearestSelectionRange(l, lr.isGecko ? 'forward' : 'backward')),
                  r ||
                    (function (e, t) {
                      const n = e.model;
                      for (; t; ) {
                        if (n.schema.isObject(t)) return n.createRangeOn(t);
                        t = t.parent;
                      }
                    })(e, l.parent)))
              : (function (e, t) {
                  const n = e.model,
                    o = n.schema,
                    i = n.createPositionAt(t, 0);
                  return o.getNearestSelectionRange(i, 'forward');
                })(e, a);
          }
          function Sf(e) {
            return lr.isGecko ? e.dropEffect : ['all', 'copyMove'].includes(e.effectAllowed) ? 'move' : 'copy';
          }
          function Mf(e, t) {
            let n;
            function o(...i) {
              o.cancel(), (n = setTimeout(() => e(...i), t));
            }
            return (
              (o.cancel = () => {
                clearTimeout(n);
              }),
              o
            );
          }
          function Bf(e) {
            if (e.is('editableElement')) return null;
            if (e.hasClass('ck-widget__selection-handle')) return e.findAncestor(Xp);
            if (Xp(e)) return e;
            const t = e.findAncestor((e) => Xp(e) || e.is('editableElement'));
            return Xp(t) ? t : null;
          }
          class Nf extends V {
            static get pluginName() {
              return 'PastePlainText';
            }
            static get requires() {
              return [Gp];
            }
            init() {
              const e = this.editor,
                t = e.model,
                n = e.editing.view,
                o = n.document,
                i = t.document.selection;
              let r = !1;
              n.addObserver(Up),
                this.listenTo(o, 'keydown', (e, t) => {
                  r = t.shiftKey;
                }),
                e.plugins.get(Gp).on('contentInsertion', (e, n) => {
                  (r ||
                    (function (e, t) {
                      if (e.childCount > 1) return !1;
                      const n = e.getChild(0);
                      if (t.isObject(n)) return !1;
                      return 0 == [...n.getAttributeKeys()].length;
                    })(n.content, t.schema)) &&
                    t.change((e) => {
                      const o = Array.from(i.getAttributes()).filter(([e]) => t.schema.getAttributeProperties(e).isFormatting);
                      i.isCollapsed || t.deleteContent(i, { doNotAutoparagraph: !0 }), o.push(...i.getAttributes());
                      const r = e.createRangeIn(n.content);
                      for (const t of r.getItems()) t.is('$textProxy') && e.setAttributes(o, t);
                    });
                });
            }
          }
          class Pf extends V {
            static get pluginName() {
              return 'Clipboard';
            }
            static get requires() {
              return [Gp, Tf, Nf];
            }
          }
          class zf extends H {
            constructor(e) {
              super(e), (this.affectsData = !1);
            }
            execute() {
              const e = this.editor.model,
                t = e.document.selection;
              let n = e.schema.getLimitElement(t);
              if (t.containsEntireContent(n) || !Lf(e.schema, n))
                do {
                  if (((n = n.parent), !n)) return;
                } while (!Lf(e.schema, n));
              e.change((e) => {
                e.setSelection(n, 'in');
              });
            }
          }
          function Lf(e, t) {
            return e.isLimit(t) && (e.checkChild(t, '$text') || e.checkChild(t, 'paragraph'));
          }
          const jf = pr('Ctrl+A');
          class Of extends V {
            static get pluginName() {
              return 'SelectAllEditing';
            }
            init() {
              const e = this.editor,
                t = e.editing.view.document;
              e.commands.add('selectAll', new zf(e)),
                this.listenTo(t, 'keydown', (t, n) => {
                  gr(n) === jf && (e.execute('selectAll'), n.preventDefault());
                });
            }
          }
          class Rf extends V {
            static get pluginName() {
              return 'SelectAllUI';
            }
            init() {
              const e = this.editor;
              e.ui.componentFactory.add('selectAll', (t) => {
                const n = e.commands.get('selectAll'),
                  o = new zu(t),
                  i = t.t;
                return (
                  o.set({
                    label: i('Select all'),
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75zm18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75zm-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0h2.25zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5h2.25zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6z"/></svg>',
                    keystroke: 'Ctrl+A',
                    tooltip: !0,
                  }),
                  o.bind('isOn', 'isEnabled').to(n, 'value', 'isEnabled'),
                  this.listenTo(o, 'execute', () => {
                    e.execute('selectAll'), e.editing.view.focus();
                  }),
                  o
                );
              });
            }
          }
          class Vf extends V {
            static get requires() {
              return [Of, Rf];
            }
            static get pluginName() {
              return 'SelectAll';
            }
          }
          class Ff extends H {
            constructor(e) {
              super(e),
                (this._stack = []),
                (this._createdBatches = new WeakSet()),
                this.refresh(),
                this.listenTo(
                  e.data,
                  'set',
                  (e, t) => {
                    t[1] = { ...t[1] };
                    const n = t[1];
                    n.batchType || (n.batchType = { isUndoable: !1 });
                  },
                  { priority: 'high' }
                ),
                this.listenTo(e.data, 'set', (e, t) => {
                  t[1].batchType.isUndoable || this.clearStack();
                });
            }
            refresh() {
              this.isEnabled = this._stack.length > 0;
            }
            addBatch(e) {
              const t = this.editor.model.document.selection,
                n = { ranges: t.hasOwnRange ? Array.from(t.getRanges()) : [], isBackward: t.isBackward };
              this._stack.push({ batch: e, selection: n }), this.refresh();
            }
            clearStack() {
              (this._stack = []), this.refresh();
            }
            _restoreSelection(e, t, n) {
              const o = this.editor.model,
                i = o.document,
                r = [],
                s = e.map((e) => e.getTransformedByOperations(n)),
                a = s.flat();
              for (const e of s) {
                const t = e.filter((e) => e.root != i.graveyard).filter((e) => !Uf(e, a));
                t.length && (Hf(t), r.push(t[0]));
              }
              r.length &&
                o.change((e) => {
                  e.setSelection(r, { backward: t });
                });
            }
            _undo(e, t) {
              const n = this.editor.model,
                o = n.document;
              this._createdBatches.add(t);
              const i = e.operations.slice().filter((e) => e.isDocumentOperation);
              i.reverse();
              for (const e of i) {
                const i = e.baseVersion + 1,
                  r = Array.from(o.history.getOperations(i)),
                  s = _m([e.getReversed()], r, {
                    useRelations: !0,
                    document: this.editor.model.document,
                    padWithNoOps: !1,
                    forceWeakRemove: !0,
                  }).operationsA;
                for (const i of s) t.addOperation(i), n.applyOperation(i), o.history.setOperationAsUndone(e, i);
              }
            }
          }
          function Hf(e) {
            e.sort((e, t) => (e.start.isBefore(t.start) ? -1 : 1));
            for (let t = 1; t < e.length; t++) {
              const n = e[t - 1].getJoined(e[t], !0);
              n && (t--, e.splice(t, 2, n));
            }
          }
          function Uf(e, t) {
            return t.some((t) => t !== e && t.containsRange(e, !0));
          }
          class qf extends Ff {
            execute(e = null) {
              const t = e ? this._stack.findIndex((t) => t.batch == e) : this._stack.length - 1,
                n = this._stack.splice(t, 1)[0],
                o = this.editor.model.createBatch({ isUndo: !0 });
              this.editor.model.enqueueChange(o, () => {
                this._undo(n.batch, o);
                const e = this.editor.model.document.history.getOperations(n.batch.baseVersion);
                this._restoreSelection(n.selection.ranges, n.selection.isBackward, e), this.fire('revert', n.batch, o);
              }),
                this.refresh();
            }
          }
          class Wf extends Ff {
            execute() {
              const e = this._stack.pop(),
                t = this.editor.model.createBatch({ isUndo: !0 });
              this.editor.model.enqueueChange(t, () => {
                const n = e.batch.operations[e.batch.operations.length - 1].baseVersion + 1,
                  o = this.editor.model.document.history.getOperations(n);
                this._restoreSelection(e.selection.ranges, e.selection.isBackward, o), this._undo(e.batch, t);
              }),
                this.refresh();
            }
          }
          class Gf extends V {
            static get pluginName() {
              return 'UndoEditing';
            }
            constructor(e) {
              super(e), (this._batchRegistry = new WeakSet());
            }
            init() {
              const e = this.editor;
              (this._undoCommand = new qf(e)),
                (this._redoCommand = new Wf(e)),
                e.commands.add('undo', this._undoCommand),
                e.commands.add('redo', this._redoCommand),
                this.listenTo(
                  e.model,
                  'applyOperation',
                  (e, t) => {
                    const n = t[0];
                    if (!n.isDocumentOperation) return;
                    const o = n.batch,
                      i = this._redoCommand._createdBatches.has(o),
                      r = this._undoCommand._createdBatches.has(o);
                    this._batchRegistry.has(o) ||
                      (this._batchRegistry.add(o),
                      o.isUndoable &&
                        (i ? this._undoCommand.addBatch(o) : r || (this._undoCommand.addBatch(o), this._redoCommand.clearStack())));
                  },
                  { priority: 'highest' }
                ),
                this.listenTo(this._undoCommand, 'revert', (e, t, n) => {
                  this._redoCommand.addBatch(n);
                }),
                e.keystrokes.set('CTRL+Z', 'undo'),
                e.keystrokes.set('CTRL+Y', 'redo'),
                e.keystrokes.set('CTRL+SHIFT+Z', 'redo');
            }
          }
          const $f =
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m5.042 9.367 2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>',
            Yf =
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m14.958 9.367-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>';
          class Kf extends V {
            static get pluginName() {
              return 'UndoUI';
            }
            init() {
              const e = this.editor,
                t = e.locale,
                n = e.t,
                o = 'ltr' == t.uiLanguageDirection ? $f : Yf,
                i = 'ltr' == t.uiLanguageDirection ? Yf : $f;
              this._addButton('undo', n('Undo'), 'CTRL+Z', o), this._addButton('redo', n('Redo'), 'CTRL+Y', i);
            }
            _addButton(e, t, n, o) {
              const i = this.editor;
              i.ui.componentFactory.add(e, (r) => {
                const s = i.commands.get(e),
                  a = new zu(r);
                return (
                  a.set({ label: t, icon: o, keystroke: n, tooltip: !0 }),
                  a.bind('isEnabled').to(s, 'isEnabled'),
                  this.listenTo(a, 'execute', () => {
                    i.execute(e), i.editing.view.focus();
                  }),
                  a
                );
              });
            }
          }
          class Qf extends V {
            static get requires() {
              return [Gf, Kf];
            }
            static get pluginName() {
              return 'Undo';
            }
          }
          class Zf extends H {
            refresh() {
              const e = this.editor.model,
                t = Ca(e.document.selection.getSelectedBlocks());
              (this.value = !!t && t.is('element', 'paragraph')), (this.isEnabled = !!t && Jf(t, e.schema));
            }
            execute(e = {}) {
              const t = this.editor.model,
                n = t.document;
              t.change((o) => {
                const i = (e.selection || n.selection).getSelectedBlocks();
                for (const e of i) !e.is('element', 'paragraph') && Jf(e, t.schema) && o.rename(e, 'paragraph');
              });
            }
          }
          function Jf(e, t) {
            return t.checkChild(e.parent, 'paragraph') && !t.isObject(e);
          }
          class Xf extends H {
            execute(e) {
              const t = this.editor.model,
                n = e.attributes;
              let o = e.position;
              t.change((e) => {
                const i = e.createElement('paragraph');
                if ((n && t.schema.setAllowedAttributes(i, n, e), !t.schema.checkChild(o.parent, i))) {
                  const n = t.schema.findAllowedParent(o, i);
                  if (!n) return;
                  o = e.split(o, n).position;
                }
                t.insertContent(i, o), e.setSelection(i, 'in');
              });
            }
          }
          class ek extends V {
            static get pluginName() {
              return 'Paragraph';
            }
            init() {
              const e = this.editor,
                t = e.model;
              e.commands.add('paragraph', new Zf(e)),
                e.commands.add('insertParagraph', new Xf(e)),
                t.schema.register('paragraph', { inheritAllFrom: '$block' }),
                e.conversion.elementToElement({ model: 'paragraph', view: 'p' }),
                e.conversion.for('upcast').elementToElement({
                  model: (e, { writer: t }) =>
                    ek.paragraphLikeElements.has(e.name) ? (e.isEmpty ? null : t.createElement('paragraph')) : null,
                  view: /.+/,
                  converterPriority: 'low',
                });
            }
          }
          ek.paragraphLikeElements = new Set(['blockquote', 'dd', 'div', 'dt', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li', 'p', 'td', 'th']);
          class tk extends H {
            constructor(e, t) {
              super(e), (this.modelElements = t);
            }
            refresh() {
              const e = Ca(this.editor.model.document.selection.getSelectedBlocks());
              (this.value = !!e && this.modelElements.includes(e.name) && e.name),
                (this.isEnabled = !!e && this.modelElements.some((t) => nk(e, t, this.editor.model.schema)));
            }
            execute(e) {
              const t = this.editor.model,
                n = t.document,
                o = e.value;
              t.change((e) => {
                const i = Array.from(n.selection.getSelectedBlocks()).filter((e) => nk(e, o, t.schema));
                for (const t of i) t.is('element', o) || e.rename(t, o);
              });
            }
          }
          function nk(e, t, n) {
            return n.checkChild(e.parent, t) && !n.isObject(e);
          }
          const ok = 'paragraph';
          class ik extends V {
            static get pluginName() {
              return 'HeadingEditing';
            }
            constructor(e) {
              super(e),
                e.config.define('heading', {
                  options: [
                    { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                    { model: 'heading1', view: 'h2', title: 'Heading 1', class: 'ck-heading_heading1' },
                    { model: 'heading2', view: 'h3', title: 'Heading 2', class: 'ck-heading_heading2' },
                    { model: 'heading3', view: 'h4', title: 'Heading 3', class: 'ck-heading_heading3' },
                  ],
                });
            }
            static get requires() {
              return [ek];
            }
            init() {
              const e = this.editor,
                t = e.config.get('heading.options'),
                n = [];
              for (const o of t)
                o.model !== ok &&
                  (e.model.schema.register(o.model, { inheritAllFrom: '$block' }), e.conversion.elementToElement(o), n.push(o.model));
              this._addDefaultH1Conversion(e), e.commands.add('heading', new tk(e, n));
            }
            afterInit() {
              const e = this.editor,
                t = e.commands.get('enter'),
                n = e.config.get('heading.options');
              t &&
                this.listenTo(t, 'afterExecute', (t, o) => {
                  const i = e.model.document.selection.getFirstPosition().parent;
                  n.some((e) => i.is('element', e.model)) && !i.is('element', ok) && 0 === i.childCount && o.writer.rename(i, ok);
                });
            }
            _addDefaultH1Conversion(e) {
              e.conversion.for('upcast').elementToElement({ model: 'heading1', view: 'h1', converterPriority: s.get('low') + 1 });
            }
          }
          var rk = n(3230),
            sk = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(rk.Z, sk);
          rk.Z.locals;
          class ak extends V {
            static get pluginName() {
              return 'HeadingUI';
            }
            init() {
              const e = this.editor,
                t = e.t,
                n = (function (e) {
                  const t = e.t,
                    n = {
                      Paragraph: t('Paragraph'),
                      'Heading 1': t('Heading 1'),
                      'Heading 2': t('Heading 2'),
                      'Heading 3': t('Heading 3'),
                      'Heading 4': t('Heading 4'),
                      'Heading 5': t('Heading 5'),
                      'Heading 6': t('Heading 6'),
                    };
                  return e.config.get('heading.options').map((e) => {
                    const t = n[e.title];
                    return t && t != e.title && (e.title = t), e;
                  });
                })(e),
                o = t('Choose heading'),
                i = t('Heading');
              e.ui.componentFactory.add('heading', (t) => {
                const r = {},
                  s = new fo(),
                  a = e.commands.get('heading'),
                  l = e.commands.get('paragraph'),
                  c = [a];
                for (const e of n) {
                  const t = { type: 'button', model: new $h({ label: e.title, class: e.class, withText: !0 }) };
                  'paragraph' === e.model
                    ? (t.model.bind('isOn').to(l, 'value'), t.model.set('commandName', 'paragraph'), c.push(l))
                    : (t.model.bind('isOn').to(a, 'value', (t) => t === e.model),
                      t.model.set({ commandName: 'heading', commandValue: e.model })),
                    s.add(t),
                    (r[e.model] = e.title);
                }
                const d = yh(t);
                return (
                  Ch(d, s),
                  d.buttonView.set({ isOn: !1, withText: !0, tooltip: i }),
                  d.extendTemplate({ attributes: { class: ['ck-heading-dropdown'] } }),
                  d.bind('isEnabled').toMany(c, 'isEnabled', (...e) => e.some((e) => e)),
                  d.buttonView.bind('label').to(a, 'value', l, 'value', (e, t) => {
                    const n = e || (t && 'paragraph');
                    return r[n] ? r[n] : o;
                  }),
                  this.listenTo(d, 'execute', (t) => {
                    e.execute(t.source.commandName, t.source.commandValue ? { value: t.source.commandValue } : void 0),
                      e.editing.view.focus();
                  }),
                  d
                );
              });
            }
          }
          class lk extends V {
            static get requires() {
              return [Xh];
            }
            static get pluginName() {
              return 'WidgetToolbarRepository';
            }
            init() {
              const e = this.editor;
              if (e.plugins.has('BalloonToolbar')) {
                const t = e.plugins.get('BalloonToolbar');
                this.listenTo(
                  t,
                  'show',
                  (t) => {
                    (function (e) {
                      const t = e.getSelectedElement();
                      return !(!t || !Xp(t));
                    })(e.editing.view.document.selection) && t.stop();
                  },
                  { priority: 'high' }
                );
              }
              (this._toolbarDefinitions = new Map()),
                (this._balloon = this.editor.plugins.get('ContextualBalloon')),
                this.on('change:isEnabled', () => {
                  this._updateToolbarsVisibility();
                }),
                this.listenTo(e.ui, 'update', () => {
                  this._updateToolbarsVisibility();
                }),
                this.listenTo(
                  e.ui.focusTracker,
                  'change:isFocused',
                  () => {
                    this._updateToolbarsVisibility();
                  },
                  { priority: 'low' }
                );
            }
            destroy() {
              super.destroy();
              for (const e of this._toolbarDefinitions.values()) e.view.destroy();
            }
            register(e, { ariaLabel: t, items: n, getRelatedElement: o, balloonClassName: i = 'ck-toolbar-container' }) {
              if (!n.length) return void c('widget-toolbar-no-items', { toolbarId: e });
              const r = this.editor,
                s = r.t,
                a = new lh(r.locale);
              if (((a.ariaLabel = t || s('Widget toolbar')), this._toolbarDefinitions.has(e)))
                throw new l('widget-toolbar-duplicated', this, { toolbarId: e });
              a.fillFromConfig(n, r.ui.componentFactory);
              const d = { view: a, getRelatedElement: o, balloonClassName: i };
              r.ui.addToolbar(a, {
                isContextual: !0,
                beforeFocus: () => {
                  const e = o(r.editing.view.document.selection);
                  e && this._showToolbar(d, e);
                },
                afterBlur: () => {
                  this._hideToolbar(d);
                },
              }),
                this._toolbarDefinitions.set(e, d);
            }
            _updateToolbarsVisibility() {
              let e = 0,
                t = null,
                n = null;
              for (const o of this._toolbarDefinitions.values()) {
                const i = o.getRelatedElement(this.editor.editing.view.document.selection);
                if (this.isEnabled && i)
                  if (this.editor.ui.focusTracker.isFocused) {
                    const r = i.getAncestors().length;
                    r > e && ((e = r), (t = i), (n = o));
                  } else this._isToolbarVisible(o) && this._hideToolbar(o);
                else this._isToolbarInBalloon(o) && this._hideToolbar(o);
              }
              n && this._showToolbar(n, t);
            }
            _hideToolbar(e) {
              this._balloon.remove(e.view), this.stopListening(this._balloon, 'change:visibleView');
            }
            _showToolbar(e, t) {
              this._isToolbarVisible(e)
                ? ck(this.editor, t)
                : this._isToolbarInBalloon(e) ||
                  (this._balloon.add({ view: e.view, position: dk(this.editor, t), balloonClassName: e.balloonClassName }),
                  this.listenTo(this._balloon, 'change:visibleView', () => {
                    for (const e of this._toolbarDefinitions.values())
                      if (this._isToolbarVisible(e)) {
                        const t = e.getRelatedElement(this.editor.editing.view.document.selection);
                        ck(this.editor, t);
                      }
                  }));
            }
            _isToolbarVisible(e) {
              return this._balloon.visibleView === e.view;
            }
            _isToolbarInBalloon(e) {
              return this._balloon.hasView(e.view);
            }
          }
          function ck(e, t) {
            const n = e.plugins.get('ContextualBalloon'),
              o = dk(e, t);
            n.updatePosition(o);
          }
          function dk(e, t) {
            const n = e.editing.view,
              o = au.defaultPositions;
            return {
              target: n.domConverter.mapViewToDom(t),
              positions: [
                o.northArrowSouth,
                o.northArrowSouthWest,
                o.northArrowSouthEast,
                o.southArrowNorth,
                o.southArrowNorthWest,
                o.southArrowNorthEast,
                o.viewportStickyNorth,
              ],
            };
          }
          class uk {
            constructor(e) {
              this.set('activeHandlePosition', null),
                this.set('proposedWidthPercents', null),
                this.set('proposedWidth', null),
                this.set('proposedHeight', null),
                this.set('proposedHandleHostWidth', null),
                this.set('proposedHandleHostHeight', null),
                (this._options = e),
                (this._referenceCoordinates = null);
            }
            begin(e, t, n) {
              const o = new ka(t);
              (this.activeHandlePosition = (function (e) {
                const t = ['top-left', 'top-right', 'bottom-right', 'bottom-left'];
                for (const n of t) if (e.classList.contains(hk(n))) return n;
              })(e)),
                (this._referenceCoordinates = (function (e, t) {
                  const n = new ka(e),
                    o = t.split('-'),
                    i = { x: 'right' == o[1] ? n.right : n.left, y: 'bottom' == o[0] ? n.bottom : n.top };
                  return (i.x += e.ownerDocument.defaultView.scrollX), (i.y += e.ownerDocument.defaultView.scrollY), i;
                })(
                  t,
                  (function (e) {
                    const t = e.split('-'),
                      n = { top: 'bottom', bottom: 'top', left: 'right', right: 'left' };
                    return `${n[t[0]]}-${n[t[1]]}`;
                  })(this.activeHandlePosition)
                )),
                (this.originalWidth = o.width),
                (this.originalHeight = o.height),
                (this.aspectRatio = o.width / o.height);
              const i = n.style.width;
              i && i.match(/^\d+(\.\d*)?%$/)
                ? (this.originalWidthPercents = parseFloat(i))
                : (this.originalWidthPercents = (function (e, t) {
                    const n = e.parentElement,
                      o = parseFloat(n.ownerDocument.defaultView.getComputedStyle(n).width);
                    return (t.width / o) * 100;
                  })(n, o));
            }
            update(e) {
              (this.proposedWidth = e.width),
                (this.proposedHeight = e.height),
                (this.proposedWidthPercents = e.widthPercents),
                (this.proposedHandleHostWidth = e.handleHostWidth),
                (this.proposedHandleHostHeight = e.handleHostHeight);
            }
          }
          function hk(e) {
            return `ck-widget__resizer__handle-${e}`;
          }
          R(uk, B);
          class mk extends Jd {
            constructor() {
              super();
              const e = this.bindTemplate;
              this.setTemplate({
                tag: 'div',
                attributes: {
                  class: ['ck', 'ck-size-view', e.to('_viewPosition', (e) => (e ? `ck-orientation-${e}` : ''))],
                  style: { display: e.if('_isVisible', 'none', (e) => !e) },
                },
                children: [{ text: e.to('_label') }],
              });
            }
            _bindToState(e, t) {
              this.bind('_isVisible').to(t, 'proposedWidth', t, 'proposedHeight', (e, t) => null !== e && null !== t),
                this.bind('_label').to(t, 'proposedHandleHostWidth', t, 'proposedHandleHostHeight', t, 'proposedWidthPercents', (t, n, o) =>
                  'px' === e.unit ? `${t}×${n}` : `${o}%`
                ),
                this.bind('_viewPosition').to(
                  t,
                  'activeHandlePosition',
                  t,
                  'proposedHandleHostWidth',
                  t,
                  'proposedHandleHostHeight',
                  (e, t, n) => (t < 50 || n < 50 ? 'above-center' : e)
                );
            }
            _dismiss() {
              this.unbind(), (this._isVisible = !1);
            }
          }
          class gk {
            constructor(e) {
              (this._options = e),
                (this._viewResizerWrapper = null),
                this.set('isEnabled', !0),
                this.decorate('begin'),
                this.decorate('cancel'),
                this.decorate('commit'),
                this.decorate('updateSize'),
                this.on(
                  'commit',
                  (e) => {
                    this.state.proposedWidth || this.state.proposedWidthPercents || (this._cleanup(), e.stop());
                  },
                  { priority: 'high' }
                ),
                this.on('change:isEnabled', () => {
                  this.isEnabled && this.redraw();
                });
            }
            attach() {
              const e = this,
                t = this._options.viewElement;
              this._options.editor.editing.view.change((n) => {
                const o = n.createUIElement('div', { class: 'ck ck-reset_all ck-widget__resizer' }, function (t) {
                  const n = this.toDomElement(t);
                  return (
                    e._appendHandles(n),
                    e._appendSizeUI(n),
                    e.on('change:isEnabled', (e, t, o) => {
                      n.style.display = o ? '' : 'none';
                    }),
                    (n.style.display = e.isEnabled ? '' : 'none'),
                    n
                  );
                });
                n.insert(n.createPositionAt(t, 'end'), o), n.addClass('ck-widget_with-resizer', t), (this._viewResizerWrapper = o);
              });
            }
            begin(e) {
              (this.state = new uk(this._options)),
                this._sizeView._bindToState(this._options, this.state),
                (this._initialViewWidth = this._options.viewElement.getStyle('width')),
                this.state.begin(e, this._getHandleHost(), this._getResizeHost());
            }
            updateSize(e) {
              const t = this._proposeNewSize(e);
              this._options.editor.editing.view.change((e) => {
                const n = this._options.unit || '%',
                  o = ('%' === n ? t.widthPercents : t.width) + n;
                e.setStyle('width', o, this._options.viewElement);
              });
              const n = this._getHandleHost(),
                o = new ka(n);
              (t.handleHostWidth = Math.round(o.width)), (t.handleHostHeight = Math.round(o.height));
              const i = new ka(n);
              (t.width = Math.round(i.width)), (t.height = Math.round(i.height)), this.redraw(o), this.state.update(t);
            }
            commit() {
              const e = this._options.unit || '%',
                t = ('%' === e ? this.state.proposedWidthPercents : this.state.proposedWidth) + e;
              this._options.editor.editing.view.change(() => {
                this._cleanup(), this._options.onCommit(t);
              });
            }
            cancel() {
              this._cleanup();
            }
            destroy() {
              this.cancel();
            }
            redraw(e) {
              const t = this._domResizerWrapper;
              if (!((n = t) && n.ownerDocument && n.ownerDocument.contains(n))) return;
              var n;
              const o = t.parentElement,
                i = this._getHandleHost(),
                r = this._viewResizerWrapper,
                s = [r.getStyle('width'), r.getStyle('height'), r.getStyle('left'), r.getStyle('top')];
              let a;
              if (o.isSameNode(i)) {
                const t = e || new ka(i);
                a = [t.width + 'px', t.height + 'px', void 0, void 0];
              } else a = [i.offsetWidth + 'px', i.offsetHeight + 'px', i.offsetLeft + 'px', i.offsetTop + 'px'];
              'same' !== To(s, a) &&
                this._options.editor.editing.view.change((e) => {
                  e.setStyle({ width: a[0], height: a[1], left: a[2], top: a[3] }, r);
                });
            }
            containsHandle(e) {
              return this._domResizerWrapper.contains(e);
            }
            static isResizeHandle(e) {
              return e.classList.contains('ck-widget__resizer__handle');
            }
            _cleanup() {
              this._sizeView._dismiss();
              this._options.editor.editing.view.change((e) => {
                e.setStyle('width', this._initialViewWidth, this._options.viewElement);
              });
            }
            _proposeNewSize(e) {
              const t = this.state,
                n = { x: (o = e).pageX, y: o.pageY };
              var o;
              const i = !this._options.isCentered || this._options.isCentered(this),
                r = { x: t._referenceCoordinates.x - (n.x + t.originalWidth), y: n.y - t.originalHeight - t._referenceCoordinates.y };
              i && t.activeHandlePosition.endsWith('-right') && (r.x = n.x - (t._referenceCoordinates.x + t.originalWidth)),
                i && (r.x *= 2);
              const s = { width: Math.abs(t.originalWidth + r.x), height: Math.abs(t.originalHeight + r.y) };
              (s.dominant = s.width / t.aspectRatio > s.height ? 'width' : 'height'), (s.max = s[s.dominant]);
              const a = { width: s.width, height: s.height };
              return (
                'width' == s.dominant ? (a.height = a.width / t.aspectRatio) : (a.width = a.height * t.aspectRatio),
                {
                  width: Math.round(a.width),
                  height: Math.round(a.height),
                  widthPercents: Math.min(Math.round((t.originalWidthPercents / t.originalWidth) * a.width * 100) / 100, 100),
                }
              );
            }
            _getResizeHost() {
              const e = this._domResizerWrapper.parentElement;
              return this._options.getResizeHost(e);
            }
            _getHandleHost() {
              const e = this._domResizerWrapper.parentElement;
              return this._options.getHandleHost(e);
            }
            get _domResizerWrapper() {
              return this._options.editor.editing.view.domConverter.mapViewToDom(this._viewResizerWrapper);
            }
            _appendHandles(e) {
              const t = ['top-left', 'top-right', 'bottom-right', 'bottom-left'];
              for (const o of t)
                e.appendChild(
                  new Sd({
                    tag: 'div',
                    attributes: { class: 'ck-widget__resizer__handle ' + ((n = o), `ck-widget__resizer__handle-${n}`) },
                  }).render()
                );
              var n;
            }
            _appendSizeUI(e) {
              (this._sizeView = new mk()), this._sizeView.render(), e.appendChild(this._sizeView.element);
            }
          }
          R(gk, B);
          var pk = n(2263),
            fk = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(pk.Z, fk);
          pk.Z.locals;
          R(
            class extends V {
              static get pluginName() {
                return 'WidgetResize';
              }
              init() {
                const e = this.editor.editing,
                  t = _o.window.document;
                this.set('visibleResizer', null),
                  this.set('_activeResizer', null),
                  (this._resizers = new Map()),
                  e.view.addObserver(Tm),
                  (this._observer = Object.create(bs)),
                  this.listenTo(e.view.document, 'mousedown', this._mouseDownListener.bind(this), { priority: 'high' }),
                  this._observer.listenTo(t, 'mousemove', this._mouseMoveListener.bind(this)),
                  this._observer.listenTo(t, 'mouseup', this._mouseUpListener.bind(this));
                const n = () => {
                  this.visibleResizer && this.visibleResizer.redraw();
                };
                (this._redrawFocusedResizerThrottled = xf(n, 200)),
                  this.on('change:visibleResizer', n),
                  this.editor.ui.on('update', this._redrawFocusedResizerThrottled),
                  this.editor.model.document.on(
                    'change',
                    () => {
                      for (const [e, t] of this._resizers) e.isAttached() || (this._resizers.delete(e), t.destroy());
                    },
                    { priority: 'lowest' }
                  ),
                  this._observer.listenTo(_o.window, 'resize', this._redrawFocusedResizerThrottled);
                const o = this.editor.editing.view.document.selection;
                o.on('change', () => {
                  const e = o.getSelectedElement();
                  this.visibleResizer = this.getResizerByViewElement(e) || null;
                });
              }
              destroy() {
                this._observer.stopListening();
                for (const e of this._resizers.values()) e.destroy();
                this._redrawFocusedResizerThrottled.cancel();
              }
              attachTo(e) {
                const t = new gk(e),
                  n = this.editor.plugins;
                if ((t.attach(), n.has('WidgetToolbarRepository'))) {
                  const e = n.get('WidgetToolbarRepository');
                  t.on(
                    'begin',
                    () => {
                      e.forceDisabled('resize');
                    },
                    { priority: 'lowest' }
                  ),
                    t.on(
                      'cancel',
                      () => {
                        e.clearForceDisabled('resize');
                      },
                      { priority: 'highest' }
                    ),
                    t.on(
                      'commit',
                      () => {
                        e.clearForceDisabled('resize');
                      },
                      { priority: 'highest' }
                    );
                }
                this._resizers.set(e.viewElement, t);
                const o = this.editor.editing.view.document.selection.getSelectedElement();
                return this.getResizerByViewElement(o) == t && (this.visibleResizer = t), t;
              }
              getResizerByViewElement(e) {
                return this._resizers.get(e);
              }
              _getResizerByHandle(e) {
                for (const t of this._resizers.values()) if (t.containsHandle(e)) return t;
              }
              _mouseDownListener(e, t) {
                const n = t.domTarget;
                gk.isResizeHandle(n) &&
                  ((this._activeResizer = this._getResizerByHandle(n)),
                  this._activeResizer && (this._activeResizer.begin(n), e.stop(), t.preventDefault()));
              }
              _mouseMoveListener(e, t) {
                this._activeResizer && this._activeResizer.updateSize(t);
              }
              _mouseUpListener() {
                this._activeResizer && (this._activeResizer.commit(), (this._activeResizer = null));
              }
            },
            B
          );
          class kk extends H {
            refresh() {
              const e = this.editor.plugins.get('ImageUtils').getClosestSelectedImageElement(this.editor.model.document.selection);
              (this.isEnabled = !!e), this.isEnabled && e.hasAttribute('alt') ? (this.value = e.getAttribute('alt')) : (this.value = !1);
            }
            execute(e) {
              const t = this.editor,
                n = t.plugins.get('ImageUtils'),
                o = t.model,
                i = n.getClosestSelectedImageElement(o.document.selection);
              o.change((t) => {
                t.setAttribute('alt', e.newValue, i);
              });
            }
          }
          function bk(e) {
            return e.createContainerElement('figure', { class: 'image' }, [e.createEmptyElement('img'), e.createSlot()]);
          }
          function wk(e, t) {
            const n = e.plugins.get('ImageUtils'),
              o = e.plugins.has('ImageInlineEditing') && e.plugins.has('ImageBlockEditing');
            return (e) => {
              if (!n.isInlineImageView(e)) return null;
              if (!o) return i(e);
              return (e.findAncestor(n.isBlockImageView) ? 'imageBlock' : 'imageInline') !== t ? null : i(e);
            };
            function i(e) {
              const t = { name: !0 };
              return e.hasAttribute('src') && (t.attributes = ['src']), t;
            }
          }
          function _k(e, t) {
            const n = Ca(t.getSelectedBlocks());
            return !n || e.isObject(n) || (n.isEmpty && 'listItem' != n.name) ? 'imageBlock' : 'imageInline';
          }
          class yk extends V {
            static get pluginName() {
              return 'ImageUtils';
            }
            isImage(e) {
              return this.isInlineImage(e) || this.isBlockImage(e);
            }
            isInlineImageView(e) {
              return !!e && e.is('element', 'img');
            }
            isBlockImageView(e) {
              return !!e && e.is('element', 'figure') && e.hasClass('image');
            }
            insertImage(e = {}, t = null, n = null) {
              const o = this.editor,
                i = o.model,
                r = i.document.selection;
              (n = Ak(o, t || r, n)), (e = { ...Object.fromEntries(r.getAttributes()), ...e });
              for (const t in e) i.schema.checkAttribute(n, t) || delete e[t];
              return i.change((o) => {
                const r = o.createElement(n, e);
                return (
                  i.insertObject(r, t, null, { setSelection: 'on', findOptimalPosition: !t && 'imageInline' != n }), r.parent ? r : null
                );
              });
            }
            getClosestSelectedImageWidget(e) {
              const t = e.getFirstPosition();
              if (!t) return null;
              const n = e.getSelectedElement();
              if (n && this.isImageWidget(n)) return n;
              let o = t.parent;
              for (; o; ) {
                if (o.is('element') && this.isImageWidget(o)) return o;
                o = o.parent;
              }
              return null;
            }
            getClosestSelectedImageElement(e) {
              const t = e.getSelectedElement();
              return this.isImage(t) ? t : e.getFirstPosition().findAncestor('imageBlock');
            }
            isImageAllowed() {
              const e = this.editor.model.document.selection;
              return (
                (function (e, t) {
                  if ('imageBlock' == Ak(e, t)) {
                    const n = (function (e, t) {
                      const n = af(e, t).start.parent;
                      if (n.isEmpty && !n.is('element', '$root')) return n.parent;
                      return n;
                    })(t, e.model);
                    if (e.model.schema.checkChild(n, 'imageBlock')) return !0;
                  } else if (e.model.schema.checkChild(t.focus, 'imageInline')) return !0;
                  return !1;
                })(this.editor, e) &&
                (function (e) {
                  return [...e.focus.getAncestors()].every((e) => !e.is('element', 'imageBlock'));
                })(e)
              );
            }
            toImageWidget(e, t, n) {
              t.setCustomProperty('image', !0, e);
              return ef(e, t, {
                label: () => {
                  const t = this.findViewImgElement(e).getAttribute('alt');
                  return t ? `${t} ${n}` : n;
                },
              });
            }
            isImageWidget(e) {
              return !!e.getCustomProperty('image') && Xp(e);
            }
            isBlockImage(e) {
              return !!e && e.is('element', 'imageBlock');
            }
            isInlineImage(e) {
              return !!e && e.is('element', 'imageInline');
            }
            findViewImgElement(e) {
              if (this.isInlineImageView(e)) return e;
              const t = this.editor.editing.view;
              for (const { item: n } of t.createRangeIn(e)) if (this.isInlineImageView(n)) return n;
            }
          }
          function Ak(e, t, n) {
            const o = e.model.schema,
              i = e.config.get('image.insert.type');
            return e.plugins.has('ImageBlockEditing')
              ? e.plugins.has('ImageInlineEditing')
                ? n ||
                  ('inline' === i
                    ? 'imageInline'
                    : 'block' === i
                    ? 'imageBlock'
                    : t.is('selection')
                    ? _k(o, t)
                    : o.checkChild(t, 'imageInline')
                    ? 'imageInline'
                    : 'imageBlock')
                : 'imageBlock'
              : 'imageInline';
          }
          class Ck extends V {
            static get requires() {
              return [yk];
            }
            static get pluginName() {
              return 'ImageTextAlternativeEditing';
            }
            init() {
              this.editor.commands.add('imageTextAlternative', new kk(this.editor));
            }
          }
          var vk = n(6831),
            xk = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(vk.Z, xk);
          vk.Z.locals;
          var Ek = n(1590),
            Dk = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Ek.Z, Dk);
          Ek.Z.locals;
          class Tk extends Jd {
            constructor(e) {
              super(e);
              const t = this.locale.t;
              (this.focusTracker = new va()),
                (this.keystrokes = new xa()),
                (this.labeledInput = this._createLabeledInputView()),
                (this.saveButtonView = this._createButton(t('Save'), Cu.check, 'ck-button-save')),
                (this.saveButtonView.type = 'submit'),
                (this.cancelButtonView = this._createButton(t('Cancel'), Cu.cancel, 'ck-button-cancel', 'cancel')),
                (this._focusables = new Id()),
                (this._focusCycler = new th({
                  focusables: this._focusables,
                  focusTracker: this.focusTracker,
                  keystrokeHandler: this.keystrokes,
                  actions: { focusPrevious: 'shift + tab', focusNext: 'tab' },
                })),
                this.setTemplate({
                  tag: 'form',
                  attributes: { class: ['ck', 'ck-text-alternative-form', 'ck-responsive-form'], tabindex: '-1' },
                  children: [this.labeledInput, this.saveButtonView, this.cancelButtonView],
                }),
                xu(this);
            }
            render() {
              super.render(),
                this.keystrokes.listenTo(this.element),
                Eu({ view: this }),
                [this.labeledInput, this.saveButtonView, this.cancelButtonView].forEach((e) => {
                  this._focusables.add(e), this.focusTracker.add(e.element);
                });
            }
            destroy() {
              super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
            }
            _createButton(e, t, n, o) {
              const i = new zu(this.locale);
              return (
                i.set({ label: e, icon: t, tooltip: !0 }),
                i.extendTemplate({ attributes: { class: n } }),
                o && i.delegate('execute').to(this, o),
                i
              );
            }
            _createLabeledInputView() {
              const e = this.locale.t,
                t = new Uh(this.locale, qh);
              return (t.label = e('Text alternative')), t;
            }
          }
          function Ik(e) {
            const t = e.editing.view,
              n = au.defaultPositions,
              o = e.plugins.get('ImageUtils');
            return {
              target: t.domConverter.mapViewToDom(o.getClosestSelectedImageWidget(t.document.selection)),
              positions: [
                n.northArrowSouth,
                n.northArrowSouthWest,
                n.northArrowSouthEast,
                n.southArrowNorth,
                n.southArrowNorthWest,
                n.southArrowNorthEast,
                n.viewportStickyNorth,
              ],
            };
          }
          class Sk extends V {
            static get requires() {
              return [Xh];
            }
            static get pluginName() {
              return 'ImageTextAlternativeUI';
            }
            init() {
              this._createButton(), this._createForm();
            }
            destroy() {
              super.destroy(), this._form.destroy();
            }
            _createButton() {
              const e = this.editor,
                t = e.t;
              e.ui.componentFactory.add('imageTextAlternative', (n) => {
                const o = e.commands.get('imageTextAlternative'),
                  i = new zu(n);
                return (
                  i.set({ label: t('Change image text alternative'), icon: Cu.lowVision, tooltip: !0 }),
                  i.bind('isEnabled').to(o, 'isEnabled'),
                  this.listenTo(i, 'execute', () => {
                    this._showForm();
                  }),
                  i
                );
              });
            }
            _createForm() {
              const e = this.editor,
                t = e.editing.view.document,
                n = e.plugins.get('ImageUtils');
              (this._balloon = this.editor.plugins.get('ContextualBalloon')),
                (this._form = new Tk(e.locale)),
                this._form.render(),
                this.listenTo(this._form, 'submit', () => {
                  e.execute('imageTextAlternative', { newValue: this._form.labeledInput.fieldView.element.value }), this._hideForm(!0);
                }),
                this.listenTo(this._form, 'cancel', () => {
                  this._hideForm(!0);
                }),
                this._form.keystrokes.set('Esc', (e, t) => {
                  this._hideForm(!0), t();
                }),
                this.listenTo(e.ui, 'update', () => {
                  n.getClosestSelectedImageWidget(t.selection)
                    ? this._isVisible &&
                      (function (e) {
                        const t = e.plugins.get('ContextualBalloon');
                        if (e.plugins.get('ImageUtils').getClosestSelectedImageWidget(e.editing.view.document.selection)) {
                          const n = Ik(e);
                          t.updatePosition(n);
                        }
                      })(e)
                    : this._hideForm(!0);
                }),
                vu({
                  emitter: this._form,
                  activator: () => this._isVisible,
                  contextElements: [this._balloon.view.element],
                  callback: () => this._hideForm(),
                });
            }
            _showForm() {
              if (this._isVisible) return;
              const e = this.editor,
                t = e.commands.get('imageTextAlternative'),
                n = this._form.labeledInput;
              this._form.disableCssTransitions(),
                this._isInBalloon || this._balloon.add({ view: this._form, position: Ik(e) }),
                (n.fieldView.value = n.fieldView.element.value = t.value || ''),
                this._form.labeledInput.fieldView.select(),
                this._form.enableCssTransitions();
            }
            _hideForm(e) {
              this._isInBalloon &&
                (this._form.focusTracker.isFocused && this._form.saveButtonView.focus(),
                this._balloon.remove(this._form),
                e && this.editor.editing.view.focus());
            }
            get _isVisible() {
              return this._balloon.visibleView === this._form;
            }
            get _isInBalloon() {
              return this._balloon.hasView(this._form);
            }
          }
          class Mk extends V {
            static get requires() {
              return [Ck, Sk];
            }
            static get pluginName() {
              return 'ImageTextAlternative';
            }
          }
          function Bk(e, t) {
            return (e) => {
              e.on(`attribute:srcset:${t}`, n);
            };
            function n(t, n, o) {
              if (!o.consumable.consume(n.item, t.name)) return;
              const i = o.writer,
                r = o.mapper.toViewElement(n.item),
                s = e.findViewImgElement(r);
              if (null === n.attributeNewValue) {
                const e = n.attributeOldValue;
                e.data && (i.removeAttribute('srcset', s), i.removeAttribute('sizes', s), e.width && i.removeAttribute('width', s));
              } else {
                const e = n.attributeNewValue;
                e.data &&
                  (i.setAttribute('srcset', e.data, s),
                  i.setAttribute('sizes', '100vw', s),
                  e.width && i.setAttribute('width', e.width, s));
              }
            }
          }
          function Nk(e, t, n) {
            return (e) => {
              e.on(`attribute:${n}:${t}`, o);
            };
            function o(t, n, o) {
              if (!o.consumable.consume(n.item, t.name)) return;
              const i = o.writer,
                r = o.mapper.toViewElement(n.item),
                s = e.findViewImgElement(r);
              i.setAttribute(n.attributeKey, n.attributeNewValue || '', s);
            }
          }
          class Pk extends As {
            observe(e) {
              this.listenTo(
                e,
                'load',
                (e, t) => {
                  const n = t.target;
                  this.checkShouldIgnoreEventFromTarget(n) || ('IMG' == n.tagName && this._fireEvents(t));
                },
                { useCapture: !0 }
              );
            }
            _fireEvents(e) {
              this.isEnabled && (this.document.fire('layoutChanged'), this.document.fire('imageLoaded', e));
            }
          }
          class zk extends H {
            constructor(e) {
              super(e);
              const t = e.config.get('image.insert.type');
              e.plugins.has('ImageBlockEditing') || ('block' === t && c('image-block-plugin-required')),
                e.plugins.has('ImageInlineEditing') || ('inline' === t && c('image-inline-plugin-required'));
            }
            refresh() {
              this.isEnabled = this.editor.plugins.get('ImageUtils').isImageAllowed();
            }
            execute(e) {
              const t = bo(e.source),
                n = this.editor.model.document.selection,
                o = this.editor.plugins.get('ImageUtils'),
                i = Object.fromEntries(n.getAttributes());
              t.forEach((e, t) => {
                const r = n.getSelectedElement();
                if (('string' == typeof e && (e = { src: e }), t && r && o.isImage(r))) {
                  const t = this.editor.model.createPositionAfter(r);
                  o.insertImage({ ...e, ...i }, t);
                } else o.insertImage({ ...e, ...i });
              });
            }
          }
          class Lk extends V {
            static get requires() {
              return [yk];
            }
            static get pluginName() {
              return 'ImageEditing';
            }
            init() {
              const e = this.editor,
                t = e.conversion;
              e.editing.view.addObserver(Pk),
                t
                  .for('upcast')
                  .attributeToAttribute({ view: { name: 'img', key: 'alt' }, model: 'alt' })
                  .attributeToAttribute({
                    view: { name: 'img', key: 'srcset' },
                    model: {
                      key: 'srcset',
                      value: (e) => {
                        const t = { data: e.getAttribute('srcset') };
                        return e.hasAttribute('width') && (t.width = e.getAttribute('width')), t;
                      },
                    },
                  });
              const n = new zk(e);
              e.commands.add('insertImage', n), e.commands.add('imageInsert', n);
            }
          }
          class jk extends H {
            constructor(e, t) {
              super(e), (this._modelElementName = t);
            }
            refresh() {
              const e = this.editor.plugins.get('ImageUtils'),
                t = e.getClosestSelectedImageElement(this.editor.model.document.selection);
              'imageBlock' === this._modelElementName ? (this.isEnabled = e.isInlineImage(t)) : (this.isEnabled = e.isBlockImage(t));
            }
            execute() {
              const e = this.editor,
                t = this.editor.model,
                n = e.plugins.get('ImageUtils'),
                o = n.getClosestSelectedImageElement(t.document.selection),
                i = Object.fromEntries(o.getAttributes());
              return i.src || i.uploadId
                ? t.change((e) => {
                    const r = Array.from(t.markers).filter((e) => e.getRange().containsItem(o)),
                      s = n.insertImage(i, t.createSelection(o, 'on'), this._modelElementName);
                    if (!s) return null;
                    const a = e.createRangeOn(s);
                    for (const t of r) {
                      const n = t.getRange(),
                        o = '$graveyard' != n.root.rootName ? n.getJoined(a, !0) : a;
                      e.updateMarker(t, { range: o });
                    }
                    return { oldElement: o, newElement: s };
                  })
                : null;
            }
          }
          class Ok extends V {
            static get requires() {
              return [Lk, yk, Gp];
            }
            static get pluginName() {
              return 'ImageBlockEditing';
            }
            init() {
              const e = this.editor;
              e.model.schema.register('imageBlock', { inheritAllFrom: '$blockObject', allowAttributes: ['alt', 'src', 'srcset'] }),
                this._setupConversion(),
                e.plugins.has('ImageInlineEditing') &&
                  (e.commands.add('imageTypeBlock', new jk(this.editor, 'imageBlock')), this._setupClipboardIntegration());
            }
            _setupConversion() {
              const e = this.editor,
                t = e.t,
                n = e.conversion,
                o = e.plugins.get('ImageUtils');
              n.for('dataDowncast').elementToStructure({ model: 'imageBlock', view: (e, { writer: t }) => bk(t) }),
                n
                  .for('editingDowncast')
                  .elementToStructure({ model: 'imageBlock', view: (e, { writer: n }) => o.toImageWidget(bk(n), n, t('image widget')) }),
                n.for('downcast').add(Nk(o, 'imageBlock', 'src')).add(Nk(o, 'imageBlock', 'alt')).add(Bk(o, 'imageBlock')),
                n
                  .for('upcast')
                  .elementToElement({
                    view: wk(e, 'imageBlock'),
                    model: (e, { writer: t }) =>
                      t.createElement('imageBlock', e.hasAttribute('src') ? { src: e.getAttribute('src') } : null),
                  })
                  .add(
                    (function (e) {
                      return (e) => {
                        e.on('element:figure', t);
                      };
                      function t(t, n, o) {
                        if (!o.consumable.test(n.viewItem, { name: !0, classes: 'image' })) return;
                        const i = e.findViewImgElement(n.viewItem);
                        if (!i || !o.consumable.test(i, { name: !0 })) return;
                        o.consumable.consume(n.viewItem, { name: !0, classes: 'image' });
                        const r = Ca(o.convertItem(i, n.modelCursor).modelRange.getItems());
                        r
                          ? (o.convertChildren(n.viewItem, r), o.updateConversionResult(r, n))
                          : o.consumable.revert(n.viewItem, { name: !0, classes: 'image' });
                      }
                    })(o)
                  );
            }
            _setupClipboardIntegration() {
              const e = this.editor,
                t = e.model,
                n = e.editing.view,
                o = e.plugins.get('ImageUtils');
              this.listenTo(e.plugins.get('ClipboardPipeline'), 'inputTransformation', (i, r) => {
                const s = Array.from(r.content.getChildren());
                let a;
                if (!s.every(o.isInlineImageView)) return;
                a = r.targetRanges ? e.editing.mapper.toModelRange(r.targetRanges[0]) : t.document.selection.getFirstRange();
                const l = t.createSelection(a);
                if ('imageBlock' === _k(t.schema, l)) {
                  const e = new Im(n.document),
                    t = s.map((t) => e.createElement('figure', { class: 'image' }, t));
                  r.content = e.createDocumentFragment(t);
                }
              });
            }
          }
          var Rk = n(9048),
            Vk = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Rk.Z, Vk);
          Rk.Z.locals;
          class Fk extends V {
            static get requires() {
              return [Ok, Cf, Mk];
            }
            static get pluginName() {
              return 'ImageBlock';
            }
          }
          class Hk extends V {
            static get requires() {
              return [Lk, yk, Gp];
            }
            static get pluginName() {
              return 'ImageInlineEditing';
            }
            init() {
              const e = this.editor,
                t = e.model.schema;
              t.register('imageInline', { inheritAllFrom: '$inlineObject', allowAttributes: ['alt', 'src', 'srcset'] }),
                t.addChildCheck((e, t) => {
                  if (e.endsWith('caption') && 'imageInline' === t.name) return !1;
                }),
                this._setupConversion(),
                e.plugins.has('ImageBlockEditing') &&
                  (e.commands.add('imageTypeInline', new jk(this.editor, 'imageInline')), this._setupClipboardIntegration());
            }
            _setupConversion() {
              const e = this.editor,
                t = e.t,
                n = e.conversion,
                o = e.plugins.get('ImageUtils');
              n.for('dataDowncast').elementToElement({ model: 'imageInline', view: (e, { writer: t }) => t.createEmptyElement('img') }),
                n.for('editingDowncast').elementToStructure({
                  model: 'imageInline',
                  view: (e, { writer: n }) =>
                    o.toImageWidget(
                      (function (e) {
                        return e.createContainerElement('span', { class: 'image-inline' }, e.createEmptyElement('img'));
                      })(n),
                      n,
                      t('image widget')
                    ),
                }),
                n.for('downcast').add(Nk(o, 'imageInline', 'src')).add(Nk(o, 'imageInline', 'alt')).add(Bk(o, 'imageInline')),
                n.for('upcast').elementToElement({
                  view: wk(e, 'imageInline'),
                  model: (e, { writer: t }) =>
                    t.createElement('imageInline', e.hasAttribute('src') ? { src: e.getAttribute('src') } : null),
                });
            }
            _setupClipboardIntegration() {
              const e = this.editor,
                t = e.model,
                n = e.editing.view,
                o = e.plugins.get('ImageUtils');
              this.listenTo(e.plugins.get('ClipboardPipeline'), 'inputTransformation', (i, r) => {
                const s = Array.from(r.content.getChildren());
                let a;
                if (!s.every(o.isBlockImageView)) return;
                a = r.targetRanges ? e.editing.mapper.toModelRange(r.targetRanges[0]) : t.document.selection.getFirstRange();
                const l = t.createSelection(a);
                if ('imageInline' === _k(t.schema, l)) {
                  const e = new Im(n.document),
                    t = s.map((t) =>
                      1 === t.childCount
                        ? (Array.from(t.getAttributes()).forEach((n) => e.setAttribute(...n, o.findViewImgElement(t))), t.getChild(0))
                        : t
                    );
                  r.content = e.createDocumentFragment(t);
                }
              });
            }
          }
          class Uk extends V {
            static get requires() {
              return [Hk, Cf, Mk];
            }
            static get pluginName() {
              return 'ImageInline';
            }
          }
          class qk extends H {
            refresh() {
              const e = this.editor,
                t = e.plugins.get('ImageCaptionUtils');
              if (!e.plugins.has(Ok)) return (this.isEnabled = !1), void (this.value = !1);
              const n = e.model.document.selection,
                o = n.getSelectedElement();
              if (!o) {
                const e = t.getCaptionFromModelSelection(n);
                return (this.isEnabled = !!e), void (this.value = !!e);
              }
              (this.isEnabled = this.editor.plugins.get('ImageUtils').isImage(o)),
                this.isEnabled ? (this.value = !!t.getCaptionFromImageModelElement(o)) : (this.value = !1);
            }
            execute(e = {}) {
              const { focusCaptionOnShow: t } = e;
              this.editor.model.change((e) => {
                this.value ? this._hideImageCaption(e) : this._showImageCaption(e, t);
              });
            }
            _showImageCaption(e, t) {
              const n = this.editor.model.document.selection,
                o = this.editor.plugins.get('ImageCaptionEditing');
              let i = n.getSelectedElement();
              const r = o._getSavedCaption(i);
              this.editor.plugins.get('ImageUtils').isInlineImage(i) &&
                (this.editor.execute('imageTypeBlock'), (i = n.getSelectedElement()));
              const s = r || e.createElement('caption');
              e.append(s, i), t && e.setSelection(s, 'in');
            }
            _hideImageCaption(e) {
              const t = this.editor,
                n = t.model.document.selection,
                o = t.plugins.get('ImageCaptionEditing'),
                i = t.plugins.get('ImageCaptionUtils');
              let r,
                s = n.getSelectedElement();
              s ? (r = i.getCaptionFromImageModelElement(s)) : ((r = i.getCaptionFromModelSelection(n)), (s = r.parent)),
                o._saveCaption(s, r),
                e.setSelection(s, 'on'),
                e.remove(r);
            }
          }
          class Wk extends V {
            static get pluginName() {
              return 'ImageCaptionUtils';
            }
            static get requires() {
              return [yk];
            }
            getCaptionFromImageModelElement(e) {
              for (const t of e.getChildren()) if (t && t.is('element', 'caption')) return t;
              return null;
            }
            getCaptionFromModelSelection(e) {
              const t = this.editor.plugins.get('ImageUtils'),
                n = e.getFirstPosition().findAncestor('caption');
              return n && t.isBlockImage(n.parent) ? n : null;
            }
            matchImageCaptionViewElement(e) {
              const t = this.editor.plugins.get('ImageUtils');
              return 'figcaption' == e.name && t.isBlockImageView(e.parent) ? { name: !0 } : null;
            }
          }
          class Gk extends V {
            static get requires() {
              return [yk, Wk];
            }
            static get pluginName() {
              return 'ImageCaptionEditing';
            }
            constructor(e) {
              super(e), (this._savedCaptionsMap = new WeakMap());
            }
            init() {
              const e = this.editor,
                t = e.model.schema;
              t.isRegistered('caption')
                ? t.extend('caption', { allowIn: 'imageBlock' })
                : t.register('caption', { allowIn: 'imageBlock', allowContentOf: '$block', isLimit: !0 }),
                e.commands.add('toggleImageCaption', new qk(this.editor)),
                this._setupConversion(),
                this._setupImageTypeCommandsIntegration(),
                this._registerCaptionReconversion();
            }
            _setupConversion() {
              const e = this.editor,
                t = e.editing.view,
                n = e.plugins.get('ImageUtils'),
                o = e.plugins.get('ImageCaptionUtils'),
                i = e.t;
              e.conversion.for('upcast').elementToElement({ view: (e) => o.matchImageCaptionViewElement(e), model: 'caption' }),
                e.conversion.for('dataDowncast').elementToElement({
                  model: 'caption',
                  view: (e, { writer: t }) => (n.isBlockImage(e.parent) ? t.createContainerElement('figcaption') : null),
                }),
                e.conversion.for('editingDowncast').elementToElement({
                  model: 'caption',
                  view: (e, { writer: o }) => {
                    if (!n.isBlockImage(e.parent)) return null;
                    const r = o.createEditableElement('figcaption');
                    o.setCustomProperty('imageCaption', !0, r),
                      um({ view: t, element: r, text: i('Enter image caption'), keepOnFocus: !0 });
                    const s = e.parent.getAttribute('alt');
                    return sf(r, o, { label: s ? i('Caption for image: %0', [s]) : i('Caption for the image') });
                  },
                });
            }
            _setupImageTypeCommandsIntegration() {
              const e = this.editor,
                t = e.plugins.get('ImageUtils'),
                n = e.plugins.get('ImageCaptionUtils'),
                o = e.commands.get('imageTypeInline'),
                i = e.commands.get('imageTypeBlock'),
                r = (e) => {
                  if (!e.return) return;
                  const { oldElement: o, newElement: i } = e.return;
                  if (!o) return;
                  if (t.isBlockImage(o)) {
                    const e = n.getCaptionFromImageModelElement(o);
                    if (e) return void this._saveCaption(i, e);
                  }
                  const r = this._getSavedCaption(o);
                  r && this._saveCaption(i, r);
                };
              o && this.listenTo(o, 'execute', r, { priority: 'low' }), i && this.listenTo(i, 'execute', r, { priority: 'low' });
            }
            _getSavedCaption(e) {
              const t = this._savedCaptionsMap.get(e);
              return t ? Ua.fromJSON(t) : null;
            }
            _saveCaption(e, t) {
              this._savedCaptionsMap.set(e, t.toJSON());
            }
            _registerCaptionReconversion() {
              const e = this.editor,
                t = e.model,
                n = e.plugins.get('ImageUtils'),
                o = e.plugins.get('ImageCaptionUtils');
              t.document.on('change:data', () => {
                const i = t.document.differ.getChanges();
                for (const t of i) {
                  if ('alt' !== t.attributeKey) continue;
                  const i = t.range.start.nodeAfter;
                  if (n.isBlockImage(i)) {
                    const t = o.getCaptionFromImageModelElement(i);
                    if (!t) return;
                    e.editing.reconvertItem(t);
                  }
                }
              });
            }
          }
          class $k extends V {
            static get requires() {
              return [Wk];
            }
            static get pluginName() {
              return 'ImageCaptionUI';
            }
            init() {
              const e = this.editor,
                t = e.editing.view,
                n = e.plugins.get('ImageCaptionUtils'),
                o = e.t;
              e.ui.componentFactory.add('toggleImageCaption', (i) => {
                const r = e.commands.get('toggleImageCaption'),
                  s = new zu(i);
                return (
                  s.set({ icon: Cu.caption, tooltip: !0, isToggleable: !0 }),
                  s.bind('isOn', 'isEnabled').to(r, 'value', 'isEnabled'),
                  s.bind('label').to(r, 'value', (e) => o(e ? 'Toggle caption off' : 'Toggle caption on')),
                  this.listenTo(s, 'execute', () => {
                    e.execute('toggleImageCaption', { focusCaptionOnShow: !0 });
                    const o = n.getCaptionFromModelSelection(e.model.document.selection);
                    if (o) {
                      const n = e.editing.mapper.toViewElement(o);
                      t.scrollToTheSelection(),
                        t.change((e) => {
                          e.addClass('image__caption_highlighted', n);
                        });
                    }
                    e.editing.view.focus();
                  }),
                  s
                );
              });
            }
          }
          var Yk = n(8662),
            Kk = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Yk.Z, Kk);
          Yk.Z.locals;
          class Qk extends H {
            constructor(e, t) {
              super(e),
                (this._defaultStyles = { imageBlock: !1, imageInline: !1 }),
                (this._styles = new Map(
                  t.map((e) => {
                    if (e.isDefault) for (const t of e.modelElements) this._defaultStyles[t] = e.name;
                    return [e.name, e];
                  })
                ));
            }
            refresh() {
              const e = this.editor.plugins.get('ImageUtils').getClosestSelectedImageElement(this.editor.model.document.selection);
              (this.isEnabled = !!e),
                this.isEnabled
                  ? e.hasAttribute('imageStyle')
                    ? (this.value = e.getAttribute('imageStyle'))
                    : (this.value = this._defaultStyles[e.name])
                  : (this.value = !1);
            }
            execute(e = {}) {
              const t = this.editor,
                n = t.model,
                o = t.plugins.get('ImageUtils');
              n.change((t) => {
                const i = e.value;
                let r = o.getClosestSelectedImageElement(n.document.selection);
                i &&
                  this.shouldConvertImageType(i, r) &&
                  (this.editor.execute(o.isBlockImage(r) ? 'imageTypeInline' : 'imageTypeBlock'),
                  (r = o.getClosestSelectedImageElement(n.document.selection))),
                  !i || this._styles.get(i).isDefault ? t.removeAttribute('imageStyle', r) : t.setAttribute('imageStyle', i, r);
              });
            }
            shouldConvertImageType(e, t) {
              return !this._styles.get(e).modelElements.includes(t.name);
            }
          }
          const {
              objectFullWidth: Zk,
              objectInline: Jk,
              objectLeft: Xk,
              objectRight: eb,
              objectCenter: tb,
              objectBlockLeft: nb,
              objectBlockRight: ob,
            } = Cu,
            ib = {
              get inline() {
                return { name: 'inline', title: 'In line', icon: Jk, modelElements: ['imageInline'], isDefault: !0 };
              },
              get alignLeft() {
                return {
                  name: 'alignLeft',
                  title: 'Left aligned image',
                  icon: Xk,
                  modelElements: ['imageBlock', 'imageInline'],
                  className: 'image-style-align-left',
                };
              },
              get alignBlockLeft() {
                return {
                  name: 'alignBlockLeft',
                  title: 'Left aligned image',
                  icon: nb,
                  modelElements: ['imageBlock'],
                  className: 'image-style-block-align-left',
                };
              },
              get alignCenter() {
                return {
                  name: 'alignCenter',
                  title: 'Centered image',
                  icon: tb,
                  modelElements: ['imageBlock'],
                  className: 'image-style-align-center',
                };
              },
              get alignRight() {
                return {
                  name: 'alignRight',
                  title: 'Right aligned image',
                  icon: eb,
                  modelElements: ['imageBlock', 'imageInline'],
                  className: 'image-style-align-right',
                };
              },
              get alignBlockRight() {
                return {
                  name: 'alignBlockRight',
                  title: 'Right aligned image',
                  icon: ob,
                  modelElements: ['imageBlock'],
                  className: 'image-style-block-align-right',
                };
              },
              get block() {
                return { name: 'block', title: 'Centered image', icon: tb, modelElements: ['imageBlock'], isDefault: !0 };
              },
              get side() {
                return { name: 'side', title: 'Side image', icon: eb, modelElements: ['imageBlock'], className: 'image-style-side' };
              },
            },
            rb = { full: Zk, left: nb, right: ob, center: tb, inlineLeft: Xk, inlineRight: eb, inline: Jk },
            sb = [
              {
                name: 'imageStyle:wrapText',
                title: 'Wrap text',
                defaultItem: 'imageStyle:alignLeft',
                items: ['imageStyle:alignLeft', 'imageStyle:alignRight'],
              },
              {
                name: 'imageStyle:breakText',
                title: 'Break text',
                defaultItem: 'imageStyle:block',
                items: ['imageStyle:alignBlockLeft', 'imageStyle:block', 'imageStyle:alignBlockRight'],
              },
            ];
          function ab(e) {
            c('image-style-configuration-definition-invalid', e);
          }
          const lb = {
            normalizeStyles: function (e) {
              return (e.configuredStyles.options || [])
                .map((e) =>
                  (function (e) {
                    e =
                      'string' == typeof e
                        ? ib[e]
                          ? { ...ib[e] }
                          : { name: e }
                        : (function (e, t) {
                            const n = { ...t };
                            for (const o in e) Object.prototype.hasOwnProperty.call(t, o) || (n[o] = e[o]);
                            return n;
                          })(ib[e.name], e);
                    'string' == typeof e.icon && (e.icon = rb[e.icon] || e.icon);
                    return e;
                  })(e)
                )
                .filter((t) =>
                  (function (e, { isBlockPluginLoaded: t, isInlinePluginLoaded: n }) {
                    const { modelElements: o, name: i } = e;
                    if (!(o && o.length && i)) return ab({ style: e }), !1;
                    {
                      const i = [t ? 'imageBlock' : null, n ? 'imageInline' : null];
                      if (!o.some((e) => i.includes(e)))
                        return (
                          c('image-style-missing-dependency', {
                            style: e,
                            missingPlugins: o.map((e) => ('imageBlock' === e ? 'ImageBlockEditing' : 'ImageInlineEditing')),
                          }),
                          !1
                        );
                    }
                    return !0;
                  })(t, e)
                );
            },
            getDefaultStylesConfiguration: function (e, t) {
              return e && t
                ? { options: ['inline', 'alignLeft', 'alignRight', 'alignCenter', 'alignBlockLeft', 'alignBlockRight', 'block', 'side'] }
                : e
                ? { options: ['block', 'side'] }
                : t
                ? { options: ['inline', 'alignLeft', 'alignRight'] }
                : {};
            },
            getDefaultDropdownDefinitions: function (e) {
              return e.has('ImageBlockEditing') && e.has('ImageInlineEditing') ? [...sb] : [];
            },
            warnInvalidStyle: ab,
            DEFAULT_OPTIONS: ib,
            DEFAULT_ICONS: rb,
            DEFAULT_DROPDOWN_DEFINITIONS: sb,
          };
          function cb(e, t) {
            for (const n of t) if (n.name === e) return n;
          }
          class db extends V {
            static get pluginName() {
              return 'ImageStyleEditing';
            }
            static get requires() {
              return [yk];
            }
            init() {
              const { normalizeStyles: e, getDefaultStylesConfiguration: t } = lb,
                n = this.editor,
                o = n.plugins.has('ImageBlockEditing'),
                i = n.plugins.has('ImageInlineEditing');
              n.config.define('image.styles', t(o, i)),
                (this.normalizedStyles = e({
                  configuredStyles: n.config.get('image.styles'),
                  isBlockPluginLoaded: o,
                  isInlinePluginLoaded: i,
                })),
                this._setupConversion(o, i),
                this._setupPostFixer(),
                n.commands.add('imageStyle', new Qk(n, this.normalizedStyles));
            }
            _setupConversion(e, t) {
              const n = this.editor,
                o = n.model.schema,
                i =
                  ((r = this.normalizedStyles),
                  (e, t, n) => {
                    if (!n.consumable.consume(t.item, e.name)) return;
                    const o = cb(t.attributeNewValue, r),
                      i = cb(t.attributeOldValue, r),
                      s = n.mapper.toViewElement(t.item),
                      a = n.writer;
                    i && a.removeClass(i.className, s), o && a.addClass(o.className, s);
                  });
              var r;
              const s = (function (e) {
                const t = {
                  imageInline: e.filter((e) => !e.isDefault && e.modelElements.includes('imageInline')),
                  imageBlock: e.filter((e) => !e.isDefault && e.modelElements.includes('imageBlock')),
                };
                return (e, n, o) => {
                  if (!n.modelRange) return;
                  const i = n.viewItem,
                    r = Ca(n.modelRange.getItems());
                  if (r && o.schema.checkAttribute(r, 'imageStyle'))
                    for (const e of t[r.name])
                      o.consumable.consume(i, { classes: e.className }) && o.writer.setAttribute('imageStyle', e.name, r);
                };
              })(this.normalizedStyles);
              n.editing.downcastDispatcher.on('attribute:imageStyle', i),
                n.data.downcastDispatcher.on('attribute:imageStyle', i),
                e &&
                  (o.extend('imageBlock', { allowAttributes: 'imageStyle' }),
                  n.data.upcastDispatcher.on('element:figure', s, { priority: 'low' })),
                t &&
                  (o.extend('imageInline', { allowAttributes: 'imageStyle' }),
                  n.data.upcastDispatcher.on('element:img', s, { priority: 'low' }));
            }
            _setupPostFixer() {
              const e = this.editor,
                t = e.model.document,
                n = e.plugins.get(yk),
                o = new Map(this.normalizedStyles.map((e) => [e.name, e]));
              t.registerPostFixer((e) => {
                let i = !1;
                for (const r of t.differ.getChanges())
                  if ('insert' == r.type || ('attribute' == r.type && 'imageStyle' == r.attributeKey)) {
                    let t = 'insert' == r.type ? r.position.nodeAfter : r.range.start.nodeAfter;
                    if ((t && t.is('element', 'paragraph') && t.childCount > 0 && (t = t.getChild(0)), !n.isImage(t))) continue;
                    const s = t.getAttribute('imageStyle');
                    if (!s) continue;
                    const a = o.get(s);
                    (a && a.modelElements.includes(t.name)) || (e.removeAttribute('imageStyle', t), (i = !0));
                  }
                return i;
              });
            }
          }
          var ub = n(4622),
            hb = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(ub.Z, hb);
          ub.Z.locals;
          class mb extends V {
            static get requires() {
              return [db];
            }
            static get pluginName() {
              return 'ImageStyleUI';
            }
            get localizedDefaultStylesTitles() {
              const e = this.editor.t;
              return {
                'Wrap text': e('Wrap text'),
                'Break text': e('Break text'),
                'In line': e('In line'),
                'Full size image': e('Full size image'),
                'Side image': e('Side image'),
                'Left aligned image': e('Left aligned image'),
                'Centered image': e('Centered image'),
                'Right aligned image': e('Right aligned image'),
              };
            }
            init() {
              const e = this.editor.plugins,
                t = this.editor.config.get('image.toolbar') || [],
                n = gb(e.get('ImageStyleEditing').normalizedStyles, this.localizedDefaultStylesTitles);
              for (const e of n) this._createButton(e);
              const o = gb([...t.filter(E), ...lb.getDefaultDropdownDefinitions(e)], this.localizedDefaultStylesTitles);
              for (const e of o) this._createDropdown(e, n);
            }
            _createDropdown(e, t) {
              const n = this.editor.ui.componentFactory;
              n.add(e.name, (o) => {
                let i;
                const { defaultItem: r, items: s, title: a } = e,
                  l = s
                    .filter((e) => t.find(({ name: t }) => pb(t) === e))
                    .map((e) => {
                      const t = n.create(e);
                      return e === r && (i = t), t;
                    });
                s.length !== l.length && lb.warnInvalidStyle({ dropdown: e });
                const c = yh(o, Qu),
                  d = c.buttonView,
                  u = d.arrowView;
                return (
                  Ah(c, l, { enableActiveItemFocusOnDropdownOpen: !0 }),
                  d.set({ label: fb(a, i.label), class: null, tooltip: !0 }),
                  u.unbind('label'),
                  u.set({ label: a }),
                  d.bind('icon').toMany(l, 'isOn', (...e) => {
                    const t = e.findIndex(gi);
                    return t < 0 ? i.icon : l[t].icon;
                  }),
                  d.bind('label').toMany(l, 'isOn', (...e) => {
                    const t = e.findIndex(gi);
                    return fb(a, t < 0 ? i.label : l[t].label);
                  }),
                  d.bind('isOn').toMany(l, 'isOn', (...e) => e.some(gi)),
                  d.bind('class').toMany(l, 'isOn', (...e) => (e.some(gi) ? 'ck-splitbutton_flatten' : null)),
                  d.on('execute', () => {
                    l.some(({ isOn: e }) => e) ? (c.isOpen = !c.isOpen) : i.fire('execute');
                  }),
                  c.bind('isEnabled').toMany(l, 'isEnabled', (...e) => e.some(gi)),
                  this.listenTo(c, 'execute', () => {
                    this.editor.editing.view.focus();
                  }),
                  c
                );
              });
            }
            _createButton(e) {
              const t = e.name;
              this.editor.ui.componentFactory.add(pb(t), (n) => {
                const o = this.editor.commands.get('imageStyle'),
                  i = new zu(n);
                return (
                  i.set({ label: e.title, icon: e.icon, tooltip: !0, isToggleable: !0 }),
                  i.bind('isEnabled').to(o, 'isEnabled'),
                  i.bind('isOn').to(o, 'value', (e) => e === t),
                  i.on('execute', this._executeCommand.bind(this, t)),
                  i
                );
              });
            }
            _executeCommand(e) {
              this.editor.execute('imageStyle', { value: e }), this.editor.editing.view.focus();
            }
          }
          function gb(e, t) {
            for (const n of e) t[n.title] && (n.title = t[n.title]);
            return e;
          }
          function pb(e) {
            return `imageStyle:${e}`;
          }
          function fb(e, t) {
            return (e ? e + ': ' : '') + t;
          }
          class kb {
            constructor() {
              const e = new window.FileReader();
              (this._reader = e),
                (this._data = void 0),
                this.set('loaded', 0),
                (e.onprogress = (e) => {
                  this.loaded = e.loaded;
                });
            }
            get error() {
              return this._reader.error;
            }
            get data() {
              return this._data;
            }
            read(e) {
              const t = this._reader;
              return (
                (this.total = e.size),
                new Promise((n, o) => {
                  (t.onload = () => {
                    const e = t.result;
                    (this._data = e), n(e);
                  }),
                    (t.onerror = () => {
                      o('error');
                    }),
                    (t.onabort = () => {
                      o('aborted');
                    }),
                    this._reader.readAsDataURL(e);
                })
              );
            }
            abort() {
              this._reader.abort();
            }
          }
          R(kb, B);
          class bb extends V {
            static get pluginName() {
              return 'FileRepository';
            }
            static get requires() {
              return [yu];
            }
            init() {
              (this.loaders = new fo()),
                this.loaders.on('add', () => this._updatePendingAction()),
                this.loaders.on('remove', () => this._updatePendingAction()),
                (this._loadersMap = new Map()),
                (this._pendingAction = null),
                this.set('uploaded', 0),
                this.set('uploadTotal', null),
                this.bind('uploadedPercent').to(this, 'uploaded', this, 'uploadTotal', (e, t) => (t ? (e / t) * 100 : 0));
            }
            getLoader(e) {
              return this._loadersMap.get(e) || null;
            }
            createLoader(e) {
              if (!this.createUploadAdapter) return c('filerepository-no-upload-adapter'), null;
              const t = new wb(Promise.resolve(e), this.createUploadAdapter);
              return (
                this.loaders.add(t),
                this._loadersMap.set(e, t),
                e instanceof Promise &&
                  t.file
                    .then((e) => {
                      this._loadersMap.set(e, t);
                    })
                    .catch(() => {}),
                t.on('change:uploaded', () => {
                  let e = 0;
                  for (const t of this.loaders) e += t.uploaded;
                  this.uploaded = e;
                }),
                t.on('change:uploadTotal', () => {
                  let e = 0;
                  for (const t of this.loaders) t.uploadTotal && (e += t.uploadTotal);
                  this.uploadTotal = e;
                }),
                t
              );
            }
            destroyLoader(e) {
              const t = e instanceof wb ? e : this.getLoader(e);
              t._destroy(),
                this.loaders.remove(t),
                this._loadersMap.forEach((e, n) => {
                  e === t && this._loadersMap.delete(n);
                });
            }
            _updatePendingAction() {
              const e = this.editor.plugins.get(yu);
              if (this.loaders.length) {
                if (!this._pendingAction) {
                  const t = this.editor.t,
                    n = (e) => `${t('Upload in progress')} ${parseInt(e)}%.`;
                  (this._pendingAction = e.add(n(this.uploadedPercent))),
                    this._pendingAction.bind('message').to(this, 'uploadedPercent', n);
                }
              } else e.remove(this._pendingAction), (this._pendingAction = null);
            }
          }
          R(bb, B);
          class wb {
            constructor(e, t) {
              (this.id = r()),
                (this._filePromiseWrapper = this._createFilePromiseWrapper(e)),
                (this._adapter = t(this)),
                (this._reader = new kb()),
                this.set('status', 'idle'),
                this.set('uploaded', 0),
                this.set('uploadTotal', null),
                this.bind('uploadedPercent').to(this, 'uploaded', this, 'uploadTotal', (e, t) => (t ? (e / t) * 100 : 0)),
                this.set('uploadResponse', null);
            }
            get file() {
              return this._filePromiseWrapper
                ? this._filePromiseWrapper.promise.then((e) => (this._filePromiseWrapper ? e : null))
                : Promise.resolve(null);
            }
            get data() {
              return this._reader.data;
            }
            read() {
              if ('idle' != this.status) throw new l('filerepository-read-wrong-status', this);
              return (
                (this.status = 'reading'),
                this.file
                  .then((e) => this._reader.read(e))
                  .then((e) => {
                    if ('reading' !== this.status) throw this.status;
                    return (this.status = 'idle'), e;
                  })
                  .catch((e) => {
                    if ('aborted' === e) throw ((this.status = 'aborted'), 'aborted');
                    throw ((this.status = 'error'), this._reader.error ? this._reader.error : e);
                  })
              );
            }
            upload() {
              if ('idle' != this.status) throw new l('filerepository-upload-wrong-status', this);
              return (
                (this.status = 'uploading'),
                this.file
                  .then(() => this._adapter.upload())
                  .then((e) => ((this.uploadResponse = e), (this.status = 'idle'), e))
                  .catch((e) => {
                    if ('aborted' === this.status) throw 'aborted';
                    throw ((this.status = 'error'), e);
                  })
              );
            }
            abort() {
              const e = this.status;
              (this.status = 'aborted'),
                this._filePromiseWrapper.isFulfilled
                  ? 'reading' == e
                    ? this._reader.abort()
                    : 'uploading' == e && this._adapter.abort && this._adapter.abort()
                  : (this._filePromiseWrapper.promise.catch(() => {}), this._filePromiseWrapper.rejecter('aborted')),
                this._destroy();
            }
            _destroy() {
              (this._filePromiseWrapper = void 0), (this._reader = void 0), (this._adapter = void 0), (this.uploadResponse = void 0);
            }
            _createFilePromiseWrapper(e) {
              const t = {};
              return (
                (t.promise = new Promise((n, o) => {
                  (t.rejecter = o),
                    (t.isFulfilled = !1),
                    e
                      .then((e) => {
                        (t.isFulfilled = !0), n(e);
                      })
                      .catch((e) => {
                        (t.isFulfilled = !0), o(e);
                      });
                })),
                t
              );
            }
          }
          R(wb, B);
          class _b extends Jd {
            constructor(e) {
              super(e),
                (this.buttonView = new zu(e)),
                (this._fileInputView = new yb(e)),
                this._fileInputView.bind('acceptedType').to(this),
                this._fileInputView.bind('allowMultipleFiles').to(this),
                this._fileInputView.delegate('done').to(this),
                this.setTemplate({
                  tag: 'span',
                  attributes: { class: 'ck-file-dialog-button' },
                  children: [this.buttonView, this._fileInputView],
                }),
                this.buttonView.on('execute', () => {
                  this._fileInputView.open();
                });
            }
            focus() {
              this.buttonView.focus();
            }
          }
          class yb extends Jd {
            constructor(e) {
              super(e), this.set('acceptedType'), this.set('allowMultipleFiles', !1);
              const t = this.bindTemplate;
              this.setTemplate({
                tag: 'input',
                attributes: {
                  class: ['ck-hidden'],
                  type: 'file',
                  tabindex: '-1',
                  accept: t.to('acceptedType'),
                  multiple: t.to('allowMultipleFiles'),
                },
                on: {
                  change: t.to(() => {
                    this.element && this.element.files && this.element.files.length && this.fire('done', this.element.files),
                      (this.element.value = '');
                  }),
                },
              });
            }
            open() {
              this.element.click();
            }
          }
          function Ab(e) {
            const t = e.map((e) => e.replace('+', '\\+'));
            return new RegExp(`^image\\/(${t.join('|')})$`);
          }
          function Cb(e) {
            return new Promise((t, n) => {
              const o = e.getAttribute('src');
              fetch(o)
                .then((e) => e.blob())
                .then((e) => {
                  const n = vb(e, o),
                    i = n.replace('image/', ''),
                    r = new File([e], `image.${i}`, { type: n });
                  t(r);
                })
                .catch((e) =>
                  e && 'TypeError' === e.name
                    ? (function (e) {
                        return (function (e) {
                          return new Promise((t, n) => {
                            const o = _o.document.createElement('img');
                            o.addEventListener('load', () => {
                              const e = _o.document.createElement('canvas');
                              (e.width = o.width), (e.height = o.height);
                              e.getContext('2d').drawImage(o, 0, 0), e.toBlob((e) => (e ? t(e) : n()));
                            }),
                              o.addEventListener('error', () => n()),
                              (o.src = e);
                          });
                        })(e).then((t) => {
                          const n = vb(t, e),
                            o = n.replace('image/', '');
                          return new File([t], `image.${o}`, { type: n });
                        });
                      })(o)
                        .then(t)
                        .catch(n)
                    : n(e)
                );
            });
          }
          function vb(e, t) {
            return e.type
              ? e.type
              : t.match(/data:(image\/\w+);base64/)
              ? t.match(/data:(image\/\w+);base64/)[1].toLowerCase()
              : 'image/jpeg';
          }
          class xb extends V {
            static get pluginName() {
              return 'ImageUploadUI';
            }
            init() {
              const e = this.editor,
                t = e.t,
                n = (n) => {
                  const o = new _b(n),
                    i = e.commands.get('uploadImage'),
                    r = e.config.get('image.upload.types'),
                    s = Ab(r);
                  return (
                    o.set({ acceptedType: r.map((e) => `image/${e}`).join(','), allowMultipleFiles: !0 }),
                    o.buttonView.set({ label: t('Insert image'), icon: Cu.image, tooltip: !0 }),
                    o.buttonView.bind('isEnabled').to(i),
                    o.on('done', (t, n) => {
                      const o = Array.from(n).filter((e) => s.test(e.type));
                      o.length && (e.execute('uploadImage', { file: o }), e.editing.view.focus());
                    }),
                    o
                  );
                };
              e.ui.componentFactory.add('uploadImage', n), e.ui.componentFactory.add('imageUpload', n);
            }
          }
          var Eb = n(5870),
            Db = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Eb.Z, Db);
          Eb.Z.locals;
          var Tb = n(9899),
            Ib = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Tb.Z, Ib);
          Tb.Z.locals;
          var Sb = n(9825),
            Mb = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Sb.Z, Mb);
          Sb.Z.locals;
          class Bb extends V {
            static get pluginName() {
              return 'ImageUploadProgress';
            }
            constructor(e) {
              super(e), (this.placeholder = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==');
            }
            init() {
              const e = this.editor;
              e.plugins.has('ImageBlockEditing') &&
                e.editing.downcastDispatcher.on('attribute:uploadStatus:imageBlock', (...e) => this.uploadStatusChange(...e)),
                e.plugins.has('ImageInlineEditing') &&
                  e.editing.downcastDispatcher.on('attribute:uploadStatus:imageInline', (...e) => this.uploadStatusChange(...e));
            }
            uploadStatusChange(e, t, n) {
              const o = this.editor,
                i = t.item,
                r = i.getAttribute('uploadId');
              if (!n.consumable.consume(t.item, e.name)) return;
              const s = o.plugins.get('ImageUtils'),
                a = o.plugins.get(bb),
                l = r ? t.attributeNewValue : null,
                c = this.placeholder,
                d = o.editing.mapper.toViewElement(i),
                u = n.writer;
              if ('reading' == l) return Nb(d, u), void Pb(s, c, d, u);
              if ('uploading' == l) {
                const e = a.loaders.get(r);
                return (
                  Nb(d, u),
                  void (e
                    ? (zb(d, u),
                      (function (e, t, n, o) {
                        const i = (function (e) {
                          const t = e.createUIElement('div', { class: 'ck-progress-bar' });
                          return e.setCustomProperty('progressBar', !0, t), t;
                        })(t);
                        t.insert(t.createPositionAt(e, 'end'), i),
                          n.on('change:uploadedPercent', (e, t, n) => {
                            o.change((e) => {
                              e.setStyle('width', n + '%', i);
                            });
                          });
                      })(d, u, e, o.editing.view),
                      (function (e, t, n, o) {
                        if (o.data) {
                          const i = e.findViewImgElement(t);
                          n.setAttribute('src', o.data, i);
                        }
                      })(s, d, u, e))
                    : Pb(s, c, d, u))
                );
              }
              'complete' == l &&
                a.loaders.get(r) &&
                (function (e, t, n) {
                  const o = t.createUIElement('div', { class: 'ck-image-upload-complete-icon' });
                  t.insert(t.createPositionAt(e, 'end'), o),
                    setTimeout(() => {
                      n.change((e) => e.remove(e.createRangeOn(o)));
                    }, 3e3);
                })(d, u, o.editing.view),
                (function (e, t) {
                  jb(e, t, 'progressBar');
                })(d, u),
                zb(d, u),
                (function (e, t) {
                  t.removeClass('ck-appear', e);
                })(d, u);
            }
          }
          function Nb(e, t) {
            e.hasClass('ck-appear') || t.addClass('ck-appear', e);
          }
          function Pb(e, t, n, o) {
            n.hasClass('ck-image-upload-placeholder') || o.addClass('ck-image-upload-placeholder', n);
            const i = e.findViewImgElement(n);
            i.getAttribute('src') !== t && o.setAttribute('src', t, i),
              Lb(n, 'placeholder') ||
                o.insert(
                  o.createPositionAfter(i),
                  (function (e) {
                    const t = e.createUIElement('div', { class: 'ck-upload-placeholder-loader' });
                    return e.setCustomProperty('placeholder', !0, t), t;
                  })(o)
                );
          }
          function zb(e, t) {
            e.hasClass('ck-image-upload-placeholder') && t.removeClass('ck-image-upload-placeholder', e), jb(e, t, 'placeholder');
          }
          function Lb(e, t) {
            for (const n of e.getChildren()) if (n.getCustomProperty(t)) return n;
          }
          function jb(e, t, n) {
            const o = Lb(e, n);
            o && t.remove(t.createRangeOn(o));
          }
          class Ob extends H {
            refresh() {
              const e = this.editor,
                t = e.plugins.get('ImageUtils'),
                n = e.model.document.selection.getSelectedElement();
              this.isEnabled = t.isImageAllowed() || t.isImage(n);
            }
            execute(e) {
              const t = bo(e.file),
                n = this.editor.model.document.selection,
                o = this.editor.plugins.get('ImageUtils'),
                i = Object.fromEntries(n.getAttributes());
              t.forEach((e, t) => {
                const r = n.getSelectedElement();
                if (t && r && o.isImage(r)) {
                  const t = this.editor.model.createPositionAfter(r);
                  this._uploadImage(e, i, t);
                } else this._uploadImage(e, i);
              });
            }
            _uploadImage(e, t, n) {
              const o = this.editor,
                i = o.plugins.get(bb).createLoader(e),
                r = o.plugins.get('ImageUtils');
              i && r.insertImage({ ...t, uploadId: i.id }, n);
            }
          }
          class Rb extends V {
            static get requires() {
              return [bb, Gh, Gp, yk];
            }
            static get pluginName() {
              return 'ImageUploadEditing';
            }
            constructor(e) {
              super(e),
                e.config.define('image', { upload: { types: ['jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff'] } }),
                (this._uploadImageElements = new Map());
            }
            init() {
              const e = this.editor,
                t = e.model.document,
                n = e.conversion,
                o = e.plugins.get(bb),
                i = e.plugins.get('ImageUtils'),
                r = Ab(e.config.get('image.upload.types')),
                s = new Ob(e);
              e.commands.add('uploadImage', s),
                e.commands.add('imageUpload', s),
                n.for('upcast').attributeToAttribute({ view: { name: 'img', key: 'uploadId' }, model: 'uploadId' }),
                this.listenTo(e.editing.view.document, 'clipboardInput', (t, n) => {
                  if (((o = n.dataTransfer), Array.from(o.types).includes('text/html') && '' !== o.getData('text/html'))) return;
                  var o;
                  const i = Array.from(n.dataTransfer.files).filter((e) => !!e && r.test(e.type));
                  i.length &&
                    (t.stop(),
                    e.model.change((t) => {
                      n.targetRanges && t.setSelection(n.targetRanges.map((t) => e.editing.mapper.toModelRange(t))),
                        e.model.enqueueChange(() => {
                          e.execute('uploadImage', { file: i });
                        });
                    }));
                }),
                this.listenTo(e.plugins.get('ClipboardPipeline'), 'inputTransformation', (t, n) => {
                  const r = Array.from(e.editing.view.createRangeIn(n.content))
                    .filter(
                      (e) =>
                        (function (e, t) {
                          return (
                            !(!e.isInlineImageView(t) || !t.getAttribute('src')) &&
                            (t.getAttribute('src').match(/^data:image\/\w+;base64,/g) || t.getAttribute('src').match(/^blob:/g))
                          );
                        })(i, e.item) && !e.item.getAttribute('uploadProcessed')
                    )
                    .map((e) => ({ promise: Cb(e.item), imageElement: e.item }));
                  if (!r.length) return;
                  const s = new Im(e.editing.view.document);
                  for (const e of r) {
                    s.setAttribute('uploadProcessed', !0, e.imageElement);
                    const t = o.createLoader(e.promise);
                    t && (s.setAttribute('src', '', e.imageElement), s.setAttribute('uploadId', t.id, e.imageElement));
                  }
                }),
                e.editing.view.document.on('dragover', (e, t) => {
                  t.preventDefault();
                }),
                t.on('change', () => {
                  const n = t.differ.getChanges({ includeChangesInGraveyard: !0 }).reverse(),
                    i = new Set();
                  for (const t of n)
                    if ('insert' == t.type && '$text' != t.name) {
                      const n = t.position.nodeAfter,
                        r = '$graveyard' == t.position.root.rootName;
                      for (const t of Vb(e, n)) {
                        const e = t.getAttribute('uploadId');
                        if (!e) continue;
                        const n = o.loaders.get(e);
                        n &&
                          (r
                            ? i.has(e) || n.abort()
                            : (i.add(e), this._uploadImageElements.set(e, t), 'idle' == n.status && this._readAndUpload(n)));
                      }
                    }
                }),
                this.on(
                  'uploadComplete',
                  (e, { imageElement: t, data: n }) => {
                    const o = n.urls ? n.urls : n;
                    this.editor.model.change((e) => {
                      e.setAttribute('src', o.default, t), this._parseAndSetSrcsetAttributeOnImage(o, t, e);
                    });
                  },
                  { priority: 'low' }
                );
            }
            afterInit() {
              const e = this.editor.model.schema;
              this.editor.plugins.has('ImageBlockEditing') && e.extend('imageBlock', { allowAttributes: ['uploadId', 'uploadStatus'] }),
                this.editor.plugins.has('ImageInlineEditing') && e.extend('imageInline', { allowAttributes: ['uploadId', 'uploadStatus'] });
            }
            _readAndUpload(e) {
              const t = this.editor,
                n = t.model,
                o = t.locale.t,
                i = t.plugins.get(bb),
                r = t.plugins.get(Gh),
                s = t.plugins.get('ImageUtils'),
                a = this._uploadImageElements;
              return (
                n.enqueueChange({ isUndoable: !1 }, (t) => {
                  t.setAttribute('uploadStatus', 'reading', a.get(e.id));
                }),
                e
                  .read()
                  .then(() => {
                    const o = e.upload(),
                      i = a.get(e.id);
                    if (lr.isSafari) {
                      const e = t.editing.mapper.toViewElement(i),
                        n = s.findViewImgElement(e);
                      t.editing.view.once('render', () => {
                        if (!n.parent) return;
                        const e = t.editing.view.domConverter.mapViewToDom(n.parent);
                        if (!e) return;
                        const o = e.style.display;
                        (e.style.display = 'none'), (e._ckHack = e.offsetHeight), (e.style.display = o);
                      });
                    }
                    return (
                      n.enqueueChange({ isUndoable: !1 }, (e) => {
                        e.setAttribute('uploadStatus', 'uploading', i);
                      }),
                      o
                    );
                  })
                  .then((t) => {
                    n.enqueueChange({ isUndoable: !1 }, (n) => {
                      const o = a.get(e.id);
                      n.setAttribute('uploadStatus', 'complete', o), this.fire('uploadComplete', { data: t, imageElement: o });
                    }),
                      l();
                  })
                  .catch((t) => {
                    if ('error' !== e.status && 'aborted' !== e.status) throw t;
                    'error' == e.status && t && r.showWarning(t, { title: o('Upload failed'), namespace: 'upload' }),
                      n.enqueueChange({ isUndoable: !1 }, (t) => {
                        t.remove(a.get(e.id));
                      }),
                      l();
                  })
              );
              function l() {
                n.enqueueChange({ isUndoable: !1 }, (t) => {
                  const n = a.get(e.id);
                  t.removeAttribute('uploadId', n), t.removeAttribute('uploadStatus', n), a.delete(e.id);
                }),
                  i.destroyLoader(e);
              }
            }
            _parseAndSetSrcsetAttributeOnImage(e, t, n) {
              let o = 0;
              const i = Object.keys(e)
                .filter((e) => {
                  const t = parseInt(e, 10);
                  if (!isNaN(t)) return (o = Math.max(o, t)), !0;
                })
                .map((t) => `${e[t]} ${t}w`)
                .join(', ');
              '' != i && n.setAttribute('srcset', { data: i, width: o }, t);
            }
          }
          function Vb(e, t) {
            const n = e.plugins.get('ImageUtils');
            return Array.from(e.model.createRangeOn(t))
              .filter((e) => n.isImage(e.item))
              .map((e) => e.item);
          }
          class Fb extends V {
            static get pluginName() {
              return 'IndentEditing';
            }
            init() {
              const e = this.editor;
              e.commands.add('indent', new q(e)), e.commands.add('outdent', new q(e));
            }
          }
          const Hb =
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zM1.632 6.95 5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z"/></svg>',
            Ub =
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zm1.618-9.55L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z"/></svg>';
          class qb extends V {
            static get pluginName() {
              return 'IndentUI';
            }
            init() {
              const e = this.editor,
                t = e.locale,
                n = e.t,
                o = 'ltr' == t.uiLanguageDirection ? Hb : Ub,
                i = 'ltr' == t.uiLanguageDirection ? Ub : Hb;
              this._defineButton('indent', n('Increase indent'), o), this._defineButton('outdent', n('Decrease indent'), i);
            }
            _defineButton(e, t, n) {
              const o = this.editor;
              o.ui.componentFactory.add(e, (i) => {
                const r = o.commands.get(e),
                  s = new zu(i);
                return (
                  s.set({ label: t, icon: n, tooltip: !0 }),
                  s.bind('isOn', 'isEnabled').to(r, 'value', 'isEnabled'),
                  this.listenTo(s, 'execute', () => {
                    o.execute(e), o.editing.view.focus();
                  }),
                  s
                );
              });
            }
          }
          class Wb extends H {
            constructor(e, t) {
              super(e), (this._indentBehavior = t);
            }
            refresh() {
              const e = this.editor.model,
                t = Ca(e.document.selection.getSelectedBlocks());
              t && e.schema.checkAttribute(t, 'blockIndent')
                ? (this.isEnabled = this._indentBehavior.checkEnabled(t.getAttribute('blockIndent')))
                : (this.isEnabled = !1);
            }
            execute() {
              const e = this.editor.model,
                t = (function (e) {
                  const t = e.document.selection,
                    n = e.schema;
                  return Array.from(t.getSelectedBlocks()).filter((e) => n.checkAttribute(e, 'blockIndent'));
                })(e);
              e.change((e) => {
                for (const n of t) {
                  const t = n.getAttribute('blockIndent'),
                    o = this._indentBehavior.getNextIndent(t);
                  o ? e.setAttribute('blockIndent', o, n) : e.removeAttribute('blockIndent', n);
                }
              });
            }
          }
          class Gb {
            constructor(e) {
              (this.isForward = 'forward' === e.direction), (this.offset = e.offset), (this.unit = e.unit);
            }
            checkEnabled(e) {
              const t = parseFloat(e || 0);
              return this.isForward || t > 0;
            }
            getNextIndent(e) {
              const t = parseFloat(e || 0);
              if (!(!e || e.endsWith(this.unit))) return this.isForward ? this.offset + this.unit : void 0;
              const n = t + (this.isForward ? this.offset : -this.offset);
              return n > 0 ? n + this.unit : void 0;
            }
          }
          class $b {
            constructor(e) {
              (this.isForward = 'forward' === e.direction), (this.classes = e.classes);
            }
            checkEnabled(e) {
              const t = this.classes.indexOf(e);
              return this.isForward ? t < this.classes.length - 1 : t >= 0;
            }
            getNextIndent(e) {
              const t = this.classes.indexOf(e),
                n = this.isForward ? 1 : -1;
              return this.classes[t + n];
            }
          }
          const Yb = ['paragraph', 'heading1', 'heading2', 'heading3', 'heading4', 'heading5', 'heading6'];
          const Kb = 'italic';
          class Qb extends V {
            static get pluginName() {
              return 'ItalicEditing';
            }
            init() {
              const e = this.editor;
              e.model.schema.extend('$text', { allowAttributes: Kb }),
                e.model.schema.setAttributeProperties(Kb, { isFormatting: !0, copyOnEnter: !0 }),
                e.conversion.attributeToElement({ model: Kb, view: 'i', upcastAlso: ['em', { styles: { 'font-style': 'italic' } }] }),
                e.commands.add(Kb, new Ip(e, Kb)),
                e.keystrokes.set('CTRL+I', Kb);
            }
          }
          const Zb = 'italic';
          class Jb extends V {
            static get pluginName() {
              return 'ItalicUI';
            }
            init() {
              const e = this.editor,
                t = e.t;
              e.ui.componentFactory.add(Zb, (n) => {
                const o = e.commands.get(Zb),
                  i = new zu(n);
                return (
                  i.set({
                    label: t('Italic'),
                    icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.586 14.633.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>',
                    keystroke: 'CTRL+I',
                    tooltip: !0,
                    isToggleable: !0,
                  }),
                  i.bind('isOn', 'isEnabled').to(o, 'value', 'isEnabled'),
                  this.listenTo(i, 'execute', () => {
                    e.execute(Zb), e.editing.view.focus();
                  }),
                  i
                );
              });
            }
          }
          class Xb {
            constructor() {
              this._definitions = new Set();
            }
            get length() {
              return this._definitions.size;
            }
            add(e) {
              Array.isArray(e) ? e.forEach((e) => this._definitions.add(e)) : this._definitions.add(e);
            }
            getDispatcher() {
              return (e) => {
                e.on(
                  'attribute:linkHref',
                  (e, t, n) => {
                    if (!n.consumable.test(t.item, 'attribute:linkHref')) return;
                    if (!t.item.is('selection') && !n.schema.isInline(t.item)) return;
                    const o = n.writer,
                      i = o.document.selection;
                    for (const e of this._definitions) {
                      const r = o.createAttributeElement('a', e.attributes, { priority: 5 });
                      e.classes && o.addClass(e.classes, r);
                      for (const t in e.styles) o.setStyle(t, e.styles[t], r);
                      o.setCustomProperty('link', !0, r),
                        e.callback(t.attributeNewValue)
                          ? t.item.is('selection')
                            ? o.wrap(i.getFirstRange(), r)
                            : o.wrap(n.mapper.toViewRange(t.range), r)
                          : o.unwrap(n.mapper.toViewRange(t.range), r);
                    }
                  },
                  { priority: 'high' }
                );
              };
            }
            getDispatcherForLinkedImage() {
              return (e) => {
                e.on('attribute:linkHref:imageBlock', (e, t, { writer: n, mapper: o }) => {
                  const i = o.toViewElement(t.item),
                    r = Array.from(i.getChildren()).find((e) => 'a' === e.name);
                  for (const e of this._definitions) {
                    const o = No(e.attributes);
                    if (e.callback(t.attributeNewValue)) {
                      for (const [e, t] of o) 'class' === e ? n.addClass(t, r) : n.setAttribute(e, t, r);
                      e.classes && n.addClass(e.classes, r);
                      for (const t in e.styles) n.setStyle(t, e.styles[t], r);
                    } else {
                      for (const [e, t] of o) 'class' === e ? n.removeClass(t, r) : n.removeAttribute(e, r);
                      e.classes && n.removeClass(e.classes, r);
                      for (const t in e.styles) n.removeStyle(t, r);
                    }
                  }
                });
              };
            }
          }
          const ew = function (e, t, n) {
            var o = e.length;
            return (n = void 0 === n ? o : n), !t && n >= o ? e : ni(e, t, n);
          };
          var tw = RegExp('[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]');
          const nw = function (e) {
            return tw.test(e);
          };
          const ow = function (e) {
            return e.split('');
          };
          var iw = '[\\ud800-\\udfff]',
            rw = '[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]',
            sw = '\\ud83c[\\udffb-\\udfff]',
            aw = '[^\\ud800-\\udfff]',
            lw = '(?:\\ud83c[\\udde6-\\uddff]){2}',
            cw = '[\\ud800-\\udbff][\\udc00-\\udfff]',
            dw = '(?:' + rw + '|' + sw + ')' + '?',
            uw = '[\\ufe0e\\ufe0f]?',
            hw = uw + dw + ('(?:\\u200d(?:' + [aw, lw, cw].join('|') + ')' + uw + dw + ')*'),
            mw = '(?:' + [aw + rw + '?', rw, lw, cw, iw].join('|') + ')',
            gw = RegExp(sw + '(?=' + sw + ')|' + mw + hw, 'g');
          const pw = function (e) {
            return e.match(gw) || [];
          };
          const fw = function (e) {
            return nw(e) ? pw(e) : ow(e);
          };
          const kw = (function (e) {
              return function (t) {
                t = Zo(t);
                var n = nw(t) ? fw(t) : void 0,
                  o = n ? n[0] : t.charAt(0),
                  i = n ? ew(n, 1).join('') : t.slice(1);
                return o[e]() + i;
              };
            })('toUpperCase'),
            bw = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g,
            ww = /^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i,
            _w = /^[\S]+@((?![-_])(?:[-\w\u00a1-\uffff]{0,63}[^-_]\.))+(?:[a-z\u00a1-\uffff]{2,})$/i,
            yw = /^((\w+:(\/{2,})?)|(\W))/i,
            Aw = 'Ctrl+K';
          function Cw(e, { writer: t }) {
            const n = t.createAttributeElement('a', { href: e }, { priority: 5 });
            return t.setCustomProperty('link', !0, n), n;
          }
          function vw(e) {
            return (function (e) {
              return e.replace(bw, '').match(ww);
            })((e = String(e)))
              ? e
              : '#';
          }
          function xw(e, t) {
            return !!e && t.checkAttribute(e.name, 'linkHref');
          }
          function Ew(e, t) {
            const n = ((o = e), _w.test(o) ? 'mailto:' : t);
            var o;
            const i = !!n && !yw.test(e);
            return e && i ? n + e : e;
          }
          function Dw(e) {
            window.open(e, '_blank', 'noopener');
          }
          class Tw extends H {
            constructor(e) {
              super(e), (this.manualDecorators = new fo()), (this.automaticDecorators = new Xb());
            }
            restoreManualDecoratorStates() {
              for (const e of this.manualDecorators) e.value = this._getDecoratorStateFromModel(e.id);
            }
            refresh() {
              const e = this.editor.model,
                t = e.document.selection,
                n = t.getSelectedElement() || Ca(t.getSelectedBlocks());
              xw(n, e.schema)
                ? ((this.value = n.getAttribute('linkHref')), (this.isEnabled = e.schema.checkAttribute(n, 'linkHref')))
                : ((this.value = t.getAttribute('linkHref')), (this.isEnabled = e.schema.checkAttributeInSelection(t, 'linkHref')));
              for (const e of this.manualDecorators) e.value = this._getDecoratorStateFromModel(e.id);
            }
            execute(e, t = {}) {
              const n = this.editor.model,
                o = n.document.selection,
                i = [],
                r = [];
              for (const e in t) t[e] ? i.push(e) : r.push(e);
              n.change((t) => {
                if (o.isCollapsed) {
                  const s = o.getFirstPosition();
                  if (o.hasAttribute('linkHref')) {
                    const a = sp(s, 'linkHref', o.getAttribute('linkHref'), n);
                    t.setAttribute('linkHref', e, a),
                      i.forEach((e) => {
                        t.setAttribute(e, !0, a);
                      }),
                      r.forEach((e) => {
                        t.removeAttribute(e, a);
                      }),
                      t.setSelection(t.createPositionAfter(a.end.nodeBefore));
                  } else if ('' !== e) {
                    const r = No(o.getAttributes());
                    r.set('linkHref', e),
                      i.forEach((e) => {
                        r.set(e, !0);
                      });
                    const { end: a } = n.insertContent(t.createText(e, r), s);
                    t.setSelection(a);
                  }
                  ['linkHref', ...i, ...r].forEach((e) => {
                    t.removeSelectionAttribute(e);
                  });
                } else {
                  const s = n.schema.getValidRanges(o.getRanges(), 'linkHref'),
                    a = [];
                  for (const e of o.getSelectedBlocks()) n.schema.checkAttribute(e, 'linkHref') && a.push(t.createRangeOn(e));
                  const l = a.slice();
                  for (const e of s) this._isRangeToUpdate(e, a) && l.push(e);
                  for (const n of l)
                    t.setAttribute('linkHref', e, n),
                      i.forEach((e) => {
                        t.setAttribute(e, !0, n);
                      }),
                      r.forEach((e) => {
                        t.removeAttribute(e, n);
                      });
                }
              });
            }
            _getDecoratorStateFromModel(e) {
              const t = this.editor.model,
                n = t.document.selection,
                o = n.getSelectedElement();
              return xw(o, t.schema) ? o.getAttribute(e) : n.getAttribute(e);
            }
            _isRangeToUpdate(e, t) {
              for (const n of t) if (n.containsRange(e)) return !1;
              return !0;
            }
          }
          class Iw extends H {
            refresh() {
              const e = this.editor.model,
                t = e.document.selection,
                n = t.getSelectedElement();
              xw(n, e.schema)
                ? (this.isEnabled = e.schema.checkAttribute(n, 'linkHref'))
                : (this.isEnabled = e.schema.checkAttributeInSelection(t, 'linkHref'));
            }
            execute() {
              const e = this.editor,
                t = this.editor.model,
                n = t.document.selection,
                o = e.commands.get('link');
              t.change((e) => {
                const i = n.isCollapsed
                  ? [sp(n.getFirstPosition(), 'linkHref', n.getAttribute('linkHref'), t)]
                  : t.schema.getValidRanges(n.getRanges(), 'linkHref');
                for (const t of i)
                  if ((e.removeAttribute('linkHref', t), o)) for (const n of o.manualDecorators) e.removeAttribute(n.id, t);
              });
            }
          }
          class Sw {
            constructor({ id: e, label: t, attributes: n, classes: o, styles: i, defaultValue: r }) {
              (this.id = e),
                this.set('value'),
                (this.defaultValue = r),
                (this.label = t),
                (this.attributes = n),
                (this.classes = o),
                (this.styles = i);
            }
            _createPattern() {
              return { attributes: this.attributes, classes: this.classes, styles: this.styles };
            }
          }
          R(Sw, B);
          var Mw = n(399),
            Bw = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Mw.Z, Bw);
          Mw.Z.locals;
          const Nw = 'automatic',
            Pw = /^(https?:)?\/\//;
          class zw extends V {
            static get pluginName() {
              return 'LinkEditing';
            }
            static get requires() {
              return [Wg, Og, Gp];
            }
            constructor(e) {
              super(e), e.config.define('link', { addTargetToExternalLinks: !1 });
            }
            init() {
              const e = this.editor;
              e.model.schema.extend('$text', { allowAttributes: 'linkHref' }),
                e.conversion.for('dataDowncast').attributeToElement({ model: 'linkHref', view: Cw }),
                e.conversion.for('editingDowncast').attributeToElement({ model: 'linkHref', view: (e, t) => Cw(vw(e), t) }),
                e.conversion.for('upcast').elementToAttribute({
                  view: { name: 'a', attributes: { href: !0 } },
                  model: { key: 'linkHref', value: (e) => e.getAttribute('href') },
                }),
                e.commands.add('link', new Tw(e)),
                e.commands.add('unlink', new Iw(e));
              const t = (function (e, t) {
                const n = { 'Open in a new tab': e('Open in a new tab'), Downloadable: e('Downloadable') };
                return t.forEach((e) => (e.label && n[e.label] && (e.label = n[e.label]), e)), t;
              })(
                e.t,
                (function (e) {
                  const t = [];
                  if (e)
                    for (const [n, o] of Object.entries(e)) {
                      const e = Object.assign({}, o, { id: `link${kw(n)}` });
                      t.push(e);
                    }
                  return t;
                })(e.config.get('link.decorators'))
              );
              this._enableAutomaticDecorators(t.filter((e) => e.mode === Nw)),
                this._enableManualDecorators(t.filter((e) => 'manual' === e.mode));
              e.plugins.get(Wg).registerAttribute('linkHref'),
                (function (e, t, n, o) {
                  const i = e.editing.view,
                    r = new Set();
                  i.document.registerPostFixer((i) => {
                    const s = e.model.document.selection;
                    let a = !1;
                    if (s.hasAttribute(t)) {
                      const l = sp(s.getFirstPosition(), t, s.getAttribute(t), e.model),
                        c = e.editing.mapper.toViewRange(l);
                      for (const e of c.getItems()) e.is('element', n) && !e.hasClass(o) && (i.addClass(o, e), r.add(e), (a = !0));
                    }
                    return a;
                  }),
                    e.conversion.for('editingDowncast').add((e) => {
                      function t() {
                        i.change((e) => {
                          for (const t of r.values()) e.removeClass(o, t), r.delete(t);
                        });
                      }
                      e.on('insert', t, { priority: 'highest' }),
                        e.on('remove', t, { priority: 'highest' }),
                        e.on('attribute', t, { priority: 'highest' }),
                        e.on('selection', t, { priority: 'highest' });
                    });
                })(e, 'linkHref', 'a', 'ck-link_selected'),
                this._enableLinkOpen(),
                this._enableInsertContentSelectionAttributesFixer(),
                this._enableClickingAfterLink(),
                this._enableTypingOverLink(),
                this._handleDeleteContentAfterLink();
            }
            _enableAutomaticDecorators(e) {
              const t = this.editor,
                n = t.commands.get('link').automaticDecorators;
              t.config.get('link.addTargetToExternalLinks') &&
                n.add({
                  id: 'linkIsExternal',
                  mode: Nw,
                  callback: (e) => Pw.test(e),
                  attributes: { target: '_blank', rel: 'noopener noreferrer' },
                }),
                n.add(e),
                n.length && t.conversion.for('downcast').add(n.getDispatcher());
            }
            _enableManualDecorators(e) {
              if (!e.length) return;
              const t = this.editor,
                n = t.commands.get('link').manualDecorators;
              e.forEach((e) => {
                t.model.schema.extend('$text', { allowAttributes: e.id }),
                  (e = new Sw(e)),
                  n.add(e),
                  t.conversion.for('downcast').attributeToElement({
                    model: e.id,
                    view: (t, { writer: n, schema: o }, { item: i }) => {
                      if ((i.is('selection') || o.isInline(i)) && t) {
                        const t = n.createAttributeElement('a', e.attributes, { priority: 5 });
                        e.classes && n.addClass(e.classes, t);
                        for (const o in e.styles) n.setStyle(o, e.styles[o], t);
                        return n.setCustomProperty('link', !0, t), t;
                      }
                    },
                  }),
                  t.conversion.for('upcast').elementToAttribute({ view: { name: 'a', ...e._createPattern() }, model: { key: e.id } });
              });
            }
            _enableLinkOpen() {
              const e = this.editor,
                t = e.editing.view.document,
                n = e.model.document;
              this.listenTo(
                t,
                'click',
                (e, t) => {
                  if (!(lr.isMac ? t.domEvent.metaKey : t.domEvent.ctrlKey)) return;
                  let n = t.domTarget;
                  if (('a' != n.tagName.toLowerCase() && (n = n.closest('a')), !n)) return;
                  const o = n.getAttribute('href');
                  o && (e.stop(), t.preventDefault(), Dw(o));
                },
                { context: '$capture' }
              ),
                this.listenTo(
                  t,
                  'enter',
                  (e, t) => {
                    const o = n.selection,
                      i = o.getSelectedElement(),
                      r = i ? i.getAttribute('linkHref') : o.getAttribute('linkHref');
                    r && t.domEvent.altKey && (e.stop(), Dw(r));
                  },
                  { context: 'a' }
                );
            }
            _enableInsertContentSelectionAttributesFixer() {
              const e = this.editor.model,
                t = e.document.selection;
              this.listenTo(
                e,
                'insertContent',
                () => {
                  const n = t.anchor.nodeBefore,
                    o = t.anchor.nodeAfter;
                  t.hasAttribute('linkHref') &&
                    n &&
                    n.hasAttribute('linkHref') &&
                    ((o && o.hasAttribute('linkHref')) ||
                      e.change((t) => {
                        Lw(t, Ow(e.schema));
                      }));
                },
                { priority: 'low' }
              );
            }
            _enableClickingAfterLink() {
              const e = this.editor,
                t = e.model;
              e.editing.view.addObserver(Tm);
              let n = !1;
              this.listenTo(e.editing.view.document, 'mousedown', () => {
                n = !0;
              }),
                this.listenTo(e.editing.view.document, 'selectionChange', () => {
                  if (!n) return;
                  n = !1;
                  const e = t.document.selection;
                  if (!e.isCollapsed) return;
                  if (!e.hasAttribute('linkHref')) return;
                  const o = e.getFirstPosition(),
                    i = sp(o, 'linkHref', e.getAttribute('linkHref'), t);
                  (o.isTouching(i.start) || o.isTouching(i.end)) &&
                    t.change((e) => {
                      Lw(e, Ow(t.schema));
                    });
                });
            }
            _enableTypingOverLink() {
              const e = this.editor,
                t = e.editing.view;
              let n, o;
              this.listenTo(
                t.document,
                'delete',
                () => {
                  o = !0;
                },
                { priority: 'high' }
              ),
                this.listenTo(
                  e.model,
                  'deleteContent',
                  () => {
                    const t = e.model.document.selection;
                    t.isCollapsed ||
                      (o
                        ? (o = !1)
                        : jw(e) &&
                          (function (e) {
                            const t = e.document.selection,
                              n = t.getFirstPosition(),
                              o = t.getLastPosition(),
                              i = n.nodeAfter;
                            if (!i) return !1;
                            if (!i.is('$text')) return !1;
                            if (!i.hasAttribute('linkHref')) return !1;
                            const r = o.textNode || o.nodeBefore;
                            if (i === r) return !0;
                            return sp(n, 'linkHref', i.getAttribute('linkHref'), e).containsRange(e.createRange(n, o), !0);
                          })(e.model) &&
                          (n = t.getAttributes()));
                  },
                  { priority: 'high' }
                ),
                this.listenTo(
                  e.model,
                  'insertContent',
                  (t, [i]) => {
                    (o = !1),
                      jw(e) &&
                        n &&
                        (e.model.change((e) => {
                          for (const [t, o] of n) e.setAttribute(t, o, i);
                        }),
                        (n = null));
                  },
                  { priority: 'high' }
                );
            }
            _handleDeleteContentAfterLink() {
              const e = this.editor,
                t = e.model,
                n = t.document.selection,
                o = e.editing.view;
              let i = !1,
                r = !1;
              this.listenTo(
                o.document,
                'delete',
                (e, t) => {
                  r = t.domEvent.keyCode === hr.backspace;
                },
                { priority: 'high' }
              ),
                this.listenTo(
                  t,
                  'deleteContent',
                  () => {
                    i = !1;
                    const e = n.getFirstPosition(),
                      o = n.getAttribute('linkHref');
                    if (!o) return;
                    const r = sp(e, 'linkHref', o, t);
                    i = r.containsPosition(e) || r.end.isEqual(e);
                  },
                  { priority: 'high' }
                ),
                this.listenTo(
                  t,
                  'deleteContent',
                  () => {
                    r &&
                      ((r = !1),
                      i ||
                        e.model.enqueueChange((e) => {
                          Lw(e, Ow(t.schema));
                        }));
                  },
                  { priority: 'low' }
                );
            }
          }
          function Lw(e, t) {
            e.removeSelectionAttribute('linkHref');
            for (const n of t) e.removeSelectionAttribute(n);
          }
          function jw(e) {
            return e.model.change((e) => e.batch).isTyping;
          }
          function Ow(e) {
            return e.getDefinition('$text').allowAttributes.filter((e) => e.startsWith('link'));
          }
          var Rw = n(4827),
            Vw = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Rw.Z, Vw);
          Rw.Z.locals;
          class Fw extends Jd {
            constructor(e, t) {
              super(e);
              const n = e.t;
              (this.focusTracker = new va()),
                (this.keystrokes = new xa()),
                (this.urlInputView = this._createUrlInput()),
                (this.saveButtonView = this._createButton(n('Save'), Cu.check, 'ck-button-save')),
                (this.saveButtonView.type = 'submit'),
                (this.cancelButtonView = this._createButton(n('Cancel'), Cu.cancel, 'ck-button-cancel', 'cancel')),
                (this._manualDecoratorSwitches = this._createManualDecoratorSwitches(t)),
                (this.children = this._createFormChildren(t.manualDecorators)),
                (this._focusables = new Id()),
                (this._focusCycler = new th({
                  focusables: this._focusables,
                  focusTracker: this.focusTracker,
                  keystrokeHandler: this.keystrokes,
                  actions: { focusPrevious: 'shift + tab', focusNext: 'tab' },
                }));
              const o = ['ck', 'ck-link-form', 'ck-responsive-form'];
              t.manualDecorators.length && o.push('ck-link-form_layout-vertical', 'ck-vertical-form'),
                this.setTemplate({ tag: 'form', attributes: { class: o, tabindex: '-1' }, children: this.children }),
                xu(this);
            }
            getDecoratorSwitchesState() {
              return Array.from(this._manualDecoratorSwitches).reduce((e, t) => ((e[t.name] = t.isOn), e), {});
            }
            render() {
              super.render(), Eu({ view: this });
              [this.urlInputView, ...this._manualDecoratorSwitches, this.saveButtonView, this.cancelButtonView].forEach((e) => {
                this._focusables.add(e), this.focusTracker.add(e.element);
              }),
                this.keystrokes.listenTo(this.element);
            }
            destroy() {
              super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
            }
            focus() {
              this._focusCycler.focusFirst();
            }
            _createUrlInput() {
              const e = this.locale.t,
                t = new Uh(this.locale, qh);
              return (t.label = e('Link URL')), t;
            }
            _createButton(e, t, n, o) {
              const i = new zu(this.locale);
              return (
                i.set({ label: e, icon: t, tooltip: !0 }),
                i.extendTemplate({ attributes: { class: n } }),
                o && i.delegate('execute').to(this, o),
                i
              );
            }
            _createManualDecoratorSwitches(e) {
              const t = this.createCollection();
              for (const n of e.manualDecorators) {
                const o = new Ou(this.locale);
                o.set({ name: n.id, label: n.label, withText: !0 }),
                  o.bind('isOn').toMany([n, e], 'value', (e, t) => (void 0 === t && void 0 === e ? n.defaultValue : e)),
                  o.on('execute', () => {
                    n.set('value', !o.isOn);
                  }),
                  t.add(o);
              }
              return t;
            }
            _createFormChildren(e) {
              const t = this.createCollection();
              if ((t.add(this.urlInputView), e.length)) {
                const e = new Jd();
                e.setTemplate({
                  tag: 'ul',
                  children: this._manualDecoratorSwitches.map((e) => ({
                    tag: 'li',
                    children: [e],
                    attributes: { class: ['ck', 'ck-list__item'] },
                  })),
                  attributes: { class: ['ck', 'ck-reset', 'ck-list'] },
                }),
                  t.add(e);
              }
              return t.add(this.saveButtonView), t.add(this.cancelButtonView), t;
            }
          }
          var Hw = n(9465),
            Uw = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Hw.Z, Uw);
          Hw.Z.locals;
          class qw extends Jd {
            constructor(e) {
              super(e);
              const t = e.t;
              (this.focusTracker = new va()),
                (this.keystrokes = new xa()),
                (this.previewButtonView = this._createPreviewButton()),
                (this.unlinkButtonView = this._createButton(
                  t('Unlink'),
                  '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>',
                  'unlink'
                )),
                (this.editButtonView = this._createButton(t('Edit link'), Cu.pencil, 'edit')),
                this.set('href'),
                (this._focusables = new Id()),
                (this._focusCycler = new th({
                  focusables: this._focusables,
                  focusTracker: this.focusTracker,
                  keystrokeHandler: this.keystrokes,
                  actions: { focusPrevious: 'shift + tab', focusNext: 'tab' },
                })),
                this.setTemplate({
                  tag: 'div',
                  attributes: { class: ['ck', 'ck-link-actions', 'ck-responsive-form'], tabindex: '-1' },
                  children: [this.previewButtonView, this.editButtonView, this.unlinkButtonView],
                });
            }
            render() {
              super.render();
              [this.previewButtonView, this.editButtonView, this.unlinkButtonView].forEach((e) => {
                this._focusables.add(e), this.focusTracker.add(e.element);
              }),
                this.keystrokes.listenTo(this.element);
            }
            destroy() {
              super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
            }
            focus() {
              this._focusCycler.focusFirst();
            }
            _createButton(e, t, n) {
              const o = new zu(this.locale);
              return o.set({ label: e, icon: t, tooltip: !0 }), o.delegate('execute').to(this, n), o;
            }
            _createPreviewButton() {
              const e = new zu(this.locale),
                t = this.bindTemplate,
                n = this.t;
              return (
                e.set({ withText: !0, tooltip: n('Open link in new tab') }),
                e.extendTemplate({
                  attributes: {
                    class: ['ck', 'ck-link-actions__preview'],
                    href: t.to('href', (e) => e && vw(e)),
                    target: '_blank',
                    rel: 'noopener noreferrer',
                  },
                }),
                e.bind('label').to(this, 'href', (e) => e || n('This link has no URL')),
                e.bind('isEnabled').to(this, 'href', (e) => !!e),
                (e.template.tag = 'a'),
                (e.template.eventListeners = {}),
                e
              );
            }
          }
          const Ww = 'link-ui';
          class Gw extends V {
            static get requires() {
              return [Xh];
            }
            static get pluginName() {
              return 'LinkUI';
            }
            init() {
              const e = this.editor;
              e.editing.view.addObserver(Dm),
                (this.actionsView = this._createActionsView()),
                (this.formView = this._createFormView()),
                (this._balloon = e.plugins.get(Xh)),
                this._createToolbarLinkButton(),
                this._enableUserBalloonInteractions(),
                e.conversion.for('editingDowncast').markerToHighlight({ model: Ww, view: { classes: ['ck-fake-link-selection'] } }),
                e.conversion.for('editingDowncast').markerToElement({
                  model: Ww,
                  view: { name: 'span', classes: ['ck-fake-link-selection', 'ck-fake-link-selection_collapsed'] },
                });
            }
            destroy() {
              super.destroy(), this.formView.destroy();
            }
            _createActionsView() {
              const e = this.editor,
                t = new qw(e.locale),
                n = e.commands.get('link'),
                o = e.commands.get('unlink');
              return (
                t.bind('href').to(n, 'value'),
                t.editButtonView.bind('isEnabled').to(n),
                t.unlinkButtonView.bind('isEnabled').to(o),
                this.listenTo(t, 'edit', () => {
                  this._addFormView();
                }),
                this.listenTo(t, 'unlink', () => {
                  e.execute('unlink'), this._hideUI();
                }),
                t.keystrokes.set('Esc', (e, t) => {
                  this._hideUI(), t();
                }),
                t.keystrokes.set(Aw, (e, t) => {
                  this._addFormView(), t();
                }),
                t
              );
            }
            _createFormView() {
              const e = this.editor,
                t = e.commands.get('link'),
                n = e.config.get('link.defaultProtocol'),
                o = new Fw(e.locale, t);
              return (
                o.urlInputView.fieldView.bind('value').to(t, 'value'),
                o.urlInputView.bind('isReadOnly').to(t, 'isEnabled', (e) => !e),
                o.saveButtonView.bind('isEnabled').to(t),
                this.listenTo(o, 'submit', () => {
                  const { value: t } = o.urlInputView.fieldView.element,
                    i = Ew(t, n);
                  e.execute('link', i, o.getDecoratorSwitchesState()), this._closeFormView();
                }),
                this.listenTo(o, 'cancel', () => {
                  this._closeFormView();
                }),
                o.keystrokes.set('Esc', (e, t) => {
                  this._closeFormView(), t();
                }),
                o
              );
            }
            _createToolbarLinkButton() {
              const e = this.editor,
                t = e.commands.get('link'),
                n = e.t;
              e.keystrokes.set(Aw, (e, n) => {
                n(), t.isEnabled && this._showUI(!0);
              }),
                e.ui.componentFactory.add('link', (e) => {
                  const o = new zu(e);
                  return (
                    (o.isEnabled = !0),
                    (o.label = n('Link')),
                    (o.icon =
                      '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>'),
                    (o.keystroke = Aw),
                    (o.tooltip = !0),
                    (o.isToggleable = !0),
                    o.bind('isEnabled').to(t, 'isEnabled'),
                    o.bind('isOn').to(t, 'value', (e) => !!e),
                    this.listenTo(o, 'execute', () => this._showUI(!0)),
                    o
                  );
                });
            }
            _enableUserBalloonInteractions() {
              const e = this.editor.editing.view.document;
              this.listenTo(e, 'click', () => {
                this._getSelectedLinkElement() && this._showUI();
              }),
                this.editor.keystrokes.set(
                  'Tab',
                  (e, t) => {
                    this._areActionsVisible && !this.actionsView.focusTracker.isFocused && (this.actionsView.focus(), t());
                  },
                  { priority: 'high' }
                ),
                this.editor.keystrokes.set('Esc', (e, t) => {
                  this._isUIVisible && (this._hideUI(), t());
                }),
                vu({
                  emitter: this.formView,
                  activator: () => this._isUIInPanel,
                  contextElements: [this._balloon.view.element],
                  callback: () => this._hideUI(),
                });
            }
            _addActionsView() {
              this._areActionsInPanel || this._balloon.add({ view: this.actionsView, position: this._getBalloonPositionData() });
            }
            _addFormView() {
              if (this._isFormInPanel) return;
              const e = this.editor.commands.get('link');
              this.formView.disableCssTransitions(),
                this._balloon.add({ view: this.formView, position: this._getBalloonPositionData() }),
                this._balloon.visibleView === this.formView && this.formView.urlInputView.fieldView.select(),
                this.formView.enableCssTransitions(),
                (this.formView.urlInputView.fieldView.element.value = e.value || '');
            }
            _closeFormView() {
              const e = this.editor.commands.get('link');
              e.restoreManualDecoratorStates(), void 0 !== e.value ? this._removeFormView() : this._hideUI();
            }
            _removeFormView() {
              this._isFormInPanel &&
                (this.formView.saveButtonView.focus(),
                this._balloon.remove(this.formView),
                this.editor.editing.view.focus(),
                this._hideFakeVisualSelection());
            }
            _showUI(e = !1) {
              this._getSelectedLinkElement()
                ? (this._areActionsVisible ? this._addFormView() : this._addActionsView(), e && this._balloon.showStack('main'))
                : (this._showFakeVisualSelection(), this._addActionsView(), e && this._balloon.showStack('main'), this._addFormView()),
                this._startUpdatingUI();
            }
            _hideUI() {
              if (!this._isUIInPanel) return;
              const e = this.editor;
              this.stopListening(e.ui, 'update'),
                this.stopListening(this._balloon, 'change:visibleView'),
                e.editing.view.focus(),
                this._removeFormView(),
                this._balloon.remove(this.actionsView),
                this._hideFakeVisualSelection();
            }
            _startUpdatingUI() {
              const e = this.editor,
                t = e.editing.view.document;
              let n = this._getSelectedLinkElement(),
                o = r();
              const i = () => {
                const e = this._getSelectedLinkElement(),
                  t = r();
                (n && !e) || (!n && t !== o)
                  ? this._hideUI()
                  : this._isUIVisible && this._balloon.updatePosition(this._getBalloonPositionData()),
                  (n = e),
                  (o = t);
              };
              function r() {
                return t.selection.focus
                  .getAncestors()
                  .reverse()
                  .find((e) => e.is('element'));
              }
              this.listenTo(e.ui, 'update', i), this.listenTo(this._balloon, 'change:visibleView', i);
            }
            get _isFormInPanel() {
              return this._balloon.hasView(this.formView);
            }
            get _areActionsInPanel() {
              return this._balloon.hasView(this.actionsView);
            }
            get _areActionsVisible() {
              return this._balloon.visibleView === this.actionsView;
            }
            get _isUIInPanel() {
              return this._isFormInPanel || this._areActionsInPanel;
            }
            get _isUIVisible() {
              return this._balloon.visibleView == this.formView || this._areActionsVisible;
            }
            _getBalloonPositionData() {
              const e = this.editor.editing.view,
                t = this.editor.model,
                n = e.document;
              let o = null;
              if (t.markers.has(Ww)) {
                const t = Array.from(this.editor.editing.mapper.markerNameToElements(Ww)),
                  n = e.createRange(e.createPositionBefore(t[0]), e.createPositionAfter(t[t.length - 1]));
                o = e.domConverter.viewRangeToDom(n);
              } else
                o = () => {
                  const t = this._getSelectedLinkElement();
                  return t ? e.domConverter.mapViewToDom(t) : e.domConverter.viewRangeToDom(n.selection.getFirstRange());
                };
              return { target: o };
            }
            _getSelectedLinkElement() {
              const e = this.editor.editing.view,
                t = e.document.selection,
                n = t.getSelectedElement();
              if (t.isCollapsed || (n && Xp(n))) return $w(t.getFirstPosition());
              {
                const n = t.getFirstRange().getTrimmed(),
                  o = $w(n.start),
                  i = $w(n.end);
                return o && o == i && e.createRangeIn(o).getTrimmed().isEqual(n) ? o : null;
              }
            }
            _showFakeVisualSelection() {
              const e = this.editor.model;
              e.change((t) => {
                const n = e.document.selection.getFirstRange();
                if (e.markers.has(Ww)) t.updateMarker(Ww, { range: n });
                else if (n.start.isAtEnd) {
                  const o = n.start.getLastMatchingPosition(({ item: t }) => !e.schema.isContent(t), { boundaries: n });
                  t.addMarker(Ww, { usingOperation: !1, affectsData: !1, range: t.createRange(o, n.end) });
                } else t.addMarker(Ww, { usingOperation: !1, affectsData: !1, range: n });
              });
            }
            _hideFakeVisualSelection() {
              const e = this.editor.model;
              e.markers.has(Ww) &&
                e.change((e) => {
                  e.removeMarker(Ww);
                });
            }
          }
          function $w(e) {
            return e.getAncestors().find((e) => {
              return (t = e).is('attributeElement') && !!t.getCustomProperty('link');
              var t;
            });
          }
          const Yw = new RegExp(
            '(^|\\s)(((?:(?:(?:https?|ftp):)?\\/\\/)(?:\\S+(?::\\S*)?@)?(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(((?!www\\.)|(www\\.))(?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.)+(?:[a-z\\u00a1-\\uffff]{2,63})))(?::\\d{2,5})?(?:[/?#]\\S*)?)|((www.|(\\S+@))((?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.))+(?:[a-z\\u00a1-\\uffff]{2,63})))$',
            'i'
          );
          class Kw extends V {
            static get requires() {
              return [Fg];
            }
            static get pluginName() {
              return 'AutoLink';
            }
            init() {
              const e = this.editor.model.document.selection;
              e.on('change:range', () => {
                this.isEnabled = !e.anchor.parent.is('element', 'codeBlock');
              }),
                this._enableTypingHandling();
            }
            afterInit() {
              this._enableEnterHandling(), this._enableShiftEnterHandling();
            }
            _enableTypingHandling() {
              const e = this.editor,
                t = new qg(e.model, (e) => {
                  if (
                    !(function (e) {
                      return e.length > 4 && ' ' === e[e.length - 1] && ' ' !== e[e.length - 2];
                    })(e)
                  )
                    return;
                  const t = Qw(e.substr(0, e.length - 1));
                  return t ? { url: t } : void 0;
                });
              t.on('matched:data', (t, n) => {
                const { batch: o, range: i, url: r } = n;
                if (!o.isTyping) return;
                const s = i.end.getShiftedBy(-1),
                  a = s.getShiftedBy(-r.length),
                  l = e.model.createRange(a, s);
                this._applyAutoLink(r, l);
              }),
                t.bind('isEnabled').to(this);
            }
            _enableEnterHandling() {
              const e = this.editor,
                t = e.model,
                n = e.commands.get('enter');
              n &&
                n.on('execute', () => {
                  const e = t.document.selection.getFirstPosition();
                  if (!e.parent.previousSibling) return;
                  const n = t.createRangeIn(e.parent.previousSibling);
                  this._checkAndApplyAutoLinkOnRange(n);
                });
            }
            _enableShiftEnterHandling() {
              const e = this.editor,
                t = e.model,
                n = e.commands.get('shiftEnter');
              n &&
                n.on('execute', () => {
                  const e = t.document.selection.getFirstPosition(),
                    n = t.createRange(t.createPositionAt(e.parent, 0), e.getShiftedBy(-1));
                  this._checkAndApplyAutoLinkOnRange(n);
                });
            }
            _checkAndApplyAutoLinkOnRange(e) {
              const t = this.editor.model,
                { text: n, range: o } = Ug(e, t),
                i = Qw(n);
              if (i) {
                const e = t.createRange(o.end.getShiftedBy(-i.length), o.end);
                this._applyAutoLink(i, e);
              }
            }
            _applyAutoLink(e, t) {
              const n = this.editor.model,
                o = this.editor.plugins.get('Delete');
              this.isEnabled &&
                (function (e, t) {
                  return t.schema.checkAttributeInSelection(t.createSelection(e), 'linkHref');
                })(t, n) &&
                n.enqueueChange((i) => {
                  const r = this.editor.config.get('link.defaultProtocol'),
                    s = Ew(e, r);
                  i.setAttribute('linkHref', s, t),
                    n.enqueueChange(() => {
                      o.requestUndoOnBackspace();
                    });
                });
            }
          }
          function Qw(e) {
            const t = Yw.exec(e);
            return t ? t[2] : null;
          }
          class Zw extends H {
            constructor(e, t) {
              super(e), (this.type = t);
            }
            refresh() {
              (this.value = this._getValue()), (this.isEnabled = this._checkEnabled());
            }
            execute(e = {}) {
              const t = this.editor.model,
                n = t.document,
                o = Array.from(n.selection.getSelectedBlocks()).filter((e) => Xw(e, t.schema)),
                i = void 0 !== e.forceValue ? !e.forceValue : this.value;
              t.change((e) => {
                if (i) {
                  let t = o[o.length - 1].nextSibling,
                    n = Number.POSITIVE_INFINITY,
                    i = [];
                  for (; t && 'listItem' == t.name && 0 !== t.getAttribute('listIndent'); ) {
                    const e = t.getAttribute('listIndent');
                    e < n && (n = e);
                    const o = e - n;
                    i.push({ element: t, listIndent: o }), (t = t.nextSibling);
                  }
                  i = i.reverse();
                  for (const t of i) e.setAttribute('listIndent', t.listIndent, t.element);
                }
                if (!i) {
                  let e = Number.POSITIVE_INFINITY;
                  for (const t of o) t.is('element', 'listItem') && t.getAttribute('listIndent') < e && (e = t.getAttribute('listIndent'));
                  (e = 0 === e ? 1 : e), Jw(o, !0, e), Jw(o, !1, e);
                }
                for (const t of o.reverse())
                  i && 'listItem' == t.name
                    ? e.rename(t, 'paragraph')
                    : i || 'listItem' == t.name
                    ? i || 'listItem' != t.name || t.getAttribute('listType') == this.type || e.setAttribute('listType', this.type, t)
                    : (e.setAttributes({ listType: this.type, listIndent: 0 }, t), e.rename(t, 'listItem'));
                this.fire('_executeCleanup', o);
              });
            }
            _getValue() {
              const e = Ca(this.editor.model.document.selection.getSelectedBlocks());
              return !!e && e.is('element', 'listItem') && e.getAttribute('listType') == this.type;
            }
            _checkEnabled() {
              if (this.value) return !0;
              const e = this.editor.model.document.selection,
                t = this.editor.model.schema,
                n = Ca(e.getSelectedBlocks());
              return !!n && Xw(n, t);
            }
          }
          function Jw(e, t, n) {
            const o = t ? e[0] : e[e.length - 1];
            if (o.is('element', 'listItem')) {
              let i = o[t ? 'previousSibling' : 'nextSibling'],
                r = o.getAttribute('listIndent');
              for (; i && i.is('element', 'listItem') && i.getAttribute('listIndent') >= n; )
                r > i.getAttribute('listIndent') && (r = i.getAttribute('listIndent')),
                  i.getAttribute('listIndent') == r && e[t ? 'unshift' : 'push'](i),
                  (i = i[t ? 'previousSibling' : 'nextSibling']);
            }
          }
          function Xw(e, t) {
            return t.checkChild(e.parent, 'listItem') && !t.isObject(e);
          }
          class e_ extends H {
            constructor(e, t) {
              super(e), (this._indentBy = 'forward' == t ? 1 : -1);
            }
            refresh() {
              this.isEnabled = this._checkEnabled();
            }
            execute() {
              const e = this.editor.model,
                t = e.document;
              let n = Array.from(t.selection.getSelectedBlocks());
              e.change((e) => {
                const t = n[n.length - 1];
                let o = t.nextSibling;
                for (; o && 'listItem' == o.name && o.getAttribute('listIndent') > t.getAttribute('listIndent'); )
                  n.push(o), (o = o.nextSibling);
                this._indentBy < 0 && (n = n.reverse());
                for (const t of n) {
                  const n = t.getAttribute('listIndent') + this._indentBy;
                  n < 0 ? e.rename(t, 'paragraph') : e.setAttribute('listIndent', n, t);
                }
                this.fire('_executeCleanup', n);
              });
            }
            _checkEnabled() {
              const e = Ca(this.editor.model.document.selection.getSelectedBlocks());
              if (!e || !e.is('element', 'listItem')) return !1;
              if (this._indentBy > 0) {
                const t = e.getAttribute('listIndent'),
                  n = e.getAttribute('listType');
                let o = e.previousSibling;
                for (; o && o.is('element', 'listItem') && o.getAttribute('listIndent') >= t; ) {
                  if (o.getAttribute('listIndent') == t) return o.getAttribute('listType') == n;
                  o = o.previousSibling;
                }
                return !1;
              }
              return !0;
            }
          }
          function t_(e, t) {
            const n = t.mapper,
              o = t.writer,
              i = 'numbered' == e.getAttribute('listType') ? 'ol' : 'ul',
              r = (function (e) {
                const t = e.createContainerElement('li');
                return (t.getFillerOffset = a_), t;
              })(o),
              s = o.createContainerElement(i, null);
            return o.insert(o.createPositionAt(s, 0), r), n.bindElements(e, r), r;
          }
          function n_(e, t, n, o) {
            const i = t.parent,
              r = n.mapper,
              s = n.writer;
            let a = r.toViewPosition(o.createPositionBefore(e));
            const l = r_(e.previousSibling, { sameIndent: !0, smallerIndent: !0, listIndent: e.getAttribute('listIndent') }),
              c = e.previousSibling;
            if (l && l.getAttribute('listIndent') == e.getAttribute('listIndent')) {
              const e = r.toViewElement(l);
              a = s.breakContainer(s.createPositionAfter(e));
            } else if (c && 'listItem' == c.name) {
              a = r.toViewPosition(o.createPositionAt(c, 'end'));
              const e = r.findMappedViewAncestor(a),
                t = (function (e) {
                  for (const t of e.getChildren()) if ('ul' == t.name || 'ol' == t.name) return t;
                  return null;
                })(e);
              a = t ? s.createPositionBefore(t) : s.createPositionAt(e, 'end');
            } else a = r.toViewPosition(o.createPositionBefore(e));
            if (((a = i_(a)), s.insert(a, i), c && 'listItem' == c.name)) {
              const e = r.toViewElement(c),
                n = s.createRange(s.createPositionAt(e, 0), a).getWalker({ ignoreElementEnd: !0 });
              for (const e of n)
                if (e.item.is('element', 'li')) {
                  const o = s.breakContainer(s.createPositionBefore(e.item)),
                    i = e.item.parent,
                    r = s.createPositionAt(t, 'end');
                  o_(s, r.nodeBefore, r.nodeAfter), s.move(s.createRangeOn(i), r), (n.position = o);
                }
            } else {
              const n = i.nextSibling;
              if (n && (n.is('element', 'ul') || n.is('element', 'ol'))) {
                let o = null;
                for (const t of n.getChildren()) {
                  const n = r.toModelElement(t);
                  if (!(n && n.getAttribute('listIndent') > e.getAttribute('listIndent'))) break;
                  o = t;
                }
                o && (s.breakContainer(s.createPositionAfter(o)), s.move(s.createRangeOn(o.parent), s.createPositionAt(t, 'end')));
              }
            }
            o_(s, i, i.nextSibling), o_(s, i.previousSibling, i);
          }
          function o_(e, t, n) {
            return !t || !n || ('ul' != t.name && 'ol' != t.name) || t.name != n.name || t.getAttribute('class') !== n.getAttribute('class')
              ? null
              : e.mergeContainers(e.createPositionAfter(t));
          }
          function i_(e) {
            return e.getLastMatchingPosition((e) => e.item.is('uiElement'));
          }
          function r_(e, t) {
            const n = !!t.sameIndent,
              o = !!t.smallerIndent,
              i = t.listIndent;
            let r = e;
            for (; r && 'listItem' == r.name; ) {
              const e = r.getAttribute('listIndent');
              if ((n && i == e) || (o && i > e)) return r;
              r = 'forward' === t.direction ? r.nextSibling : r.previousSibling;
            }
            return null;
          }
          function s_(e, t, n, o) {
            e.ui.componentFactory.add(t, (i) => {
              const r = e.commands.get(t),
                s = new zu(i);
              return (
                s.set({ label: n, icon: o, tooltip: !0, isToggleable: !0 }),
                s.bind('isOn', 'isEnabled').to(r, 'value', 'isEnabled'),
                s.on('execute', () => {
                  e.execute(t), e.editing.view.focus();
                }),
                s
              );
            });
          }
          function a_() {
            const e = !this.isEmpty && ('ul' == this.getChild(0).name || 'ol' == this.getChild(0).name);
            return this.isEmpty || e ? 0 : Li.call(this);
          }
          function l_(e) {
            return (t, n, o) => {
              const i = o.consumable;
              if (!i.test(n.item, 'insert') || !i.test(n.item, 'attribute:listType') || !i.test(n.item, 'attribute:listIndent')) return;
              i.consume(n.item, 'insert'), i.consume(n.item, 'attribute:listType'), i.consume(n.item, 'attribute:listIndent');
              const r = n.item;
              n_(r, t_(r, o), o, e);
            };
          }
          function c_(e, t, n) {
            if (!n.consumable.test(t.item, e.name)) return;
            const o = n.mapper.toViewElement(t.item),
              i = n.writer;
            i.breakContainer(i.createPositionBefore(o)), i.breakContainer(i.createPositionAfter(o));
            const r = o.parent,
              s = 'numbered' == t.attributeNewValue ? 'ol' : 'ul';
            i.rename(s, r);
          }
          function d_(e, t, n) {
            n.consumable.consume(t.item, e.name);
            const o = n.mapper.toViewElement(t.item).parent,
              i = n.writer;
            o_(i, o, o.nextSibling), o_(i, o.previousSibling, o);
          }
          function u_(e, t, n) {
            if (n.consumable.test(t.item, e.name) && 'listItem' != t.item.name) {
              let e = n.mapper.toViewPosition(t.range.start);
              const o = n.writer,
                i = [];
              for (; ('ul' == e.parent.name || 'ol' == e.parent.name) && ((e = o.breakContainer(e)), 'li' == e.parent.name); ) {
                const t = e,
                  n = o.createPositionAt(e.parent, 'end');
                if (!t.isEqual(n)) {
                  const e = o.remove(o.createRange(t, n));
                  i.push(e);
                }
                e = o.createPositionAfter(e.parent);
              }
              if (i.length > 0) {
                for (let t = 0; t < i.length; t++) {
                  const n = e.nodeBefore;
                  if (((e = o.insert(e, i[t]).end), t > 0)) {
                    const t = o_(o, n, n.nextSibling);
                    t && t.parent == n && e.offset--;
                  }
                }
                o_(o, e.nodeBefore, e.nodeAfter);
              }
            }
          }
          function h_(e, t, n) {
            const o = n.mapper.toViewPosition(t.position),
              i = o.nodeBefore,
              r = o.nodeAfter;
            o_(n.writer, i, r);
          }
          function m_(e, t, n) {
            if (n.consumable.consume(t.viewItem, { name: !0 })) {
              const e = n.writer,
                o = e.createElement('listItem'),
                i = (function (e) {
                  let t = 0,
                    n = e.parent;
                  for (; n; ) {
                    if (n.is('element', 'li')) t++;
                    else {
                      const e = n.previousSibling;
                      e && e.is('element', 'li') && t++;
                    }
                    n = n.parent;
                  }
                  return t;
                })(t.viewItem);
              e.setAttribute('listIndent', i, o);
              const r = t.viewItem.parent && 'ol' == t.viewItem.parent.name ? 'numbered' : 'bulleted';
              if ((e.setAttribute('listType', r, o), !n.safeInsert(o, t.modelCursor))) return;
              const s = (function (e, t, n) {
                const { writer: o, schema: i } = n;
                let r = o.createPositionAfter(e);
                for (const s of t)
                  if ('ul' == s.name || 'ol' == s.name) r = n.convertItem(s, r).modelCursor;
                  else {
                    const t = n.convertItem(s, o.createPositionAt(e, 'end')),
                      a = t.modelRange.start.nodeAfter;
                    a &&
                      a.is('element') &&
                      !i.checkChild(e, a.name) &&
                      ((e = t.modelCursor.parent.is('element', 'listItem') ? t.modelCursor.parent : b_(t.modelCursor)),
                      (r = o.createPositionAfter(e)));
                  }
                return r;
              })(o, t.viewItem.getChildren(), n);
              (t.modelRange = e.createRange(t.modelCursor, s)), n.updateConversionResult(o, t);
            }
          }
          function g_(e, t, n) {
            if (n.consumable.test(t.viewItem, { name: !0 })) {
              const e = Array.from(t.viewItem.getChildren());
              for (const t of e) {
                !(t.is('element', 'li') || __(t)) && t._remove();
              }
            }
          }
          function p_(e, t, n) {
            if (n.consumable.test(t.viewItem, { name: !0 })) {
              if (0 === t.viewItem.childCount) return;
              const e = [...t.viewItem.getChildren()];
              let n = !1;
              for (const t of e) n && !__(t) && t._remove(), __(t) && (n = !0);
            }
          }
          function f_(e) {
            return (t, n) => {
              if (n.isPhantom) return;
              const o = n.modelPosition.nodeBefore;
              if (o && o.is('element', 'listItem')) {
                const t = n.mapper.toViewElement(o),
                  i = t.getAncestors().find(__),
                  r = e.createPositionAt(t, 0).getWalker();
                for (const e of r) {
                  if ('elementStart' == e.type && e.item.is('element', 'li')) {
                    n.viewPosition = e.previousPosition;
                    break;
                  }
                  if ('elementEnd' == e.type && e.item == i) {
                    n.viewPosition = e.nextPosition;
                    break;
                  }
                }
              }
            };
          }
          function k_(e, [t, n]) {
            let o,
              i = t.is('documentFragment') ? t.getChild(0) : t;
            if (((o = n ? this.createSelection(n) : this.document.selection), i && i.is('element', 'listItem'))) {
              const e = o.getFirstPosition();
              let t = null;
              if (
                (e.parent.is('element', 'listItem')
                  ? (t = e.parent)
                  : e.nodeBefore && e.nodeBefore.is('element', 'listItem') && (t = e.nodeBefore),
                t)
              ) {
                const e = t.getAttribute('listIndent');
                if (e > 0)
                  for (; i && i.is('element', 'listItem'); )
                    i._setAttribute('listIndent', i.getAttribute('listIndent') + e), (i = i.nextSibling);
              }
            }
          }
          function b_(e) {
            const t = new qa({ startPosition: e });
            let n;
            do {
              n = t.next();
            } while (!n.value.item.is('element', 'listItem'));
            return n.value.item;
          }
          function w_(e, t, n, o, i, r) {
            const s = r_(t.nodeBefore, { sameIndent: !0, smallerIndent: !0, listIndent: e, foo: 'b' }),
              a = i.mapper,
              l = i.writer,
              c = s ? s.getAttribute('listIndent') : null;
            let d;
            if (s)
              if (c == e) {
                const e = a.toViewElement(s).parent;
                d = l.createPositionAfter(e);
              } else {
                const e = r.createPositionAt(s, 'end');
                d = a.toViewPosition(e);
              }
            else d = n;
            d = i_(d);
            for (const e of [...o.getChildren()])
              __(e) && ((d = l.move(l.createRangeOn(e), d).end), o_(l, e, e.nextSibling), o_(l, e.previousSibling, e));
          }
          function __(e) {
            return e.is('element', 'ol') || e.is('element', 'ul');
          }
          class y_ extends V {
            static get pluginName() {
              return 'ListEditing';
            }
            static get requires() {
              return [fp, Fg];
            }
            init() {
              const e = this.editor;
              e.model.schema.register('listItem', { inheritAllFrom: '$block', allowAttributes: ['listType', 'listIndent'] });
              const t = e.data,
                n = e.editing;
              var o;
              e.model.document.registerPostFixer((t) =>
                (function (e, t) {
                  const n = e.document.differ.getChanges(),
                    o = new Map();
                  let i = !1;
                  for (const o of n)
                    if ('insert' == o.type && 'listItem' == o.name) r(o.position);
                    else if ('insert' == o.type && 'listItem' != o.name) {
                      if ('$text' != o.name) {
                        const n = o.position.nodeAfter;
                        n.hasAttribute('listIndent') && (t.removeAttribute('listIndent', n), (i = !0)),
                          n.hasAttribute('listType') && (t.removeAttribute('listType', n), (i = !0)),
                          n.hasAttribute('listStyle') && (t.removeAttribute('listStyle', n), (i = !0)),
                          n.hasAttribute('listReversed') && (t.removeAttribute('listReversed', n), (i = !0)),
                          n.hasAttribute('listStart') && (t.removeAttribute('listStart', n), (i = !0));
                        for (const t of Array.from(e.createRangeIn(n)).filter((e) => e.item.is('element', 'listItem')))
                          r(t.previousPosition);
                      }
                      r(o.position.getShiftedBy(o.length));
                    } else
                      'remove' == o.type && 'listItem' == o.name
                        ? r(o.position)
                        : (('attribute' == o.type && 'listIndent' == o.attributeKey) ||
                            ('attribute' == o.type && 'listType' == o.attributeKey)) &&
                          r(o.range.start);
                  for (const e of o.values()) s(e), a(e);
                  return i;
                  function r(e) {
                    const t = e.nodeBefore;
                    if (t && t.is('element', 'listItem')) {
                      let e = t;
                      if (o.has(e)) return;
                      for (let t = e.previousSibling; t && t.is('element', 'listItem'); t = e.previousSibling)
                        if (((e = t), o.has(e))) return;
                      o.set(t, e);
                    } else {
                      const t = e.nodeAfter;
                      t && t.is('element', 'listItem') && o.set(t, t);
                    }
                  }
                  function s(e) {
                    let n = 0,
                      o = null;
                    for (; e && e.is('element', 'listItem'); ) {
                      const r = e.getAttribute('listIndent');
                      if (r > n) {
                        let s;
                        null === o ? ((o = r - n), (s = n)) : (o > r && (o = r), (s = r - o)), t.setAttribute('listIndent', s, e), (i = !0);
                      } else (o = null), (n = e.getAttribute('listIndent') + 1);
                      e = e.nextSibling;
                    }
                  }
                  function a(e) {
                    let n = [],
                      o = null;
                    for (; e && e.is('element', 'listItem'); ) {
                      const r = e.getAttribute('listIndent');
                      if ((o && o.getAttribute('listIndent') > r && (n = n.slice(0, r + 1)), 0 != r))
                        if (n[r]) {
                          const o = n[r];
                          e.getAttribute('listType') != o && (t.setAttribute('listType', o, e), (i = !0));
                        } else n[r] = e.getAttribute('listType');
                      (o = e), (e = e.nextSibling);
                    }
                  }
                })(e.model, t)
              ),
                n.mapper.registerViewToModelLength('li', A_),
                t.mapper.registerViewToModelLength('li', A_),
                n.mapper.on('modelToViewPosition', f_(n.view)),
                n.mapper.on(
                  'viewToModelPosition',
                  ((o = e.model),
                  (e, t) => {
                    const n = t.viewPosition,
                      i = n.parent,
                      r = t.mapper;
                    if ('ul' == i.name || 'ol' == i.name) {
                      if (n.isAtEnd) {
                        const e = r.toModelElement(n.nodeBefore),
                          i = r.getModelLength(n.nodeBefore);
                        t.modelPosition = o.createPositionBefore(e).getShiftedBy(i);
                      } else {
                        const e = r.toModelElement(n.nodeAfter);
                        t.modelPosition = o.createPositionBefore(e);
                      }
                      e.stop();
                    } else if ('li' == i.name && n.nodeBefore && ('ul' == n.nodeBefore.name || 'ol' == n.nodeBefore.name)) {
                      const s = r.toModelElement(i);
                      let a = 1,
                        l = n.nodeBefore;
                      for (; l && __(l); ) (a += r.getModelLength(l)), (l = l.previousSibling);
                      (t.modelPosition = o.createPositionBefore(s).getShiftedBy(a)), e.stop();
                    }
                  })
                ),
                t.mapper.on('modelToViewPosition', f_(n.view)),
                e.conversion.for('editingDowncast').add((t) => {
                  t.on('insert', u_, { priority: 'high' }),
                    t.on('insert:listItem', l_(e.model)),
                    t.on('attribute:listType:listItem', c_, { priority: 'high' }),
                    t.on('attribute:listType:listItem', d_, { priority: 'low' }),
                    t.on(
                      'attribute:listIndent:listItem',
                      (function (e) {
                        return (t, n, o) => {
                          if (!o.consumable.consume(n.item, 'attribute:listIndent')) return;
                          const i = o.mapper.toViewElement(n.item),
                            r = o.writer;
                          r.breakContainer(r.createPositionBefore(i)), r.breakContainer(r.createPositionAfter(i));
                          const s = i.parent,
                            a = s.previousSibling,
                            l = r.createRangeOn(s);
                          r.remove(l),
                            a && a.nextSibling && o_(r, a, a.nextSibling),
                            w_(n.attributeOldValue + 1, n.range.start, l.start, i, o, e),
                            n_(n.item, i, o, e);
                          for (const e of n.item.getChildren()) o.consumable.consume(e, 'insert');
                        };
                      })(e.model)
                    ),
                    t.on(
                      'remove:listItem',
                      (function (e) {
                        return (t, n, o) => {
                          const i = o.mapper
                              .toViewPosition(n.position)
                              .getLastMatchingPosition((e) => !e.item.is('element', 'li')).nodeAfter,
                            r = o.writer;
                          r.breakContainer(r.createPositionBefore(i)), r.breakContainer(r.createPositionAfter(i));
                          const s = i.parent,
                            a = s.previousSibling,
                            l = r.createRangeOn(s),
                            c = r.remove(l);
                          a && a.nextSibling && o_(r, a, a.nextSibling),
                            w_(o.mapper.toModelElement(i).getAttribute('listIndent') + 1, n.position, l.start, i, o, e);
                          for (const e of r.createRangeIn(c).getItems()) o.mapper.unbindViewElement(e);
                          t.stop();
                        };
                      })(e.model)
                    ),
                    t.on('remove', h_, { priority: 'low' });
                }),
                e.conversion.for('dataDowncast').add((t) => {
                  t.on('insert', u_, { priority: 'high' }), t.on('insert:listItem', l_(e.model));
                }),
                e.conversion.for('upcast').add((e) => {
                  e.on('element:ul', g_, { priority: 'high' }),
                    e.on('element:ol', g_, { priority: 'high' }),
                    e.on('element:li', p_, { priority: 'high' }),
                    e.on('element:li', m_);
                }),
                e.model.on('insertContent', k_, { priority: 'high' }),
                e.commands.add('numberedList', new Zw(e, 'numbered')),
                e.commands.add('bulletedList', new Zw(e, 'bulleted')),
                e.commands.add('indentList', new e_(e, 'forward')),
                e.commands.add('outdentList', new e_(e, 'backward'));
              const i = n.view.document;
              this.listenTo(
                i,
                'enter',
                (e, t) => {
                  const n = this.editor.model.document,
                    o = n.selection.getLastPosition().parent;
                  n.selection.isCollapsed &&
                    'listItem' == o.name &&
                    o.isEmpty &&
                    (this.editor.execute('outdentList'), t.preventDefault(), e.stop());
                },
                { context: 'li' }
              ),
                this.listenTo(
                  i,
                  'delete',
                  (e, t) => {
                    if ('backward' !== t.direction) return;
                    const n = this.editor.model.document.selection;
                    if (!n.isCollapsed) return;
                    const o = n.getFirstPosition();
                    if (!o.isAtStart) return;
                    const i = o.parent;
                    if ('listItem' !== i.name) return;
                    (i.previousSibling && 'listItem' === i.previousSibling.name) ||
                      (this.editor.execute('outdentList'), t.preventDefault(), e.stop());
                  },
                  { context: 'li' }
                ),
                this.listenTo(
                  e.editing.view.document,
                  'tab',
                  (t, n) => {
                    const o = n.shiftKey ? 'outdentList' : 'indentList';
                    this.editor.commands.get(o).isEnabled && (e.execute(o), n.stopPropagation(), n.preventDefault(), t.stop());
                  },
                  { context: 'li' }
                );
            }
            afterInit() {
              const e = this.editor.commands,
                t = e.get('indent'),
                n = e.get('outdent');
              t && t.registerChildCommand(e.get('indentList')), n && n.registerChildCommand(e.get('outdentList'));
            }
          }
          function A_(e) {
            let t = 1;
            for (const n of e.getChildren()) if ('ul' == n.name || 'ol' == n.name) for (const e of n.getChildren()) t += A_(e);
            return t;
          }
          class C_ extends V {
            static get pluginName() {
              return 'ListUI';
            }
            init() {
              const e = this.editor.t;
              s_(
                this.editor,
                'numberedList',
                e('Numbered List'),
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>'
              ),
                s_(
                  this.editor,
                  'bulletedList',
                  e('Bulleted List'),
                  '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>'
                );
            }
          }
          function v_(e, t) {
            return (e) => {
              e.on('attribute:url:media', n);
            };
            function n(n, o, i) {
              if (!i.consumable.consume(o.item, n.name)) return;
              const r = o.attributeNewValue,
                s = i.writer,
                a = i.mapper.toViewElement(o.item),
                l = [...a.getChildren()].find((e) => e.getCustomProperty('media-content'));
              s.remove(l);
              const c = e.getMediaViewElement(s, r, t);
              s.insert(s.createPositionAt(a, 0), c);
            }
          }
          function x_(e, t, n, o) {
            return e.createContainerElement('figure', { class: 'media' }, [t.getMediaViewElement(e, n, o), e.createSlot()]);
          }
          function E_(e) {
            const t = e.getSelectedElement();
            return t && t.is('element', 'media') ? t : null;
          }
          function D_(e, t, n, o) {
            e.change((i) => {
              const r = i.createElement('media', { url: t });
              e.insertObject(r, n, null, { setSelection: 'on', findOptimalPosition: o });
            });
          }
          class T_ extends H {
            refresh() {
              const e = this.editor.model,
                t = e.document.selection,
                n = E_(t);
              (this.value = n ? n.getAttribute('url') : null),
                (this.isEnabled =
                  (function (e) {
                    const t = e.getSelectedElement();
                    return !!t && 'media' === t.name;
                  })(t) ||
                  (function (e, t) {
                    let n = af(e, t).start.parent;
                    n.isEmpty && !t.schema.isLimit(n) && (n = n.parent);
                    return t.schema.checkChild(n, 'media');
                  })(t, e));
            }
            execute(e) {
              const t = this.editor.model,
                n = t.document.selection,
                o = E_(n);
              o
                ? t.change((t) => {
                    t.setAttribute('url', e, o);
                  })
                : D_(t, e, n, !0);
            }
          }
          class I_ {
            constructor(e, t) {
              const n = t.providers,
                o = t.extraProviders || [],
                i = new Set(t.removeProviders),
                r = n.concat(o).filter((e) => {
                  const t = e.name;
                  return t ? !i.has(t) : (c('media-embed-no-provider-name', { provider: e }), !1);
                });
              (this.locale = e), (this.providerDefinitions = r);
            }
            hasMedia(e) {
              return !!this._getMedia(e);
            }
            getMediaViewElement(e, t, n) {
              return this._getMedia(t).getViewElement(e, n);
            }
            _getMedia(e) {
              if (!e) return new S_(this.locale);
              e = e.trim();
              for (const t of this.providerDefinitions) {
                const n = t.html,
                  o = bo(t.url);
                for (const t of o) {
                  const o = this._getUrlMatches(e, t);
                  if (o) return new S_(this.locale, e, o, n);
                }
              }
              return null;
            }
            _getUrlMatches(e, t) {
              let n = e.match(t);
              if (n) return n;
              let o = e.replace(/^https?:\/\//, '');
              return (n = o.match(t)), n || ((o = o.replace(/^www\./, '')), (n = o.match(t)), n || null);
            }
          }
          class S_ {
            constructor(e, t, n, o) {
              (this.url = this._getValidUrl(t)), (this._locale = e), (this._match = n), (this._previewRenderer = o);
            }
            getViewElement(e, t) {
              const n = {};
              let o;
              if (t.renderForEditingView || (t.renderMediaPreview && this.url && this._previewRenderer)) {
                this.url && (n['data-oembed-url'] = this.url), t.renderForEditingView && (n.class = 'ck-media__wrapper');
                const i = this._getPreviewHtml(t);
                o = e.createRawElement('div', n, (e, t) => {
                  t.setContentOf(e, i);
                });
              } else this.url && (n.url = this.url), (o = e.createEmptyElement(t.elementName, n));
              return e.setCustomProperty('media-content', !0, o), o;
            }
            _getPreviewHtml(e) {
              return this._previewRenderer
                ? this._previewRenderer(this._match)
                : this.url && e.renderForEditingView
                ? this._getPlaceholderHtml()
                : '';
            }
            _getPlaceholderHtml() {
              const e = new Bu(),
                t = this._locale.t;
              (e.content =
                '<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>'),
                (e.viewBox = '0 0 64 42');
              return new Sd({
                tag: 'div',
                attributes: { class: 'ck ck-reset_all ck-media__placeholder' },
                children: [
                  { tag: 'div', attributes: { class: 'ck-media__placeholder__icon' }, children: [e] },
                  {
                    tag: 'a',
                    attributes: {
                      class: 'ck-media__placeholder__url',
                      target: '_blank',
                      rel: 'noopener noreferrer',
                      href: this.url,
                      'data-cke-tooltip-text': t('Open media in new tab'),
                    },
                    children: [{ tag: 'span', attributes: { class: 'ck-media__placeholder__url__text' }, children: [this.url] }],
                  },
                ],
              }).render().outerHTML;
            }
            _getValidUrl(e) {
              return e ? (e.match(/^https?/) ? e : 'https://' + e) : null;
            }
          }
          var M_ = n(952),
            B_ = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(M_.Z, B_);
          M_.Z.locals;
          class N_ extends V {
            static get pluginName() {
              return 'MediaEmbedEditing';
            }
            constructor(e) {
              super(e),
                e.config.define('mediaEmbed', {
                  elementName: 'oembed',
                  providers: [
                    {
                      name: 'dailymotion',
                      url: /^dailymotion\.com\/video\/(\w+)/,
                      html: (e) =>
                        `<div style="position: relative; padding-bottom: 100%; height: 0; "><iframe src="https://www.dailymotion.com/embed/video/${e[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" width="480" height="270" allowfullscreen allow="autoplay"></iframe></div>`,
                    },
                    {
                      name: 'spotify',
                      url: [/^open\.spotify\.com\/(artist\/\w+)/, /^open\.spotify\.com\/(album\/\w+)/, /^open\.spotify\.com\/(track\/\w+)/],
                      html: (e) =>
                        `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;"><iframe src="https://open.spotify.com/embed/${e[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe></div>`,
                    },
                    {
                      name: 'youtube',
                      url: [
                        /^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)(?:&t=(\d+))?/,
                        /^(?:m\.)?youtube\.com\/v\/([\w-]+)(?:\?t=(\d+))?/,
                        /^youtube\.com\/embed\/([\w-]+)(?:\?start=(\d+))?/,
                        /^youtu\.be\/([\w-]+)(?:\?t=(\d+))?/,
                      ],
                      html: (e) => {
                        const t = e[1],
                          n = e[2];
                        return `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe src="https://www.youtube.com/embed/${t}${
                          n ? `?start=${n}` : ''
                        }" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>`;
                      },
                    },
                    {
                      name: 'vimeo',
                      url: [
                        /^vimeo\.com\/(\d+)/,
                        /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/,
                        /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/,
                        /^vimeo\.com\/channels\/[^/]+\/(\d+)/,
                        /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/,
                        /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/,
                        /^player\.vimeo\.com\/video\/(\d+)/,
                      ],
                      html: (e) =>
                        `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe src="https://player.vimeo.com/video/${e[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>`,
                    },
                    { name: 'instagram', url: /^instagram\.com\/p\/(\w+)/ },
                    { name: 'twitter', url: /^twitter\.com/ },
                    { name: 'googleMaps', url: [/^google\.com\/maps/, /^goo\.gl\/maps/, /^maps\.google\.com/, /^maps\.app\.goo\.gl/] },
                    { name: 'flickr', url: /^flickr\.com/ },
                    { name: 'facebook', url: /^facebook\.com/ },
                  ],
                }),
                (this.registry = new I_(e.locale, e.config.get('mediaEmbed')));
            }
            init() {
              const e = this.editor,
                t = e.model.schema,
                n = e.t,
                o = e.conversion,
                i = e.config.get('mediaEmbed.previewsInData'),
                r = e.config.get('mediaEmbed.elementName'),
                s = this.registry;
              e.commands.add('mediaEmbed', new T_(e)),
                t.register('media', { inheritAllFrom: '$blockObject', allowAttributes: ['url'] }),
                o.for('dataDowncast').elementToStructure({
                  model: 'media',
                  view: (e, { writer: t }) => {
                    const n = e.getAttribute('url');
                    return x_(t, s, n, { elementName: r, renderMediaPreview: n && i });
                  },
                }),
                o.for('dataDowncast').add(v_(s, { elementName: r, renderMediaPreview: i })),
                o.for('editingDowncast').elementToStructure({
                  model: 'media',
                  view: (e, { writer: t }) => {
                    const o = e.getAttribute('url');
                    return (function (e, t, n) {
                      return t.setCustomProperty('media', !0, e), ef(e, t, { label: n });
                    })(x_(t, s, o, { elementName: r, renderForEditingView: !0 }), t, n('media widget'));
                  },
                }),
                o.for('editingDowncast').add(v_(s, { elementName: r, renderForEditingView: !0 })),
                o
                  .for('upcast')
                  .elementToElement({
                    view: (e) => (['oembed', r].includes(e.name) && e.getAttribute('url') ? { name: !0 } : null),
                    model: (e, { writer: t }) => {
                      const n = e.getAttribute('url');
                      if (s.hasMedia(n)) return t.createElement('media', { url: n });
                    },
                  })
                  .elementToElement({
                    view: { name: 'div', attributes: { 'data-oembed-url': !0 } },
                    model: (e, { writer: t }) => {
                      const n = e.getAttribute('data-oembed-url');
                      if (s.hasMedia(n)) return t.createElement('media', { url: n });
                    },
                  })
                  .add((e) => {
                    e.on('element:figure', function (e, t, n) {
                      if (!n.consumable.consume(t.viewItem, { name: !0, classes: 'media' })) return;
                      const { modelRange: o, modelCursor: i } = n.convertChildren(t.viewItem, t.modelCursor);
                      (t.modelRange = o), (t.modelCursor = i);
                      Ca(o.getItems()) || n.consumable.revert(t.viewItem, { name: !0, classes: 'media' });
                    });
                  });
            }
          }
          const P_ = /^(?:http(s)?:\/\/)?[\w-]+\.[\w-.~:/?#[\]@!$&'()*+,;=%]+$/;
          class z_ extends V {
            static get requires() {
              return [Pf, Fg, Qf];
            }
            static get pluginName() {
              return 'AutoMediaEmbed';
            }
            constructor(e) {
              super(e), (this._timeoutId = null), (this._positionToInsert = null);
            }
            init() {
              const e = this.editor,
                t = e.model.document;
              this.listenTo(e.plugins.get('ClipboardPipeline'), 'inputTransformation', () => {
                const e = t.selection.getFirstRange(),
                  n = sd.fromPosition(e.start);
                n.stickiness = 'toPrevious';
                const o = sd.fromPosition(e.end);
                (o.stickiness = 'toNext'),
                  t.once(
                    'change:data',
                    () => {
                      this._embedMediaBetweenPositions(n, o), n.detach(), o.detach();
                    },
                    { priority: 'high' }
                  );
              }),
                e.commands.get('undo').on(
                  'execute',
                  () => {
                    this._timeoutId &&
                      (_o.window.clearTimeout(this._timeoutId),
                      this._positionToInsert.detach(),
                      (this._timeoutId = null),
                      (this._positionToInsert = null));
                  },
                  { priority: 'high' }
                );
            }
            _embedMediaBetweenPositions(e, t) {
              const n = this.editor,
                o = n.plugins.get(N_).registry,
                i = new ll(e, t),
                r = i.getWalker({ ignoreElementEnd: !0 });
              let s = '';
              for (const e of r) e.item.is('$textProxy') && (s += e.item.data);
              if (((s = s.trim()), !s.match(P_))) return void i.detach();
              if (!o.hasMedia(s)) return void i.detach();
              n.commands.get('mediaEmbed').isEnabled
                ? ((this._positionToInsert = sd.fromPosition(e)),
                  (this._timeoutId = _o.window.setTimeout(() => {
                    n.model.change((e) => {
                      let t;
                      (this._timeoutId = null),
                        e.remove(i),
                        i.detach(),
                        '$graveyard' !== this._positionToInsert.root.rootName && (t = this._positionToInsert),
                        D_(n.model, s, t, !1),
                        this._positionToInsert.detach(),
                        (this._positionToInsert = null);
                    }),
                      n.plugins.get('Delete').requestUndoOnBackspace();
                  }, 100)))
                : i.detach();
            }
          }
          var L_ = n(3525),
            j_ = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(L_.Z, j_);
          L_.Z.locals;
          class O_ extends Jd {
            constructor(e, t) {
              super(t);
              const n = t.t;
              (this.focusTracker = new va()),
                (this.keystrokes = new xa()),
                this.set('mediaURLInputValue', ''),
                (this.urlInputView = this._createUrlInput()),
                (this.saveButtonView = this._createButton(n('Save'), Cu.check, 'ck-button-save')),
                (this.saveButtonView.type = 'submit'),
                this.saveButtonView.bind('isEnabled').to(this, 'mediaURLInputValue', (e) => !!e),
                (this.cancelButtonView = this._createButton(n('Cancel'), Cu.cancel, 'ck-button-cancel', 'cancel')),
                (this._focusables = new Id()),
                (this._focusCycler = new th({
                  focusables: this._focusables,
                  focusTracker: this.focusTracker,
                  keystrokeHandler: this.keystrokes,
                  actions: { focusPrevious: 'shift + tab', focusNext: 'tab' },
                })),
                (this._validators = e),
                this.setTemplate({
                  tag: 'form',
                  attributes: { class: ['ck', 'ck-media-form', 'ck-responsive-form'], tabindex: '-1' },
                  children: [this.urlInputView, this.saveButtonView, this.cancelButtonView],
                }),
                xu(this);
            }
            render() {
              super.render(), Eu({ view: this });
              [this.urlInputView, this.saveButtonView, this.cancelButtonView].forEach((e) => {
                this._focusables.add(e), this.focusTracker.add(e.element);
              }),
                this.keystrokes.listenTo(this.element);
              const e = (e) => e.stopPropagation();
              this.keystrokes.set('arrowright', e),
                this.keystrokes.set('arrowleft', e),
                this.keystrokes.set('arrowup', e),
                this.keystrokes.set('arrowdown', e),
                this.listenTo(
                  this.urlInputView.element,
                  'selectstart',
                  (e, t) => {
                    t.stopPropagation();
                  },
                  { priority: 'high' }
                );
            }
            destroy() {
              super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
            }
            focus() {
              this._focusCycler.focusFirst();
            }
            get url() {
              return this.urlInputView.fieldView.element.value.trim();
            }
            set url(e) {
              this.urlInputView.fieldView.element.value = e.trim();
            }
            isValid() {
              this.resetFormStatus();
              for (const e of this._validators) {
                const t = e(this);
                if (t) return (this.urlInputView.errorText = t), !1;
              }
              return !0;
            }
            resetFormStatus() {
              (this.urlInputView.errorText = null), (this.urlInputView.infoText = this._urlInputViewInfoDefault);
            }
            _createUrlInput() {
              const e = this.locale.t,
                t = new Uh(this.locale, qh),
                n = t.fieldView;
              return (
                (this._urlInputViewInfoDefault = e('Paste the media URL in the input.')),
                (this._urlInputViewInfoTip = e('Tip: Paste the URL into the content to embed faster.')),
                (t.label = e('Media URL')),
                (t.infoText = this._urlInputViewInfoDefault),
                n.on('input', () => {
                  (t.infoText = n.element.value ? this._urlInputViewInfoTip : this._urlInputViewInfoDefault),
                    (this.mediaURLInputValue = n.element.value.trim());
                }),
                t
              );
            }
            _createButton(e, t, n, o) {
              const i = new zu(this.locale);
              return (
                i.set({ label: e, icon: t, tooltip: !0 }),
                i.extendTemplate({ attributes: { class: n } }),
                o && i.delegate('execute').to(this, o),
                i
              );
            }
          }
          class R_ extends V {
            static get requires() {
              return [N_];
            }
            static get pluginName() {
              return 'MediaEmbedUI';
            }
            init() {
              const e = this.editor,
                t = e.commands.get('mediaEmbed'),
                n = e.plugins.get(N_).registry;
              e.ui.componentFactory.add('mediaEmbed', (o) => {
                const i = yh(o),
                  r = new O_(
                    (function (e, t) {
                      return [
                        (t) => {
                          if (!t.url.length) return e('The URL must not be empty.');
                        },
                        (n) => {
                          if (!t.hasMedia(n.url)) return e('This media URL is not supported.');
                        },
                      ];
                    })(e.t, n),
                    e.locale
                  );
                return this._setUpDropdown(i, r, t, e), this._setUpForm(i, r, t), i;
              });
            }
            _setUpDropdown(e, t, n) {
              const o = this.editor,
                i = o.t,
                r = e.buttonView;
              function s() {
                o.editing.view.focus(), (e.isOpen = !1);
              }
              e.bind('isEnabled').to(n),
                e.panelView.children.add(t),
                r.set({
                  label: i('Insert media'),
                  icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M18.68 3.03c.6 0 .59-.03.59.55v12.84c0 .59.01.56-.59.56H1.29c-.6 0-.59.03-.59-.56V3.58c0-.58-.01-.55.6-.55h17.38zM15.77 15V5H4.2v10h11.57zM2 4v1h1V4H2zm0 2v1h1V6H2zm0 2v1h1V8H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zM17 4v1h1V4h-1zm0 2v1h1V6h-1zm0 2v1h1V8h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zM7.5 7.177a.4.4 0 0 1 .593-.351l5.133 2.824a.4.4 0 0 1 0 .7l-5.133 2.824a.4.4 0 0 1-.593-.35V7.176v.001z"/></svg>',
                  tooltip: !0,
                }),
                r.on(
                  'open',
                  () => {
                    t.disableCssTransitions(), (t.url = n.value || ''), t.urlInputView.fieldView.select(), t.enableCssTransitions();
                  },
                  { priority: 'low' }
                ),
                e.on('submit', () => {
                  t.isValid() && (o.execute('mediaEmbed', t.url), s());
                }),
                e.on('change:isOpen', () => t.resetFormStatus()),
                e.on('cancel', () => s());
            }
            _setUpForm(e, t, n) {
              t.delegate('submit', 'cancel').to(e),
                t.urlInputView.bind('value').to(n, 'value'),
                t.urlInputView.bind('isReadOnly').to(n, 'isEnabled', (e) => !e);
            }
          }
          var V_ = n(5777),
            F_ = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(V_.Z, F_);
          V_.Z.locals;
          class H_ extends H {
            refresh() {
              const e = this.editor.model,
                t = e.document;
              this.isEnabled = e.schema.checkAttributeInSelection(t.selection, 'mention');
            }
            execute(e) {
              const t = this.editor.model,
                n = t.document.selection,
                o = 'string' == typeof e.mention ? { id: e.mention } : e.mention,
                i = o.id,
                r = e.range || n.getFirstRange(),
                s = e.text || i,
                a = q_({ _text: s, id: i }, o);
              if (1 != e.marker.length) throw new l('mentioncommand-incorrect-marker', this);
              if (i.charAt(0) != e.marker) throw new l('mentioncommand-incorrect-id', this);
              t.change((e) => {
                const o = No(n.getAttributes()),
                  i = new Map(o.entries());
                i.set('mention', a),
                  t.insertContent(e.createText(s, i), r),
                  t.insertContent(e.createText(' ', o), r.start.getShiftedBy(s.length));
              });
            }
          }
          class U_ extends V {
            static get pluginName() {
              return 'MentionEditing';
            }
            init() {
              const e = this.editor,
                t = e.model,
                n = t.document;
              t.schema.extend('$text', { allowAttributes: 'mention' }),
                e.conversion.for('upcast').elementToAttribute({
                  view: { name: 'span', key: 'data-mention', classes: 'mention' },
                  model: { key: 'mention', value: (e) => W_(e) },
                }),
                e.conversion.for('downcast').attributeToElement({ model: 'mention', view: $_ }),
                e.conversion.for('downcast').add(G_),
                n.registerPostFixer((e) =>
                  (function (e, t, n) {
                    const o = t.differ.getChanges();
                    let i = !1;
                    for (const t of o) {
                      const o = t.position;
                      if ('$text' == t.name) {
                        const t = o.textNode && o.textNode.nextSibling;
                        (i = K_(o.textNode, e) || i), (i = K_(t, e) || i), (i = K_(o.nodeBefore, e) || i), (i = K_(o.nodeAfter, e) || i);
                      }
                      if ('$text' != t.name && 'insert' == t.type) {
                        const t = o.nodeAfter;
                        for (const n of e.createRangeIn(t).getItems()) i = K_(n, e) || i;
                      }
                      if ('insert' == t.type && n.isInline(t.name)) {
                        const t = o.nodeAfter && o.nodeAfter.nextSibling;
                        (i = K_(o.nodeBefore, e) || i), (i = K_(t, e) || i);
                      }
                    }
                    return i;
                  })(e, n, t.schema)
                ),
                n.registerPostFixer((e) =>
                  (function (e, t) {
                    const n = t.differ.getChanges();
                    let o = !1;
                    for (const t of n)
                      if ('attribute' === t.type && 'mention' != t.attributeKey) {
                        const n = t.range.start.nodeBefore,
                          i = t.range.end.nodeAfter;
                        for (const r of [n, i])
                          Y_(r) &&
                            r.getAttribute(t.attributeKey) != t.attributeNewValue &&
                            (e.setAttribute(t.attributeKey, t.attributeNewValue, r), (o = !0));
                      }
                    return o;
                  })(e, n)
                ),
                n.registerPostFixer((e) =>
                  (function (e, t) {
                    const n = t.selection,
                      o = n.focus;
                    if (
                      n.isCollapsed &&
                      n.hasAttribute('mention') &&
                      (function (e) {
                        const t = e.isAtStart;
                        return (e.nodeBefore && e.nodeBefore.is('$text')) || t;
                      })(o)
                    )
                      return e.removeSelectionAttribute('mention'), !0;
                  })(e, n)
                ),
                e.commands.add('mention', new H_(e));
            }
          }
          function q_(e, t) {
            return Object.assign({ uid: r() }, e, t || {});
          }
          function W_(e, t) {
            const n = e.getAttribute('data-mention'),
              o = e.getChild(0);
            if (!o) return;
            return q_({ id: n, _text: o.data }, t);
          }
          function G_(e) {
            e.on(
              'attribute:mention',
              (e, t, n) => {
                const o = t.attributeNewValue;
                if (!t.item.is('$textProxy') || !o) return;
                const i = t.range.start;
                (i.textNode || i.nodeAfter).data != o._text && n.consumable.consume(t.item, e.name);
              },
              { priority: 'highest' }
            );
          }
          function $_(e, { writer: t }) {
            if (!e) return;
            const n = { class: 'mention', 'data-mention': e.id },
              o = { id: e.uid, priority: 20 };
            return t.createAttributeElement('span', n, o);
          }
          function Y_(e) {
            if (!e || (!e.is('$text') && !e.is('$textProxy')) || !e.hasAttribute('mention')) return !1;
            return e.data != e.getAttribute('mention')._text;
          }
          function K_(e, t) {
            return !!Y_(e) && (t.removeAttribute('mention', e), !0);
          }
          var Q_ = n(6391),
            Z_ = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(Q_.Z, Z_);
          Q_.Z.locals;
          class J_ extends gh {
            constructor(e) {
              super(e), this.extendTemplate({ attributes: { class: ['ck-mentions'], tabindex: '-1' } });
            }
            selectFirst() {
              this.select(0);
            }
            selectNext() {
              const e = this.selected,
                t = this.items.getIndex(e);
              this.select(t + 1);
            }
            selectPrevious() {
              const e = this.selected,
                t = this.items.getIndex(e);
              this.select(t - 1);
            }
            select(e) {
              let t = 0;
              e > 0 && e < this.items.length ? (t = e) : e < 0 && (t = this.items.length - 1);
              const n = this.items.get(t);
              this.selected !== n &&
                (this.selected && this.selected.removeHighlight(),
                n.highlight(),
                (this.selected = n),
                this._isItemVisibleInScrolledArea(n) || (this.element.scrollTop = n.element.offsetTop));
            }
            executeSelected() {
              this.selected.fire('execute');
            }
            _isItemVisibleInScrolledArea(e) {
              return new ka(this.element).contains(new ka(e.element));
            }
          }
          class X_ extends Jd {
            constructor(e, t) {
              super(e),
                (this.template = !1),
                (this.domElement = t),
                this.domElement.classList.add('ck-button'),
                this.set('isOn', !1),
                this.on('change:isOn', (e, t, n) => {
                  n
                    ? (this.domElement.classList.add('ck-on'), this.domElement.classList.remove('ck-off'))
                    : (this.domElement.classList.add('ck-off'), this.domElement.classList.remove('ck-on'));
                }),
                this.listenTo(this.domElement, 'click', () => {
                  this.fire('execute');
                });
            }
            render() {
              super.render(), (this.element = this.domElement);
            }
          }
          class ey extends ph {
            highlight() {
              this.children.first.isOn = !0;
            }
            removeHighlight() {
              this.children.first.isOn = !1;
            }
          }
          const ty = [hr.arrowup, hr.arrowdown, hr.esc],
            ny = [hr.enter, hr.tab];
          class oy extends V {
            static get pluginName() {
              return 'MentionUI';
            }
            static get requires() {
              return [Xh];
            }
            constructor(e) {
              super(e),
                (this._mentionsView = this._createMentionView()),
                (this._mentionsConfigurations = new Map()),
                (this._requestFeedDebounced = aa(this._requestFeed, 100)),
                e.config.define('mention', { feeds: [] });
            }
            init() {
              const e = this.editor,
                t = e.config.get('mention.commitKeys') || ny,
                n = ty.concat(t);
              (this._balloon = e.plugins.get(Xh)),
                e.editing.view.document.on(
                  'keydown',
                  (e, o) => {
                    var i;
                    (i = o.keyCode),
                      n.includes(i) &&
                        this._isUIVisible &&
                        (o.preventDefault(),
                        e.stop(),
                        o.keyCode == hr.arrowdown && this._mentionsView.selectNext(),
                        o.keyCode == hr.arrowup && this._mentionsView.selectPrevious(),
                        t.includes(o.keyCode) && this._mentionsView.executeSelected(),
                        o.keyCode == hr.esc && this._hideUIAndRemoveMarker());
                  },
                  { priority: 'highest' }
                ),
                vu({
                  emitter: this._mentionsView,
                  activator: () => this._isUIVisible,
                  contextElements: [this._balloon.view.element],
                  callback: () => this._hideUIAndRemoveMarker(),
                });
              const o = e.config.get('mention.feeds');
              for (const e of o) {
                const t = e.feed,
                  n = e.marker;
                if (!ly(n)) throw new l('mentionconfig-incorrect-marker', null, { marker: n });
                const o = { marker: n, feedCallback: 'function' == typeof t ? t.bind(this.editor) : ay(t), itemRenderer: e.itemRenderer };
                this._mentionsConfigurations.set(n, o);
              }
              this._setupTextWatcher(o),
                this.listenTo(e, 'change:isReadOnly', () => {
                  this._hideUIAndRemoveMarker();
                }),
                this.on('requestFeed:response', (e, t) => this._handleFeedResponse(t)),
                this.on('requestFeed:error', () => this._hideUIAndRemoveMarker());
            }
            destroy() {
              super.destroy(), this._mentionsView.destroy();
            }
            get _isUIVisible() {
              return this._balloon.visibleView === this._mentionsView;
            }
            _createMentionView() {
              const e = this.editor.locale,
                t = new J_(e);
              return (
                (this._items = new fo()),
                t.items.bindTo(this._items).using((n) => {
                  const { item: o, marker: i } = n,
                    r = this.editor.config.get('mention.dropdownLimit') || 10;
                  if (t.items.length >= r) return;
                  const s = new ey(e),
                    a = this._renderItem(o, i);
                  return (
                    a.delegate('execute').to(s),
                    s.children.add(a),
                    (s.item = o),
                    (s.marker = i),
                    s.on('execute', () => {
                      t.fire('execute', { item: o, marker: i });
                    }),
                    s
                  );
                }),
                t.on('execute', (e, t) => {
                  const n = this.editor,
                    o = n.model,
                    i = t.item,
                    r = t.marker,
                    s = n.model.markers.get('mention'),
                    a = o.createPositionAt(o.document.selection.focus),
                    l = o.createPositionAt(s.getStart()),
                    c = o.createRange(l, a);
                  this._hideUIAndRemoveMarker(),
                    n.execute('mention', { mention: i, text: i.text, marker: r, range: c }),
                    n.editing.view.focus();
                }),
                t
              );
            }
            _getItemRenderer(e) {
              const { itemRenderer: t } = this._mentionsConfigurations.get(e);
              return t;
            }
            _requestFeed(e, t) {
              this._lastRequested = t;
              const { feedCallback: n } = this._mentionsConfigurations.get(e),
                o = n(t);
              o instanceof Promise
                ? o
                    .then((n) => {
                      this._lastRequested == t
                        ? this.fire('requestFeed:response', { feed: n, marker: e, feedText: t })
                        : this.fire('requestFeed:discarded', { feed: n, marker: e, feedText: t });
                    })
                    .catch((t) => {
                      this.fire('requestFeed:error', { error: t }), c('mention-feed-callback-error', { marker: e });
                    })
                : this.fire('requestFeed:response', { feed: o, marker: e, feedText: t });
            }
            _setupTextWatcher(e) {
              const t = this.editor,
                n = e.map((e) => ({ ...e, pattern: sy(e.marker, e.minimumCharacters || 0) })),
                o = new qg(
                  t.model,
                  (function (e) {
                    return (t) => {
                      const n = ry(e, t);
                      if (!n) return !1;
                      let o = 0;
                      0 !== n.position && (o = n.position - 1);
                      const i = t.substring(o);
                      return n.pattern.test(i);
                    };
                  })(n)
                );
              o.on('matched', (e, o) => {
                const i = ry(n, o.text),
                  r = t.model.document.selection.focus,
                  s = t.model.createPositionAt(r.parent, i.position);
                if (
                  (function (e) {
                    const t = e.textNode && e.textNode.hasAttribute('mention'),
                      n = e.nodeBefore;
                    return t || (n && n.is('$text') && n.hasAttribute('mention'));
                  })(r) ||
                  (function (e) {
                    const t = e.nodeAfter;
                    return t && t.is('$text') && t.hasAttribute('mention');
                  })(s)
                )
                  return void this._hideUIAndRemoveMarker();
                const a = (function (e, t) {
                    let n = 0;
                    0 !== e.position && (n = e.position - 1);
                    const o = sy(e.marker, 0),
                      i = t.substring(n);
                    return i.match(o)[2];
                  })(i, o.text),
                  l = i.marker.length + a.length,
                  c = r.getShiftedBy(-l),
                  d = r.getShiftedBy(-a.length),
                  u = t.model.createRange(c, d);
                if (cy(t)) {
                  const e = t.model.markers.get('mention');
                  t.model.change((t) => {
                    t.updateMarker(e, { range: u });
                  });
                } else
                  t.model.change((e) => {
                    e.addMarker('mention', { range: u, usingOperation: !1, affectsData: !1 });
                  });
                this._requestFeedDebounced(i.marker, a);
              }),
                o.on('unmatched', () => {
                  this._hideUIAndRemoveMarker();
                });
              const i = t.commands.get('mention');
              return o.bind('isEnabled').to(i), o;
            }
            _handleFeedResponse(e) {
              const { feed: t, marker: n } = e;
              if (!cy(this.editor)) return;
              this._items.clear();
              for (const e of t) {
                const t = 'object' != typeof e ? { id: e, text: e } : e;
                this._items.add({ item: t, marker: n });
              }
              const o = this.editor.model.markers.get('mention');
              this._items.length ? this._showOrUpdateUI(o) : this._hideUIAndRemoveMarker();
            }
            _showOrUpdateUI(e) {
              this._isUIVisible
                ? this._balloon.updatePosition(this._getBalloonPanelPositionData(e, this._mentionsView.position))
                : this._balloon.add({
                    view: this._mentionsView,
                    position: this._getBalloonPanelPositionData(e, this._mentionsView.position),
                    singleViewMode: !0,
                  }),
                (this._mentionsView.position = this._balloon.view.position),
                this._mentionsView.selectFirst();
            }
            _hideUIAndRemoveMarker() {
              this._balloon.hasView(this._mentionsView) && this._balloon.remove(this._mentionsView),
                cy(this.editor) && this.editor.model.change((e) => e.removeMarker('mention')),
                (this._mentionsView.position = void 0);
            }
            _renderItem(e, t) {
              const n = this.editor;
              let o,
                i = e.id;
              const r = this._getItemRenderer(t);
              if (r) {
                const t = r(e);
                'string' != typeof t ? (o = new X_(n.locale, t)) : (i = t);
              }
              if (!o) {
                const e = new zu(n.locale);
                (e.label = i), (e.withText = !0), (o = e);
              }
              return o;
            }
            _getBalloonPanelPositionData(e, t) {
              const n = this.editor,
                o = n.editing,
                i = o.view.domConverter,
                r = o.mapper;
              return {
                target: () => {
                  let t = e.getRange();
                  '$graveyard' == t.start.root.rootName && (t = n.model.document.selection.getFirstRange());
                  const o = r.toViewRange(t);
                  return ka.getDomRangeRects(i.viewRangeToDom(o)).pop();
                },
                limiter: () => {
                  const e = this.editor.editing.view,
                    t = e.document.selection.editableElement;
                  return t ? e.domConverter.mapViewToDom(t.root) : null;
                },
                positions: iy(t),
              };
            }
          }
          function iy(e) {
            const t = {
              caret_se: (e) => ({ top: e.bottom + 3, left: e.right, name: 'caret_se', config: { withArrow: !1 } }),
              caret_ne: (e, t) => ({ top: e.top - t.height - 3, left: e.right, name: 'caret_ne', config: { withArrow: !1 } }),
              caret_sw: (e, t) => ({ top: e.bottom + 3, left: e.right - t.width, name: 'caret_sw', config: { withArrow: !1 } }),
              caret_nw: (e, t) => ({ top: e.top - t.height - 3, left: e.right - t.width, name: 'caret_nw', config: { withArrow: !1 } }),
            };
            return Object.prototype.hasOwnProperty.call(t, e) ? [t[e]] : [t.caret_se, t.caret_sw, t.caret_ne, t.caret_nw];
          }
          function ry(e, t) {
            let n;
            for (const o of e) {
              const e = t.lastIndexOf(o.marker);
              (e > 0 && !t.substring(e - 1).match(o.pattern)) ||
                ((!n || e >= n.position) &&
                  (n = { marker: o.marker, position: e, minimumCharacters: o.minimumCharacters, pattern: o.pattern }));
            }
            return n;
          }
          function sy(e, t) {
            const n = 0 == t ? '*' : `{${t},}`,
              o = lr.features.isRegExpUnicodePropertySupported ? '\\p{Ps}\\p{Pi}"\'' : '\\(\\[{"\'';
            return new RegExp(`(?:^|[ ${o}])([${e}])(.${n})$`, 'u');
          }
          function ay(e) {
            return (t) => e.filter((e) => ('string' == typeof e ? e : String(e.id)).toLowerCase().includes(t.toLowerCase()));
          }
          function ly(e) {
            return e && 1 == e.length;
          }
          function cy(e) {
            return e.model.markers.has('mention');
          }
          var dy = n(7583),
            uy = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(dy.Z, uy);
          dy.Z.locals;
          function hy(e, t) {
            if (!e.childCount) return;
            const n = new Im(e.document),
              o = (function (e, t) {
                const n = t.createRangeIn(e),
                  o = new Po({ name: /^p|h\d+$/, styles: { 'mso-list': /.*/ } }),
                  i = [];
                for (const e of n)
                  if ('elementStart' === e.type && o.match(e.item)) {
                    const t = py(e.item);
                    i.push({ element: e.item, id: t.id, order: t.order, indent: t.indent });
                  }
                return i;
              })(e, n);
            if (!o.length) return;
            let i = null,
              r = 1;
            o.forEach((e, s) => {
              const a = (function (e, t) {
                  if (!e) return !0;
                  if (e.id !== t.id) return t.indent - e.indent != 1;
                  const n = t.element.previousSibling;
                  if (!n) return !0;
                  return (o = n), !(o.is('element', 'ol') || o.is('element', 'ul'));
                  var o;
                })(o[s - 1], e),
                l = a ? null : o[s - 1],
                c = ((u = e), (d = l) ? u.indent - d.indent : u.indent - 1);
              var d, u;
              if ((a && ((i = null), (r = 1)), !i || 0 !== c)) {
                const o = (function (e, t) {
                  const n = new RegExp(`@list l${e.id}:level${e.indent}\\s*({[^}]*)`, 'gi'),
                    o = /mso-level-number-format:([^;]{0,100});/gi,
                    i = /mso-level-start-at:\s{0,100}([0-9]{0,10})\s{0,100};/gi,
                    r = n.exec(t);
                  let s = 'decimal',
                    a = 'ol',
                    l = null;
                  if (r && r[1]) {
                    const t = o.exec(r[1]);
                    if ((t && t[1] && ((s = t[1].trim()), (a = 'bullet' !== s && 'image' !== s ? 'ol' : 'ul')), 'bullet' === s)) {
                      const t = (function (e) {
                        const t = (function (e) {
                          if (e.getChild(0).is('$text')) return null;
                          for (const t of e.getChildren()) {
                            if (!t.is('element', 'span')) continue;
                            const e = t.getChild(0);
                            return e.is('$text') ? e : e.getChild(0);
                          }
                        })(e);
                        if (!t) return null;
                        const n = t._data;
                        if ('o' === n) return 'circle';
                        if ('·' === n) return 'disc';
                        if ('§' === n) return 'square';
                        return null;
                      })(e.element);
                      t && (s = t);
                    } else {
                      const e = i.exec(r[1]);
                      e && e[1] && (l = parseInt(e[1]));
                    }
                  }
                  return { type: a, startIndex: l, style: my(s) };
                })(e, t);
                if (i) {
                  if (e.indent > r) {
                    const e = i.getChild(i.childCount - 1),
                      t = e.getChild(e.childCount - 1);
                    (i = gy(o, t, n)), (r += 1);
                  } else if (e.indent < r) {
                    const t = r - e.indent;
                    (i = (function (e, t) {
                      const n = e.getAncestors({ parentFirst: !0 });
                      let o = null,
                        i = 0;
                      for (const e of n)
                        if ((('ul' !== e.name && 'ol' !== e.name) || i++, i === t)) {
                          o = e;
                          break;
                        }
                      return o;
                    })(i, t)),
                      (r = parseInt(e.indent));
                  }
                } else i = gy(o, e.element, n);
                e.indent <= r && (i.is('element', o.type) || (i = n.rename(o.type, i)));
              }
              const h = (function (e, t) {
                return (
                  (function (e, t) {
                    const n = new Po({ name: 'span', styles: { 'mso-list': 'Ignore' } }),
                      o = t.createRangeIn(e);
                    for (const e of o) 'elementStart' === e.type && n.match(e.item) && t.remove(e.item);
                  })(e, t),
                  t.rename('li', e)
                );
              })(e.element, n);
              n.appendChild(h, i);
            });
          }
          function my(e) {
            if (e.startsWith('arabic-leading-zero')) return 'decimal-leading-zero';
            switch (e) {
              case 'alpha-upper':
                return 'upper-alpha';
              case 'alpha-lower':
                return 'lower-alpha';
              case 'roman-upper':
                return 'upper-roman';
              case 'roman-lower':
                return 'lower-roman';
              case 'circle':
              case 'disc':
              case 'square':
                return e;
              default:
                return null;
            }
          }
          function gy(e, t, n) {
            const o = t.parent,
              i = n.createElement(e.type),
              r = o.getChildIndex(t) + 1;
            return (
              n.insertChild(r, i, o),
              e.style && n.setStyle('list-style-type', e.style, i),
              e.startIndex && e.startIndex > 1 && n.setAttribute('start', e.startIndex, i),
              i
            );
          }
          function py(e) {
            const t = {},
              n = e.getStyle('mso-list');
            if (n) {
              const e = n.match(/(^|\s{1,100})l(\d+)/i),
                o = n.match(/\s{0,100}lfo(\d+)/i),
                i = n.match(/\s{0,100}level(\d+)/i);
              e && o && i && ((t.id = e[2]), (t.order = o[1]), (t.indent = i[1]));
            }
            return t;
          }
          const fy = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;
          class ky {
            constructor(e) {
              this.document = e;
            }
            isActive(e) {
              return fy.test(e);
            }
            execute(e) {
              const t = new Im(this.document),
                { body: n } = e._parsedData;
              !(function (e, t) {
                for (const n of e.getChildren())
                  if (n.is('element', 'b') && 'normal' === n.getStyle('font-weight')) {
                    const o = e.getChildIndex(n);
                    t.remove(n), t.insertChild(o, n.getChildren(), e);
                  }
              })(n, t),
                (function (e, t) {
                  for (const n of t.createRangeIn(e)) {
                    const e = n.item;
                    if (e.is('element', 'li')) {
                      const n = e.getChild(0);
                      n && n.is('element', 'p') && t.unwrapElement(n);
                    }
                  }
                })(n, t),
                (e.content = n);
            }
          }
          function by(e, t) {
            if (!e.childCount) return;
            const n = new Im(),
              o = (function (e, t) {
                const n = t.createRangeIn(e),
                  o = new Po({ name: /v:(.+)/ }),
                  i = [];
                for (const e of n) {
                  if ('elementStart' != e.type) continue;
                  const t = e.item,
                    n = (t.previousSibling && t.previousSibling.name) || null;
                  o.match(t) && t.getAttribute('o:gfxdata') && 'v:shapetype' !== n && i.push(e.item.getAttribute('id'));
                }
                return i;
              })(e, n);
            !(function (e, t, n) {
              const o = n.createRangeIn(t),
                i = new Po({ name: 'img' }),
                r = [];
              for (const t of o)
                if (i.match(t.item)) {
                  const n = t.item,
                    o = n.getAttribute('v:shapes') ? n.getAttribute('v:shapes').split(' ') : [];
                  o.length && o.every((t) => e.indexOf(t) > -1) ? r.push(n) : n.getAttribute('src') || r.push(n);
                }
              for (const e of r) n.remove(e);
            })(o, e, n),
              (function (e, t) {
                const n = t.createRangeIn(e),
                  o = new Po({ name: /v:(.+)/ }),
                  i = [];
                for (const e of n) 'elementStart' == e.type && o.match(e.item) && i.push(e.item);
                for (const e of i) t.remove(e);
              })(e, n);
            const i = (function (e, t) {
              const n = t.createRangeIn(e),
                o = new Po({ name: 'img' }),
                i = [];
              for (const e of n) o.match(e.item) && e.item.getAttribute('src').startsWith('file://') && i.push(e.item);
              return i;
            })(e, n);
            i.length &&
              (function (e, t, n) {
                if (e.length === t.length)
                  for (let o = 0; o < e.length; o++) {
                    const i = `data:${t[o].type};base64,${wy(t[o].hex)}`;
                    n.setAttribute('src', i, e[o]);
                  }
              })(
                i,
                (function (e) {
                  if (!e) return [];
                  const t = /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/,
                    n = new RegExp('(?:(' + t.source + '))([\\da-fA-F\\s]+)\\}', 'g'),
                    o = e.match(n),
                    i = [];
                  if (o)
                    for (const e of o) {
                      let n = !1;
                      e.includes('\\pngblip') ? (n = 'image/png') : e.includes('\\jpegblip') && (n = 'image/jpeg'),
                        n && i.push({ hex: e.replace(t, '').replace(/[^\da-fA-F]/g, ''), type: n });
                    }
                  return i;
                })(t),
                n
              );
          }
          function wy(e) {
            return btoa(
              e
                .match(/\w{2}/g)
                .map((e) => String.fromCharCode(parseInt(e, 16)))
                .join('')
            );
          }
          const _y = /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i,
            yy = /xmlns:o="urn:schemas-microsoft-com/i;
          class Ay {
            constructor(e) {
              this.document = e;
            }
            isActive(e) {
              return _y.test(e) || yy.test(e);
            }
            execute(e) {
              const { body: t, stylesString: n } = e._parsedData;
              hy(t, n), by(t, e.dataTransfer.getData('text/rtf')), (e.content = t);
            }
          }
          function Cy(e) {
            return e.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, (e, t) =>
              1 === t.length
                ? ' '
                : Array(t.length + 1)
                    .join('  ')
                    .substr(0, t.length)
            );
          }
          function vy(e, t) {
            const n = new DOMParser(),
              o = (function (e) {
                return Cy(Cy(e))
                  .replace(/(<span\s+style=['"]mso-spacerun:yes['"]>[^\S\r\n]*?)[\r\n]+([^\S\r\n]*<\/span>)/g, '$1$2')
                  .replace(/<span\s+style=['"]mso-spacerun:yes['"]><\/span>/g, '')
                  .replace(/ <\//g, ' </')
                  .replace(/ <o:p><\/o:p>/g, ' <o:p></o:p>')
                  .replace(/<o:p>(&nbsp;|\u00A0)<\/o:p>/g, '')
                  .replace(/>([^\S\r\n]*[\r\n]\s*)</g, '><');
              })(
                (function (e) {
                  const t = '</body>',
                    n = '</html>',
                    o = e.indexOf(t);
                  if (o < 0) return e;
                  const i = e.indexOf(n, o + t.length);
                  return e.substring(0, o + t.length) + (i >= 0 ? e.substring(i) : '');
                })((e = e.replace(/<!--\[if gte vml 1]>/g, '')))
              ),
              i = n.parseFromString(o, 'text/html');
            !(function (e) {
              e.querySelectorAll('span[style*=spacerun]').forEach((e) => {
                const t = e.innerText.length || 0;
                e.innerText = Array(t + 1)
                  .join('  ')
                  .substr(0, t);
              });
            })(i);
            const r = i.body.innerHTML,
              s = (function (e, t) {
                const n = new er(t),
                  o = new ms(n, { renderingMode: 'data' }),
                  i = e.createDocumentFragment(),
                  r = e.body.childNodes;
                for (; r.length > 0; ) i.appendChild(r[0]);
                return o.domToView(i, { skipComments: !0 });
              })(i, t),
              a = (function (e) {
                const t = [],
                  n = [],
                  o = Array.from(e.getElementsByTagName('style'));
                for (const e of o) e.sheet && e.sheet.cssRules && e.sheet.cssRules.length && (t.push(e.sheet), n.push(e.innerHTML));
                return { styles: t, stylesString: n.join(' ') };
              })(i);
            return { body: s, bodyString: r, styles: a.styles, stylesString: a.stylesString };
          }
          function xy(e, t, n, o, i = 1) {
            t > i ? o.setAttribute(e, t, n) : o.removeAttribute(e, n);
          }
          function Ey(e, t, n = {}) {
            const o = e.createElement('tableCell', n);
            return e.insertElement('paragraph', o), e.insert(o, t), o;
          }
          function Dy(e, t) {
            const n = t.parent.parent,
              o = parseInt(n.getAttribute('headingColumns') || 0),
              { column: i } = e.getCellLocation(t);
            return !!o && i < o;
          }
          function Ty() {
            return (e) => {
              e.on('element:table', (e, t, n) => {
                const o = t.viewItem;
                if (!n.consumable.test(o, { name: !0 })) return;
                const {
                    rows: i,
                    headingRows: r,
                    headingColumns: s,
                  } = (function (e) {
                    const t = { headingRows: 0, headingColumns: 0 },
                      n = [],
                      o = [];
                    let i;
                    for (const r of Array.from(e.getChildren()))
                      if ('tbody' === r.name || 'thead' === r.name || 'tfoot' === r.name) {
                        'thead' !== r.name || i || (i = r);
                        const e = Array.from(r.getChildren()).filter((e) => e.is('element', 'tr'));
                        for (const r of e)
                          if ('thead' === r.parent.name && r.parent === i) t.headingRows++, n.push(r);
                          else {
                            o.push(r);
                            const e = Sy(r);
                            e > t.headingColumns && (t.headingColumns = e);
                          }
                      }
                    return (t.rows = [...n, ...o]), t;
                  })(o),
                  a = {};
                s && (a.headingColumns = s), r && (a.headingRows = r);
                const l = n.writer.createElement('table', a);
                if (n.safeInsert(l, t.modelCursor)) {
                  if (
                    (n.consumable.consume(o, { name: !0 }),
                    i.forEach((e) => n.convertItem(e, n.writer.createPositionAt(l, 'end'))),
                    n.convertChildren(o, n.writer.createPositionAt(l, 'end')),
                    l.isEmpty)
                  ) {
                    const e = n.writer.createElement('tableRow');
                    n.writer.insert(e, n.writer.createPositionAt(l, 'end')), Ey(n.writer, n.writer.createPositionAt(e, 'end'));
                  }
                  n.updateConversionResult(l, t);
                }
              });
            };
          }
          function Iy(e) {
            return (t) => {
              t.on(
                `element:${e}`,
                (e, t, n) => {
                  if (t.modelRange && t.viewItem.isEmpty) {
                    const e = t.modelRange.start.nodeAfter,
                      o = n.writer.createPositionAt(e, 0);
                    n.writer.insertElement('paragraph', o);
                  }
                },
                { priority: 'low' }
              );
            };
          }
          function Sy(e) {
            let t = 0,
              n = 0;
            const o = Array.from(e.getChildren()).filter((e) => 'th' === e.name || 'td' === e.name);
            for (; n < o.length && 'th' === o[n].name; ) {
              const e = o[n];
              (t += parseInt(e.getAttribute('colspan') || 1)), n++;
            }
            return t;
          }
          class My {
            constructor(e, t = {}) {
              (this._table = e),
                (this._startRow = void 0 !== t.row ? t.row : t.startRow || 0),
                (this._endRow = void 0 !== t.row ? t.row : t.endRow),
                (this._startColumn = void 0 !== t.column ? t.column : t.startColumn || 0),
                (this._endColumn = void 0 !== t.column ? t.column : t.endColumn),
                (this._includeAllSlots = !!t.includeAllSlots),
                (this._skipRows = new Set()),
                (this._row = 0),
                (this._rowIndex = 0),
                (this._column = 0),
                (this._cellIndex = 0),
                (this._spannedCells = new Map()),
                (this._nextCellAtColumn = -1);
            }
            [Symbol.iterator]() {
              return this;
            }
            next() {
              const e = this._table.getChild(this._rowIndex);
              if (!e || this._isOverEndRow()) return { done: !0 };
              if (!e.is('element', 'tableRow')) return this._rowIndex++, this.next();
              if (this._isOverEndColumn()) return this._advanceToNextRow();
              let t = null;
              const n = this._getSpanned();
              if (n) this._includeAllSlots && !this._shouldSkipSlot() && (t = this._formatOutValue(n.cell, n.row, n.column));
              else {
                const n = e.getChild(this._cellIndex);
                if (!n) return this._advanceToNextRow();
                const o = parseInt(n.getAttribute('colspan') || 1),
                  i = parseInt(n.getAttribute('rowspan') || 1);
                (o > 1 || i > 1) && this._recordSpans(n, i, o),
                  this._shouldSkipSlot() || (t = this._formatOutValue(n)),
                  (this._nextCellAtColumn = this._column + o);
              }
              return this._column++, this._column == this._nextCellAtColumn && this._cellIndex++, t || this.next();
            }
            skipRow(e) {
              this._skipRows.add(e);
            }
            _advanceToNextRow() {
              return this._row++, this._rowIndex++, (this._column = 0), (this._cellIndex = 0), (this._nextCellAtColumn = -1), this.next();
            }
            _isOverEndRow() {
              return void 0 !== this._endRow && this._row > this._endRow;
            }
            _isOverEndColumn() {
              return void 0 !== this._endColumn && this._column > this._endColumn;
            }
            _formatOutValue(e, t = this._row, n = this._column) {
              return { done: !1, value: new By(this, e, t, n) };
            }
            _shouldSkipSlot() {
              const e = this._skipRows.has(this._row),
                t = this._row < this._startRow,
                n = this._column < this._startColumn,
                o = void 0 !== this._endColumn && this._column > this._endColumn;
              return e || t || n || o;
            }
            _getSpanned() {
              const e = this._spannedCells.get(this._row);
              return (e && e.get(this._column)) || null;
            }
            _recordSpans(e, t, n) {
              const o = { cell: e, row: this._row, column: this._column };
              for (let e = this._row; e < this._row + t; e++)
                for (let t = this._column; t < this._column + n; t++)
                  (e == this._row && t == this._column) || this._markSpannedCell(e, t, o);
            }
            _markSpannedCell(e, t, n) {
              this._spannedCells.has(e) || this._spannedCells.set(e, new Map());
              this._spannedCells.get(e).set(t, n);
            }
          }
          class By {
            constructor(e, t, n, o) {
              (this.cell = t),
                (this.row = e._row),
                (this.column = e._column),
                (this.cellAnchorRow = n),
                (this.cellAnchorColumn = o),
                (this._cellIndex = e._cellIndex),
                (this._rowIndex = e._rowIndex),
                (this._table = e._table);
            }
            get isAnchor() {
              return this.row === this.cellAnchorRow && this.column === this.cellAnchorColumn;
            }
            get cellWidth() {
              return parseInt(this.cell.getAttribute('colspan') || 1);
            }
            get cellHeight() {
              return parseInt(this.cell.getAttribute('rowspan') || 1);
            }
            get rowIndex() {
              return this._rowIndex;
            }
            getPositionBefore() {
              return this._table.root.document.model.createPositionAt(this._table.getChild(this.row), this._cellIndex);
            }
          }
          function Ny(e, t = {}) {
            return (n, { writer: o }) => {
              const i = n.getAttribute('headingRows') || 0,
                r = [];
              i > 0 &&
                r.push(
                  o.createContainerElement(
                    'thead',
                    null,
                    o.createSlot((e) => e.is('element', 'tableRow') && e.index < i)
                  )
                ),
                i < e.getRows(n) &&
                  r.push(
                    o.createContainerElement(
                      'tbody',
                      null,
                      o.createSlot((e) => e.is('element', 'tableRow') && e.index >= i)
                    )
                  );
              const s = o.createContainerElement('figure', { class: 'table' }, [
                o.createContainerElement('table', null, r),
                o.createSlot((e) => !e.is('element', 'tableRow')),
              ]);
              return t.asWidget
                ? (function (e, t) {
                    return t.setCustomProperty('table', !0, e), ef(e, t, { hasSelectionHandle: !0 });
                  })(s, o)
                : s;
            };
          }
          function Py(e = {}) {
            return (t, { writer: n }) => {
              const o = t.parent,
                i = o.parent,
                r = i.getChildIndex(o),
                s = new My(i, { row: r }),
                a = i.getAttribute('headingRows') || 0,
                l = i.getAttribute('headingColumns') || 0;
              for (const o of s)
                if (o.cell == t) {
                  const t = o.row < a || o.column < l ? 'th' : 'td';
                  return e.asWidget ? sf(n.createEditableElement(t), n) : n.createContainerElement(t);
                }
            };
          }
          function zy(e = {}) {
            return (t, { writer: n, consumable: o, mapper: i }) => {
              if (t.parent.is('element', 'tableCell') && Ly(t))
                return e.asWidget
                  ? n.createContainerElement('span', { class: 'ck-table-bogus-paragraph' })
                  : (o.consume(t, 'insert'), void i.bindElements(t, i.toViewElement(t.parent)));
            };
          }
          function Ly(e) {
            return 1 == e.parent.childCount && ![...e.getAttributeKeys()].length;
          }
          class jy extends H {
            refresh() {
              const e = this.editor.model,
                t = e.document.selection,
                n = e.schema;
              this.isEnabled = (function (e, t) {
                const n = e.getFirstPosition().parent,
                  o = n === n.root ? n : n.parent;
                return t.checkChild(o, 'table');
              })(t, n);
            }
            execute(e = {}) {
              const t = this.editor.model,
                n = this.editor.plugins.get('TableUtils'),
                o = this.editor.config.get('table'),
                i = o.defaultHeadings.rows,
                r = o.defaultHeadings.columns;
              void 0 === e.headingRows && i && (e.headingRows = i),
                void 0 === e.headingColumns && r && (e.headingColumns = r),
                t.change((o) => {
                  const i = n.createTable(o, e);
                  t.insertObject(i, null, null, { findOptimalPosition: 'auto' }),
                    o.setSelection(o.createPositionAt(i.getNodeByPath([0, 0, 0]), 0));
                });
            }
          }
          class Oy extends H {
            constructor(e, t = {}) {
              super(e), (this.order = t.order || 'below');
            }
            refresh() {
              const e = this.editor.model.document.selection,
                t = !!this.editor.plugins.get('TableUtils').getSelectionAffectedTableCells(e).length;
              this.isEnabled = t;
            }
            execute() {
              const e = this.editor,
                t = e.model.document.selection,
                n = e.plugins.get('TableUtils'),
                o = 'above' === this.order,
                i = n.getSelectionAffectedTableCells(t),
                r = n.getRowIndexes(i),
                s = o ? r.first : r.last,
                a = i[0].findAncestor('table');
              n.insertRows(a, { at: o ? s : s + 1, copyStructureFromAbove: !o });
            }
          }
          class Ry extends H {
            constructor(e, t = {}) {
              super(e), (this.order = t.order || 'right');
            }
            refresh() {
              const e = this.editor.model.document.selection,
                t = !!this.editor.plugins.get('TableUtils').getSelectionAffectedTableCells(e).length;
              this.isEnabled = t;
            }
            execute() {
              const e = this.editor,
                t = e.model.document.selection,
                n = e.plugins.get('TableUtils'),
                o = 'left' === this.order,
                i = n.getSelectionAffectedTableCells(t),
                r = n.getColumnIndexes(i),
                s = o ? r.first : r.last,
                a = i[0].findAncestor('table');
              n.insertColumns(a, { columns: 1, at: o ? s : s + 1 });
            }
          }
          class Vy extends H {
            constructor(e, t = {}) {
              super(e), (this.direction = t.direction || 'horizontally');
            }
            refresh() {
              const e = this.editor.plugins.get('TableUtils').getSelectionAffectedTableCells(this.editor.model.document.selection);
              this.isEnabled = 1 === e.length;
            }
            execute() {
              const e = this.editor.plugins.get('TableUtils'),
                t = e.getSelectionAffectedTableCells(this.editor.model.document.selection)[0];
              'horizontally' === this.direction ? e.splitCellHorizontally(t, 2) : e.splitCellVertically(t, 2);
            }
          }
          function Fy(e, t, n) {
            const { startRow: o, startColumn: i, endRow: r, endColumn: s } = t,
              a = n.createElement('table'),
              l = r - o + 1;
            for (let e = 0; e < l; e++) n.insertElement('tableRow', a, 'end');
            const c = [...new My(e, { startRow: o, endRow: r, startColumn: i, endColumn: s, includeAllSlots: !0 })];
            for (const { row: e, column: t, cell: l, isAnchor: d, cellAnchorRow: u, cellAnchorColumn: h } of c) {
              const c = e - o,
                m = a.getChild(c);
              if (d) {
                const o = n.cloneElement(l);
                n.append(o, m), Gy(o, e, t, r, s, n);
              } else (u < o || h < i) && Ey(n, n.createPositionAt(m, 'end'));
            }
            return (
              (function (e, t, n, o, i) {
                const r = parseInt(t.getAttribute('headingRows') || 0);
                if (r > 0) {
                  xy('headingRows', r - n, e, i, 0);
                }
                const s = parseInt(t.getAttribute('headingColumns') || 0);
                if (s > 0) {
                  xy('headingColumns', s - o, e, i, 0);
                }
              })(a, e, o, i, n),
              a
            );
          }
          function Hy(e, t, n = 0) {
            const o = [],
              i = new My(e, { startRow: n, endRow: t - 1 });
            for (const e of i) {
              const { row: n, cellHeight: i } = e,
                r = n + i - 1;
              n < t && t <= r && o.push(e);
            }
            return o;
          }
          function Uy(e, t, n) {
            const o = e.parent,
              i = o.parent,
              r = o.index,
              s = t - r,
              a = {},
              l = parseInt(e.getAttribute('rowspan')) - s;
            l > 1 && (a.rowspan = l);
            const c = parseInt(e.getAttribute('colspan') || 1);
            c > 1 && (a.colspan = c);
            const d = r + s,
              u = [...new My(i, { startRow: r, endRow: d, includeAllSlots: !0 })];
            let h,
              m = null;
            for (const t of u) {
              const { row: o, column: i, cell: r } = t;
              r === e && void 0 === h && (h = i), void 0 !== h && h === i && o === d && (m = Ey(n, t.getPositionBefore(), a));
            }
            return xy('rowspan', s, e, n), m;
          }
          function qy(e, t) {
            const n = [],
              o = new My(e);
            for (const e of o) {
              const { column: o, cellWidth: i } = e,
                r = o + i - 1;
              o < t && t <= r && n.push(e);
            }
            return n;
          }
          function Wy(e, t, n, o) {
            const i = n - t,
              r = {},
              s = parseInt(e.getAttribute('colspan')) - i;
            s > 1 && (r.colspan = s);
            const a = parseInt(e.getAttribute('rowspan') || 1);
            a > 1 && (r.rowspan = a);
            const l = Ey(o, o.createPositionAfter(e), r);
            return xy('colspan', i, e, o), l;
          }
          function Gy(e, t, n, o, i, r) {
            const s = parseInt(e.getAttribute('colspan') || 1),
              a = parseInt(e.getAttribute('rowspan') || 1);
            if (n + s - 1 > i) {
              xy('colspan', i - n + 1, e, r, 1);
            }
            if (t + a - 1 > o) {
              xy('rowspan', o - t + 1, e, r, 1);
            }
          }
          function $y(e, t) {
            const n = t.getColumns(e),
              o = new Array(n).fill(0);
            for (const { column: t } of new My(e)) o[t]++;
            const i = o.reduce((e, t, n) => (t ? e : [...e, n]), []);
            if (i.length > 0) {
              const n = i[i.length - 1];
              return t.removeColumns(e, { at: n }), !0;
            }
            return !1;
          }
          function Yy(e, t) {
            const n = [],
              o = t.getRows(e);
            for (let t = 0; t < o; t++) {
              e.getChild(t).isEmpty && n.push(t);
            }
            if (n.length > 0) {
              const o = n[n.length - 1];
              return t.removeRows(e, { at: o }), !0;
            }
            return !1;
          }
          function Ky(e, t) {
            $y(e, t) || Yy(e, t);
          }
          function Qy(e, t) {
            const n = Array.from(new My(e, { startColumn: t.firstColumn, endColumn: t.lastColumn, row: t.lastRow }));
            if (n.every(({ cellHeight: e }) => 1 === e)) return t.lastRow;
            const o = n[0].cellHeight - 1;
            return t.lastRow + o;
          }
          function Zy(e, t) {
            const n = Array.from(new My(e, { startRow: t.firstRow, endRow: t.lastRow, column: t.lastColumn }));
            if (n.every(({ cellWidth: e }) => 1 === e)) return t.lastColumn;
            const o = n[0].cellWidth - 1;
            return t.lastColumn + o;
          }
          class Jy extends H {
            constructor(e, t) {
              super(e), (this.direction = t.direction), (this.isHorizontal = 'right' == this.direction || 'left' == this.direction);
            }
            refresh() {
              const e = this._getMergeableCell();
              (this.value = e), (this.isEnabled = !!e);
            }
            execute() {
              const e = this.editor.model,
                t = e.document,
                n = this.editor.plugins.get('TableUtils').getTableCellsContainingSelection(t.selection)[0],
                o = this.value,
                i = this.direction;
              e.change((e) => {
                const t = 'right' == i || 'down' == i,
                  r = t ? n : o,
                  s = t ? o : n,
                  a = s.parent;
                !(function (e, t, n) {
                  Xy(e) || (Xy(t) && n.remove(n.createRangeIn(t)), n.move(n.createRangeIn(e), n.createPositionAt(t, 'end')));
                  n.remove(e);
                })(s, r, e);
                const l = this.isHorizontal ? 'colspan' : 'rowspan',
                  c = parseInt(n.getAttribute(l) || 1),
                  d = parseInt(o.getAttribute(l) || 1);
                e.setAttribute(l, c + d, r), e.setSelection(e.createRangeIn(r));
                const u = this.editor.plugins.get('TableUtils');
                Ky(a.findAncestor('table'), u);
              });
            }
            _getMergeableCell() {
              const e = this.editor.model.document,
                t = this.editor.plugins.get('TableUtils'),
                n = t.getTableCellsContainingSelection(e.selection)[0];
              if (!n) return;
              const o = this.isHorizontal
                ? (function (e, t, n) {
                    const o = e.parent.parent,
                      i = 'right' == t ? e.nextSibling : e.previousSibling,
                      r = (o.getAttribute('headingColumns') || 0) > 0;
                    if (!i) return;
                    const s = 'right' == t ? e : i,
                      a = 'right' == t ? i : e,
                      { column: l } = n.getCellLocation(s),
                      { column: c } = n.getCellLocation(a),
                      d = parseInt(s.getAttribute('colspan') || 1),
                      u = Dy(n, s),
                      h = Dy(n, a);
                    if (r && u != h) return;
                    return l + d === c ? i : void 0;
                  })(n, this.direction, t)
                : (function (e, t, n) {
                    const o = e.parent,
                      i = o.parent,
                      r = i.getChildIndex(o);
                    if (('down' == t && r === n.getRows(i) - 1) || ('up' == t && 0 === r)) return;
                    const s = parseInt(e.getAttribute('rowspan') || 1),
                      a = i.getAttribute('headingRows') || 0,
                      l = 'down' == t && r + s === a,
                      c = 'up' == t && r === a;
                    if (a && (l || c)) return;
                    const d = parseInt(e.getAttribute('rowspan') || 1),
                      u = 'down' == t ? r + d : r,
                      h = [...new My(i, { endRow: u })],
                      m = h.find((t) => t.cell === e).column,
                      g = h.find(({ row: e, cellHeight: n, column: o }) => o === m && ('down' == t ? e === u : u === e + n));
                    return g && g.cell;
                  })(n, this.direction, t);
              if (!o) return;
              const i = this.isHorizontal ? 'rowspan' : 'colspan',
                r = parseInt(n.getAttribute(i) || 1);
              return parseInt(o.getAttribute(i) || 1) === r ? o : void 0;
            }
          }
          function Xy(e) {
            return 1 == e.childCount && e.getChild(0).is('element', 'paragraph') && e.getChild(0).isEmpty;
          }
          class eA extends H {
            refresh() {
              const e = this.editor.plugins.get('TableUtils'),
                t = e.getSelectionAffectedTableCells(this.editor.model.document.selection),
                n = t[0];
              if (n) {
                const o = n.findAncestor('table'),
                  i = this.editor.plugins.get('TableUtils').getRows(o) - 1,
                  r = e.getRowIndexes(t),
                  s = 0 === r.first && r.last === i;
                this.isEnabled = !s;
              } else this.isEnabled = !1;
            }
            execute() {
              const e = this.editor.model,
                t = this.editor.plugins.get('TableUtils'),
                n = t.getSelectionAffectedTableCells(e.document.selection),
                o = t.getRowIndexes(n),
                i = n[0],
                r = i.findAncestor('table'),
                s = t.getCellLocation(i).column;
              e.change((e) => {
                const n = o.last - o.first + 1;
                t.removeRows(r, { at: o.first, rows: n });
                const i = (function (e, t, n, o) {
                  const i = e.getChild(Math.min(t, o - 1));
                  let r = i.getChild(0),
                    s = 0;
                  for (const e of i.getChildren()) {
                    if (s > n) return r;
                    (r = e), (s += parseInt(e.getAttribute('colspan') || 1));
                  }
                  return r;
                })(r, o.first, s, t.getRows(r));
                e.setSelection(e.createPositionAt(i, 0));
              });
            }
          }
          class tA extends H {
            refresh() {
              const e = this.editor.plugins.get('TableUtils'),
                t = e.getSelectionAffectedTableCells(this.editor.model.document.selection),
                n = t[0];
              if (n) {
                const o = n.findAncestor('table'),
                  i = e.getColumns(o),
                  { first: r, last: s } = e.getColumnIndexes(t);
                this.isEnabled = s - r < i - 1;
              } else this.isEnabled = !1;
            }
            execute() {
              const e = this.editor.plugins.get('TableUtils'),
                [t, n] = (function (e, t) {
                  const n = t.getSelectionAffectedTableCells(e),
                    o = n[0],
                    i = n.pop(),
                    r = [o, i];
                  return o.isBefore(i) ? r : r.reverse();
                })(this.editor.model.document.selection, e),
                o = t.parent.parent,
                i = [...new My(o)],
                r = { first: i.find((e) => e.cell === t).column, last: i.find((e) => e.cell === n).column },
                s = (function (e, t, n, o) {
                  return parseInt(n.getAttribute('colspan') || 1) > 1
                    ? n
                    : t.previousSibling || n.nextSibling
                    ? n.nextSibling || t.previousSibling
                    : o.first
                    ? e.reverse().find(({ column: e }) => e < o.first).cell
                    : e.reverse().find(({ column: e }) => e > o.last).cell;
                })(i, t, n, r);
              this.editor.model.change((e) => {
                const t = r.last - r.first + 1;
                this.editor.plugins.get('TableUtils').removeColumns(o, { at: r.first, columns: t }),
                  e.setSelection(e.createPositionAt(s, 0));
              });
            }
          }
          class nA extends H {
            refresh() {
              const e = this.editor.plugins.get('TableUtils'),
                t = this.editor.model,
                n = e.getSelectionAffectedTableCells(t.document.selection),
                o = n.length > 0;
              (this.isEnabled = o), (this.value = o && n.every((e) => this._isInHeading(e, e.parent.parent)));
            }
            execute(e = {}) {
              if (e.forceValue === this.value) return;
              const t = this.editor.plugins.get('TableUtils'),
                n = this.editor.model,
                o = t.getSelectionAffectedTableCells(n.document.selection),
                i = o[0].findAncestor('table'),
                { first: r, last: s } = t.getRowIndexes(o),
                a = this.value ? r : s + 1,
                l = i.getAttribute('headingRows') || 0;
              n.change((e) => {
                if (a) {
                  const t = Hy(i, a, a > l ? l : 0);
                  for (const { cell: n } of t) Uy(n, a, e);
                }
                xy('headingRows', a, i, e, 0);
              });
            }
            _isInHeading(e, t) {
              const n = parseInt(t.getAttribute('headingRows') || 0);
              return !!n && e.parent.index < n;
            }
          }
          class oA extends H {
            refresh() {
              const e = this.editor.model,
                t = this.editor.plugins.get('TableUtils'),
                n = t.getSelectionAffectedTableCells(e.document.selection),
                o = n.length > 0;
              (this.isEnabled = o), (this.value = o && n.every((e) => Dy(t, e)));
            }
            execute(e = {}) {
              if (e.forceValue === this.value) return;
              const t = this.editor.plugins.get('TableUtils'),
                n = this.editor.model,
                o = t.getSelectionAffectedTableCells(n.document.selection),
                i = o[0].findAncestor('table'),
                { first: r, last: s } = t.getColumnIndexes(o),
                a = this.value ? r : s + 1;
              n.change((e) => {
                if (a) {
                  const t = qy(i, a);
                  for (const { cell: n, column: o } of t) Wy(n, o, a, e);
                }
                xy('headingColumns', a, i, e, 0);
              });
            }
          }
          class iA extends V {
            static get pluginName() {
              return 'TableUtils';
            }
            init() {
              this.decorate('insertColumns'), this.decorate('insertRows');
            }
            getCellLocation(e) {
              const t = e.parent,
                n = t.parent,
                o = n.getChildIndex(t),
                i = new My(n, { row: o });
              for (const { cell: t, row: n, column: o } of i) if (t === e) return { row: n, column: o };
            }
            createTable(e, t) {
              const n = e.createElement('table'),
                o = parseInt(t.rows) || 2,
                i = parseInt(t.columns) || 2;
              return (
                rA(e, n, 0, o, i),
                t.headingRows && xy('headingRows', Math.min(t.headingRows, o), n, e, 0),
                t.headingColumns && xy('headingColumns', Math.min(t.headingColumns, i), n, e, 0),
                n
              );
            }
            insertRows(e, t = {}) {
              const n = this.editor.model,
                o = t.at || 0,
                i = t.rows || 1,
                r = void 0 !== t.copyStructureFromAbove,
                s = t.copyStructureFromAbove ? o - 1 : o,
                a = this.getRows(e),
                c = this.getColumns(e);
              if (o > a) throw new l('tableutils-insertrows-insert-out-of-range', this, { options: t });
              n.change((t) => {
                const n = e.getAttribute('headingRows') || 0;
                if ((n > o && xy('headingRows', n + i, e, t, 0), !r && (0 === o || o === a))) return void rA(t, e, o, i, c);
                const l = r ? Math.max(o, s) : o,
                  d = new My(e, { endRow: l }),
                  u = new Array(c).fill(1);
                for (const { row: e, column: n, cellHeight: a, cellWidth: l, cell: c } of d) {
                  const d = e + a - 1,
                    h = e <= s && s <= d;
                  e < o && o <= d ? (t.setAttribute('rowspan', a + i, c), (u[n] = -l)) : r && h && (u[n] = l);
                }
                for (let n = 0; n < i; n++) {
                  const n = t.createElement('tableRow');
                  t.insert(n, e, o);
                  for (let e = 0; e < u.length; e++) {
                    const o = u[e],
                      i = t.createPositionAt(n, 'end');
                    o > 0 && Ey(t, i, o > 1 ? { colspan: o } : null), (e += Math.abs(o) - 1);
                  }
                }
              });
            }
            insertColumns(e, t = {}) {
              const n = this.editor.model,
                o = t.at || 0,
                i = t.columns || 1;
              n.change((t) => {
                const n = e.getAttribute('headingColumns');
                o < n && t.setAttribute('headingColumns', n + i, e);
                const r = this.getColumns(e);
                if (0 === o || r === o) {
                  for (const n of e.getChildren()) n.is('element', 'tableRow') && sA(i, t, t.createPositionAt(n, o ? 'end' : 0));
                  return;
                }
                const s = new My(e, { column: o, includeAllSlots: !0 });
                for (const e of s) {
                  const { row: n, cell: r, cellAnchorColumn: a, cellAnchorRow: l, cellWidth: c, cellHeight: d } = e;
                  if (a < o) {
                    t.setAttribute('colspan', c + i, r);
                    const e = l + d - 1;
                    for (let t = n; t <= e; t++) s.skipRow(t);
                  } else sA(i, t, e.getPositionBefore());
                }
              });
            }
            removeRows(e, t) {
              const n = this.editor.model,
                o = t.rows || 1,
                i = this.getRows(e),
                r = t.at,
                s = r + o - 1;
              if (s > i - 1) throw new l('tableutils-removerows-row-index-out-of-range', this, { table: e, options: t });
              n.change((t) => {
                const { cellsToMove: n, cellsToTrim: o } = (function (e, t, n) {
                  const o = new Map(),
                    i = [];
                  for (const { row: r, column: s, cellHeight: a, cell: l } of new My(e, { endRow: n })) {
                    const e = r + a - 1;
                    if (r >= t && r <= n && e > n) {
                      const e = a - (n - r + 1);
                      o.set(s, { cell: l, rowspan: e });
                    }
                    if (r < t && e >= t) {
                      let o;
                      (o = e >= n ? n - t + 1 : e - t + 1), i.push({ cell: l, rowspan: a - o });
                    }
                  }
                  return { cellsToMove: o, cellsToTrim: i };
                })(e, r, s);
                if (n.size) {
                  !(function (e, t, n, o) {
                    const i = [...new My(e, { includeAllSlots: !0, row: t })],
                      r = e.getChild(t);
                    let s;
                    for (const { column: e, cell: t, isAnchor: a } of i)
                      if (n.has(e)) {
                        const { cell: t, rowspan: i } = n.get(e),
                          a = s ? o.createPositionAfter(s) : o.createPositionAt(r, 0);
                        o.move(o.createRangeOn(t), a), xy('rowspan', i, t, o), (s = t);
                      } else a && (s = t);
                  })(e, s + 1, n, t);
                }
                for (let n = s; n >= r; n--) t.remove(e.getChild(n));
                for (const { rowspan: e, cell: n } of o) xy('rowspan', e, n, t);
                !(function (e, t, n, o) {
                  const i = e.getAttribute('headingRows') || 0;
                  if (t < i) {
                    xy('headingRows', n < i ? i - (n - t + 1) : t, e, o, 0);
                  }
                })(e, r, s, t),
                  $y(e, this) || Yy(e, this);
              });
            }
            removeColumns(e, t) {
              const n = this.editor.model,
                o = t.at,
                i = t.columns || 1,
                r = t.at + i - 1;
              n.change((t) => {
                !(function (e, t, n) {
                  const o = e.getAttribute('headingColumns') || 0;
                  if (o && t.first < o) {
                    const i = Math.min(o - 1, t.last) - t.first + 1;
                    n.setAttribute('headingColumns', o - i, e);
                  }
                })(e, { first: o, last: r }, t);
                for (let n = r; n >= o; n--)
                  for (const { cell: o, column: i, cellWidth: r } of [...new My(e)])
                    i <= n && r > 1 && i + r > n ? xy('colspan', r - 1, o, t) : i === n && t.remove(o);
                Yy(e, this) || $y(e, this);
              });
            }
            splitCellVertically(e, t = 2) {
              const n = this.editor.model,
                o = e.parent.parent,
                i = parseInt(e.getAttribute('rowspan') || 1),
                r = parseInt(e.getAttribute('colspan') || 1);
              n.change((n) => {
                if (r > 1) {
                  const { newCellsSpan: o, updatedSpan: s } = aA(r, t);
                  xy('colspan', s, e, n);
                  const a = {};
                  o > 1 && (a.colspan = o), i > 1 && (a.rowspan = i);
                  sA(r > t ? t - 1 : r - 1, n, n.createPositionAfter(e), a);
                }
                if (r < t) {
                  const s = t - r,
                    a = [...new My(o)],
                    { column: l } = a.find(({ cell: t }) => t === e),
                    c = a.filter(({ cell: t, cellWidth: n, column: o }) => (t !== e && o === l) || (o < l && o + n > l));
                  for (const { cell: e, cellWidth: t } of c) n.setAttribute('colspan', t + s, e);
                  const d = {};
                  i > 1 && (d.rowspan = i), sA(s, n, n.createPositionAfter(e), d);
                  const u = o.getAttribute('headingColumns') || 0;
                  u > l && xy('headingColumns', u + s, o, n);
                }
              });
            }
            splitCellHorizontally(e, t = 2) {
              const n = this.editor.model,
                o = e.parent,
                i = o.parent,
                r = i.getChildIndex(o),
                s = parseInt(e.getAttribute('rowspan') || 1),
                a = parseInt(e.getAttribute('colspan') || 1);
              n.change((n) => {
                if (s > 1) {
                  const o = [...new My(i, { startRow: r, endRow: r + s - 1, includeAllSlots: !0 })],
                    { newCellsSpan: l, updatedSpan: c } = aA(s, t);
                  xy('rowspan', c, e, n);
                  const { column: d } = o.find(({ cell: t }) => t === e),
                    u = {};
                  l > 1 && (u.rowspan = l), a > 1 && (u.colspan = a);
                  for (const e of o) {
                    const { column: t, row: o } = e,
                      i = t === d,
                      s = (o + r + c) % l == 0;
                    o >= r + c && i && s && sA(1, n, e.getPositionBefore(), u);
                  }
                }
                if (s < t) {
                  const o = t - s,
                    l = [...new My(i, { startRow: 0, endRow: r })];
                  for (const { cell: t, cellHeight: i, row: s } of l)
                    if (t !== e && s + i > r) {
                      const e = i + o;
                      n.setAttribute('rowspan', e, t);
                    }
                  const c = {};
                  a > 1 && (c.colspan = a), rA(n, i, r + 1, o, 1, c);
                  const d = i.getAttribute('headingRows') || 0;
                  d > r && xy('headingRows', d + o, i, n);
                }
              });
            }
            getColumns(e) {
              return [...e.getChild(0).getChildren()].reduce((e, t) => e + parseInt(t.getAttribute('colspan') || 1), 0);
            }
            getRows(e) {
              return Array.from(e.getChildren()).reduce((e, t) => (t.is('element', 'tableRow') ? e + 1 : e), 0);
            }
            createTableWalker(e, t = {}) {
              return new My(e, t);
            }
            getSelectedTableCells(e) {
              const t = [];
              for (const n of this.sortRanges(e.getRanges())) {
                const e = n.getContainedElement();
                e && e.is('element', 'tableCell') && t.push(e);
              }
              return t;
            }
            getTableCellsContainingSelection(e) {
              const t = [];
              for (const n of e.getRanges()) {
                const e = n.start.findAncestor('tableCell');
                e && t.push(e);
              }
              return t;
            }
            getSelectionAffectedTableCells(e) {
              const t = this.getSelectedTableCells(e);
              return t.length ? t : this.getTableCellsContainingSelection(e);
            }
            getRowIndexes(e) {
              const t = e.map((e) => e.parent.index);
              return this._getFirstLastIndexesObject(t);
            }
            getColumnIndexes(e) {
              const t = e[0].findAncestor('table'),
                n = [...new My(t)].filter((t) => e.includes(t.cell)).map((e) => e.column);
              return this._getFirstLastIndexesObject(n);
            }
            isSelectionRectangular(e) {
              if (e.length < 2 || !this._areCellInTheSameTableSection(e)) return !1;
              const t = new Set(),
                n = new Set();
              let o = 0;
              for (const i of e) {
                const { row: e, column: r } = this.getCellLocation(i),
                  s = parseInt(i.getAttribute('rowspan') || 1),
                  a = parseInt(i.getAttribute('colspan') || 1);
                t.add(e), n.add(r), s > 1 && t.add(e + s - 1), a > 1 && n.add(r + a - 1), (o += s * a);
              }
              const i = (function (e, t) {
                const n = Array.from(e.values()),
                  o = Array.from(t.values()),
                  i = Math.max(...n),
                  r = Math.min(...n),
                  s = Math.max(...o),
                  a = Math.min(...o);
                return (i - r + 1) * (s - a + 1);
              })(t, n);
              return i == o;
            }
            sortRanges(e) {
              return Array.from(e).sort(lA);
            }
            _getFirstLastIndexesObject(e) {
              const t = e.sort((e, t) => e - t);
              return { first: t[0], last: t[t.length - 1] };
            }
            _areCellInTheSameTableSection(e) {
              const t = e[0].findAncestor('table'),
                n = this.getRowIndexes(e),
                o = parseInt(t.getAttribute('headingRows') || 0);
              if (!this._areIndexesInSameSection(n, o)) return !1;
              const i = parseInt(t.getAttribute('headingColumns') || 0),
                r = this.getColumnIndexes(e);
              return this._areIndexesInSameSection(r, i);
            }
            _areIndexesInSameSection({ first: e, last: t }, n) {
              return e < n === t < n;
            }
          }
          function rA(e, t, n, o, i, r = {}) {
            for (let s = 0; s < o; s++) {
              const o = e.createElement('tableRow');
              e.insert(o, t, n), sA(i, e, e.createPositionAt(o, 'end'), r);
            }
          }
          function sA(e, t, n, o = {}) {
            for (let i = 0; i < e; i++) Ey(t, n, o);
          }
          function aA(e, t) {
            if (e < t) return { newCellsSpan: 1, updatedSpan: 1 };
            const n = Math.floor(e / t);
            return { newCellsSpan: n, updatedSpan: e - n * t + n };
          }
          function lA(e, t) {
            const n = e.start,
              o = t.start;
            return n.isBefore(o) ? -1 : 1;
          }
          class cA extends H {
            refresh() {
              const e = this.editor.plugins.get(iA),
                t = e.getSelectedTableCells(this.editor.model.document.selection);
              this.isEnabled = e.isSelectionRectangular(t, this.editor.plugins.get(iA));
            }
            execute() {
              const e = this.editor.model,
                t = this.editor.plugins.get(iA);
              e.change((n) => {
                const o = t.getSelectedTableCells(e.document.selection),
                  i = o.shift(),
                  { mergeWidth: r, mergeHeight: s } = (function (e, t, n) {
                    let o = 0,
                      i = 0;
                    for (const e of t) {
                      const { row: t, column: r } = n.getCellLocation(e);
                      (o = hA(e, r, o, 'colspan')), (i = hA(e, t, i, 'rowspan'));
                    }
                    const { row: r, column: s } = n.getCellLocation(e);
                    return { mergeWidth: o - s, mergeHeight: i - r };
                  })(i, o, t);
                xy('colspan', r, i, n), xy('rowspan', s, i, n);
                for (const e of o) dA(e, i, n);
                Ky(i.findAncestor('table'), t), n.setSelection(i, 'in');
              });
            }
          }
          function dA(e, t, n) {
            uA(e) || (uA(t) && n.remove(n.createRangeIn(t)), n.move(n.createRangeIn(e), n.createPositionAt(t, 'end'))), n.remove(e);
          }
          function uA(e) {
            return 1 == e.childCount && e.getChild(0).is('element', 'paragraph') && e.getChild(0).isEmpty;
          }
          function hA(e, t, n, o) {
            const i = parseInt(e.getAttribute(o) || 1);
            return Math.max(n, t + i);
          }
          class mA extends H {
            constructor(e) {
              super(e), (this.affectsData = !1);
            }
            refresh() {
              const e = this.editor.plugins.get('TableUtils').getSelectionAffectedTableCells(this.editor.model.document.selection);
              this.isEnabled = e.length > 0;
            }
            execute() {
              const e = this.editor.model,
                t = this.editor.plugins.get('TableUtils'),
                n = t.getSelectionAffectedTableCells(e.document.selection),
                o = t.getRowIndexes(n),
                i = n[0].findAncestor('table'),
                r = [];
              for (let t = o.first; t <= o.last; t++) for (const n of i.getChild(t).getChildren()) r.push(e.createRangeOn(n));
              e.change((e) => {
                e.setSelection(r);
              });
            }
          }
          class gA extends H {
            constructor(e) {
              super(e), (this.affectsData = !1);
            }
            refresh() {
              const e = this.editor.plugins.get('TableUtils').getSelectionAffectedTableCells(this.editor.model.document.selection);
              this.isEnabled = e.length > 0;
            }
            execute() {
              const e = this.editor.plugins.get('TableUtils'),
                t = this.editor.model,
                n = e.getSelectionAffectedTableCells(t.document.selection),
                o = n[0],
                i = n.pop(),
                r = o.findAncestor('table'),
                s = e.getCellLocation(o),
                a = e.getCellLocation(i),
                l = Math.min(s.column, a.column),
                c = Math.max(s.column, a.column),
                d = [];
              for (const e of new My(r, { startColumn: l, endColumn: c })) d.push(t.createRangeOn(e.cell));
              t.change((e) => {
                e.setSelection(d);
              });
            }
          }
          function pA(e) {
            e.document.registerPostFixer((t) =>
              (function (e, t) {
                const n = t.document.differ.getChanges();
                let o = !1;
                const i = new Set();
                for (const t of n) {
                  let n;
                  'table' == t.name && 'insert' == t.type && (n = t.position.nodeAfter),
                    ('tableRow' != t.name && 'tableCell' != t.name) || (n = t.position.findAncestor('table')),
                    bA(t) && (n = t.range.start.findAncestor('table')),
                    n && !i.has(n) && ((o = fA(n, e) || o), (o = kA(n, e) || o), i.add(n));
                }
                return o;
              })(t, e)
            );
          }
          function fA(e, t) {
            let n = !1;
            const o = (function (e) {
              const t = parseInt(e.getAttribute('headingRows') || 0),
                n = Array.from(e.getChildren()).reduce((e, t) => (t.is('element', 'tableRow') ? e + 1 : e), 0),
                o = [];
              for (const { row: i, cell: r, cellHeight: s } of new My(e)) {
                if (s < 2) continue;
                const e = i < t ? t : n;
                if (i + s > e) {
                  const t = e - i;
                  o.push({ cell: r, rowspan: t });
                }
              }
              return o;
            })(e);
            if (o.length) {
              n = !0;
              for (const e of o) xy('rowspan', e.rowspan, e.cell, t, 1);
            }
            return n;
          }
          function kA(e, t) {
            let n = !1;
            const o = (function (e) {
                const t = new Array(e.childCount).fill(0);
                for (const { rowIndex: n } of new My(e, { includeAllSlots: !0 })) t[n]++;
                return t;
              })(e),
              i = [];
            for (const [t, n] of o.entries()) !n && e.getChild(t).is('element', 'tableRow') && i.push(t);
            if (i.length) {
              n = !0;
              for (const n of i.reverse()) t.remove(e.getChild(n)), o.splice(n, 1);
            }
            const r = o.filter((t, n) => e.getChild(n).is('element', 'tableRow')),
              s = r[0];
            if (!r.every((e) => e === s)) {
              const o = r.reduce((e, t) => (t > e ? t : e), 0);
              for (const [i, s] of r.entries()) {
                const r = o - s;
                if (r) {
                  for (let n = 0; n < r; n++) Ey(t, t.createPositionAt(e.getChild(i), 'end'));
                  n = !0;
                }
              }
            }
            return n;
          }
          function bA(e) {
            const t = 'attribute' === e.type,
              n = e.attributeKey;
            return t && ('headingRows' === n || 'colspan' === n || 'rowspan' === n);
          }
          function wA(e) {
            e.document.registerPostFixer((t) =>
              (function (e, t) {
                const n = t.document.differ.getChanges();
                let o = !1;
                for (const t of n)
                  'insert' == t.type && 'table' == t.name && (o = _A(t.position.nodeAfter, e) || o),
                    'insert' == t.type && 'tableRow' == t.name && (o = yA(t.position.nodeAfter, e) || o),
                    'insert' == t.type && 'tableCell' == t.name && (o = AA(t.position.nodeAfter, e) || o),
                    CA(t) && (o = AA(t.position.parent, e) || o);
                return o;
              })(t, e)
            );
          }
          function _A(e, t) {
            let n = !1;
            for (const o of e.getChildren()) o.is('element', 'tableRow') && (n = yA(o, t) || n);
            return n;
          }
          function yA(e, t) {
            let n = !1;
            for (const o of e.getChildren()) n = AA(o, t) || n;
            return n;
          }
          function AA(e, t) {
            if (0 == e.childCount) return t.insertElement('paragraph', e), !0;
            const n = Array.from(e.getChildren()).filter((e) => e.is('$text'));
            for (const e of n) t.wrap(t.createRangeOn(e), 'paragraph');
            return !!n.length;
          }
          function CA(e) {
            return (
              !(!e.position || !e.position.parent.is('element', 'tableCell')) &&
              (('insert' == e.type && '$text' == e.name) || 'remove' == e.type)
            );
          }
          function vA(e, t) {
            if (!e.is('element', 'paragraph')) return !1;
            const n = t.toViewElement(e);
            return !!n && Ly(e) !== n.is('element', 'span');
          }
          var xA = n(4777),
            EA = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(xA.Z, EA);
          xA.Z.locals;
          class DA extends V {
            static get pluginName() {
              return 'TableEditing';
            }
            static get requires() {
              return [iA];
            }
            init() {
              const e = this.editor,
                t = e.model,
                n = t.schema,
                o = e.conversion,
                i = e.plugins.get(iA);
              n.register('table', { inheritAllFrom: '$blockObject', allowAttributes: ['headingRows', 'headingColumns'] }),
                n.register('tableRow', { allowIn: 'table', isLimit: !0 }),
                n.register('tableCell', {
                  allowContentOf: '$container',
                  allowIn: 'tableRow',
                  allowAttributes: ['colspan', 'rowspan'],
                  isLimit: !0,
                  isSelectable: !0,
                }),
                o.for('upcast').add((e) => {
                  e.on('element:figure', (e, t, n) => {
                    if (!n.consumable.test(t.viewItem, { name: !0, classes: 'table' })) return;
                    const o = (function (e) {
                      for (const t of e.getChildren()) if (t.is('element', 'table')) return t;
                    })(t.viewItem);
                    if (!o || !n.consumable.test(o, { name: !0 })) return;
                    n.consumable.consume(t.viewItem, { name: !0, classes: 'table' });
                    const i = Ca(n.convertItem(o, t.modelCursor).modelRange.getItems());
                    i
                      ? (n.convertChildren(t.viewItem, n.writer.createPositionAt(i, 'end')), n.updateConversionResult(i, t))
                      : n.consumable.revert(t.viewItem, { name: !0, classes: 'table' });
                  });
                }),
                o.for('upcast').add(Ty()),
                o
                  .for('editingDowncast')
                  .elementToStructure({ model: { name: 'table', attributes: ['headingRows'] }, view: Ny(i, { asWidget: !0 }) }),
                o.for('dataDowncast').elementToStructure({ model: { name: 'table', attributes: ['headingRows'] }, view: Ny(i) }),
                o.for('upcast').elementToElement({ model: 'tableRow', view: 'tr' }),
                o.for('upcast').add((e) => {
                  e.on(
                    'element:tr',
                    (e, t) => {
                      t.viewItem.isEmpty && 0 == t.modelCursor.index && e.stop();
                    },
                    { priority: 'high' }
                  );
                }),
                o.for('downcast').elementToElement({
                  model: 'tableRow',
                  view: (e, { writer: t }) => (e.isEmpty ? t.createEmptyElement('tr') : t.createContainerElement('tr')),
                }),
                o.for('upcast').elementToElement({ model: 'tableCell', view: 'td' }),
                o.for('upcast').elementToElement({ model: 'tableCell', view: 'th' }),
                o.for('upcast').add(Iy('td')),
                o.for('upcast').add(Iy('th')),
                o.for('editingDowncast').elementToElement({ model: 'tableCell', view: Py({ asWidget: !0 }) }),
                o.for('dataDowncast').elementToElement({ model: 'tableCell', view: Py() }),
                o.for('editingDowncast').elementToElement({ model: 'paragraph', view: zy({ asWidget: !0 }), converterPriority: 'high' }),
                o.for('dataDowncast').elementToElement({ model: 'paragraph', view: zy(), converterPriority: 'high' }),
                o.for('downcast').attributeToAttribute({ model: 'colspan', view: 'colspan' }),
                o.for('upcast').attributeToAttribute({ model: { key: 'colspan', value: TA('colspan') }, view: 'colspan' }),
                o.for('downcast').attributeToAttribute({ model: 'rowspan', view: 'rowspan' }),
                o.for('upcast').attributeToAttribute({ model: { key: 'rowspan', value: TA('rowspan') }, view: 'rowspan' }),
                e.data.mapper.on('modelToViewPosition', (e, t) => {
                  const n = t.modelPosition.parent,
                    o = t.modelPosition.nodeBefore;
                  if (!n.is('element', 'tableCell')) return;
                  if (!o || !o.is('element', 'paragraph')) return;
                  const i = t.mapper.toViewElement(o),
                    r = t.mapper.toViewElement(n);
                  i === r && (t.viewPosition = t.mapper.findPositionIn(r, o.maxOffset));
                }),
                e.config.define('table.defaultHeadings.rows', 0),
                e.config.define('table.defaultHeadings.columns', 0),
                e.commands.add('insertTable', new jy(e)),
                e.commands.add('insertTableRowAbove', new Oy(e, { order: 'above' })),
                e.commands.add('insertTableRowBelow', new Oy(e, { order: 'below' })),
                e.commands.add('insertTableColumnLeft', new Ry(e, { order: 'left' })),
                e.commands.add('insertTableColumnRight', new Ry(e, { order: 'right' })),
                e.commands.add('removeTableRow', new eA(e)),
                e.commands.add('removeTableColumn', new tA(e)),
                e.commands.add('splitTableCellVertically', new Vy(e, { direction: 'vertically' })),
                e.commands.add('splitTableCellHorizontally', new Vy(e, { direction: 'horizontally' })),
                e.commands.add('mergeTableCells', new cA(e)),
                e.commands.add('mergeTableCellRight', new Jy(e, { direction: 'right' })),
                e.commands.add('mergeTableCellLeft', new Jy(e, { direction: 'left' })),
                e.commands.add('mergeTableCellDown', new Jy(e, { direction: 'down' })),
                e.commands.add('mergeTableCellUp', new Jy(e, { direction: 'up' })),
                e.commands.add('setTableColumnHeader', new oA(e)),
                e.commands.add('setTableRowHeader', new nA(e)),
                e.commands.add('selectTableRow', new mA(e)),
                e.commands.add('selectTableColumn', new gA(e)),
                pA(t),
                wA(t),
                this.listenTo(t.document, 'change:data', () => {
                  !(function (e, t) {
                    const n = e.document.differ;
                    for (const e of n.getChanges()) {
                      let n,
                        o = !1;
                      if ('attribute' == e.type) {
                        const t = e.range.start.nodeAfter;
                        if (!t || !t.is('element', 'table')) continue;
                        if ('headingRows' != e.attributeKey && 'headingColumns' != e.attributeKey) continue;
                        (n = t), (o = 'headingRows' == e.attributeKey);
                      } else
                        ('tableRow' != e.name && 'tableCell' != e.name) ||
                          ((n = e.position.findAncestor('table')), (o = 'tableRow' == e.name));
                      if (!n) continue;
                      const i = n.getAttribute('headingRows') || 0,
                        r = n.getAttribute('headingColumns') || 0,
                        s = new My(n);
                      for (const e of s) {
                        const n = e.row < i || e.column < r ? 'th' : 'td',
                          s = t.mapper.toViewElement(e.cell);
                        s && s.is('element') && s.name != n && t.reconvertItem(o ? e.cell.parent : e.cell);
                      }
                    }
                  })(t, e.editing),
                    (function (e, t) {
                      const n = e.document.differ,
                        o = new Set();
                      for (const e of n.getChanges()) {
                        const t = 'attribute' == e.type ? e.range.start.parent : e.position.parent;
                        t.is('element', 'tableCell') && o.add(t);
                      }
                      for (const e of o.values()) {
                        const n = Array.from(e.getChildren()).filter((e) => vA(e, t.mapper));
                        for (const e of n) t.reconvertItem(e);
                      }
                    })(t, e.editing);
                });
            }
          }
          function TA(e) {
            return (t) => {
              const n = parseInt(t.getAttribute(e));
              return Number.isNaN(n) || n <= 0 ? null : n;
            };
          }
          var IA = n(8085),
            SA = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(IA.Z, SA);
          IA.Z.locals;
          class MA extends Jd {
            constructor(e) {
              super(e);
              const t = this.bindTemplate;
              (this._geometryLabelId = `ck-editor__label_${r()}`),
                (this.items = this._createGridCollection()),
                (this.keystrokes = new xa()),
                (this.focusTracker = new va()),
                this.set('rows', 0),
                this.set('columns', 0),
                this.bind('label').to(this, 'columns', this, 'rows', (e, t) => `${t} × ${e}`),
                this.setTemplate({
                  tag: 'div',
                  attributes: { class: ['ck'] },
                  children: [
                    {
                      tag: 'div',
                      attributes: { class: ['ck-insert-table-dropdown__grid'] },
                      on: { 'mouseover@.ck-insert-table-dropdown-grid-box': t.to('boxover') },
                      children: this.items,
                    },
                    {
                      tag: 'div',
                      attributes: { id: this._geometryLabelId, class: ['ck', 'ck-insert-table-dropdown__label'] },
                      children: [{ text: t.to('label') }],
                    },
                  ],
                  on: {
                    mousedown: t.to((e) => {
                      e.preventDefault();
                    }),
                    click: t.to(() => {
                      this.fire('execute');
                    }),
                    keydown: t.to((e) => {
                      'Enter' === e.key && (this.fire('execute'), e.preventDefault());
                    }),
                  },
                }),
                this.on('boxover', (e, t) => {
                  const { row: n, column: o } = t.target.dataset;
                  this.items.get(10 * (n - 1) + (o - 1)).focus();
                }),
                this.focusTracker.on('change:focusedElement', (e, t, n) => {
                  if (!n) return;
                  const { row: o, column: i } = n.dataset;
                  this.set({ rows: parseInt(o), columns: parseInt(i) });
                }),
                this.on('change:columns', () => this._highlightGridBoxes()),
                this.on('change:rows', () => this._highlightGridBoxes());
            }
            render() {
              super.render(),
                Du({ keystrokeHandler: this.keystrokes, focusTracker: this.focusTracker, gridItems: this.items, numberOfColumns: 10 });
              for (const e of this.items) this.focusTracker.add(e.element);
              this.keystrokes.listenTo(this.element);
            }
            focus() {
              this.items.get(0).focus();
            }
            focusLast() {
              this.items.get(0).focus();
            }
            _highlightGridBoxes() {
              const e = this.rows,
                t = this.columns;
              this.items.map((n, o) => {
                const i = Math.floor(o / 10) < e && o % 10 < t;
                n.set('isOn', i);
              });
            }
            _createGridCollection() {
              const e = [];
              for (let t = 0; t < 100; t++) {
                const n = Math.floor(t / 10),
                  o = t % 10;
                e.push(new BA(this.locale, n + 1, o + 1, this._geometryLabelId));
              }
              return this.createCollection(e);
            }
          }
          class BA extends Jd {
            constructor(e, t, n, o) {
              super(e);
              const i = this.bindTemplate;
              this.set('isOn', !1),
                this.setTemplate({
                  tag: 'div',
                  attributes: {
                    class: ['ck', 'ck-insert-table-dropdown-grid-box', i.if('isOn', 'ck-on')],
                    'data-row': t,
                    'data-column': n,
                    tabindex: -1,
                    'aria-labelledby': o,
                  },
                });
            }
            focus() {
              this.element.focus();
            }
          }
          class NA extends V {
            static get pluginName() {
              return 'TableUI';
            }
            init() {
              const e = this.editor,
                t = this.editor.t,
                n = 'ltr' === e.locale.contentLanguageDirection;
              e.ui.componentFactory.add('insertTable', (n) => {
                const o = e.commands.get('insertTable'),
                  i = yh(n);
                let r;
                return (
                  i.bind('isEnabled').to(o),
                  i.buttonView.set({
                    icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 6v3h4V6H3zm0 4v3h4v-3H3zm0 4v3h4v-3H3zm5 3h4v-3H8v3zm5 0h4v-3h-4v3zm4-4v-3h-4v3h4zm0-4V6h-4v3h4zm1.5 8a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 17V4c.222-.863 1.068-1.5 2-1.5h13c.932 0 1.778.637 2 1.5v13zM12 13v-3H8v3h4zm0-4V6H8v3h4z"/></svg>',
                    label: t('Insert table'),
                    tooltip: !0,
                  }),
                  i.on('change:isOpen', () => {
                    r ||
                      ((r = new MA(n)),
                      i.panelView.children.add(r),
                      r.delegate('execute').to(i),
                      i.on('execute', () => {
                        e.execute('insertTable', { rows: r.rows, columns: r.columns }), e.editing.view.focus();
                      }));
                  }),
                  i
                );
              }),
                e.ui.componentFactory.add('tableColumn', (e) => {
                  const o = [
                    { type: 'switchbutton', model: { commandName: 'setTableColumnHeader', label: t('Header column'), bindIsOn: !0 } },
                    { type: 'separator' },
                    {
                      type: 'button',
                      model: { commandName: n ? 'insertTableColumnLeft' : 'insertTableColumnRight', label: t('Insert column left') },
                    },
                    {
                      type: 'button',
                      model: { commandName: n ? 'insertTableColumnRight' : 'insertTableColumnLeft', label: t('Insert column right') },
                    },
                    { type: 'button', model: { commandName: 'removeTableColumn', label: t('Delete column') } },
                    { type: 'button', model: { commandName: 'selectTableColumn', label: t('Select column') } },
                  ];
                  return this._prepareDropdown(
                    t('Column'),
                    '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M18 7v1H2V7h16zm0 5v1H2v-1h16z" opacity=".6"/><path d="M14 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-2 1H8v4h4V2zm0 6H8v4h4V8zm0 6H8v4h4v-4z"/></svg>',
                    o,
                    e
                  );
                }),
                e.ui.componentFactory.add('tableRow', (e) => {
                  const n = [
                    { type: 'switchbutton', model: { commandName: 'setTableRowHeader', label: t('Header row'), bindIsOn: !0 } },
                    { type: 'separator' },
                    { type: 'button', model: { commandName: 'insertTableRowAbove', label: t('Insert row above') } },
                    { type: 'button', model: { commandName: 'insertTableRowBelow', label: t('Insert row below') } },
                    { type: 'button', model: { commandName: 'removeTableRow', label: t('Delete row') } },
                    { type: 'button', model: { commandName: 'selectTableRow', label: t('Select row') } },
                  ];
                  return this._prepareDropdown(
                    t('Row'),
                    '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v16h-1V2z" opacity=".6"/><path d="M1 6h18a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm1 2v4h4V8H2zm6 0v4h4V8H8zm6 0v4h4V8h-4z"/></svg>',
                    n,
                    e
                  );
                }),
                e.ui.componentFactory.add('mergeTableCells', (e) => {
                  const o = [
                    { type: 'button', model: { commandName: 'mergeTableCellUp', label: t('Merge cell up') } },
                    {
                      type: 'button',
                      model: { commandName: n ? 'mergeTableCellRight' : 'mergeTableCellLeft', label: t('Merge cell right') },
                    },
                    { type: 'button', model: { commandName: 'mergeTableCellDown', label: t('Merge cell down') } },
                    {
                      type: 'button',
                      model: { commandName: n ? 'mergeTableCellLeft' : 'mergeTableCellRight', label: t('Merge cell left') },
                    },
                    { type: 'separator' },
                    { type: 'button', model: { commandName: 'splitTableCellVertically', label: t('Split cell vertically') } },
                    { type: 'button', model: { commandName: 'splitTableCellHorizontally', label: t('Split cell horizontally') } },
                  ];
                  return this._prepareMergeSplitButtonDropdown(
                    t('Merge cells'),
                    '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v7h-1V2zm6 5v1H2V7h16zM8 12v1H2v-1h6z" opacity=".6"/><path d="M7 7h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm1 2v9h10V9H8z"/></svg>',
                    o,
                    e
                  );
                });
            }
            _prepareDropdown(e, t, n, o) {
              const i = this.editor,
                r = yh(o),
                s = this._fillDropdownWithListOptions(r, n);
              return (
                r.buttonView.set({ label: e, icon: t, tooltip: !0 }),
                r.bind('isEnabled').toMany(s, 'isEnabled', (...e) => e.some((e) => e)),
                this.listenTo(r, 'execute', (e) => {
                  i.execute(e.source.commandName), e.source instanceof Ou || i.editing.view.focus();
                }),
                r
              );
            }
            _prepareMergeSplitButtonDropdown(e, t, n, o) {
              const i = this.editor,
                r = yh(o, Qu),
                s = 'mergeTableCells',
                a = i.commands.get(s),
                l = this._fillDropdownWithListOptions(r, n);
              return (
                r.buttonView.set({ label: e, icon: t, tooltip: !0, isEnabled: !0 }),
                r.bind('isEnabled').toMany([a, ...l], 'isEnabled', (...e) => e.some((e) => e)),
                this.listenTo(r.buttonView, 'execute', () => {
                  i.execute(s), i.editing.view.focus();
                }),
                this.listenTo(r, 'execute', (e) => {
                  i.execute(e.source.commandName), i.editing.view.focus();
                }),
                r
              );
            }
            _fillDropdownWithListOptions(e, t) {
              const n = this.editor,
                o = [],
                i = new fo();
              for (const e of t) PA(e, n, o, i);
              return Ch(e, i, n.ui.componentFactory), o;
            }
          }
          function PA(e, t, n, o) {
            const i = (e.model = new $h(e.model)),
              { commandName: r, bindIsOn: s } = e.model;
            if ('button' === e.type || 'switchbutton' === e.type) {
              const e = t.commands.get(r);
              n.push(e), i.set({ commandName: r }), i.bind('isEnabled').to(e), s && i.bind('isOn').to(e, 'value');
            }
            i.set({ withText: !0 }), o.add(e);
          }
          var zA = n(5593),
            LA = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(zA.Z, LA);
          zA.Z.locals;
          class jA extends V {
            static get pluginName() {
              return 'TableSelection';
            }
            static get requires() {
              return [iA, iA];
            }
            init() {
              const e = this.editor.model;
              this.listenTo(e, 'deleteContent', (e, t) => this._handleDeleteContent(e, t), { priority: 'high' }),
                this._defineSelectionConverter(),
                this._enablePluginDisabling();
            }
            getSelectedTableCells() {
              const e = this.editor.plugins.get(iA),
                t = this.editor.model.document.selection,
                n = e.getSelectedTableCells(t);
              return 0 == n.length ? null : n;
            }
            getSelectionAsFragment() {
              const e = this.editor.plugins.get(iA),
                t = this.getSelectedTableCells();
              return t
                ? this.editor.model.change((n) => {
                    const o = n.createDocumentFragment(),
                      { first: i, last: r } = e.getColumnIndexes(t),
                      { first: s, last: a } = e.getRowIndexes(t),
                      l = t[0].findAncestor('table');
                    let c = a,
                      d = r;
                    if (e.isSelectionRectangular(t)) {
                      const e = { firstColumn: i, lastColumn: r, firstRow: s, lastRow: a };
                      (c = Qy(l, e)), (d = Zy(l, e));
                    }
                    const u = Fy(l, { startRow: s, startColumn: i, endRow: c, endColumn: d }, n);
                    return n.insert(u, o, 0), o;
                  })
                : null;
            }
            setCellSelection(e, t) {
              const n = this._getCellsToSelect(e, t);
              this.editor.model.change((e) => {
                e.setSelection(
                  n.cells.map((t) => e.createRangeOn(t)),
                  { backward: n.backward }
                );
              });
            }
            getFocusCell() {
              const e = [...this.editor.model.document.selection.getRanges()].pop().getContainedElement();
              return e && e.is('element', 'tableCell') ? e : null;
            }
            getAnchorCell() {
              const e = Ca(this.editor.model.document.selection.getRanges()).getContainedElement();
              return e && e.is('element', 'tableCell') ? e : null;
            }
            _defineSelectionConverter() {
              const e = this.editor,
                t = new Set();
              e.conversion.for('editingDowncast').add((e) =>
                e.on(
                  'selection',
                  (e, n, o) => {
                    const i = o.writer;
                    !(function (e) {
                      for (const n of t) e.removeClass('ck-editor__editable_selected', n);
                      t.clear();
                    })(i);
                    const r = this.getSelectedTableCells();
                    if (!r) return;
                    for (const e of r) {
                      const n = o.mapper.toViewElement(e);
                      i.addClass('ck-editor__editable_selected', n), t.add(n);
                    }
                    const s = o.mapper.toViewElement(r[r.length - 1]);
                    i.setSelection(s, 0);
                  },
                  { priority: 'lowest' }
                )
              );
            }
            _enablePluginDisabling() {
              const e = this.editor;
              this.on('change:isEnabled', () => {
                if (!this.isEnabled) {
                  const t = this.getSelectedTableCells();
                  if (!t) return;
                  e.model.change((n) => {
                    const o = n.createPositionAt(t[0], 0),
                      i = e.model.schema.getNearestSelectionRange(o);
                    n.setSelection(i);
                  });
                }
              });
            }
            _handleDeleteContent(e, t) {
              const n = this.editor.plugins.get(iA),
                [o, i] = t,
                r = this.editor.model,
                s = !i || 'backward' == i.direction,
                a = n.getSelectedTableCells(o);
              a.length &&
                (e.stop(),
                r.change((e) => {
                  const t = a[s ? a.length - 1 : 0];
                  r.change((e) => {
                    for (const t of a) r.deleteContent(e.createSelection(t, 'in'));
                  });
                  const n = r.schema.getNearestSelectionRange(e.createPositionAt(t, 0));
                  o.is('documentSelection') ? e.setSelection(n) : o.setTo(n);
                }));
            }
            _getCellsToSelect(e, t) {
              const n = this.editor.plugins.get('TableUtils'),
                o = n.getCellLocation(e),
                i = n.getCellLocation(t),
                r = Math.min(o.row, i.row),
                s = Math.max(o.row, i.row),
                a = Math.min(o.column, i.column),
                l = Math.max(o.column, i.column),
                c = new Array(s - r + 1).fill(null).map(() => []),
                d = { startRow: r, endRow: s, startColumn: a, endColumn: l };
              for (const { row: t, cell: n } of new My(e.findAncestor('table'), d)) c[t - r].push(n);
              const u = i.row < o.row,
                h = i.column < o.column;
              return u && c.reverse(), h && c.forEach((e) => e.reverse()), { cells: c.flat(), backward: u || h };
            }
          }
          class OA extends V {
            static get pluginName() {
              return 'TableClipboard';
            }
            static get requires() {
              return [jA, iA];
            }
            init() {
              const e = this.editor,
                t = e.editing.view.document;
              this.listenTo(t, 'copy', (e, t) => this._onCopyCut(e, t)),
                this.listenTo(t, 'cut', (e, t) => this._onCopyCut(e, t)),
                this.listenTo(e.model, 'insertContent', (e, t) => this._onInsertContent(e, ...t), { priority: 'high' }),
                this.decorate('_replaceTableSlotCell');
            }
            _onCopyCut(e, t) {
              const n = this.editor.plugins.get(jA);
              if (!n.getSelectedTableCells()) return;
              if ('cut' == e.name && this.editor.isReadOnly) return;
              t.preventDefault(), e.stop();
              const o = this.editor.data,
                i = this.editor.editing.view.document,
                r = o.toView(n.getSelectionAsFragment());
              i.fire('clipboardOutput', { dataTransfer: t.dataTransfer, content: r, method: e.name });
            }
            _onInsertContent(e, t, n) {
              if (n && !n.is('documentSelection')) return;
              const o = this.editor.model,
                i = this.editor.plugins.get(iA);
              let r = RA(t, o);
              if (!r) return;
              const s = i.getSelectionAffectedTableCells(o.document.selection);
              s.length
                ? (e.stop(),
                  o.change((e) => {
                    const t = { width: i.getColumns(r), height: i.getRows(r) },
                      n = (function (e, t, n, o) {
                        const i = e[0].findAncestor('table'),
                          r = o.getColumnIndexes(e),
                          s = o.getRowIndexes(e),
                          a = { firstColumn: r.first, lastColumn: r.last, firstRow: s.first, lastRow: s.last },
                          l = 1 === e.length;
                        l &&
                          ((a.lastRow += t.height - 1),
                          (a.lastColumn += t.width - 1),
                          (function (e, t, n, o) {
                            const i = o.getColumns(e),
                              r = o.getRows(e);
                            n > i && o.insertColumns(e, { at: i, columns: n - i });
                            t > r && o.insertRows(e, { at: r, rows: t - r });
                          })(i, a.lastRow + 1, a.lastColumn + 1, o));
                        l || !o.isSelectionRectangular(e)
                          ? (function (e, t, n) {
                              const { firstRow: o, lastRow: i, firstColumn: r, lastColumn: s } = t,
                                a = { first: o, last: i },
                                l = { first: r, last: s };
                              FA(e, r, a, n), FA(e, s + 1, a, n), VA(e, o, l, n), VA(e, i + 1, l, n, o);
                            })(i, a, n)
                          : ((a.lastRow = Qy(i, a)), (a.lastColumn = Zy(i, a)));
                        return a;
                      })(s, t, e, i),
                      o = n.lastRow - n.firstRow + 1,
                      a = n.lastColumn - n.firstColumn + 1,
                      l = { startRow: 0, startColumn: 0, endRow: Math.min(o, t.height) - 1, endColumn: Math.min(a, t.width) - 1 };
                    r = Fy(r, l, e);
                    const c = s[0].findAncestor('table'),
                      d = this._replaceSelectedCellsWithPasted(r, t, c, n, e);
                    if (this.editor.plugins.get('TableSelection').isEnabled) {
                      const t = i.sortRanges(d.map((t) => e.createRangeOn(t)));
                      e.setSelection(t);
                    } else e.setSelection(d[0], 0);
                  }))
                : Ky(r, i);
            }
            _replaceSelectedCellsWithPasted(e, t, n, o, i) {
              const { width: r, height: s } = t,
                a = (function (e, t, n) {
                  const o = new Array(n).fill(null).map(() => new Array(t).fill(null));
                  for (const { column: t, row: n, cell: i } of new My(e)) o[n][t] = i;
                  return o;
                })(e, r, s),
                l = [
                  ...new My(n, {
                    startRow: o.firstRow,
                    endRow: o.lastRow,
                    startColumn: o.firstColumn,
                    endColumn: o.lastColumn,
                    includeAllSlots: !0,
                  }),
                ],
                c = [];
              let d;
              for (const e of l) {
                const { row: t, column: n } = e;
                n === o.firstColumn && (d = e.getPositionBefore());
                const l = t - o.firstRow,
                  u = n - o.firstColumn,
                  h = a[l % s][u % r],
                  m = h ? i.cloneElement(h) : null,
                  g = this._replaceTableSlotCell(e, m, d, i);
                g && (Gy(g, t, n, o.lastRow, o.lastColumn, i), c.push(g), (d = i.createPositionAfter(g)));
              }
              const u = parseInt(n.getAttribute('headingRows') || 0),
                h = parseInt(n.getAttribute('headingColumns') || 0),
                m = o.firstRow < u && u <= o.lastRow,
                g = o.firstColumn < h && h <= o.lastColumn;
              if (m) {
                const e = VA(n, u, { first: o.firstColumn, last: o.lastColumn }, i, o.firstRow);
                c.push(...e);
              }
              if (g) {
                const e = FA(n, h, { first: o.firstRow, last: o.lastRow }, i);
                c.push(...e);
              }
              return c;
            }
            _replaceTableSlotCell(e, t, n, o) {
              const { cell: i, isAnchor: r } = e;
              return r && o.remove(i), t ? (o.insert(t, n), t) : null;
            }
            getTableIfOnlyTableInContent(e, t) {
              return RA(e, t);
            }
          }
          function RA(e, t) {
            if (!e.is('documentFragment') && !e.is('element')) return null;
            if (e.is('element', 'table')) return e;
            if (1 == e.childCount && e.getChild(0).is('element', 'table')) return e.getChild(0);
            const n = t.createRangeIn(e);
            for (const e of n.getItems())
              if (e.is('element', 'table')) {
                const o = t.createRange(n.start, t.createPositionBefore(e));
                if (t.hasContent(o, { ignoreWhitespaces: !0 })) return null;
                const i = t.createRange(t.createPositionAfter(e), n.end);
                return t.hasContent(i, { ignoreWhitespaces: !0 }) ? null : e;
              }
            return null;
          }
          function VA(e, t, n, o, i = 0) {
            if (t < 1) return;
            return Hy(e, t, i)
              .filter(({ column: e, cellWidth: t }) => HA(e, t, n))
              .map(({ cell: e }) => Uy(e, t, o));
          }
          function FA(e, t, n, o) {
            if (t < 1) return;
            return qy(e, t)
              .filter(({ row: e, cellHeight: t }) => HA(e, t, n))
              .map(({ cell: e, column: n }) => Wy(e, n, t, o));
          }
          function HA(e, t, n) {
            const o = e + t - 1,
              { first: i, last: r } = n;
            return (e >= i && e <= r) || (e < i && o >= i);
          }
          class UA extends V {
            static get pluginName() {
              return 'TableKeyboard';
            }
            static get requires() {
              return [jA, iA];
            }
            init() {
              const e = this.editor.editing.view.document;
              this.listenTo(e, 'arrowKey', (...e) => this._onArrowKey(...e), { context: 'table' }),
                this.listenTo(e, 'tab', (...e) => this._handleTabOnSelectedTable(...e), { context: 'figure' }),
                this.listenTo(e, 'tab', (...e) => this._handleTab(...e), { context: ['th', 'td'] });
            }
            _handleTabOnSelectedTable(e, t) {
              const n = this.editor,
                o = n.model.document.selection.getSelectedElement();
              o &&
                o.is('element', 'table') &&
                (t.preventDefault(),
                t.stopPropagation(),
                e.stop(),
                n.model.change((e) => {
                  e.setSelection(e.createRangeIn(o.getChild(0).getChild(0)));
                }));
            }
            _handleTab(e, t) {
              const n = this.editor,
                o = this.editor.plugins.get(iA),
                i = n.model.document.selection,
                r = !t.shiftKey;
              let s = o.getTableCellsContainingSelection(i)[0];
              if ((s || (s = this.editor.plugins.get('TableSelection').getFocusCell()), !s)) return;
              t.preventDefault(), t.stopPropagation(), e.stop();
              const a = s.parent,
                l = a.parent,
                c = l.getChildIndex(a),
                d = a.getChildIndex(s),
                u = 0 === d;
              if (!r && u && 0 === c)
                return void n.model.change((e) => {
                  e.setSelection(e.createRangeOn(l));
                });
              const h = d === a.childCount - 1,
                m = c === o.getRows(l) - 1;
              if (r && m && h && (n.execute('insertTableRowBelow'), c === o.getRows(l) - 1))
                return void n.model.change((e) => {
                  e.setSelection(e.createRangeOn(l));
                });
              let g;
              if (r && h) {
                const e = l.getChild(c + 1);
                g = e.getChild(0);
              } else if (!r && u) {
                const e = l.getChild(c - 1);
                g = e.getChild(e.childCount - 1);
              } else g = a.getChild(d + (r ? 1 : -1));
              n.model.change((e) => {
                e.setSelection(e.createRangeIn(g));
              });
            }
            _onArrowKey(e, t) {
              const n = this.editor,
                o = kr(t.keyCode, n.locale.contentLanguageDirection);
              this._handleArrowKeys(o, t.shiftKey) && (t.preventDefault(), t.stopPropagation(), e.stop());
            }
            _handleArrowKeys(e, t) {
              const n = this.editor.plugins.get(iA),
                o = this.editor.model,
                i = o.document.selection,
                r = ['right', 'down'].includes(e),
                s = n.getSelectedTableCells(i);
              if (s.length) {
                let n;
                return (
                  (n = t ? this.editor.plugins.get('TableSelection').getFocusCell() : r ? s[s.length - 1] : s[0]),
                  this._navigateFromCellInDirection(n, e, t),
                  !0
                );
              }
              const a = i.focus.findAncestor('tableCell');
              if (!a) return !1;
              if (!i.isCollapsed)
                if (t) {
                  if (i.isBackward == r && !i.containsEntireContent(a)) return !1;
                } else {
                  const e = i.getSelectedElement();
                  if (!e || !o.schema.isObject(e)) return !1;
                }
              return !!this._isSelectionAtCellEdge(i, a, r) && (this._navigateFromCellInDirection(a, e, t), !0);
            }
            _isSelectionAtCellEdge(e, t, n) {
              const o = this.editor.model,
                i = this.editor.model.schema,
                r = n ? e.getLastPosition() : e.getFirstPosition();
              if (!i.getLimitElement(r).is('element', 'tableCell')) {
                return o.createPositionAt(t, n ? 'end' : 0).isTouching(r);
              }
              const s = o.createSelection(r);
              return o.modifySelection(s, { direction: n ? 'forward' : 'backward' }), r.isEqual(s.focus);
            }
            _navigateFromCellInDirection(e, t, n = !1) {
              const o = this.editor.model,
                i = e.findAncestor('table'),
                r = [...new My(i, { includeAllSlots: !0 })],
                { row: s, column: a } = r[r.length - 1],
                l = r.find(({ cell: t }) => t == e);
              let { row: c, column: d } = l;
              switch (t) {
                case 'left':
                  d--;
                  break;
                case 'up':
                  c--;
                  break;
                case 'right':
                  d += l.cellWidth;
                  break;
                case 'down':
                  c += l.cellHeight;
              }
              if (c < 0 || c > s || (d < 0 && c <= 0) || (d > a && c >= s))
                return void o.change((e) => {
                  e.setSelection(e.createRangeOn(i));
                });
              d < 0 ? ((d = n ? 0 : a), c--) : d > a && ((d = n ? a : 0), c++);
              const u = r.find((e) => e.row == c && e.column == d).cell,
                h = ['right', 'down'].includes(t),
                m = this.editor.plugins.get('TableSelection');
              if (n && m.isEnabled) {
                const t = m.getAnchorCell() || e;
                m.setCellSelection(t, u);
              } else {
                const e = o.createPositionAt(u, h ? 0 : 'end');
                o.change((t) => {
                  t.setSelection(e);
                });
              }
            }
          }
          class qA extends $s {
            constructor(e) {
              super(e), (this.domEventType = ['mousemove', 'mouseleave']);
            }
            onDomEvent(e) {
              this.fire(e.type, e);
            }
          }
          class WA extends V {
            static get pluginName() {
              return 'TableMouse';
            }
            static get requires() {
              return [jA, iA];
            }
            init() {
              this.editor.editing.view.addObserver(qA), this._enableShiftClickSelection(), this._enableMouseDragSelection();
            }
            _enableShiftClickSelection() {
              const e = this.editor,
                t = e.plugins.get(iA);
              let n = !1;
              const o = e.plugins.get(jA);
              this.listenTo(e.editing.view.document, 'mousedown', (i, r) => {
                const s = e.model.document.selection;
                if (!this.isEnabled || !o.isEnabled) return;
                if (!r.domEvent.shiftKey) return;
                const a = o.getAnchorCell() || t.getTableCellsContainingSelection(s)[0];
                if (!a) return;
                const l = this._getModelTableCellFromDomEvent(r);
                l && GA(a, l) && ((n = !0), o.setCellSelection(a, l), r.preventDefault());
              }),
                this.listenTo(e.editing.view.document, 'mouseup', () => {
                  n = !1;
                }),
                this.listenTo(
                  e.editing.view.document,
                  'selectionChange',
                  (e) => {
                    n && e.stop();
                  },
                  { priority: 'highest' }
                );
            }
            _enableMouseDragSelection() {
              const e = this.editor;
              let t,
                n,
                o = !1,
                i = !1;
              const r = e.plugins.get(jA);
              this.listenTo(e.editing.view.document, 'mousedown', (e, n) => {
                this.isEnabled &&
                  r.isEnabled &&
                  (n.domEvent.shiftKey || n.domEvent.ctrlKey || n.domEvent.altKey || (t = this._getModelTableCellFromDomEvent(n)));
              }),
                this.listenTo(e.editing.view.document, 'mousemove', (e, s) => {
                  if (!s.domEvent.buttons) return;
                  if (!t) return;
                  const a = this._getModelTableCellFromDomEvent(s);
                  a && GA(t, a) && ((n = a), o || n == t || (o = !0)), o && ((i = !0), r.setCellSelection(t, n), s.preventDefault());
                }),
                this.listenTo(e.editing.view.document, 'mouseup', () => {
                  (o = !1), (i = !1), (t = null), (n = null);
                }),
                this.listenTo(
                  e.editing.view.document,
                  'selectionChange',
                  (e) => {
                    i && e.stop();
                  },
                  { priority: 'highest' }
                );
            }
            _getModelTableCellFromDomEvent(e) {
              const t = e.target,
                n = this.editor.editing.view.createPositionAt(t, 0);
              return this.editor.editing.mapper.toModelPosition(n).parent.findAncestor('tableCell', { includeSelf: !0 });
            }
          }
          function GA(e, t) {
            return e.parent.parent == t.parent.parent;
          }
          var $A = n(4104),
            YA = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()($A.Z, YA);
          $A.Z.locals;
          function KA(e) {
            const t = e.getSelectedElement();
            return t && ZA(t) ? t : null;
          }
          function QA(e) {
            const t = e.getFirstPosition();
            if (!t) return null;
            let n = t.parent;
            for (; n; ) {
              if (n.is('element') && ZA(n)) return n;
              n = n.parent;
            }
            return null;
          }
          function ZA(e) {
            return !!e.getCustomProperty('table') && Xp(e);
          }
          function JA(e, t) {
            const { viewElement: n, defaultValue: o, modelAttribute: i, styleName: r, reduceBoxSides: s = !1 } = t;
            e.for('upcast').attributeToAttribute({
              view: { name: n, styles: { [r]: /[\s\S]+/ } },
              model: {
                key: i,
                value: (e) => {
                  const t = e.getNormalizedStyle(r),
                    n = s ? nC(t) : t;
                  if (o !== n) return n;
                },
              },
            });
          }
          function XA(e, t, n, o) {
            e.for('upcast').add((e) =>
              e.on('element:' + t, (e, t, i) => {
                if (!t.modelRange) return;
                const r = [
                  'border-top-width',
                  'border-top-color',
                  'border-top-style',
                  'border-bottom-width',
                  'border-bottom-color',
                  'border-bottom-style',
                  'border-right-width',
                  'border-right-color',
                  'border-right-style',
                  'border-left-width',
                  'border-left-color',
                  'border-left-style',
                ].filter((e) => t.viewItem.hasStyle(e));
                if (!r.length) return;
                const s = { styles: r };
                if (!i.consumable.test(t.viewItem, s)) return;
                const a = [...t.modelRange.getItems({ shallow: !0 })].pop();
                i.consumable.consume(t.viewItem, s);
                const l = {
                    style: t.viewItem.getNormalizedStyle('border-style'),
                    color: t.viewItem.getNormalizedStyle('border-color'),
                    width: t.viewItem.getNormalizedStyle('border-width'),
                  },
                  c = { style: nC(l.style), color: nC(l.color), width: nC(l.width) };
                c.style !== o.style && i.writer.setAttribute(n.style, c.style, a),
                  c.color !== o.color && i.writer.setAttribute(n.color, c.color, a),
                  c.width !== o.width && i.writer.setAttribute(n.width, c.width, a);
              })
            );
          }
          function eC(e, { modelElement: t, modelAttribute: n, styleName: o }) {
            e.for('downcast').attributeToAttribute({ model: { name: t, key: n }, view: (e) => ({ key: 'style', value: { [o]: e } }) });
          }
          function tC(e, { modelAttribute: t, styleName: n }) {
            e.for('downcast').add((e) =>
              e.on(`attribute:${t}:table`, (e, t, o) => {
                const { item: i, attributeNewValue: r } = t,
                  { mapper: s, writer: a } = o;
                if (!o.consumable.consume(t.item, e.name)) return;
                const l = [...s.toViewElement(i).getChildren()].find((e) => e.is('element', 'table'));
                r ? a.setStyle(n, r, l) : a.removeStyle(n, l);
              })
            );
          }
          function nC(e) {
            if (!e) return;
            return ['top', 'right', 'bottom', 'left'].map((t) => e[t]).reduce((e, t) => (e == t ? e : null)) || e;
          }
          class oC extends H {
            constructor(e, t, n) {
              super(e), (this.attributeName = t), (this._defaultValue = n);
            }
            refresh() {
              const e = this.editor.model.document.selection.getFirstPosition().findAncestor('table');
              (this.isEnabled = !!e), (this.value = this._getValue(e));
            }
            execute(e = {}) {
              const t = this.editor.model,
                n = t.document.selection,
                { value: o, batch: i } = e,
                r = n.getFirstPosition().findAncestor('table'),
                s = this._getValueToSet(o);
              t.enqueueChange(i, (e) => {
                s ? e.setAttribute(this.attributeName, s, r) : e.removeAttribute(this.attributeName, r);
              });
            }
            _getValue(e) {
              if (!e) return;
              const t = e.getAttribute(this.attributeName);
              return t !== this._defaultValue ? t : void 0;
            }
            _getValueToSet(e) {
              if (e !== this._defaultValue) return e;
            }
          }
          class iC extends oC {
            constructor(e, t) {
              super(e, 'tableBackgroundColor', t);
            }
          }
          function rC(e) {
            if (!e || !E(e)) return e;
            const { top: t, right: n, bottom: o, left: i } = e;
            return t == n && n == o && o == i ? t : void 0;
          }
          function sC(e, t) {
            const n = parseFloat(e);
            return Number.isNaN(n) || String(n) !== String(e) ? e : `${n}${t}`;
          }
          function aC(e, t = {}) {
            const n = Object.assign(
              { borderStyle: 'none', borderWidth: '', borderColor: '', backgroundColor: '', width: '', height: '' },
              e
            );
            return (
              t.includeAlignmentProperty && !n.alignment && (n.alignment = 'center'),
              t.includePaddingProperty && !n.padding && (n.padding = ''),
              t.includeVerticalAlignmentProperty && !n.verticalAlignment && (n.verticalAlignment = 'middle'),
              t.includeHorizontalAlignmentProperty &&
                !n.horizontalAlignment &&
                (n.horizontalAlignment = t.isRightToLeftContent ? 'right' : 'left'),
              n
            );
          }
          class lC extends oC {
            constructor(e, t) {
              super(e, 'tableBorderColor', t);
            }
            _getValue(e) {
              if (!e) return;
              const t = rC(e.getAttribute(this.attributeName));
              return t !== this._defaultValue ? t : void 0;
            }
          }
          class cC extends oC {
            constructor(e, t) {
              super(e, 'tableBorderStyle', t);
            }
            _getValue(e) {
              if (!e) return;
              const t = rC(e.getAttribute(this.attributeName));
              return t !== this._defaultValue ? t : void 0;
            }
          }
          class dC extends oC {
            constructor(e, t) {
              super(e, 'tableBorderWidth', t);
            }
            _getValue(e) {
              if (!e) return;
              const t = rC(e.getAttribute(this.attributeName));
              return t !== this._defaultValue ? t : void 0;
            }
            _getValueToSet(e) {
              if ((e = sC(e, 'px')) !== this._defaultValue) return e;
            }
          }
          class uC extends oC {
            constructor(e, t) {
              super(e, 'tableWidth', t);
            }
            _getValueToSet(e) {
              if ((e = sC(e, 'px')) !== this._defaultValue) return e;
            }
          }
          class hC extends oC {
            constructor(e, t) {
              super(e, 'tableHeight', t);
            }
            _getValueToSet(e) {
              return (e = sC(e, 'px')) === this._defaultValue ? null : e;
            }
          }
          class mC extends oC {
            constructor(e, t) {
              super(e, 'tableAlignment', t);
            }
          }
          const gC = /^(left|center|right)$/,
            pC = /^(left|none|right)$/;
          class fC extends V {
            static get pluginName() {
              return 'TablePropertiesEditing';
            }
            static get requires() {
              return [DA];
            }
            init() {
              const e = this.editor,
                t = e.model.schema,
                n = e.conversion;
              e.config.define('table.tableProperties.defaultProperties', {});
              const o = aC(e.config.get('table.tableProperties.defaultProperties'), { includeAlignmentProperty: !0 });
              e.data.addStyleProcessorRules(ng),
                (function (e, t, n) {
                  const o = { width: 'tableBorderWidth', color: 'tableBorderColor', style: 'tableBorderStyle' };
                  e.extend('table', { allowAttributes: Object.values(o) }),
                    XA(t, 'table', o, n),
                    tC(t, { modelAttribute: o.color, styleName: 'border-color' }),
                    tC(t, { modelAttribute: o.style, styleName: 'border-style' }),
                    tC(t, { modelAttribute: o.width, styleName: 'border-width' });
                })(t, n, { color: o.borderColor, style: o.borderStyle, width: o.borderWidth }),
                e.commands.add('tableBorderColor', new lC(e, o.borderColor)),
                e.commands.add('tableBorderStyle', new cC(e, o.borderStyle)),
                e.commands.add('tableBorderWidth', new dC(e, o.borderWidth)),
                (function (e, t, n) {
                  e.extend('table', { allowAttributes: ['tableAlignment'] }),
                    t.for('downcast').attributeToAttribute({
                      model: { name: 'table', key: 'tableAlignment' },
                      view: (e) => ({ key: 'style', value: { float: 'center' === e ? 'none' : e } }),
                      converterPriority: 'high',
                    }),
                    t
                      .for('upcast')
                      .attributeToAttribute({
                        view: { name: /^(table|figure)$/, styles: { float: pC } },
                        model: {
                          key: 'tableAlignment',
                          value: (e) => {
                            let t = e.getStyle('float');
                            return 'none' === t && (t = 'center'), t === n ? null : t;
                          },
                        },
                      })
                      .attributeToAttribute({
                        view: { attributes: { align: gC } },
                        model: {
                          name: 'table',
                          key: 'tableAlignment',
                          value: (e) => {
                            const t = e.getAttribute('align');
                            return t === n ? null : t;
                          },
                        },
                      });
                })(t, n, o.alignment),
                e.commands.add('tableAlignment', new mC(e, o.alignment)),
                kC(t, n, { modelAttribute: 'tableWidth', styleName: 'width', defaultValue: o.width }),
                e.commands.add('tableWidth', new uC(e, o.width)),
                kC(t, n, { modelAttribute: 'tableHeight', styleName: 'height', defaultValue: o.height }),
                e.commands.add('tableHeight', new hC(e, o.height)),
                e.data.addStyleProcessorRules(tg),
                (function (e, t, n) {
                  const { modelAttribute: o } = n;
                  e.extend('table', { allowAttributes: [o] }), JA(t, { viewElement: 'table', ...n }), tC(t, n);
                })(t, n, { modelAttribute: 'tableBackgroundColor', styleName: 'background-color', defaultValue: o.backgroundColor }),
                e.commands.add('tableBackgroundColor', new iC(e, o.backgroundColor));
            }
          }
          function kC(e, t, n) {
            const { modelAttribute: o } = n;
            e.extend('table', { allowAttributes: [o] }),
              JA(t, { viewElement: /^(table|figure)$/, ...n }),
              eC(t, { modelElement: 'table', ...n });
          }
          var bC = n(4082),
            wC = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(bC.Z, wC);
          bC.Z.locals;
          class _C extends Jd {
            constructor(e, t) {
              super(e);
              const n = this.bindTemplate;
              this.set('value', ''),
                this.set('id'),
                this.set('isReadOnly', !1),
                this.set('hasError', !1),
                this.set('isFocused', !1),
                this.set('isEmpty', !0),
                this.set('ariaDescribedById'),
                (this.options = t),
                (this._dropdownView = this._createDropdownView()),
                (this._inputView = this._createInputTextView()),
                (this._stillTyping = !1),
                this.setTemplate({
                  tag: 'div',
                  attributes: {
                    class: ['ck', 'ck-input-color', n.if('hasError', 'ck-error')],
                    id: n.to('id'),
                    'aria-invalid': n.if('hasError', !0),
                    'aria-describedby': n.to('ariaDescribedById'),
                  },
                  children: [this._dropdownView, this._inputView],
                }),
                this.on('change:value', (e, t, n) => this._setInputValue(n));
            }
            focus() {
              this._inputView.focus();
            }
            _createDropdownView() {
              const e = this.locale,
                t = e.t,
                n = this.bindTemplate,
                o = this._createColorGrid(e),
                i = yh(e),
                r = new Jd(),
                s = this._createRemoveColorButton();
              return (
                r.setTemplate({
                  tag: 'span',
                  attributes: { class: ['ck', 'ck-input-color__button__preview'], style: { backgroundColor: n.to('value') } },
                  children: [
                    {
                      tag: 'span',
                      attributes: {
                        class: ['ck', 'ck-input-color__button__preview__no-color-indicator', n.if('value', 'ck-hidden', (e) => '' != e)],
                      },
                    },
                  ],
                }),
                i.buttonView.extendTemplate({ attributes: { class: 'ck-input-color__button' } }),
                i.buttonView.children.add(r),
                (i.buttonView.label = t('Color picker')),
                (i.buttonView.tooltip = !0),
                (i.panelPosition = 'rtl' === e.uiLanguageDirection ? 'se' : 'sw'),
                i.panelView.children.add(s),
                i.panelView.children.add(o),
                i.bind('isEnabled').to(this, 'isReadOnly', (e) => !e),
                i
              );
            }
            _createInputTextView() {
              const e = this.locale,
                t = new Vh(e);
              return (
                t.extendTemplate({ on: { blur: t.bindTemplate.to('blur') } }),
                (t.value = this.value),
                t.bind('isReadOnly', 'hasError').to(this),
                this.bind('isFocused', 'isEmpty').to(t),
                t.on('input', () => {
                  const e = t.element.value,
                    n = this.options.colorDefinitions.find((t) => e === t.label);
                  (this._stillTyping = !0), (this.value = (n && n.color) || e);
                }),
                t.on('blur', () => {
                  (this._stillTyping = !1), this._setInputValue(t.element.value);
                }),
                t.delegate('input').to(this),
                t
              );
            }
            _createRemoveColorButton() {
              const e = this.locale,
                t = e.t,
                n = new zu(e),
                o = this.options.defaultColorValue || '',
                i = t(o ? 'Restore default' : 'Remove color');
              return (
                (n.class = 'ck-input-color__remove-color'),
                (n.withText = !0),
                (n.icon = Cu.eraser),
                (n.label = i),
                n.on('execute', () => {
                  (this.value = o), (this._dropdownView.isOpen = !1), this.fire('input');
                }),
                n
              );
            }
            _createColorGrid(e) {
              const t = new Wu(e, { colorDefinitions: this.options.colorDefinitions, columns: this.options.columns });
              return (
                t.on('execute', (e, t) => {
                  (this.value = t.value), (this._dropdownView.isOpen = !1), this.fire('input');
                }),
                t.bind('selectedColor').to(this, 'value'),
                t
              );
            }
            _setInputValue(e) {
              if (!this._stillTyping) {
                const t = yC(e),
                  n = this.options.colorDefinitions.find((e) => t === yC(e.color));
                this._inputView.value = n ? n.label : e || '';
              }
            }
          }
          function yC(e) {
            return e
              .replace(/([(,])\s+/g, '$1')
              .replace(/^\s+|\s+(?=[),\s]|$)/g, '')
              .replace(/,|\s/g, ' ');
          }
          const AC = (e) => '' === e;
          function CC(e) {
            return {
              none: e('None'),
              solid: e('Solid'),
              dotted: e('Dotted'),
              dashed: e('Dashed'),
              double: e('Double'),
              groove: e('Groove'),
              ridge: e('Ridge'),
              inset: e('Inset'),
              outset: e('Outset'),
            };
          }
          function vC(e) {
            return e('The color is invalid. Try "#FF0000" or "rgb(255,0,0)" or "red".');
          }
          function xC(e) {
            return e('The value is invalid. Try "10px" or "2em" or simply "2".');
          }
          function EC(e) {
            return (e = e.trim()), AC(e) || Lm(e);
          }
          function DC(e) {
            return (e = e.trim()), AC(e) || NC(e) || Vm(e) || ((t = e), Fm.test(t));
            var t;
          }
          function TC(e) {
            return (e = e.trim()), AC(e) || NC(e) || Vm(e);
          }
          function IC(e, t) {
            const n = new fo(),
              o = CC(e.t);
            for (const i in o) {
              const r = { type: 'button', model: new $h({ _borderStyleValue: i, label: o[i], withText: !0 }) };
              'none' === i
                ? r.model.bind('isOn').to(e, 'borderStyle', (e) => ('none' === t ? !e : e === i))
                : r.model.bind('isOn').to(e, 'borderStyle', (e) => e === i),
                n.add(r);
            }
            return n;
          }
          function SC(e) {
            const { view: t, icons: n, toolbar: o, labels: i, propertyName: r, nameToValue: s, defaultValue: a } = e;
            for (const e in i) {
              const l = new zu(t.locale);
              l.set({ label: i[e], icon: n[e], tooltip: i[e] });
              const c = s ? s(e) : e;
              l.bind('isOn').to(t, r, (e) => {
                let t = e;
                return '' === e && a && (t = a), c === t;
              }),
                l.on('execute', () => {
                  t[r] = c;
                }),
                o.items.add(l);
            }
          }
          const MC = [
            { color: 'hsl(0, 0%, 0%)', label: 'Black' },
            { color: 'hsl(0, 0%, 30%)', label: 'Dim grey' },
            { color: 'hsl(0, 0%, 60%)', label: 'Grey' },
            { color: 'hsl(0, 0%, 90%)', label: 'Light grey' },
            { color: 'hsl(0, 0%, 100%)', label: 'White', hasBorder: !0 },
            { color: 'hsl(0, 75%, 60%)', label: 'Red' },
            { color: 'hsl(30, 75%, 60%)', label: 'Orange' },
            { color: 'hsl(60, 75%, 60%)', label: 'Yellow' },
            { color: 'hsl(90, 75%, 60%)', label: 'Light green' },
            { color: 'hsl(120, 75%, 60%)', label: 'Green' },
            { color: 'hsl(150, 75%, 60%)', label: 'Aquamarine' },
            { color: 'hsl(180, 75%, 60%)', label: 'Turquoise' },
            { color: 'hsl(210, 75%, 60%)', label: 'Light blue' },
            { color: 'hsl(240, 75%, 60%)', label: 'Blue' },
            { color: 'hsl(270, 75%, 60%)', label: 'Purple' },
          ];
          function BC(e) {
            return (t, n, o) => {
              const i = new _C(t.locale, {
                colorDefinitions:
                  ((r = e.colorConfig), r.map((e) => ({ color: e.model, label: e.label, options: { hasBorder: e.hasBorder } }))),
                columns: e.columns,
                defaultColorValue: e.defaultColorValue,
              });
              var r;
              return (
                i.set({ id: n, ariaDescribedById: o }),
                i.bind('isReadOnly').to(t, 'isEnabled', (e) => !e),
                i.bind('hasError').to(t, 'errorText', (e) => !!e),
                i.on('input', () => {
                  t.errorText = null;
                }),
                t.bind('isEmpty', 'isFocused').to(i),
                i
              );
            };
          }
          function NC(e) {
            const t = parseFloat(e);
            return !Number.isNaN(t) && e === String(t);
          }
          var PC = n(9865),
            zC = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(PC.Z, zC);
          PC.Z.locals;
          class LC extends Jd {
            constructor(e, t = {}) {
              super(e);
              const n = this.bindTemplate;
              this.set('class', t.class || null),
                (this.children = this.createCollection()),
                t.children && t.children.forEach((e) => this.children.add(e)),
                this.set('_role', null),
                this.set('_ariaLabelledBy', null),
                t.labelView && this.set({ _role: 'group', _ariaLabelledBy: t.labelView.id }),
                this.setTemplate({
                  tag: 'div',
                  attributes: {
                    class: ['ck', 'ck-form__row', n.to('class')],
                    role: n.to('_role'),
                    'aria-labelledby': n.to('_ariaLabelledBy'),
                  },
                  children: this.children,
                });
            }
          }
          var jC = n(4880),
            OC = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(jC.Z, OC);
          jC.Z.locals;
          var RC = n(198),
            VC = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(RC.Z, VC);
          RC.Z.locals;
          var FC = n(9221),
            HC = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(FC.Z, HC);
          FC.Z.locals;
          const UC = { left: Cu.objectLeft, center: Cu.objectCenter, right: Cu.objectRight };
          class qC extends Jd {
            constructor(e, t) {
              super(e),
                this.set({ borderStyle: '', borderWidth: '', borderColor: '', backgroundColor: '', width: '', height: '', alignment: '' }),
                (this.options = t);
              const { borderStyleDropdown: n, borderWidthInput: o, borderColorInput: i, borderRowLabel: r } = this._createBorderFields(),
                { backgroundRowLabel: s, backgroundInput: a } = this._createBackgroundFields(),
                { widthInput: l, operatorLabel: c, heightInput: d, dimensionsLabel: u } = this._createDimensionFields(),
                { alignmentToolbar: h, alignmentLabel: m } = this._createAlignmentFields();
              (this.focusTracker = new va()),
                (this.keystrokes = new xa()),
                (this.children = this.createCollection()),
                (this.borderStyleDropdown = n),
                (this.borderWidthInput = o),
                (this.borderColorInput = i),
                (this.backgroundInput = a),
                (this.widthInput = l),
                (this.heightInput = d),
                (this.alignmentToolbar = h);
              const { saveButtonView: g, cancelButtonView: p } = this._createActionButtons();
              (this.saveButtonView = g),
                (this.cancelButtonView = p),
                (this._focusables = new Id()),
                (this._focusCycler = new th({
                  focusables: this._focusables,
                  focusTracker: this.focusTracker,
                  keystrokeHandler: this.keystrokes,
                  actions: { focusPrevious: 'shift + tab', focusNext: 'tab' },
                })),
                this.children.add(new Lh(e, { label: this.t('Table properties') })),
                this.children.add(new LC(e, { labelView: r, children: [r, n, i, o], class: 'ck-table-form__border-row' })),
                this.children.add(new LC(e, { labelView: s, children: [s, a], class: 'ck-table-form__background-row' })),
                this.children.add(
                  new LC(e, {
                    children: [
                      new LC(e, { labelView: u, children: [u, l, c, d], class: 'ck-table-form__dimensions-row' }),
                      new LC(e, { labelView: m, children: [m, h], class: 'ck-table-properties-form__alignment-row' }),
                    ],
                  })
                ),
                this.children.add(
                  new LC(e, { children: [this.saveButtonView, this.cancelButtonView], class: 'ck-table-form__action-row' })
                ),
                this.setTemplate({
                  tag: 'form',
                  attributes: { class: ['ck', 'ck-form', 'ck-table-form', 'ck-table-properties-form'], tabindex: '-1' },
                  children: this.children,
                });
            }
            render() {
              super.render(),
                Eu({ view: this }),
                [
                  this.borderStyleDropdown,
                  this.borderColorInput,
                  this.borderWidthInput,
                  this.backgroundInput,
                  this.widthInput,
                  this.heightInput,
                  this.alignmentToolbar,
                  this.saveButtonView,
                  this.cancelButtonView,
                ].forEach((e) => {
                  this._focusables.add(e), this.focusTracker.add(e.element);
                }),
                this.keystrokes.listenTo(this.element);
            }
            destroy() {
              super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
            }
            focus() {
              this._focusCycler.focusFirst();
            }
            _createBorderFields() {
              const e = this.options.defaultTableProperties,
                t = { style: e.borderStyle, width: e.borderWidth, color: e.borderColor },
                n = BC({ colorConfig: this.options.borderColors, columns: 5, defaultColorValue: t.color }),
                o = this.locale,
                i = this.t,
                r = new Sh(o);
              r.text = i('Border');
              const s = CC(this.t),
                a = new Uh(o, Wh);
              a.set({ label: i('Style'), class: 'ck-table-form__border-style' }),
                a.fieldView.buttonView.set({ isOn: !1, withText: !0, tooltip: i('Style') }),
                a.fieldView.buttonView.bind('label').to(this, 'borderStyle', (e) => s[e || 'none']),
                a.fieldView.on('execute', (e) => {
                  this.borderStyle = e.source._borderStyleValue;
                }),
                a.bind('isEmpty').to(this, 'borderStyle', (e) => !e),
                Ch(a.fieldView, IC(this, t.style));
              const l = new Uh(o, qh);
              l.set({ label: i('Width'), class: 'ck-table-form__border-width' }),
                l.fieldView.bind('value').to(this, 'borderWidth'),
                l.bind('isEnabled').to(this, 'borderStyle', WC),
                l.fieldView.on('input', () => {
                  this.borderWidth = l.fieldView.element.value;
                });
              const c = new Uh(o, n);
              return (
                c.set({ label: i('Color'), class: 'ck-table-form__border-color' }),
                c.fieldView.bind('value').to(this, 'borderColor'),
                c.bind('isEnabled').to(this, 'borderStyle', WC),
                c.fieldView.on('input', () => {
                  this.borderColor = c.fieldView.value;
                }),
                this.on('change:borderStyle', (e, n, o, i) => {
                  WC(o) || ((this.borderColor = ''), (this.borderWidth = '')),
                    WC(i) || ((this.borderColor = t.color), (this.borderWidth = t.width));
                }),
                { borderRowLabel: r, borderStyleDropdown: a, borderColorInput: c, borderWidthInput: l }
              );
            }
            _createBackgroundFields() {
              const e = this.locale,
                t = this.t,
                n = new Sh(e);
              n.text = t('Background');
              const o = BC({
                  colorConfig: this.options.backgroundColors,
                  columns: 5,
                  defaultColorValue: this.options.defaultTableProperties.backgroundColor,
                }),
                i = new Uh(e, o);
              return (
                i.set({ label: t('Color'), class: 'ck-table-properties-form__background' }),
                i.fieldView.bind('value').to(this, 'backgroundColor'),
                i.fieldView.on('input', () => {
                  this.backgroundColor = i.fieldView.value;
                }),
                { backgroundRowLabel: n, backgroundInput: i }
              );
            }
            _createDimensionFields() {
              const e = this.locale,
                t = this.t,
                n = new Sh(e);
              n.text = t('Dimensions');
              const o = new Uh(e, qh);
              o.set({ label: t('Width'), class: 'ck-table-form__dimensions-row__width' }),
                o.fieldView.bind('value').to(this, 'width'),
                o.fieldView.on('input', () => {
                  this.width = o.fieldView.element.value;
                });
              const i = new Jd(e);
              i.setTemplate({ tag: 'span', attributes: { class: ['ck-table-form__dimension-operator'] }, children: [{ text: '×' }] });
              const r = new Uh(e, qh);
              return (
                r.set({ label: t('Height'), class: 'ck-table-form__dimensions-row__height' }),
                r.fieldView.bind('value').to(this, 'height'),
                r.fieldView.on('input', () => {
                  this.height = r.fieldView.element.value;
                }),
                { dimensionsLabel: n, widthInput: o, operatorLabel: i, heightInput: r }
              );
            }
            _createAlignmentFields() {
              const e = this.locale,
                t = this.t,
                n = new Sh(e);
              n.text = t('Alignment');
              const o = new lh(e);
              return (
                o.set({ isCompact: !0, ariaLabel: t('Table alignment toolbar') }),
                SC({
                  view: this,
                  icons: UC,
                  toolbar: o,
                  labels: this._alignmentLabels,
                  propertyName: 'alignment',
                  defaultValue: this.options.defaultTableProperties.alignment,
                }),
                { alignmentLabel: n, alignmentToolbar: o }
              );
            }
            _createActionButtons() {
              const e = this.locale,
                t = this.t,
                n = new zu(e),
                o = new zu(e),
                i = [this.borderWidthInput, this.borderColorInput, this.backgroundInput, this.widthInput, this.heightInput];
              return (
                n.set({ label: t('Save'), icon: Cu.check, class: 'ck-button-save', type: 'submit', withText: !0 }),
                n.bind('isEnabled').toMany(i, 'errorText', (...e) => e.every((e) => !e)),
                o.set({ label: t('Cancel'), icon: Cu.cancel, class: 'ck-button-cancel', withText: !0 }),
                o.delegate('execute').to(this, 'cancel'),
                { saveButtonView: n, cancelButtonView: o }
              );
            }
            get _alignmentLabels() {
              const e = this.locale,
                t = this.t,
                n = t('Align table to the left'),
                o = t('Center table'),
                i = t('Align table to the right');
              return 'rtl' === e.uiLanguageDirection ? { right: i, center: o, left: n } : { left: n, center: o, right: i };
            }
          }
          function WC(e) {
            return 'none' !== e;
          }
          const GC = au.defaultPositions,
            $C = [
              GC.northArrowSouth,
              GC.northArrowSouthWest,
              GC.northArrowSouthEast,
              GC.southArrowNorth,
              GC.southArrowNorthWest,
              GC.southArrowNorthEast,
              GC.viewportStickyNorth,
            ];
          function YC(e, t) {
            const n = e.plugins.get('ContextualBalloon');
            if (QA(e.editing.view.document.selection)) {
              let o;
              (o = 'cell' === t ? QC(e) : KC(e)), n.updatePosition(o);
            }
          }
          function KC(e) {
            const t = e.model.document.selection.getFirstPosition().findAncestor('table'),
              n = e.editing.mapper.toViewElement(t);
            return { target: e.editing.view.domConverter.mapViewToDom(n), positions: $C };
          }
          function QC(e) {
            const t = e.editing.mapper,
              n = e.editing.view.domConverter,
              o = e.model.document.selection;
            if (o.rangeCount > 1)
              return {
                target: () =>
                  (function (e, t) {
                    const n = t.editing.mapper,
                      o = t.editing.view.domConverter,
                      i = Array.from(e).map((e) => {
                        const t = ZC(e.start),
                          i = n.toViewElement(t);
                        return new ka(o.mapViewToDom(i));
                      });
                    return ka.getBoundingRect(i);
                  })(o.getRanges(), e),
                positions: $C,
              };
            const i = ZC(o.getFirstPosition()),
              r = t.toViewElement(i);
            return { target: n.mapViewToDom(r), positions: $C };
          }
          function ZC(e) {
            return e.nodeAfter && e.nodeAfter.is('element', 'tableCell') ? e.nodeAfter : e.findAncestor('tableCell');
          }
          const JC = {
            borderStyle: 'tableBorderStyle',
            borderColor: 'tableBorderColor',
            borderWidth: 'tableBorderWidth',
            backgroundColor: 'tableBackgroundColor',
            width: 'tableWidth',
            height: 'tableHeight',
            alignment: 'tableAlignment',
          };
          class XC extends V {
            static get requires() {
              return [Xh];
            }
            static get pluginName() {
              return 'TablePropertiesUI';
            }
            constructor(e) {
              super(e), e.config.define('table.tableProperties', { borderColors: MC, backgroundColors: MC });
            }
            init() {
              const e = this.editor,
                t = e.t;
              (this._defaultTableProperties = aC(e.config.get('table.tableProperties.defaultProperties'), {
                includeAlignmentProperty: !0,
              })),
                (this._balloon = e.plugins.get(Xh)),
                (this.view = this._createPropertiesView()),
                (this._undoStepBatch = null),
                e.ui.componentFactory.add('tableProperties', (n) => {
                  const o = new zu(n);
                  o.set({
                    label: t('Table properties'),
                    icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8 2v5h4V2h1v5h5v1h-5v4h.021l-.172.351-1.916.28-.151.027c-.287.063-.54.182-.755.341L8 13v5H7v-5H2v-1h5V8H2V7h5V2h1zm4 6H8v4h4V8z" opacity=".6"/><path d="m15.5 11.5 1.323 2.68 2.957.43-2.14 2.085.505 2.946L15.5 18.25l-2.645 1.39.505-2.945-2.14-2.086 2.957-.43L15.5 11.5zM17 1a2 2 0 0 1 2 2v9.475l-.85-.124-.857-1.736a2.048 2.048 0 0 0-.292-.44L17 3H3v14h7.808l.402.392L10.935 19H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14z"/></svg>',
                    tooltip: !0,
                  }),
                    this.listenTo(o, 'execute', () => this._showView());
                  const i = Object.values(JC).map((t) => e.commands.get(t));
                  return o.bind('isEnabled').toMany(i, 'isEnabled', (...e) => e.some((e) => e)), o;
                });
            }
            destroy() {
              super.destroy(), this.view.destroy();
            }
            _createPropertiesView() {
              const e = this.editor,
                t = e.config.get('table.tableProperties'),
                n = Vu(t.borderColors),
                o = Ru(e.locale, n),
                i = Vu(t.backgroundColors),
                r = Ru(e.locale, i),
                s = new qC(e.locale, { borderColors: o, backgroundColors: r, defaultTableProperties: this._defaultTableProperties }),
                a = e.t;
              s.render(),
                this.listenTo(s, 'submit', () => {
                  this._hideView();
                }),
                this.listenTo(s, 'cancel', () => {
                  this._undoStepBatch.operations.length && e.execute('undo', this._undoStepBatch), this._hideView();
                }),
                s.keystrokes.set('Esc', (e, t) => {
                  this._hideView(), t();
                }),
                vu({
                  emitter: s,
                  activator: () => this._isViewInBalloon,
                  contextElements: [this._balloon.view.element],
                  callback: () => this._hideView(),
                });
              const l = vC(a),
                c = xC(a);
              return (
                s.on('change:borderStyle', this._getPropertyChangeCallback('tableBorderStyle', this._defaultTableProperties.borderStyle)),
                s.on(
                  'change:borderColor',
                  this._getValidatedPropertyChangeCallback({
                    viewField: s.borderColorInput,
                    commandName: 'tableBorderColor',
                    errorText: l,
                    validator: EC,
                    defaultValue: this._defaultTableProperties.borderColor,
                  })
                ),
                s.on(
                  'change:borderWidth',
                  this._getValidatedPropertyChangeCallback({
                    viewField: s.borderWidthInput,
                    commandName: 'tableBorderWidth',
                    errorText: c,
                    validator: TC,
                    defaultValue: this._defaultTableProperties.borderWidth,
                  })
                ),
                s.on(
                  'change:backgroundColor',
                  this._getValidatedPropertyChangeCallback({
                    viewField: s.backgroundInput,
                    commandName: 'tableBackgroundColor',
                    errorText: l,
                    validator: EC,
                    defaultValue: this._defaultTableProperties.backgroundColor,
                  })
                ),
                s.on(
                  'change:width',
                  this._getValidatedPropertyChangeCallback({
                    viewField: s.widthInput,
                    commandName: 'tableWidth',
                    errorText: c,
                    validator: DC,
                    defaultValue: this._defaultTableProperties.width,
                  })
                ),
                s.on(
                  'change:height',
                  this._getValidatedPropertyChangeCallback({
                    viewField: s.heightInput,
                    commandName: 'tableHeight',
                    errorText: c,
                    validator: DC,
                    defaultValue: this._defaultTableProperties.height,
                  })
                ),
                s.on('change:alignment', this._getPropertyChangeCallback('tableAlignment', this._defaultTableProperties.alignment)),
                s
              );
            }
            _fillViewFormFromCommandValues() {
              const e = this.editor.commands,
                t = e.get('tableBorderStyle');
              Object.entries(JC)
                .map(([t, n]) => {
                  const o = this._defaultTableProperties[t] || '';
                  return [t, e.get(n).value || o];
                })
                .forEach(([e, n]) => {
                  (('borderColor' !== e && 'borderWidth' !== e) || 'none' !== t.value) && this.view.set(e, n);
                });
            }
            _showView() {
              const e = this.editor;
              this.listenTo(e.ui, 'update', () => {
                this._updateView();
              }),
                this._fillViewFormFromCommandValues(),
                this._balloon.add({ view: this.view, position: KC(e) }),
                (this._undoStepBatch = e.model.createBatch()),
                this.view.focus();
            }
            _hideView() {
              const e = this.editor;
              this.stopListening(e.ui, 'update'),
                this.view.saveButtonView.focus(),
                this._balloon.remove(this.view),
                this.editor.editing.view.focus();
            }
            _updateView() {
              const e = this.editor;
              QA(e.editing.view.document.selection) ? this._isViewVisible && YC(e, 'table') : this._hideView();
            }
            get _isViewVisible() {
              return this._balloon.visibleView === this.view;
            }
            get _isViewInBalloon() {
              return this._balloon.hasView(this.view);
            }
            _getPropertyChangeCallback(e, t) {
              return (n, o, i, r) => {
                (r || t !== i) && this.editor.execute(e, { value: i, batch: this._undoStepBatch });
              };
            }
            _getValidatedPropertyChangeCallback(e) {
              const { commandName: t, viewField: n, validator: o, errorText: i, defaultValue: r } = e,
                s = aa(() => {
                  n.errorText = i;
                }, 500);
              return (e, i, a, l) => {
                s.cancel(),
                  (l || r !== a) && (o(a) ? (this.editor.execute(t, { value: a, batch: this._undoStepBatch }), (n.errorText = null)) : s());
              };
            }
          }
          var ev = n(5737),
            tv = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(ev.Z, tv);
          ev.Z.locals;
          const nv = {
            left: Cu.alignLeft,
            center: Cu.alignCenter,
            right: Cu.alignRight,
            justify: Cu.alignJustify,
            top: Cu.alignTop,
            middle: Cu.alignMiddle,
            bottom: Cu.alignBottom,
          };
          class ov extends Jd {
            constructor(e, t) {
              super(e),
                this.set({
                  borderStyle: '',
                  borderWidth: '',
                  borderColor: '',
                  padding: '',
                  backgroundColor: '',
                  width: '',
                  height: '',
                  horizontalAlignment: '',
                  verticalAlignment: '',
                }),
                (this.options = t);
              const { borderStyleDropdown: n, borderWidthInput: o, borderColorInput: i, borderRowLabel: r } = this._createBorderFields(),
                { backgroundRowLabel: s, backgroundInput: a } = this._createBackgroundFields(),
                { widthInput: l, operatorLabel: c, heightInput: d, dimensionsLabel: u } = this._createDimensionFields(),
                { horizontalAlignmentToolbar: h, verticalAlignmentToolbar: m, alignmentLabel: g } = this._createAlignmentFields();
              (this.focusTracker = new va()),
                (this.keystrokes = new xa()),
                (this.children = this.createCollection()),
                (this.borderStyleDropdown = n),
                (this.borderWidthInput = o),
                (this.borderColorInput = i),
                (this.backgroundInput = a),
                (this.paddingInput = this._createPaddingField()),
                (this.widthInput = l),
                (this.heightInput = d),
                (this.horizontalAlignmentToolbar = h),
                (this.verticalAlignmentToolbar = m);
              const { saveButtonView: p, cancelButtonView: f } = this._createActionButtons();
              (this.saveButtonView = p),
                (this.cancelButtonView = f),
                (this._focusables = new Id()),
                (this._focusCycler = new th({
                  focusables: this._focusables,
                  focusTracker: this.focusTracker,
                  keystrokeHandler: this.keystrokes,
                  actions: { focusPrevious: 'shift + tab', focusNext: 'tab' },
                })),
                this.children.add(new Lh(e, { label: this.t('Cell properties') })),
                this.children.add(new LC(e, { labelView: r, children: [r, n, i, o], class: 'ck-table-form__border-row' })),
                this.children.add(new LC(e, { labelView: s, children: [s, a], class: 'ck-table-form__background-row' })),
                this.children.add(
                  new LC(e, {
                    children: [
                      new LC(e, { labelView: u, children: [u, l, c, d], class: 'ck-table-form__dimensions-row' }),
                      new LC(e, { children: [this.paddingInput], class: 'ck-table-cell-properties-form__padding-row' }),
                    ],
                  })
                ),
                this.children.add(new LC(e, { labelView: g, children: [g, h, m], class: 'ck-table-cell-properties-form__alignment-row' })),
                this.children.add(
                  new LC(e, { children: [this.saveButtonView, this.cancelButtonView], class: 'ck-table-form__action-row' })
                ),
                this.setTemplate({
                  tag: 'form',
                  attributes: { class: ['ck', 'ck-form', 'ck-table-form', 'ck-table-cell-properties-form'], tabindex: '-1' },
                  children: this.children,
                });
            }
            render() {
              super.render(),
                Eu({ view: this }),
                [
                  this.borderStyleDropdown,
                  this.borderColorInput,
                  this.borderWidthInput,
                  this.backgroundInput,
                  this.widthInput,
                  this.heightInput,
                  this.paddingInput,
                  this.horizontalAlignmentToolbar,
                  this.verticalAlignmentToolbar,
                  this.saveButtonView,
                  this.cancelButtonView,
                ].forEach((e) => {
                  this._focusables.add(e), this.focusTracker.add(e.element);
                }),
                this.keystrokes.listenTo(this.element);
            }
            destroy() {
              super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
            }
            focus() {
              this._focusCycler.focusFirst();
            }
            _createBorderFields() {
              const e = this.options.defaultTableCellProperties,
                t = { style: e.borderStyle, width: e.borderWidth, color: e.borderColor },
                n = BC({ colorConfig: this.options.borderColors, columns: 5, defaultColorValue: t.color }),
                o = this.locale,
                i = this.t,
                r = new Sh(o);
              r.text = i('Border');
              const s = CC(i),
                a = new Uh(o, Wh);
              a.set({ label: i('Style'), class: 'ck-table-form__border-style' }),
                a.fieldView.buttonView.set({ isOn: !1, withText: !0, tooltip: i('Style') }),
                a.fieldView.buttonView.bind('label').to(this, 'borderStyle', (e) => s[e || 'none']),
                a.fieldView.on('execute', (e) => {
                  this.borderStyle = e.source._borderStyleValue;
                }),
                a.bind('isEmpty').to(this, 'borderStyle', (e) => !e),
                Ch(a.fieldView, IC(this, t.style));
              const l = new Uh(o, qh);
              l.set({ label: i('Width'), class: 'ck-table-form__border-width' }),
                l.fieldView.bind('value').to(this, 'borderWidth'),
                l.bind('isEnabled').to(this, 'borderStyle', iv),
                l.fieldView.on('input', () => {
                  this.borderWidth = l.fieldView.element.value;
                });
              const c = new Uh(o, n);
              return (
                c.set({ label: i('Color'), class: 'ck-table-form__border-color' }),
                c.fieldView.bind('value').to(this, 'borderColor'),
                c.bind('isEnabled').to(this, 'borderStyle', iv),
                c.fieldView.on('input', () => {
                  this.borderColor = c.fieldView.value;
                }),
                this.on('change:borderStyle', (e, n, o, i) => {
                  iv(o) || ((this.borderColor = ''), (this.borderWidth = '')),
                    iv(i) || ((this.borderColor = t.color), (this.borderWidth = t.width));
                }),
                { borderRowLabel: r, borderStyleDropdown: a, borderColorInput: c, borderWidthInput: l }
              );
            }
            _createBackgroundFields() {
              const e = this.locale,
                t = this.t,
                n = new Sh(e);
              n.text = t('Background');
              const o = BC({
                  colorConfig: this.options.backgroundColors,
                  columns: 5,
                  defaultColorValue: this.options.defaultTableCellProperties.backgroundColor,
                }),
                i = new Uh(e, o);
              return (
                i.set({ label: t('Color'), class: 'ck-table-cell-properties-form__background' }),
                i.fieldView.bind('value').to(this, 'backgroundColor'),
                i.fieldView.on('input', () => {
                  this.backgroundColor = i.fieldView.value;
                }),
                { backgroundRowLabel: n, backgroundInput: i }
              );
            }
            _createDimensionFields() {
              const e = this.locale,
                t = this.t,
                n = new Sh(e);
              n.text = t('Dimensions');
              const o = new Uh(e, qh);
              o.set({ label: t('Width'), class: 'ck-table-form__dimensions-row__width' }),
                o.fieldView.bind('value').to(this, 'width'),
                o.fieldView.on('input', () => {
                  this.width = o.fieldView.element.value;
                });
              const i = new Jd(e);
              i.setTemplate({ tag: 'span', attributes: { class: ['ck-table-form__dimension-operator'] }, children: [{ text: '×' }] });
              const r = new Uh(e, qh);
              return (
                r.set({ label: t('Height'), class: 'ck-table-form__dimensions-row__height' }),
                r.fieldView.bind('value').to(this, 'height'),
                r.fieldView.on('input', () => {
                  this.height = r.fieldView.element.value;
                }),
                { dimensionsLabel: n, widthInput: o, operatorLabel: i, heightInput: r }
              );
            }
            _createPaddingField() {
              const e = this.locale,
                t = this.t,
                n = new Uh(e, qh);
              return (
                n.set({ label: t('Padding'), class: 'ck-table-cell-properties-form__padding' }),
                n.fieldView.bind('value').to(this, 'padding'),
                n.fieldView.on('input', () => {
                  this.padding = n.fieldView.element.value;
                }),
                n
              );
            }
            _createAlignmentFields() {
              const e = this.locale,
                t = this.t,
                n = new Sh(e);
              n.text = t('Table cell text alignment');
              const o = new lh(e),
                i = 'rtl' === this.locale.contentLanguageDirection;
              o.set({ isCompact: !0, ariaLabel: t('Horizontal text alignment toolbar') }),
                SC({
                  view: this,
                  icons: nv,
                  toolbar: o,
                  labels: this._horizontalAlignmentLabels,
                  propertyName: 'horizontalAlignment',
                  nameToValue: (e) => {
                    if (i) {
                      if ('left' === e) return 'right';
                      if ('right' === e) return 'left';
                    }
                    return e;
                  },
                  defaultValue: this.options.defaultTableCellProperties.horizontalAlignment,
                });
              const r = new lh(e);
              return (
                r.set({ isCompact: !0, ariaLabel: t('Vertical text alignment toolbar') }),
                SC({
                  view: this,
                  icons: nv,
                  toolbar: r,
                  labels: this._verticalAlignmentLabels,
                  propertyName: 'verticalAlignment',
                  defaultValue: this.options.defaultTableCellProperties.verticalAlignment,
                }),
                { horizontalAlignmentToolbar: o, verticalAlignmentToolbar: r, alignmentLabel: n }
              );
            }
            _createActionButtons() {
              const e = this.locale,
                t = this.t,
                n = new zu(e),
                o = new zu(e),
                i = [this.borderWidthInput, this.borderColorInput, this.backgroundInput, this.paddingInput];
              return (
                n.set({ label: t('Save'), icon: Cu.check, class: 'ck-button-save', type: 'submit', withText: !0 }),
                n.bind('isEnabled').toMany(i, 'errorText', (...e) => e.every((e) => !e)),
                o.set({ label: t('Cancel'), icon: Cu.cancel, class: 'ck-button-cancel', withText: !0 }),
                o.delegate('execute').to(this, 'cancel'),
                { saveButtonView: n, cancelButtonView: o }
              );
            }
            get _horizontalAlignmentLabels() {
              const e = this.locale,
                t = this.t,
                n = t('Align cell text to the left'),
                o = t('Align cell text to the center'),
                i = t('Align cell text to the right'),
                r = t('Justify cell text');
              return 'rtl' === e.uiLanguageDirection
                ? { right: i, center: o, left: n, justify: r }
                : { left: n, center: o, right: i, justify: r };
            }
            get _verticalAlignmentLabels() {
              const e = this.t;
              return {
                top: e('Align cell text to the top'),
                middle: e('Align cell text to the middle'),
                bottom: e('Align cell text to the bottom'),
              };
            }
          }
          function iv(e) {
            return 'none' !== e;
          }
          const rv = {
            borderStyle: 'tableCellBorderStyle',
            borderColor: 'tableCellBorderColor',
            borderWidth: 'tableCellBorderWidth',
            width: 'tableCellWidth',
            height: 'tableCellHeight',
            padding: 'tableCellPadding',
            backgroundColor: 'tableCellBackgroundColor',
            horizontalAlignment: 'tableCellHorizontalAlignment',
            verticalAlignment: 'tableCellVerticalAlignment',
          };
          class sv extends V {
            static get requires() {
              return [Xh];
            }
            static get pluginName() {
              return 'TableCellPropertiesUI';
            }
            constructor(e) {
              super(e), e.config.define('table.tableCellProperties', { borderColors: MC, backgroundColors: MC });
            }
            init() {
              const e = this.editor,
                t = e.t;
              (this._defaultTableCellProperties = aC(e.config.get('table.tableCellProperties.defaultProperties'), {
                includeVerticalAlignmentProperty: !0,
                includeHorizontalAlignmentProperty: !0,
                includePaddingProperty: !0,
                isRightToLeftContent: 'rtl' === e.locale.contentLanguageDirection,
              })),
                (this._balloon = e.plugins.get(Xh)),
                (this.view = this._createPropertiesView()),
                (this._undoStepBatch = null),
                e.ui.componentFactory.add('tableCellProperties', (n) => {
                  const o = new zu(n);
                  o.set({
                    label: t('Cell properties'),
                    icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.105 18-.17 1H2.5A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1h15A1.5 1.5 0 0 1 19 2.5v9.975l-.85-.124-.15-.302V8h-5v4h.021l-.172.351-1.916.28-.151.027c-.287.063-.54.182-.755.341L8 13v5h3.105zM2 12h5V8H2v4zm10-4H8v4h4V8zM2 2v5h5V2H2zm0 16h5v-5H2v5zM13 7h5V2h-5v5zM8 2v5h4V2H8z" opacity=".6"/><path d="m15.5 11.5 1.323 2.68 2.957.43-2.14 2.085.505 2.946L15.5 18.25l-2.645 1.39.505-2.945-2.14-2.086 2.957-.43L15.5 11.5zM13 6a1 1 0 0 1 1 1v3.172a2.047 2.047 0 0 0-.293.443l-.858 1.736-1.916.28-.151.027A1.976 1.976 0 0 0 9.315 14H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6zm-1 2H8v4h4V8z"/></svg>',
                    tooltip: !0,
                  }),
                    this.listenTo(o, 'execute', () => this._showView());
                  const i = Object.values(rv).map((t) => e.commands.get(t));
                  return o.bind('isEnabled').toMany(i, 'isEnabled', (...e) => e.some((e) => e)), o;
                });
            }
            destroy() {
              super.destroy(), this.view.destroy();
            }
            _createPropertiesView() {
              const e = this.editor,
                t = e.editing.view.document,
                n = e.config.get('table.tableCellProperties'),
                o = Vu(n.borderColors),
                i = Ru(e.locale, o),
                r = Vu(n.backgroundColors),
                s = Ru(e.locale, r),
                a = new ov(e.locale, {
                  borderColors: i,
                  backgroundColors: s,
                  defaultTableCellProperties: this._defaultTableCellProperties,
                }),
                l = e.t;
              a.render(),
                this.listenTo(a, 'submit', () => {
                  this._hideView();
                }),
                this.listenTo(a, 'cancel', () => {
                  this._undoStepBatch.operations.length && e.execute('undo', this._undoStepBatch), this._hideView();
                }),
                a.keystrokes.set('Esc', (e, t) => {
                  this._hideView(), t();
                }),
                this.listenTo(e.ui, 'update', () => {
                  QA(t.selection) ? this._isViewVisible && YC(e, 'cell') : this._hideView();
                }),
                vu({
                  emitter: a,
                  activator: () => this._isViewInBalloon,
                  contextElements: [this._balloon.view.element],
                  callback: () => this._hideView(),
                });
              const c = vC(l),
                d = xC(l);
              return (
                a.on(
                  'change:borderStyle',
                  this._getPropertyChangeCallback('tableCellBorderStyle', this._defaultTableCellProperties.borderStyle)
                ),
                a.on(
                  'change:borderColor',
                  this._getValidatedPropertyChangeCallback({
                    viewField: a.borderColorInput,
                    commandName: 'tableCellBorderColor',
                    errorText: c,
                    validator: EC,
                    defaultValue: this._defaultTableCellProperties.borderColor,
                  })
                ),
                a.on(
                  'change:borderWidth',
                  this._getValidatedPropertyChangeCallback({
                    viewField: a.borderWidthInput,
                    commandName: 'tableCellBorderWidth',
                    errorText: d,
                    validator: TC,
                    defaultValue: this._defaultTableCellProperties.borderWidth,
                  })
                ),
                a.on(
                  'change:padding',
                  this._getValidatedPropertyChangeCallback({
                    viewField: a.paddingInput,
                    commandName: 'tableCellPadding',
                    errorText: d,
                    validator: DC,
                    defaultValue: this._defaultTableCellProperties.padding,
                  })
                ),
                a.on(
                  'change:width',
                  this._getValidatedPropertyChangeCallback({
                    viewField: a.widthInput,
                    commandName: 'tableCellWidth',
                    errorText: d,
                    validator: DC,
                    defaultValue: this._defaultTableCellProperties.width,
                  })
                ),
                a.on(
                  'change:height',
                  this._getValidatedPropertyChangeCallback({
                    viewField: a.heightInput,
                    commandName: 'tableCellHeight',
                    errorText: d,
                    validator: DC,
                    defaultValue: this._defaultTableCellProperties.height,
                  })
                ),
                a.on(
                  'change:backgroundColor',
                  this._getValidatedPropertyChangeCallback({
                    viewField: a.backgroundInput,
                    commandName: 'tableCellBackgroundColor',
                    errorText: c,
                    validator: EC,
                    defaultValue: this._defaultTableCellProperties.backgroundColor,
                  })
                ),
                a.on(
                  'change:horizontalAlignment',
                  this._getPropertyChangeCallback('tableCellHorizontalAlignment', this._defaultTableCellProperties.horizontalAlignment)
                ),
                a.on(
                  'change:verticalAlignment',
                  this._getPropertyChangeCallback('tableCellVerticalAlignment', this._defaultTableCellProperties.verticalAlignment)
                ),
                a
              );
            }
            _fillViewFormFromCommandValues() {
              const e = this.editor.commands,
                t = e.get('tableCellBorderStyle');
              Object.entries(rv)
                .map(([t, n]) => {
                  const o = this._defaultTableCellProperties[t] || '';
                  return [t, e.get(n).value || o];
                })
                .forEach(([e, n]) => {
                  (('borderColor' !== e && 'borderWidth' !== e) || 'none' !== t.value) && this.view.set(e, n);
                });
            }
            _showView() {
              const e = this.editor;
              this._fillViewFormFromCommandValues(),
                this._balloon.add({ view: this.view, position: QC(e) }),
                (this._undoStepBatch = e.model.createBatch()),
                this.view.focus();
            }
            _hideView() {
              if (!this._isViewInBalloon) return;
              const e = this.editor;
              this.stopListening(e.ui, 'update'),
                this.view.saveButtonView.focus(),
                this._balloon.remove(this.view),
                this.editor.editing.view.focus();
            }
            get _isViewVisible() {
              return this._balloon.visibleView === this.view;
            }
            get _isViewInBalloon() {
              return this._balloon.hasView(this.view);
            }
            _getPropertyChangeCallback(e, t) {
              return (n, o, i, r) => {
                (r || t !== i) && this.editor.execute(e, { value: i, batch: this._undoStepBatch });
              };
            }
            _getValidatedPropertyChangeCallback(e) {
              const { commandName: t, viewField: n, validator: o, errorText: i, defaultValue: r } = e,
                s = aa(() => {
                  n.errorText = i;
                }, 500);
              return (e, i, a, l) => {
                s.cancel(),
                  (l || r !== a) && (o(a) ? (this.editor.execute(t, { value: a, batch: this._undoStepBatch }), (n.errorText = null)) : s());
              };
            }
          }
          class av extends H {
            constructor(e, t, n) {
              super(e), (this.attributeName = t), (this._defaultValue = n);
            }
            refresh() {
              const e = this.editor,
                t = this.editor.plugins.get('TableUtils').getSelectionAffectedTableCells(e.model.document.selection);
              (this.isEnabled = !!t.length), (this.value = this._getSingleValue(t));
            }
            execute(e = {}) {
              const { value: t, batch: n } = e,
                o = this.editor.model,
                i = this.editor.plugins.get('TableUtils').getSelectionAffectedTableCells(o.document.selection),
                r = this._getValueToSet(t);
              o.enqueueChange(n, (e) => {
                r ? i.forEach((t) => e.setAttribute(this.attributeName, r, t)) : i.forEach((t) => e.removeAttribute(this.attributeName, t));
              });
            }
            _getAttribute(e) {
              if (!e) return;
              const t = e.getAttribute(this.attributeName);
              return t !== this._defaultValue ? t : void 0;
            }
            _getValueToSet(e) {
              if (e !== this._defaultValue) return e;
            }
            _getSingleValue(e) {
              const t = this._getAttribute(e[0]);
              return e.every((e) => this._getAttribute(e) === t) ? t : void 0;
            }
          }
          class lv extends av {
            constructor(e, t) {
              super(e, 'tableCellPadding', t);
            }
            _getAttribute(e) {
              if (!e) return;
              const t = rC(e.getAttribute(this.attributeName));
              return t !== this._defaultValue ? t : void 0;
            }
            _getValueToSet(e) {
              if ((e = sC(e, 'px')) !== this._defaultValue) return e;
            }
          }
          class cv extends av {
            constructor(e, t) {
              super(e, 'tableCellWidth', t);
            }
            _getValueToSet(e) {
              if ((e = sC(e, 'px')) !== this._defaultValue) return e;
            }
          }
          class dv extends av {
            constructor(e, t) {
              super(e, 'tableCellHeight', t);
            }
            _getValueToSet(e) {
              return (e = sC(e, 'px')) === this._defaultValue ? null : e;
            }
          }
          class uv extends av {
            constructor(e, t) {
              super(e, 'tableCellBackgroundColor', t);
            }
          }
          class hv extends av {
            constructor(e, t) {
              super(e, 'tableCellVerticalAlignment', t);
            }
          }
          class mv extends av {
            constructor(e, t) {
              super(e, 'tableCellHorizontalAlignment', t);
            }
          }
          class gv extends av {
            constructor(e, t) {
              super(e, 'tableCellBorderStyle', t);
            }
            _getAttribute(e) {
              if (!e) return;
              const t = rC(e.getAttribute(this.attributeName));
              return t !== this._defaultValue ? t : void 0;
            }
          }
          class pv extends av {
            constructor(e, t) {
              super(e, 'tableCellBorderColor', t);
            }
            _getAttribute(e) {
              if (!e) return;
              const t = rC(e.getAttribute(this.attributeName));
              return t !== this._defaultValue ? t : void 0;
            }
          }
          class fv extends av {
            constructor(e, t) {
              super(e, 'tableCellBorderWidth', t);
            }
            _getAttribute(e) {
              if (!e) return;
              const t = rC(e.getAttribute(this.attributeName));
              return t !== this._defaultValue ? t : void 0;
            }
            _getValueToSet(e) {
              if ((e = sC(e, 'px')) !== this._defaultValue) return e;
            }
          }
          const kv = /^(top|middle|bottom)$/,
            bv = /^(left|center|right|justify)$/;
          class wv extends V {
            static get pluginName() {
              return 'TableCellPropertiesEditing';
            }
            static get requires() {
              return [DA];
            }
            init() {
              const e = this.editor,
                t = e.model.schema,
                n = e.conversion;
              e.config.define('table.tableCellProperties.defaultProperties', {});
              const o = aC(e.config.get('table.tableCellProperties.defaultProperties'), {
                includeVerticalAlignmentProperty: !0,
                includeHorizontalAlignmentProperty: !0,
                includePaddingProperty: !0,
                isRightToLeftContent: 'rtl' === e.locale.contentLanguageDirection,
              });
              e.data.addStyleProcessorRules(ng),
                (function (e, t, n) {
                  const o = { width: 'tableCellBorderWidth', color: 'tableCellBorderColor', style: 'tableCellBorderStyle' };
                  e.extend('tableCell', { allowAttributes: Object.values(o) }),
                    XA(t, 'td', o, n),
                    XA(t, 'th', o, n),
                    eC(t, { modelElement: 'tableCell', modelAttribute: o.style, styleName: 'border-style' }),
                    eC(t, { modelElement: 'tableCell', modelAttribute: o.color, styleName: 'border-color' }),
                    eC(t, { modelElement: 'tableCell', modelAttribute: o.width, styleName: 'border-width' });
                })(t, n, { color: o.borderColor, style: o.borderStyle, width: o.borderWidth }),
                e.commands.add('tableCellBorderStyle', new gv(e, o.borderStyle)),
                e.commands.add('tableCellBorderColor', new pv(e, o.borderColor)),
                e.commands.add('tableCellBorderWidth', new fv(e, o.borderWidth)),
                _v(t, n, { modelAttribute: 'tableCellWidth', styleName: 'width', defaultValue: o.width }),
                e.commands.add('tableCellWidth', new cv(e, o.width)),
                _v(t, n, { modelAttribute: 'tableCellHeight', styleName: 'height', defaultValue: o.height }),
                e.commands.add('tableCellHeight', new dv(e, o.height)),
                e.data.addStyleProcessorRules(mg),
                _v(t, n, { modelAttribute: 'tableCellPadding', styleName: 'padding', reduceBoxSides: !0, defaultValue: o.padding }),
                e.commands.add('tableCellPadding', new lv(e, o.padding)),
                e.data.addStyleProcessorRules(tg),
                _v(t, n, { modelAttribute: 'tableCellBackgroundColor', styleName: 'background-color', defaultValue: o.backgroundColor }),
                e.commands.add('tableCellBackgroundColor', new uv(e, o.backgroundColor)),
                (function (e, t, n) {
                  e.extend('tableCell', { allowAttributes: ['tableCellHorizontalAlignment'] }),
                    t.for('downcast').attributeToAttribute({
                      model: { name: 'tableCell', key: 'tableCellHorizontalAlignment' },
                      view: (e) => ({ key: 'style', value: { 'text-align': e } }),
                    }),
                    t
                      .for('upcast')
                      .attributeToAttribute({
                        view: { name: /^(td|th)$/, styles: { 'text-align': bv } },
                        model: {
                          key: 'tableCellHorizontalAlignment',
                          value: (e) => {
                            const t = e.getStyle('text-align');
                            return t === n ? null : t;
                          },
                        },
                      })
                      .attributeToAttribute({
                        view: { name: /^(td|th)$/, attributes: { align: bv } },
                        model: {
                          key: 'tableCellHorizontalAlignment',
                          value: (e) => {
                            const t = e.getAttribute('align');
                            return t === n ? null : t;
                          },
                        },
                      });
                })(t, n, o.horizontalAlignment),
                e.commands.add('tableCellHorizontalAlignment', new mv(e, o.horizontalAlignment)),
                (function (e, t, n) {
                  e.extend('tableCell', { allowAttributes: ['tableCellVerticalAlignment'] }),
                    t.for('downcast').attributeToAttribute({
                      model: { name: 'tableCell', key: 'tableCellVerticalAlignment' },
                      view: (e) => ({ key: 'style', value: { 'vertical-align': e } }),
                    }),
                    t
                      .for('upcast')
                      .attributeToAttribute({
                        view: { name: /^(td|th)$/, styles: { 'vertical-align': kv } },
                        model: {
                          key: 'tableCellVerticalAlignment',
                          value: (e) => {
                            const t = e.getStyle('vertical-align');
                            return t === n ? null : t;
                          },
                        },
                      })
                      .attributeToAttribute({
                        view: { name: /^(td|th)$/, attributes: { valign: kv } },
                        model: {
                          key: 'tableCellVerticalAlignment',
                          value: (e) => {
                            const t = e.getAttribute('valign');
                            return t === n ? null : t;
                          },
                        },
                      });
                })(t, n, o.verticalAlignment),
                e.commands.add('tableCellVerticalAlignment', new hv(e, o.verticalAlignment));
            }
          }
          function _v(e, t, n) {
            const { modelAttribute: o } = n;
            e.extend('tableCell', { allowAttributes: [o] }),
              JA(t, { viewElement: /^(td|th)$/, ...n }),
              eC(t, { modelElement: 'tableCell', ...n });
          }
          const yv = 'underline';
          class Av extends V {
            static get pluginName() {
              return 'UnderlineEditing';
            }
            init() {
              const e = this.editor;
              e.model.schema.extend('$text', { allowAttributes: yv }),
                e.model.schema.setAttributeProperties(yv, { isFormatting: !0, copyOnEnter: !0 }),
                e.conversion.attributeToElement({ model: yv, view: 'u', upcastAlso: { styles: { 'text-decoration': 'underline' } } }),
                e.commands.add(yv, new Ip(e, yv)),
                e.keystrokes.set('CTRL+U', 'underline');
            }
          }
          const Cv = 'underline';
          class vv extends V {
            static get pluginName() {
              return 'UnderlineUI';
            }
            init() {
              const e = this.editor,
                t = e.t;
              e.ui.componentFactory.add(Cv, (n) => {
                const o = e.commands.get(Cv),
                  i = new zu(n);
                return (
                  i.set({
                    label: t('Underline'),
                    icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 18v-1.5h14V18zm2.2-8V3.6c0-.4.4-.6.8-.6.3 0 .7.2.7.6v6.2c0 2 1.3 2.8 3.2 2.8 1.9 0 3.4-.9 3.4-2.9V3.6c0-.3.4-.5.8-.5.3 0 .7.2.7.5V10c0 2.7-2.2 4-4.9 4-2.6 0-4.7-1.2-4.7-4z"/></svg>',
                    keystroke: 'CTRL+U',
                    tooltip: !0,
                    isToggleable: !0,
                  }),
                  i.bind('isOn', 'isEnabled').to(o, 'value', 'isEnabled'),
                  this.listenTo(i, 'execute', () => {
                    e.execute(Cv), e.editing.view.focus();
                  }),
                  i
                );
              });
            }
          }
          var xv = n(6710),
            Ev = { injectType: 'singletonStyleTag', attributes: { 'data-cke': !0 }, insert: 'head', singleton: !0 };
          Xr()(xv.Z, Ev);
          xv.Z.locals;
          class Dv extends Jd {
            constructor(e) {
              super(e.locale),
                (this.focusTracker = new va()),
                (this.keystrokes = new xa()),
                (this.emojiButtonViews = new Id(e.locale)),
                e.config.get('emoji').forEach((e) => {
                  this.emojiButtonViews.add(this._createButton(e.text, 'emoji:' + e.name));
                }),
                (this._focusables = new Id()),
                (this._focusCycler = new th({
                  focusables: this._focusables,
                  focusTracker: this.focusTracker,
                  keystrokeHandler: this.keystrokes,
                  actions: { focusPrevious: 'shift + tab', focusNext: 'tab' },
                })),
                this.setTemplate({
                  tag: 'form',
                  attributes: { class: ['ck-emoji'], tabindex: '-1' },
                  children: [{ tag: 'div', attributes: { class: ['ck-emoji__actions'] }, children: this.emojiButtonViews }],
                });
            }
            render() {
              super.render(),
                Eu({ view: this }),
                this.emojiButtonViews.map((e) => {
                  this._focusables.add(e), this.focusTracker.add(e.element);
                }),
                this.keystrokes.listenTo(this.element);
            }
            focus() {
              this._focusCycler.focusFirst();
            }
            _createButton(e, t) {
              const n = new zu(this.locale);
              return (n.label = e), (n.withText = !0), t && n.delegate('execute').to(this, t), n;
            }
          }
          const Tv = JSON.parse(
            '[{"name":":grinning_face:","text":"😀","group":"people","keywords":["face","grin","grinning face"]},{"name":":beaming_face_with_smiling_eyes:","text":"😁","group":"people","keywords":["beaming face with smiling eyes","eye","face","grin","smile"]},{"name":":face_with_tears_of_joy:","text":"😂","group":"people","keywords":["face","face with tears of joy","joy","laugh","tear"]},{"name":":rolling_on_the_floor_laughing:","text":"🤣","group":"people","keywords":["face","floor","laugh","rolling","rolling on the floor laughing"]},{"name":":grinning_face_with_big_eyes:","text":"😃","group":"people","keywords":["face","grinning face with big eyes","mouth","open","smile"]},{"name":":grinning_face_with_smiling_eyes:","text":"😄","group":"people","keywords":["eye","face","grinning face with smiling eyes","mouth","open","smile"]},{"name":":grinning_face_with_sweat:","text":"😅","group":"people","keywords":["cold","face","grinning face with sweat","open","smile","sweat"]},{"name":":grinning_squinting_face:","text":"😆","group":"people","keywords":["face","grinning squinting face","laugh","mouth","satisfied","smile"]},{"name":":winking_face:","text":"😉","group":"people","keywords":["face","wink","winking face"]},{"name":":smiling_face_with_smiling_eyes:","text":"😊","group":"people","keywords":["blush","eye","face","smile","smiling face with smiling eyes"]},{"name":":face_savoring_food:","text":"😋","group":"people","keywords":["delicious","face","face savoring food","savouring","smile","yum"]},{"name":":smiling_face_with_sunglasses:","text":"😎","group":"people","keywords":["bright","cool","face","smiling face with sunglasses","sun","sunglasses"]},{"name":":smiling_face_with_heart-eyes:","text":"😍","group":"people","keywords":["eye","face","love","smile","smiling face with heart-eyes"]},{"name":":face_blowing_a_kiss:","text":"😘","group":"people","keywords":["face","face blowing a kiss","kiss"]},{"name":":kissing_face:","text":"😗","group":"people","keywords":["face","kiss","kissing face"]},{"name":":kissing_face_with_smiling_eyes:","text":"😙","group":"people","keywords":["eye","face","kiss","kissing face with smiling eyes","smile"]},{"name":":kissing_face_with_closed_eyes:","text":"😚","group":"people","keywords":["closed","eye","face","kiss","kissing face with closed eyes"]},{"name":":smiling_face:","text":"☺","group":"people","keywords":["face","outlined","relaxed","smile","smiling face"]},{"name":":slightly_smiling_face:","text":"🙂","group":"people","keywords":["face","slightly smiling face","smile"]},{"name":":hugging_face:","text":"🤗","group":"people","keywords":["face","hug","hugging"]},{"name":":star-struck:","text":"🤩","group":"people","keywords":["eyes","face","grinning","star","star-struck",""]},{"name":":thinking_face:","text":"🤔","group":"people","keywords":["face","thinking"]},{"name":":face_with_raised_eyebrow:","text":"🤨","group":"people","keywords":["distrust","face with raised eyebrow","skeptic",""]},{"name":":neutral_face:","text":"😐","group":"people","keywords":["deadpan","face","neutral"]},{"name":":expressionless_face:","text":"😑","group":"people","keywords":["expressionless","face","inexpressive","unexpressive"]},{"name":":face_without_mouth:","text":"😶","group":"people","keywords":["face","face without mouth","mouth","quiet","silent"]},{"name":":face_with_rolling_eyes:","text":"🙄","group":"people","keywords":["eyes","face","face with rolling eyes","rolling"]},{"name":":smirking_face:","text":"😏","group":"people","keywords":["face","smirk","smirking face"]},{"name":":persevering_face:","text":"😣","group":"people","keywords":["face","persevere","persevering face"]},{"name":":sad_but_relieved_face:","text":"😥","group":"people","keywords":["disappointed","face","relieved","sad but relieved face","whew"]},{"name":":face_with_open_mouth:","text":"😮","group":"people","keywords":["face","face with open mouth","mouth","open","sympathy"]},{"name":":zipper-mouth_face:","text":"🤐","group":"people","keywords":["face","mouth","zipper","zipper-mouth face"]},{"name":":hushed_face:","text":"😯","group":"people","keywords":["face","hushed","stunned","surprised"]},{"name":":sleepy_face:","text":"😪","group":"people","keywords":["face","sleep","sleepy face"]},{"name":":tired_face:","text":"😫","group":"people","keywords":["face","tired"]},{"name":":sleeping_face:","text":"😴","group":"people","keywords":["face","sleep","sleeping face","zzz"]},{"name":":relieved_face:","text":"😌","group":"people","keywords":["face","relieved"]},{"name":":face_with_tongue:","text":"😛","group":"people","keywords":["face","face with tongue","tongue"]},{"name":":winking_face_with_tongue:","text":"😜","group":"people","keywords":["eye","face","joke","tongue","wink","winking face with tongue"]},{"name":":squinting_face_with_tongue:","text":"😝","group":"people","keywords":["eye","face","horrible","squinting face with tongue","taste","tongue"]},{"name":":drooling_face:","text":"🤤","group":"people","keywords":["drooling","face"]},{"name":":unamused_face:","text":"😒","group":"people","keywords":["face","unamused","unhappy"]},{"name":":downcast_face_with_sweat:","text":"😓","group":"people","keywords":["cold","downcast face with sweat","face","sweat"]},{"name":":pensive_face:","text":"😔","group":"people","keywords":["dejected","face","pensive"]},{"name":":confused_face:","text":"😕","group":"people","keywords":["confused","face"]},{"name":":upside-down_face:","text":"🙃","group":"people","keywords":["face","upside-down"]},{"name":":money-mouth_face:","text":"🤑","group":"people","keywords":["face","money","money-mouth face","mouth"]},{"name":":astonished_face:","text":"😲","group":"people","keywords":["astonished","face","shocked","totally"]},{"name":":frowning_face:","text":"☹","group":"people","keywords":["face","frown","frowning face"]},{"name":":slightly_frowning_face:","text":"🙁","group":"people","keywords":["face","frown","slightly frowning face"]},{"name":":confounded_face:","text":"😖","group":"people","keywords":["confounded","face"]},{"name":":disappointed_face:","text":"😞","group":"people","keywords":["disappointed","face"]},{"name":":worried_face:","text":"😟","group":"people","keywords":["face","worried"]},{"name":":face_with_steam_from_nose:","text":"😤","group":"people","keywords":["face","face with steam from nose","triumph","won"]},{"name":":crying_face:","text":"😢","group":"people","keywords":["cry","crying face","face","sad","tear"]},{"name":":loudly_crying_face:","text":"😭","group":"people","keywords":["cry","face","loudly crying face","sad","sob","tear"]},{"name":":frowning_face_with_open_mouth:","text":"😦","group":"people","keywords":["face","frown","frowning face with open mouth","mouth","open"]},{"name":":anguished_face:","text":"😧","group":"people","keywords":["anguished","face"]},{"name":":fearful_face:","text":"😨","group":"people","keywords":["face","fear","fearful","scared"]},{"name":":weary_face:","text":"😩","group":"people","keywords":["face","tired","weary"]},{"name":":exploding_head:","text":"🤯","group":"people","keywords":["exploding head","shocked"]},{"name":":grimacing_face:","text":"😬","group":"people","keywords":["face","grimace","grimacing face"]},{"name":":anxious_face_with_sweat:","text":"😰","group":"people","keywords":["anxious face with sweat","blue","cold","face","rushed","sweat"]},{"name":":face_screaming_in_fear:","text":"😱","group":"people","keywords":["face","face screaming in fear","fear","munch","scared","scream"]},{"name":":flushed_face:","text":"😳","group":"people","keywords":["dazed","face","flushed"]},{"name":":zany_face:","text":"🤪","group":"people","keywords":["eye","goofy","large","small","zany face"]},{"name":":dizzy_face:","text":"😵","group":"people","keywords":["dizzy","face"]},{"name":":pouting_face:","text":"😡","group":"people","keywords":["angry","face","mad","pouting","rage","red"]},{"name":":angry_face:","text":"😠","group":"people","keywords":["angry","face","mad"]},{"name":":face_with_symbols_on_mouth:","text":"🤬","group":"people","keywords":["face with symbols on mouth","swearing",""]},{"name":":face_with_medical_mask:","text":"😷","group":"people","keywords":["cold","doctor","face","face with medical mask","mask","sick"]},{"name":":face_with_thermometer:","text":"🤒","group":"people","keywords":["face","face with thermometer","ill","sick","thermometer"]},{"name":":face_with_head-bandage:","text":"🤕","group":"people","keywords":["bandage","face","face with head-bandage","hurt","injury"]},{"name":":nauseated_face:","text":"🤢","group":"people","keywords":["face","nauseated","vomit"]},{"name":":face_vomiting:","text":"🤮","group":"people","keywords":["face vomiting","sick","vomit"]},{"name":":sneezing_face:","text":"🤧","group":"people","keywords":["face","gesundheit","sneeze","sneezing face"]},{"name":":smiling_face_with_halo:","text":"😇","group":"people","keywords":["angel","face","fantasy","halo","innocent","smiling face with halo"]},{"name":":cowboy_hat_face:","text":"🤠","group":"people","keywords":["cowboy","cowgirl","face","hat"]},{"name":":lying_face:","text":"🤥","group":"people","keywords":["face","lie","lying face","pinocchio"]},{"name":":shushing_face:","text":"🤫","group":"people","keywords":["quiet","shush","shushing face"]},{"name":":face_with_hand_over_mouth:","text":"🤭","group":"people","keywords":["face with hand over mouth","whoops",""]},{"name":":face_with_monocle:","text":"🧐","group":"people","keywords":["face with monocle","stuffy",""]},{"name":":nerd_face:","text":"🤓","group":"people","keywords":["face","geek","nerd"]},{"name":":smiling_face_with_horns:","text":"😈","group":"people","keywords":["face","fairy tale","fantasy","horns","smile","smiling face with horns"]},{"name":":angry_face_with_horns:","text":"👿","group":"people","keywords":["angry face with horns","demon","devil","face","fantasy","imp"]},{"name":":clown_face:","text":"🤡","group":"people","keywords":["clown","face"]},{"name":":ogre:","text":"👹","group":"people","keywords":["creature","face","fairy tale","fantasy","monster","ogre",""]},{"name":":goblin:","text":"👺","group":"people","keywords":["creature","face","fairy tale","fantasy","goblin","monster"]},{"name":":skull:","text":"💀","group":"people","keywords":["death","face","fairy tale","monster","skull"]},{"name":":skull_and_crossbones:","text":"☠","group":"people","keywords":["crossbones","death","face","monster","skull","skull and crossbones"]},{"name":":ghost:","text":"👻","group":"people","keywords":["creature","face","fairy tale","fantasy","ghost","monster"]},{"name":":alien:","text":"👽","group":"people","keywords":["alien","creature","extraterrestrial","face","fantasy","ufo"]},{"name":":alien_monster:","text":"👾","group":"people","keywords":["alien","creature","extraterrestrial","face","monster","ufo"]},{"name":":robot_face:","text":"🤖","group":"people","keywords":["face","monster","robot"]},{"name":":pile_of_poo:","text":"💩","group":"people","keywords":["dung","face","monster","pile of poo","poo","poop"]},{"name":":grinning_cat_face:","text":"😺","group":"people","keywords":["cat","face","grinning cat face","mouth","open","smile"]},{"name":":grinning_cat_face_with_smiling_eyes:","text":"😸","group":"people","keywords":["cat","eye","face","grin","grinning cat face with smiling eyes","smile"]},{"name":":cat_face_with_tears_of_joy:","text":"😹","group":"people","keywords":["cat","cat face with tears of joy","face","joy","tear"]},{"name":":smiling_cat_face_with_heart-eyes:","text":"😻","group":"people","keywords":["cat","eye","face","love","smile","smiling cat face with heart-eyes"]},{"name":":cat_face_with_wry_smile:","text":"😼","group":"people","keywords":["cat","cat face with wry smile","face","ironic","smile","wry"]},{"name":":kissing_cat_face:","text":"😽","group":"people","keywords":["cat","eye","face","kiss","kissing cat face"]},{"name":":weary_cat_face:","text":"🙀","group":"people","keywords":["cat","face","oh","surprised","weary"]},{"name":":crying_cat_face:","text":"😿","group":"people","keywords":["cat","cry","crying cat face","face","sad","tear"]},{"name":":pouting_cat_face:","text":"😾","group":"people","keywords":["cat","face","pouting"]},{"name":":see-no-evil_monkey:","text":"🙈","group":"people","keywords":["evil","face","forbidden","monkey","see","see-no-evil monkey"]},{"name":":hear-no-evil_monkey:","text":"🙉","group":"people","keywords":["evil","face","forbidden","hear","hear-no-evil monkey","monkey"]},{"name":":speak-no-evil_monkey:","text":"🙊","group":"people","keywords":["evil","face","forbidden","monkey","speak","speak-no-evil monkey"]},{"name":":baby:","text":"👶","group":"people","keywords":["baby","young"]},{"name":":child:","text":"🧒","group":"people","keywords":["child","gender-neutral","unspecified gender","young"]},{"name":":boy:","text":"👦","group":"people","keywords":["boy","young"]},{"name":":girl:","text":"👧","group":"people","keywords":["girl","Virgo","young","zodiac"]},{"name":":person:","text":"🧑","group":"people","keywords":["adult","gender-neutral","person","unspecified gender"]},{"name":":person_blond_hair:","text":"👱","group":"people","keywords":["blond","blond-haired person","person: blond hair"]},{"name":":man:","text":"👨","group":"people","keywords":["adult","man"]},{"name":":man_blond_hair:","text":"👱‍♂️","group":"people","keywords":["blond","blond-haired man","man","man: blond hair"]},{"name":":man_beard:","text":"🧔","group":"people","keywords":["beard","man: beard","person",""]},{"name":":woman:","text":"👩","group":"people","keywords":["adult","woman"]},{"name":":woman_blond_hair:","text":"👱‍♀️","group":"people","keywords":["blond-haired woman","blonde","woman","woman: blond hair"]},{"name":":older_person:","text":"🧓","group":"people","keywords":["adult","gender-neutral","old","older person","unspecified gender"]},{"name":":old_man:","text":"👴","group":"people","keywords":["adult","man","old"]},{"name":":old_woman:","text":"👵","group":"people","keywords":["adult","old","woman"]},{"name":":man_health_worker:","text":"👨‍⚕️","group":"people","keywords":["doctor","healthcare","man","man health worker","nurse","therapist"]},{"name":":woman_health_worker:","text":"👩‍⚕️","group":"people","keywords":["doctor","healthcare","nurse","therapist","woman","woman health worker"]},{"name":":man_student:","text":"👨‍🎓","group":"people","keywords":["graduate","man","student"]},{"name":":woman_student:","text":"👩‍🎓","group":"people","keywords":["graduate","student","woman"]},{"name":":man_teacher:","text":"👨‍🏫","group":"people","keywords":["instructor","man","professor","teacher"]},{"name":":woman_teacher:","text":"👩‍🏫","group":"people","keywords":["instructor","professor","teacher","woman"]},{"name":":man_judge:","text":"👨‍⚖️","group":"people","keywords":["justice","man","man judge","scales"]},{"name":":woman_judge:","text":"👩‍⚖️","group":"people","keywords":["judge","scales","woman"]},{"name":":man_farmer:","text":"👨‍🌾","group":"people","keywords":["farmer","gardener","man","rancher"]},{"name":":woman_farmer:","text":"👩‍🌾","group":"people","keywords":["farmer","gardener","rancher","woman"]},{"name":":man_cook:","text":"👨‍🍳","group":"people","keywords":["chef","cook","man"]},{"name":":woman_cook:","text":"👩‍🍳","group":"people","keywords":["chef","cook","woman"]},{"name":":man_mechanic:","text":"👨‍🔧","group":"people","keywords":["electrician","man","mechanic","plumber","tradesperson"]},{"name":":woman_mechanic:","text":"👩‍🔧","group":"people","keywords":["electrician","mechanic","plumber","tradesperson","woman"]},{"name":":man_factory_worker:","text":"👨‍🏭","group":"people","keywords":["assembly","factory","industrial","man","worker"]},{"name":":woman_factory_worker:","text":"👩‍🏭","group":"people","keywords":["assembly","factory","industrial","woman","worker"]},{"name":":man_office_worker:","text":"👨‍💼","group":"people","keywords":["architect","business","man","man office worker","manager","white-collar"]},{"name":":woman_office_worker:","text":"👩‍💼","group":"people","keywords":["architect","business","manager","white-collar","woman","woman office worker"]},{"name":":man_scientist:","text":"👨‍🔬","group":"people","keywords":["biologist","chemist","engineer","man","physicist","scientist"]},{"name":":woman_scientist:","text":"👩‍🔬","group":"people","keywords":["biologist","chemist","engineer","physicist","scientist","woman"]},{"name":":man_technologist:","text":"👨‍💻","group":"people","keywords":["coder","developer","inventor","man","software","technologist"]},{"name":":woman_technologist:","text":"👩‍💻","group":"people","keywords":["coder","developer","inventor","software","technologist","woman"]},{"name":":man_singer:","text":"👨‍🎤","group":"people","keywords":["actor","entertainer","man","rock","singer","star"]},{"name":":woman_singer:","text":"👩‍🎤","group":"people","keywords":["actor","entertainer","rock","singer","star","woman"]},{"name":":man_artist:","text":"👨‍🎨","group":"people","keywords":["artist","man","palette"]},{"name":":woman_artist:","text":"👩‍🎨","group":"people","keywords":["artist","palette","woman"]},{"name":":man_pilot:","text":"👨‍✈️","group":"people","keywords":["man","pilot","plane"]},{"name":":woman_pilot:","text":"👩‍✈️","group":"people","keywords":["pilot","plane","woman"]},{"name":":man_astronaut:","text":"👨‍🚀","group":"people","keywords":["astronaut","man","rocket"]},{"name":":woman_astronaut:","text":"👩‍🚀","group":"people","keywords":["astronaut","rocket","woman"]},{"name":":man_firefighter:","text":"👨‍🚒","group":"people","keywords":["firefighter","firetruck","man"]},{"name":":woman_firefighter:","text":"👩‍🚒","group":"people","keywords":["firefighter","firetruck","woman"]},{"name":":police_officer:","text":"👮","group":"people","keywords":["cop","officer","police"]},{"name":":man_police_officer:","text":"👮‍♂️","group":"people","keywords":["cop","man","officer","police"]},{"name":":woman_police_officer:","text":"👮‍♀️","group":"people","keywords":["cop","officer","police","woman"]},{"name":":detective:","text":"🕵","group":"people","keywords":["detective","sleuth","spy"]},{"name":":man_detective:","text":"🕵️‍♂️","group":"people","keywords":["detective","man","sleuth","spy"]},{"name":":woman_detective:","text":"🕵️‍♀️","group":"people","keywords":["detective","sleuth","spy","woman"]},{"name":":guard:","text":"💂","group":"people","keywords":["guard"]},{"name":":man_guard:","text":"💂‍♂️","group":"people","keywords":["guard","man"]},{"name":":woman_guard:","text":"💂‍♀️","group":"people","keywords":["guard","woman"]},{"name":":construction_worker:","text":"👷","group":"people","keywords":["construction","hat","worker"]},{"name":":man_construction_worker:","text":"👷‍♂️","group":"people","keywords":["construction","man","worker"]},{"name":":woman_construction_worker:","text":"👷‍♀️","group":"people","keywords":["construction","woman","worker"]},{"name":":prince:","text":"🤴","group":"people","keywords":["prince"]},{"name":":princess:","text":"👸","group":"people","keywords":["fairy tale","fantasy","princess"]},{"name":":person_wearing_turban:","text":"👳","group":"people","keywords":["person wearing turban","turban"]},{"name":":man_wearing_turban:","text":"👳‍♂️","group":"people","keywords":["man","man wearing turban","turban"]},{"name":":woman_wearing_turban:","text":"👳‍♀️","group":"people","keywords":["turban","woman","woman wearing turban"]},{"name":":man_with_chinese_cap:","text":"👲","group":"people","keywords":["gua pi mao","hat","man","man with Chinese cap"]},{"name":":woman_with_headscarf:","text":"🧕","group":"people","keywords":["headscarf","hijab","mantilla","tichel","woman with headscarf",""]},{"name":":man_in_tuxedo:","text":"🤵","group":"people","keywords":["groom","man","man in tuxedo","tuxedo"]},{"name":":bride_with_veil:","text":"👰","group":"people","keywords":["bride","bride with veil","veil","wedding"]},{"name":":pregnant_woman:","text":"🤰","group":"people","keywords":["pregnant","woman"]},{"name":":breast-feeding:","text":"🤱","group":"people","keywords":["baby","breast","breast-feeding","nursing"]},{"name":":baby_angel:","text":"👼","group":"people","keywords":["angel","baby","face","fairy tale","fantasy"]},{"name":":santa_claus:","text":"🎅","group":"people","keywords":["celebration","Christmas","claus","father","santa","Santa Claus"]},{"name":":mrs._claus:","text":"🤶","group":"people","keywords":["celebration","Christmas","claus","mother","Mrs.","Mrs. Claus"]},{"name":":mage:","text":"🧙","group":"people","keywords":["mage","sorcerer","sorceress","witch","wizard"]},{"name":":man_mage:","text":"🧙‍♂️","group":"people","keywords":["man mage","sorcerer","wizard"]},{"name":":woman_mage:","text":"🧙‍♀️","group":"people","keywords":["sorceress","witch","woman mage"]},{"name":":fairy:","text":"🧚","group":"people","keywords":["fairy","Oberon","Puck","Titania"]},{"name":":man_fairy:","text":"🧚‍♂️","group":"people","keywords":["man fairy","Oberon","Puck"]},{"name":":woman_fairy:","text":"🧚‍♀️","group":"people","keywords":["Titania","woman fairy"]},{"name":":vampire:","text":"🧛","group":"people","keywords":["Dracula","undead","vampire"]},{"name":":man_vampire:","text":"🧛‍♂️","group":"people","keywords":["Dracula","man vampire","undead"]},{"name":":woman_vampire:","text":"🧛‍♀️","group":"people","keywords":["undead","woman vampire"]},{"name":":merperson:","text":"🧜","group":"people","keywords":["mermaid","merman","merperson","merwoman"]},{"name":":merman:","text":"🧜‍♂️","group":"people","keywords":["merman","Triton"]},{"name":":mermaid:","text":"🧜‍♀️","group":"people","keywords":["mermaid","merwoman"]},{"name":":elf:","text":"🧝","group":"people","keywords":["elf","magical",""]},{"name":":man_elf:","text":"🧝‍♂️","group":"people","keywords":["magical","man elf"]},{"name":":woman_elf:","text":"🧝‍♀️","group":"people","keywords":["magical","woman elf"]},{"name":":genie:","text":"🧞","group":"people","keywords":["djinn","genie",""]},{"name":":man_genie:","text":"🧞‍♂️","group":"people","keywords":["djinn","man genie"]},{"name":":woman_genie:","text":"🧞‍♀️","group":"people","keywords":["djinn","woman genie"]},{"name":":zombie:","text":"🧟","group":"people","keywords":["undead","walking dead","zombie",""]},{"name":":man_zombie:","text":"🧟‍♂️","group":"people","keywords":["man zombie","undead","walking dead"]},{"name":":woman_zombie:","text":"🧟‍♀️","group":"people","keywords":["undead","walking dead","woman zombie"]},{"name":":person_frowning:","text":"🙍","group":"people","keywords":["frown","gesture","person frowning"]},{"name":":man_frowning:","text":"🙍‍♂️","group":"people","keywords":["frowning","gesture","man"]},{"name":":woman_frowning:","text":"🙍‍♀️","group":"people","keywords":["frowning","gesture","woman"]},{"name":":person_pouting:","text":"🙎","group":"people","keywords":["gesture","person pouting","pouting"]},{"name":":man_pouting:","text":"🙎‍♂️","group":"people","keywords":["gesture","man","pouting"]},{"name":":woman_pouting:","text":"🙎‍♀️","group":"people","keywords":["gesture","pouting","woman"]},{"name":":person_gesturing_no:","text":"🙅","group":"people","keywords":["forbidden","gesture","hand","person gesturing NO","prohibited"]},{"name":":man_gesturing_no:","text":"🙅‍♂️","group":"people","keywords":["forbidden","gesture","hand","man","man gesturing NO","prohibited"]},{"name":":woman_gesturing_no:","text":"🙅‍♀️","group":"people","keywords":["forbidden","gesture","hand","prohibited","woman","woman gesturing NO"]},{"name":":person_gesturing_ok:","text":"🙆","group":"people","keywords":["gesture","hand","OK","person gesturing OK"]},{"name":":man_gesturing_ok:","text":"🙆‍♂️","group":"people","keywords":["gesture","hand","man","man gesturing OK","OK"]},{"name":":woman_gesturing_ok:","text":"🙆‍♀️","group":"people","keywords":["gesture","hand","OK","woman","woman gesturing OK"]},{"name":":person_tipping_hand:","text":"💁","group":"people","keywords":["hand","help","information","person tipping hand","sassy","tipping"]},{"name":":man_tipping_hand:","text":"💁‍♂️","group":"people","keywords":["man","man tipping hand","sassy","tipping hand"]},{"name":":woman_tipping_hand:","text":"💁‍♀️","group":"people","keywords":["sassy","tipping hand","woman","woman tipping hand"]},{"name":":person_raising_hand:","text":"🙋","group":"people","keywords":["gesture","hand","happy","person raising hand","raised"]},{"name":":man_raising_hand:","text":"🙋‍♂️","group":"people","keywords":["gesture","man","man raising hand","raising hand"]},{"name":":woman_raising_hand:","text":"🙋‍♀️","group":"people","keywords":["gesture","raising hand","woman","woman raising hand"]},{"name":":person_bowing:","text":"🙇","group":"people","keywords":["apology","bow","gesture","person bowing","sorry"]},{"name":":man_bowing:","text":"🙇‍♂️","group":"people","keywords":["apology","bowing","favor","gesture","man","sorry"]},{"name":":woman_bowing:","text":"🙇‍♀️","group":"people","keywords":["apology","bowing","favor","gesture","sorry","woman"]},{"name":":person_facepalming:","text":"🤦","group":"people","keywords":["disbelief","exasperation","face","palm","person facepalming"]},{"name":":man_facepalming:","text":"🤦‍♂️","group":"people","keywords":["disbelief","exasperation","facepalm","man","man facepalming"]},{"name":":woman_facepalming:","text":"🤦‍♀️","group":"people","keywords":["disbelief","exasperation","facepalm","woman","woman facepalming"]},{"name":":person_shrugging:","text":"🤷","group":"people","keywords":["doubt","ignorance","indifference","person shrugging","shrug"]},{"name":":man_shrugging:","text":"🤷‍♂️","group":"people","keywords":["doubt","ignorance","indifference","man","man shrugging","shrug"]},{"name":":woman_shrugging:","text":"🤷‍♀️","group":"people","keywords":["doubt","ignorance","indifference","shrug","woman","woman shrugging"]},{"name":":person_getting_massage:","text":"💆","group":"people","keywords":["face","massage","person getting massage","salon"]},{"name":":man_getting_massage:","text":"💆‍♂️","group":"people","keywords":["face","man","man getting massage","massage"]},{"name":":woman_getting_massage:","text":"💆‍♀️","group":"people","keywords":["face","massage","woman","woman getting massage"]},{"name":":person_getting_haircut:","text":"💇","group":"people","keywords":["barber","beauty","haircut","parlor","person getting haircut"]},{"name":":man_getting_haircut:","text":"💇‍♂️","group":"people","keywords":["haircut","man","man getting haircut"]},{"name":":woman_getting_haircut:","text":"💇‍♀️","group":"people","keywords":["haircut","woman","woman getting haircut"]},{"name":":person_walking:","text":"🚶","group":"people","keywords":["hike","person walking","walk","walking"]},{"name":":man_walking:","text":"🚶‍♂️","group":"people","keywords":["hike","man","man walking","walk"]},{"name":":woman_walking:","text":"🚶‍♀️","group":"people","keywords":["hike","walk","woman","woman walking"]},{"name":":person_running:","text":"🏃","group":"people","keywords":["marathon","person running","running"]},{"name":":man_running:","text":"🏃‍♂️","group":"people","keywords":["man","marathon","racing","running"]},{"name":":woman_running:","text":"🏃‍♀️","group":"people","keywords":["marathon","racing","running","woman"]},{"name":":woman_dancing:","text":"💃","group":"people","keywords":["dancing","woman"]},{"name":":man_dancing:","text":"🕺","group":"people","keywords":["dance","man","man dancing"]},{"name":":people_with_bunny_ears:","text":"👯","group":"people","keywords":["bunny ear","dancer","partying","people with bunny ears"]},{"name":":men_with_bunny_ears:","text":"👯‍♂️","group":"people","keywords":["bunny ear","dancer","men","men with bunny ears","partying"]},{"name":":women_with_bunny_ears:","text":"👯‍♀️","group":"people","keywords":["bunny ear","dancer","partying","women","women with bunny ears"]},{"name":":person_in_steamy_room:","text":"🧖","group":"people","keywords":["person in steamy room","sauna","steam room",""]},{"name":":man_in_steamy_room:","text":"🧖‍♂️","group":"people","keywords":["man in steamy room","sauna","steam room"]},{"name":":woman_in_steamy_room:","text":"🧖‍♀️","group":"people","keywords":["sauna","steam room","woman in steamy room"]},{"name":":person_climbing:","text":"🧗","group":"people","keywords":["climber","person climbing"]},{"name":":man_climbing:","text":"🧗‍♂️","group":"people","keywords":["climber","man climbing"]},{"name":":woman_climbing:","text":"🧗‍♀️","group":"people","keywords":["climber","woman climbing"]},{"name":":person_in_lotus_position:","text":"🧘","group":"people","keywords":["meditation","person in lotus position","yoga",""]},{"name":":man_in_lotus_position:","text":"🧘‍♂️","group":"people","keywords":["man in lotus position","meditation","yoga"]},{"name":":woman_in_lotus_position:","text":"🧘‍♀️","group":"people","keywords":["meditation","woman in lotus position","yoga"]},{"name":":person_taking_bath:","text":"🛀","group":"people","keywords":["bath","bathtub","person taking bath"]},{"name":":person_in_bed:","text":"🛌","group":"people","keywords":["hotel","person in bed","sleep"]},{"name":":man_in_suit_levitating:","text":"🕴","group":"people","keywords":["business","man","man in suit levitating","suit"]},{"name":":speaking_head:","text":"🗣","group":"people","keywords":["face","head","silhouette","speak","speaking"]},{"name":":bust_in_silhouette:","text":"👤","group":"people","keywords":["bust","bust in silhouette","silhouette"]},{"name":":busts_in_silhouette:","text":"👥","group":"people","keywords":["bust","busts in silhouette","silhouette"]},{"name":":person_fencing:","text":"🤺","group":"people","keywords":["fencer","fencing","person fencing","sword"]},{"name":":horse_racing:","text":"🏇","group":"people","keywords":["horse","jockey","racehorse","racing"]},{"name":":skier:","text":"⛷","group":"people","keywords":["ski","skier","snow"]},{"name":":snowboarder:","text":"🏂","group":"people","keywords":["ski","snow","snowboard","snowboarder"]},{"name":":person_golfing:","text":"🏌","group":"people","keywords":["ball","golf","person golfing"]},{"name":":man_golfing:","text":"🏌️‍♂️","group":"people","keywords":["golf","man","man golfing"]},{"name":":woman_golfing:","text":"🏌️‍♀️","group":"people","keywords":["golf","woman","woman golfing"]},{"name":":person_surfing:","text":"🏄","group":"people","keywords":["person surfing","surfing"]},{"name":":man_surfing:","text":"🏄‍♂️","group":"people","keywords":["man","surfing"]},{"name":":woman_surfing:","text":"🏄‍♀️","group":"people","keywords":["surfing","woman"]},{"name":":person_rowing_boat:","text":"🚣","group":"people","keywords":["boat","person rowing boat","rowboat"]},{"name":":man_rowing_boat:","text":"🚣‍♂️","group":"people","keywords":["boat","man","man rowing boat","rowboat"]},{"name":":woman_rowing_boat:","text":"🚣‍♀️","group":"people","keywords":["boat","rowboat","woman","woman rowing boat"]},{"name":":person_swimming:","text":"🏊","group":"people","keywords":["person swimming","swim"]},{"name":":man_swimming:","text":"🏊‍♂️","group":"people","keywords":["man","man swimming","swim"]},{"name":":woman_swimming:","text":"🏊‍♀️","group":"people","keywords":["swim","woman","woman swimming"]},{"name":":person_bouncing_ball:","text":"⛹","group":"people","keywords":["ball","person bouncing ball"]},{"name":":man_bouncing_ball:","text":"⛹️‍♂️","group":"people","keywords":["ball","man","man bouncing ball"]},{"name":":woman_bouncing_ball:","text":"⛹️‍♀️","group":"people","keywords":["ball","woman","woman bouncing ball"]},{"name":":person_lifting_weights:","text":"🏋","group":"people","keywords":["lifter","person lifting weights","weight"]},{"name":":man_lifting_weights:","text":"🏋️‍♂️","group":"people","keywords":["man","man lifting weights","weight lifter"]},{"name":":woman_lifting_weights:","text":"🏋️‍♀️","group":"people","keywords":["weight lifter","woman","woman lifting weights"]},{"name":":person_biking:","text":"🚴","group":"people","keywords":["bicycle","biking","cyclist","person biking"]},{"name":":man_biking:","text":"🚴‍♂️","group":"people","keywords":["bicycle","biking","cyclist","man"]},{"name":":woman_biking:","text":"🚴‍♀️","group":"people","keywords":["bicycle","biking","cyclist","woman"]},{"name":":person_mountain_biking:","text":"🚵","group":"people","keywords":["bicycle","bicyclist","bike","cyclist","mountain","person mountain biking"]},{"name":":man_mountain_biking:","text":"🚵‍♂️","group":"people","keywords":["bicycle","bike","cyclist","man","man mountain biking","mountain"]},{"name":":woman_mountain_biking:","text":"🚵‍♀️","group":"people","keywords":["bicycle","bike","biking","cyclist","mountain","woman"]},{"name":":racing_car:","text":"🏎","group":"people","keywords":["car","racing"]},{"name":":motorcycle:","text":"🏍","group":"people","keywords":["motorcycle","racing"]},{"name":":person_cartwheeling:","text":"🤸","group":"people","keywords":["cartwheel","gymnastics","person cartwheeling"]},{"name":":man_cartwheeling:","text":"🤸‍♂️","group":"people","keywords":["cartwheel","gymnastics","man","man cartwheeling"]},{"name":":woman_cartwheeling:","text":"🤸‍♀️","group":"people","keywords":["cartwheel","gymnastics","woman","woman cartwheeling"]},{"name":":people_wrestling:","text":"🤼","group":"people","keywords":["people wrestling","wrestle","wrestler"]},{"name":":men_wrestling:","text":"🤼‍♂️","group":"people","keywords":["men","men wrestling","wrestle"]},{"name":":women_wrestling:","text":"🤼‍♀️","group":"people","keywords":["women","women wrestling","wrestle"]},{"name":":person_playing_water_polo:","text":"🤽","group":"people","keywords":["person playing water polo","polo","water"]},{"name":":man_playing_water_polo:","text":"🤽‍♂️","group":"people","keywords":["man","man playing water polo","water polo"]},{"name":":woman_playing_water_polo:","text":"🤽‍♀️","group":"people","keywords":["water polo","woman","woman playing water polo"]},{"name":":person_playing_handball:","text":"🤾","group":"people","keywords":["ball","handball","person playing handball"]},{"name":":man_playing_handball:","text":"🤾‍♂️","group":"people","keywords":["handball","man","man playing handball"]},{"name":":woman_playing_handball:","text":"🤾‍♀️","group":"people","keywords":["handball","woman","woman playing handball"]},{"name":":person_juggling:","text":"🤹","group":"people","keywords":["balance","juggle","multitask","person juggling","skill"]},{"name":":man_juggling:","text":"🤹‍♂️","group":"people","keywords":["juggling","man","multitask"]},{"name":":woman_juggling:","text":"🤹‍♀️","group":"people","keywords":["juggling","multitask","woman"]},{"name":":man_and_woman_holding_hands:","text":"👫","group":"people","keywords":["couple","hand","hold","man","man and woman holding hands","woman"]},{"name":":two_men_holding_hands:","text":"👬","group":"people","keywords":["couple","Gemini","man","twins","two men holding hands","zodiac"]},{"name":":two_women_holding_hands:","text":"👭","group":"people","keywords":["couple","hand","two women holding hands","woman"]},{"name":":kiss:","text":"💏","group":"people","keywords":["couple","kiss"]},{"name":":kiss_woman_man:","text":"👩‍❤️‍💋‍👨","group":"people","keywords":["couple","kiss","man","woman"]},{"name":":kiss_man_man:","text":"👨‍❤️‍💋‍👨","group":"people","keywords":["couple","kiss","man"]},{"name":":kiss_woman_woman:","text":"👩‍❤️‍💋‍👩","group":"people","keywords":["couple","kiss","woman"]},{"name":":couple_with_heart:","text":"💑","group":"people","keywords":["couple","couple with heart","love"]},{"name":":couple_with_heart_woman_man:","text":"👩‍❤️‍👨","group":"people","keywords":["couple","couple with heart","love","man","woman"]},{"name":":couple_with_heart_man_man:","text":"👨‍❤️‍👨","group":"people","keywords":["couple","couple with heart","love","man"]},{"name":":couple_with_heart_woman_woman:","text":"👩‍❤️‍👩","group":"people","keywords":["couple","couple with heart","love","woman"]},{"name":":family:","text":"👪","group":"people","keywords":["family"]},{"name":":family_man_woman_boy:","text":"👨‍👩‍👦","group":"people","keywords":["boy","family","man","woman"]},{"name":":family_man_woman_girl:","text":"👨‍👩‍👧","group":"people","keywords":["family","girl","man","woman"]},{"name":":family_man_woman_girl_boy:","text":"👨‍👩‍👧‍👦","group":"people","keywords":["boy","family","girl","man","woman"]},{"name":":family_man_woman_boy_boy:","text":"👨‍👩‍👦‍👦","group":"people","keywords":["boy","family","man","woman"]},{"name":":family_man_woman_girl_girl:","text":"👨‍👩‍👧‍👧","group":"people","keywords":["family","girl","man","woman"]},{"name":":family_man_man_boy:","text":"👨‍👨‍👦","group":"people","keywords":["boy","family","man"]},{"name":":family_man_man_girl:","text":"👨‍👨‍👧","group":"people","keywords":["family","girl","man"]},{"name":":family_man_man_girl_boy:","text":"👨‍👨‍👧‍👦","group":"people","keywords":["boy","family","girl","man"]},{"name":":family_man_man_boy_boy:","text":"👨‍👨‍👦‍👦","group":"people","keywords":["boy","family","man"]},{"name":":family_man_man_girl_girl:","text":"👨‍👨‍👧‍👧","group":"people","keywords":["family","girl","man"]},{"name":":family_woman_woman_boy:","text":"👩‍👩‍👦","group":"people","keywords":["boy","family","woman"]},{"name":":family_woman_woman_girl:","text":"👩‍👩‍👧","group":"people","keywords":["family","girl","woman"]},{"name":":family_woman_woman_girl_boy:","text":"👩‍👩‍👧‍👦","group":"people","keywords":["boy","family","girl","woman"]},{"name":":family_woman_woman_boy_boy:","text":"👩‍👩‍👦‍👦","group":"people","keywords":["boy","family","woman"]},{"name":":family_woman_woman_girl_girl:","text":"👩‍👩‍👧‍👧","group":"people","keywords":["family","girl","woman"]},{"name":":family_man_boy:","text":"👨‍👦","group":"people","keywords":["boy","family","man"]},{"name":":family_man_boy_boy:","text":"👨‍👦‍👦","group":"people","keywords":["boy","family","man"]},{"name":":family_man_girl:","text":"👨‍👧","group":"people","keywords":["family","girl","man"]},{"name":":family_man_girl_boy:","text":"👨‍👧‍👦","group":"people","keywords":["boy","family","girl","man"]},{"name":":family_man_girl_girl:","text":"👨‍👧‍👧","group":"people","keywords":["family","girl","man"]},{"name":":family_woman_boy:","text":"👩‍👦","group":"people","keywords":["boy","family","woman"]},{"name":":family_woman_boy_boy:","text":"👩‍👦‍👦","group":"people","keywords":["boy","family","woman"]},{"name":":family_woman_girl:","text":"👩‍👧","group":"people","keywords":["family","girl","woman"]},{"name":":family_woman_girl_boy:","text":"👩‍👧‍👦","group":"people","keywords":["boy","family","girl","woman"]},{"name":":family_woman_girl_girl:","text":"👩‍👧‍👧","group":"people","keywords":["family","girl","woman"]},{"name":":selfie:","text":"🤳","group":"people","keywords":["camera","phone","selfie"]},{"name":":flexed_biceps:","text":"💪","group":"people","keywords":["biceps","comic","flex","flexed biceps","muscle"]},{"name":":backhand_index_pointing_left:","text":"👈","group":"people","keywords":["backhand","backhand index pointing left","finger","hand","index","point"]},{"name":":backhand_index_pointing_right:","text":"👉","group":"people","keywords":["backhand","backhand index pointing right","finger","hand","index","point"]},{"name":":index_pointing_up:","text":"☝","group":"people","keywords":["finger","hand","index","index pointing up","point","up"]},{"name":":backhand_index_pointing_up:","text":"👆","group":"people","keywords":["backhand","backhand index pointing up","finger","hand","point","up"]},{"name":":middle_finger:","text":"🖕","group":"people","keywords":["finger","hand","middle finger"]},{"name":":backhand_index_pointing_down:","text":"👇","group":"people","keywords":["backhand","backhand index pointing down","down","finger","hand","point"]},{"name":":victory_hand:","text":"✌","group":"people","keywords":["hand","v","victory"]},{"name":":crossed_fingers:","text":"🤞","group":"people","keywords":["cross","crossed fingers","finger","hand","luck"]},{"name":":vulcan_salute:","text":"🖖","group":"people","keywords":["finger","hand","spock","vulcan","vulcan salute"]},{"name":":sign_of_the_horns:","text":"🤘","group":"people","keywords":["finger","hand","horns","rock-on","sign of the horns"]},{"name":":call_me_hand:","text":"🤙","group":"people","keywords":["call","call me hand","hand"]},{"name":":hand_with_fingers_splayed:","text":"🖐","group":"people","keywords":["finger","hand","hand with fingers splayed","splayed"]},{"name":":raised_hand:","text":"✋","group":"people","keywords":["hand","raised hand"]},{"name":":ok_hand:","text":"👌","group":"people","keywords":["hand","OK"]},{"name":":thumbs_up:","text":"👍","group":"people","keywords":["+1","hand","thumb","thumbs up","up"]},{"name":":thumbs_down:","text":"👎","group":"people","keywords":["-1","down","hand","thumb","thumbs down"]},{"name":":raised_fist:","text":"✊","group":"people","keywords":["clenched","fist","hand","punch","raised fist"]},{"name":":oncoming_fist:","text":"👊","group":"people","keywords":["clenched","fist","hand","oncoming fist","punch"]},{"name":":left-facing_fist:","text":"🤛","group":"people","keywords":["fist","left-facing fist","leftwards"]},{"name":":right-facing_fist:","text":"🤜","group":"people","keywords":["fist","right-facing fist","rightwards"]},{"name":":raised_back_of_hand:","text":"🤚","group":"people","keywords":["backhand","raised","raised back of hand"]},{"name":":waving_hand:","text":"👋","group":"people","keywords":["hand","wave","waving"]},{"name":":love-you_gesture:","text":"🤟","group":"people","keywords":["hand","ILY","love-you gesture"]},{"name":":writing_hand:","text":"✍","group":"people","keywords":["hand","write","writing hand"]},{"name":":clapping_hands:","text":"👏","group":"people","keywords":["clap","clapping hands","hand"]},{"name":":open_hands:","text":"👐","group":"people","keywords":["hand","open","open hands"]},{"name":":raising_hands:","text":"🙌","group":"people","keywords":["celebration","gesture","hand","hooray","raised","raising hands"]},{"name":":palms_up_together:","text":"🤲","group":"people","keywords":["palms up together","prayer",""]},{"name":":folded_hands:","text":"🙏","group":"people","keywords":["ask","folded hands","hand","please","pray","thanks"]},{"name":":handshake:","text":"🤝","group":"people","keywords":["agreement","hand","handshake","meeting","shake"]},{"name":":nail_polish:","text":"💅","group":"people","keywords":["care","cosmetics","manicure","nail","polish"]},{"name":":ear:","text":"👂","group":"people","keywords":["body","ear"]},{"name":":nose:","text":"👃","group":"people","keywords":["body","nose"]},{"name":":footprints:","text":"👣","group":"people","keywords":["clothing","footprint","footprints","print"]},{"name":":eyes:","text":"👀","group":"people","keywords":["eye","eyes","face"]},{"name":":eye:","text":"👁","group":"people","keywords":["body","eye"]},{"name":":eye_in_speech_bubble:","text":"👁️‍🗨️","group":"people","keywords":["eye","eye in speech bubble","speech bubble","witness"]},{"name":":brain:","text":"🧠","group":"people","keywords":["brain","intelligent"]},{"name":":tongue:","text":"👅","group":"people","keywords":["body","tongue"]},{"name":":mouth:","text":"👄","group":"people","keywords":["lips","mouth"]},{"name":":kiss_mark:","text":"💋","group":"people","keywords":["kiss","kiss mark","lips"]},{"name":":heart_with_arrow:","text":"💘","group":"people","keywords":["arrow","cupid","heart with arrow"]},{"name":":heart_with_ribbon:","text":"💝","group":"people","keywords":["heart with ribbon","ribbon","valentine"]},{"name":":sparkling_heart:","text":"💖","group":"people","keywords":["excited","sparkle","sparkling heart"]},{"name":":growing_heart:","text":"💗","group":"people","keywords":["excited","growing","growing heart","nervous","pulse"]},{"name":":beating_heart:","text":"💓","group":"people","keywords":["beating","beating heart","heartbeat","pulsating"]},{"name":":revolving_hearts:","text":"💞","group":"people","keywords":["revolving","revolving hearts"]},{"name":":two_hearts:","text":"💕","group":"people","keywords":["love","two hearts"]},{"name":":love_letter:","text":"💌","group":"people","keywords":["heart","letter","love","mail"]},{"name":":heavy_heart_exclamation:","text":"❣","group":"people","keywords":["exclamation","heavy heart exclamation","mark","punctuation"]},{"name":":broken_heart:","text":"💔","group":"people","keywords":["break","broken","broken heart"]},{"name":":red_heart:","text":"❤","group":"people","keywords":["heart","red heart"]},{"name":":orange_heart:","text":"🧡","group":"people","keywords":["orange","orange heart"]},{"name":":yellow_heart:","text":"💛","group":"people","keywords":["yellow","yellow heart"]},{"name":":green_heart:","text":"💚","group":"people","keywords":["green","green heart"]},{"name":":blue_heart:","text":"💙","group":"people","keywords":["blue","blue heart"]},{"name":":purple_heart:","text":"💜","group":"people","keywords":["purple","purple heart"]},{"name":":black_heart:","text":"🖤","group":"people","keywords":["black","black heart","evil","wicked"]},{"name":":heart_decoration:","text":"💟","group":"people","keywords":["heart","heart decoration"]},{"name":":zzz:","text":"💤","group":"people","keywords":["comic","sleep","zzz"]},{"name":":anger_symbol:","text":"💢","group":"people","keywords":["anger symbol","angry","comic","mad"]},{"name":":bomb:","text":"💣","group":"people","keywords":["bomb","comic"]},{"name":":collision:","text":"💥","group":"people","keywords":["boom","collision","comic"]},{"name":":sweat_droplets:","text":"💦","group":"people","keywords":["comic","splashing","sweat","sweat droplets"]},{"name":":dashing_away:","text":"💨","group":"people","keywords":["comic","dash","dashing away","running"]},{"name":":dizzy:","text":"💫","group":"people","keywords":["comic","dizzy","star"]},{"name":":speech_balloon:","text":"💬","group":"people","keywords":["balloon","bubble","comic","dialog","speech"]},{"name":":left_speech_bubble:","text":"🗨","group":"people","keywords":["dialog","left speech bubble","speech"]},{"name":":right_anger_bubble:","text":"🗯","group":"people","keywords":["angry","balloon","bubble","mad","right anger bubble"]},{"name":":thought_balloon:","text":"💭","group":"people","keywords":["balloon","bubble","comic","thought"]},{"name":":hole:","text":"🕳","group":"people","keywords":["hole"]},{"name":":glasses:","text":"👓","group":"people","keywords":["clothing","eye","eyeglasses","eyewear","glasses"]},{"name":":sunglasses:","text":"🕶","group":"people","keywords":["dark","eye","eyewear","glasses","sunglasses"]},{"name":":necktie:","text":"👔","group":"people","keywords":["clothing","necktie","tie"]},{"name":":t-shirt:","text":"👕","group":"people","keywords":["clothing","shirt","t-shirt","tshirt"]},{"name":":jeans:","text":"👖","group":"people","keywords":["clothing","jeans","pants","trousers"]},{"name":":scarf:","text":"🧣","group":"people","keywords":["neck","scarf"]},{"name":":gloves:","text":"🧤","group":"people","keywords":["gloves","hand"]},{"name":":coat:","text":"🧥","group":"people","keywords":["coat","jacket"]},{"name":":socks:","text":"🧦","group":"people","keywords":["socks","stocking"]},{"name":":dress:","text":"👗","group":"people","keywords":["clothing","dress"]},{"name":":kimono:","text":"👘","group":"people","keywords":["clothing","kimono"]},{"name":":bikini:","text":"👙","group":"people","keywords":["bikini","clothing","swim"]},{"name":":woman’s_clothes:","text":"👚","group":"people","keywords":["clothing","woman","woman’s clothes"]},{"name":":purse:","text":"👛","group":"people","keywords":["clothing","coin","purse"]},{"name":":handbag:","text":"👜","group":"people","keywords":["bag","clothing","handbag","purse"]},{"name":":clutch_bag:","text":"👝","group":"people","keywords":["bag","clothing","clutch bag","pouch"]},{"name":":shopping_bags:","text":"🛍","group":"people","keywords":["bag","hotel","shopping","shopping bags"]},{"name":":backpack:","text":"🎒","group":"people","keywords":["backpack","bag","rucksack","satchel","school"]},{"name":":man’s_shoe:","text":"👞","group":"people","keywords":["clothing","man","man’s shoe","shoe"]},{"name":":running_shoe:","text":"👟","group":"people","keywords":["athletic","clothing","running shoe","shoe","sneaker"]},{"name":":high-heeled_shoe:","text":"👠","group":"people","keywords":["clothing","heel","high-heeled shoe","shoe","woman"]},{"name":":woman’s_sandal:","text":"👡","group":"people","keywords":["clothing","sandal","shoe","woman","woman’s sandal"]},{"name":":woman’s_boot:","text":"👢","group":"people","keywords":["boot","clothing","shoe","woman","woman’s boot"]},{"name":":crown:","text":"👑","group":"people","keywords":["clothing","crown","king","queen"]},{"name":":woman’s_hat:","text":"👒","group":"people","keywords":["clothing","hat","woman","woman’s hat"]},{"name":":top_hat:","text":"🎩","group":"people","keywords":["clothing","hat","top","tophat"]},{"name":":graduation_cap:","text":"🎓","group":"people","keywords":["cap","celebration","clothing","graduation","hat"]},{"name":":billed_cap:","text":"🧢","group":"people","keywords":["baseball cap","billed cap"]},{"name":":rescue_worker’s_helmet:","text":"⛑","group":"people","keywords":["aid","cross","face","hat","helmet","rescue worker’s helmet"]},{"name":":prayer_beads:","text":"📿","group":"people","keywords":["beads","clothing","necklace","prayer","religion"]},{"name":":lipstick:","text":"💄","group":"people","keywords":["cosmetics","lipstick","makeup"]},{"name":":ring:","text":"💍","group":"people","keywords":["diamond","ring"]},{"name":":gem_stone:","text":"💎","group":"people","keywords":["diamond","gem","gem stone","jewel"]},{"name":":monkey_face:","text":"🐵","group":"nature","keywords":["face","monkey"]},{"name":":monkey:","text":"🐒","group":"nature","keywords":["monkey"]},{"name":":gorilla:","text":"🦍","group":"nature","keywords":["gorilla"]},{"name":":dog_face:","text":"🐶","group":"nature","keywords":["dog","face","pet"]},{"name":":dog:","text":"🐕","group":"nature","keywords":["dog","pet"]},{"name":":poodle:","text":"🐩","group":"nature","keywords":["dog","poodle"]},{"name":":wolf_face:","text":"🐺","group":"nature","keywords":["face","wolf"]},{"name":":fox_face:","text":"🦊","group":"nature","keywords":["face","fox"]},{"name":":cat_face:","text":"🐱","group":"nature","keywords":["cat","face","pet"]},{"name":":cat:","text":"🐈","group":"nature","keywords":["cat","pet"]},{"name":":lion_face:","text":"🦁","group":"nature","keywords":["face","Leo","lion","zodiac"]},{"name":":tiger_face:","text":"🐯","group":"nature","keywords":["face","tiger"]},{"name":":tiger:","text":"🐅","group":"nature","keywords":["tiger"]},{"name":":leopard:","text":"🐆","group":"nature","keywords":["leopard"]},{"name":":horse_face:","text":"🐴","group":"nature","keywords":["face","horse"]},{"name":":horse:","text":"🐎","group":"nature","keywords":["equestrian","horse","racehorse","racing"]},{"name":":unicorn_face:","text":"🦄","group":"nature","keywords":["face","unicorn"]},{"name":":zebra:","text":"🦓","group":"nature","keywords":["stripe","zebra"]},{"name":":deer:","text":"🦌","group":"nature","keywords":["deer"]},{"name":":cow_face:","text":"🐮","group":"nature","keywords":["cow","face"]},{"name":":ox:","text":"🐂","group":"nature","keywords":["bull","ox","Taurus","zodiac"]},{"name":":water_buffalo:","text":"🐃","group":"nature","keywords":["buffalo","water"]},{"name":":cow:","text":"🐄","group":"nature","keywords":["cow"]},{"name":":pig_face:","text":"🐷","group":"nature","keywords":["face","pig"]},{"name":":pig:","text":"🐖","group":"nature","keywords":["pig","sow"]},{"name":":boar:","text":"🐗","group":"nature","keywords":["boar","pig"]},{"name":":pig_nose:","text":"🐽","group":"nature","keywords":["face","nose","pig"]},{"name":":ram:","text":"🐏","group":"nature","keywords":["Aries","male","ram","sheep","zodiac"]},{"name":":ewe:","text":"🐑","group":"nature","keywords":["ewe","female","sheep"]},{"name":":goat:","text":"🐐","group":"nature","keywords":["Capricorn","goat","zodiac"]},{"name":":camel:","text":"🐪","group":"nature","keywords":["camel","dromedary","hump"]},{"name":":two-hump_camel:","text":"🐫","group":"nature","keywords":["bactrian","camel","hump","two-hump camel"]},{"name":":giraffe:","text":"🦒","group":"nature","keywords":["giraffe","spots"]},{"name":":elephant:","text":"🐘","group":"nature","keywords":["elephant"]},{"name":":rhinoceros:","text":"🦏","group":"nature","keywords":["rhinoceros"]},{"name":":mouse_face:","text":"🐭","group":"nature","keywords":["face","mouse"]},{"name":":mouse:","text":"🐁","group":"nature","keywords":["mouse"]},{"name":":rat:","text":"🐀","group":"nature","keywords":["rat"]},{"name":":hamster_face:","text":"🐹","group":"nature","keywords":["face","hamster","pet"]},{"name":":rabbit_face:","text":"🐰","group":"nature","keywords":["bunny","face","pet","rabbit"]},{"name":":rabbit:","text":"🐇","group":"nature","keywords":["bunny","pet","rabbit"]},{"name":":chipmunk:","text":"🐿","group":"nature","keywords":["chipmunk","squirrel"]},{"name":":hedgehog:","text":"🦔","group":"nature","keywords":["hedgehog","spiny"]},{"name":":bat:","text":"🦇","group":"nature","keywords":["bat","vampire"]},{"name":":bear_face:","text":"🐻","group":"nature","keywords":["bear","face"]},{"name":":koala:","text":"🐨","group":"nature","keywords":["bear","koala"]},{"name":":panda_face:","text":"🐼","group":"nature","keywords":["face","panda"]},{"name":":paw_prints:","text":"🐾","group":"nature","keywords":["feet","paw","paw prints","print"]},{"name":":turkey:","text":"🦃","group":"nature","keywords":["bird","turkey"]},{"name":":chicken:","text":"🐔","group":"nature","keywords":["bird","chicken"]},{"name":":rooster:","text":"🐓","group":"nature","keywords":["bird","rooster"]},{"name":":hatching_chick:","text":"🐣","group":"nature","keywords":["baby","bird","chick","hatching"]},{"name":":baby_chick:","text":"🐤","group":"nature","keywords":["baby","bird","chick"]},{"name":":front-facing_baby_chick:","text":"🐥","group":"nature","keywords":["baby","bird","chick","front-facing baby chick"]},{"name":":bird:","text":"🐦","group":"nature","keywords":["bird"]},{"name":":penguin:","text":"🐧","group":"nature","keywords":["bird","penguin"]},{"name":":dove:","text":"🕊","group":"nature","keywords":["bird","dove","fly","peace"]},{"name":":eagle:","text":"🦅","group":"nature","keywords":["bird","eagle"]},{"name":":duck:","text":"🦆","group":"nature","keywords":["bird","duck"]},{"name":":owl:","text":"🦉","group":"nature","keywords":["bird","owl","wise"]},{"name":":frog_face:","text":"🐸","group":"nature","keywords":["face","frog"]},{"name":":crocodile:","text":"🐊","group":"nature","keywords":["crocodile"]},{"name":":turtle:","text":"🐢","group":"nature","keywords":["terrapin","tortoise","turtle"]},{"name":":lizard:","text":"🦎","group":"nature","keywords":["lizard","reptile"]},{"name":":snake:","text":"🐍","group":"nature","keywords":["bearer","Ophiuchus","serpent","snake","zodiac"]},{"name":":dragon_face:","text":"🐲","group":"nature","keywords":["dragon","face","fairy tale"]},{"name":":dragon:","text":"🐉","group":"nature","keywords":["dragon","fairy tale"]},{"name":":sauropod:","text":"🦕","group":"nature","keywords":["brachiosaurus","brontosaurus","diplodocus","sauropod"]},{"name":":t-rex:","text":"🦖","group":"nature","keywords":["T-Rex","Tyrannosaurus Rex"]},{"name":":spouting_whale:","text":"🐳","group":"nature","keywords":["face","spouting","whale"]},{"name":":whale:","text":"🐋","group":"nature","keywords":["whale"]},{"name":":dolphin:","text":"🐬","group":"nature","keywords":["dolphin","flipper"]},{"name":":fish:","text":"🐟","group":"nature","keywords":["fish","Pisces","zodiac"]},{"name":":tropical_fish:","text":"🐠","group":"nature","keywords":["fish","tropical"]},{"name":":blowfish:","text":"🐡","group":"nature","keywords":["blowfish","fish"]},{"name":":shark:","text":"🦈","group":"nature","keywords":["fish","shark"]},{"name":":octopus:","text":"🐙","group":"nature","keywords":["octopus"]},{"name":":spiral_shell:","text":"🐚","group":"nature","keywords":["shell","spiral"]},{"name":":crab:","text":"🦀","group":"nature","keywords":["Cancer","crab","zodiac"]},{"name":":shrimp:","text":"🦐","group":"nature","keywords":["food","shellfish","shrimp","small"]},{"name":":squid:","text":"🦑","group":"nature","keywords":["food","molusc","squid"]},{"name":":snail:","text":"🐌","group":"nature","keywords":["snail"]},{"name":":butterfly:","text":"🦋","group":"nature","keywords":["butterfly","insect","pretty"]},{"name":":bug:","text":"🐛","group":"nature","keywords":["bug","insect"]},{"name":":ant:","text":"🐜","group":"nature","keywords":["ant","insect"]},{"name":":honeybee:","text":"🐝","group":"nature","keywords":["bee","honeybee","insect"]},{"name":":lady_beetle:","text":"🐞","group":"nature","keywords":["beetle","insect","lady beetle","ladybird","ladybug"]},{"name":":cricket:","text":"🦗","group":"nature","keywords":["cricket","grasshopper",""]},{"name":":spider:","text":"🕷","group":"nature","keywords":["insect","spider"]},{"name":":spider_web:","text":"🕸","group":"nature","keywords":["spider","web"]},{"name":":scorpion:","text":"🦂","group":"nature","keywords":["scorpio","Scorpio","scorpion","zodiac"]},{"name":":bouquet:","text":"💐","group":"nature","keywords":["bouquet","flower"]},{"name":":cherry_blossom:","text":"🌸","group":"nature","keywords":["blossom","cherry","flower"]},{"name":":white_flower:","text":"💮","group":"nature","keywords":["flower","white flower"]},{"name":":rosette:","text":"🏵","group":"nature","keywords":["plant","rosette"]},{"name":":rose:","text":"🌹","group":"nature","keywords":["flower","rose"]},{"name":":wilted_flower:","text":"🥀","group":"nature","keywords":["flower","wilted"]},{"name":":hibiscus:","text":"🌺","group":"nature","keywords":["flower","hibiscus"]},{"name":":sunflower:","text":"🌻","group":"nature","keywords":["flower","sun","sunflower"]},{"name":":blossom:","text":"🌼","group":"nature","keywords":["blossom","flower"]},{"name":":tulip:","text":"🌷","group":"nature","keywords":["flower","tulip"]},{"name":":seedling:","text":"🌱","group":"nature","keywords":["seedling","young"]},{"name":":evergreen_tree:","text":"🌲","group":"nature","keywords":["evergreen tree","tree"]},{"name":":deciduous_tree:","text":"🌳","group":"nature","keywords":["deciduous","shedding","tree"]},{"name":":palm_tree:","text":"🌴","group":"nature","keywords":["palm","tree"]},{"name":":cactus:","text":"🌵","group":"nature","keywords":["cactus","plant"]},{"name":":sheaf_of_rice:","text":"🌾","group":"nature","keywords":["ear","grain","rice","sheaf of rice"]},{"name":":herb:","text":"🌿","group":"nature","keywords":["herb","leaf"]},{"name":":shamrock:","text":"☘","group":"nature","keywords":["plant","shamrock"]},{"name":":four_leaf_clover:","text":"🍀","group":"nature","keywords":["4","clover","four","four-leaf clover","leaf"]},{"name":":maple_leaf:","text":"🍁","group":"nature","keywords":["falling","leaf","maple"]},{"name":":fallen_leaf:","text":"🍂","group":"nature","keywords":["fallen leaf","falling","leaf"]},{"name":":leaf_fluttering_in_wind:","text":"🍃","group":"nature","keywords":["blow","flutter","leaf","leaf fluttering in wind","wind"]},{"name":":grapes:","text":"🍇","group":"food","keywords":["fruit","grape","grapes"]},{"name":":melon:","text":"🍈","group":"food","keywords":["fruit","melon"]},{"name":":watermelon:","text":"🍉","group":"food","keywords":["fruit","watermelon"]},{"name":":tangerine:","text":"🍊","group":"food","keywords":["fruit","orange","tangerine"]},{"name":":lemon:","text":"🍋","group":"food","keywords":["citrus","fruit","lemon"]},{"name":":banana:","text":"🍌","group":"food","keywords":["banana","fruit"]},{"name":":pineapple:","text":"🍍","group":"food","keywords":["fruit","pineapple"]},{"name":":red_apple:","text":"🍎","group":"food","keywords":["apple","fruit","red"]},{"name":":green_apple:","text":"🍏","group":"food","keywords":["apple","fruit","green"]},{"name":":pear:","text":"🍐","group":"food","keywords":["fruit","pear"]},{"name":":peach:","text":"🍑","group":"food","keywords":["fruit","peach"]},{"name":":cherries:","text":"🍒","group":"food","keywords":["berries","cherries","cherry","fruit","red"]},{"name":":strawberry:","text":"🍓","group":"food","keywords":["berry","fruit","strawberry"]},{"name":":kiwi_fruit:","text":"🥝","group":"food","keywords":["food","fruit","kiwi"]},{"name":":tomato:","text":"🍅","group":"food","keywords":["fruit","tomato","vegetable"]},{"name":":coconut:","text":"🥥","group":"food","keywords":["coconut","palm","piña colada"]},{"name":":avocado:","text":"🥑","group":"food","keywords":["avocado","food","fruit"]},{"name":":eggplant:","text":"🍆","group":"food","keywords":["aubergine","eggplant","vegetable"]},{"name":":potato:","text":"🥔","group":"food","keywords":["food","potato","vegetable"]},{"name":":carrot:","text":"🥕","group":"food","keywords":["carrot","food","vegetable"]},{"name":":ear_of_corn:","text":"🌽","group":"food","keywords":["corn","ear","ear of corn","maize","maze"]},{"name":":hot_pepper:","text":"🌶","group":"food","keywords":["hot","pepper"]},{"name":":cucumber:","text":"🥒","group":"food","keywords":["cucumber","food","pickle","vegetable"]},{"name":":broccoli:","text":"🥦","group":"food","keywords":["broccoli","wild cabbage"]},{"name":":mushroom:","text":"🍄","group":"food","keywords":["mushroom","toadstool"]},{"name":":peanuts:","text":"🥜","group":"food","keywords":["food","nut","peanut","peanuts","vegetable"]},{"name":":chestnut:","text":"🌰","group":"food","keywords":["chestnut","plant"]},{"name":":bread:","text":"🍞","group":"food","keywords":["bread","loaf"]},{"name":":croissant:","text":"🥐","group":"food","keywords":["bread","crescent roll","croissant","food","french"]},{"name":":baguette_bread:","text":"🥖","group":"food","keywords":["baguette","bread","food","french"]},{"name":":pretzel:","text":"🥨","group":"food","keywords":["pretzel","twisted",""]},{"name":":pancakes:","text":"🥞","group":"food","keywords":["crêpe","food","hotcake","pancake","pancakes"]},{"name":":cheese_wedge:","text":"🧀","group":"food","keywords":["cheese","cheese wedge"]},{"name":":meat_on_bone:","text":"🍖","group":"food","keywords":["bone","meat","meat on bone"]},{"name":":poultry_leg:","text":"🍗","group":"food","keywords":["bone","chicken","drumstick","leg","poultry"]},{"name":":cut_of_meat:","text":"🥩","group":"food","keywords":["chop","cut of meat","lambchop","porkchop","steak"]},{"name":":bacon:","text":"🥓","group":"food","keywords":["bacon","food","meat"]},{"name":":hamburger:","text":"🍔","group":"food","keywords":["burger","hamburger"]},{"name":":french_fries:","text":"🍟","group":"food","keywords":["french","fries"]},{"name":":pizza:","text":"🍕","group":"food","keywords":["cheese","pizza","slice"]},{"name":":hot_dog:","text":"🌭","group":"food","keywords":["frankfurter","hot dog","hotdog","sausage"]},{"name":":sandwich:","text":"🥪","group":"food","keywords":["bread","sandwich"]},{"name":":taco:","text":"🌮","group":"food","keywords":["mexican","taco"]},{"name":":burrito:","text":"🌯","group":"food","keywords":["burrito","mexican","wrap"]},{"name":":stuffed_flatbread:","text":"🥙","group":"food","keywords":["falafel","flatbread","food","gyro","kebab","stuffed"]},{"name":":egg:","text":"🥚","group":"food","keywords":["egg","food"]},{"name":":cooking:","text":"🍳","group":"food","keywords":["cooking","egg","frying","pan"]},{"name":":shallow_pan_of_food:","text":"🥘","group":"food","keywords":["casserole","food","paella","pan","shallow","shallow pan of food"]},{"name":":pot_of_food:","text":"🍲","group":"food","keywords":["pot","pot of food","stew"]},{"name":":bowl_with_spoon:","text":"🥣","group":"food","keywords":["bowl with spoon","breakfast","cereal","congee",""]},{"name":":green_salad:","text":"🥗","group":"food","keywords":["food","green","salad"]},{"name":":popcorn:","text":"🍿","group":"food","keywords":["popcorn"]},{"name":":canned_food:","text":"🥫","group":"food","keywords":["can","canned food"]},{"name":":bento_box:","text":"🍱","group":"food","keywords":["bento","box"]},{"name":":rice_cracker:","text":"🍘","group":"food","keywords":["cracker","rice"]},{"name":":rice_ball:","text":"🍙","group":"food","keywords":["ball","Japanese","rice"]},{"name":":cooked_rice:","text":"🍚","group":"food","keywords":["cooked","rice"]},{"name":":curry_rice:","text":"🍛","group":"food","keywords":["curry","rice"]},{"name":":steaming_bowl:","text":"🍜","group":"food","keywords":["bowl","noodle","ramen","steaming"]},{"name":":spaghetti:","text":"🍝","group":"food","keywords":["pasta","spaghetti"]},{"name":":roasted_sweet_potato:","text":"🍠","group":"food","keywords":["potato","roasted","sweet"]},{"name":":oden:","text":"🍢","group":"food","keywords":["kebab","oden","seafood","skewer","stick"]},{"name":":sushi:","text":"🍣","group":"food","keywords":["sushi"]},{"name":":fried_shrimp:","text":"🍤","group":"food","keywords":["fried","prawn","shrimp","tempura"]},{"name":":fish_cake_with_swirl:","text":"🍥","group":"food","keywords":["cake","fish","fish cake with swirl","pastry","swirl"]},{"name":":dango:","text":"🍡","group":"food","keywords":["dango","dessert","Japanese","skewer","stick","sweet"]},{"name":":dumpling:","text":"🥟","group":"food","keywords":["dumpling","empanada","gyōza","jiaozi","pierogi","potsticker"]},{"name":":fortune_cookie:","text":"🥠","group":"food","keywords":["fortune cookie","prophecy"]},{"name":":takeout_box:","text":"🥡","group":"food","keywords":["oyster pail","takeout box"]},{"name":":soft_ice_cream:","text":"🍦","group":"food","keywords":["cream","dessert","ice","icecream","soft","sweet"]},{"name":":shaved_ice:","text":"🍧","group":"food","keywords":["dessert","ice","shaved","sweet"]},{"name":":ice_cream:","text":"🍨","group":"food","keywords":["cream","dessert","ice","sweet"]},{"name":":doughnut:","text":"🍩","group":"food","keywords":["dessert","donut","doughnut","sweet"]},{"name":":cookie:","text":"🍪","group":"food","keywords":["cookie","dessert","sweet"]},{"name":":birthday_cake:","text":"🎂","group":"food","keywords":["birthday","cake","celebration","dessert","pastry","sweet"]},{"name":":shortcake:","text":"🍰","group":"food","keywords":["cake","dessert","pastry","shortcake","slice","sweet"]},{"name":":pie:","text":"🥧","group":"food","keywords":["filling","pastry","pie",""]},{"name":":chocolate_bar:","text":"🍫","group":"food","keywords":["bar","chocolate","dessert","sweet"]},{"name":":candy:","text":"🍬","group":"food","keywords":["candy","dessert","sweet"]},{"name":":lollipop:","text":"🍭","group":"food","keywords":["candy","dessert","lollipop","sweet"]},{"name":":custard:","text":"🍮","group":"food","keywords":["custard","dessert","pudding","sweet"]},{"name":":honey_pot:","text":"🍯","group":"food","keywords":["honey","honeypot","pot","sweet"]},{"name":":baby_bottle:","text":"🍼","group":"food","keywords":["baby","bottle","drink","milk"]},{"name":":glass_of_milk:","text":"🥛","group":"food","keywords":["drink","glass","glass of milk","milk"]},{"name":":hot_beverage:","text":"☕","group":"food","keywords":["beverage","coffee","drink","hot","steaming","tea"]},{"name":":teacup_without_handle:","text":"🍵","group":"food","keywords":["beverage","cup","drink","tea","teacup","teacup without handle"]},{"name":":sake:","text":"🍶","group":"food","keywords":["bar","beverage","bottle","cup","drink","sake"]},{"name":":bottle_with_popping_cork:","text":"🍾","group":"food","keywords":["bar","bottle","bottle with popping cork","cork","drink","popping"]},{"name":":wine_glass:","text":"🍷","group":"food","keywords":["bar","beverage","drink","glass","wine"]},{"name":":cocktail_glass:","text":"🍸","group":"food","keywords":["bar","cocktail","drink","glass"]},{"name":":tropical_drink:","text":"🍹","group":"food","keywords":["bar","drink","tropical"]},{"name":":beer_mug:","text":"🍺","group":"food","keywords":["bar","beer","drink","mug"]},{"name":":clinking_beer_mugs:","text":"🍻","group":"food","keywords":["bar","beer","clink","clinking beer mugs","drink","mug"]},{"name":":clinking_glasses:","text":"🥂","group":"food","keywords":["celebrate","clink","clinking glasses","drink","glass"]},{"name":":tumbler_glass:","text":"🥃","group":"food","keywords":["glass","liquor","shot","tumbler","whisky"]},{"name":":cup_with_straw:","text":"🥤","group":"food","keywords":["cup with straw","juice","soda",""]},{"name":":chopsticks:","text":"🥢","group":"food","keywords":["chopsticks","hashi",""]},{"name":":fork_and_knife_with_plate:","text":"🍽","group":"food","keywords":["cooking","fork","fork and knife with plate","knife","plate"]},{"name":":fork_and_knife:","text":"🍴","group":"food","keywords":["cooking","cutlery","fork","fork and knife","knife"]},{"name":":spoon:","text":"🥄","group":"food","keywords":["spoon","tableware"]},{"name":":kitchen_knife:","text":"🔪","group":"food","keywords":["cooking","hocho","kitchen knife","knife","tool","weapon"]},{"name":":amphora:","text":"🏺","group":"food","keywords":["amphora","Aquarius","cooking","drink","jug","zodiac"]},{"name":":globe_showing_europe-africa:","text":"🌍","group":"travel","keywords":["Africa","earth","Europe","globe","globe showing Europe-Africa","world"]},{"name":":globe_showing_americas:","text":"🌎","group":"travel","keywords":["Americas","earth","globe","globe showing Americas","world"]},{"name":":globe_showing_asia-australia:","text":"🌏","group":"travel","keywords":["Asia","Australia","earth","globe","globe showing Asia-Australia","world"]},{"name":":globe_with_meridians:","text":"🌐","group":"travel","keywords":["earth","globe","globe with meridians","meridians","world"]},{"name":":world_map:","text":"🗺","group":"travel","keywords":["map","world"]},{"name":":map_of_japan:","text":"🗾","group":"travel","keywords":["Japan","map","map of Japan"]},{"name":":snow-capped_mountain:","text":"🏔","group":"travel","keywords":["cold","mountain","snow","snow-capped mountain"]},{"name":":mountain:","text":"⛰","group":"travel","keywords":["mountain"]},{"name":":volcano:","text":"🌋","group":"travel","keywords":["eruption","mountain","volcano"]},{"name":":mount_fuji:","text":"🗻","group":"travel","keywords":["fuji","mount fuji","mountain"]},{"name":":camping:","text":"🏕","group":"travel","keywords":["camping"]},{"name":":beach_with_umbrella:","text":"🏖","group":"travel","keywords":["beach","beach with umbrella","umbrella"]},{"name":":desert:","text":"🏜","group":"travel","keywords":["desert"]},{"name":":desert_island:","text":"🏝","group":"travel","keywords":["desert","island"]},{"name":":national_park:","text":"🏞","group":"travel","keywords":["national park","park"]},{"name":":stadium:","text":"🏟","group":"travel","keywords":["stadium"]},{"name":":classical_building:","text":"🏛","group":"travel","keywords":["classical","classical building"]},{"name":":building_construction:","text":"🏗","group":"travel","keywords":["building construction","construction"]},{"name":":houses:","text":"🏘","group":"travel","keywords":["houses"]},{"name":":derelict_house:","text":"🏚","group":"travel","keywords":["derelict","house"]},{"name":":house:","text":"🏠","group":"travel","keywords":["home","house"]},{"name":":house_with_garden:","text":"🏡","group":"travel","keywords":["garden","home","house","house with garden"]},{"name":":office_building:","text":"🏢","group":"travel","keywords":["building","office building"]},{"name":":japanese_post_office:","text":"🏣","group":"travel","keywords":["Japanese","Japanese post office","post"]},{"name":":post_office:","text":"🏤","group":"travel","keywords":["European","post","post office"]},{"name":":hospital:","text":"🏥","group":"travel","keywords":["doctor","hospital","medicine"]},{"name":":bank:","text":"🏦","group":"travel","keywords":["bank","building"]},{"name":":hotel:","text":"🏨","group":"travel","keywords":["building","hotel"]},{"name":":love_hotel:","text":"🏩","group":"travel","keywords":["hotel","love"]},{"name":":convenience_store:","text":"🏪","group":"travel","keywords":["convenience","store"]},{"name":":school:","text":"🏫","group":"travel","keywords":["building","school"]},{"name":":department_store:","text":"🏬","group":"travel","keywords":["department","store"]},{"name":":factory:","text":"🏭","group":"travel","keywords":["building","factory"]},{"name":":japanese_castle:","text":"🏯","group":"travel","keywords":["castle","Japanese"]},{"name":":castle:","text":"🏰","group":"travel","keywords":["castle","European"]},{"name":":wedding:","text":"💒","group":"travel","keywords":["chapel","romance","wedding"]},{"name":":tokyo_tower:","text":"🗼","group":"travel","keywords":["Tokyo","tower"]},{"name":":statue_of_liberty:","text":"🗽","group":"travel","keywords":["liberty","statue","Statue of Liberty"]},{"name":":church:","text":"⛪","group":"travel","keywords":["Christian","church","cross","religion"]},{"name":":mosque:","text":"🕌","group":"travel","keywords":["islam","mosque","Muslim","religion"]},{"name":":synagogue:","text":"🕍","group":"travel","keywords":["Jew","Jewish","religion","synagogue","temple"]},{"name":":shinto_shrine:","text":"⛩","group":"travel","keywords":["religion","shinto","shrine"]},{"name":":kaaba:","text":"🕋","group":"travel","keywords":["islam","kaaba","Muslim","religion"]},{"name":":fountain:","text":"⛲","group":"travel","keywords":["fountain"]},{"name":":tent:","text":"⛺","group":"travel","keywords":["camping","tent"]},{"name":":foggy:","text":"🌁","group":"travel","keywords":["fog","foggy"]},{"name":":night_with_stars:","text":"🌃","group":"travel","keywords":["night","night with stars","star"]},{"name":":cityscape:","text":"🏙","group":"travel","keywords":["city","cityscape"]},{"name":":sunrise_over_mountains:","text":"🌄","group":"travel","keywords":["morning","mountain","sun","sunrise","sunrise over mountains"]},{"name":":sunrise:","text":"🌅","group":"travel","keywords":["morning","sun","sunrise"]},{"name":":cityscape_at_dusk:","text":"🌆","group":"travel","keywords":["city","cityscape at dusk","dusk","evening","landscape","sunset"]},{"name":":sunset:","text":"🌇","group":"travel","keywords":["dusk","sun","sunset"]},{"name":":bridge_at_night:","text":"🌉","group":"travel","keywords":["bridge","bridge at night","night"]},{"name":":hot_springs:","text":"♨","group":"travel","keywords":["hot","hotsprings","springs","steaming"]},{"name":":milky_way:","text":"🌌","group":"travel","keywords":["milky way","space"]},{"name":":carousel_horse:","text":"🎠","group":"travel","keywords":["carousel","horse"]},{"name":":ferris_wheel:","text":"🎡","group":"travel","keywords":["amusement park","ferris","wheel"]},{"name":":roller_coaster:","text":"🎢","group":"travel","keywords":["amusement park","coaster","roller"]},{"name":":barber_pole:","text":"💈","group":"travel","keywords":["barber","haircut","pole"]},{"name":":circus_tent:","text":"🎪","group":"travel","keywords":["circus","tent"]},{"name":":locomotive:","text":"🚂","group":"travel","keywords":["engine","locomotive","railway","steam","train"]},{"name":":railway_car:","text":"🚃","group":"travel","keywords":["car","electric","railway","train","tram","trolleybus"]},{"name":":high-speed_train:","text":"🚄","group":"travel","keywords":["high-speed train","railway","shinkansen","speed","train"]},{"name":":bullet_train:","text":"🚅","group":"travel","keywords":["bullet","railway","shinkansen","speed","train"]},{"name":":train:","text":"🚆","group":"travel","keywords":["railway","train"]},{"name":":metro:","text":"🚇","group":"travel","keywords":["metro","subway"]},{"name":":light_rail:","text":"🚈","group":"travel","keywords":["light rail","railway"]},{"name":":station:","text":"🚉","group":"travel","keywords":["railway","station","train"]},{"name":":tram:","text":"🚊","group":"travel","keywords":["tram","trolleybus"]},{"name":":monorail:","text":"🚝","group":"travel","keywords":["monorail","vehicle"]},{"name":":mountain_railway:","text":"🚞","group":"travel","keywords":["car","mountain","railway"]},{"name":":tram_car:","text":"🚋","group":"travel","keywords":["car","tram","trolleybus"]},{"name":":bus:","text":"🚌","group":"travel","keywords":["bus","vehicle"]},{"name":":oncoming_bus:","text":"🚍","group":"travel","keywords":["bus","oncoming"]},{"name":":trolleybus:","text":"🚎","group":"travel","keywords":["bus","tram","trolley","trolleybus"]},{"name":":minibus:","text":"🚐","group":"travel","keywords":["bus","minibus"]},{"name":":ambulance:","text":"🚑","group":"travel","keywords":["ambulance","vehicle"]},{"name":":fire_engine:","text":"🚒","group":"travel","keywords":["engine","fire","truck"]},{"name":":police_car:","text":"🚓","group":"travel","keywords":["car","patrol","police"]},{"name":":oncoming_police_car:","text":"🚔","group":"travel","keywords":["car","oncoming","police"]},{"name":":taxi:","text":"🚕","group":"travel","keywords":["taxi","vehicle"]},{"name":":oncoming_taxi:","text":"🚖","group":"travel","keywords":["oncoming","taxi"]},{"name":":automobile:","text":"🚗","group":"travel","keywords":["automobile","car"]},{"name":":oncoming_automobile:","text":"🚘","group":"travel","keywords":["automobile","car","oncoming"]},{"name":":sport_utility_vehicle:","text":"🚙","group":"travel","keywords":["recreational","sport utility","sport utility vehicle"]},{"name":":delivery_truck:","text":"🚚","group":"travel","keywords":["delivery","truck"]},{"name":":articulated_lorry:","text":"🚛","group":"travel","keywords":["articulated lorry","lorry","semi","truck"]},{"name":":tractor:","text":"🚜","group":"travel","keywords":["tractor","vehicle"]},{"name":":bicycle:","text":"🚲","group":"travel","keywords":["bicycle","bike"]},{"name":":kick_scooter:","text":"🛴","group":"travel","keywords":["kick","scooter"]},{"name":":motor_scooter:","text":"🛵","group":"travel","keywords":["motor","scooter"]},{"name":":bus_stop:","text":"🚏","group":"travel","keywords":["bus","busstop","stop"]},{"name":":motorway:","text":"🛣","group":"travel","keywords":["highway","motorway","road"]},{"name":":railway_track:","text":"🛤","group":"travel","keywords":["railway","railway track","train"]},{"name":":oil_drum:","text":"🛢","group":"travel","keywords":["drum","oil"]},{"name":":fuel_pump:","text":"⛽","group":"travel","keywords":["diesel","fuel","fuelpump","gas","pump","station"]},{"name":":police_car_light:","text":"🚨","group":"travel","keywords":["beacon","car","light","police","revolving"]},{"name":":horizontal_traffic_light:","text":"🚥","group":"travel","keywords":["horizontal traffic light","light","signal","traffic"]},{"name":":vertical_traffic_light:","text":"🚦","group":"travel","keywords":["light","signal","traffic","vertical traffic light"]},{"name":":stop_sign:","text":"🛑","group":"travel","keywords":["octagonal","sign","stop"]},{"name":":construction:","text":"🚧","group":"travel","keywords":["barrier","construction"]},{"name":":anchor:","text":"⚓","group":"travel","keywords":["anchor","ship","tool"]},{"name":":sailboat:","text":"⛵","group":"travel","keywords":["boat","resort","sailboat","sea","yacht"]},{"name":":canoe:","text":"🛶","group":"travel","keywords":["boat","canoe"]},{"name":":speedboat:","text":"🚤","group":"travel","keywords":["boat","speedboat"]},{"name":":passenger_ship:","text":"🛳","group":"travel","keywords":["passenger","ship"]},{"name":":ferry:","text":"⛴","group":"travel","keywords":["boat","ferry","passenger"]},{"name":":motor_boat:","text":"🛥","group":"travel","keywords":["boat","motor boat","motorboat"]},{"name":":ship:","text":"🚢","group":"travel","keywords":["boat","passenger","ship"]},{"name":":airplane:","text":"✈","group":"travel","keywords":["aeroplane","airplane"]},{"name":":small_airplane:","text":"🛩","group":"travel","keywords":["aeroplane","airplane","small airplane"]},{"name":":airplane_departure:","text":"🛫","group":"travel","keywords":["aeroplane","airplane","check-in","departure","departures"]},{"name":":airplane_arrival:","text":"🛬","group":"travel","keywords":["aeroplane","airplane","airplane arrival","arrivals","arriving","landing"]},{"name":":seat:","text":"💺","group":"travel","keywords":["chair","seat"]},{"name":":helicopter:","text":"🚁","group":"travel","keywords":["helicopter","vehicle"]},{"name":":suspension_railway:","text":"🚟","group":"travel","keywords":["railway","suspension"]},{"name":":mountain_cableway:","text":"🚠","group":"travel","keywords":["cable","gondola","mountain","mountain cableway"]},{"name":":aerial_tramway:","text":"🚡","group":"travel","keywords":["aerial","cable","car","gondola","tramway"]},{"name":":satellite:","text":"🛰","group":"travel","keywords":["satellite","space"]},{"name":":rocket:","text":"🚀","group":"travel","keywords":["rocket","space"]},{"name":":flying_saucer:","text":"🛸","group":"travel","keywords":["flying saucer","UFO"]},{"name":":bellhop_bell:","text":"🛎","group":"travel","keywords":["bell","bellhop","hotel"]},{"name":":hourglass_done:","text":"⌛","group":"travel","keywords":["hourglass done","sand","timer"]},{"name":":hourglass_not_done:","text":"⏳","group":"travel","keywords":["hourglass","hourglass not done","sand","timer"]},{"name":":watch:","text":"⌚","group":"travel","keywords":["clock","watch"]},{"name":":alarm_clock:","text":"⏰","group":"travel","keywords":["alarm","clock"]},{"name":":stopwatch:","text":"⏱","group":"travel","keywords":["clock","stopwatch"]},{"name":":timer_clock:","text":"⏲","group":"travel","keywords":["clock","timer"]},{"name":":mantelpiece_clock:","text":"🕰","group":"travel","keywords":["clock","mantelpiece clock"]},{"name":":twelve_o’clock:","text":"🕛","group":"travel","keywords":["00","12","12:00","clock","o’clock","twelve"]},{"name":":twelve-thirty:","text":"🕧","group":"travel","keywords":["12","12:30","clock","thirty","twelve","twelve-thirty"]},{"name":":one_o’clock:","text":"🕐","group":"travel","keywords":["00","1","1:00","clock","o’clock","one"]},{"name":":one-thirty:","text":"🕜","group":"travel","keywords":["1","1:30","clock","one","one-thirty","thirty"]},{"name":":two_o’clock:","text":"🕑","group":"travel","keywords":["00","2","2:00","clock","o’clock","two"]},{"name":":two-thirty:","text":"🕝","group":"travel","keywords":["2","2:30","clock","thirty","two","two-thirty"]},{"name":":three_o’clock:","text":"🕒","group":"travel","keywords":["00","3","3:00","clock","o’clock","three"]},{"name":":three-thirty:","text":"🕞","group":"travel","keywords":["3","3:30","clock","thirty","three","three-thirty"]},{"name":":four_o’clock:","text":"🕓","group":"travel","keywords":["00","4","4:00","clock","four","o’clock"]},{"name":":four-thirty:","text":"🕟","group":"travel","keywords":["4","4:30","clock","four","four-thirty","thirty"]},{"name":":five_o’clock:","text":"🕔","group":"travel","keywords":["00","5","5:00","clock","five","o’clock"]},{"name":":five-thirty:","text":"🕠","group":"travel","keywords":["5","5:30","clock","five","five-thirty","thirty"]},{"name":":six_o’clock:","text":"🕕","group":"travel","keywords":["00","6","6:00","clock","o’clock","six"]},{"name":":six-thirty:","text":"🕡","group":"travel","keywords":["6","6:30","clock","six","six-thirty","thirty"]},{"name":":seven_o’clock:","text":"🕖","group":"travel","keywords":["00","7","7:00","clock","o’clock","seven"]},{"name":":seven-thirty:","text":"🕢","group":"travel","keywords":["7","7:30","clock","seven","seven-thirty","thirty"]},{"name":":eight_o’clock:","text":"🕗","group":"travel","keywords":["00","8","8:00","clock","eight","o’clock"]},{"name":":eight-thirty:","text":"🕣","group":"travel","keywords":["8","8:30","clock","eight","eight-thirty","thirty"]},{"name":":nine_o’clock:","text":"🕘","group":"travel","keywords":["00","9","9:00","clock","nine","o’clock"]},{"name":":nine-thirty:","text":"🕤","group":"travel","keywords":["9","9:30","clock","nine","nine-thirty","thirty"]},{"name":":ten_o’clock:","text":"🕙","group":"travel","keywords":["00","10","10:00","clock","o’clock","ten"]},{"name":":ten-thirty:","text":"🕥","group":"travel","keywords":["10","10:30","clock","ten","ten-thirty","thirty"]},{"name":":eleven_o’clock:","text":"🕚","group":"travel","keywords":["00","11","11:00","clock","eleven","o’clock"]},{"name":":eleven-thirty:","text":"🕦","group":"travel","keywords":["11","11:30","clock","eleven","eleven-thirty","thirty"]},{"name":":new_moon:","text":"🌑","group":"travel","keywords":["dark","moon","new moon"]},{"name":":waxing_crescent_moon:","text":"🌒","group":"travel","keywords":["crescent","moon","waxing"]},{"name":":first_quarter_moon:","text":"🌓","group":"travel","keywords":["first quarter moon","moon","quarter"]},{"name":":waxing_gibbous_moon:","text":"🌔","group":"travel","keywords":["gibbous","moon","waxing"]},{"name":":full_moon:","text":"🌕","group":"travel","keywords":["full","moon"]},{"name":":waning_gibbous_moon:","text":"🌖","group":"travel","keywords":["gibbous","moon","waning"]},{"name":":last_quarter_moon:","text":"🌗","group":"travel","keywords":["last quarter moon","moon","quarter"]},{"name":":waning_crescent_moon:","text":"🌘","group":"travel","keywords":["crescent","moon","waning"]},{"name":":crescent_moon:","text":"🌙","group":"travel","keywords":["crescent","moon"]},{"name":":new_moon_face:","text":"🌚","group":"travel","keywords":["face","moon","new moon face"]},{"name":":first_quarter_moon_face:","text":"🌛","group":"travel","keywords":["face","first quarter moon face","moon","quarter"]},{"name":":last_quarter_moon_face:","text":"🌜","group":"travel","keywords":["face","last quarter moon face","moon","quarter"]},{"name":":thermometer:","text":"🌡","group":"travel","keywords":["thermometer","weather"]},{"name":":sun:","text":"☀","group":"travel","keywords":["bright","rays","sun","sunny"]},{"name":":full_moon_face:","text":"🌝","group":"travel","keywords":["bright","face","full","moon"]},{"name":":sun_with_face:","text":"🌞","group":"travel","keywords":["bright","face","sun","sun with face"]},{"name":":star:","text":"⭐","group":"travel","keywords":["star"]},{"name":":glowing_star:","text":"🌟","group":"travel","keywords":["glittery","glow","glowing star","shining","sparkle","star"]},{"name":":shooting_star:","text":"🌠","group":"travel","keywords":["falling","shooting","star"]},{"name":":cloud:","text":"☁","group":"travel","keywords":["cloud","weather"]},{"name":":sun_behind_cloud:","text":"⛅","group":"travel","keywords":["cloud","sun","sun behind cloud"]},{"name":":cloud_with_lightning_and_rain:","text":"⛈","group":"travel","keywords":["cloud","cloud with lightning and rain","rain","thunder"]},{"name":":sun_behind_small_cloud:","text":"🌤","group":"travel","keywords":["cloud","sun","sun behind small cloud"]},{"name":":sun_behind_large_cloud:","text":"🌥","group":"travel","keywords":["cloud","sun","sun behind large cloud"]},{"name":":sun_behind_rain_cloud:","text":"🌦","group":"travel","keywords":["cloud","rain","sun","sun behind rain cloud"]},{"name":":cloud_with_rain:","text":"🌧","group":"travel","keywords":["cloud","cloud with rain","rain"]},{"name":":cloud_with_snow:","text":"🌨","group":"travel","keywords":["cloud","cloud with snow","cold","snow"]},{"name":":cloud_with_lightning:","text":"🌩","group":"travel","keywords":["cloud","cloud with lightning","lightning"]},{"name":":tornado:","text":"🌪","group":"travel","keywords":["cloud","tornado","whirlwind"]},{"name":":fog:","text":"🌫","group":"travel","keywords":["cloud","fog"]},{"name":":wind_face:","text":"🌬","group":"travel","keywords":["blow","cloud","face","wind"]},{"name":":cyclone:","text":"🌀","group":"travel","keywords":["cyclone","dizzy","hurricane","twister","typhoon"]},{"name":":rainbow:","text":"🌈","group":"travel","keywords":["rain","rainbow"]},{"name":":closed_umbrella:","text":"🌂","group":"travel","keywords":["closed umbrella","clothing","rain","umbrella"]},{"name":":umbrella:","text":"☂","group":"travel","keywords":["clothing","rain","umbrella"]},{"name":":umbrella_with_rain_drops:","text":"☔","group":"travel","keywords":["clothing","drop","rain","umbrella","umbrella with rain drops"]},{"name":":umbrella_on_ground:","text":"⛱","group":"travel","keywords":["rain","sun","umbrella","umbrella on ground"]},{"name":":high_voltage:","text":"⚡","group":"travel","keywords":["danger","electric","high voltage","lightning","voltage","zap"]},{"name":":snowflake:","text":"❄","group":"travel","keywords":["cold","snow","snowflake"]},{"name":":snowman:","text":"☃","group":"travel","keywords":["cold","snow","snowman"]},{"name":":snowman_without_snow:","text":"⛄","group":"travel","keywords":["cold","snow","snowman","snowman without snow"]},{"name":":comet:","text":"☄","group":"travel","keywords":["comet","space"]},{"name":":fire:","text":"🔥","group":"travel","keywords":["fire","flame","tool"]},{"name":":droplet:","text":"💧","group":"travel","keywords":["cold","comic","drop","droplet","sweat"]},{"name":":water_wave:","text":"🌊","group":"travel","keywords":["ocean","water","wave"]},{"name":":jack-o-lantern:","text":"🎃","group":"activities","keywords":["celebration","halloween","jack","jack-o-lantern","lantern"]},{"name":":christmas_tree:","text":"🎄","group":"activities","keywords":["celebration","Christmas","tree"]},{"name":":fireworks:","text":"🎆","group":"activities","keywords":["celebration","fireworks"]},{"name":":sparkler:","text":"🎇","group":"activities","keywords":["celebration","fireworks","sparkle","sparkler"]},{"name":":sparkles:","text":"✨","group":"activities","keywords":["sparkle","sparkles","star"]},{"name":":balloon:","text":"🎈","group":"activities","keywords":["balloon","celebration"]},{"name":":party_popper:","text":"🎉","group":"activities","keywords":["celebration","party","popper","tada"]},{"name":":confetti_ball:","text":"🎊","group":"activities","keywords":["ball","celebration","confetti"]},{"name":":tanabata_tree:","text":"🎋","group":"activities","keywords":["banner","celebration","Japanese","tanabata tree","tree"]},{"name":":pine_decoration:","text":"🎍","group":"activities","keywords":["bamboo","celebration","Japanese","pine","pine decoration"]},{"name":":japanese_dolls:","text":"🎎","group":"activities","keywords":["celebration","doll","festival","Japanese","Japanese dolls"]},{"name":":carp_streamer:","text":"🎏","group":"activities","keywords":["carp","celebration","streamer"]},{"name":":wind_chime:","text":"🎐","group":"activities","keywords":["bell","celebration","chime","wind"]},{"name":":moon_viewing_ceremony:","text":"🎑","group":"activities","keywords":["celebration","ceremony","moon","moon viewing ceremony"]},{"name":":ribbon:","text":"🎀","group":"activities","keywords":["celebration","ribbon"]},{"name":":wrapped_gift:","text":"🎁","group":"activities","keywords":["box","celebration","gift","present","wrapped"]},{"name":":reminder_ribbon:","text":"🎗","group":"activities","keywords":["celebration","reminder","ribbon"]},{"name":":admission_tickets:","text":"🎟","group":"activities","keywords":["admission","admission tickets","ticket"]},{"name":":ticket:","text":"🎫","group":"activities","keywords":["admission","ticket"]},{"name":":military_medal:","text":"🎖","group":"activities","keywords":["celebration","medal","military"]},{"name":":trophy:","text":"🏆","group":"activities","keywords":["prize","trophy"]},{"name":":sports_medal:","text":"🏅","group":"activities","keywords":["medal","sports medal"]},{"name":":1st_place_medal:","text":"🥇","group":"activities","keywords":["1st place medal","first","gold","medal"]},{"name":":2nd_place_medal:","text":"🥈","group":"activities","keywords":["2nd place medal","medal","second","silver"]},{"name":":3rd_place_medal:","text":"🥉","group":"activities","keywords":["3rd place medal","bronze","medal","third"]},{"name":":soccer_ball:","text":"⚽","group":"activities","keywords":["ball","football","soccer"]},{"name":":baseball:","text":"⚾","group":"activities","keywords":["ball","baseball"]},{"name":":basketball:","text":"🏀","group":"activities","keywords":["ball","basketball","hoop"]},{"name":":volleyball:","text":"🏐","group":"activities","keywords":["ball","game","volleyball"]},{"name":":american_football:","text":"🏈","group":"activities","keywords":["american","ball","football"]},{"name":":rugby_football:","text":"🏉","group":"activities","keywords":["ball","football","rugby"]},{"name":":tennis:","text":"🎾","group":"activities","keywords":["ball","racquet","tennis"]},{"name":":bowling:","text":"🎳","group":"activities","keywords":["ball","bowling","game"]},{"name":":cricket_game:","text":"🏏","group":"activities","keywords":["ball","bat","cricket game","game"]},{"name":":field_hockey:","text":"🏑","group":"activities","keywords":["ball","field","game","hockey","stick"]},{"name":":ice_hockey:","text":"🏒","group":"activities","keywords":["game","hockey","ice","puck","stick"]},{"name":":ping_pong:","text":"🏓","group":"activities","keywords":["ball","bat","game","paddle","ping pong","table tennis"]},{"name":":badminton:","text":"🏸","group":"activities","keywords":["badminton","birdie","game","racquet","shuttlecock"]},{"name":":boxing_glove:","text":"🥊","group":"activities","keywords":["boxing","glove"]},{"name":":martial_arts_uniform:","text":"🥋","group":"activities","keywords":["judo","karate","martial arts","martial arts uniform","taekwondo","uniform"]},{"name":":goal_net:","text":"🥅","group":"activities","keywords":["goal","net"]},{"name":":flag_in_hole:","text":"⛳","group":"activities","keywords":["flag in hole","golf","hole"]},{"name":":ice_skate:","text":"⛸","group":"activities","keywords":["ice","skate"]},{"name":":fishing_pole:","text":"🎣","group":"activities","keywords":["fish","fishing pole","pole"]},{"name":":running_shirt:","text":"🎽","group":"activities","keywords":["athletics","running","sash","shirt"]},{"name":":skis:","text":"🎿","group":"activities","keywords":["ski","skis","snow"]},{"name":":sled:","text":"🛷","group":"activities","keywords":["sled","sledge","sleigh",""]},{"name":":curling_stone:","text":"🥌","group":"activities","keywords":["curling stone","game","rock"]},{"name":":direct_hit:","text":"🎯","group":"activities","keywords":["bullseye","dart","direct hit","game","hit","target"]},{"name":":pool_8_ball:","text":"🎱","group":"activities","keywords":["8","ball","billiard","eight","game","pool 8 ball"]},{"name":":crystal_ball:","text":"🔮","group":"activities","keywords":["ball","crystal","fairy tale","fantasy","fortune","tool"]},{"name":":video_game:","text":"🎮","group":"activities","keywords":["controller","game","video game"]},{"name":":joystick:","text":"🕹","group":"activities","keywords":["game","joystick","video game"]},{"name":":slot_machine:","text":"🎰","group":"activities","keywords":["game","slot","slot machine"]},{"name":":game_die:","text":"🎲","group":"activities","keywords":["dice","die","game"]},{"name":":spade_suit:","text":"♠","group":"activities","keywords":["card","game","spade suit"]},{"name":":heart_suit:","text":"♥","group":"activities","keywords":["card","game","heart suit"]},{"name":":diamond_suit:","text":"♦","group":"activities","keywords":["card","diamond suit","game"]},{"name":":club_suit:","text":"♣","group":"activities","keywords":["card","club suit","game"]},{"name":":joker:","text":"🃏","group":"activities","keywords":["card","game","joker","wildcard"]},{"name":":mahjong_red_dragon:","text":"🀄","group":"activities","keywords":["game","mahjong","mahjong red dragon","red"]},{"name":":flower_playing_cards:","text":"🎴","group":"activities","keywords":["card","flower","flower playing cards","game","Japanese","playing"]},{"name":":performing_arts:","text":"🎭","group":"activities","keywords":["art","mask","performing","performing arts","theater","theatre"]},{"name":":framed_picture:","text":"🖼","group":"activities","keywords":["art","frame","framed picture","museum","painting","picture"]},{"name":":artist_palette:","text":"🎨","group":"activities","keywords":["art","artist palette","museum","painting","palette"]},{"name":":muted_speaker:","text":"🔇","group":"objects","keywords":["mute","muted speaker","quiet","silent","speaker"]},{"name":":speaker_low_volume:","text":"🔈","group":"objects","keywords":["soft","speaker low volume"]},{"name":":speaker_medium_volume:","text":"🔉","group":"objects","keywords":["medium","speaker medium volume"]},{"name":":speaker_high_volume:","text":"🔊","group":"objects","keywords":["loud","speaker high volume"]},{"name":":loudspeaker:","text":"📢","group":"objects","keywords":["loud","loudspeaker","public address"]},{"name":":megaphone:","text":"📣","group":"objects","keywords":["cheering","megaphone"]},{"name":":postal_horn:","text":"📯","group":"objects","keywords":["horn","post","postal"]},{"name":":bell:","text":"🔔","group":"objects","keywords":["bell"]},{"name":":bell_with_slash:","text":"🔕","group":"objects","keywords":["bell","bell with slash","forbidden","mute","quiet","silent"]},{"name":":musical_score:","text":"🎼","group":"objects","keywords":["music","musical score","score"]},{"name":":musical_note:","text":"🎵","group":"objects","keywords":["music","musical note","note"]},{"name":":musical_notes:","text":"🎶","group":"objects","keywords":["music","musical notes","note","notes"]},{"name":":studio_microphone:","text":"🎙","group":"objects","keywords":["mic","microphone","music","studio"]},{"name":":level_slider:","text":"🎚","group":"objects","keywords":["level","music","slider"]},{"name":":control_knobs:","text":"🎛","group":"objects","keywords":["control","knobs","music"]},{"name":":microphone:","text":"🎤","group":"objects","keywords":["karaoke","mic","microphone"]},{"name":":headphone:","text":"🎧","group":"objects","keywords":["earbud","headphone"]},{"name":":radio:","text":"📻","group":"objects","keywords":["radio","video"]},{"name":":saxophone:","text":"🎷","group":"objects","keywords":["instrument","music","sax","saxophone"]},{"name":":guitar:","text":"🎸","group":"objects","keywords":["guitar","instrument","music"]},{"name":":musical_keyboard:","text":"🎹","group":"objects","keywords":["instrument","keyboard","music","musical keyboard","piano"]},{"name":":trumpet:","text":"🎺","group":"objects","keywords":["instrument","music","trumpet"]},{"name":":violin:","text":"🎻","group":"objects","keywords":["instrument","music","violin"]},{"name":":drum:","text":"🥁","group":"objects","keywords":["drum","drumsticks","music"]},{"name":":mobile_phone:","text":"📱","group":"objects","keywords":["cell","mobile","phone","telephone"]},{"name":":mobile_phone_with_arrow:","text":"📲","group":"objects","keywords":["arrow","cell","mobile","mobile phone with arrow","phone","receive"]},{"name":":telephone:","text":"☎","group":"objects","keywords":["phone","telephone"]},{"name":":telephone_receiver:","text":"📞","group":"objects","keywords":["phone","receiver","telephone"]},{"name":":pager:","text":"📟","group":"objects","keywords":["pager"]},{"name":":fax_machine:","text":"📠","group":"objects","keywords":["fax","fax machine"]},{"name":":battery:","text":"🔋","group":"objects","keywords":["battery"]},{"name":":electric_plug:","text":"🔌","group":"objects","keywords":["electric","electricity","plug"]},{"name":":laptop_computer:","text":"💻","group":"objects","keywords":["computer","laptop computer","pc","personal"]},{"name":":desktop_computer:","text":"🖥","group":"objects","keywords":["computer","desktop"]},{"name":":printer:","text":"🖨","group":"objects","keywords":["computer","printer"]},{"name":":keyboard:","text":"⌨","group":"objects","keywords":["computer","keyboard"]},{"name":":computer_mouse:","text":"🖱","group":"objects","keywords":["computer","computer mouse"]},{"name":":trackball:","text":"🖲","group":"objects","keywords":["computer","trackball"]},{"name":":computer_disk:","text":"💽","group":"objects","keywords":["computer","disk","minidisk","optical"]},{"name":":floppy_disk:","text":"💾","group":"objects","keywords":["computer","disk","floppy"]},{"name":":optical_disk:","text":"💿","group":"objects","keywords":["cd","computer","disk","optical"]},{"name":":dvd:","text":"📀","group":"objects","keywords":["blu-ray","computer","disk","dvd","optical"]},{"name":":movie_camera:","text":"🎥","group":"objects","keywords":["camera","cinema","movie"]},{"name":":film_frames:","text":"🎞","group":"objects","keywords":["cinema","film","frames","movie"]},{"name":":film_projector:","text":"📽","group":"objects","keywords":["cinema","film","movie","projector","video"]},{"name":":clapper_board:","text":"🎬","group":"objects","keywords":["clapper","clapper board","movie"]},{"name":":television:","text":"📺","group":"objects","keywords":["television","tv","video"]},{"name":":camera:","text":"📷","group":"objects","keywords":["camera","video"]},{"name":":camera_with_flash:","text":"📸","group":"objects","keywords":["camera","camera with flash","flash","video"]},{"name":":video_camera:","text":"📹","group":"objects","keywords":["camera","video"]},{"name":":videocassette:","text":"📼","group":"objects","keywords":["tape","vhs","video","videocassette"]},{"name":":magnifying_glass_tilted_left:","text":"🔍","group":"objects","keywords":["glass","magnifying","magnifying glass tilted left","search","tool"]},{"name":":magnifying_glass_tilted_right:","text":"🔎","group":"objects","keywords":["glass","magnifying","magnifying glass tilted right","search","tool"]},{"name":":candle:","text":"🕯","group":"objects","keywords":["candle","light"]},{"name":":light_bulb:","text":"💡","group":"objects","keywords":["bulb","comic","electric","idea","light"]},{"name":":flashlight:","text":"🔦","group":"objects","keywords":["electric","flashlight","light","tool","torch"]},{"name":":red_paper_lantern:","text":"🏮","group":"objects","keywords":["bar","lantern","light","red","red paper lantern"]},{"name":":notebook_with_decorative_cover:","text":"📔","group":"objects","keywords":["book","cover","decorated","notebook","notebook with decorative cover"]},{"name":":closed_book:","text":"📕","group":"objects","keywords":["book","closed"]},{"name":":open_book:","text":"📖","group":"objects","keywords":["book","open"]},{"name":":green_book:","text":"📗","group":"objects","keywords":["book","green"]},{"name":":blue_book:","text":"📘","group":"objects","keywords":["blue","book"]},{"name":":orange_book:","text":"📙","group":"objects","keywords":["book","orange"]},{"name":":books:","text":"📚","group":"objects","keywords":["book","books"]},{"name":":notebook:","text":"📓","group":"objects","keywords":["notebook"]},{"name":":ledger:","text":"📒","group":"objects","keywords":["ledger","notebook"]},{"name":":page_with_curl:","text":"📃","group":"objects","keywords":["curl","document","page","page with curl"]},{"name":":scroll:","text":"📜","group":"objects","keywords":["paper","scroll"]},{"name":":page_facing_up:","text":"📄","group":"objects","keywords":["document","page","page facing up"]},{"name":":newspaper:","text":"📰","group":"objects","keywords":["news","newspaper","paper"]},{"name":":rolled-up_newspaper:","text":"🗞","group":"objects","keywords":["news","newspaper","paper","rolled","rolled-up newspaper"]},{"name":":bookmark_tabs:","text":"📑","group":"objects","keywords":["bookmark","mark","marker","tabs"]},{"name":":bookmark:","text":"🔖","group":"objects","keywords":["bookmark","mark"]},{"name":":label:","text":"🏷","group":"objects","keywords":["label"]},{"name":":money_bag:","text":"💰","group":"objects","keywords":["bag","dollar","money","moneybag"]},{"name":":yen_banknote:","text":"💴","group":"objects","keywords":["banknote","bill","currency","money","note","yen"]},{"name":":dollar_banknote:","text":"💵","group":"objects","keywords":["banknote","bill","currency","dollar","money","note"]},{"name":":euro_banknote:","text":"💶","group":"objects","keywords":["banknote","bill","currency","euro","money","note"]},{"name":":pound_banknote:","text":"💷","group":"objects","keywords":["banknote","bill","currency","money","note","pound"]},{"name":":money_with_wings:","text":"💸","group":"objects","keywords":["banknote","bill","fly","money","money with wings","wings"]},{"name":":credit_card:","text":"💳","group":"objects","keywords":["card","credit","money"]},{"name":":chart_increasing_with_yen:","text":"💹","group":"objects","keywords":["chart","chart increasing with yen","graph","growth","money","yen"]},{"name":":currency_exchange:","text":"💱","group":"objects","keywords":["bank","currency","exchange","money"]},{"name":":heavy_dollar_sign:","text":"💲","group":"objects","keywords":["currency","dollar","heavy dollar sign","money"]},{"name":":envelope:","text":"✉","group":"objects","keywords":["email","envelope","letter"]},{"name":":e-mail:","text":"📧","group":"objects","keywords":["e-mail","email","letter","mail"]},{"name":":incoming_envelope:","text":"📨","group":"objects","keywords":["e-mail","email","envelope","incoming","letter","receive"]},{"name":":envelope_with_arrow:","text":"📩","group":"objects","keywords":["arrow","e-mail","email","envelope","envelope with arrow","outgoing"]},{"name":":outbox_tray:","text":"📤","group":"objects","keywords":["box","letter","mail","outbox","sent","tray"]},{"name":":inbox_tray:","text":"📥","group":"objects","keywords":["box","inbox","letter","mail","receive","tray"]},{"name":":package:","text":"📦","group":"objects","keywords":["box","package","parcel"]},{"name":":closed_mailbox_with_raised_flag:","text":"📫","group":"objects","keywords":["closed","closed mailbox with raised flag","mail","mailbox","postbox"]},{"name":":closed_mailbox_with_lowered_flag:","text":"📪","group":"objects","keywords":["closed","closed mailbox with lowered flag","lowered","mail","mailbox","postbox"]},{"name":":open_mailbox_with_raised_flag:","text":"📬","group":"objects","keywords":["mail","mailbox","open","open mailbox with raised flag","postbox"]},{"name":":open_mailbox_with_lowered_flag:","text":"📭","group":"objects","keywords":["lowered","mail","mailbox","open","open mailbox with lowered flag","postbox"]},{"name":":postbox:","text":"📮","group":"objects","keywords":["mail","mailbox","postbox"]},{"name":":ballot_box_with_ballot:","text":"🗳","group":"objects","keywords":["ballot","ballot box with ballot","box"]},{"name":":pencil:","text":"✏","group":"objects","keywords":["pencil"]},{"name":":black_nib:","text":"✒","group":"objects","keywords":["black nib","nib","pen"]},{"name":":fountain_pen:","text":"🖋","group":"objects","keywords":["fountain","pen"]},{"name":":pen:","text":"🖊","group":"objects","keywords":["ballpoint","pen"]},{"name":":paintbrush:","text":"🖌","group":"objects","keywords":["paintbrush","painting"]},{"name":":crayon:","text":"🖍","group":"objects","keywords":["crayon"]},{"name":":memo:","text":"📝","group":"objects","keywords":["memo","pencil"]},{"name":":briefcase:","text":"💼","group":"objects","keywords":["briefcase"]},{"name":":file_folder:","text":"📁","group":"objects","keywords":["file","folder"]},{"name":":open_file_folder:","text":"📂","group":"objects","keywords":["file","folder","open"]},{"name":":card_index_dividers:","text":"🗂","group":"objects","keywords":["card","dividers","index"]},{"name":":calendar:","text":"📅","group":"objects","keywords":["calendar","date"]},{"name":":tear-off_calendar:","text":"📆","group":"objects","keywords":["calendar","tear-off calendar"]},{"name":":spiral_notepad:","text":"🗒","group":"objects","keywords":["note","pad","spiral","spiral notepad"]},{"name":":spiral_calendar:","text":"🗓","group":"objects","keywords":["calendar","pad","spiral"]},{"name":":card_index:","text":"📇","group":"objects","keywords":["card","index","rolodex"]},{"name":":chart_increasing:","text":"📈","group":"objects","keywords":["chart","chart increasing","graph","growth","trend","upward"]},{"name":":chart_decreasing:","text":"📉","group":"objects","keywords":["chart","chart decreasing","down","graph","trend"]},{"name":":bar_chart:","text":"📊","group":"objects","keywords":["bar","chart","graph"]},{"name":":clipboard:","text":"📋","group":"objects","keywords":["clipboard"]},{"name":":pushpin:","text":"📌","group":"objects","keywords":["pin","pushpin"]},{"name":":round_pushpin:","text":"📍","group":"objects","keywords":["pin","pushpin","round pushpin"]},{"name":":paperclip:","text":"📎","group":"objects","keywords":["paperclip"]},{"name":":linked_paperclips:","text":"🖇","group":"objects","keywords":["link","linked paperclips","paperclip"]},{"name":":straight_ruler:","text":"📏","group":"objects","keywords":["ruler","straight edge","straight ruler"]},{"name":":triangular_ruler:","text":"📐","group":"objects","keywords":["ruler","set","triangle","triangular ruler"]},{"name":":scissors:","text":"✂","group":"objects","keywords":["cutting","scissors","tool"]},{"name":":card_file_box:","text":"🗃","group":"objects","keywords":["box","card","file"]},{"name":":file_cabinet:","text":"🗄","group":"objects","keywords":["cabinet","file","filing"]},{"name":":wastebasket:","text":"🗑","group":"objects","keywords":["wastebasket"]},{"name":":locked:","text":"🔒","group":"objects","keywords":["closed","locked"]},{"name":":unlocked:","text":"🔓","group":"objects","keywords":["lock","open","unlock","unlocked"]},{"name":":locked_with_pen:","text":"🔏","group":"objects","keywords":["ink","lock","locked with pen","nib","pen","privacy"]},{"name":":locked_with_key:","text":"🔐","group":"objects","keywords":["closed","key","lock","locked with key","secure"]},{"name":":key:","text":"🔑","group":"objects","keywords":["key","lock","password"]},{"name":":old_key:","text":"🗝","group":"objects","keywords":["clue","key","lock","old"]},{"name":":hammer:","text":"🔨","group":"objects","keywords":["hammer","tool"]},{"name":":pick:","text":"⛏","group":"objects","keywords":["mining","pick","tool"]},{"name":":hammer_and_pick:","text":"⚒","group":"objects","keywords":["hammer","hammer and pick","pick","tool"]},{"name":":hammer_and_wrench:","text":"🛠","group":"objects","keywords":["hammer","hammer and wrench","spanner","tool","wrench"]},{"name":":dagger:","text":"🗡","group":"objects","keywords":["dagger","knife","weapon"]},{"name":":crossed_swords:","text":"⚔","group":"objects","keywords":["crossed","swords","weapon"]},{"name":":pistol:","text":"🔫","group":"objects","keywords":["gun","handgun","pistol","revolver","tool","weapon"]},{"name":":bow_and_arrow:","text":"🏹","group":"objects","keywords":["archer","arrow","bow","bow and arrow","Sagittarius","zodiac"]},{"name":":shield:","text":"🛡","group":"objects","keywords":["shield","weapon"]},{"name":":wrench:","text":"🔧","group":"objects","keywords":["spanner","tool","wrench"]},{"name":":nut_and_bolt:","text":"🔩","group":"objects","keywords":["bolt","nut","nut and bolt","tool"]},{"name":":gear:","text":"⚙","group":"objects","keywords":["cog","cogwheel","gear","tool"]},{"name":":clamp:","text":"🗜","group":"objects","keywords":["clamp","compress","tool","vice"]},{"name":":balance_scale:","text":"⚖","group":"objects","keywords":["balance","justice","Libra","scale","zodiac"]},{"name":":link:","text":"🔗","group":"objects","keywords":["link"]},{"name":":chains:","text":"⛓","group":"objects","keywords":["chain","chains"]},{"name":":alembic:","text":"⚗","group":"objects","keywords":["alembic","chemistry","tool"]},{"name":":microscope:","text":"🔬","group":"objects","keywords":["microscope","science","tool"]},{"name":":telescope:","text":"🔭","group":"objects","keywords":["science","telescope","tool"]},{"name":":satellite_antenna:","text":"📡","group":"objects","keywords":["antenna","dish","satellite"]},{"name":":syringe:","text":"💉","group":"objects","keywords":["medicine","needle","shot","sick","syringe"]},{"name":":pill:","text":"💊","group":"objects","keywords":["doctor","medicine","pill","sick"]},{"name":":door:","text":"🚪","group":"objects","keywords":["door"]},{"name":":bed:","text":"🛏","group":"objects","keywords":["bed","hotel","sleep"]},{"name":":couch_and_lamp:","text":"🛋","group":"objects","keywords":["couch","couch and lamp","hotel","lamp"]},{"name":":toilet:","text":"🚽","group":"objects","keywords":["toilet"]},{"name":":shower:","text":"🚿","group":"objects","keywords":["shower","water"]},{"name":":bathtub:","text":"🛁","group":"objects","keywords":["bath","bathtub"]},{"name":":shopping_cart:","text":"🛒","group":"objects","keywords":["cart","shopping","trolley"]},{"name":":cigarette:","text":"🚬","group":"objects","keywords":["cigarette","smoking"]},{"name":":coffin:","text":"⚰","group":"objects","keywords":["coffin","death"]},{"name":":funeral_urn:","text":"⚱","group":"objects","keywords":["ashes","death","funeral","urn"]},{"name":":moai:","text":"🗿","group":"objects","keywords":["face","moai","moyai","statue"]},{"name":":atm_sign:","text":"🏧","group":"symbols","keywords":["atm","ATM sign","automated","bank","teller"]},{"name":":litter_in_bin_sign:","text":"🚮","group":"symbols","keywords":["litter","litter bin","litter in bin sign"]},{"name":":potable_water:","text":"🚰","group":"symbols","keywords":["drinking","potable","water"]},{"name":":wheelchair_symbol:","text":"♿","group":"symbols","keywords":["access","wheelchair symbol"]},{"name":":men’s_room:","text":"🚹","group":"symbols","keywords":["lavatory","man","men’s room","restroom","wc"]},{"name":":women’s_room:","text":"🚺","group":"symbols","keywords":["lavatory","restroom","wc","woman","women’s room"]},{"name":":restroom:","text":"🚻","group":"symbols","keywords":["lavatory","restroom","WC"]},{"name":":baby_symbol:","text":"🚼","group":"symbols","keywords":["baby","baby symbol","changing"]},{"name":":water_closet:","text":"🚾","group":"symbols","keywords":["closet","lavatory","restroom","water","wc"]},{"name":":passport_control:","text":"🛂","group":"symbols","keywords":["control","passport"]},{"name":":customs:","text":"🛃","group":"symbols","keywords":["customs"]},{"name":":baggage_claim:","text":"🛄","group":"symbols","keywords":["baggage","claim"]},{"name":":left_luggage:","text":"🛅","group":"symbols","keywords":["baggage","left luggage","locker","luggage"]},{"name":":warning:","text":"⚠","group":"symbols","keywords":["warning"]},{"name":":children_crossing:","text":"🚸","group":"symbols","keywords":["child","children crossing","crossing","pedestrian","traffic"]},{"name":":no_entry:","text":"⛔","group":"symbols","keywords":["entry","forbidden","no","not","prohibited","traffic"]},{"name":":prohibited:","text":"🚫","group":"symbols","keywords":["entry","forbidden","no","not","prohibited"]},{"name":":no_bicycles:","text":"🚳","group":"symbols","keywords":["bicycle","bike","forbidden","no","no bicycles","prohibited"]},{"name":":no_smoking:","text":"🚭","group":"symbols","keywords":["forbidden","no","not","prohibited","smoking"]},{"name":":no_littering:","text":"🚯","group":"symbols","keywords":["forbidden","litter","no","no littering","not","prohibited"]},{"name":":non-potable_water:","text":"🚱","group":"symbols","keywords":["non-drinking","non-potable","water"]},{"name":":no_pedestrians:","text":"🚷","group":"symbols","keywords":["forbidden","no","no pedestrians","not","pedestrian","prohibited"]},{"name":":no_mobile_phones:","text":"📵","group":"symbols","keywords":["cell","forbidden","mobile","no","no mobile phones","phone"]},{"name":":no_one_under_eighteen:","text":"🔞","group":"symbols","keywords":["18","age restriction","eighteen","no one under eighteen","prohibited","underage"]},{"name":":radioactive:","text":"☢","group":"symbols","keywords":["radioactive","sign"]},{"name":":biohazard:","text":"☣","group":"symbols","keywords":["biohazard","sign"]},{"name":":up_arrow:","text":"⬆","group":"symbols","keywords":["arrow","cardinal","direction","north","up arrow"]},{"name":":up-right_arrow:","text":"↗","group":"symbols","keywords":["arrow","direction","intercardinal","northeast","up-right arrow"]},{"name":":right_arrow:","text":"➡","group":"symbols","keywords":["arrow","cardinal","direction","east","right arrow"]},{"name":":down-right_arrow:","text":"↘","group":"symbols","keywords":["arrow","direction","down-right arrow","intercardinal","southeast"]},{"name":":down_arrow:","text":"⬇","group":"symbols","keywords":["arrow","cardinal","direction","down","south"]},{"name":":down-left_arrow:","text":"↙","group":"symbols","keywords":["arrow","direction","down-left arrow","intercardinal","southwest"]},{"name":":left_arrow:","text":"⬅","group":"symbols","keywords":["arrow","cardinal","direction","left arrow","west"]},{"name":":up-left_arrow:","text":"↖","group":"symbols","keywords":["arrow","direction","intercardinal","northwest","up-left arrow"]},{"name":":up-down_arrow:","text":"↕","group":"symbols","keywords":["arrow","up-down arrow"]},{"name":":left-right_arrow:","text":"↔","group":"symbols","keywords":["arrow","left-right arrow"]},{"name":":right_arrow_curving_left:","text":"↩","group":"symbols","keywords":["arrow","right arrow curving left"]},{"name":":left_arrow_curving_right:","text":"↪","group":"symbols","keywords":["arrow","left arrow curving right"]},{"name":":right_arrow_curving_up:","text":"⤴","group":"symbols","keywords":["arrow","right arrow curving up"]},{"name":":right_arrow_curving_down:","text":"⤵","group":"symbols","keywords":["arrow","down","right arrow curving down"]},{"name":":clockwise_vertical_arrows:","text":"🔃","group":"symbols","keywords":["arrow","clockwise","clockwise vertical arrows","reload"]},{"name":":counterclockwise_arrows_button:","text":"🔄","group":"symbols","keywords":["anticlockwise","arrow","counterclockwise","counterclockwise arrows button","withershins"]},{"name":":back_arrow:","text":"🔙","group":"symbols","keywords":["arrow","back","BACK arrow"]},{"name":":end_arrow:","text":"🔚","group":"symbols","keywords":["arrow","end","END arrow"]},{"name":":on!_arrow:","text":"🔛","group":"symbols","keywords":["arrow","mark","on","ON! arrow"]},{"name":":soon_arrow:","text":"🔜","group":"symbols","keywords":["arrow","soon","SOON arrow"]},{"name":":top_arrow:","text":"🔝","group":"symbols","keywords":["arrow","top","TOP arrow","up"]},{"name":":place_of_worship:","text":"🛐","group":"symbols","keywords":["place of worship","religion","worship"]},{"name":":atom_symbol:","text":"⚛","group":"symbols","keywords":["atheist","atom","atom symbol"]},{"name":":om:","text":"🕉","group":"symbols","keywords":["Hindu","om","religion"]},{"name":":star_of_david:","text":"✡","group":"symbols","keywords":["David","Jew","Jewish","religion","star","star of David"]},{"name":":wheel_of_dharma:","text":"☸","group":"symbols","keywords":["Buddhist","dharma","religion","wheel","wheel of dharma"]},{"name":":yin_yang:","text":"☯","group":"symbols","keywords":["religion","tao","taoist","yang","yin"]},{"name":":latin_cross:","text":"✝","group":"symbols","keywords":["Christian","cross","latin cross","religion"]},{"name":":orthodox_cross:","text":"☦","group":"symbols","keywords":["Christian","cross","orthodox cross","religion"]},{"name":":star_and_crescent:","text":"☪","group":"symbols","keywords":["islam","Muslim","religion","star and crescent"]},{"name":":peace_symbol:","text":"☮","group":"symbols","keywords":["peace","peace symbol"]},{"name":":menorah:","text":"🕎","group":"symbols","keywords":["candelabrum","candlestick","menorah","religion"]},{"name":":dotted_six-pointed_star:","text":"🔯","group":"symbols","keywords":["dotted six-pointed star","fortune","star"]},{"name":":aries:","text":"♈","group":"symbols","keywords":["Aries","ram","zodiac"]},{"name":":taurus:","text":"♉","group":"symbols","keywords":["bull","ox","Taurus","zodiac"]},{"name":":gemini:","text":"♊","group":"symbols","keywords":["Gemini","twins","zodiac"]},{"name":":cancer:","text":"♋","group":"symbols","keywords":["Cancer","crab","zodiac"]},{"name":":leo:","text":"♌","group":"symbols","keywords":["Leo","lion","zodiac"]},{"name":":virgo:","text":"♍","group":"symbols","keywords":["Virgo","zodiac"]},{"name":":libra:","text":"♎","group":"symbols","keywords":["balance","justice","Libra","scales","zodiac"]},{"name":":scorpio:","text":"♏","group":"symbols","keywords":["Scorpio","scorpion","scorpius","zodiac"]},{"name":":sagittarius:","text":"♐","group":"symbols","keywords":["archer","Sagittarius","zodiac"]},{"name":":capricorn:","text":"♑","group":"symbols","keywords":["Capricorn","goat","zodiac"]},{"name":":aquarius:","text":"♒","group":"symbols","keywords":["Aquarius","bearer","water","zodiac"]},{"name":":pisces:","text":"♓","group":"symbols","keywords":["fish","Pisces","zodiac"]},{"name":":ophiuchus:","text":"⛎","group":"symbols","keywords":["bearer","Ophiuchus","serpent","snake","zodiac"]},{"name":":shuffle_tracks_button:","text":"🔀","group":"symbols","keywords":["arrow","crossed","shuffle tracks button"]},{"name":":repeat_button:","text":"🔁","group":"symbols","keywords":["arrow","clockwise","repeat","repeat button"]},{"name":":repeat_single_button:","text":"🔂","group":"symbols","keywords":["arrow","clockwise","once","repeat single button"]},{"name":":play_button:","text":"▶","group":"symbols","keywords":["arrow","play","play button","right","triangle"]},{"name":":fast-forward_button:","text":"⏩","group":"symbols","keywords":["arrow","double","fast","fast-forward button","forward"]},{"name":":next_track_button:","text":"⏭","group":"symbols","keywords":["arrow","next scene","next track","next track button","triangle"]},{"name":":play_or_pause_button:","text":"⏯","group":"symbols","keywords":["arrow","pause","play","play or pause button","right","triangle"]},{"name":":reverse_button:","text":"◀","group":"symbols","keywords":["arrow","left","reverse","reverse button","triangle"]},{"name":":fast_reverse_button:","text":"⏪","group":"symbols","keywords":["arrow","double","fast reverse button","rewind"]},{"name":":last_track_button:","text":"⏮","group":"symbols","keywords":["arrow","last track button","previous scene","previous track","triangle"]},{"name":":upwards_button:","text":"🔼","group":"symbols","keywords":["arrow","button","red","upwards button"]},{"name":":fast_up_button:","text":"⏫","group":"symbols","keywords":["arrow","double","fast up button"]},{"name":":downwards_button:","text":"🔽","group":"symbols","keywords":["arrow","button","down","downwards button","red"]},{"name":":fast_down_button:","text":"⏬","group":"symbols","keywords":["arrow","double","down","fast down button"]},{"name":":pause_button:","text":"⏸","group":"symbols","keywords":["bar","double","pause","pause button","vertical"]},{"name":":stop_button:","text":"⏹","group":"symbols","keywords":["square","stop","stop button"]},{"name":":record_button:","text":"⏺","group":"symbols","keywords":["circle","record","record button"]},{"name":":eject_button:","text":"⏏","group":"symbols","keywords":["eject","eject button"]},{"name":":cinema:","text":"🎦","group":"symbols","keywords":["camera","cinema","film","movie"]},{"name":":dim_button:","text":"🔅","group":"symbols","keywords":["brightness","dim","dim button","low"]},{"name":":bright_button:","text":"🔆","group":"symbols","keywords":["bright","bright button","brightness"]},{"name":":antenna_bars:","text":"📶","group":"symbols","keywords":["antenna","antenna bars","bar","cell","mobile","phone"]},{"name":":vibration_mode:","text":"📳","group":"symbols","keywords":["cell","mobile","mode","phone","telephone","vibration"]},{"name":":mobile_phone_off:","text":"📴","group":"symbols","keywords":["cell","mobile","off","phone","telephone"]},{"name":":female_sign:","text":"♀","group":"symbols","keywords":["female sign","woman"]},{"name":":male_sign:","text":"♂","group":"symbols","keywords":["male sign","man"]},{"name":":medical_symbol:","text":"⚕","group":"symbols","keywords":["aesculapius","medical symbol","medicine","staff"]},{"name":":recycling_symbol:","text":"♻","group":"symbols","keywords":["recycle","recycling symbol"]},{"name":":fleur-de-lis:","text":"⚜","group":"symbols","keywords":["fleur-de-lis"]},{"name":":trident_emblem:","text":"🔱","group":"symbols","keywords":["anchor","emblem","ship","tool","trident"]},{"name":":name_badge:","text":"📛","group":"symbols","keywords":["badge","name"]},{"name":":japanese_symbol_for_beginner:","text":"🔰","group":"symbols","keywords":["beginner","chevron","Japanese","Japanese symbol for beginner","leaf"]},{"name":":heavy_large_circle:","text":"⭕","group":"symbols","keywords":["circle","heavy large circle","o"]},{"name":":white_heavy_check_mark:","text":"✅","group":"symbols","keywords":["check","mark","white heavy check mark"]},{"name":":ballot_box_with_check:","text":"☑","group":"symbols","keywords":["ballot","ballot box with check","box","check"]},{"name":":heavy_check_mark:","text":"✔","group":"symbols","keywords":["check","heavy check mark","mark"]},{"name":":heavy_multiplication_x:","text":"✖","group":"symbols","keywords":["cancel","heavy multiplication x","multiplication","multiply","x"]},{"name":":cross_mark:","text":"❌","group":"symbols","keywords":["cancel","cross mark","mark","multiplication","multiply","x"]},{"name":":cross_mark_button:","text":"❎","group":"symbols","keywords":["cross mark button","mark","square"]},{"name":":heavy_plus_sign:","text":"➕","group":"symbols","keywords":["heavy plus sign","math","plus"]},{"name":":heavy_minus_sign:","text":"➖","group":"symbols","keywords":["heavy minus sign","math","minus"]},{"name":":heavy_division_sign:","text":"➗","group":"symbols","keywords":["division","heavy division sign","math"]},{"name":":curly_loop:","text":"➰","group":"symbols","keywords":["curl","curly loop","loop"]},{"name":":double_curly_loop:","text":"➿","group":"symbols","keywords":["curl","double","double curly loop","loop"]},{"name":":part_alternation_mark:","text":"〽","group":"symbols","keywords":["mark","part","part alternation mark"]},{"name":":eight-spoked_asterisk:","text":"✳","group":"symbols","keywords":["asterisk","eight-spoked asterisk"]},{"name":":eight-pointed_star:","text":"✴","group":"symbols","keywords":["eight-pointed star","star"]},{"name":":sparkle:","text":"❇","group":"symbols","keywords":["sparkle"]},{"name":":double_exclamation_mark:","text":"‼","group":"symbols","keywords":["bangbang","double exclamation mark","exclamation","mark","punctuation"]},{"name":":exclamation_question_mark:","text":"⁉","group":"symbols","keywords":["exclamation","interrobang","mark","punctuation","question"]},{"name":":question_mark:","text":"❓","group":"symbols","keywords":["mark","punctuation","question"]},{"name":":white_question_mark:","text":"❔","group":"symbols","keywords":["mark","outlined","punctuation","question","white question mark"]},{"name":":white_exclamation_mark:","text":"❕","group":"symbols","keywords":["exclamation","mark","outlined","punctuation","white exclamation mark"]},{"name":":exclamation_mark:","text":"❗","group":"symbols","keywords":["exclamation","mark","punctuation"]},{"name":":wavy_dash:","text":"〰","group":"symbols","keywords":["dash","punctuation","wavy"]},{"name":":copyright:","text":"©","group":"symbols","keywords":["copyright"]},{"name":":registered:","text":"®","group":"symbols","keywords":["registered"]},{"name":":trade_mark:","text":"™","group":"symbols","keywords":["mark","tm","trade mark","trademark"]},{"name":":keycap_#:","text":"#️⃣","group":"symbols","keywords":["keycap"]},{"name":":keycap_*:","text":"*️⃣","group":"symbols","keywords":["keycap"]},{"name":":keycap_0:","text":"0️⃣","group":"symbols","keywords":["keycap"]},{"name":":keycap_1:","text":"1️⃣","group":"symbols","keywords":["keycap"]},{"name":":keycap_2:","text":"2️⃣","group":"symbols","keywords":["keycap"]},{"name":":keycap_3:","text":"3️⃣","group":"symbols","keywords":["keycap"]},{"name":":keycap_4:","text":"4️⃣","group":"symbols","keywords":["keycap"]},{"name":":keycap_5:","text":"5️⃣","group":"symbols","keywords":["keycap"]},{"name":":keycap_6:","text":"6️⃣","group":"symbols","keywords":["keycap"]},{"name":":keycap_7:","text":"7️⃣","group":"symbols","keywords":["keycap"]},{"name":":keycap_8:","text":"8️⃣","group":"symbols","keywords":["keycap"]},{"name":":keycap_9:","text":"9️⃣","group":"symbols","keywords":["keycap"]},{"name":":keycap_10:","text":"🔟","group":"symbols","keywords":["keycap"]},{"name":":hundred_points:","text":"💯","group":"symbols","keywords":["100","full","hundred","hundred points","score"]},{"name":":input_latin_uppercase:","text":"🔠","group":"symbols","keywords":["ABCD","input","latin","letters","uppercase"]},{"name":":input_latin_lowercase:","text":"🔡","group":"symbols","keywords":["abcd","input","latin","letters","lowercase"]},{"name":":input_numbers:","text":"🔢","group":"symbols","keywords":["1234","input","numbers"]},{"name":":input_symbols:","text":"🔣","group":"symbols","keywords":["〒♪&amp;%","input","input symbols"]},{"name":":input_latin_letters:","text":"🔤","group":"symbols","keywords":["abc","alphabet","input","latin","letters"]},{"name":":a_button_(blood_type):","text":"🅰","group":"symbols","keywords":["a","A button (blood type)","blood type"]},{"name":":ab_button_(blood_type):","text":"🆎","group":"symbols","keywords":["ab","AB button (blood type)","blood type"]},{"name":":b_button_(blood_type):","text":"🅱","group":"symbols","keywords":["b","B button (blood type)","blood type"]},{"name":":cl_button:","text":"🆑","group":"symbols","keywords":["cl","CL button"]},{"name":":cool_button:","text":"🆒","group":"symbols","keywords":["cool","COOL button"]},{"name":":free_button:","text":"🆓","group":"symbols","keywords":["free","FREE button"]},{"name":":information:","text":"ℹ","group":"symbols","keywords":["i","information"]},{"name":":id_button:","text":"🆔","group":"symbols","keywords":["id","ID button","identity"]},{"name":":circled_m:","text":"Ⓜ","group":"symbols","keywords":["circle","circled M","m"]},{"name":":new_button:","text":"🆕","group":"symbols","keywords":["new","NEW button"]},{"name":":ng_button:","text":"🆖","group":"symbols","keywords":["ng","NG button"]},{"name":":o_button_(blood_type):","text":"🅾","group":"symbols","keywords":["blood type","o","O button (blood type)"]},{"name":":ok_button:","text":"🆗","group":"symbols","keywords":["OK","OK button"]},{"name":":p_button:","text":"🅿","group":"symbols","keywords":["P button","parking"]},{"name":":sos_button:","text":"🆘","group":"symbols","keywords":["help","sos","SOS button"]},{"name":":up!_button:","text":"🆙","group":"symbols","keywords":["mark","up","UP! button"]},{"name":":vs_button:","text":"🆚","group":"symbols","keywords":["versus","vs","VS button"]},{"name":":japanese_“here”_button:","text":"🈁","group":"symbols","keywords":["“here”","Japanese","Japanese “here” button","katakana","ココ"]},{"name":":japanese_“service_charge”_button:","text":"🈂","group":"symbols","keywords":["“service charge”","Japanese","Japanese “service charge” button","katakana","サ"]},{"name":":japanese_“monthly_amount”_button:","text":"🈷","group":"symbols","keywords":["“monthly amount”","ideograph","Japanese","Japanese “monthly amount” button","月"]},{"name":":japanese_“not_free_of_charge”_button:","text":"🈶","group":"symbols","keywords":["“not free of charge”","ideograph","Japanese","Japanese “not free of charge” button","有"]},{"name":":japanese_“reserved”_button:","text":"🈯","group":"symbols","keywords":["“reserved”","ideograph","Japanese","Japanese “reserved” button","指"]},{"name":":japanese_“bargain”_button:","text":"🉐","group":"symbols","keywords":["“bargain”","ideograph","Japanese","Japanese “bargain” button","得"]},{"name":":japanese_“discount”_button:","text":"🈹","group":"symbols","keywords":["“discount”","ideograph","Japanese","Japanese “discount” button","割"]},{"name":":japanese_“free_of_charge”_button:","text":"🈚","group":"symbols","keywords":["“free of charge”","ideograph","Japanese","Japanese “free of charge” button","無"]},{"name":":japanese_“prohibited”_button:","text":"🈲","group":"symbols","keywords":["“prohibited”","ideograph","Japanese","Japanese “prohibited” button","禁"]},{"name":":japanese_“acceptable”_button:","text":"🉑","group":"symbols","keywords":["“acceptable”","ideograph","Japanese","Japanese “acceptable” button","可"]},{"name":":japanese_“application”_button:","text":"🈸","group":"symbols","keywords":["“application”","ideograph","Japanese","Japanese “application” button","申"]},{"name":":japanese_“passing_grade”_button:","text":"🈴","group":"symbols","keywords":["“passing grade”","ideograph","Japanese","Japanese “passing grade” button","合"]},{"name":":japanese_“vacancy”_button:","text":"🈳","group":"symbols","keywords":["“vacancy”","ideograph","Japanese","Japanese “vacancy” button","空"]},{"name":":japanese_“congratulations”_button:","text":"㊗","group":"symbols","keywords":["“congratulations”","ideograph","Japanese","Japanese “congratulations” button","祝"]},{"name":":japanese_“secret”_button:","text":"㊙","group":"symbols","keywords":["“secret”","ideograph","Japanese","Japanese “secret” button","秘"]},{"name":":japanese_“open_for_business”_button:","text":"🈺","group":"symbols","keywords":["“open for business”","ideograph","Japanese","Japanese “open for business” button","営"]},{"name":":japanese_“no_vacancy”_button:","text":"🈵","group":"symbols","keywords":["“no vacancy”","ideograph","Japanese","Japanese “no vacancy” button","満"]},{"name":":red_circle:","text":"🔴","group":"symbols","keywords":["circle","geometric","red"]},{"name":":blue_circle:","text":"🔵","group":"symbols","keywords":["blue","circle","geometric"]},{"name":":white_circle:","text":"⚪","group":"symbols","keywords":["circle","geometric","white circle"]},{"name":":black_circle:","text":"⚫","group":"symbols","keywords":["black circle","circle","geometric"]},{"name":":white_large_square:","text":"⬜","group":"symbols","keywords":["geometric","square","white large square"]},{"name":":black_large_square:","text":"⬛","group":"symbols","keywords":["black large square","geometric","square"]},{"name":":black_medium_square:","text":"◼","group":"symbols","keywords":["black medium square","geometric","square"]},{"name":":white_medium_square:","text":"◻","group":"symbols","keywords":["geometric","square","white medium square"]},{"name":":white_medium-small_square:","text":"◽","group":"symbols","keywords":["geometric","square","white medium-small square"]},{"name":":black_medium-small_square:","text":"◾","group":"symbols","keywords":["black medium-small square","geometric","square"]},{"name":":white_small_square:","text":"▫","group":"symbols","keywords":["geometric","square","white small square"]},{"name":":black_small_square:","text":"▪","group":"symbols","keywords":["black small square","geometric","square"]},{"name":":large_orange_diamond:","text":"🔶","group":"symbols","keywords":["diamond","geometric","large orange diamond","orange"]},{"name":":large_blue_diamond:","text":"🔷","group":"symbols","keywords":["blue","diamond","geometric","large blue diamond"]},{"name":":small_orange_diamond:","text":"🔸","group":"symbols","keywords":["diamond","geometric","orange","small orange diamond"]},{"name":":small_blue_diamond:","text":"🔹","group":"symbols","keywords":["blue","diamond","geometric","small blue diamond"]},{"name":":red_triangle_pointed_up:","text":"🔺","group":"symbols","keywords":["geometric","red","red triangle pointed up"]},{"name":":red_triangle_pointed_down:","text":"🔻","group":"symbols","keywords":["down","geometric","red","red triangle pointed down"]},{"name":":diamond_with_a_dot:","text":"💠","group":"symbols","keywords":["comic","diamond","diamond with a dot","geometric","inside"]},{"name":":radio_button:","text":"🔘","group":"symbols","keywords":["button","geometric","radio"]},{"name":":black_square_button:","text":"🔲","group":"symbols","keywords":["black square button","button","geometric","square"]},{"name":":white_square_button:","text":"🔳","group":"symbols","keywords":["button","geometric","outlined","square","white square button"]},{"name":":chequered_flag:","text":"🏁","group":"flags","keywords":["checkered","chequered","chequered flag","racing"]},{"name":":triangular_flag:","text":"🚩","group":"flags","keywords":["post","triangular flag"]},{"name":":crossed_flags:","text":"🎌","group":"flags","keywords":["celebration","cross","crossed","crossed flags","Japanese"]},{"name":":black_flag:","text":"🏴","group":"flags","keywords":["black flag","waving"]},{"name":":white_flag:","text":"🏳","group":"flags","keywords":["waving","white flag"]},{"name":":rainbow_flag:","text":"🏳️‍🌈","group":"flags","keywords":["rainbow","rainbow flag"]}]'
          );
          class Iv extends bg {}
          (Iv.builtinPlugins = [
            class extends V {
              static get requires() {
                return [xg, Dg];
              }
              static get pluginName() {
                return 'Alignment';
              }
            },
            class extends V {
              static get requires() {
                return [Fg];
              }
              static get pluginName() {
                return 'Autoformat';
              }
              afterInit() {
                this._addListAutoformats(),
                  this._addBasicStylesAutoformats(),
                  this._addHeadingAutoformats(),
                  this._addBlockQuoteAutoformats(),
                  this._addCodeBlockAutoformats(),
                  this._addHorizontalLineAutoformats();
              }
              _addListAutoformats() {
                const e = this.editor.commands;
                e.get('bulletedList') && lp(this.editor, this, /^[*-]\s$/, 'bulletedList'),
                  e.get('numberedList') && lp(this.editor, this, /^1[.|)]\s$/, 'numberedList'),
                  e.get('todoList') && lp(this.editor, this, /^\[\s?\]\s$/, 'todoList'),
                  e.get('checkTodoList') &&
                    lp(this.editor, this, /^\[\s?x\s?\]\s$/, () => {
                      this.editor.execute('todoList'), this.editor.execute('checkTodoList');
                    });
              }
              _addBasicStylesAutoformats() {
                const e = this.editor.commands;
                if (e.get('bold')) {
                  const e = up(this.editor, 'bold');
                  cp(this.editor, this, /(?:^|\s)(\*\*)([^*]+)(\*\*)$/g, e), cp(this.editor, this, /(?:^|\s)(__)([^_]+)(__)$/g, e);
                }
                if (e.get('italic')) {
                  const e = up(this.editor, 'italic');
                  cp(this.editor, this, /(?:^|\s)(\*)([^*_]+)(\*)$/g, e), cp(this.editor, this, /(?:^|\s)(_)([^_]+)(_)$/g, e);
                }
                if (e.get('code')) {
                  const e = up(this.editor, 'code');
                  cp(this.editor, this, /(`)([^`]+)(`)$/g, e);
                }
                if (e.get('strikethrough')) {
                  const e = up(this.editor, 'strikethrough');
                  cp(this.editor, this, /(~~)([^~]+)(~~)$/g, e);
                }
              }
              _addHeadingAutoformats() {
                const e = this.editor.commands.get('heading');
                e &&
                  e.modelElements
                    .filter((e) => e.match(/^heading[1-6]$/))
                    .forEach((t) => {
                      const n = t[7],
                        o = new RegExp(`^(#{${n}})\\s$`);
                      lp(this.editor, this, o, () => {
                        if (!e.isEnabled || e.value === t) return !1;
                        this.editor.execute('heading', { value: t });
                      });
                    });
              }
              _addBlockQuoteAutoformats() {
                this.editor.commands.get('blockQuote') && lp(this.editor, this, /^>\s$/, 'blockQuote');
              }
              _addCodeBlockAutoformats() {
                const e = this.editor,
                  t = e.model.document.selection;
                e.commands.get('codeBlock') &&
                  lp(e, this, /^```$/, () => {
                    if (t.getFirstPosition().parent.is('element', 'listItem')) return !1;
                    this.editor.execute('codeBlock', { usePreviousLanguageChoice: !0 });
                  });
              }
              _addHorizontalLineAutoformats() {
                this.editor.commands.get('horizontalLine') && lp(this.editor, this, /^---$/, 'horizontalLine');
              }
            },
            class extends V {
              static get requires() {
                return [xp, Tp];
              }
              static get pluginName() {
                return 'BlockQuote';
              }
            },
            class extends V {
              static get requires() {
                return [Mp, Np];
              }
              static get pluginName() {
                return 'Bold';
              }
            },
            class extends Eo {
              static get pluginName() {
                return 'CloudServices';
              }
              static get requires() {
                return [Fp];
              }
              init() {
                const e = this.context.config.get('cloudServices') || {};
                for (const t in e) this[t] = e[t];
                if (((this._tokens = new Map()), this.tokenUrl))
                  return (
                    (this.token = this.context.plugins.get('CloudServicesCore').createToken(this.tokenUrl)),
                    this._tokens.set(this.tokenUrl, this.token),
                    this.token.init()
                  );
                this.token = null;
              }
              registerTokenUrl(e) {
                if (this._tokens.has(e)) return Promise.resolve(this.getTokenFor(e));
                const t = this.context.plugins.get('CloudServicesCore').createToken(e);
                return this._tokens.set(e, t), t.init();
              }
              getTokenFor(e) {
                const t = this._tokens.get(e);
                if (!t) throw new l('cloudservices-token-not-registered', this);
                return t;
              }
              destroy() {
                super.destroy();
                for (const e of this._tokens.values()) e.destroy();
              }
            },
            class extends V {
              static get requires() {
                return [Pf, fp, Vf, _p, Hg, Qf];
              }
              static get pluginName() {
                return 'Essentials';
              }
            },
            class extends V {
              static get requires() {
                return [ik, ak];
              }
              static get pluginName() {
                return 'Heading';
              }
            },
            class extends V {
              static get requires() {
                return [Fk, Uk];
              }
              static get pluginName() {
                return 'Image';
              }
            },
            class extends V {
              static get requires() {
                return [Gk, $k];
              }
              static get pluginName() {
                return 'ImageCaption';
              }
            },
            class extends V {
              static get requires() {
                return [db, mb];
              }
              static get pluginName() {
                return 'ImageStyle';
              }
            },
            class extends V {
              static get requires() {
                return [lk, yk];
              }
              static get pluginName() {
                return 'ImageToolbar';
              }
              afterInit() {
                const e = this.editor,
                  t = e.t,
                  n = e.plugins.get(lk),
                  o = e.plugins.get('ImageUtils');
                var i;
                n.register('image', {
                  ariaLabel: t('Image toolbar'),
                  items: ((i = e.config.get('image.toolbar') || []), i.map((e) => (E(e) ? e.name : e))),
                  getRelatedElement: (e) => o.getClosestSelectedImageWidget(e),
                });
              }
            },
            class extends V {
              static get pluginName() {
                return 'ImageUpload';
              }
              static get requires() {
                return [Rb, xb, Bb];
              }
            },
            class extends V {
              static get pluginName() {
                return 'Indent';
              }
              static get requires() {
                return [Fb, qb];
              }
            },
            class extends V {
              constructor(e) {
                super(e), e.config.define('indentBlock', { offset: 40, unit: 'px' });
              }
              static get pluginName() {
                return 'IndentBlock';
              }
              init() {
                const e = this.editor,
                  t = e.config.get('indentBlock'),
                  n = !t.classes || !t.classes.length,
                  o = Object.assign({ direction: 'forward' }, t),
                  i = Object.assign({ direction: 'backward' }, t);
                n
                  ? (e.data.addStyleProcessorRules(hg),
                    this._setupConversionUsingOffset(e.conversion),
                    e.commands.add('indentBlock', new Wb(e, new Gb(o))),
                    e.commands.add('outdentBlock', new Wb(e, new Gb(i))))
                  : (this._setupConversionUsingClasses(t.classes),
                    e.commands.add('indentBlock', new Wb(e, new $b(o))),
                    e.commands.add('outdentBlock', new Wb(e, new $b(i))));
              }
              afterInit() {
                const e = this.editor,
                  t = e.model.schema,
                  n = e.commands.get('indent'),
                  o = e.commands.get('outdent'),
                  i = e.config.get('heading.options');
                ((i && i.map((e) => e.model)) || Yb).forEach((e) => {
                  t.isRegistered(e) && t.extend(e, { allowAttributes: 'blockIndent' });
                }),
                  t.setAttributeProperties('blockIndent', { isFormatting: !0 }),
                  n.registerChildCommand(e.commands.get('indentBlock')),
                  o.registerChildCommand(e.commands.get('outdentBlock'));
              }
              _setupConversionUsingOffset() {
                const e = this.editor.conversion,
                  t = 'rtl' === this.editor.locale.contentLanguageDirection ? 'margin-right' : 'margin-left';
                e.for('upcast').attributeToAttribute({
                  view: { styles: { [t]: /[\s\S]+/ } },
                  model: { key: 'blockIndent', value: (e) => e.getStyle(t) },
                }),
                  e.for('downcast').attributeToAttribute({ model: 'blockIndent', view: (e) => ({ key: 'style', value: { [t]: e } }) });
              }
              _setupConversionUsingClasses(e) {
                const t = { model: { key: 'blockIndent', values: [] }, view: {} };
                for (const n of e) t.model.values.push(n), (t.view[n] = { key: 'class', value: [n] });
                this.editor.conversion.attributeToAttribute(t);
              }
            },
            class extends V {
              static get requires() {
                return [Qb, Jb];
              }
              static get pluginName() {
                return 'Italic';
              }
            },
            class extends V {
              static get requires() {
                return [zw, Gw, Kw];
              }
              static get pluginName() {
                return 'Link';
              }
            },
            class extends V {
              static get requires() {
                return [y_, C_];
              }
              static get pluginName() {
                return 'List';
              }
            },
            class extends V {
              static get requires() {
                return [N_, R_, z_, Cf];
              }
              static get pluginName() {
                return 'MediaEmbed';
              }
            },
            class extends V {
              toMentionAttribute(e, t) {
                return W_(e, t);
              }
              static get pluginName() {
                return 'Mention';
              }
              static get requires() {
                return [U_, oy];
              }
            },
            ek,
            class extends V {
              static get pluginName() {
                return 'PasteFromOffice';
              }
              static get requires() {
                return [Gp];
              }
              init() {
                const e = this.editor,
                  t = e.editing.view.document,
                  n = [];
                n.push(new Ay(t)),
                  n.push(new ky(t)),
                  e.plugins.get('ClipboardPipeline').on(
                    'inputTransformation',
                    (o, i) => {
                      if (i._isTransformedWithPasteFromOffice) return;
                      if (e.model.document.selection.getFirstPosition().parent.is('element', 'codeBlock')) return;
                      const r = i.dataTransfer.getData('text/html'),
                        s = n.find((e) => e.isActive(r));
                      s && ((i._parsedData = vy(r, t.stylesProcessor)), s.execute(i), (i._isTransformedWithPasteFromOffice = !0));
                    },
                    { priority: 'high' }
                  );
              }
            },
            class extends V {
              static get requires() {
                return [DA, NA, jA, WA, UA, OA, Cf];
              }
              static get pluginName() {
                return 'Table';
              }
            },
            class extends V {
              static get requires() {
                return [lk];
              }
              static get pluginName() {
                return 'TableToolbar';
              }
              afterInit() {
                const e = this.editor,
                  t = e.t,
                  n = e.plugins.get(lk),
                  o = e.config.get('table.contentToolbar'),
                  i = e.config.get('table.tableToolbar');
                o && n.register('tableContent', { ariaLabel: t('Table toolbar'), items: o, getRelatedElement: QA }),
                  i && n.register('table', { ariaLabel: t('Table toolbar'), items: i, getRelatedElement: KA });
              }
            },
            class extends V {
              static get pluginName() {
                return 'TableProperties';
              }
              static get requires() {
                return [fC, XC];
              }
            },
            class extends V {
              static get pluginName() {
                return 'TableCellProperties';
              }
              static get requires() {
                return [wv, sv];
              }
            },
            class extends V {
              static get requires() {
                return ['Delete', 'Input'];
              }
              static get pluginName() {
                return 'TextTransformation';
              }
              constructor(e) {
                super(e), e.config.define('typing', { transformations: { include: tp } });
              }
              init() {
                const e = this.editor.model.document.selection;
                e.on('change:range', () => {
                  this.isEnabled = !e.anchor.parent.is('element', 'codeBlock');
                }),
                  this._enableTransformationWatchers();
              }
              _enableTransformationWatchers() {
                const e = this.editor,
                  t = e.model,
                  n = e.plugins.get('Delete'),
                  o = (function (e) {
                    const t = e.extra || [],
                      n = e.remove || [],
                      o = (e) => !n.includes(e);
                    return (function (e) {
                      const t = new Set();
                      for (const n of e)
                        if (ep[n]) for (const e of ep[n]) t.add(e);
                        else t.add(n);
                      return Array.from(t);
                    })(e.include.concat(t).filter(o))
                      .filter(o)
                      .map((e) => Xg[e] || e)
                      .filter((e) => 'object' == typeof e)
                      .map((e) => ({ from: np(e.from), to: op(e.to) }));
                  })(e.config.get('typing.transformations')),
                  i = new qg(e.model, (e) => {
                    for (const t of o) {
                      if (t.from.test(e)) return { normalizedTransformation: t };
                    }
                  });
                i.on('matched:data', (e, o) => {
                  if (!o.batch.isTyping) return;
                  const { from: i, to: r } = o.normalizedTransformation,
                    s = i.exec(o.text),
                    a = r(s.slice(1)),
                    l = o.range;
                  let c = s.index;
                  t.enqueueChange((e) => {
                    for (let n = 1; n < s.length; n++) {
                      const o = s[n],
                        i = a[n - 1];
                      if (null == i) {
                        c += o.length;
                        continue;
                      }
                      const r = l.start.getShiftedBy(c),
                        d = t.createRange(r, r.getShiftedBy(o.length)),
                        u = ip(r);
                      t.insertContent(e.createText(i, u), d), (c += i.length);
                    }
                    t.enqueueChange(() => {
                      n.requestUndoOnBackspace();
                    });
                  });
                }),
                  i.bind('isEnabled').to(this);
              }
            },
            class extends V {
              static get requires() {
                return [Av, vv];
              }
              static get pluginName() {
                return 'Underline';
              }
            },
            class extends V {
              static get requires() {
                return [Xh];
              }
              static get pluginName() {
                return 'Emoji';
              }
              init() {
                const e = this.editor;
                e.editing.view.addObserver(Dm),
                  e.config.define('emoji', [
                    { name: 'smile', text: '😀' },
                    { name: 'wink', text: '😉' },
                    { name: 'cool', text: '😎' },
                    { name: 'surprise', text: '😮' },
                    { name: 'confusion', text: '😕' },
                    { name: 'crying', text: '😢' },
                  ]),
                  (this._balloon = e.plugins.get(Xh)),
                  (this.formView = this._createForm()),
                  e.ui.componentFactory.add('emoji', (t) => {
                    const n = new zu(t);
                    return (
                      (n.isEnabled = !0),
                      (n.label = e.t('Emoji')),
                      (n.icon =
                        '<svg width="128" height="128" style="enable-background:new 0 0 128 128;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n\t<symbol id="Grid" viewBox="-64.5 -64.5 129 129">\n\t\t<g id="XMLID_102_">\n\t\t\t<rect id="XMLID_110_" height="128" style="fill:none;stroke:#4285F4;stroke-miterlimit:10;" width="128" x="-64" y="-64"/>\n\t\t\t<path id="XMLID_109_" d="M36.95,37.82C27.32,46.32,14.2,51,0,51 c-14.27,0-27.39-4.62-36.96-13.01C-47.45,28.79-53,15.65-53,0c0-15.58,5.55-28.69,16.04-37.92C-27.36-46.35-14.24-51,0-51 c14.17,0,27.29,4.71,36.95,13.25C47.45-28.45,53-15.4,53,0C53,15.47,47.45,28.55,36.95,37.82z" style="fill:none;stroke:#4285F4;stroke-miterlimit:10;"/>\n\t\t\t<path id="XMLID_108_" d="M0,55L0,55L0,55c-29.59,0-57-19.01-57-55 c0-35.8,27.41-55,57-55h0h0c29.59,0,57,19.69,57,55C57,35.51,29.59,55,0,55z" style="fill:none;stroke:#4285F4;stroke-miterlimit:10;"/>\n\t\t\t<path id="XMLID_107_" d="M0-43c-12.29,0-23.54,3.94-31.68,11.09 C-40.39-24.25-45-13.21-45,0c0,29.7,22.6,43,45,43c21.67,0,45-13.46,45-43S21.67-43,0-43L0-43z" style="fill:none;stroke:#4285F4;stroke-miterlimit:10;"/>\n\t\t\t<line id="XMLID_106_" style="fill:none;stroke:#4285F4;stroke-miterlimit:10;" x1="-0.01" x2="-0.01" y1="51" y2="-51"/>\n\t\t\t<line id="XMLID_105_" style="fill:none;stroke:#4285F4;stroke-miterlimit:10;" x1="-16" x2="-16" y1="48.95" y2="-48.93"/>\n\t\t\t<line id="XMLID_104_" style="fill:none;stroke:#4285F4;stroke-miterlimit:10;" x1="15.99" x2="15.99" y1="48.91" y2="-48.93"/>\n\t\t\t<line id="XMLID_103_" style="fill:none;stroke:#4285F4;stroke-miterlimit:10;" x1="53" x2="-53" y1="0.08" y2="0.08"/>\n\t\t</g>\n\t</symbol>\n\t<g id="Layer_1">\n\t\t<g>\n\t\t\t<g>\n\t\t\t\t<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="64" x2="64" y1="19.7166" y2="107.7021">\n\t\t\t\t\t<stop offset="0.5" style="stop-color:#FEE133"/>\n\t\t\t\t\t<stop offset="0.6118" style="stop-color:#FEDE32"/>\n\t\t\t\t\t<stop offset="0.7076" style="stop-color:#FCD32F"/>\n\t\t\t\t\t<stop offset="0.7975" style="stop-color:#FAC12B"/>\n\t\t\t\t\t<stop offset="0.8834" style="stop-color:#F7A924"/>\n\t\t\t\t\t<stop offset="0.9" style="stop-color:#F6A323"/>\n\t\t\t\t</linearGradient>\n\t\t\t\t<path d="M64,119.89C36.07,119.89,6,102.4,6,64S36.07,8.11,64,8.11c15.48,0,29.81,5.12,40.36,14.43 C115.9,32.72,122,47.06,122,64c0,16.86-6.1,31.17-17.64,41.39C93.78,114.74,79.45,119.89,64,119.89z" style="fill:url(#SVGID_1_);"/>\n\t\t\t\t<path d="M64,10.11L64,10.11c14.99,0,28.86,4.95,39.03,13.93C114.13,33.83,120,47.65,120,64 c0,16.27-5.87,30.07-16.97,39.89c-10.21,9.03-24.07,14-39.03,14c-15.04,0-28.9-4.91-39.04-13.82C13.86,94.32,8,80.46,8,64 c0-16.54,5.86-30.42,16.96-40.15C35.07,14.99,48.93,10.11,64,10.11 M64,6.11L64,6.11L64,6.11L64,6.11C32.85,6.11,4,26.11,4,64 c0,37.68,28.85,57.89,60,57.89h0h0h0c31.15,0,60-20.73,60-57.89C124,26.63,95.15,6.11,64,6.11L64,6.11z" style="fill:#EB8F00;"/>\n\t\t\t</g>\n\t\t\t<g>\n\t\t\t\t<defs>\n\t\t\t\t\t<path id="SVGID_3_" d="M63.47,62.53c-15.71,0-30.31-1.32-42.49-3.57c-3.02-0.56-5.69,2.1-5.08,5.11 c4.04,19.81,23.55,36.08,47.55,36.08c26.27,0,43.94-16.8,47.61-36.15c0.57-2.99-2.1-5.6-5.09-5.04 C93.79,61.21,79.19,62.53,63.47,62.53z"/>\n\t\t\t\t</defs>\n\t\t\t\t<clipPath id="SVGID_4_">\n\t\t\t\t\t<use style="overflow:visible;" xlink:href="#SVGID_3_"/>\n\t\t\t\t</clipPath>\n\t\t\t\t<path d="M63.47,62.53c-15.71,0-30.31-1.32-42.49-3.57 c-3.02-0.56-5.69,2.1-5.08,5.11c4.04,19.81,23.55,36.08,47.55,36.08c26.27,0,43.94-16.8,47.61-36.15c0.57-2.99-2.1-5.6-5.09-5.04 C93.79,61.21,79.19,62.53,63.47,62.53z" style="clip-path:url(#SVGID_4_);fill:#242424;"/>\n\t\t\t\t<path d="M116.72,61.38V46.49H10.24v14.89C26.61,71,44.6,76.35,63.48,76.35 S100.34,71,116.72,61.38z" style="clip-path:url(#SVGID_4_);fill:#FFFFFF;"/>\n\t\t\t\t<path d="M63.48,86.42c-11.78,0-22.05,6.42-27.53,15.95 c7.12,3.89,16.83,6.29,27.53,6.29s20.41-2.4,27.53-6.29C85.53,92.84,75.26,86.42,63.48,86.42z" style="clip-path:url(#SVGID_4_);fill:#ED7770;"/>\n\t\t\t\t<g style="clip-path:url(#SVGID_4_);">\n\t\t\t\t\t<defs>\n\t\t\t\t\t\t<path id="SVGID_5_" d="M10.24,46.49v14.89C26.62,71,44.6,76.35,63.48,76.35c18.88,0,36.86-5.35,53.24-14.97V46.49H10.24z M63.48,86.42c-11.78,0-22.05,6.42-27.53,15.95c7.12,3.89,16.83,6.29,27.53,6.29c10.71,0,20.41-2.4,27.53-6.29 C85.53,92.84,75.26,86.42,63.48,86.42z"/>\n\t\t\t\t\t</defs>\n\t\t\t\t\t<clipPath id="SVGID_6_">\n\t\t\t\t\t\t<use style="overflow:visible;" xlink:href="#SVGID_5_"/>\n\t\t\t\t\t</clipPath>\n\t\t\t\t\t<g style="clip-path:url(#SVGID_6_);">\n\t\t\t\t\t\t<path d="M106.79,62.88c0.16,0,0.26,0.11,0.29,0.14c0.08,0.1,0.07,0.18,0.06,0.23 c-1.69,8.9-6.63,17.06-13.92,22.97c-8.01,6.49-18.3,9.92-29.76,9.92c-10.51,0-20.73-3.47-28.8-9.76 c-7.76-6.06-13.03-14.27-14.83-23.11c-0.01-0.05-0.03-0.13,0.06-0.23c0.03-0.03,0.13-0.15,0.29-0.15c0.03,0,0.05,0,0.08,0.01 c12.85,2.38,27.8,3.64,43.22,3.64c15.43,0,30.38-1.26,43.24-3.64C106.74,62.88,106.76,62.88,106.79,62.88 M106.79,58.88 c-0.27,0-0.54,0.02-0.81,0.08c-12.18,2.26-26.79,3.58-42.51,3.58c-15.71,0-30.31-1.32-42.49-3.57 c-0.27-0.05-0.54-0.08-0.81-0.08c-2.67,0-4.83,2.44-4.27,5.18c4.04,19.81,23.55,36.08,47.55,36.08 c26.27,0,43.94-16.8,47.61-36.15C111.58,61.28,109.43,58.88,106.79,58.88L106.79,58.88z" style="fill:#EB8F00;"/>\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</g>\n\t\t\t<path d="M82.74,30.19L82.74,30.19c4.19,0,8,3.54,8,9.42s-3.81,9.42-8,9.42l0,0c-4.19,0-8-3.54-8-9.42 S78.55,30.19,82.74,30.19z" style="fill:#242424;"/>\n\t\t\t<path d="M45.2,30.19L45.2,30.19c-4.19,0-8,3.54-8,9.42s3.81,9.42,8,9.42l0,0c4.19,0,8-3.54,8-9.42 S49.39,30.19,45.2,30.19z" style="fill:#242424;"/>\n\t\t</g>\n\t</g>\n\t<g id="Layer_2" style="display:none;">\n\t\t<g style="display:inline;">\n\t\t\t<g style="opacity:0.6;">\n\t\t\t\t<circle cx="64" cy="64" r="28" style="opacity:0.61;fill:none;stroke:#000000;stroke-width:0.2625;stroke-miterlimit:10;"/>\n\t\t\t\t<line style="opacity:0.61;fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="84" x2="84" y1="0" y2="128"/>\n\t\t\t\t<line style="opacity:0.61;fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="44" x2="44" y1="0" y2="128"/>\n\t\t\t\t<line style="opacity:0.61;fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="64" x2="64" y1="0" y2="128"/>\n\t\t\t\t<line style="opacity:0.61;fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="0" y1="64" y2="64"/>\n\t\t\t\t<line style="opacity:0.61;fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="0" y1="44" y2="44"/>\n\t\t\t\t<line style="opacity:0.61;fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="0" y1="83.75" y2="83.75"/>\n\t\t\t\t<line style="opacity:0.61;fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="0" y1="128" y2="0"/>\n\t\t\t\t<line style="opacity:0.61;fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="0" x2="128" y1="128" y2="0"/>\n\t\t\t\t<g style="opacity:0.61;">\n\t\t\t\t\t<path d="M64,4.26c32.94,0,59.74,26.8,59.74,59.74S96.94,123.74,64,123.74S4.26,96.94,4.26,64S31.06,4.26,64,4.26 M64,4 C30.86,4,4,30.86,4,64s26.86,60,60,60s60-26.86,60-60S97.14,4,64,4L64,4z"/>\n\t\t\t\t</g>\n\t\t\t\t<path d="M107.97,115.97H20.03 c-4.42,0-8.03-3.61-8.03-8.03V20.03c0-4.42,3.61-8.03,8.03-8.03h87.94c4.42,0,8.03,3.61,8.03,8.03v87.91 C116,112.36,112.39,115.97,107.97,115.97z" style="opacity:0.61;fill:none;stroke:#000000;stroke-width:0.2578;stroke-miterlimit:10;"/>\n\t\t\t\t<path d="M100,124H28c-4.4,0-8-3.6-8-8 V12c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v104C108,120.4,104.4,124,100,124z" style="opacity:0.61;fill:none;stroke:#000000;stroke-width:0.2628;stroke-miterlimit:10;"/>\n\t\t\t\t<path d="M113.77,108H14.23 C8.6,108,4,103.4,4,97.77V30.28c0-5.63,4.6-10.23,10.23-10.23h99.54c5.63,0,10.23,4.6,10.23,10.23v67.48 C124,103.4,119.4,108,113.77,108z" style="opacity:0.61;fill:none;stroke:#000000;stroke-width:0.2627;stroke-miterlimit:10;"/>\n\t\t\t</g>\n\t\t\t<g>\n\t\t\t\t<g style="opacity:0.2;">\n\t\t\t\t\t<defs>\n\t\t\t\t\t\t<rect id="SVGID_2_" height="128" style="opacity:0.2;" width="128" x="0" y="0"/>\n\t\t\t\t\t</defs>\n\t\t\t\t\t<clipPath id="SVGID_7_">\n\t\t\t\t\t\t<use style="overflow:visible;" xlink:href="#SVGID_2_"/>\n\t\t\t\t\t</clipPath>\n\t\t\t\t\t<g style="clip-path:url(#SVGID_7_);">\n\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-28" x2="-28" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-24" x2="-24" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-20" x2="-20" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-16" x2="-16" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-12" x2="-12" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-8" x2="-8" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-4" x2="-4" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="0" x2="0" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="4" x2="4" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="8" x2="8" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="12" x2="12" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="16" x2="16" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="20" x2="20" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="24" x2="24" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="28" x2="28" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="32" x2="32" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="36" x2="36" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="40" x2="40" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="44" x2="44" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="48" x2="48" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="52" x2="52" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="56" x2="56" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="60" x2="60" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="64" x2="64" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="68" x2="68" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="72" x2="72" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="76" x2="76" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="80" x2="80" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="84" x2="84" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="88" x2="88" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="92" x2="92" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="96" x2="96" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="100" x2="100" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="104" x2="104" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="108" x2="108" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="112" x2="112" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="116" x2="116" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="120" x2="120" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="124" x2="124" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="128" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="132" x2="132" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="136" x2="136" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="137" x2="137" y1="166.05" y2="-25.95"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="144" x2="144" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="148" x2="148" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="152" x2="152" y1="160" y2="-32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="156" x2="156" y1="160" y2="-32"/>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="-28" y2="-28"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="-24" y2="-24"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="-20" y2="-20"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="-16" y2="-16"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="-12" y2="-12"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="-8" y2="-8"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="-4" y2="-4"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="0" y2="0"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="4" y2="4"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="8" y2="8"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="12" y2="12"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="16" y2="16"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="20" y2="20"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="24" y2="24"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="28" y2="28"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="32" y2="32"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="36" y2="36"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="40" y2="40"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="44" y2="44"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="48" y2="48"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="52" y2="52"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="56" y2="56"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="60" y2="60"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="64" y2="64"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="68" y2="68"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="72" y2="72"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="76" y2="76"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="80" y2="80"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="84" y2="84"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="88" y2="88"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="92" y2="92"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="96" y2="96"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="100" y2="100"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="104" y2="104"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="108" y2="108"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="112" y2="112"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="116" y2="116"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="120" y2="120"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="124" y2="124"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="128" y2="128"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="132" y2="132"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="136" y2="136"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="140" y2="140"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="144" y2="144"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="148" y2="148"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="152" y2="152"/>\n\t\t\t\t\t\t\t<line style="fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;" x1="-32" x2="160" y1="156" y2="156"/>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t\t<path d="M159.75-31.75v191.5h-191.5v-191.5H159.75 M160-32H-32v192h192V-32L160-32z"/>\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t\t<g>\n\t\t\t\t\t<rect height="128" style="opacity:0.3;fill:#F44336;" width="4" x="0" y="0"/>\n\t\t\t\t\t<rect height="128" style="opacity:0.3;fill:#F44336;" width="4" x="124" y="0"/>\n\t\t\t\t\t<rect height="120" style="opacity:0.3;fill:#F44336;" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 66 -62)" width="4" x="62" y="-58"/>\n\t\t\t\t\t<rect height="120" style="opacity:0.3;fill:#F44336;" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 190 62)" width="4" x="62" y="66"/>\n\t\t\t\t</g>\n\t\t\t</g>\n\t\t</g>\n\t</g>\n\t<g id="Layer_3" style="display:none;">\n\t\t<rect id="XMLID_46_" height="128" style="display:inline;fill:none;stroke:#616161;stroke-width:0.25;stroke-miterlimit:10;" transform="matrix(-1.346904e-10 -1 1 -1.346904e-10 8.631098e-09 128)" width="128" x="0"/>\n\t\t<g id="XMLID_9_" style="display:inline;">\n\t\t\t<rect id="XMLID_45_" height="128" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" width="128" x="0"/>\n\t\t\t<line id="XMLID_44_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="8" x2="8" y1="0" y2="128"/>\n\t\t\t<line id="XMLID_43_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="16" x2="16" y1="0" y2="128"/>\n\t\t\t<line id="XMLID_42_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="24" x2="24" y1="0" y2="128"/>\n\t\t\t<line id="XMLID_41_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="32" x2="32" y1="0" y2="128"/>\n\t\t\t<line id="XMLID_40_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="40" x2="40" y1="0" y2="128"/>\n\t\t\t<line id="XMLID_39_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="48" x2="48" y1="0" y2="128"/>\n\t\t\t<line id="XMLID_38_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="56" x2="56" y1="0" y2="128"/>\n\t\t\t<line id="XMLID_37_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="63.99" x2="63.99" y1="0" y2="128"/>\n\t\t\t<line id="XMLID_36_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="71.99" x2="71.99" y1="0" y2="128"/>\n\t\t\t<line id="XMLID_35_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="79.99" x2="79.99" y1="0" y2="128"/>\n\t\t\t<line id="XMLID_34_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="87.99" x2="87.99" y1="0" y2="128"/>\n\t\t\t<line id="XMLID_33_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="95.99" x2="95.99" y1="0" y2="128"/>\n\t\t\t<line id="XMLID_32_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="103.99" x2="103.99" y1="0" y2="128"/>\n\t\t\t<line id="XMLID_47_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="111.99" x2="111.99" y1="0" y2="128"/>\n\t\t\t<line id="XMLID_48_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="119.99" x2="119.99" y1="0" y2="128"/>\n\t\t\t<line id="XMLID_49_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="0" y1="120" y2="120"/>\n\t\t\t<line id="XMLID_50_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="0" y1="112" y2="112"/>\n\t\t\t<line id="XMLID_51_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="0" y1="104" y2="104"/>\n\t\t\t<line id="XMLID_52_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="0" y1="96" y2="96"/>\n\t\t\t<line id="XMLID_53_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="0" y1="88" y2="88"/>\n\t\t\t<line id="XMLID_54_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="0" y1="80" y2="80"/>\n\t\t\t<line id="XMLID_55_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="0" y1="72" y2="72"/>\n\t\t\t<line id="XMLID_56_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="0" y1="64.01" y2="64.01"/>\n\t\t\t<line id="XMLID_57_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="0" y1="56.01" y2="56.01"/>\n\t\t\t<line id="XMLID_58_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="0" y1="48.01" y2="48.01"/>\n\t\t\t<line id="XMLID_60_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="0" y1="40.01" y2="40.01"/>\n\t\t\t<line id="XMLID_61_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="0" y1="32.01" y2="32.01"/>\n\t\t\t<line id="XMLID_62_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="0" y1="24.01" y2="24.01"/>\n\t\t\t<line id="XMLID_63_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="0" y1="16.01" y2="16.01"/>\n\t\t\t<line id="XMLID_64_" style="fill:none;stroke:#999999;stroke-width:0.25;stroke-miterlimit:10;" x1="128" x2="0" y1="8.01" y2="8.01"/>\n\t\t</g>\n\t\t<use id="XMLID_31_" height="129" style="display:inline;overflow:visible;" transform="matrix(1 0 0 -1 64 64)" width="129" x="-64.5" xlink:href="#Grid" y="-64.5"/>\n\t</g>\n</svg>'),
                      (n.tooltip = !0),
                      setTimeout(function () {
                        n.iconView.set('viewBox', '0 0 128 128');
                      }, 0),
                      this.listenTo(n, 'execute', () => this._showPanel(!0)),
                      n
                    );
                  }),
                  this._attachActions();
              }
              _createForm() {
                const e = this.editor,
                  t = new Dv(e);
                return (
                  e.config.get('emoji').forEach((n) => {
                    this.listenTo(t, 'emoji:' + n.name, () => {
                      e.model.change((t) => {
                        t.insertText(n.text, e.model.document.selection.getFirstPosition()), this._hidePanel();
                      });
                    });
                  }),
                  t.keystrokes.set('Esc', (e, t) => {
                    this._hidePanel(!0), t();
                  }),
                  t
                );
              }
              _getBalloonPositionData() {
                const e = this.editor.editing.view,
                  t = e.document;
                return { target: e.domConverter.viewRangeToDom(t.selection.getFirstRange()) };
              }
              _showPanel() {
                this._balloon.add({ view: this.formView, position: this._getBalloonPositionData() });
              }
              _attachActions() {
                this.editor.keystrokes.set(
                  'Tab',
                  (e, t) => {
                    this._balloon.visibleView !== this.formView || this.formView.focusTracker.isFocused || (this.formView.focus(), t());
                  },
                  { priority: 'high' }
                ),
                  this.editor.keystrokes.set('Esc', (e, t) => {
                    this._balloon.visibleView === this.formView && (this._hidePanel(), t());
                  }),
                  vu({
                    emitter: this.formView,
                    activator: () => this._balloon.hasView(this.formView),
                    contextElements: [this._balloon.view.element],
                    callback: () => this._hidePanel(),
                  });
              }
              _hidePanel(e) {
                this.stopListening(this.editor.editing.view, 'render'),
                  this._balloon.hasView(this.formView) &&
                    (e && this.editor.editing.view.focus(),
                    this.stopListening(this.editor.editing.view, 'render'),
                    this._balloon.remove(this.formView));
              }
            },
            function (e) {
              e.conversion.for('upcast').elementToAttribute({
                view: { name: 'a', key: 'data-mention', classes: 'mention', attributes: { href: !1, 'data-user-id': !0, isMuted: !0 } },
                model: {
                  key: 'mention',
                  value: (t) =>
                    e.plugins
                      .get('Mention')
                      .toMentionAttribute(t, { userId: t.getAttribute('data-user-id'), isMuted: t.getAttribute('isMuted') }),
                },
                converterPriority: 'high',
              }),
                e.conversion.for('downcast').attributeToElement({
                  model: 'mention',
                  view: (e, { writer: t }) => {
                    if (e)
                      return t.createAttributeElement(
                        'a',
                        { class: 'mention', 'data-mention': e.id, 'data-user-id': e.userId, isMuted: e.isMuted },
                        { priority: 20, id: e.uid }
                      );
                  },
                  converterPriority: 'high',
                });
            },
          ]),
            (Iv.defaultConfig = {
              toolbar: {
                items: [
                  'heading',
                  '|',
                  'bold',
                  'italic',
                  'link',
                  'bulletedList',
                  'numberedList',
                  '|',
                  'outdent',
                  'indent',
                  '|',
                  'imageUpload',
                  'blockQuote',
                  'insertTable',
                  '|',
                  'mediaEmbed',
                  'undo',
                  'redo',
                  'emoji',
                ],
              },
              language: 'en',
              image: { toolbar: ['imageTextAlternative', 'imageStyle:inline', 'imageStyle:block', 'imageStyle:side'] },
              table: { contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties'] },
              emoji: Tv,
              mention: { feeds: [{ marker: '@', feed: [], minimumCharacters: 1 }] },
              allowedContent: !0,
            });
          const Sv = Iv;
        })(),
        (o = o.default)
      );
    })()
  );
//# sourceMappingURL=ckeditor.js.map
